import { Fragment as e, KeepAlive as t, computed as n, createBlock as r, createCommentVNode as i, createElementBlock as a, createElementVNode as o, createSlots as s, createTextVNode as c, createVNode as l, defineAsyncComponent as u, defineComponent as d, getCurrentInstance as f, guardReactiveProps as p, h as m, inject as h, isRef as g, markRaw as _, mergeModels as v, mergeProps as y, nextTick as b, normalizeClass as x, normalizeProps as S, normalizeStyle as C, onBeforeUnmount as w, onBeforeUpdate as T, onMounted as E, onUnmounted as D, openBlock as O, provide as k, reactive as ee, ref as A, renderList as j, renderSlot as M, resolveComponent as N, resolveDynamicComponent as te, shallowRef as ne, toDisplayString as P, toHandlers as re, toRaw as ie, toRefs as ae, unref as F, useAttrs as oe, useId as se, useModel as ce, useSlots as le, vShow as ue, watch as I, withCtx as L, withDirectives as de, withKeys as fe, withModifiers as R } from "vue";
import { apiSettings as pe, dialogVisibilityKey as me, getHelixApiBaseUrl as he, hGetAppRouteUrl as ge, isExternalUrl as _e, isUrlWithBase as ve, publicSettings as ye, resolvePublicLogoUrl as be, useHAlerts as xe, useHCardResolver as Se, useHCommon as Ce, useHConfig as we, useHConfirm as Te, useHDateRangePresets as Ee, useHDefaults as z, useHFormField as De, useHFormatDateTime as Oe, useHLocale as ke, useHLocaleFallback as Ae, useHNamespaceProps as je, useHPageHead as Me, useHThemePack as Ne, useHThemePackDefaults as Pe, useHTranslate as B, useOCommon as Fe, useOSettings as Ie, useOUserSettingsStore as Le, useTooltipGroup as Re } from "@onify/helix-core";
import { VBreadcrumbs as ze } from "vuetify/components/VBreadcrumbs";
import { VCard as Be, VCardActions as Ve, VCardItem as He, VCardSubtitle as Ue, VCardText as We, VCardTitle as Ge } from "vuetify/components/VCard";
import { VBtn as Ke } from "vuetify/components/VBtn";
import { VTooltip as qe } from "vuetify/components/VTooltip";
import { VIcon as V } from "vuetify/components/VIcon";
import { VCol as H, VContainer as Je, VRow as Ye, VSpacer as Xe } from "vuetify/components/VGrid";
import { VTextField as Ze } from "vuetify/components/VTextField";
import { VSelect as Qe } from "vuetify/components/VSelect";
import { VAutocomplete as $e } from "vuetify/components/VAutocomplete";
import { VCombobox as et } from "vuetify/components/VCombobox";
import { VTextarea as tt } from "vuetify/components/VTextarea";
import { VSwitch as nt } from "vuetify/components/VSwitch";
import { VDatePicker as rt } from "vuetify/components/VDatePicker";
import { VMenu as it } from "vuetify/components/VMenu";
import { VTimePicker as at } from "vuetify/components/VTimePicker";
import { VInput as ot } from "vuetify/components/VInput";
import { RouterLink as st, loadRouteLocation as ct, routeLocationKey as lt, useRoute as ut, useRouter as dt } from "vue-router";
import { computedAsync as ft, useArrayEvery as pt, useElementSize as mt, useEventListener as ht, useIntervalFn as gt, useResizeObserver as _t, useTimeoutFn as vt, useToggle as yt, useVModel as bt, useVModels as xt } from "@vueuse/core";
import { VList as St, VListGroup as Ct, VListItem as wt, VListItemSubtitle as Tt, VListItemTitle as Et, VListSubheader as Dt } from "vuetify/components/VList";
import { VExpandTransition as Ot } from "vuetify/components/transitions";
import { VChip as kt } from "vuetify/components/VChip";
import { VBadge as At } from "vuetify/components/VBadge";
import { VImg as jt } from "vuetify/components/VImg";
import { VCheckbox as Mt, VCheckboxBtn as Nt } from "vuetify/components/VCheckbox";
import { VDataTableFooter as Pt, VDataTableServer as Ft } from "vuetify/components/VDataTable";
import { VDivider as It } from "vuetify/components/VDivider";
import { VAvatar as Lt } from "vuetify/components/VAvatar";
import { VDialog as Rt } from "vuetify/components/VDialog";
import { VTable as zt } from "vuetify/components/VTable";
import { useDisplay as Bt, useTheme as Vt } from "vuetify";
import { VDefaultsProvider as Ht } from "vuetify/components/VDefaultsProvider";
import { VAutocomplete as Ut, VAvatar as Wt, VBtn as Gt, VDialog as Kt, VIcon as qt } from "vuetify/components";
import { VAlert as Jt } from "vuetify/components/VAlert";
import { VExpansionPanel as Yt, VExpansionPanelText as Xt, VExpansionPanels as Zt } from "vuetify/components/VExpansionPanel";
import { VFileInput as Qt } from "vuetify/components/VFileInput";
import { VSheet as $t } from "vuetify/components/VSheet";
import { VLayout as en } from "vuetify/components/VLayout";
import { VMain as tn } from "vuetify/components/VMain";
import { VNavigationDrawer as nn } from "vuetify/components/VNavigationDrawer";
import { injectDefaults as rn } from "vuetify/lib/composables/defaults.js";
import { VForm as an } from "vuetify/components/VForm";
import { VOverlay as on } from "vuetify/components/VOverlay";
import { VProgressCircular as sn } from "vuetify/components/VProgressCircular";
import { VStepper as cn, VStepperHeader as ln, VStepperItem as un } from "vuetify/components/VStepper";
import { addDays as dn, format as fn, formatDistance as pn, isValid as mn, isWeekend as hn, parseISO as gn, startOfDay as _n } from "date-fns";
import { enUS as vn, fi as yn, sv as bn } from "date-fns/locale";
import { storeToRefs as xn } from "pinia";
import { Tooltip as Sn } from "vuetify/directives";
import { VSkeletonLoader as Cn } from "vuetify/components/VSkeletonLoader";
//#region \0rolldown/runtime.js
var wn = Object.create, Tn = Object.defineProperty, En = Object.getOwnPropertyDescriptor, Dn = Object.getOwnPropertyNames, On = Object.getPrototypeOf, kn = Object.prototype.hasOwnProperty, An = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), jn = (e, t) => {
	let n = {};
	for (var r in e) Tn(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Tn(n, Symbol.toStringTag, { value: "Module" }), n;
}, Mn = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Dn(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !kn.call(e, s) && s !== n && Tn(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = En(t, s)) || r.enumerable
	});
	return e;
}, Nn = (e, t, n) => (n = e == null ? {} : wn(On(e)), Mn(t || !e || !e.__esModule ? Tn(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Pn = { class: "h-admin-page__breadcrumbs" }, Fn = { class: "h-admin-page__header" }, In = { class: "h-admin-page__heading-row" }, Ln = { class: "h-admin-page__heading" }, Rn = { class: "h-admin-page__title" }, zn = { class: "h-admin-page__header-controls" }, Bn = /*@__PURE__*/ d({
	__name: "admin-layout",
	props: {
		pageTitle: { default: "" },
		pagePrefix: { default: "" },
		headerTitle: { default: "" },
		headerDescription: { default: "" },
		pageKey: {},
		breadcrumbItems: { default: () => [] }
	},
	setup(e) {
		let t = z(e, "HAdminLayout"), a = n(() => {
			let e = [...t.breadcrumbItems || []];
			if (!e.length) return [];
			let n = B("home"), r = e[0];
			return r.href !== "/" && r.title !== n && r.text !== n && e.unshift({
				title: n,
				href: "/"
			}), e.map((t, n) => ({
				title: t.title || t.text || "",
				to: n === 0 ? "/" : t.href || (n === 1 ? "/admin/dashboard" : void 0),
				disabled: n === e.length - 1
			}));
		});
		return (t, n) => {
			let s = N("h-page-container");
			return O(), r(s, {
				"page-title": e.pageTitle,
				"page-prefix": e.pagePrefix,
				class: x(["h-admin-page", e.pageKey && `h-admin-${e.pageKey}-page`])
			}, {
				default: L(() => [
					M(t.$slots, "header-top", {}, () => [o("div", Pn, [e.breadcrumbItems && e.breadcrumbItems.length > 0 ? (O(), r(ze, {
						key: 0,
						items: a.value,
						class: "h-admin-breadcrumbs",
						icon: "mdi:mdi-home-outline"
					}, {
						divider: L(() => [...n[0] ||= [o("svg", {
							width: "20",
							height: "20",
							viewBox: "0 0 24 24",
							fill: "currentColor",
							"aria-hidden": "true",
							focusable: "false"
						}, [o("path", { d: "M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" })], -1)]]),
						_: 1
					}, 8, ["items"])) : i("", !0)])], !0),
					o("div", Fn, [M(t.$slots, "header-container", {}, () => [o("div", In, [M(t.$slots, "header-left", {}, () => [o("div", Ln, [M(t.$slots, "header-left-content", {}, () => [o("div", Rn, [o("h1", null, P(e.headerTitle), 1)])], !0)])], !0), M(t.$slots, "header-right", {}, () => [o("div", zn, [M(t.$slots, "header-right-content", {}, void 0, !0)])], !0)])], !0)]),
					M(t.$slots, "default", {}, void 0, !0)
				]),
				_: 3
			}, 8, [
				"page-title",
				"page-prefix",
				"class"
			]);
		};
	}
}), Vn = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Hn = /*#__PURE__*/ Vn(Bn, [["__scopeId", "data-v-8792fee4"]]), Un = { class: "h-admin-page__filters mb-4" }, Wn = { key: 1 }, Gn = { key: 2 }, Kn = { key: 0 }, qn = { class: "h-admin-filter-row d-flex flex-row flex-wrap ga-2" }, Jn = { class: "h-admin-filter-group-fields" }, Yn = { class: "h-admin-page__widgets" }, Xn = { class: "h-admin-page__content" }, Zn = /* @__PURE__ */ d({
	__name: "admin-data-view",
	props: /*@__PURE__*/ v({
		summaryLabel: {},
		filtersActive: { type: Boolean },
		tableShowSelect: { type: Boolean },
		externalFilterToggle: { type: Boolean },
		filterPanelId: {},
		totalResults: {},
		isFilterActive: {},
		tableHeaders: {},
		tableData: {},
		tableLoading: { type: Boolean },
		tableActions: { default: () => [] },
		tableRowsPerPage: { default: 25 },
		tableTotalItemsLimit: { default: 1e4 },
		tableRowsPerPageOptions: { default: () => [
			25,
			50,
			100,
			500
		] },
		tableNonPaginatedLimit: {},
		tablePagination: {
			type: Boolean,
			default: !0
		},
		filtersConfig: {},
		pageKey: { default: "" }
	}, {
		tableParams: {},
		tableParamsModifiers: {},
		filters: {},
		filtersModifiers: {},
		filtersExpanded: {
			type: Boolean,
			default: !1
		},
		filtersExpandedModifiers: {}
	}),
	emits: /*@__PURE__*/ v([
		"update:table-sort",
		"update:table-page",
		"clear-filters"
	], [
		"update:tableParams",
		"update:filters",
		"update:filtersExpanded"
	]),
	setup(t, { emit: c }) {
		k("adminFilterDesign", !0), k("adminResponsiveChips", !0);
		let u = z(t, "HAdminDataView"), d = ce(t, "tableParams"), f = ce(t, "filters"), m = ce(t, "filtersExpanded"), h = c, _ = A(null);
		function v() {
			return typeof window < "u" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
		}
		function b() {
			if (typeof window > "u") return;
			let e = v() ? "auto" : "smooth", t = _.value;
			for (; t;) {
				let n = getComputedStyle(t).overflowY;
				(n === "auto" || n === "scroll") && t.scrollHeight > t.clientHeight && typeof t.scrollTo == "function" && t.scrollTo({
					top: 0,
					behavior: e
				}), t = t.parentElement;
			}
			window.scrollTo({
				top: 0,
				behavior: e
			});
		}
		let x = A([...(u.tableHeaders ?? []).map((e) => ({
			...e,
			width: e.width || 150
		})), ...u.tableActions?.length > 0 ? [{
			title: "actions",
			key: "actions",
			sortable: !1,
			width: u.tableActions.length * 32 + 16,
			translate: !0
		}] : []]), C = n(() => {
			let e = f.value?.sortBy;
			for (let t of x.value) if (t.customSortKey === e) {
				e = t.key ?? e;
				break;
			}
			return [{
				key: e ?? "",
				order: f.value?.sortOrder ?? "desc"
			}];
		});
		E(() => {
			u.tableActions || (d.value.pagesize = u.tableNonPaginatedLimit || u.tableRowsPerPage, d.value.startfrom = 0);
		});
		function w(e) {
			f.value.sortBy = e.key, f.value.sortOrder = e.order, h("update:table-sort", e);
		}
		function T(e) {
			!f.value || f.value.page === e || (f.value.page = e, h("update:table-page", e), b());
		}
		function D(e) {
			!f.value || f.value.pageSize === e || (f.value.pageSize = e, f.value.page !== 1 && (f.value.page = 1), b());
		}
		function ee(e) {
			return `item.${e}`;
		}
		function ne(e) {
			let t = {
				...e.props,
				...e.attrs
			};
			return u.pageKey && (t.classPrefix = u.pageKey, t.filterKey = e.key), Object.keys(t).forEach((e) => {
				g(t[e]) && (t[e] = F(t[e])), typeof t[e] == "function" && (t[e] = t[e](f.value));
			}), t;
		}
		function ie(e) {
			if (!e.events) return {};
			let t = {};
			return Object.entries(e.events).forEach(([e, n]) => {
				typeof n == "function" ? t[e] = n : console.warn(`Event handler for "${e}" must be a function, received: ${typeof n}`);
			}), t;
		}
		return (n, c) => {
			let u = N("h-filters-container"), h = N("h-data-table");
			return O(), a("div", {
				ref_key: "dataViewRef",
				ref: _,
				class: "h-admin-data-view"
			}, [
				o("div", Un, [M(n.$slots, "filters-container", {}, () => [l(u, {
					expanded: m.value,
					"onUpdate:expanded": c[1] ||= (e) => m.value = e,
					results: t.totalResults,
					"hide-toggle": t.externalFilterToggle,
					"panel-id": t.filterPanelId,
					"hide-clear": t.externalFilterToggle && !t.filtersActive && !m.value,
					active: t.filtersActive || m.value,
					"clear-disabled": !t.filtersActive,
					onClearFilters: c[2] ||= (e) => n.$emit("clear-filters")
				}, {
					results: L(() => [n.$slots["filter-results"] ? M(n.$slots, "filter-results", { key: 0 }) : t.summaryLabel && !t.filtersActive && !m.value ? (O(), a("span", Wn, P(t.summaryLabel) + ": " + P(t.totalResults), 1)) : (O(), a("span", Gn, P(F(B)("admin_filter_results", { results: t.totalResults })), 1))]),
					filters: L(() => [M(n.$slots, "filters", {}, () => [t.filtersConfig && t.filtersConfig.filters && t.filtersConfig.filters.length > 0 ? (O(), a("div", Kn, [o("div", qn, [(O(!0), a(e, null, j(t.filtersConfig.filters, (t) => (O(), a(e, { key: t.key }, [t.type !== "group" && t.props?.showMatchTypeSelector ? (O(), r(te(t.component), y({
						key: 0,
						modelValue: f.value[t.model || t.key],
						"onUpdate:modelValue": (e) => f.value[t.model || t.key] = e,
						"match-type": f.value[`${t.key}MatchType`],
						"onUpdate:matchType": (e) => f.value[`${t.key}MatchType`] = e
					}, { ref_for: !0 }, ne(t), re(ie(t))), null, 16, [
						"modelValue",
						"onUpdate:modelValue",
						"match-type",
						"onUpdate:matchType"
					])) : t.type === "group" ? (O(), r(te(t.component), y({
						key: 2,
						filters: f.value,
						"onUpdate:filters": c[0] ||= (e) => f.value = e,
						"filter-keys": t.filters?.map((e) => e.model || e.key)
					}, { ref_for: !0 }, ne(t)), {
						default: L(() => [o("div", Jn, [(O(!0), a(e, null, j(t.filters, (t) => (O(), a(e, { key: t.key }, [t.props?.showMatchTypeSelector ? (O(), r(te(t.component), y({
							key: 0,
							modelValue: f.value[t.model || t.key],
							"onUpdate:modelValue": (e) => f.value[t.model || t.key] = e,
							"match-type": f.value[`${t.key}MatchType`],
							"onUpdate:matchType": (e) => f.value[`${t.key}MatchType`] = e
						}, { ref_for: !0 }, ne(t), re(ie(t))), null, 16, [
							"modelValue",
							"onUpdate:modelValue",
							"match-type",
							"onUpdate:matchType"
						])) : (O(), r(te(t.component), y({
							key: 1,
							modelValue: f.value[t.model || t.key],
							"onUpdate:modelValue": (e) => f.value[t.model || t.key] = e
						}, { ref_for: !0 }, ne(t), re(ie(t))), null, 16, ["modelValue", "onUpdate:modelValue"]))], 64))), 128))])]),
						_: 2
					}, 1040, ["filters", "filter-keys"])) : (O(), r(te(t.component), y({
						key: 1,
						modelValue: f.value[t.model || t.key],
						"onUpdate:modelValue": (e) => f.value[t.model || t.key] = e
					}, { ref_for: !0 }, ne(t), re(ie(t))), null, 16, ["modelValue", "onUpdate:modelValue"]))], 64))), 128))])])) : i("", !0)])]),
					_: 3
				}, 8, [
					"expanded",
					"results",
					"hide-toggle",
					"panel-id",
					"hide-clear",
					"active",
					"clear-disabled"
				])])]),
				o("div", Yn, [M(n.$slots, "widgets")]),
				o("div", Xn, [M(n.$slots, "content", {}, () => [l(Be, {
					class: "mt-3 h-admin-template-content-card",
					rounded: "lg"
				}, {
					default: L(() => [l(h, {
						"data-params": d.value,
						"onUpdate:dataParams": c[3] ||= (e) => d.value = e,
						headers: x.value,
						data: t.tableData,
						loading: t.tableLoading,
						"is-cell-active": t.isFilterActive,
						"total-items-limit": t.tableTotalItemsLimit,
						"items-per-page-options": t.tableRowsPerPageOptions,
						"items-per-page": Number(f.value?.pageSize) > 0 ? Number(f.value?.pageSize) : t.tableRowsPerPage,
						page: Number(f.value?.page) > 0 ? Number(f.value?.page) : 1,
						"item-actions": t.tableActions,
						"non-paginated-limit": t.tableNonPaginatedLimit,
						pagination: t.tablePagination,
						"sort-by": C.value,
						"class-prefix": t.pageKey,
						"show-select": t.tableShowSelect,
						"item-value": (e) => e.id || e.key,
						"onUpdate:sort": w,
						"onUpdate:page": T,
						"onUpdate:pageSize": D
					}, s({ _: 2 }, [j(t.tableHeaders, (e) => ({
						name: ee(e.key),
						fn: L((t) => [M(n.$slots, ee(e.key), S(p(t)))])
					})), n.$slots.bottom ? {
						name: "bottom",
						fn: L(() => [M(n.$slots, "bottom")]),
						key: "0"
					} : void 0]), 1032, [
						"data-params",
						"headers",
						"data",
						"loading",
						"is-cell-active",
						"total-items-limit",
						"items-per-page-options",
						"items-per-page",
						"page",
						"item-actions",
						"non-paginated-limit",
						"pagination",
						"sort-by",
						"class-prefix",
						"show-select",
						"item-value"
					])]),
					_: 3
				})])])
			], 512);
		};
	}
}), Qn = {
	key: 0,
	class: "h-admin-page__filter-count"
}, $n = /* @__PURE__ */ d({
	__name: "admin-template",
	props: /*@__PURE__*/ v({
		pageConfiguration: {},
		filtersConfig: {},
		widgetsConfig: {},
		tableHeaders: {},
		totalResults: {},
		isFilterActive: {},
		tableData: {},
		tableLoading: { type: Boolean },
		tableActions: { default: () => [] },
		tableRowsPerPage: { default: 25 },
		tableTotalItemsLimit: { default: 1e4 },
		tableRowsPerPageOptions: { default: () => [
			5,
			10,
			25,
			50,
			100,
			500
		] },
		tableNonPaginatedLimit: {},
		tablePagination: {
			type: Boolean,
			default: !0
		},
		openForm: {}
	}, {
		autoSearchEnabled: {
			type: Boolean,
			default: !0
		},
		autoSearchEnabledModifiers: {},
		tableParams: {},
		tableParamsModifiers: {},
		filters: {},
		filtersModifiers: {}
	}),
	emits: /*@__PURE__*/ v([
		"update:table-sort",
		"update:table-page",
		"clear-filters",
		"search"
	], [
		"update:autoSearchEnabled",
		"update:tableParams",
		"update:filters"
	]),
	setup(e, { emit: t }) {
		let u = z(e, "HAdminTemplate"), d = ce(e, "autoSearchEnabled"), f = A(!1), m = `admin-filters-${se()}`, h = ce(e, "tableParams"), g = ce(e, "filters"), _ = (e) => e == null || e === "" || e === "*" || Array.isArray(e) && e.length === 0 ? "" : JSON.stringify(e), v = Object.fromEntries(Object.entries(g.value || {}).map(([e, t]) => [e, _(t)])), b = /* @__PURE__ */ new Set([
			"page",
			"pageSize",
			"sortBy",
			"sortOrder"
		]), C = n(() => Object.entries(g.value || {}).some(([e, t]) => !b.has(e) && _(t) !== (v[e] ?? ""))), w = n(() => Object.entries(g.value || {}).reduce((e, [t, n]) => b.has(t) || t.endsWith("MatchType") || !t.endsWith("Preset") && _(g.value?.[`${t}Preset`]) || !_(n) || _(n) === (v[t] ?? "") ? e : e + (Array.isArray(n) ? n.length : 1), 0)), T = n(() => u.pageConfiguration?.pageTitle ?? ""), E = n(() => u.pageConfiguration?.pagePrefix ?? ""), D = n(() => u.pageConfiguration?.headerTitle ?? ""), k = n(() => u.pageConfiguration?.headerDescription ?? ""), ee = n(() => u.pageConfiguration?.searchPlaceholder ?? ""), te = n(() => u.pageConfiguration?.breadcrumbItems ?? []), ne = n(() => u.pageConfiguration?.pageKey ?? ""), re = n(() => u.widgetsConfig?.widgets?.find((e) => e.summary)), ie = n(() => u.widgetsConfig?.widgets?.filter((e) => !e.summary) ?? []), ae = n(() => u.tableHeaders ?? []), oe = n(() => u.filtersConfig ?? { filters: [] }), le = n(() => B("create"));
		return (t, n) => {
			let _ = N("h-search"), v = N("h-widgets-container"), b = N("h-theme-scope");
			return O(), r(Hn, {
				"page-title": T.value,
				"page-prefix": E.value,
				"header-title": D.value,
				"page-key": ne.value,
				"header-description": k.value,
				"breadcrumb-items": te.value
			}, {
				"header-right-content": L(() => [l(_, {
					modelValue: g.value.term,
					"onUpdate:modelValue": n[0] ||= (e) => g.value.term = e,
					"auto-search-enabled": d.value,
					"onUpdate:autoSearchEnabled": n[1] ||= (e) => d.value = e,
					class: "h-admin-page__search",
					"page-name": ee.value,
					"settings-menu": "",
					onSearch: n[2] ||= (e) => t.$emit("search")
				}, null, 8, [
					"modelValue",
					"auto-search-enabled",
					"page-name"
				]), l(Ke, {
					class: x(["h-admin-page__filter-toggle h-filters-container__toggle-filters", { "h-admin-page__filter-toggle--active": f.value || C.value }]),
					variant: "flat",
					color: "secondary",
					"prepend-icon": "mdi:mdi-filter",
					"aria-expanded": f.value,
					"aria-controls": m,
					onClick: n[3] ||= (e) => f.value = !f.value
				}, {
					default: L(() => [c(P(F(B)("admin_filters")) + " ", 1), w.value ? (O(), a("span", Qn, P(w.value), 1)) : i("", !0)]),
					_: 1
				}, 8, ["class", "aria-expanded"])]),
				default: L(() => [l(Zn, {
					"filters-expanded": f.value,
					"onUpdate:filtersExpanded": n[4] ||= (e) => f.value = e,
					filters: g.value,
					"onUpdate:filters": n[5] ||= (e) => g.value = e,
					"table-params": h.value,
					"onUpdate:tableParams": n[6] ||= (e) => h.value = e,
					"total-results": e.totalResults,
					"summary-label": re.value?.title,
					"filters-active": C.value,
					"is-filter-active": e.isFilterActive,
					"table-headers": ae.value,
					"table-data": e.tableData,
					"table-loading": e.tableLoading,
					"table-actions": e.tableActions,
					"table-rows-per-page": e.tableRowsPerPage,
					"table-total-items-limit": e.tableTotalItemsLimit,
					"table-rows-per-page-options": e.tableRowsPerPageOptions,
					"table-non-paginated-limit": e.tableNonPaginatedLimit,
					"table-pagination": e.tablePagination,
					"filters-config": oe.value,
					"page-key": ne.value,
					"filter-panel-id": m,
					"external-filter-toggle": "",
					onClearFilters: n[7] ||= (e) => t.$emit("clear-filters"),
					"onUpdate:tableSort": n[8] ||= (e) => t.$emit("update:table-sort", e),
					"onUpdate:tablePage": n[9] ||= (e) => t.$emit("update:table-page", e)
				}, s({
					widgets: L(() => [ie.value?.length ? (O(), r(v, {
						key: 0,
						widgets: ie.value,
						class: "h-widgets-container"
					}, null, 8, ["widgets"])) : i("", !0)]),
					_: 2
				}, [j(t.$slots, (e, n) => ({
					name: n,
					fn: L((e) => [M(t.$slots, n, S(p(e)))])
				})), t.$slots.bottom ? {
					name: "bottom",
					fn: L(() => [l(b, { name: "HScopedAdminTemplateTableBottom" }, {
						default: L(() => [M(t.$slots, "bottom")]),
						_: 3
					})]),
					key: "0"
				} : void 0]), 1032, [
					"filters-expanded",
					"filters",
					"table-params",
					"total-results",
					"summary-label",
					"filters-active",
					"is-filter-active",
					"table-headers",
					"table-data",
					"table-loading",
					"table-actions",
					"table-rows-per-page",
					"table-total-items-limit",
					"table-rows-per-page-options",
					"table-non-paginated-limit",
					"table-pagination",
					"filters-config",
					"page-key"
				]), F(u).openForm ? (O(), r(qe, {
					key: 0,
					location: "left"
				}, {
					activator: L(({ props: t }) => [l(Ke, y(t, {
						icon: "mdi:mdi-plus",
						color: "primary",
						size: "large",
						elevation: "3",
						class: "position-fixed ma-6",
						style: {
							bottom: "0",
							right: "0",
							"z-index": "99"
						},
						"aria-label": le.value,
						onClick: e.openForm
					}), null, 16, ["aria-label", "onClick"])]),
					default: L(() => [o("span", null, P(le.value), 1)]),
					_: 1
				})) : i("", !0)]),
				_: 3
			}, 8, [
				"page-title",
				"page-prefix",
				"header-title",
				"page-key",
				"header-description",
				"breadcrumb-items"
			]);
		};
	}
}), er = ["for"], tr = /*@__PURE__*/ Object.assign({
	name: "HFormLabel",
	inheritAttrs: !1
}, {
	__name: "form-label",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: "neutral-70"
		},
		iconSize: {
			type: String,
			default: "small"
		},
		labelColor: {
			type: String,
			default: "on-surface-variant"
		},
		labelWeight: {
			type: String,
			default: "font-weight-bold"
		},
		errorColor: {
			type: String,
			default: "error"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: !1
		},
		fieldId: {
			type: String,
			default: void 0
		},
		shrink: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = z(e, "HFormLabel"), o = n(() => t.error);
		return (t, n) => e.icon || e.label ? (O(), a("label", {
			key: 0,
			for: e.fieldId,
			class: x(["d-flex align-center ga-1 cursor-pointer", { "flex-shrink-0": e.shrink }])
		}, [
			e.icon ? (O(), r(V, {
				key: 0,
				size: e.iconSize,
				icon: e.icon,
				color: o.value ? e.errorColor : e.iconColor
			}, null, 8, [
				"size",
				"icon",
				"color"
			])) : i("", !0),
			e.label ? (O(), a("span", {
				key: 1,
				class: x([
					"text-body-medium",
					e.labelWeight,
					o.value ? `text-${e.errorColor}` : `text-${e.labelColor}`
				])
			}, P(e.label), 3)) : i("", !0),
			e.required ? (O(), a("span", {
				key: 2,
				class: x([`text-${e.errorColor}`])
			}, "*", 2)) : i("", !0)
		], 10, er)) : i("", !0);
	}
}), nr = { class: "d-flex align-center ga-2" }, rr = {
	key: 0,
	class: "header-spacing"
}, ir = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormField",
	inheritAttrs: !1
}, {
	__name: "form-field",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: "neutral-70"
		},
		iconSize: {
			type: String,
			default: "small"
		},
		labelColor: {
			type: String,
			default: "on-surface-variant"
		},
		labelWeight: {
			type: String,
			default: "font-weight-bold"
		},
		errorColor: {
			type: String,
			default: "error"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		labelPlacement: {
			type: String,
			default: "top",
			validator: (e) => ["top", "left"].includes(e)
		},
		indent: {
			type: Boolean,
			default: !1
		}
	},
	setup(e, { expose: t }) {
		let s = z(e, "HFormField"), c = se(), u = A(null), d = n(() => {
			if (s.error !== void 0) return s.error;
			let e = u.value;
			return e ? e.hasError || e.errorMessages && e.errorMessages.length > 0 || e.isValid === !1 : !1;
		});
		function f() {
			u.value?.focus && u.value.focus();
		}
		return t({
			fieldRef: u,
			fieldId: c,
			hasError: d,
			focusField: f
		}), (t, n) => e.labelPlacement === "left" ? (O(), r(H, {
			key: 0,
			class: "d-flex"
		}, {
			default: L(() => [o("div", nr, [l(tr, {
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				"label-color": e.labelColor,
				"label-weight": e.labelWeight,
				"error-color": e.errorColor,
				required: e.required,
				error: d.value,
				"field-id": F(c),
				shrink: !0
			}, null, 8, [
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"label-color",
				"label-weight",
				"error-color",
				"required",
				"error",
				"field-id"
			]), o("div", { class: x({ "px-6": e.indent }) }, [M(t.$slots, "default", S(p({
				id: F(c),
				"aria-required": e.required,
				"aria-label": e.ariaLabel || e.label
			})), void 0, !0)], 2)])]),
			_: 3
		})) : (O(), r(H, {
			key: 1,
			class: "d-flex flex-column"
		}, {
			default: L(() => [e.icon || e.label ? (O(), a("div", rr, [l(tr, {
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				"label-color": e.labelColor,
				"label-weight": e.labelWeight,
				"error-color": e.errorColor,
				required: e.required,
				error: d.value,
				"field-id": F(c)
			}, null, 8, [
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"label-color",
				"label-weight",
				"error-color",
				"required",
				"error",
				"field-id"
			])])) : i("", !0), o("div", { class: x(["mt-0", { "px-6": e.indent }]) }, [M(t.$slots, "default", S(p({
				id: F(c),
				"aria-required": e.required,
				"aria-label": e.ariaLabel || e.label
			})), void 0, !0)], 2)]),
			_: 3
		}));
	}
}), [["__scopeId", "data-v-ab1ffdac"]]), ar = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormText",
	inheritAttrs: !1
}, {
	__name: "form-text",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let i = n, a = oe(), o = z(e, "HFormText"), c = A(null), u = A(null), { handleKeydown: d, focus: f } = De(c, u, a, i, "input");
		function m() {
			return (c.value?.$el ?? c.value)?.querySelector?.("input")?.value ?? "";
		}
		return t({
			fieldRef: c,
			focus: f,
			getValue: m
		}), (t, n) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: u,
			label: F(o).variant === "filled" ? void 0 : e.label,
			icon: F(o).variant === "filled" ? void 0 : e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((n) => [l(Ze, y({
				ref_key: "fieldRef",
				ref: c
			}, {
				...n,
				...t.$attrs,
				label: F(o).variant === "filled" ? e.label : void 0,
				prependInnerIcon: F(o).variant === "filled" ? e.icon : void 0,
				variant: F(o).variant,
				bgColor: F(o).bgColor,
				color: F(o).color,
				baseColor: F(o).baseColor,
				rounded: F(o).rounded,
				density: F(o).density,
				hideDetails: F(o).hideDetails,
				persistentHint: F(o).persistentHint
			}, { onKeydown: F(d) }), s({ _: 2 }, [t.$slots["append-inner"] ? {
				name: "append-inner",
				fn: L((e) => [M(t.$slots, "append-inner", S(p(e || {})), void 0, !0)]),
				key: "0"
			} : void 0]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-8de0626f"]]), or = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormSelect",
	inheritAttrs: !1
}, {
	__name: "form-select",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let i = n, a = oe(), o = z(e, "HFormSelect"), c = A(null), u = A(null), { handleKeydown: d, focus: f } = De(c, u, a, i, "select");
		return t({
			fieldRef: c,
			focus: f
		}), (t, n) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: u,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((e) => [l(Qe, y({
				ref_key: "fieldRef",
				ref: c
			}, {
				...e,
				...t.$attrs,
				variant: F(o).variant,
				bgColor: F(o).bgColor,
				color: F(o).color,
				baseColor: F(o).baseColor,
				rounded: F(o).rounded,
				density: F(o).density,
				hideDetails: F(o).hideDetails,
				persistentHint: F(o).persistentHint,
				items: F(o).items,
				multiple: F(o).multiple,
				chips: F(o).chips,
				closableChips: F(o).closableChips
			}, { onKeydown: F(d) }), s({ _: 2 }, [j(t.$slots, (e, n) => ({
				name: n,
				fn: L((e) => [M(t.$slots, n, S(p(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-86dc11fd"]]), sr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormAutocomplete",
	inheritAttrs: !1
}, {
	__name: "form-autocomplete",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let i = n, a = oe(), o = z(e, "HFormAutocomplete"), c = A(null), u = A(null), { handleKeydown: d, focus: f } = De(c, u, a, i, "autocomplete");
		return t({
			fieldRef: c,
			focus: f
		}), (t, n) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: u,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((e) => [l($e, y({
				ref_key: "fieldRef",
				ref: c
			}, {
				...e,
				...t.$attrs,
				variant: F(o).variant,
				bgColor: F(o).bgColor,
				color: F(o).color,
				baseColor: F(o).baseColor,
				rounded: F(o).rounded,
				density: F(o).density,
				hideDetails: F(o).hideDetails,
				persistentHint: F(o).persistentHint,
				items: F(o).items,
				loading: F(o).loading,
				multiple: F(o).multiple,
				chips: F(o).chips,
				closableChips: F(o).closableChips
			}, { onKeydown: F(d) }), s({ _: 2 }, [j(t.$slots, (e, n) => ({
				name: n,
				fn: L((e) => [M(t.$slots, n, S(p(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-4bc6de4f"]]), cr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormCombobox",
	inheritAttrs: !1
}, {
	__name: "form-combobox",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: Boolean,
			default: !1
		},
		chips: {
			type: Boolean,
			default: !1
		},
		closableChips: {
			type: Boolean,
			default: !1
		},
		validateOn: {
			type: String,
			default: "blur"
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let i = n, a = oe(), o = z(e, "HFormCombobox"), c = A(null), u = A(null), { handleKeydown: d, focus: f } = De(c, u, a, i, "combobox");
		return t({
			fieldRef: c,
			focus: f
		}), (t, n) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: u,
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((e) => [l(et, y({
				ref_key: "fieldRef",
				ref: c
			}, {
				...e,
				...t.$attrs,
				validateOn: F(o).validateOn,
				variant: F(o).variant,
				bgColor: F(o).bgColor,
				color: F(o).color,
				baseColor: F(o).baseColor,
				rounded: F(o).rounded,
				density: F(o).density,
				hideDetails: F(o).hideDetails,
				persistentHint: F(o).persistentHint,
				items: F(o).items,
				loading: F(o).loading,
				multiple: F(o).multiple,
				chips: F(o).chips,
				closableChips: F(o).closableChips
			}, { onKeydown: F(d) }), s({ _: 2 }, [j(t.$slots, (e, n) => ({
				name: n,
				fn: L((e) => [M(t.$slots, n, S(p(e || {})), void 0, !0)])
			}))]), 1040, ["onKeydown"])]),
			_: 3
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-3273b534"]]), lr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormTextarea",
	inheritAttrs: !1
}, {
	__name: "form-textarea",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		autoGrow: {
			type: Boolean,
			default: !1
		},
		rows: {
			type: [Number, String],
			default: 3
		}
	},
	emits: ["keydown:enter", "keydown:esc"],
	setup(e, { expose: t, emit: n }) {
		let i = n, a = oe(), o = z(e, "HFormTextarea"), s = A(null), c = A(null), { handleKeydown: u, focus: d } = De(s, c, a, i, "textarea");
		return t({
			fieldRef: s,
			focus: d
		}), (t, n) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: c,
			label: F(o).variant === "filled" ? void 0 : e.label,
			icon: F(o).variant === "filled" ? void 0 : e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((n) => [l(tt, y({
				ref_key: "fieldRef",
				ref: s
			}, {
				...n,
				...t.$attrs,
				label: F(o).variant === "filled" ? e.label : void 0,
				prependInnerIcon: F(o).variant === "filled" ? e.icon : void 0,
				variant: F(o).variant,
				bgColor: F(o).bgColor,
				color: F(o).color,
				baseColor: F(o).baseColor,
				rounded: F(o).rounded,
				density: F(o).density,
				hideDetails: F(o).hideDetails,
				persistentHint: F(o).persistentHint,
				autoGrow: F(o).autoGrow,
				rows: F(o).rows
			}, { onKeydown: F(u) }), null, 16, ["onKeydown"])]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-dba304d3"]]), ur = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormSwitch",
	inheritAttrs: !1
}, {
	__name: "form-switch",
	props: {
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		color: {
			type: String,
			default: "primary"
		},
		baseColor: {
			type: String,
			default: "neutral-70"
		},
		density: {
			type: String,
			default: "default"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		inset: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		labelPlacement: {
			type: String,
			default: "top",
			validator: (e) => ["top", "left"].includes(e)
		}
	},
	setup(e, { expose: t }) {
		let n = z(e, "HFormSwitch"), i = A(null);
		return t({
			fieldRef: i,
			focus: () => i.value?.focus()
		}), (t, a) => (O(), r(ir, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel,
			"label-placement": e.labelPlacement
		}, {
			default: L((e) => [l(nt, y({
				ref_key: "fieldRef",
				ref: i
			}, {
				...e,
				...t.$attrs,
				color: F(n).color,
				baseColor: F(n).baseColor,
				density: F(n).density,
				hideDetails: F(n).hideDetails,
				persistentHint: F(n).persistentHint,
				inset: F(n).inset,
				disabled: F(n).disabled
			}), null, 16)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label",
			"label-placement"
		]));
	}
}), [["__scopeId", "data-v-037a9dc4"]]), dr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormDatePicker",
	inheritAttrs: !1
}, {
	__name: "form-date-picker",
	props: {
		modelValue: {
			type: [
				String,
				Number,
				Date,
				Array
			],
			default: null
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		pickerColor: {
			type: String,
			default: "primary"
		},
		pickerBgColor: {
			type: String,
			default: "surface"
		},
		pickerHeader: {
			type: String,
			default: void 0
		},
		pickerTitle: {
			type: String,
			default: void 0
		},
		hideHeader: {
			type: Boolean,
			default: !0
		},
		hideActions: {
			type: Boolean,
			default: !1
		},
		showAdjacentMonths: {
			type: Boolean,
			default: !1
		},
		showWeek: {
			type: Boolean,
			default: !1
		},
		multiple: {
			type: [
				Boolean,
				Number,
				String
			],
			default: !1
		},
		min: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		max: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		allowedDates: {
			type: [Array, Function],
			default: void 0
		},
		dateFormat: {
			type: Function,
			default: (e) => {
				if (!e) return "";
				let t = new Date(e);
				return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
			}
		},
		menuTransition: {
			type: String,
			default: "scale-transition"
		},
		menuLocation: {
			type: String,
			default: "bottom"
		},
		menuMinWidth: {
			type: String,
			default: "auto"
		},
		clearable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: i }) {
		let a = i, o = z(e, "HFormDatePicker"), c = A(null), u = A(!1), d = A(o.modelValue);
		I(() => o.modelValue, (e) => {
			d.value = e;
		});
		let f = n(() => d.value ? Array.isArray(d.value) ? d.value.map((e) => o.dateFormat(e)).join(", ") : o.dateFormat(d.value) : ""), m = (e) => {
			d.value = e, a("update:modelValue", e), o.multiple || (u.value = !1);
		}, h = () => {
			d.value = null, a("update:modelValue", null), u.value = !1;
		};
		return t({
			fieldRef: c,
			focus: () => c.value?.focus(),
			clear: h
		}), (t, n) => (O(), r(it, {
			modelValue: u.value,
			"onUpdate:modelValue": n[1] ||= (e) => u.value = e,
			"close-on-content-click": !1,
			transition: e.menuTransition,
			location: e.menuLocation,
			"min-width": e.menuMinWidth
		}, {
			activator: L(({ props: n }) => [l(ar, y({
				ref_key: "fieldRef",
				ref: c
			}, {
				...n,
				...t.$attrs
			}, {
				"model-value": f.value,
				label: e.label,
				icon: e.icon,
				"icon-color": e.iconColor,
				"icon-size": e.iconSize,
				required: e.required,
				error: e.error,
				"aria-label": e.ariaLabel,
				variant: e.variant,
				"bg-color": e.bgColor,
				color: e.color,
				"base-color": e.baseColor,
				rounded: e.rounded,
				density: e.density,
				"hide-details": e.hideDetails,
				class: { "h-form-date-picker--has-clear": e.clearable && f.value },
				readonly: ""
			}), s({ _: 2 }, [e.clearable && f.value ? {
				name: "append-inner",
				fn: L(() => [l(Ke, {
					class: "h-form-date-picker-clear",
					icon: "",
					variant: "text",
					size: "small",
					"aria-label": F(B)("clear"),
					onClick: R(h, ["stop", "prevent"])
				}, {
					default: L(() => [l(V, {
						icon: "mdi:mdi-close",
						size: "small"
					})]),
					_: 1
				}, 8, ["aria-label"])]),
				key: "0"
			} : void 0]), 1040, [
				"model-value",
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"required",
				"error",
				"aria-label",
				"variant",
				"bg-color",
				"color",
				"base-color",
				"rounded",
				"density",
				"hide-details",
				"class"
			])]),
			default: L(() => [l(rt, {
				modelValue: d.value,
				"onUpdate:modelValue": [n[0] ||= (e) => d.value = e, m],
				color: e.pickerColor,
				"bg-color": e.pickerBgColor,
				header: e.pickerHeader,
				title: e.pickerTitle,
				"hide-header": e.hideHeader,
				"hide-actions": e.hideActions,
				"show-adjacent-months": e.showAdjacentMonths,
				"show-week": e.showWeek,
				multiple: e.multiple,
				min: e.min,
				max: e.max,
				"allowed-dates": e.allowedDates
			}, s({ _: 2 }, [j(t.$slots, (e, n) => ({
				name: n,
				fn: L((e) => [M(t.$slots, n, S(p(e || {})), void 0, !0)])
			}))]), 1032, [
				"modelValue",
				"color",
				"bg-color",
				"header",
				"title",
				"hide-header",
				"hide-actions",
				"show-adjacent-months",
				"show-week",
				"multiple",
				"min",
				"max",
				"allowed-dates"
			])]),
			_: 3
		}, 8, [
			"modelValue",
			"transition",
			"location",
			"min-width"
		]));
	}
}), [["__scopeId", "data-v-4d6c29eb"]]);
//#endregion
//#region src/components/composed/form/date-value.js
function fr(e) {
	return String(e).padStart(2, "0");
}
function pr(e) {
	return e.includes("Z") || e.includes("z") || e.includes("+") ? !0 : e.lastIndexOf("-") > 10;
}
function mr(e) {
	if (e == null || e === "") return null;
	if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
	if (typeof e == "number") {
		let t = new Date(e);
		return Number.isNaN(t.getTime()) ? null : t;
	}
	if (typeof e != "string") {
		let t = new Date(e);
		return Number.isNaN(t.getTime()) ? null : t;
	}
	if (e.length === 10 && e[4] === "-" && e[7] === "-") {
		let t = new Date(Number(e.slice(0, 4)), Number(e.slice(5, 7)) - 1, Number(e.slice(8, 10)));
		return Number.isNaN(t.getTime()) ? null : t;
	}
	let t = e[10];
	if ((t === " " || t === "T") && e.length >= 16 && !pr(e)) {
		let t = e.length >= 19 && e[16] === ":" ? Number(e.slice(17, 19)) : 0, n = new Date(Number(e.slice(0, 4)), Number(e.slice(5, 7)) - 1, Number(e.slice(8, 10)), Number(e.slice(11, 13)), Number(e.slice(14, 16)), Number.isFinite(t) ? t : 0);
		return Number.isNaN(n.getTime()) ? null : n;
	}
	let n = new Date(e);
	return Number.isNaN(n.getTime()) ? null : n;
}
function hr(e, t) {
	let n = mr(e) ?? /* @__PURE__ */ new Date(), r = new Date(n.getTime()), [i, a, o] = (typeof t == "string" && t ? t : "00:00").split(":").map((e) => Number(e));
	return r.setHours(Number.isFinite(i) ? i : 0, Number.isFinite(a) ? a : 0, Number.isFinite(o) ? o : 0, 0), r;
}
function gr(e) {
	let t = mr(e);
	return t ? `${`${t.getFullYear()}-${fr(t.getMonth() + 1)}-${fr(t.getDate())}`} ${fr(t.getHours())}:${fr(t.getMinutes())}` : "";
}
function _r(e) {
	let t = mr(e);
	return t ? `${t.getFullYear()}-${fr(t.getMonth() + 1)}-${fr(t.getDate())}` : "";
}
//#endregion
//#region src/components/composed/form/form-date-time-picker.vue
var vr = { class: "h-form-date-time-picker-menu" }, yr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormDateTimePicker",
	inheritAttrs: !1
}, {
	__name: "form-date-time-picker",
	props: {
		modelValue: {
			type: [
				String,
				Number,
				Date
			],
			default: null
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "neutral-variant-90"
		},
		rounded: {
			type: [String, Number],
			default: 4
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		pickerColor: {
			type: String,
			default: "primary"
		},
		pickerBgColor: {
			type: String,
			default: "surface"
		},
		pickerHeader: {
			type: String,
			default: void 0
		},
		pickerTitle: {
			type: String,
			default: void 0
		},
		hideHeader: {
			type: Boolean,
			default: !0
		},
		showAdjacentMonths: {
			type: Boolean,
			default: !1
		},
		showWeek: {
			type: Boolean,
			default: !1
		},
		min: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		max: {
			type: [
				String,
				Number,
				Date
			],
			default: void 0
		},
		allowedDates: {
			type: [Array, Function],
			default: void 0
		},
		menuTransition: {
			type: String,
			default: "scale-transition"
		},
		menuLocation: {
			type: String,
			default: "bottom"
		},
		menuMinWidth: {
			type: String,
			default: "328px"
		},
		clearable: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(t, { expose: u, emit: d }) {
		let f = d, m = z(t, "HFormDateTimePicker"), h = A(null), g = A(!1), _ = A("date"), v = A(m.modelValue), b = A(mr(m.modelValue)), x = A(null);
		I(() => m.modelValue, (e) => {
			v.value = e, _.value === "date" && (b.value = mr(e));
		}), I(g, (e) => {
			e || E();
		});
		let C = n(() => b.value ?? mr(v.value)), w = n(() => _r(b.value ?? v.value)), T = n(() => gr(v.value));
		function E() {
			_.value = "date", b.value = mr(v.value), x.value = null;
		}
		function D(e) {
			e && (b.value = mr(e) ?? e, x.value = null, _.value = "time");
		}
		function k(e) {
			if (!e) return;
			let t = hr(b.value ?? v.value, e);
			v.value = t, f("update:modelValue", t), g.value = !1, E();
		}
		function ee() {
			x.value = null, _.value = "date";
		}
		function N() {
			v.value = null, b.value = null, x.value = null, _.value = "date", f("update:modelValue", null), g.value = !1;
		}
		return u({
			fieldRef: h,
			focus: () => h.value?.focus?.(),
			clear: N
		}), (n, u) => (O(), r(it, {
			modelValue: g.value,
			"onUpdate:modelValue": u[0] ||= (e) => g.value = e,
			"close-on-content-click": !1,
			transition: t.menuTransition,
			location: t.menuLocation,
			"min-width": t.menuMinWidth,
			"max-width": t.menuMinWidth
		}, {
			activator: L(({ props: e }) => [l(ar, y({
				ref_key: "fieldRef",
				ref: h
			}, {
				...e,
				...n.$attrs
			}, {
				"model-value": T.value,
				label: t.label,
				icon: t.icon,
				"icon-color": t.iconColor,
				"icon-size": t.iconSize,
				required: t.required,
				error: t.error,
				"aria-label": t.ariaLabel,
				variant: t.variant,
				"bg-color": t.bgColor,
				color: t.color,
				"base-color": t.baseColor,
				rounded: t.rounded,
				density: t.density,
				"hide-details": t.hideDetails,
				class: { "h-form-date-time-picker--has-clear": t.clearable && T.value },
				readonly: ""
			}), s({ _: 2 }, [t.clearable && T.value ? {
				name: "append-inner",
				fn: L(() => [l(Ke, {
					class: "h-form-date-time-picker-clear",
					icon: "",
					variant: "text",
					size: "small",
					"aria-label": F(B)("clear"),
					onClick: R(N, ["stop", "prevent"])
				}, {
					default: L(() => [l(V, {
						icon: "mdi:mdi-close",
						size: "small"
					})]),
					_: 1
				}, 8, ["aria-label"])]),
				key: "0"
			} : void 0]), 1040, [
				"model-value",
				"label",
				"icon",
				"icon-color",
				"icon-size",
				"required",
				"error",
				"aria-label",
				"variant",
				"bg-color",
				"color",
				"base-color",
				"rounded",
				"density",
				"hide-details",
				"class"
			])]),
			default: L(() => [o("div", vr, [_.value === "date" ? (O(), r(rt, {
				key: 0,
				"model-value": C.value,
				color: t.pickerColor,
				"bg-color": t.pickerBgColor,
				header: t.pickerHeader,
				title: t.pickerTitle,
				"hide-header": t.hideHeader,
				"hide-actions": "",
				"show-adjacent-months": t.showAdjacentMonths,
				"show-week": t.showWeek,
				min: t.min,
				max: t.max,
				"allowed-dates": t.allowedDates,
				"onUpdate:modelValue": D
			}, s({ _: 2 }, [j(n.$slots, (e, t) => ({
				name: t,
				fn: L((e) => [M(n.$slots, t, S(p(e || {})), void 0, !0)])
			}))]), 1032, [
				"model-value",
				"color",
				"bg-color",
				"header",
				"title",
				"hide-header",
				"show-adjacent-months",
				"show-week",
				"min",
				"max",
				"allowed-dates"
			])) : _.value === "time" ? (O(), a(e, { key: 1 }, [l(Ke, {
				class: "h-form-date-time-picker-back",
				variant: "text",
				"prepend-icon": "mdi:mdi-chevron-left",
				"aria-label": F(B)("back"),
				onClick: ee
			}, {
				default: L(() => [c(P(w.value), 1)]),
				_: 1
			}, 8, ["aria-label"]), l(at, {
				class: "h-form-date-time-picker-time",
				"model-value": x.value,
				color: t.pickerColor,
				"bg-color": t.pickerBgColor,
				format: "24hr",
				"hide-header": "",
				"onUpdate:modelValue": k
			}, null, 8, [
				"model-value",
				"color",
				"bg-color"
			])], 64)) : i("", !0)])]),
			_: 3
		}, 8, [
			"modelValue",
			"transition",
			"location",
			"min-width",
			"max-width"
		]));
	}
}), [["__scopeId", "data-v-09a981a0"]]), br = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormOtpInput",
	inheritAttrs: !1
}, {
	__name: "form-otp-input",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		length: {
			type: Number,
			default: 6,
			validator: (e) => e > 0 && e <= 12
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: void 0
		},
		required: {
			type: Boolean,
			default: !1
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "filled"
		},
		density: {
			type: String,
			default: "comfortable"
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: !1
		},
		hideDetails: {
			type: Boolean,
			default: !0
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		gap: {
			type: String,
			default: "4px"
		},
		customDefaults: {
			type: Object,
			default: void 0
		}
	},
	emits: ["update:modelValue", "complete"],
	setup(t, { expose: i, emit: s }) {
		let c = s;
		oe();
		let l = z(t, "HFormOtpInput"), u = A(null), d = A([]), f = (e, t) => {
			e && (d.value[t] = e);
		}, p = A(Array(l.length).fill("")), m = n(() => l.gap);
		I(() => l.modelValue, (e) => {
			let t = (e || "").split("").slice(0, l.length);
			p.value = [...t, ...Array(l.length - t.length).fill("")];
		}, { immediate: !0 }), I(p, (e) => {
			let t = e.join("");
			c("update:modelValue", t), t.length === l.length && !t.includes("") && c("complete", t);
		}, { deep: !0 });
		let h = (e, t) => {
			let n = t.target.value;
			n && (p.value[e] = n.slice(-1), e < l.length - 1 && w(e + 1));
		}, g = (e, t) => {
			!p.value[e] && e > 0 ? (t.preventDefault(), p.value[e - 1] = "", w(e - 1)) : p.value[e] && (p.value[e] = "");
		}, _ = (e) => {
			p.value[e] = "";
		}, v = (e) => {
			e > 0 && w(e - 1);
		}, y = (e) => {
			e < l.length - 1 && w(e + 1);
		}, x = (e, t) => {
			t.preventDefault();
			let n = t.clipboardData.getData("text").trim();
			if (n) {
				let t = n.split("").slice(0, l.length - e);
				t.forEach((t, n) => {
					e + n < l.length && /^[a-zA-Z0-9]$/.test(t) && (p.value[e + n] = t);
				});
				let r = p.value.findIndex((t, n) => n >= e && !t);
				w(r === -1 ? Math.min(e + t.length, l.length - 1) : r);
			}
		}, S = (e) => {
			b(() => {
				let t = T(e);
				t && t.select();
			});
		}, w = (e) => {
			b(() => {
				let t = T(e);
				t && t.focus();
			});
		}, T = (e) => {
			let t = d.value[e];
			return t ? t.$el?.querySelector("input") : null;
		};
		return i({
			clear: () => {
				p.value = Array(l.length).fill(""), w(0);
			},
			focus: () => {
				w(0);
			},
			formFieldRef: u
		}), (n, i) => (O(), r(ir, {
			ref_key: "formFieldRef",
			ref: u,
			label: t.label,
			icon: t.icon,
			"icon-color": t.iconColor,
			"icon-size": t.iconSize,
			required: t.required,
			error: t.error,
			"aria-label": t.ariaLabel
		}, {
			default: L(() => [o("div", {
				class: "h-form-otp-input d-flex",
				style: C({ gap: m.value })
			}, [(O(!0), a(e, null, j(p.value, (e, n) => (O(), r(Ze, {
				key: n,
				ref_for: !0,
				ref: (e) => f(e, n),
				modelValue: p.value[n],
				"onUpdate:modelValue": (e) => p.value[n] = e,
				variant: t.variant,
				density: t.density,
				disabled: t.disabled,
				error: t.error,
				"hide-details": t.hideDetails,
				"persistent-hint": t.persistentHint,
				color: "primary",
				class: "h-form-otp-input__field",
				maxlength: "1",
				onInput: (e) => h(n, e),
				onKeydown: [
					fe((e) => g(n, e), ["backspace"]),
					fe((e) => _(n), ["delete"]),
					fe((e) => v(n), ["left"]),
					fe((e) => y(n), ["right"])
				],
				onPaste: (e) => x(n, e),
				onFocus: (e) => S(n)
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"variant",
				"density",
				"disabled",
				"error",
				"hide-details",
				"persistent-hint",
				"onInput",
				"onKeydown",
				"onPaste",
				"onFocus"
			]))), 128))], 4)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-c6033d1d"]]), xr = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormPassword",
	inheritAttrs: !1
}, {
	__name: "form-password",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		allowEmpty: {
			type: Boolean,
			default: !1
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: "mdi:mdi-lock"
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "on-surface-variant"
		},
		rounded: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		persistentHint: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		passwordLabel: {
			type: String,
			default: void 0
		},
		confirmLabel: {
			type: String,
			default: void 0
		},
		minPasswordLength: {
			type: Number,
			default: 8
		},
		id: {
			type: String,
			default: void 0
		},
		disableAutofill: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: i }) {
		let a = `password-confirm-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`, o = z(e, "HFormPassword"), s = i, c = n(() => o.disableAutofill ? {
			autocomplete: "new-password",
			"data-1p-ignore": !0,
			"data-lpignore": "true"
		} : {}), u = o.id || a, d = `${u}-password`, f = `${u}-confirm`, p = A(null), m = A(null), h = A(""), g = A(""), _ = A(!1), v = A(!1), x = A(!1), S = A(void 0);
		I(() => o.modelValue, (e) => {
			e !== S.value && (x.value = !0, o.allowEmpty && e ? (h.value = "", g.value = "") : (h.value = e || "", g.value = ""), b(() => {
				x.value = !1;
			}));
		}, { immediate: !0 });
		let C = n(() => {
			let e = [];
			return o.required && !o.allowEmpty && e.push((e) => !!e || B("password_required")), h.value && h.value.length > 0 && e.push((e) => e && e.length >= o.minPasswordLength || B("password_min_length", { length: o.minPasswordLength })), e;
		}), w = n(() => {
			let e = [];
			return h.value && (e.push((e) => !!e || B("confirm_password_required")), e.push((e) => e === h.value || B("passwords_must_match"))), e;
		});
		return I([h, g], ([e, t]) => {
			x.value || e === t && (S.value = e, s("update:modelValue", e));
		}), t({
			passwordFieldRef: p,
			confirmFieldRef: m,
			focus: () => p.value?.focus()
		}), (t, n) => (O(), r(ir, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error,
			"aria-label": e.ariaLabel
		}, {
			default: L((t) => [l(Ye, null, {
				default: L(() => [l(H, { cols: "12" }, {
					default: L(() => [l(Ze, y({
						id: d,
						ref_key: "passwordFieldRef",
						ref: p,
						modelValue: h.value,
						"onUpdate:modelValue": n[3] ||= (e) => h.value = e,
						type: _.value ? "text" : "password",
						placeholder: e.allowEmpty && !h.value ? "••••••" : "",
						label: e.passwordLabel,
						variant: e.variant,
						"bg-color": e.bgColor,
						color: e.color,
						"base-color": e.baseColor,
						rounded: e.rounded,
						density: e.density,
						"hide-details": e.hideDetails,
						"persistent-hint": e.persistentHint,
						disabled: e.disabled,
						rules: C.value
					}, {
						...t,
						...c.value
					}), {
						"append-inner": L(() => [l(V, {
							icon: _.value ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
							role: "button",
							tabindex: "0",
							"aria-label": F(B)("toggle_password_visibility"),
							class: "cursor-pointer",
							onClick: n[0] ||= (e) => _.value = !_.value,
							onKeydown: [n[1] ||= fe((e) => _.value = !_.value, ["enter"]), n[2] ||= fe(R((e) => _.value = !_.value, ["prevent"]), ["space"])]
						}, null, 8, ["icon", "aria-label"])]),
						_: 1
					}, 16, [
						"modelValue",
						"type",
						"placeholder",
						"label",
						"variant",
						"bg-color",
						"color",
						"base-color",
						"rounded",
						"density",
						"hide-details",
						"persistent-hint",
						"disabled",
						"rules"
					])]),
					_: 2
				}, 1024), l(H, { cols: "12" }, {
					default: L(() => [l(Ze, y({
						id: f,
						ref_key: "confirmFieldRef",
						ref: m,
						modelValue: g.value,
						"onUpdate:modelValue": n[5] ||= (e) => g.value = e,
						type: v.value ? "text" : "password",
						label: e.confirmLabel,
						variant: e.variant,
						"bg-color": e.bgColor,
						color: e.color,
						"base-color": e.baseColor,
						rounded: e.rounded,
						density: e.density,
						"hide-details": e.hideDetails,
						"persistent-hint": e.persistentHint,
						disabled: e.disabled,
						rules: w.value
					}, {
						...t,
						...c.value
					}), {
						"append-inner": L(() => [l(V, {
							icon: v.value ? "mdi:mdi-eye-off" : "mdi:mdi-eye",
							role: "button",
							tabindex: "0",
							"aria-label": F(B)("toggle_password_visibility"),
							class: "cursor-pointer",
							onClick: n[4] ||= (e) => v.value = !v.value
						}, null, 8, ["icon", "aria-label"])]),
						_: 1
					}, 16, [
						"modelValue",
						"type",
						"label",
						"variant",
						"bg-color",
						"color",
						"base-color",
						"rounded",
						"density",
						"hide-details",
						"persistent-hint",
						"disabled",
						"rules"
					])]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-68d82515"]]), Sr = [], Cr = [];
(() => {
	let e = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((e) => e ? parseInt(e, 36) : 1);
	for (let t = 0, n = 0; t < e.length; t++) (t % 2 ? Cr : Sr).push(n += e[t]);
})();
function wr(e) {
	if (e < 768) return !1;
	for (let t = 0, n = Sr.length;;) {
		let r = t + n >> 1;
		if (e < Sr[r]) n = r;
		else if (e >= Cr[r]) t = r + 1;
		else return !0;
		if (t == n) return !1;
	}
}
function Tr(e) {
	return e >= 127462 && e <= 127487;
}
var Er = 8205;
function Dr(e, t, n = !0, r = !0) {
	return (n ? Or : kr)(e, t, r);
}
function Or(e, t, n) {
	if (t == e.length) return t;
	t && jr(e.charCodeAt(t)) && Mr(e.charCodeAt(t - 1)) && t--;
	let r = Ar(e, t);
	for (t += Nr(r); t < e.length;) {
		let i = Ar(e, t);
		if (r == Er || i == Er || n && wr(i)) t += Nr(i), r = i;
		else if (Tr(i)) {
			let n = 0, r = t - 2;
			for (; r >= 0 && Tr(Ar(e, r));) n++, r -= 2;
			if (n % 2 == 0) break;
			t += 2;
		} else break;
	}
	return t;
}
function kr(e, t, n) {
	for (; t > 0;) {
		let r = Or(e, t - 2, n);
		if (r < t) return r;
		t--;
	}
	return 0;
}
function Ar(e, t) {
	let n = e.charCodeAt(t);
	if (!Mr(n) || t + 1 == e.length) return n;
	let r = e.charCodeAt(t + 1);
	return jr(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function jr(e) {
	return e >= 56320 && e < 57344;
}
function Mr(e) {
	return e >= 55296 && e < 56320;
}
function Nr(e) {
	return e < 65536 ? 1 : 2;
}
//#endregion
//#region ../../../node_modules/@codemirror/state/dist/index.js
var Pr = class e {
	lineAt(e) {
		if (e < 0 || e > this.length) throw RangeError(`Invalid position ${e} in document of length ${this.length}`);
		return this.lineInner(e, !1, 1, 0);
	}
	line(e) {
		if (e < 1 || e > this.lines) throw RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
		return this.lineInner(e, !0, 1, 0);
	}
	replace(e, t, n) {
		[e, t] = Wr(this, e, t);
		let r = [];
		return this.decompose(0, e, r, 2), n.length && n.decompose(0, n.length, r, 3), this.decompose(t, this.length, r, 1), Ir.from(r, this.length - (t - e) + n.length);
	}
	append(e) {
		return this.replace(this.length, this.length, e);
	}
	slice(e, t = this.length) {
		[e, t] = Wr(this, e, t);
		let n = [];
		return this.decompose(e, t, n, 0), Ir.from(n, t - e);
	}
	eq(e) {
		if (e == this) return !0;
		if (e.length != this.length || e.lines != this.lines) return !1;
		let t = this.scanIdentical(e, 1), n = this.length - this.scanIdentical(e, -1), r = new Br(this), i = new Br(e);
		for (let e = t, a = t;;) {
			if (r.next(e), i.next(e), e = 0, r.lineBreak != i.lineBreak || r.done != i.done || r.value != i.value) return !1;
			if (a += r.value.length, r.done || a >= n) return !0;
		}
	}
	iter(e = 1) {
		return new Br(this, e);
	}
	iterRange(e, t = this.length) {
		return new Vr(this, e, t);
	}
	iterLines(e, t) {
		let n;
		if (e == null) n = this.iter();
		else {
			t ??= this.lines + 1;
			let r = this.line(e).from;
			n = this.iterRange(r, Math.max(r, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to));
		}
		return new Hr(n);
	}
	toString() {
		return this.sliceString(0);
	}
	toJSON() {
		let e = [];
		return this.flatten(e), e;
	}
	constructor() {}
	static of(t) {
		if (t.length == 0) throw RangeError("A document must have at least one line");
		return t.length == 1 && !t[0] ? e.empty : t.length <= 32 ? new Fr(t) : Ir.from(Fr.split(t, []));
	}
}, Fr = class e extends Pr {
	constructor(e, t = Lr(e)) {
		super(), this.text = e, this.length = t;
	}
	get lines() {
		return this.text.length;
	}
	get children() {
		return null;
	}
	lineInner(e, t, n, r) {
		for (let i = 0;; i++) {
			let a = this.text[i], o = r + a.length;
			if ((t ? n : o) >= e) return new Ur(r, o, n, a);
			r = o + 1, n++;
		}
	}
	decompose(t, n, r, i) {
		let a = t <= 0 && n >= this.length ? this : new e(zr(this.text, t, n), Math.min(n, this.length) - Math.max(0, t));
		if (i & 1) {
			let t = r.pop(), n = Rr(a.text, t.text.slice(), 0, a.length);
			if (n.length <= 32) r.push(new e(n, t.length + a.length));
			else {
				let t = n.length >> 1;
				r.push(new e(n.slice(0, t)), new e(n.slice(t)));
			}
		} else r.push(a);
	}
	replace(t, n, r) {
		if (!(r instanceof e)) return super.replace(t, n, r);
		[t, n] = Wr(this, t, n);
		let i = Rr(this.text, Rr(r.text, zr(this.text, 0, t)), n), a = this.length + r.length - (n - t);
		return i.length <= 32 ? new e(i, a) : Ir.from(e.split(i, []), a);
	}
	sliceString(e, t = this.length, n = "\n") {
		[e, t] = Wr(this, e, t);
		let r = "";
		for (let i = 0, a = 0; i <= t && a < this.text.length; a++) {
			let o = this.text[a], s = i + o.length;
			i > e && a && (r += n), e < s && t > i && (r += o.slice(Math.max(0, e - i), t - i)), i = s + 1;
		}
		return r;
	}
	flatten(e) {
		for (let t of this.text) e.push(t);
	}
	scanIdentical() {
		return 0;
	}
	static split(t, n) {
		let r = [], i = -1;
		for (let a of t) r.push(a), i += a.length + 1, r.length == 32 && (n.push(new e(r, i)), r = [], i = -1);
		return i > -1 && n.push(new e(r, i)), n;
	}
}, Ir = class e extends Pr {
	constructor(e, t) {
		super(), this.children = e, this.length = t, this.lines = 0;
		for (let t of e) this.lines += t.lines;
	}
	lineInner(e, t, n, r) {
		for (let i = 0;; i++) {
			let a = this.children[i], o = r + a.length, s = n + a.lines - 1;
			if ((t ? s : o) >= e) return a.lineInner(e, t, n, r);
			r = o + 1, n = s + 1;
		}
	}
	decompose(e, t, n, r) {
		for (let i = 0, a = 0; a <= t && i < this.children.length; i++) {
			let o = this.children[i], s = a + o.length;
			if (e <= s && t >= a) {
				let i = r & (a <= e | (s >= t ? 2 : 0));
				a >= e && s <= t && !i ? n.push(o) : o.decompose(e - a, t - a, n, i);
			}
			a = s + 1;
		}
	}
	replace(t, n, r) {
		if ([t, n] = Wr(this, t, n), r.lines < this.lines) for (let i = 0, a = 0; i < this.children.length; i++) {
			let o = this.children[i], s = a + o.length;
			if (t >= a && n <= s) {
				let c = o.replace(t - a, n - a, r), l = this.lines - o.lines + c.lines;
				if (c.lines < l >> 4 && c.lines > l >> 6) {
					let a = this.children.slice();
					return a[i] = c, new e(a, this.length - (n - t) + r.length);
				}
				return super.replace(a, s, c);
			}
			a = s + 1;
		}
		return super.replace(t, n, r);
	}
	sliceString(e, t = this.length, n = "\n") {
		[e, t] = Wr(this, e, t);
		let r = "";
		for (let i = 0, a = 0; i < this.children.length && a <= t; i++) {
			let o = this.children[i], s = a + o.length;
			a > e && i && (r += n), e < s && t > a && (r += o.sliceString(e - a, t - a, n)), a = s + 1;
		}
		return r;
	}
	flatten(e) {
		for (let t of this.children) t.flatten(e);
	}
	scanIdentical(t, n) {
		if (!(t instanceof e)) return 0;
		let r = 0, [i, a, o, s] = n > 0 ? [
			0,
			0,
			this.children.length,
			t.children.length
		] : [
			this.children.length - 1,
			t.children.length - 1,
			-1,
			-1
		];
		for (;; i += n, a += n) {
			if (i == o || a == s) return r;
			let e = this.children[i], c = t.children[a];
			if (e != c) return r + e.scanIdentical(c, n);
			r += e.length + 1;
		}
	}
	static from(t, n = t.reduce((e, t) => e + t.length + 1, -1)) {
		let r = 0;
		for (let e of t) r += e.lines;
		if (r < 32) {
			let e = [];
			for (let n of t) n.flatten(e);
			return new Fr(e, n);
		}
		let i = Math.max(32, r >> 5), a = i << 1, o = i >> 1, s = [], c = 0, l = -1, u = [];
		function d(t) {
			let n;
			if (t.lines > a && t instanceof e) for (let e of t.children) d(e);
			else t.lines > o && (c > o || !c) ? (f(), s.push(t)) : t instanceof Fr && c && (n = u[u.length - 1]) instanceof Fr && t.lines + n.lines <= 32 ? (c += t.lines, l += t.length + 1, u[u.length - 1] = new Fr(n.text.concat(t.text), n.length + 1 + t.length)) : (c + t.lines > i && f(), c += t.lines, l += t.length + 1, u.push(t));
		}
		function f() {
			c != 0 && (s.push(u.length == 1 ? u[0] : e.from(u, l)), l = -1, c = u.length = 0);
		}
		for (let e of t) d(e);
		return f(), s.length == 1 ? s[0] : new e(s, n);
	}
};
Pr.empty = /*@__PURE__*/ new Fr([""], 0);
function Lr(e) {
	let t = -1;
	for (let n of e) t += n.length + 1;
	return t;
}
function Rr(e, t, n = 0, r = 1e9) {
	for (let i = 0, a = 0, o = !0; a < e.length && i <= r; a++) {
		let s = e[a], c = i + s.length;
		c >= n && (c > r && (s = s.slice(0, r - i)), i < n && (s = s.slice(n - i)), o ? (t[t.length - 1] += s, o = !1) : t.push(s)), i = c + 1;
	}
	return t;
}
function zr(e, t, n) {
	return Rr(e, [""], t, n);
}
var Br = class {
	constructor(e, t = 1) {
		this.dir = t, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [t > 0 ? 1 : (e instanceof Fr ? e.text.length : e.children.length) << 1];
	}
	nextInner(e, t) {
		for (this.done = this.lineBreak = !1;;) {
			let n = this.nodes.length - 1, r = this.nodes[n], i = this.offsets[n], a = i >> 1, o = r instanceof Fr ? r.text.length : r.children.length;
			if (a == (t > 0 ? o : 0)) {
				if (n == 0) return this.done = !0, this.value = "", this;
				t > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop();
			} else if ((i & 1) == (t > 0 ? 0 : 1)) {
				if (this.offsets[n] += t, e == 0) return this.lineBreak = !0, this.value = "\n", this;
				e--;
			} else if (r instanceof Fr) {
				let i = r.text[a + (t < 0 ? -1 : 0)];
				if (this.offsets[n] += t, i.length > Math.max(0, e)) return this.value = e == 0 ? i : t > 0 ? i.slice(e) : i.slice(0, i.length - e), this;
				e -= i.length;
			} else {
				let i = r.children[a + (t < 0 ? -1 : 0)];
				e > i.length ? (e -= i.length, this.offsets[n] += t) : (t < 0 && this.offsets[n]--, this.nodes.push(i), this.offsets.push(t > 0 ? 1 : (i instanceof Fr ? i.text.length : i.children.length) << 1));
			}
		}
	}
	next(e = 0) {
		return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
	}
}, Vr = class {
	constructor(e, t, n) {
		this.value = "", this.done = !1, this.cursor = new Br(e, t > n ? -1 : 1), this.pos = t > n ? e.length : 0, this.from = Math.min(t, n), this.to = Math.max(t, n);
	}
	nextInner(e, t) {
		if (t < 0 ? this.pos <= this.from : this.pos >= this.to) return this.value = "", this.done = !0, this;
		e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
		let n = t < 0 ? this.pos - this.from : this.to - this.pos;
		e > n && (e = n), n -= e;
		let { value: r } = this.cursor.next(e);
		return this.pos += (r.length + e) * t, this.value = r.length <= n ? r : t < 0 ? r.slice(r.length - n) : r.slice(0, n), this.done = !this.value, this;
	}
	next(e = 0) {
		return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
	}
	get lineBreak() {
		return this.cursor.lineBreak && this.value != "";
	}
}, Hr = class {
	constructor(e) {
		this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
	}
	next(e = 0) {
		let { done: t, lineBreak: n, value: r } = this.inner.next(e);
		return t && this.afterBreak ? (this.value = "", this.afterBreak = !1) : t ? (this.done = !0, this.value = "") : n ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = r, this.afterBreak = !1), this;
	}
	get lineBreak() {
		return !1;
	}
};
typeof Symbol < "u" && (Pr.prototype[Symbol.iterator] = function() {
	return this.iter();
}, Br.prototype[Symbol.iterator] = Vr.prototype[Symbol.iterator] = Hr.prototype[Symbol.iterator] = function() {
	return this;
});
var Ur = class {
	constructor(e, t, n, r) {
		this.from = e, this.to = t, this.number = n, this.text = r;
	}
	get length() {
		return this.to - this.from;
	}
};
function Wr(e, t, n) {
	return t = Math.max(0, Math.min(e.length, t)), [t, Math.max(t, Math.min(e.length, n))];
}
function Gr(e, t, n = !0, r = !0) {
	return Dr(e, t, n, r);
}
function Kr(e) {
	return e >= 56320 && e < 57344;
}
function qr(e) {
	return e >= 55296 && e < 56320;
}
function Jr(e, t) {
	let n = e.charCodeAt(t);
	if (!qr(n) || t + 1 == e.length) return n;
	let r = e.charCodeAt(t + 1);
	return Kr(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function Yr(e) {
	return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
function Xr(e) {
	return e < 65536 ? 1 : 2;
}
var Zr = /\r\n?|\n/, Qr = /*@__PURE__*/ (function(e) {
	return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
})(Qr ||= {}), $r = class e {
	constructor(e) {
		this.sections = e;
	}
	get length() {
		let e = 0;
		for (let t = 0; t < this.sections.length; t += 2) e += this.sections[t];
		return e;
	}
	get newLength() {
		let e = 0;
		for (let t = 0; t < this.sections.length; t += 2) {
			let n = this.sections[t + 1];
			e += n < 0 ? this.sections[t] : n;
		}
		return e;
	}
	get empty() {
		return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
	}
	iterGaps(e) {
		for (let t = 0, n = 0, r = 0; t < this.sections.length;) {
			let i = this.sections[t++], a = this.sections[t++];
			a < 0 ? (e(n, r, i), r += i) : r += a, n += i;
		}
	}
	iterChangedRanges(e, t = !1) {
		ri(this, e, t);
	}
	get invertedDesc() {
		let t = [];
		for (let e = 0; e < this.sections.length;) {
			let n = this.sections[e++], r = this.sections[e++];
			r < 0 ? t.push(n, r) : t.push(r, n);
		}
		return new e(t);
	}
	composeDesc(e) {
		return this.empty ? e : e.empty ? this : ai(this, e);
	}
	mapDesc(e, t = !1) {
		return e.empty ? this : ii(this, e, t);
	}
	mapPos(e, t = -1, n = Qr.Simple) {
		let r = 0, i = 0;
		for (let a = 0; a < this.sections.length;) {
			let o = this.sections[a++], s = this.sections[a++], c = r + o;
			if (s < 0) {
				if (c > e) return i + (e - r);
				i += o;
			} else {
				if (n != Qr.Simple && c >= e && (n == Qr.TrackDel && r < e && c > e || n == Qr.TrackBefore && r < e || n == Qr.TrackAfter && c > e)) return null;
				if (c > e || c == e && t < 0 && !o) return e == r || t < 0 ? i : i + s;
				i += s;
			}
			r = c;
		}
		if (e > r) throw RangeError(`Position ${e} is out of range for changeset of length ${r}`);
		return i;
	}
	touchesRange(e, t = e) {
		for (let n = 0, r = 0; n < this.sections.length && r <= t;) {
			let i = this.sections[n++], a = this.sections[n++], o = r + i;
			if (a >= 0 && r <= t && o >= e) return r < e && o > t ? "cover" : !0;
			r = o;
		}
		return !1;
	}
	toString() {
		let e = "";
		for (let t = 0; t < this.sections.length;) {
			let n = this.sections[t++], r = this.sections[t++];
			e += (e ? " " : "") + n + (r >= 0 ? ":" + r : "");
		}
		return e;
	}
	toJSON() {
		return this.sections;
	}
	static fromJSON(t) {
		if (!Array.isArray(t) || t.length % 2 || t.some((e) => typeof e != "number")) throw RangeError("Invalid JSON representation of ChangeDesc");
		return new e(t);
	}
	static create(t) {
		return new e(t);
	}
}, ei = class e extends $r {
	constructor(e, t) {
		super(e), this.inserted = t;
	}
	apply(e) {
		if (this.length != e.length) throw RangeError("Applying change set to a document with the wrong length");
		return ri(this, (t, n, r, i, a) => e = e.replace(r, r + (n - t), a), !1), e;
	}
	mapDesc(e, t = !1) {
		return ii(this, e, t, !0);
	}
	invert(t) {
		let n = this.sections.slice(), r = [];
		for (let e = 0, i = 0; e < n.length; e += 2) {
			let a = n[e], o = n[e + 1];
			if (o >= 0) {
				n[e] = o, n[e + 1] = a;
				let s = e >> 1;
				for (; r.length < s;) r.push(Pr.empty);
				r.push(a ? t.slice(i, i + a) : Pr.empty);
			}
			i += a;
		}
		return new e(n, r);
	}
	compose(e) {
		return this.empty ? e : e.empty ? this : ai(this, e, !0);
	}
	map(e, t = !1) {
		return e.empty ? this : ii(this, e, t, !0);
	}
	iterChanges(e, t = !1) {
		ri(this, e, t);
	}
	get desc() {
		return $r.create(this.sections);
	}
	filter(t) {
		let n = [], r = [], i = [], a = new oi(this);
		done: for (let e = 0, o = 0;;) {
			let s = e == t.length ? 1e9 : t[e++];
			for (; o < s || o == s && a.len == 0;) {
				if (a.done) break done;
				let e = Math.min(a.len, s - o);
				ti(i, e, -1);
				let t = a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0;
				ti(n, e, t), t > 0 && ni(r, n, a.text), a.forward(e), o += e;
			}
			let c = t[e++];
			for (; o < c;) {
				if (a.done) break done;
				let e = Math.min(a.len, c - o);
				ti(n, e, -1), ti(i, e, a.ins == -1 ? -1 : a.off == 0 ? a.ins : 0), a.forward(e), o += e;
			}
		}
		return {
			changes: new e(n, r),
			filtered: $r.create(i)
		};
	}
	toJSON() {
		let e = [];
		for (let t = 0; t < this.sections.length; t += 2) {
			let n = this.sections[t], r = this.sections[t + 1];
			r < 0 ? e.push(n) : r == 0 ? e.push([n]) : e.push([n].concat(this.inserted[t >> 1].toJSON()));
		}
		return e;
	}
	static of(t, n, r) {
		let i = [], a = [], o = 0, s = null;
		function c(t = !1) {
			if (!t && !i.length) return;
			o < n && ti(i, n - o, -1);
			let r = new e(i, a);
			s = s ? s.compose(r.map(s)) : r, i = [], a = [], o = 0;
		}
		function l(t) {
			if (Array.isArray(t)) for (let e of t) l(e);
			else if (t instanceof e) {
				if (t.length != n) throw RangeError(`Mismatched change set length (got ${t.length}, expected ${n})`);
				c(), s = s ? s.compose(t.map(s)) : t;
			} else {
				let { from: e, to: s = e, insert: l } = t;
				if (e > s || e < 0 || s > n) throw RangeError(`Invalid change range ${e} to ${s} (in doc of length ${n})`);
				let u = l ? typeof l == "string" ? Pr.of(l.split(r || Zr)) : l : Pr.empty, d = u.length;
				if (e == s && d == 0) return;
				e < o && c(), e > o && ti(i, e - o, -1), ti(i, s - e, d), ni(a, i, u), o = s;
			}
		}
		return l(t), c(!s), s;
	}
	static empty(t) {
		return new e(t ? [t, -1] : [], []);
	}
	static fromJSON(t) {
		if (!Array.isArray(t)) throw RangeError("Invalid JSON representation of ChangeSet");
		let n = [], r = [];
		for (let e = 0; e < t.length; e++) {
			let i = t[e];
			if (typeof i == "number") n.push(i, -1);
			else if (!Array.isArray(i) || typeof i[0] != "number" || i.some((e, t) => t && typeof e != "string")) throw RangeError("Invalid JSON representation of ChangeSet");
			else if (i.length == 1) n.push(i[0], 0);
			else {
				for (; r.length < e;) r.push(Pr.empty);
				r[e] = Pr.of(i.slice(1)), n.push(i[0], r[e].length);
			}
		}
		return new e(n, r);
	}
	static createSet(t, n) {
		return new e(t, n);
	}
};
function ti(e, t, n, r = !1) {
	if (t == 0 && n <= 0) return;
	let i = e.length - 2;
	i >= 0 && n <= 0 && n == e[i + 1] ? e[i] += t : i >= 0 && t == 0 && e[i] == 0 ? e[i + 1] += n : r ? (e[i] += t, e[i + 1] += n) : e.push(t, n);
}
function ni(e, t, n) {
	if (n.length == 0) return;
	let r = t.length - 2 >> 1;
	if (r < e.length) e[e.length - 1] = e[e.length - 1].append(n);
	else {
		for (; e.length < r;) e.push(Pr.empty);
		e.push(n);
	}
}
function ri(e, t, n) {
	let r = e.inserted;
	for (let i = 0, a = 0, o = 0; o < e.sections.length;) {
		let s = e.sections[o++], c = e.sections[o++];
		if (c < 0) i += s, a += s;
		else {
			let l = i, u = a, d = Pr.empty;
			for (; l += s, u += c, c && r && (d = d.append(r[o - 2 >> 1])), !(n || o == e.sections.length || e.sections[o + 1] < 0);) s = e.sections[o++], c = e.sections[o++];
			t(i, l, a, u, d), i = l, a = u;
		}
	}
}
function ii(e, t, n, r = !1) {
	let i = [], a = r ? [] : null, o = new oi(e), s = new oi(t);
	for (let e = -1;;) if (o.done && s.len || s.done && o.len) throw Error("Mismatched change set lengths");
	else if (o.ins == -1 && s.ins == -1) {
		let e = Math.min(o.len, s.len);
		ti(i, e, -1), o.forward(e), s.forward(e);
	} else if (s.ins >= 0 && (o.ins < 0 || e == o.i || o.off == 0 && (s.len < o.len || s.len == o.len && !n))) {
		let t = s.len;
		for (ti(i, s.ins, -1); t;) {
			let n = Math.min(o.len, t);
			o.ins >= 0 && e < o.i && o.len <= n && (ti(i, 0, o.ins), a && ni(a, i, o.text), e = o.i), o.forward(n), t -= n;
		}
		s.next();
	} else if (o.ins >= 0) {
		let t = 0, n = o.len;
		for (; n;) if (s.ins == -1) {
			let e = Math.min(n, s.len);
			t += e, n -= e, s.forward(e);
		} else if (s.ins == 0 && s.len < n) n -= s.len, s.next();
		else break;
		ti(i, t, e < o.i ? o.ins : 0), a && e < o.i && ni(a, i, o.text), e = o.i, o.forward(o.len - n);
	} else if (o.done && s.done) return a ? ei.createSet(i, a) : $r.create(i);
	else throw Error("Mismatched change set lengths");
}
function ai(e, t, n = !1) {
	let r = [], i = n ? [] : null, a = new oi(e), o = new oi(t);
	for (let e = !1;;) if (a.done && o.done) return i ? ei.createSet(r, i) : $r.create(r);
	else if (a.ins == 0) ti(r, a.len, 0, e), a.next();
	else if (o.len == 0 && !o.done) ti(r, 0, o.ins, e), i && ni(i, r, o.text), o.next();
	else if (a.done || o.done) throw Error("Mismatched change set lengths");
	else {
		let t = Math.min(a.len2, o.len), n = r.length;
		if (a.ins == -1) {
			let n = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
			ti(r, t, n, e), i && n && ni(i, r, o.text);
		} else o.ins == -1 ? (ti(r, a.off ? 0 : a.len, t, e), i && ni(i, r, a.textBit(t))) : (ti(r, a.off ? 0 : a.len, o.off ? 0 : o.ins, e), i && !o.off && ni(i, r, o.text));
		e = (a.ins > t || o.ins >= 0 && o.len > t) && (e || r.length > n), a.forward2(t), o.forward(t);
	}
}
var oi = class {
	constructor(e) {
		this.set = e, this.i = 0, this.next();
	}
	next() {
		let { sections: e } = this.set;
		this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
	}
	get done() {
		return this.ins == -2;
	}
	get len2() {
		return this.ins < 0 ? this.len : this.ins;
	}
	get text() {
		let { inserted: e } = this.set, t = this.i - 2 >> 1;
		return t >= e.length ? Pr.empty : e[t];
	}
	textBit(e) {
		let { inserted: t } = this.set, n = this.i - 2 >> 1;
		return n >= t.length && !e ? Pr.empty : t[n].slice(this.off, e == null ? void 0 : this.off + e);
	}
	forward(e) {
		e == this.len ? this.next() : (this.len -= e, this.off += e);
	}
	forward2(e) {
		this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
	}
}, si = class e {
	constructor(e, t, n, r) {
		this.from = e, this.to = t, this.flags = n, this.goalColumn = r;
	}
	get anchor() {
		return this.flags & 32 ? this.to : this.from;
	}
	get head() {
		return this.flags & 32 ? this.from : this.to;
	}
	get empty() {
		return this.from == this.to;
	}
	get assoc() {
		return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
	}
	get undirectional() {
		return (this.flags & 64) > 0;
	}
	get bidiLevel() {
		let e = this.flags & 7;
		return e == 7 ? null : e;
	}
	map(t, n = -1) {
		let r, i;
		return this.empty ? r = i = t.mapPos(this.from, n) : (r = t.mapPos(this.from, 1), i = t.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new e(r, i, this.flags, this.goalColumn);
	}
	extend(e, t = e, n = 0) {
		if (e <= this.anchor && t >= this.anchor) return U.range(e, t, void 0, void 0, n);
		let r = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
		return U.range(this.anchor, r, void 0, void 0, n);
	}
	eq(e, t = !1) {
		return this.anchor == e.anchor && this.head == e.head && this.goalColumn == e.goalColumn && (!t || !this.empty || this.assoc == e.assoc);
	}
	toJSON() {
		return {
			anchor: this.anchor,
			head: this.head
		};
	}
	static fromJSON(e) {
		if (!e || typeof e.anchor != "number" || typeof e.head != "number") throw RangeError("Invalid JSON representation for SelectionRange");
		return U.range(e.anchor, e.head);
	}
	static create(t, n, r, i) {
		return new e(t, n, r, i);
	}
}, U = class e {
	constructor(e, t) {
		this.ranges = e, this.mainIndex = t;
	}
	map(t, n = -1) {
		return t.empty ? this : e.create(this.ranges.map((e) => e.map(t, n)), this.mainIndex);
	}
	eq(e, t = !1) {
		if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex) return !1;
		for (let n = 0; n < this.ranges.length; n++) if (!this.ranges[n].eq(e.ranges[n], t)) return !1;
		return !0;
	}
	get main() {
		return this.ranges[this.mainIndex];
	}
	asSingle() {
		return this.ranges.length == 1 ? this : new e([this.main], 0);
	}
	addRange(t, n = !0) {
		return e.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
	}
	replaceRange(t, n = this.mainIndex) {
		let r = this.ranges.slice();
		return r[n] = t, e.create(r, this.mainIndex);
	}
	toJSON() {
		return {
			ranges: this.ranges.map((e) => e.toJSON()),
			main: this.mainIndex
		};
	}
	static fromJSON(t) {
		if (!t || !Array.isArray(t.ranges) || typeof t.main != "number" || t.main >= t.ranges.length) throw RangeError("Invalid JSON representation for EditorSelection");
		return new e(t.ranges.map((e) => si.fromJSON(e)), t.main);
	}
	static single(t, n = t) {
		return new e([e.range(t, n)], 0);
	}
	static create(t, n = 0) {
		if (t.length == 0) throw RangeError("A selection needs at least one range");
		for (let r = 0, i = 0; i < t.length; i++) {
			let a = t[i];
			if (a.empty ? a.from <= r : a.from < r) return e.normalized(t.slice(), n);
			r = a.to;
		}
		return new e(t, n);
	}
	static cursor(e, t = 0, n, r) {
		return si.create(e, e, (t == 0 ? 0 : t < 0 ? 8 : 16) | (n == null ? 7 : Math.min(6, n)), r);
	}
	static range(e, t, n, r, i) {
		let a = r == null ? 7 : Math.min(6, r);
		return !i && e != t && (i = t < e ? 1 : -1), i && (a |= i < 0 ? 8 : 16), t < e ? si.create(t, e, a | 32, n) : si.create(e, t, a, n);
	}
	static undirectionalRange(e, t) {
		return si.create(e, t, 64, void 0);
	}
	static normalized(t, n = 0) {
		let r = t[n];
		t.sort((e, t) => e.from - t.from), n = t.indexOf(r);
		for (let r = 1; r < t.length; r++) {
			let i = t[r], a = t[r - 1];
			if (i.empty ? i.from <= a.to : i.from < a.to) {
				let o = a.from, s = Math.max(i.to, a.to);
				r <= n && n--, t.splice(--r, 2, i.anchor > i.head ? e.range(s, o) : e.range(o, s));
			}
		}
		return new e(t, n);
	}
};
function ci(e, t) {
	for (let n of e.ranges) if (n.to > t) throw RangeError("Selection points outside of document");
}
var li = 0, W = class e {
	constructor(e, t, n, r, i) {
		this.combine = e, this.compareInput = t, this.compare = n, this.isStatic = r, this.id = li++, this.default = e([]), this.extensions = typeof i == "function" ? i(this) : i;
	}
	get reader() {
		return this;
	}
	static define(t = {}) {
		return new e(t.combine || ((e) => e), t.compareInput || ((e, t) => e === t), t.compare || (t.combine ? (e, t) => e === t : ui), !!t.static, t.enables);
	}
	of(e) {
		return new di([], this, 0, e);
	}
	compute(e, t) {
		if (this.isStatic) throw Error("Can't compute a static facet");
		return new di(e, this, 1, t);
	}
	computeN(e, t) {
		if (this.isStatic) throw Error("Can't compute a static facet");
		return new di(e, this, 2, t);
	}
	from(e, t) {
		return t ||= (e) => e, this.compute([e], (n) => t(n.field(e)));
	}
};
function ui(e, t) {
	return e == t || e.length == t.length && e.every((e, n) => e === t[n]);
}
var di = class {
	constructor(e, t, n, r) {
		this.dependencies = e, this.facet = t, this.type = n, this.value = r, this.id = li++;
	}
	dynamicSlot(e) {
		let t = this.value, n = this.facet.compareInput, r = this.id, i = e[r] >> 1, a = this.type == 2, o = !1, s = !1, c = [];
		for (let t of this.dependencies) t == "doc" ? o = !0 : t == "selection" ? s = !0 : (e[t.id] ?? 1) & 1 || c.push(e[t.id]);
		return {
			create(e) {
				return e.values[i] = t(e), 1;
			},
			update(e, r) {
				if (o && r.docChanged || s && (r.docChanged || r.selection) || pi(e, c)) {
					let r = t(e);
					if (a ? !fi(r, e.values[i], n) : !n(r, e.values[i])) return e.values[i] = r, 1;
				}
				return 0;
			},
			reconfigure: (e, o) => {
				let s, c = o.config.address[r];
				if (c != null) {
					let r = Ei(o, c);
					if (this.dependencies.every((t) => t instanceof W ? o.facet(t) === e.facet(t) : t instanceof gi ? o.field(t, !1) == e.field(t, !1) : !0) || (a ? fi(s = t(e), r, n) : n(s = t(e), r))) return e.values[i] = r, 0;
				} else s = t(e);
				return e.values[i] = s, 1;
			}
		};
	}
};
function fi(e, t, n) {
	if (e.length != t.length) return !1;
	for (let r = 0; r < e.length; r++) if (!n(e[r], t[r])) return !1;
	return !0;
}
function pi(e, t) {
	let n = !1;
	for (let r of t) Ti(e, r) & 1 && (n = !0);
	return n;
}
function mi(e, t, n) {
	let r = n.map((t) => e[t.id]), i = n.map((e) => e.type), a = r.filter((e) => !(e & 1)), o = e[t.id] >> 1;
	function s(e) {
		let n = [];
		for (let t = 0; t < r.length; t++) {
			let a = Ei(e, r[t]);
			if (i[t] == 2) for (let e of a) n.push(e);
			else n.push(a);
		}
		return t.combine(n);
	}
	return {
		create(e) {
			for (let t of r) Ti(e, t);
			return e.values[o] = s(e), 1;
		},
		update(e, n) {
			if (!pi(e, a)) return 0;
			let r = s(e);
			return t.compare(r, e.values[o]) ? 0 : (e.values[o] = r, 1);
		},
		reconfigure(e, i) {
			let a = pi(e, r), c = i.config.facets[t.id], l = i.facet(t);
			if (c && !a && ui(n, c)) return e.values[o] = l, 0;
			let u = s(e);
			return t.compare(u, l) ? (e.values[o] = l, 0) : (e.values[o] = u, 1);
		}
	};
}
var hi = /*@__PURE__*/ W.define({ static: !0 }), gi = class e {
	constructor(e, t, n, r, i) {
		this.id = e, this.createF = t, this.updateF = n, this.compareF = r, this.spec = i, this.provides = void 0;
	}
	static define(t) {
		let n = new e(li++, t.create, t.update, t.compare || ((e, t) => e === t), t);
		return t.provide && (n.provides = t.provide(n)), n;
	}
	create(e) {
		return (e.facet(hi).find((e) => e.field == this)?.create || this.createF)(e);
	}
	slot(e) {
		let t = e[this.id] >> 1;
		return {
			create: (e) => (e.values[t] = this.create(e), 1),
			update: (e, n) => {
				let r = e.values[t], i = this.updateF(r, n);
				return this.compareF(r, i) ? 0 : (e.values[t] = i, 1);
			},
			reconfigure: (e, n) => {
				let r = e.facet(hi), i = n.facet(hi), a;
				return (a = r.find((e) => e.field == this)) && a != i.find((e) => e.field == this) ? (e.values[t] = a.create(e), 1) : n.config.address[this.id] == null ? (e.values[t] = this.create(e), 1) : (e.values[t] = n.field(this), 0);
			}
		};
	}
	init(e) {
		return [this, hi.of({
			field: this,
			create: e
		})];
	}
	get extension() {
		return this;
	}
}, _i = {
	lowest: 4,
	low: 3,
	default: 2,
	high: 1,
	highest: 0
};
function vi(e) {
	return (t) => new bi(t, e);
}
var yi = {
	highest: /*@__PURE__*/ vi(_i.highest),
	high: /*@__PURE__*/ vi(_i.high),
	default: /*@__PURE__*/ vi(_i.default),
	low: /*@__PURE__*/ vi(_i.low),
	lowest: /*@__PURE__*/ vi(_i.lowest)
}, bi = class {
	constructor(e, t) {
		this.inner = e, this.prec = t;
	}
}, xi = class e {
	of(e) {
		return new Si(this, e);
	}
	reconfigure(t) {
		return e.reconfigure.of({
			compartment: this,
			extension: t
		});
	}
	get(e) {
		return e.config.compartments.get(this);
	}
}, Si = class {
	constructor(e, t) {
		this.compartment = e, this.inner = t;
	}
}, Ci = class e {
	constructor(e, t, n, r, i, a) {
		for (this.base = e, this.compartments = t, this.dynamicSlots = n, this.address = r, this.staticValues = i, this.facets = a, this.statusTemplate = []; this.statusTemplate.length < n.length;) this.statusTemplate.push(0);
	}
	staticFacet(e) {
		let t = this.address[e.id];
		return t == null ? e.default : this.staticValues[t >> 1];
	}
	static resolve(t, n, r) {
		let i = [], a = Object.create(null), o = /* @__PURE__ */ new Map();
		for (let e of wi(t, n, o)) e instanceof gi ? i.push(e) : (a[e.facet.id] || (a[e.facet.id] = [])).push(e);
		let s = Object.create(null), c = [], l = [];
		for (let e of i) s[e.id] = l.length << 1, l.push((t) => e.slot(t));
		let u = r?.config.facets;
		for (let e in a) {
			let t = a[e], n = t[0].facet, i = u && u[e] || [];
			if (t.every((e) => e.type == 0)) if (s[n.id] = c.length << 1 | 1, ui(i, t)) c.push(r.facet(n));
			else {
				let e = n.combine(t.map((e) => e.value));
				c.push(r && n.compare(e, r.facet(n)) ? r.facet(n) : e);
			}
			else {
				for (let e of t) e.type == 0 ? (s[e.id] = c.length << 1 | 1, c.push(e.value)) : (s[e.id] = l.length << 1, l.push((t) => e.dynamicSlot(t)));
				s[n.id] = l.length << 1, l.push((e) => mi(e, n, t));
			}
		}
		return new e(t, o, l.map((e) => e(s)), s, c, a);
	}
};
function wi(e, t, n) {
	let r = [
		[],
		[],
		[],
		[],
		[]
	], i = /* @__PURE__ */ new Map();
	function a(e, o) {
		let s = i.get(e);
		if (s != null) {
			if (s <= o) return;
			let t = r[s].indexOf(e);
			t > -1 && r[s].splice(t, 1), e instanceof Si && n.delete(e.compartment);
		}
		if (i.set(e, o), Array.isArray(e)) for (let t of e) a(t, o);
		else if (e instanceof Si) {
			if (n.has(e.compartment)) throw RangeError("Duplicate use of compartment in extensions");
			let r = t.get(e.compartment) || e.inner;
			n.set(e.compartment, r), a(r, o);
		} else if (e instanceof bi) a(e.inner, e.prec);
		else if (e instanceof gi) r[o].push(e), e.provides && a(e.provides, o);
		else if (e instanceof di) r[o].push(e), e.facet.extensions && a(e.facet.extensions, _i.default);
		else {
			let t = e.extension;
			if (!t) throw Error(`Unrecognized extension value in extension set (${e}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
			a(t, o);
		}
	}
	return a(e, _i.default), r.reduce((e, t) => e.concat(t));
}
function Ti(e, t) {
	if (t & 1) return 2;
	let n = t >> 1, r = e.status[n];
	if (r == 4) throw Error("Cyclic dependency between fields and/or facets");
	if (r & 2) return r;
	e.status[n] = 4;
	let i = e.computeSlot(e, e.config.dynamicSlots[n]);
	return e.status[n] = 2 | i;
}
function Ei(e, t) {
	return t & 1 ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
var Di = /*@__PURE__*/ W.define(), Oi = /*@__PURE__*/ W.define({
	combine: (e) => e.some((e) => e),
	static: !0
}), ki = /*@__PURE__*/ W.define({
	combine: (e) => e.length ? e[0] : void 0,
	static: !0
}), Ai = /*@__PURE__*/ W.define(), ji = /*@__PURE__*/ W.define(), Mi = /*@__PURE__*/ W.define(), Ni = /*@__PURE__*/ W.define({ combine: (e) => e.length ? e[0] : !1 }), Pi = class {
	constructor(e, t) {
		this.type = e, this.value = t;
	}
	static define() {
		return new Fi();
	}
}, Fi = class {
	of(e) {
		return new Pi(this, e);
	}
}, Ii = class {
	constructor(e) {
		this.map = e;
	}
	of(e) {
		return new Li(this, e);
	}
}, Li = class e {
	constructor(e, t) {
		this.type = e, this.value = t;
	}
	map(t) {
		let n = this.type.map(this.value, t);
		return n === void 0 ? void 0 : n == this.value ? this : new e(this.type, n);
	}
	is(e) {
		return this.type == e;
	}
	static define(e = {}) {
		return new Ii(e.map || ((e) => e));
	}
	static mapEffects(e, t) {
		if (!e.length) return e;
		let n = [];
		for (let r of e) {
			let e = r.map(t);
			e && n.push(e);
		}
		return n;
	}
};
Li.reconfigure = /*@__PURE__*/ Li.define(), Li.appendConfig = /*@__PURE__*/ Li.define();
var Ri = class e {
	constructor(t, n, r, i, a, o) {
		this.startState = t, this.changes = n, this.selection = r, this.effects = i, this.annotations = a, this.scrollIntoView = o, this._doc = null, this._state = null, r && ci(r, n.newLength), a.some((t) => t.type == e.time) || (this.annotations = a.concat(e.time.of(Date.now())));
	}
	static create(t, n, r, i, a, o) {
		return new e(t, n, r, i, a, o);
	}
	get newDoc() {
		return this._doc ||= this.changes.apply(this.startState.doc);
	}
	get newSelection() {
		return this.selection || this.startState.selection.map(this.changes);
	}
	get state() {
		return this._state || this.startState.applyTransaction(this), this._state;
	}
	annotation(e) {
		for (let t of this.annotations) if (t.type == e) return t.value;
	}
	get docChanged() {
		return !this.changes.empty;
	}
	get reconfigured() {
		return this.startState.config != this.state.config;
	}
	isUserEvent(t) {
		let n = this.annotation(e.userEvent);
		return !!(n && (n == t || n.length > t.length && n.slice(0, t.length) == t && n[t.length] == "."));
	}
};
Ri.time = /*@__PURE__*/ Pi.define(), Ri.userEvent = /*@__PURE__*/ Pi.define(), Ri.addToHistory = /*@__PURE__*/ Pi.define(), Ri.remote = /*@__PURE__*/ Pi.define();
function zi(e, t) {
	let n = [];
	for (let r = 0, i = 0;;) {
		let a, o;
		if (r < e.length && (i == t.length || t[i] >= e[r])) a = e[r++], o = e[r++];
		else if (i < t.length) a = t[i++], o = t[i++];
		else return n;
		!n.length || n[n.length - 1] < a ? n.push(a, o) : n[n.length - 1] < o && (n[n.length - 1] = o);
	}
}
function Bi(e, t, n) {
	let r, i, a;
	return n ? (r = t.changes, i = ei.empty(t.changes.length), a = e.changes.compose(t.changes)) : (r = t.changes.map(e.changes), i = e.changes.mapDesc(t.changes, !0), a = e.changes.compose(r)), {
		changes: a,
		selection: t.selection ? t.selection.map(i) : e.selection?.map(r),
		effects: Li.mapEffects(e.effects, r).concat(Li.mapEffects(t.effects, i)),
		annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
		scrollIntoView: e.scrollIntoView || t.scrollIntoView
	};
}
function Vi(e, t, n) {
	let r = t.selection, i = Ki(t.annotations);
	return t.userEvent && (i = i.concat(Ri.userEvent.of(t.userEvent))), {
		changes: t.changes instanceof ei ? t.changes : ei.of(t.changes || [], n, e.facet(ki)),
		selection: r && (r instanceof U ? r : U.single(r.anchor, r.head)),
		effects: Ki(t.effects),
		annotations: i,
		scrollIntoView: !!t.scrollIntoView
	};
}
function Hi(e, t, n) {
	let r = Vi(e, t.length ? t[0] : {}, e.doc.length);
	t.length && t[0].filter === !1 && (n = !1);
	for (let i = 1; i < t.length; i++) {
		t[i].filter === !1 && (n = !1);
		let a = !!t[i].sequential;
		r = Bi(r, Vi(e, t[i], a ? r.changes.newLength : e.doc.length), a);
	}
	let i = Ri.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
	return Wi(n ? Ui(i) : i);
}
function Ui(e) {
	let t = e.startState, n = !0;
	for (let r of t.facet(Ai)) {
		let t = r(e);
		if (t === !1) {
			n = !1;
			break;
		}
		Array.isArray(t) && (n = n === !0 ? t : zi(n, t));
	}
	if (n !== !0) {
		let r, i;
		if (n === !1) i = e.changes.invertedDesc, r = ei.empty(t.doc.length);
		else {
			let t = e.changes.filter(n);
			r = t.changes, i = t.filtered.mapDesc(t.changes).invertedDesc;
		}
		e = Ri.create(t, r, e.selection && e.selection.map(i), Li.mapEffects(e.effects, i), e.annotations, e.scrollIntoView);
	}
	let r = t.facet(ji);
	for (let n = r.length - 1; n >= 0; n--) {
		let i = r[n](e);
		e = i instanceof Ri ? i : Array.isArray(i) && i.length == 1 && i[0] instanceof Ri ? i[0] : Hi(t, Ki(i), !1);
	}
	return e;
}
function Wi(e) {
	let t = e.startState, n = t.facet(Mi), r = e;
	for (let i = n.length - 1; i >= 0; i--) {
		let a = n[i](e);
		a && Object.keys(a).length && (r = Bi(r, Vi(t, a, e.changes.newLength), !0));
	}
	return r == e ? e : Ri.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
}
var Gi = [];
function Ki(e) {
	return e == null ? Gi : Array.isArray(e) ? e : [e];
}
var qi = /*@__PURE__*/ (function(e) {
	return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
})(qi ||= {}), Ji = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/, Yi;
try {
	Yi = /*@__PURE__*/ RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {}
function Xi(e) {
	if (Yi) return Yi.test(e);
	for (let t = 0; t < e.length; t++) {
		let n = e[t];
		if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || Ji.test(n))) return !0;
	}
	return !1;
}
function Zi(e) {
	return (t) => {
		if (!/\S/.test(t)) return qi.Space;
		if (Xi(t)) return qi.Word;
		for (let n = 0; n < e.length; n++) if (t.indexOf(e[n]) > -1) return qi.Word;
		return qi.Other;
	};
}
var Qi = class e {
	constructor(e, t, n, r, i, a) {
		this.config = e, this.doc = t, this.selection = n, this.values = r, this.status = e.statusTemplate.slice(), this.computeSlot = i, a && (a._state = this);
		for (let e = 0; e < this.config.dynamicSlots.length; e++) Ti(this, e << 1);
		this.computeSlot = null;
	}
	field(e, t = !0) {
		let n = this.config.address[e.id];
		if (n == null) {
			if (t) throw RangeError("Field is not present in this state");
			return;
		}
		return Ti(this, n), Ei(this, n);
	}
	update(...e) {
		return Hi(this, e, !0);
	}
	applyTransaction(t) {
		let n = this.config, { base: r, compartments: i } = n;
		for (let e of t.effects) e.is(xi.reconfigure) ? (n &&= (i = /* @__PURE__ */ new Map(), n.compartments.forEach((e, t) => i.set(t, e)), null), i.set(e.value.compartment, e.value.extension)) : e.is(Li.reconfigure) ? (n = null, r = e.value) : e.is(Li.appendConfig) && (n = null, r = Ki(r).concat(e.value));
		let a;
		n ? a = t.startState.values.slice() : (n = Ci.resolve(r, i, this), a = new e(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (e, t) => t.reconfigure(e, this), null).values);
		let o = t.startState.facet(Oi) ? t.newSelection : t.newSelection.asSingle();
		new e(n, t.newDoc, o, a, (e, n) => n.update(e, t), t);
	}
	replaceSelection(e) {
		return typeof e == "string" && (e = this.toText(e)), this.changeByRange((t) => ({
			changes: {
				from: t.from,
				to: t.to,
				insert: e
			},
			range: U.cursor(t.from + e.length)
		}));
	}
	changeByRange(e) {
		let t = this.selection, n = e(t.ranges[0]), r = this.changes(n.changes), i = [n.range], a = Ki(n.effects);
		for (let n = 1; n < t.ranges.length; n++) {
			let o = e(t.ranges[n]), s = this.changes(o.changes), c = s.map(r);
			for (let e = 0; e < n; e++) i[e] = i[e].map(c);
			let l = r.mapDesc(s, !0);
			i.push(o.range.map(l)), r = r.compose(c), a = Li.mapEffects(a, c).concat(Li.mapEffects(Ki(o.effects), l));
		}
		return {
			changes: r,
			selection: U.create(i, t.mainIndex),
			effects: a
		};
	}
	changes(t = []) {
		return t instanceof ei ? t : ei.of(t, this.doc.length, this.facet(e.lineSeparator));
	}
	toText(t) {
		return Pr.of(t.split(this.facet(e.lineSeparator) || Zr));
	}
	sliceDoc(e = 0, t = this.doc.length) {
		return this.doc.sliceString(e, t, this.lineBreak);
	}
	facet(e) {
		let t = this.config.address[e.id];
		return t == null ? e.default : (Ti(this, t), Ei(this, t));
	}
	toJSON(e) {
		let t = {
			doc: this.sliceDoc(),
			selection: this.selection.toJSON()
		};
		if (e) for (let n in e) {
			let r = e[n];
			r instanceof gi && this.config.address[r.id] != null && (t[n] = r.spec.toJSON(this.field(e[n]), this));
		}
		return t;
	}
	static fromJSON(t, n = {}, r) {
		if (!t || typeof t.doc != "string") throw RangeError("Invalid JSON representation for EditorState");
		let i = [];
		if (r) {
			for (let e in r) if (Object.prototype.hasOwnProperty.call(t, e)) {
				let n = r[e], a = t[e];
				i.push(n.init((e) => n.spec.fromJSON(a, e)));
			}
		}
		return e.create({
			doc: t.doc,
			selection: U.fromJSON(t.selection),
			extensions: n.extensions ? i.concat([n.extensions]) : i
		});
	}
	static create(t = {}) {
		let n = Ci.resolve(t.extensions || [], /* @__PURE__ */ new Map()), r = t.doc instanceof Pr ? t.doc : Pr.of((t.doc || "").split(n.staticFacet(e.lineSeparator) || Zr)), i = t.selection ? t.selection instanceof U ? t.selection : U.single(t.selection.anchor, t.selection.head) : U.single(0);
		return ci(i, r.length), n.staticFacet(Oi) || (i = i.asSingle()), new e(n, r, i, n.dynamicSlots.map(() => null), (e, t) => t.create(e), null);
	}
	get tabSize() {
		return this.facet(e.tabSize);
	}
	get lineBreak() {
		return this.facet(e.lineSeparator) || "\n";
	}
	get readOnly() {
		return this.facet(Ni);
	}
	phrase(t, ...n) {
		for (let n of this.facet(e.phrases)) if (Object.prototype.hasOwnProperty.call(n, t)) {
			t = n[t];
			break;
		}
		return n.length && (t = t.replace(/\$(\$|\d*)/g, (e, t) => {
			if (t == "$") return "$";
			let r = +(t || 1);
			return !r || r > n.length ? e : n[r - 1];
		})), t;
	}
	languageDataAt(e, t, n = -1) {
		let r = [];
		for (let i of this.facet(Di)) for (let a of i(this, t, n)) Object.prototype.hasOwnProperty.call(a, e) && r.push(a[e]);
		return r;
	}
	charCategorizer(e) {
		let t = this.languageDataAt("wordChars", e);
		return Zi(t.length ? t[0] : "");
	}
	wordAt(e) {
		let { text: t, from: n, length: r } = this.doc.lineAt(e), i = this.charCategorizer(e), a = e - n, o = e - n;
		for (; a > 0;) {
			let e = Gr(t, a, !1);
			if (i(t.slice(e, a)) != qi.Word) break;
			a = e;
		}
		for (; o < r;) {
			let e = Gr(t, o);
			if (i(t.slice(o, e)) != qi.Word) break;
			o = e;
		}
		return a == o ? null : U.range(a + n, o + n);
	}
};
Qi.allowMultipleSelections = Oi, Qi.tabSize = /*@__PURE__*/ W.define({ combine: (e) => e.length ? e[0] : 4 }), Qi.lineSeparator = ki, Qi.readOnly = Ni, Qi.phrases = /*@__PURE__*/ W.define({ compare(e, t) {
	let n = Object.keys(e), r = Object.keys(t);
	return n.length == r.length && n.every((n) => e[n] == t[n]);
} }), Qi.languageData = Di, Qi.changeFilter = Ai, Qi.transactionFilter = ji, Qi.transactionExtender = Mi, xi.reconfigure = /*@__PURE__*/ Li.define();
function $i(e, t, n = {}) {
	let r = {};
	for (let t of e) for (let e of Object.keys(t)) {
		let i = t[e], a = r[e];
		if (a === void 0) r[e] = i;
		else if (!(a === i || i === void 0)) if (Object.hasOwnProperty.call(n, e)) r[e] = n[e](a, i);
		else throw Error("Config merge conflict for field " + e);
	}
	for (let e in t) r[e] === void 0 && (r[e] = t[e]);
	return r;
}
var ea = class {
	eq(e) {
		return this == e;
	}
	range(e, t = e) {
		return na.create(e, t, this);
	}
};
ea.prototype.startSide = ea.prototype.endSide = 0, ea.prototype.point = !1, ea.prototype.mapMode = Qr.TrackDel;
function ta(e, t) {
	return e == t || e.constructor == t.constructor && e.eq(t);
}
var na = class e {
	constructor(e, t, n) {
		this.from = e, this.to = t, this.value = n;
	}
	static create(t, n, r) {
		return new e(t, n, r);
	}
};
function ra(e, t) {
	return e.from - t.from || e.value.startSide - t.value.startSide;
}
var ia = class e {
	constructor(e, t, n, r) {
		this.from = e, this.to = t, this.value = n, this.maxPoint = r;
	}
	get length() {
		return this.to[this.to.length - 1];
	}
	findIndex(e, t, n, r = 0) {
		let i = n ? this.to : this.from;
		for (let a = r, o = i.length;;) {
			if (a == o) return a;
			let r = a + o >> 1, s = i[r] - e || (n ? this.value[r].endSide : this.value[r].startSide) - t;
			if (r == a) return s >= 0 ? a : o;
			s >= 0 ? o = r : a = r + 1;
		}
	}
	between(e, t, n, r) {
		for (let i = this.findIndex(t, -1e9, !0), a = this.findIndex(n, 1e9, !1, i); i < a; i++) if (r(this.from[i] + e, this.to[i] + e, this.value[i]) === !1) return !1;
	}
	map(t, n) {
		let r = [], i = [], a = [], o = -1, s = -1;
		for (let e = 0; e < this.value.length; e++) {
			let c = this.value[e], l = this.from[e] + t, u = this.to[e] + t, d, f;
			if (l == u) {
				let e = n.mapPos(l, c.startSide, c.mapMode);
				if (e == null || (d = f = e, c.startSide != c.endSide && (f = n.mapPos(l, c.endSide), f < d))) continue;
			} else if (d = n.mapPos(l, c.startSide), f = n.mapPos(u, c.endSide), d > f || d == f && c.startSide > 0 && c.endSide <= 0) continue;
			(f - d || c.endSide - c.startSide) < 0 || (o < 0 && (o = d), c.point && (s = Math.max(s, f - d)), r.push(c), i.push(d - o), a.push(f - o));
		}
		return {
			mapped: r.length ? new e(i, a, r, s) : null,
			pos: o
		};
	}
}, aa = class e {
	constructor(e, t, n, r) {
		this.chunkPos = e, this.chunk = t, this.nextLayer = n, this.maxPoint = r;
	}
	static create(t, n, r, i) {
		return new e(t, n, r, i);
	}
	get length() {
		let e = this.chunk.length - 1;
		return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
	}
	get size() {
		if (this.isEmpty) return 0;
		let e = this.nextLayer.size;
		for (let t of this.chunk) e += t.value.length;
		return e;
	}
	chunkEnd(e) {
		return this.chunkPos[e] + this.chunk[e].length;
	}
	update(t) {
		let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: a = this.length } = t, o = t.filter;
		if (n.length == 0 && !o) return this;
		if (r && (n = n.slice().sort(ra)), this.isEmpty) return n.length ? e.of(n) : this;
		let s = new la(this, null, -1).goto(0), c = 0, l = [], u = new sa();
		for (; s.value || c < n.length;) if (c < n.length && (s.from - n[c].from || s.startSide - n[c].value.startSide) >= 0) {
			let e = n[c++];
			u.addInner(e.from, e.to, e.value) || l.push(e);
		} else s.rangeIndex == 1 && s.chunkIndex < this.chunk.length && (c == n.length || this.chunkEnd(s.chunkIndex) < n[c].from) && (!o || i > this.chunkEnd(s.chunkIndex) || a < this.chunkPos[s.chunkIndex]) && u.addChunk(this.chunkPos[s.chunkIndex], this.chunk[s.chunkIndex]) ? s.nextChunk() : ((!o || i > s.to || a < s.from || o(s.from, s.to, s.value)) && (u.addInner(s.from, s.to, s.value) || l.push(na.create(s.from, s.to, s.value))), s.next());
		return u.finishInner(this.nextLayer.isEmpty && !l.length ? e.empty : this.nextLayer.update({
			add: l,
			filter: o,
			filterFrom: i,
			filterTo: a
		}));
	}
	map(t) {
		if (t.empty || this.isEmpty) return this;
		let n = [], r = [], i = -1;
		for (let e = 0; e < this.chunk.length; e++) {
			let a = this.chunkPos[e], o = this.chunk[e], s = t.touchesRange(a, a + o.length);
			if (s === !1) i = Math.max(i, o.maxPoint), n.push(o), r.push(t.mapPos(a));
			else if (s === !0) {
				let { mapped: e, pos: s } = o.map(a, t);
				e && (i = Math.max(i, e.maxPoint), n.push(e), r.push(s));
			}
		}
		let a = this.nextLayer.map(t);
		return n.length == 0 ? a : new e(r, n, a || e.empty, i);
	}
	between(e, t, n) {
		if (!this.isEmpty) {
			for (let r = 0; r < this.chunk.length; r++) {
				let i = this.chunkPos[r], a = this.chunk[r];
				if (t >= i && e <= i + a.length && a.between(i, e - i, t - i, n) === !1) return;
			}
			this.nextLayer.between(e, t, n);
		}
	}
	iter(e = 0) {
		return ua.from([this]).goto(e);
	}
	get isEmpty() {
		return this.nextLayer == this;
	}
	static iter(e, t = 0) {
		return ua.from(e).goto(t);
	}
	static compare(e, t, n, r, i = -1) {
		let a = e.filter((e) => e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= i), o = t.filter((e) => e.maxPoint > 0 || !e.isEmpty && e.maxPoint >= i), s = ca(a, o, n), c = new fa(a, s, i), l = new fa(o, s, i);
		n.iterGaps((e, t, n) => pa(c, e, l, t, n, r)), n.empty && n.length == 0 && pa(c, 0, l, 0, 0, r);
	}
	static eq(e, t, n = 0, r) {
		r ??= 999999999;
		let i = e.filter((e) => !e.isEmpty && t.indexOf(e) < 0), a = t.filter((t) => !t.isEmpty && e.indexOf(t) < 0);
		if (i.length != a.length) return !1;
		if (!i.length) return !0;
		let o = ca(i, a), s = new fa(i, o, 0).goto(n), c = new fa(a, o, 0).goto(n);
		for (;;) {
			if (s.to != c.to || !ma(s.active, c.active) || s.point && (!c.point || !ta(s.point, c.point))) return !1;
			if (s.to > r) return !0;
			s.next(), c.next();
		}
	}
	static spans(e, t, n, r, i = -1) {
		let a = new fa(e, null, i).goto(t), o = t, s = a.openStart;
		for (;;) {
			let e = Math.min(a.to, n);
			if (a.point) {
				let n = a.activeForPoint(a.to), i = a.pointFrom < t ? n.length + 1 : a.point.startSide < 0 ? n.length : Math.min(n.length, s);
				r.point(o, e, a.point, n, i, a.pointRank), s = Math.min(a.openEnd(e), n.length);
			} else e > o && (r.span(o, e, a.active, s), s = a.openEnd(e));
			if (a.to > n) return s + (a.point && a.to > n ? 1 : 0);
			o = a.to, a.next();
		}
	}
	static of(e, t = !1) {
		let n = new sa();
		for (let r of e instanceof na ? [e] : t ? oa(e) : e) n.add(r.from, r.to, r.value);
		return n.finish();
	}
	static join(t) {
		if (!t.length) return e.empty;
		let n = t[t.length - 1];
		for (let r = t.length - 2; r >= 0; r--) for (let i = t[r]; i != e.empty; i = i.nextLayer) n = new e(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
		return n;
	}
};
aa.empty = /*@__PURE__*/ new aa([], [], null, -1);
function oa(e) {
	if (e.length > 1) for (let t = e[0], n = 1; n < e.length; n++) {
		let r = e[n];
		if (ra(t, r) > 0) return e.slice().sort(ra);
		t = r;
	}
	return e;
}
aa.empty.nextLayer = aa.empty;
var sa = class e {
	finishChunk(e) {
		this.chunks.push(new ia(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
	}
	constructor() {
		this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
	}
	add(t, n, r) {
		this.addInner(t, n, r) || (this.nextLayer ||= new e()).add(t, n, r);
	}
	addInner(e, t, n) {
		let r = e - this.lastTo || n.startSide - this.last.endSide;
		if (r <= 0 && (e - this.lastFrom || n.startSide - this.last.startSide) < 0) throw Error("Ranges must be added sorted by `from` position and `startSide`");
		return r < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(t - this.chunkStart), this.last = n, this.lastFrom = e, this.lastTo = t, this.value.push(n), n.point && (this.maxPoint = Math.max(this.maxPoint, t - e)), !0);
	}
	addChunk(e, t) {
		if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0) return !1;
		this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint), this.chunks.push(t), this.chunkPos.push(e);
		let n = t.value.length - 1;
		return this.last = t.value[n], this.lastFrom = t.from[n] + e, this.lastTo = t.to[n] + e, !0;
	}
	finish() {
		return this.finishInner(aa.empty);
	}
	finishInner(e) {
		if (this.from.length && this.finishChunk(!1), this.chunks.length == 0) return e;
		let t = aa.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
		return this.from = null, t;
	}
};
function ca(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let t of e) for (let e = 0; e < t.chunk.length; e++) t.chunk[e].maxPoint <= 0 && r.set(t.chunk[e], t.chunkPos[e]);
	let i = /* @__PURE__ */ new Set();
	for (let e of t) for (let t = 0; t < e.chunk.length; t++) {
		let a = r.get(e.chunk[t]);
		a != null && (n ? n.mapPos(a) : a) == e.chunkPos[t] && !n?.touchesRange(a, a + e.chunk[t].length) && i.add(e.chunk[t]);
	}
	return i;
}
var la = class {
	constructor(e, t, n, r = 0) {
		this.layer = e, this.skip = t, this.minPoint = n, this.rank = r;
	}
	get startSide() {
		return this.value ? this.value.startSide : 0;
	}
	get endSide() {
		return this.value ? this.value.endSide : 0;
	}
	goto(e, t = -1e9) {
		return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, t, !1), this;
	}
	gotoInner(e, t, n) {
		for (; this.chunkIndex < this.layer.chunk.length;) {
			let t = this.layer.chunk[this.chunkIndex];
			if (!(this.skip && this.skip.has(t) || this.layer.chunkEnd(this.chunkIndex) < e || t.maxPoint < this.minPoint)) break;
			this.chunkIndex++, n = !1;
		}
		if (this.chunkIndex < this.layer.chunk.length) {
			let r = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], t, !0);
			(!n || this.rangeIndex < r) && this.setRangeIndex(r);
		}
		this.next();
	}
	forward(e, t) {
		(this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
	}
	next() {
		for (;;) if (this.chunkIndex == this.layer.chunk.length) {
			this.from = this.to = 1e9, this.value = null;
			break;
		} else {
			let e = this.layer.chunkPos[this.chunkIndex], t = this.layer.chunk[this.chunkIndex], n = e + t.from[this.rangeIndex];
			if (this.from = n, this.to = e + t.to[this.rangeIndex], this.value = t.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
		}
	}
	setRangeIndex(e) {
		if (e == this.layer.chunk[this.chunkIndex].value.length) {
			if (this.chunkIndex++, this.skip) for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]);) this.chunkIndex++;
			this.rangeIndex = 0;
		} else this.rangeIndex = e;
	}
	nextChunk() {
		this.chunkIndex++, this.rangeIndex = 0, this.next();
	}
	compare(e) {
		return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
	}
}, ua = class e {
	constructor(e) {
		this.heap = e;
	}
	static from(t, n = null, r = -1) {
		let i = [];
		for (let e = 0; e < t.length; e++) for (let a = t[e]; !a.isEmpty; a = a.nextLayer) a.maxPoint >= r && i.push(new la(a, n, r, e));
		return i.length == 1 ? i[0] : new e(i);
	}
	get startSide() {
		return this.value ? this.value.startSide : 0;
	}
	goto(e, t = -1e9) {
		for (let n of this.heap) n.goto(e, t);
		for (let e = this.heap.length >> 1; e >= 0; e--) da(this.heap, e);
		return this.next(), this;
	}
	forward(e, t) {
		for (let n of this.heap) n.forward(e, t);
		for (let e = this.heap.length >> 1; e >= 0; e--) da(this.heap, e);
		(this.to - e || this.value.endSide - t) < 0 && this.next();
	}
	next() {
		if (this.heap.length == 0) this.from = this.to = 1e9, this.value = null, this.rank = -1;
		else {
			let e = this.heap[0];
			this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), da(this.heap, 0);
		}
	}
};
function da(e, t) {
	for (let n = e[t];;) {
		let r = (t << 1) + 1;
		if (r >= e.length) break;
		let i = e[r];
		if (r + 1 < e.length && i.compare(e[r + 1]) >= 0 && (i = e[r + 1], r++), n.compare(i) < 0) break;
		e[r] = n, e[t] = i, t = r;
	}
}
var fa = class {
	constructor(e, t, n) {
		this.minPoint = n, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = ua.from(e, t, n);
	}
	goto(e, t = -1e9) {
		return this.cursor.goto(e, t), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = t, this.openStart = -1, this.next(), this;
	}
	forward(e, t) {
		for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0;) this.removeActive(this.minActive);
		this.cursor.forward(e, t);
	}
	removeActive(e) {
		ha(this.active, e), ha(this.activeTo, e), ha(this.activeRank, e), this.minActive = _a(this.active, this.activeTo);
	}
	addActive(e) {
		let t = 0, { value: n, to: r, rank: i } = this.cursor;
		for (; t < this.activeRank.length && (i - this.activeRank[t] || r - this.activeTo[t]) > 0;) t++;
		ga(this.active, t, n), ga(this.activeTo, t, r), ga(this.activeRank, t, i), e && ga(e, t, this.cursor.from), this.minActive = _a(this.active, this.activeTo);
	}
	next() {
		let e = this.to, t = this.point;
		this.point = null;
		let n = this.openStart < 0 ? [] : null;
		for (;;) {
			let r = this.minActive;
			if (r > -1 && (this.activeTo[r] - this.cursor.from || this.active[r].endSide - this.cursor.startSide) < 0) {
				if (this.activeTo[r] > e) {
					this.to = this.activeTo[r], this.endSide = this.active[r].endSide;
					break;
				}
				this.removeActive(r), n && ha(n, r);
			} else if (!this.cursor.value) {
				this.to = this.endSide = 1e9;
				break;
			} else if (this.cursor.from > e) {
				this.to = this.cursor.from, this.endSide = this.cursor.startSide;
				break;
			} else {
				let e = this.cursor.value;
				if (!e.point) this.addActive(n), this.cursor.next();
				else if (t && this.cursor.to == this.to && this.cursor.from < this.cursor.to) this.cursor.next();
				else {
					this.point = e, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = e.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
					break;
				}
			}
		}
		if (n) {
			this.openStart = 0;
			for (let t = n.length - 1; t >= 0 && n[t] < e; t--) this.openStart++;
		}
	}
	activeForPoint(e) {
		if (!this.active.length) return this.active;
		let t = [];
		for (let n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--) (this.activeTo[n] > e || this.activeTo[n] == e && this.active[n].endSide >= this.point.endSide) && t.push(this.active[n]);
		return t.reverse();
	}
	openEnd(e) {
		let t = 0;
		for (let n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > e; n--) t++;
		return t;
	}
};
function pa(e, t, n, r, i, a) {
	e.goto(t), n.goto(r);
	let o = r + i, s = r, c = r - t, l = !!a.boundChange;
	for (let t = !1;;) {
		let r = e.to + c - n.to, i = r || e.endSide - n.endSide, u = i < 0 ? e.to + c : n.to, d = Math.min(u, o);
		if (e.point || n.point ? (e.point && n.point && ta(e.point, n.point) && ma(e.activeForPoint(e.to), n.activeForPoint(n.to)) || a.comparePoint(s, d, e.point, n.point), t = !1) : (t && a.boundChange(s), d > s && !ma(e.active, n.active) && a.compareRange(s, d, e.active, n.active), l && d < o && (r || e.openEnd(u) != n.openEnd(u)) && (t = !0)), u > o) break;
		s = u, i <= 0 && e.next(), i >= 0 && n.next();
	}
}
function ma(e, t) {
	if (e.length != t.length) return !1;
	for (let n = 0; n < e.length; n++) if (e[n] != t[n] && !ta(e[n], t[n])) return !1;
	return !0;
}
function ha(e, t) {
	for (let n = t, r = e.length - 1; n < r; n++) e[n] = e[n + 1];
	e.pop();
}
function ga(e, t, n) {
	for (let n = e.length - 1; n >= t; n--) e[n + 1] = e[n];
	e[t] = n;
}
function _a(e, t) {
	let n = -1, r = 1e9;
	for (let i = 0; i < t.length; i++) (t[i] - r || e[i].endSide - e[n].endSide) < 0 && (n = i, r = t[i]);
	return n;
}
function va(e, t, n = e.length) {
	let r = 0;
	for (let i = 0; i < n && i < e.length;) e.charCodeAt(i) == 9 ? (r += t - r % t, i++) : (r++, i = Gr(e, i));
	return r;
}
function ya(e, t, n, r) {
	for (let r = 0, i = 0;;) {
		if (i >= t) return r;
		if (r == e.length) break;
		i += e.charCodeAt(r) == 9 ? n - i % n : 1, r = Gr(e, r);
	}
	return r === !0 ? -1 : e.length;
}
for (var ba = "ͼ", xa = typeof Symbol > "u" ? "__ͼ" : Symbol.for(ba), Sa = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), Ca = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {}, wa = class {
	constructor(e, t) {
		this.rules = [];
		let { finish: n } = t || {};
		function r(e) {
			return /^@/.test(e) ? [e] : e.split(/,\s*/);
		}
		function i(e, t, a, o) {
			let s = [], c = /^@(\w+)\b/.exec(e[0]), l = c && c[1] == "keyframes";
			if (c && t == null) return a.push(e[0] + ";");
			for (let n in t) {
				let o = t[n];
				if (/&/.test(n)) i(n.split(/,\s*/).map((t) => e.map((e) => t.replace(/&/, e))).reduce((e, t) => e.concat(t)), o, a);
				else if (o && typeof o == "object") {
					if (!c) throw RangeError("The value of a property (" + n + ") should be a primitive value.");
					i(r(n), o, s, l);
				} else o != null && s.push(n.replace(/_.*/, "").replace(/[A-Z]/g, (e) => "-" + e.toLowerCase()) + ": " + o + ";");
			}
			(s.length || l) && a.push((n && !c && !o ? e.map(n) : e).join(", ") + " {" + s.join(" ") + "}");
		}
		for (let t in e) i(r(t), e[t], this.rules);
	}
	getRules() {
		return this.rules.join("\n");
	}
	static newName() {
		let e = Ca[xa] || 1;
		return Ca[xa] = e + 1, ba + e.toString(36);
	}
	static mount(e, t, n) {
		let r = e[Sa], i = n && n.nonce;
		r ? i && r.setNonce(i) : r = new Ea(e, i), r.mount(Array.isArray(t) ? t : [t], e);
	}
}, Ta = /* @__PURE__ */ new Map(), Ea = class {
	constructor(e, t) {
		let n = e.ownerDocument || e, r = n.defaultView;
		if (!e.head && e.adoptedStyleSheets && r.CSSStyleSheet) {
			let t = Ta.get(n);
			if (t) return e[Sa] = t;
			this.sheet = new r.CSSStyleSheet(), Ta.set(n, this);
		} else this.styleTag = n.createElement("style"), t && this.styleTag.setAttribute("nonce", t);
		this.modules = [], e[Sa] = this;
	}
	mount(e, t) {
		let n = this.sheet, r = 0, i = 0;
		for (let t = 0; t < e.length; t++) {
			let a = e[t], o = this.modules.indexOf(a);
			if (o < i && o > -1 && (this.modules.splice(o, 1), i--, o = -1), o == -1) {
				if (this.modules.splice(i++, 0, a), n) for (let e = 0; e < a.rules.length; e++) n.insertRule(a.rules[e], r++);
			} else {
				for (; i < o;) r += this.modules[i++].rules.length;
				r += a.rules.length, i++;
			}
		}
		if (n) t.adoptedStyleSheets.indexOf(this.sheet) < 0 && (t.adoptedStyleSheets = [this.sheet, ...t.adoptedStyleSheets]);
		else {
			let e = "";
			for (let t = 0; t < this.modules.length; t++) e += this.modules[t].getRules() + "\n";
			this.styleTag.textContent = e;
			let n = t.head || t;
			this.styleTag.parentNode != n && n.insertBefore(this.styleTag, n.firstChild);
		}
	}
	setNonce(e) {
		this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
	}
}, Da = {
	8: "Backspace",
	9: "Tab",
	10: "Enter",
	12: "NumLock",
	13: "Enter",
	16: "Shift",
	17: "Control",
	18: "Alt",
	20: "CapsLock",
	27: "Escape",
	32: " ",
	33: "PageUp",
	34: "PageDown",
	35: "End",
	36: "Home",
	37: "ArrowLeft",
	38: "ArrowUp",
	39: "ArrowRight",
	40: "ArrowDown",
	44: "PrintScreen",
	45: "Insert",
	46: "Delete",
	59: ";",
	61: "=",
	91: "Meta",
	92: "Meta",
	106: "*",
	107: "+",
	108: ",",
	109: "-",
	110: ".",
	111: "/",
	144: "NumLock",
	145: "ScrollLock",
	160: "Shift",
	161: "Shift",
	162: "Control",
	163: "Control",
	164: "Alt",
	165: "Alt",
	173: "-",
	186: ";",
	187: "=",
	188: ",",
	189: "-",
	190: ".",
	191: "/",
	192: "`",
	219: "[",
	220: "\\",
	221: "]",
	222: "'"
}, Oa = {
	48: ")",
	49: "!",
	50: "@",
	51: "#",
	52: "$",
	53: "%",
	54: "^",
	55: "&",
	56: "*",
	57: "(",
	59: ":",
	61: "+",
	173: "_",
	186: ":",
	187: "+",
	188: "<",
	189: "_",
	190: ">",
	191: "?",
	192: "~",
	219: "{",
	220: "|",
	221: "}",
	222: "\""
}, ka = typeof navigator < "u" && /Mac/.test(navigator.platform), Aa = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), ja = 0; ja < 10; ja++) Da[48 + ja] = Da[96 + ja] = String(ja);
for (var ja = 1; ja <= 24; ja++) Da[ja + 111] = "F" + ja;
for (var ja = 65; ja <= 90; ja++) Da[ja] = String.fromCharCode(ja + 32), Oa[ja] = String.fromCharCode(ja);
for (var Ma in Da) Oa.hasOwnProperty(Ma) || (Oa[Ma] = Da[Ma]);
function Na(e) {
	var t = !(ka && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || Aa && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified") && e.key || (e.shiftKey ? Oa : Da)[e.keyCode] || e.key || "Unidentified";
	return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
//#endregion
//#region ../../../node_modules/crelt/index.js
function Pa() {
	var e = arguments[0];
	typeof e == "string" && (e = document.createElement(e));
	var t = 1, n = arguments[1];
	if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
		for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
			var i = n[r];
			typeof i == "string" ? e.setAttribute(r, i) : i != null && (e[r] = i);
		}
		t++;
	}
	for (; t < arguments.length; t++) Fa(e, arguments[t]);
	return e;
}
function Fa(e, t) {
	if (typeof t == "string") e.appendChild(document.createTextNode(t));
	else if (t != null) if (t.nodeType != null) e.appendChild(t);
	else if (Array.isArray(t)) for (var n = 0; n < t.length; n++) Fa(e, t[n]);
	else throw RangeError("Unsupported child node: " + t);
}
//#endregion
//#region ../../../node_modules/@codemirror/view/dist/index.js
var Ia = typeof navigator < "u" ? navigator : {
	userAgent: "",
	vendor: "",
	platform: ""
}, La = typeof document < "u" ? document : { documentElement: { style: {} } }, Ra = /*@__PURE__*/ /Edge\/(\d+)/.exec(Ia.userAgent), za = /*@__PURE__*/ /MSIE \d/.test(Ia.userAgent), Ba = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ia.userAgent), Va = !!(za || Ba || Ra), Ha = !Va && /*@__PURE__*/ /gecko\/(\d+)/i.test(Ia.userAgent), Ua = !Va && /*@__PURE__*/ /Chrome\/(\d+)/.exec(Ia.userAgent), Wa = "webkitFontSmoothing" in La.documentElement.style, Ga = !Va && /*@__PURE__*/ /Apple Computer/.test(Ia.vendor), Ka = Ga && (/*@__PURE__*/ /Mobile\/\w+/.test(Ia.userAgent) || Ia.maxTouchPoints > 2), G = {
	mac: Ka || /*@__PURE__*/ /Mac/.test(Ia.platform),
	windows: /*@__PURE__*/ /Win/.test(Ia.platform),
	linux: /*@__PURE__*/ /Linux|X11/.test(Ia.platform),
	ie: Va,
	ie_version: za ? La.documentMode || 6 : Ba ? +Ba[1] : Ra ? +Ra[1] : 0,
	gecko: Ha,
	gecko_version: Ha ? +(/*@__PURE__*/ /Firefox\/(\d+)/.exec(Ia.userAgent) || [0, 0])[1] : 0,
	chrome: !!Ua,
	chrome_version: Ua ? +Ua[1] : 0,
	ios: Ka,
	android: /*@__PURE__*/ /Android\b/.test(Ia.userAgent),
	webkit: Wa,
	webkit_version: Wa ? +(/*@__PURE__*/ /\bAppleWebKit\/(\d+)/.exec(Ia.userAgent) || [0, 0])[1] : 0,
	safari: Ga,
	safari_version: Ga ? +(/*@__PURE__*/ /\bVersion\/(\d+(\.\d+)?)/.exec(Ia.userAgent) || [0, 0])[1] : 0,
	tabSize: La.documentElement.style.tabSize == null ? "-moz-tab-size" : "tab-size"
};
function qa(e, t) {
	for (let n in e) n == "class" && t.class ? t.class += " " + e.class : n == "style" && t.style ? t.style += ";" + e.style : t[n] = e[n];
	return t;
}
var Ja = /*@__PURE__*/ Object.create(null);
function Ya(e, t, n) {
	if (e == t) return !0;
	e ||= Ja, t ||= Ja;
	let r = Object.keys(e), i = Object.keys(t);
	if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0)) return !1;
	for (let a of r) if (a != n && (i.indexOf(a) == -1 || e[a] !== t[a])) return !1;
	return !0;
}
function Xa(e, t) {
	for (let n = e.attributes.length - 1; n >= 0; n--) {
		let r = e.attributes[n].name;
		t[r] ?? e.removeAttribute(r);
	}
	for (let n in t) {
		let r = t[n];
		n == "style" ? e.style.cssText = r : e.getAttribute(n) != r && e.setAttribute(n, r);
	}
}
function Za(e, t, n) {
	let r = !1;
	if (t) for (let i in t) n && i in n || (r = !0, i == "style" ? e.style.cssText = "" : e.removeAttribute(i));
	if (n) for (let i in n) t && t[i] == n[i] || (r = !0, i == "style" ? e.style.cssText = n[i] : e.setAttribute(i, n[i]));
	return r;
}
function Qa(e) {
	let t = Object.create(null);
	for (let n = 0; n < e.attributes.length; n++) {
		let r = e.attributes[n];
		t[r.name] = r.value;
	}
	return t;
}
var $a = class {
	eq(e) {
		return !1;
	}
	updateDOM(e, t, n) {
		return !1;
	}
	compare(e) {
		return this == e || this.constructor == e.constructor && this.eq(e);
	}
	get estimatedHeight() {
		return -1;
	}
	get lineBreaks() {
		return 0;
	}
	ignoreEvent(e) {
		return !0;
	}
	coordsAt(e, t, n) {
		return null;
	}
	get isHidden() {
		return !1;
	}
	get editable() {
		return !1;
	}
	destroy(e) {}
}, eo = /*@__PURE__*/ (function(e) {
	return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
})(eo ||= {}), K = class extends ea {
	constructor(e, t, n, r) {
		super(), this.startSide = e, this.endSide = t, this.widget = n, this.spec = r;
	}
	get heightRelevant() {
		return !1;
	}
	static mark(e) {
		return new to(e);
	}
	static widget(e) {
		let t = Math.max(-1e4, Math.min(1e4, e.side || 0)), n = !!e.block;
		return t += n && !e.inlineOrder ? t > 0 ? 3e8 : -4e8 : t > 0 ? 1e8 : -1e8, new ro(e, t, t, n, e.widget || null, !1);
	}
	static replace(e) {
		let t = !!e.block, n, r;
		if (e.isBlockGap) n = -5e8, r = 4e8;
		else {
			let { start: i, end: a } = io(e, t);
			n = (i ? t ? -3e8 : -1 : 5e8) - 1, r = (a ? t ? 2e8 : 1 : -6e8) + 1;
		}
		return new ro(e, n, r, t, e.widget || null, !0);
	}
	static line(e) {
		return new no(e);
	}
	static set(e, t = !1) {
		return aa.of(e, t);
	}
	hasHeight() {
		return this.widget ? this.widget.estimatedHeight > -1 : !1;
	}
};
K.none = aa.empty;
var to = class e extends K {
	constructor(e) {
		let { start: t, end: n } = io(e);
		super(t ? -1 : 5e8, n ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.attrs = e.class && e.attributes ? qa(e.attributes, { class: e.class }) : e.class ? { class: e.class } : e.attributes || Ja;
	}
	eq(t) {
		return this == t || t instanceof e && this.tagName == t.tagName && Ya(this.attrs, t.attrs);
	}
	range(e, t = e) {
		if (e >= t) throw RangeError("Mark decorations may not be empty");
		return super.range(e, t);
	}
};
to.prototype.point = !1;
var no = class e extends K {
	constructor(e) {
		super(-2e8, -2e8, null, e);
	}
	eq(t) {
		return t instanceof e && this.spec.class == t.spec.class && Ya(this.spec.attributes, t.spec.attributes);
	}
	range(e, t = e) {
		if (t != e) throw RangeError("Line decoration ranges must be zero-length");
		return super.range(e, t);
	}
};
no.prototype.mapMode = Qr.TrackBefore, no.prototype.point = !0;
var ro = class e extends K {
	constructor(e, t, n, r, i, a) {
		super(t, n, i, e), this.block = r, this.isReplace = a, this.mapMode = r ? t <= 0 ? Qr.TrackBefore : Qr.TrackAfter : Qr.TrackDel;
	}
	get type() {
		return this.startSide == this.endSide ? this.startSide <= 0 ? eo.WidgetBefore : eo.WidgetAfter : eo.WidgetRange;
	}
	get heightRelevant() {
		return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
	}
	eq(t) {
		return t instanceof e && ao(this.widget, t.widget) && this.block == t.block && this.startSide == t.startSide && this.endSide == t.endSide;
	}
	range(e, t = e) {
		if (this.isReplace && (e > t || e == t && this.startSide > 0 && this.endSide <= 0)) throw RangeError("Invalid range for replacement decoration");
		if (!this.isReplace && t != e) throw RangeError("Widget decorations can only have zero-length ranges");
		return super.range(e, t);
	}
};
ro.prototype.point = !0;
function io(e, t = !1) {
	let { inclusiveStart: n, inclusiveEnd: r } = e;
	return n ??= e.inclusive, r ??= e.inclusive, {
		start: n ?? t,
		end: r ?? t
	};
}
function ao(e, t) {
	return e == t || !!(e && t && e.compare(t));
}
function oo(e, t, n, r = 0) {
	let i = n.length - 1;
	i >= 0 && n[i] + r >= e ? n[i] = Math.max(n[i], t) : n.push(e, t);
}
var so = class e extends ea {
	constructor(e, t, n) {
		super(), this.tagName = e, this.attributes = t, this.rank = n;
	}
	eq(t) {
		return t == this || t instanceof e && this.tagName == t.tagName && Ya(this.attributes, t.attributes);
	}
	static create(t) {
		return new e(t.tagName, t.attributes || Ja, t.rank == null ? 50 : Math.max(0, Math.min(t.rank, 100)));
	}
	static set(e, t = !1) {
		return aa.of(e, t);
	}
};
so.prototype.startSide = so.prototype.endSide = -1;
function co(e) {
	let t;
	return t = e.nodeType == 11 ? e.getSelection ? e : e.ownerDocument : e, t.getSelection();
}
function lo(e, t) {
	return t ? e == t || e.contains(t.nodeType == 1 ? t : t.parentNode) : !1;
}
function uo(e, t) {
	if (!t.anchorNode) return !1;
	try {
		return lo(e, t.anchorNode);
	} catch {
		return !1;
	}
}
function fo(e) {
	return e.nodeType == 3 ? Do(e, 0, e.nodeValue.length).getClientRects() : e.nodeType == 1 ? e.getClientRects() : [];
}
function po(e, t, n, r) {
	return n ? go(e, t, n, r, -1) || go(e, t, n, r, 1) : !1;
}
function mo(e) {
	for (var t = 0;; t++) if (e = e.previousSibling, !e) return t;
}
function ho(e) {
	return e.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
function go(e, t, n, r, i) {
	for (;;) {
		if (e == n && t == r) return !0;
		if (t == (i < 0 ? 0 : _o(e))) {
			if (e.nodeName == "DIV") return !1;
			let n = e.parentNode;
			if (!n || n.nodeType != 1) return !1;
			t = mo(e) + (i < 0 ? 0 : 1), e = n;
		} else if (e.nodeType == 1) {
			if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.nodeType == 1 && e.contentEditable == "false") return !1;
			t = i < 0 ? _o(e) : 0;
		} else return !1;
	}
}
function _o(e) {
	return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function vo(e, t) {
	let n = t ? e.left : e.right;
	return {
		left: n,
		right: n,
		top: e.top,
		bottom: e.bottom
	};
}
function yo(e) {
	let t = e.visualViewport;
	return t ? {
		left: 0,
		right: t.width,
		top: 0,
		bottom: t.height
	} : {
		left: 0,
		right: e.innerWidth,
		top: 0,
		bottom: e.innerHeight
	};
}
function bo(e, t) {
	let n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
	return (n > .995 && n < 1.005 || !isFinite(n) || Math.abs(t.width - e.offsetWidth) < 1) && (n = 1), (r > .995 && r < 1.005 || !isFinite(r) || Math.abs(t.height - e.offsetHeight) < 1) && (r = 1), {
		scaleX: n,
		scaleY: r
	};
}
function xo(e, t, n, r, i, a, o, s) {
	let c = e.ownerDocument, l = c.defaultView || window;
	for (let u = e, d = !1; u && !d;) if (u.nodeType == 1) {
		let e, f = u == c.body, p = 1, m = 1;
		if (f) e = yo(l);
		else {
			if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (d = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
				u = u.assignedSlot || u.parentNode;
				continue;
			}
			let t = u.getBoundingClientRect();
			({scaleX: p, scaleY: m} = bo(u, t)), e = {
				left: t.left,
				right: t.left + u.clientWidth * p,
				top: t.top,
				bottom: t.top + u.clientHeight * m
			};
		}
		let h = 0, g = 0;
		if (i == "nearest") t.top < e.top + o ? (g = t.top - (e.top + o), n > 0 && t.bottom > e.bottom + g && (g = t.bottom - e.bottom + o)) : t.bottom > e.bottom - o && (g = t.bottom - e.bottom + o, n < 0 && t.top - g < e.top && (g = t.top - (e.top + o)));
		else {
			let r = t.bottom - t.top, a = e.bottom - e.top;
			g = (i == "center" && r <= a ? t.top + r / 2 - a / 2 : i == "start" || i == "center" && n < 0 ? t.top - o : t.bottom - a + o) - e.top;
		}
		if (r == "nearest" ? t.left < e.left + a ? (h = t.left - (e.left + a), n > 0 && t.right > e.right + h && (h = t.right - e.right + a)) : t.right > e.right - a && (h = t.right - e.right + a, n < 0 && t.left < e.left + h && (h = t.left - (e.left + a))) : h = (r == "center" ? t.left + (t.right - t.left) / 2 - (e.right - e.left) / 2 : r == "start" == s ? t.left - a : t.right - (e.right - e.left) + a) - e.left, h || g) if (f) l.scrollBy(h, g);
		else {
			let e = 0, n = 0;
			if (g) {
				let e = u.scrollTop;
				u.scrollTop += g / m, n = (u.scrollTop - e) * m;
			}
			if (h) {
				let t = u.scrollLeft;
				u.scrollLeft += h / p, e = (u.scrollLeft - t) * p;
			}
			t = {
				left: t.left - e,
				top: t.top - n,
				right: t.right - e,
				bottom: t.bottom - n
			}, e && Math.abs(e - h) < 1 && (r = "nearest"), n && Math.abs(n - g) < 1 && (i = "nearest");
		}
		if (f) break;
		(t.top < e.top || t.bottom > e.bottom || t.left < e.left || t.right > e.right) && (t = {
			left: Math.max(t.left, e.left),
			right: Math.min(t.right, e.right),
			top: Math.max(t.top, e.top),
			bottom: Math.min(t.bottom, e.bottom)
		}), u = u.assignedSlot || u.parentNode;
	} else if (u.nodeType == 11) u = u.host;
	else break;
}
function So(e, t = !0) {
	let n = e.ownerDocument, r = null, i = null;
	for (let a = e.parentNode; a && !(a == n.body || (!t || r) && i);) if (a.nodeType == 1) !i && a.scrollHeight > a.clientHeight && (i = a), t && !r && a.scrollWidth > a.clientWidth && (r = a), a = a.assignedSlot || a.parentNode;
	else if (a.nodeType == 11) a = a.host;
	else break;
	return {
		x: r,
		y: i
	};
}
var Co = class {
	constructor() {
		this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
	}
	eq(e) {
		return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
	}
	setRange(e) {
		let { anchorNode: t, focusNode: n } = e;
		this.set(t, Math.min(e.anchorOffset, t ? _o(t) : 0), n, Math.min(e.focusOffset, n ? _o(n) : 0));
	}
	set(e, t, n, r) {
		this.anchorNode = e, this.anchorOffset = t, this.focusNode = n, this.focusOffset = r;
	}
}, wo = null;
G.safari && G.safari_version >= 26 && (wo = !1);
function To(e) {
	if (e.setActive) return e.setActive();
	if (wo) return e.focus(wo);
	let t = [];
	for (let n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode);
	if (e.focus(wo == null ? { get preventScroll() {
		return wo = { preventScroll: !0 }, !0;
	} } : void 0), !wo) {
		wo = !1;
		for (let e = 0; e < t.length;) {
			let n = t[e++], r = t[e++], i = t[e++];
			n.scrollTop != r && (n.scrollTop = r), n.scrollLeft != i && (n.scrollLeft = i);
		}
	}
}
var Eo;
function Do(e, t, n = t) {
	let r = Eo ||= document.createRange();
	return r.setEnd(e, n), r.setStart(e, t), r;
}
function Oo(e, t, n, r) {
	let i = {
		key: t,
		code: t,
		keyCode: n,
		which: n,
		cancelable: !0
	};
	r && ({altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey} = r);
	let a = new KeyboardEvent("keydown", i);
	a.synthetic = !0, e.dispatchEvent(a);
	let o = new KeyboardEvent("keyup", i);
	return o.synthetic = !0, e.dispatchEvent(o), a.defaultPrevented || o.defaultPrevented;
}
function ko(e) {
	for (; e;) {
		if (e && (e.nodeType == 9 || e.nodeType == 11 && e.host)) return e;
		e = e.assignedSlot || e.parentNode;
	}
	return null;
}
function Ao(e, t) {
	let n = t.focusNode, r = t.focusOffset;
	if (!n || t.anchorNode != n || t.anchorOffset != r) return !1;
	for (r = Math.min(r, _o(n));;) if (r) {
		if (n.nodeType != 1) return !1;
		let e = n.childNodes[r - 1];
		e.contentEditable == "false" ? r-- : (n = e, r = _o(n));
	} else if (n == e) return !0;
	else r = mo(n), n = n.parentNode;
}
function jo(e) {
	return e instanceof Window ? e.pageYOffset > Math.max(0, e.document.documentElement.scrollHeight - e.innerHeight - 4) : e.scrollTop > Math.max(1, e.scrollHeight - e.clientHeight - 4);
}
function Mo(e, t) {
	for (let n = e, r = t;;) if (n.nodeType == 3 && r > 0) return {
		node: n,
		offset: r
	};
	else if (n.nodeType == 1 && r > 0) {
		if (n.contentEditable == "false") return null;
		n = n.childNodes[r - 1], r = _o(n);
	} else if (n.parentNode && !ho(n)) r = mo(n), n = n.parentNode;
	else return null;
}
function No(e, t) {
	for (let n = e, r = t;;) if (n.nodeType == 3 && r < n.nodeValue.length) return {
		node: n,
		offset: r
	};
	else if (n.nodeType == 1 && r < n.childNodes.length) {
		if (n.contentEditable == "false") return null;
		n = n.childNodes[r], r = 0;
	} else if (n.parentNode && !ho(n)) r = mo(n) + 1, n = n.parentNode;
	else return null;
}
var Po = class e {
	constructor(e, t, n = !0) {
		this.node = e, this.offset = t, this.precise = n;
	}
	static before(t, n) {
		return new e(t.parentNode, mo(t), n);
	}
	static after(t, n) {
		return new e(t.parentNode, mo(t) + 1, n);
	}
}, Fo = /*@__PURE__*/ (function(e) {
	return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
})(Fo ||= {}), Io = Fo.LTR, Lo = Fo.RTL;
function Ro(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) t.push(1 << e[n]);
	return t;
}
var zo = /*@__PURE__*/ Ro("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), Bo = /*@__PURE__*/ Ro("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Vo = /*@__PURE__*/ Object.create(null), Ho = [];
for (let e of [
	"()",
	"[]",
	"{}"
]) {
	let t = /*@__PURE__*/ e.charCodeAt(0), n = /*@__PURE__*/ e.charCodeAt(1);
	Vo[t] = n, Vo[n] = -t;
}
function Uo(e) {
	return e <= 247 ? zo[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? Bo[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8204 ? 256 : 64336 <= e && e <= 65023 ? 4 : 1;
}
var Wo = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/, Go = class {
	get dir() {
		return this.level % 2 ? Lo : Io;
	}
	constructor(e, t, n) {
		this.from = e, this.to = t, this.level = n;
	}
	side(e, t) {
		return this.dir == t == e ? this.to : this.from;
	}
	forward(e, t) {
		return e == (this.dir == t);
	}
	static find(e, t, n, r) {
		let i = -1;
		for (let a = 0; a < e.length; a++) {
			let o = e[a];
			if (o.from <= t && o.to >= t) {
				if (o.level == n) return a;
				(i < 0 || (r == 0 ? e[i].level > o.level : r < 0 ? o.from < t : o.to > t)) && (i = a);
			}
		}
		if (i < 0) throw RangeError("Index out of range");
		return i;
	}
};
function Ko(e, t) {
	if (e.length != t.length) return !1;
	for (let n = 0; n < e.length; n++) {
		let r = e[n], i = t[n];
		if (r.from != i.from || r.to != i.to || r.direction != i.direction || !Ko(r.inner, i.inner)) return !1;
	}
	return !0;
}
var qo = [];
function Jo(e, t, n, r, i) {
	for (let a = 0; a <= r.length; a++) {
		let o = a ? r[a - 1].to : t, s = a < r.length ? r[a].from : n, c = a ? 256 : i;
		for (let t = o, n = c, r = c; t < s; t++) {
			let i = Uo(e.charCodeAt(t));
			i == 512 ? i = n : i == 8 && r == 4 && (i = 16), qo[t] = i == 4 ? 2 : i, i & 7 && (r = i), n = i;
		}
		for (let e = o, t = c, r = c; e < s; e++) {
			let i = qo[e];
			if (i == 128) e < s - 1 && t == qo[e + 1] && t & 24 ? i = qo[e] = t : qo[e] = 256;
			else if (i == 64) {
				let i = e + 1;
				for (; i < s && qo[i] == 64;) i++;
				let a = e && t == 8 || i < n && qo[i] == 8 ? r == 1 ? 1 : 8 : 256;
				for (let t = e; t < i; t++) qo[t] = a;
				e = i - 1;
			} else i == 8 && r == 1 && (qo[e] = 1);
			t = i, i & 7 && (r = i);
		}
	}
}
function Yo(e, t, n, r, i) {
	let a = i == 1 ? 2 : 1;
	for (let o = 0, s = 0, c = 0; o <= r.length; o++) {
		let l = o ? r[o - 1].to : t, u = o < r.length ? r[o].from : n;
		for (let t = l, n, r, o; t < u; t++) if (r = Vo[n = e.charCodeAt(t)]) if (r < 0) {
			for (let e = s - 3; e >= 0; e -= 3) if (Ho[e + 1] == -r) {
				let n = Ho[e + 2], r = n & 2 ? i : n & 4 ? n & 1 ? a : i : 0;
				r && (qo[t] = qo[Ho[e]] = r), s = e;
				break;
			}
		} else if (Ho.length == 189) break;
		else Ho[s++] = t, Ho[s++] = n, Ho[s++] = c;
		else if ((o = qo[t]) == 2 || o == 1) {
			let e = o == i;
			c = +!e;
			for (let t = s - 3; t >= 0; t -= 3) {
				let n = Ho[t + 2];
				if (n & 2) break;
				if (e) Ho[t + 2] |= 2;
				else {
					if (n & 4) break;
					Ho[t + 2] |= 4;
				}
			}
		}
	}
}
function Xo(e, t, n, r) {
	for (let i = 0, a = r; i <= n.length; i++) {
		let o = i ? n[i - 1].to : e, s = i < n.length ? n[i].from : t;
		for (let c = o; c < s;) {
			let o = qo[c];
			if (o == 256) {
				let o = c + 1;
				for (;;) if (o == s) {
					if (i == n.length) break;
					o = n[i++].to, s = i < n.length ? n[i].from : t;
				} else if (qo[o] == 256) o++;
				else break;
				let l = a == 1, u = l == ((o < t ? qo[o] : r) == 1) ? l ? 1 : 2 : r;
				for (let t = o, r = i, a = r ? n[r - 1].to : e; t > c;) t == a && (t = n[--r].from, a = r ? n[r - 1].to : e), qo[--t] = u;
				c = o;
			} else a = o, c++;
		}
	}
}
function Zo(e, t, n, r, i, a, o) {
	let s = r % 2 ? 2 : 1;
	if (r % 2 == i % 2) for (let c = t, l = 0; c < n;) {
		let t = !0, u = !1;
		if (l == a.length || c < a[l].from) {
			let e = qo[c];
			e != s && (t = !1, u = e == 16);
		}
		let d = !t && s == 1 ? [] : null, f = t ? r : r + 1, p = c;
		run: for (;;) if (l < a.length && p == a[l].from) {
			if (u) break run;
			let m = a[l];
			if (!t) for (let e = m.to, t = l + 1;;) {
				if (e == n) break run;
				if (t < a.length && a[t].from == e) e = a[t++].to;
				else if (qo[e] == s) break run;
				else break;
			}
			l++, d ? d.push(m) : (m.from > c && o.push(new Go(c, m.from, f)), Qo(e, m.direction == Io == !(f % 2) ? r : r + 1, i, m.inner, m.from, m.to, o), c = m.to), p = m.to;
		} else if (p == n || (t ? qo[p] != s : qo[p] == s)) break;
		else p++;
		d ? Zo(e, c, p, r + 1, i, d, o) : c < p && o.push(new Go(c, p, f)), c = p;
	}
	else for (let c = n, l = a.length; c > t;) {
		let n = !0, u = !1;
		if (!l || c > a[l - 1].to) {
			let e = qo[c - 1];
			e != s && (n = !1, u = e == 16);
		}
		let d = !n && s == 1 ? [] : null, f = n ? r : r + 1, p = c;
		run: for (;;) if (l && p == a[l - 1].to) {
			if (u) break run;
			let m = a[--l];
			if (!n) for (let e = m.from, n = l;;) {
				if (e == t) break run;
				if (n && a[n - 1].to == e) e = a[--n].from;
				else if (qo[e - 1] == s) break run;
				else break;
			}
			d ? d.push(m) : (m.to < c && o.push(new Go(m.to, c, f)), Qo(e, m.direction == Io == !(f % 2) ? r : r + 1, i, m.inner, m.from, m.to, o), c = m.from), p = m.from;
		} else if (p == t || (n ? qo[p - 1] != s : qo[p - 1] == s)) break;
		else p--;
		d ? Zo(e, p, c, r + 1, i, d, o) : p < c && o.push(new Go(p, c, f)), c = p;
	}
}
function Qo(e, t, n, r, i, a, o) {
	let s = t % 2 ? 2 : 1;
	Jo(e, i, a, r, s), Yo(e, i, a, r, s), Xo(i, a, r, s), Zo(e, i, a, t, n, r, o);
}
function $o(e, t, n) {
	if (!e) return [new Go(0, 0, +(t == Lo))];
	if (t == Io && !n.length && !Wo.test(e)) return es(e.length);
	if (n.length) for (; e.length > qo.length;) qo[qo.length] = 256;
	let r = [], i = t == Io ? 0 : 1;
	return Qo(e, i, i, n, 0, e.length, r), r;
}
function es(e) {
	return [new Go(0, e, 0)];
}
var ts = "";
function ns(e, t, n, r, i) {
	let a = r.head - e.from, o = Go.find(t, a, r.bidiLevel ?? -1, r.assoc), s = t[o], c = s.side(i, n);
	if (a == c) {
		let e = o += i ? 1 : -1;
		if (e < 0 || e >= t.length) return null;
		s = t[o = e], a = s.side(!i, n), c = s.side(i, n);
	}
	let l = Gr(e.text, a, s.forward(i, n));
	(l < s.from || l > s.to) && (l = c), ts = e.text.slice(Math.min(a, l), Math.max(a, l));
	let u = o == (i ? t.length - 1 : 0) ? null : t[o + (i ? 1 : -1)];
	return u && l == c && u.level + +!i < s.level ? U.cursor(u.side(!i, n) + e.from, u.forward(i, n) ? 1 : -1, u.level) : U.cursor(l + e.from, s.forward(i, n) ? -1 : 1, s.level);
}
function rs(e, t, n) {
	for (let r = t; r < n; r++) {
		let t = Uo(e.charCodeAt(r));
		if (t == 1) return Io;
		if (t == 2 || t == 4) return Lo;
	}
	return Io;
}
var is = /*@__PURE__*/ W.define(), as = /*@__PURE__*/ W.define(), os = /*@__PURE__*/ W.define(), ss = /*@__PURE__*/ W.define(), cs = /*@__PURE__*/ W.define(), ls = /*@__PURE__*/ W.define(), us = /*@__PURE__*/ W.define(), ds = /*@__PURE__*/ W.define(), fs = /*@__PURE__*/ W.define(), ps = /*@__PURE__*/ W.define({ combine: (e) => e.some((e) => e) }), ms = /*@__PURE__*/ W.define({ combine: (e) => e.some((e) => e) }), hs = /*@__PURE__*/ W.define(), gs = class e {
	constructor(e, t, n, r, i, a = !1) {
		this.range = e, this.y = t, this.x = n, this.yMargin = r, this.xMargin = i, this.isSnapshot = a;
	}
	map(t) {
		return t.empty ? this : new e(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
	}
	clip(t) {
		return this.range.to <= t.doc.length ? this : new e(U.cursor(t.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
	}
}, _s = /*@__PURE__*/ Li.define({ map: (e, t) => e.map(t) }), vs = /*@__PURE__*/ Li.define();
function ys(e, t, n) {
	let r = e.facet(ss);
	r.length ? r[0](t) : window.onerror && window.onerror(String(t), n, void 0, void 0, t) || (n ? console.error(n + ":", t) : console.error(t));
}
var bs = /*@__PURE__*/ W.define({ combine: (e) => e.length ? e[0] : !0 }), xs = 0, Ss = /*@__PURE__*/ W.define({ combine(e) {
	return e.filter((t, n) => {
		for (let r = 0; r < n; r++) if (e[r].plugin == t.plugin) return !1;
		return !0;
	});
} }), Cs = class e {
	constructor(e, t, n, r, i) {
		this.id = e, this.create = t, this.domEventHandlers = n, this.domEventObservers = r, this.baseExtensions = i(this), this.extension = this.baseExtensions.concat(Ss.of({
			plugin: this,
			arg: void 0
		}));
	}
	of(e) {
		return this.baseExtensions.concat(Ss.of({
			plugin: this,
			arg: e
		}));
	}
	static define(t, n) {
		let { eventHandlers: r, eventObservers: i, provide: a, decorations: o } = n || {};
		return new e(xs++, t, r, i, (e) => {
			let t = [];
			return o && t.push(Ds.of((t) => {
				let n = t.plugin(e);
				return n ? o(n) : K.none;
			})), a && t.push(a(e)), t;
		});
	}
	static fromClass(t, n) {
		return e.define((e, n) => new t(e, n), n);
	}
}, ws = class {
	constructor(e) {
		this.spec = e, this.mustUpdate = null, this.value = null;
	}
	get plugin() {
		return this.spec && this.spec.plugin;
	}
	update(e) {
		if (!this.value) {
			if (this.spec) try {
				this.value = this.spec.plugin.create(e, this.spec.arg);
			} catch (t) {
				ys(e.state, t, "CodeMirror plugin crashed"), this.deactivate();
			}
		} else if (this.mustUpdate) {
			let e = this.mustUpdate;
			if (this.mustUpdate = null, this.value.update) try {
				this.value.update(e);
			} catch (t) {
				if (ys(e.state, t, "CodeMirror plugin crashed"), this.value.destroy) try {
					this.value.destroy();
				} catch {}
				this.deactivate();
			}
		}
		return this;
	}
	destroy(e) {
		if (this.value?.destroy) try {
			this.value.destroy();
		} catch (t) {
			ys(e.state, t, "CodeMirror plugin crashed");
		}
	}
	deactivate() {
		this.spec = this.value = null;
	}
}, Ts = /*@__PURE__*/ W.define(), Es = /*@__PURE__*/ W.define(), Ds = /*@__PURE__*/ W.define(), Os = /*@__PURE__*/ W.define(), ks = /*@__PURE__*/ W.define(), As = /*@__PURE__*/ W.define(), js = /*@__PURE__*/ W.define();
function Ms(e, t) {
	let n = e.state.facet(js);
	if (!n.length) return n;
	let r = n.map((t) => t instanceof Function ? t(e) : t), i = [];
	return aa.spans(r, t.from, t.to, {
		point() {},
		span(e, n, r, a) {
			let o = e - t.from, s = n - t.from, c = i;
			for (let e = r.length - 1; e >= 0; e--, a--) {
				let n = r[e].spec.bidiIsolate, i;
				if (n ??= rs(t.text, o, s), a > 0 && c.length && (i = c[c.length - 1]).to == o && i.direction == n) i.to = s, c = i.inner;
				else {
					let e = {
						from: o,
						to: s,
						direction: n,
						inner: []
					};
					c.push(e), c = e.inner;
				}
			}
		}
	}), i;
}
var Ns = /*@__PURE__*/ W.define();
function Ps(e) {
	let t = 0, n = 0, r = 0, i = 0;
	for (let a of e.state.facet(Ns)) {
		let o = a(e);
		o && (o.left != null && (t = Math.max(t, o.left)), o.right != null && (n = Math.max(n, o.right)), o.top != null && (r = Math.max(r, o.top)), o.bottom != null && (i = Math.max(i, o.bottom)));
	}
	return {
		left: t,
		right: n,
		top: r,
		bottom: i
	};
}
var Fs = /*@__PURE__*/ W.define(), Is = class e {
	constructor(e, t, n, r) {
		this.fromA = e, this.toA = t, this.fromB = n, this.toB = r;
	}
	join(t) {
		return new e(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
	}
	addToSet(e) {
		let t = e.length, n = this;
		for (; t > 0; t--) {
			let r = e[t - 1];
			if (!(r.fromA > n.toA)) {
				if (r.toA < n.fromA) break;
				n = n.join(r), e.splice(t - 1, 1);
			}
		}
		return e.splice(t, 0, n), e;
	}
	static extendWithRanges(t, n) {
		if (n.length == 0) return t;
		let r = [];
		for (let i = 0, a = 0, o = 0;;) {
			let s = i < t.length ? t[i].fromB : 1e9, c = a < n.length ? n[a] : 1e9, l = Math.min(s, c);
			if (l == 1e9) break;
			let u = l + o, d = l, f = u;
			for (;;) if (a < n.length && n[a] <= d) {
				let e = n[a + 1];
				a += 2, d = Math.max(d, e);
				for (let e = i; e < t.length && t[e].fromB <= d; e++) o = t[e].toA - t[e].toB;
				f = Math.max(f, e + o);
			} else if (i < t.length && t[i].fromB <= d) {
				let e = t[i++];
				d = Math.max(d, e.toB), f = Math.max(f, e.toA), o = e.toA - e.toB;
			} else break;
			r.push(new e(u, f, l, d));
		}
		return r;
	}
}, Ls = class e {
	constructor(e, t, n) {
		this.view = e, this.state = t, this.transactions = n, this.flags = 0, this.startState = e.state, this.changes = ei.empty(this.startState.doc.length);
		for (let e of n) this.changes = this.changes.compose(e.changes);
		let r = [];
		this.changes.iterChangedRanges((e, t, n, i) => r.push(new Is(e, t, n, i))), this.changedRanges = r;
	}
	static create(t, n, r) {
		return new e(t, n, r);
	}
	get viewportChanged() {
		return (this.flags & 4) > 0;
	}
	get viewportMoved() {
		return (this.flags & 8) > 0;
	}
	get heightChanged() {
		return (this.flags & 2) > 0;
	}
	get geometryChanged() {
		return this.docChanged || (this.flags & 18) > 0;
	}
	get focusChanged() {
		return (this.flags & 1) > 0;
	}
	get docChanged() {
		return !this.changes.empty;
	}
	get selectionSet() {
		return this.transactions.some((e) => e.selection);
	}
	get empty() {
		return this.flags == 0 && this.transactions.length == 0;
	}
}, Rs = [], zs = class {
	constructor(e, t, n = 0) {
		this.dom = e, this.length = t, this.flags = n, this.parent = null, e.cmTile = this;
	}
	get breakAfter() {
		return this.flags & 1;
	}
	get children() {
		return Rs;
	}
	isWidget() {
		return !1;
	}
	get isHidden() {
		return !1;
	}
	isComposite() {
		return !1;
	}
	isLine() {
		return !1;
	}
	isText() {
		return !1;
	}
	isBlock() {
		return !1;
	}
	get domAttrs() {
		return null;
	}
	sync(e) {
		if (this.flags |= 2, this.flags & 4) {
			this.flags &= -5;
			let e = this.domAttrs;
			e && Xa(this.dom, e);
		}
	}
	toString() {
		return this.constructor.name + (this.children.length ? `(${this.children})` : "") + (this.breakAfter ? "#" : "");
	}
	destroy() {
		this.parent = null;
	}
	setDOM(e) {
		this.dom = e, e.cmTile = this;
	}
	get posAtStart() {
		return this.parent ? this.parent.posBefore(this) : 0;
	}
	get posAtEnd() {
		return this.posAtStart + this.length;
	}
	posBefore(e, t = this.posAtStart) {
		let n = t;
		for (let t of this.children) {
			if (t == e) return n;
			n += t.length + t.breakAfter;
		}
		throw RangeError("Invalid child in posBefore");
	}
	posAfter(e) {
		return this.posBefore(e) + e.length;
	}
	covers(e) {
		return !0;
	}
	coordsIn(e, t) {
		return null;
	}
	domPosFor(e, t) {
		let n = mo(this.dom), r = this.length ? e > 0 : t > 0;
		return new Po(this.parent.dom, n + +!!r, e == 0 || e == this.length);
	}
	markDirty(e) {
		this.flags &= -3, e && (this.flags |= 4), this.parent && this.parent.flags & 2 && this.parent.markDirty(!1);
	}
	get overrideDOMText() {
		return null;
	}
	get root() {
		for (let e = this; e; e = e.parent) if (e instanceof Hs) return e;
		return null;
	}
	static get(e) {
		return e.cmTile;
	}
}, Bs = class extends zs {
	constructor(e) {
		super(e, 0), this._children = [];
	}
	isComposite() {
		return !0;
	}
	get children() {
		return this._children;
	}
	get lastChild() {
		return this.children.length ? this.children[this.children.length - 1] : null;
	}
	append(e) {
		this.children.push(e), e.parent = this;
	}
	sync(e) {
		if (this.flags & 2) return;
		super.sync(e);
		let t = this.dom, n = null, r, i = e?.node == t ? e : null, a = 0;
		for (let o of this.children) {
			if (o.sync(e), a += o.length + o.breakAfter, r = n ? n.nextSibling : t.firstChild, i && r != o.dom && (i.written = !0), o.dom.parentNode == t) for (; r && r != o.dom;) r = Vs(r);
			else t.insertBefore(o.dom, r);
			n = o.dom;
		}
		for (r = n ? n.nextSibling : t.firstChild, i && r && (i.written = !0); r;) r = Vs(r);
		this.length = a;
	}
};
function Vs(e) {
	let t = e.nextSibling;
	return e.parentNode.removeChild(e), t;
}
var Hs = class extends Bs {
	constructor(e, t) {
		super(t), this.view = e;
	}
	owns(e) {
		for (; e; e = e.parent) if (e == this) return !0;
		return !1;
	}
	isBlock() {
		return !0;
	}
	nearest(e) {
		for (;;) {
			if (!e) return null;
			let t = zs.get(e);
			if (t && this.owns(t)) return t;
			e = e.parentNode;
		}
	}
	blockTiles(e) {
		for (let t = [], n = this, r = 0, i = 0;;) if (r == n.children.length) {
			if (!t.length) return;
			n = n.parent, n.breakAfter && i++, r = t.pop();
		} else {
			let a = n.children[r++];
			if (a instanceof Us) t.push(r), n = a, r = 0;
			else {
				let t = i + a.length, n = e(a, i);
				if (n !== void 0) return n;
				i = t + a.breakAfter;
			}
		}
	}
	resolveBlock(e, t) {
		let n, r = -1, i, a = -1;
		if (this.blockTiles((o, s) => {
			let c = s + o.length;
			if (e >= s && e <= c) {
				if (o.isWidget() && t >= -1 && t <= 1) {
					if (o.flags & 32) return !0;
					o.flags & 16 && (n = void 0);
				}
				(s < e || e == c && (t < -1 ? o.length : o.covers(1))) && (!n || !o.isWidget() && n.isWidget()) && (n = o, r = e - s), (c > e || e == s && (t > 1 ? o.length : o.covers(-1))) && (!i || !o.isWidget() && i.isWidget()) && (i = o, a = e - s);
			}
		}), !n && !i) throw Error("No tile at position " + e);
		return n && t < 0 || !i ? {
			tile: n,
			offset: r
		} : {
			tile: i,
			offset: a
		};
	}
}, Us = class e extends Bs {
	constructor(e, t) {
		super(e), this.wrapper = t;
	}
	isBlock() {
		return !0;
	}
	covers(e) {
		return this.children.length ? e < 0 ? this.children[0].covers(-1) : this.lastChild.covers(1) : !1;
	}
	get domAttrs() {
		return this.wrapper.attributes;
	}
	static of(t, n) {
		let r = new e(n || document.createElement(t.tagName), t);
		return n || (r.flags |= 4), r;
	}
}, Ws = class e extends Bs {
	constructor(e, t) {
		super(e), this.attrs = t;
	}
	isLine() {
		return !0;
	}
	static start(t, n, r) {
		let i = new e(n || document.createElement("div"), t);
		return (!n || !r) && (i.flags |= 4), i;
	}
	get domAttrs() {
		return this.attrs;
	}
	resolveInline(e, t, n) {
		let r = null, i = -1, a = null, o = -1;
		function s(e, c) {
			for (let l = 0, u = 0; l < e.children.length && u <= c; l++) {
				let d = e.children[l], f = u + d.length;
				f >= c && (d.isComposite() ? s(d, c - u) : (!a || a.isHidden && (t > 0 || n && Ks(a, d))) && (f > c || d.flags & 32) ? (a = d, o = c - u) : (u < c || d.flags & 16 && !d.isHidden) && (r = d, i = c - u)), u = f;
			}
		}
		s(this, e);
		let c = (t < 0 ? r : a) || r || a;
		return c ? {
			tile: c,
			offset: c == r ? i : o
		} : null;
	}
	coordsIn(e, t) {
		let n = this.resolveInline(e, t, !0);
		return n ? n.tile.coordsIn(Math.max(0, n.offset), t) : Gs(this);
	}
	domIn(e, t) {
		let n = this.resolveInline(e, t);
		if (n) {
			let { tile: e, offset: r } = n;
			if (this.dom.contains(e.dom)) return e.isText() ? new Po(e.dom, Math.min(e.dom.nodeValue.length, r)) : e.domPosFor(r, e.flags & 16 ? 1 : e.flags & 32 ? -1 : t);
			let i = n.tile.parent, a = !1;
			for (let e of i.children) {
				if (a) return new Po(e.dom, 0);
				e == n.tile && (a = !0);
			}
		}
		return new Po(this.dom, 0);
	}
};
function Gs(e) {
	let t = e.dom.lastChild;
	if (!t) return e.dom.getBoundingClientRect();
	let n = fo(t);
	return n[n.length - 1] || null;
}
function Ks(e, t) {
	let n = e.coordsIn(0, 1), r = t.coordsIn(0, 1);
	return n && r && r.top < n.bottom;
}
var qs = class e extends Bs {
	constructor(e, t) {
		super(e), this.mark = t;
	}
	get domAttrs() {
		return this.mark.attrs;
	}
	static of(t, n) {
		let r = new e(n || document.createElement(t.tagName), t);
		return n || (r.flags |= 4), r;
	}
}, Js = class e extends zs {
	constructor(e, t) {
		super(e, t.length), this.text = t;
	}
	sync(e) {
		this.flags & 2 || (super.sync(e), this.dom.nodeValue != this.text && (e && e.node == this.dom && (e.written = !0), this.dom.nodeValue = this.text));
	}
	isText() {
		return !0;
	}
	toString() {
		return JSON.stringify(this.text);
	}
	coordsIn(e, t) {
		let n = this.dom.nodeValue.length;
		e > n && (e = n);
		let r = e, i = e, a = 0;
		e == 0 && t < 0 || e == n && t >= 0 ? G.chrome || G.gecko || (e ? (r--, a = 1) : i < n && (i++, a = -1)) : t < 0 ? r-- : i < n && i++;
		let o = Do(this.dom, r, i).getClientRects();
		if (!o.length) return null;
		let s = o[(a ? a < 0 : t >= 0) ? 0 : o.length - 1];
		return G.safari && !a && s.width == 0 && (s = Array.prototype.find.call(o, (e) => e.width) || s), a ? vo(s, a < 0) : s || null;
	}
	static of(t, n) {
		let r = new e(n || document.createTextNode(t), t);
		return n || (r.flags |= 2), r;
	}
}, Ys = class e extends zs {
	constructor(e, t, n, r) {
		super(e, t, r), this.widget = n;
	}
	isWidget() {
		return !0;
	}
	get isHidden() {
		return this.widget.isHidden;
	}
	covers(e) {
		return this.flags & 48 ? !1 : (this.flags & (e < 0 ? 64 : 128)) > 0;
	}
	coordsIn(e, t) {
		return this.coordsInWidget(e, t, !1);
	}
	coordsInWidget(e, t, n) {
		let r = this.widget.coordsAt(this.dom, e, t);
		if (r) return r;
		if (n) return vo(this.dom.getBoundingClientRect(), this.length ? e == 0 : t <= 0);
		{
			let t = this.dom.getClientRects(), n = null;
			if (!t.length) return null;
			let r = this.flags & 16 ? !0 : this.flags & 32 ? !1 : e > 0;
			for (let i = r ? t.length - 1 : 0; n = t[i], !(e > 0 ? i == 0 : i == t.length - 1 || n.top < n.bottom); i += r ? -1 : 1);
			return vo(n, !r);
		}
	}
	get overrideDOMText() {
		if (!this.length) return Pr.empty;
		let { root: e } = this;
		if (!e) return Pr.empty;
		let t = this.posAtStart;
		return e.view.state.doc.slice(t, t + this.length);
	}
	destroy() {
		super.destroy(), this.widget.destroy(this.dom);
	}
	static of(t, n, r, i, a) {
		return a || (a = t.toDOM(n), t.editable || (a.contentEditable = "false")), new e(a, r, t, i);
	}
}, Xs = class extends zs {
	constructor(e) {
		let t = document.createElement("img");
		t.className = "cm-widgetBuffer", t.setAttribute("aria-hidden", "true"), super(t, 0, e);
	}
	get isHidden() {
		return !0;
	}
	get overrideDOMText() {
		return Pr.empty;
	}
	coordsIn(e) {
		return this.dom.getBoundingClientRect();
	}
}, Zs = class {
	constructor(e) {
		this.index = 0, this.beforeBreak = !1, this.parents = [], this.tile = e;
	}
	advance(e, t, n) {
		let { tile: r, index: i, beforeBreak: a, parents: o } = this;
		for (; e || t > 0;) if (!r.isComposite()) if (i == r.length) a = !!r.breakAfter, {tile: r, index: i} = o.pop(), i++;
		else if (e) {
			let t = Math.min(e, r.length - i);
			n && n.skip(r, i, i + t), e -= t, i += t;
		} else break;
		else if (a) {
			if (!e) break;
			n && n.break(), e--, a = !1;
		} else if (i == r.children.length) {
			if (!e && !o.length) break;
			n && n.leave(r), a = !!r.breakAfter, {tile: r, index: i} = o.pop(), i++;
		} else {
			let s = r.children[i], c = s.breakAfter;
			(t > 0 ? s.length <= e : s.length < e) && (!n || n.skip(s, 0, s.length) !== !1 || !s.isComposite) ? (a = !!c, i++, e -= s.length) : (o.push({
				tile: r,
				index: i
			}), r = s, i = 0, n && s.isComposite() && n.enter(s));
		}
		return this.tile = r, this.index = i, this.beforeBreak = a, this;
	}
	get root() {
		return this.parents.length ? this.parents[0].tile : this.tile;
	}
}, Qs = class {
	constructor(e, t, n, r) {
		this.from = e, this.to = t, this.wrapper = n, this.rank = r;
	}
}, $s = class {
	constructor(e, t, n) {
		this.cache = e, this.root = t, this.blockWrappers = n, this.curLine = null, this.lastBlock = null, this.afterWidget = null, this.pos = 0, this.wrappers = [], this.wrapperPos = 0;
	}
	addText(e, t, n, r) {
		this.flushBuffer();
		let i = this.ensureMarks(t, n), a = i.lastChild;
		if (a && a.isText() && !(a.flags & 8) && a.length + e.length < 512) {
			this.cache.reused.set(a, 2);
			let t = i.children[i.children.length - 1] = new Js(a.dom, a.text + e);
			t.parent = i;
		} else i.append(r || Js.of(e, this.cache.find(Js)?.dom));
		this.pos += e.length, this.afterWidget = null;
	}
	addComposition(e, t) {
		let n = this.curLine;
		n.dom != t.line.dom && (n.setDOM(this.cache.reused.has(t.line) ? lc(t.line.dom) : t.line.dom), this.cache.reused.set(t.line, 2));
		let r = n;
		for (let e = t.marks.length - 1; e >= 0; e--) {
			let n = t.marks[e], i = r.lastChild;
			if (i instanceof qs && i.mark.eq(n.mark)) i.dom != n.dom && i.setDOM(lc(n.dom)), r = i;
			else {
				if (this.cache.reused.get(n)) {
					let e = zs.get(n.dom);
					e && e.setDOM(lc(n.dom));
				}
				let e = qs.of(n.mark, n.dom);
				r.append(e), r = e;
			}
			this.cache.reused.set(n, 2);
		}
		let i = zs.get(e.text);
		i && this.cache.reused.set(i, 2);
		let a = new Js(e.text, e.text.nodeValue);
		a.flags |= 8, this.pos = e.range.toB, r.append(a);
	}
	addInlineWidget(e, t, n) {
		let r = this.afterWidget && e.flags & 48 && (this.afterWidget.flags & 48) == (e.flags & 48);
		r || this.flushBuffer();
		let i = this.ensureMarks(t, n);
		!r && !(e.flags & 16) && i.append(this.getBuffer(1)), i.append(e), this.pos += e.length, this.afterWidget = e;
	}
	addMark(e, t, n) {
		this.flushBuffer(), this.ensureMarks(t, n).append(e), this.pos += e.length, this.afterWidget = null;
	}
	addBlockWidget(e) {
		this.getBlockPos().append(e), this.pos += e.length, this.lastBlock = e, this.endLine();
	}
	continueWidget(e) {
		let t = this.afterWidget || this.lastBlock;
		t.length += e, this.pos += e;
	}
	addLineStart(e, t) {
		e ||= oc;
		let n = Ws.start(e, t || this.cache.find(Ws)?.dom, !!t);
		this.getBlockPos().append(this.lastBlock = this.curLine = n);
	}
	addLine(e) {
		this.getBlockPos().append(e), this.pos += e.length, this.lastBlock = e, this.endLine();
	}
	addBreak() {
		this.lastBlock.flags |= 1, this.endLine(), this.pos++;
	}
	addLineStartIfNotCovered(e) {
		this.blockPosCovered() || this.addLineStart(e);
	}
	ensureLine(e) {
		this.curLine || this.addLineStart(e);
	}
	ensureMarks(e, t) {
		let n = this.curLine;
		for (let r = e.length - 1; r >= 0; r--) {
			let i = e[r], a;
			if (t > 0 && (a = n.lastChild) && a instanceof qs && a.mark.eq(i)) n = a, t--;
			else {
				let e = qs.of(i, this.cache.find(qs, (e) => e.mark.eq(i))?.dom);
				n.append(e), n = e, t = 0;
			}
		}
		return n;
	}
	endLine() {
		if (this.curLine) {
			this.flushBuffer();
			let e = this.curLine.lastChild;
			(!e || !ic(this.curLine, !1) || e.dom.nodeName != "BR" && e.isWidget() && !(G.ios && ic(this.curLine, !0))) && this.curLine.append(this.cache.findWidget(dc, 0, 32) || new Ys(dc.toDOM(), 0, dc, 32)), this.curLine = this.afterWidget = null;
		}
	}
	updateBlockWrappers() {
		this.wrapperPos > this.pos + 1e4 && (this.blockWrappers.goto(this.pos), this.wrappers.length = 0);
		for (let e = this.wrappers.length - 1; e >= 0; e--) this.wrappers[e].to < this.pos && this.wrappers.splice(e, 1);
		for (let e = this.blockWrappers; e.value && e.from <= this.pos; e.next()) if (e.to >= this.pos) {
			let t = e.rank * 102 + e.value.rank, n = new Qs(e.from, e.to, e.value, t), r = this.wrappers.length;
			for (; r > 0 && (this.wrappers[r - 1].rank - n.rank || this.wrappers[r - 1].to - n.to) < 0;) r--;
			this.wrappers.splice(r, 0, n);
		}
		this.wrapperPos = this.pos;
	}
	getBlockPos() {
		this.updateBlockWrappers();
		let e = this.root;
		for (let t of this.wrappers) {
			let n = e.lastChild;
			if (t.from < this.pos && n instanceof Us && n.wrapper.eq(t.wrapper)) e = n;
			else {
				let n = Us.of(t.wrapper, this.cache.find(Us, (e) => e.wrapper.eq(t.wrapper))?.dom);
				e.append(n), e = n;
			}
		}
		return e;
	}
	blockPosCovered() {
		let e = this.lastBlock;
		return e != null && !e.breakAfter && (!e.isWidget() || (e.flags & 160) > 0);
	}
	getBuffer(e) {
		let t = 2 | (e < 0 ? 16 : 32), n = this.cache.find(Xs, void 0, 1);
		return n && (n.flags = t), n || new Xs(t);
	}
	flushBuffer() {
		this.afterWidget && !(this.afterWidget.flags & 32) && (this.afterWidget.parent.append(this.getBuffer(-1)), this.afterWidget = null);
	}
}, ec = class {
	constructor(e) {
		this.skipCount = 0, this.text = "", this.textOff = 0, this.cursor = e.iter();
	}
	skip(e) {
		this.textOff + e <= this.text.length ? this.textOff += e : (this.skipCount += e - (this.text.length - this.textOff), this.text = "", this.textOff = 0);
	}
	next(e) {
		if (this.textOff == this.text.length) {
			let { value: t, lineBreak: n, done: r } = this.cursor.next(this.skipCount);
			if (this.skipCount = 0, r) throw Error("Ran out of text content when drawing inline views");
			this.text = t;
			let i = this.textOff = Math.min(e, t.length);
			return n ? null : t.slice(0, i);
		}
		let t = Math.min(this.text.length, this.textOff + e), n = this.text.slice(this.textOff, t);
		return this.textOff = t, n;
	}
}, tc = [
	Ys,
	Ws,
	Js,
	qs,
	Xs,
	Us,
	Hs
];
for (let e = 0; e < tc.length; e++) tc[e].bucket = e;
var nc = class {
	constructor(e) {
		this.view = e, this.buckets = tc.map(() => []), this.index = tc.map(() => 0), this.reused = /* @__PURE__ */ new Map();
	}
	add(e) {
		let t = e.constructor.bucket, n = this.buckets[t];
		n.length < 6 ? n.push(e) : n[this.index[t] = (this.index[t] + 1) % 6] = e;
	}
	find(e, t, n = 2) {
		let r = e.bucket, i = this.buckets[r], a = this.index[r];
		for (let e = i.length - 1; e >= 0; e--) {
			let o = (e + a) % i.length, s = i[o];
			if ((!t || t(s)) && !this.reused.has(s)) return i.splice(o, 1), o < a && this.index[r]--, this.reused.set(s, n), s;
		}
		return null;
	}
	findWidget(e, t, n) {
		let r = this.buckets[0];
		if (r.length) for (let i = 0, a = 0;; i++) {
			if (i == r.length) {
				if (a) return null;
				a = 1, i = 0;
			}
			let o = r[i];
			if (!this.reused.has(o) && (a == 0 ? o.widget.compare(e) : o.widget.constructor == e.constructor && e.updateDOM(o.dom, this.view, o.widget))) return r.splice(i, 1), i < this.index[0] && this.index[0]--, o.widget == e && o.length == t && (o.flags & 497) == n ? (this.reused.set(o, 1), o) : (this.reused.set(o, 2), new Ys(o.dom, t, e, o.flags & -498 | n));
		}
	}
	reuse(e) {
		return this.reused.set(e, 1), e;
	}
	maybeReuse(e, t = 2) {
		if (!this.reused.has(e)) return this.reused.set(e, t), e.dom;
	}
	clear() {
		for (let e = 0; e < this.buckets.length; e++) this.buckets[e].length = this.index[e] = 0;
	}
}, rc = class {
	constructor(e, t, n, r, i) {
		this.view = e, this.decorations = r, this.disallowBlockEffectsFor = i, this.openWidget = !1, this.openMarks = 0, this.cache = new nc(e), this.text = new ec(e.state.doc), this.builder = new $s(this.cache, new Hs(e, e.contentDOM), aa.iter(n)), this.cache.reused.set(t, 2), this.old = new Zs(t), this.reuseWalker = {
			skip: (e, t, n) => {
				if (this.cache.add(e), e.isComposite()) return !1;
			},
			enter: (e) => this.cache.add(e),
			leave: () => {},
			break: () => {}
		};
	}
	run(e, t) {
		let n = t && this.getCompositionContext(t.text);
		for (let r = 0, i = 0, a = 0;;) {
			let o = a < e.length ? e[a++] : null, s = o ? o.fromA : this.old.root.length;
			if (s > r) {
				let e = s - r;
				this.preserve(e, !a, !o), r = s, i += e;
			}
			if (!o) break;
			t && o.fromA <= t.range.fromA && o.toA >= t.range.toA ? (this.forward(o.fromA, t.range.fromA, t.range.fromA < t.range.toA ? 1 : -1), this.emit(i, t.range.fromB), this.builder.flushBuffer(), this.cache.clear(), this.builder.addComposition(t, n), this.text.skip(t.range.toB - t.range.fromB), this.forward(t.range.fromA, o.toA), this.emit(t.range.toB, o.toB)) : (this.forward(o.fromA, o.toA), this.emit(i, o.toB)), i = o.toB, r = o.toA;
		}
		return this.builder.curLine && this.builder.endLine(), this.builder.root;
	}
	preserve(e, t, n) {
		let r = cc(this.old), i = this.openMarks;
		this.old.advance(e, n ? 1 : -1, {
			skip: (e, t, n) => {
				if (e.isWidget()) if (this.openWidget) this.builder.continueWidget(n - t);
				else {
					let a = n > 0 || t < e.length ? Ys.of(e.widget, this.view, n - t, e.flags & 496, this.cache.maybeReuse(e)) : this.cache.reuse(e);
					a.flags & 256 ? (a.flags &= -2, this.builder.addBlockWidget(a)) : (this.builder.ensureLine(null), this.builder.addInlineWidget(a, r, i), i = r.length);
				}
				else if (e.isText()) this.builder.ensureLine(null), !t && n == e.length && !this.cache.reused.has(e) ? this.builder.addText(e.text, r, i, this.cache.reuse(e)) : (this.cache.add(e), this.builder.addText(e.text.slice(t, n), r, i)), i = r.length;
				else if (e.isLine()) e.flags &= -2, this.cache.reused.set(e, 1), this.builder.addLine(e);
				else if (e instanceof Xs) this.cache.add(e);
				else if (e instanceof qs) this.builder.ensureLine(null), this.builder.addMark(e, r, i), this.cache.reused.set(e, 1), i = r.length;
				else return !1;
				this.openWidget = !1;
			},
			enter: (e) => {
				e.isLine() ? this.builder.addLineStart(e.attrs, this.cache.maybeReuse(e)) : (this.cache.add(e), e instanceof qs && r.unshift(e.mark)), this.openWidget = !1;
			},
			leave: (e) => {
				e.isLine() ? r.length &&= i = 0 : e instanceof qs && (r.shift(), i = Math.min(i, r.length));
			},
			break: () => {
				this.builder.addBreak(), this.openWidget = !1;
			}
		}), this.text.skip(e);
	}
	emit(e, t) {
		let n = null, r = this.builder, i = 0, a = aa.spans(this.decorations, e, t, {
			point: (e, t, a, o, s, c) => {
				if (a instanceof ro) {
					if (this.disallowBlockEffectsFor[c]) {
						if (a.block) throw RangeError("Block decorations may not be specified via plugins");
						if (t > this.view.state.doc.lineAt(e).to) throw RangeError("Decorations that replace line breaks may not be specified via plugins");
					}
					if (i = o.length, s > o.length) r.continueWidget(t - e);
					else {
						let i = a.widget || (a.block ? uc.block : uc.inline), c = ac(a), l = this.cache.findWidget(i, t - e, c) || Ys.of(i, this.view, t - e, c);
						a.block ? (a.startSide > 0 && r.addLineStartIfNotCovered(n), r.addBlockWidget(l)) : (r.ensureLine(n), r.addInlineWidget(l, o, s));
					}
					n = null;
				} else n = sc(n, a);
				t > e && this.text.skip(t - e);
			},
			span: (e, t, i, a) => {
				for (let o = e; o < t;) {
					let s = this.text.next(Math.min(512, t - o));
					s == null ? (r.addLineStartIfNotCovered(n), r.addBreak(), o++) : (r.ensureLine(n), r.addText(s, i, o == e ? a : i.length), o += s.length), n = null;
				}
			}
		});
		this.openWidget = a > i, this.openWidget || r.addLineStartIfNotCovered(n), this.openMarks = a;
	}
	forward(e, t, n = 1) {
		t - e <= 10 ? this.old.advance(t - e, n, this.reuseWalker) : (this.old.advance(5, -1, this.reuseWalker), this.old.advance(t - e - 10, -1), this.old.advance(5, n, this.reuseWalker));
	}
	getCompositionContext(e) {
		let t = [], n = null;
		for (let r = e.parentNode;; r = r.parentNode) {
			let e = zs.get(r);
			if (r == this.view.contentDOM) break;
			e instanceof qs ? t.push(e) : e?.isLine() ? n = e : e instanceof Us || (r.nodeName == "DIV" && !n && r != this.view.contentDOM ? n = new Ws(r, oc) : n || t.push(qs.of(new to({
				tagName: r.nodeName.toLowerCase(),
				attributes: Qa(r)
			}), r)));
		}
		return {
			line: n,
			marks: t
		};
	}
};
function ic(e, t) {
	let n = (e) => {
		for (let r of e.children) if ((t ? r.isText() : r.length) || n(r)) return !0;
		return !1;
	};
	return n(e);
}
function ac(e) {
	let t = e.isReplace ? (e.startSide < 0 ? 64 : 0) | (e.endSide > 0 ? 128 : 0) : e.startSide > 0 ? 32 : 16;
	return e.block && (t |= 256), t;
}
var oc = { class: "cm-line" };
function sc(e, t) {
	let n = t.spec.attributes, r = t.spec.class;
	return !n && !r ? e : (e ||= { class: "cm-line" }, n && qa(n, e), r && (e.class += " " + r), e);
}
function cc(e) {
	let t = [];
	for (let n = e.parents.length; n > 1; n--) {
		let r = n == e.parents.length ? e.tile : e.parents[n].tile;
		r instanceof qs && t.push(r.mark);
	}
	return t;
}
function lc(e) {
	let t = zs.get(e);
	return t && t.setDOM(e.cloneNode()), e;
}
var uc = class extends $a {
	constructor(e) {
		super(), this.tag = e;
	}
	eq(e) {
		return e.tag == this.tag;
	}
	toDOM() {
		return document.createElement(this.tag);
	}
	updateDOM(e) {
		return e.nodeName.toLowerCase() == this.tag;
	}
	get isHidden() {
		return !0;
	}
};
uc.inline = /*@__PURE__*/ new uc("span"), uc.block = /*@__PURE__*/ new uc("div");
var dc = /*@__PURE__*/ new class extends $a {
	toDOM() {
		return document.createElement("br");
	}
	get isHidden() {
		return !0;
	}
	get editable() {
		return !0;
	}
}(), fc = class {
	constructor(e) {
		this.view = e, this.decorations = [], this.blockWrappers = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.editContextFormatting = K.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.updateDeco(), this.tile = new Hs(e, e.contentDOM), this.updateInner([new Is(0, 0, 0, e.state.doc.length)], null);
	}
	update(e) {
		let t = e.changedRanges;
		this.minWidth > 0 && t.length && (t.every(({ fromA: e, toA: t }) => t < this.minWidthFrom || e > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
		let n = -1;
		this.view.inputState.composing >= 0 && !this.view.observer.editContext && (this.domChanged?.newSel ? n = this.domChanged.newSel.head : !Cc(e.changes, this.hasComposition) && !e.selectionSet && (n = e.state.selection.main.head));
		let r = n > -1 ? gc(this.view, e.changes, n) : null;
		if (this.domChanged = null, this.hasComposition) {
			let { from: n, to: r } = this.hasComposition;
			t = new Is(n, r, e.changes.mapPos(n, -1), e.changes.mapPos(r, 1)).addToSet(t.slice());
		}
		this.hasComposition = r ? {
			from: r.range.fromB,
			to: r.range.toB
		} : null, (G.ie || G.chrome) && !r && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
		let i = this.decorations, a = this.blockWrappers;
		this.updateDeco();
		let o = yc(i, this.decorations, e.changes);
		o.length && (t = Is.extendWithRanges(t, o));
		let s = xc(a, this.blockWrappers, e.changes);
		return s.length && (t = Is.extendWithRanges(t, s)), r && !t.some((e) => e.fromA <= r.range.fromA && e.toA >= r.range.toA) && (t = r.range.addToSet(t.slice())), this.tile.flags & 2 && t.length == 0 ? !1 : (this.updateInner(t, r), e.transactions.length && (this.lastUpdate = Date.now()), !0);
	}
	updateInner(e, t) {
		this.view.viewState.mustMeasureContent = !0;
		let { observer: n } = this.view;
		n.ignore(() => {
			if (t || e.length) {
				let n = this.tile, r = new rc(this.view, n, this.blockWrappers, this.decorations, this.dynamicDecorationMap);
				t && zs.get(t.text) && r.cache.reused.set(zs.get(t.text), 2), this.tile = r.run(e, t), pc(n, r.cache.reused);
			}
			this.tile.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.tile.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
			let r = G.chrome || G.ios ? {
				node: n.selectionRange.focusNode,
				written: !1
			} : void 0;
			this.tile.sync(r), r && (r.written || n.selectionRange.focusNode != r.node || !this.tile.dom.contains(r.node)) && (this.forceSelection = !0), this.tile.dom.style.height = "";
		});
		let r = [];
		if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) for (let e of this.tile.children) e.isWidget() && e.widget instanceof wc && r.push(e.dom);
		n.updateGaps(r);
	}
	updateEditContextFormatting(e) {
		this.editContextFormatting = this.editContextFormatting.map(e.changes);
		for (let t of e.transactions) for (let e of t.effects) e.is(vs) && (this.editContextFormatting = e.value);
	}
	updateSelection(e = !1, t = !1) {
		(e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
		let { dom: n } = this.tile, r = this.view.root.activeElement, i = r == n, a = !i && !(this.view.state.facet(bs) || n.tabIndex > -1) && uo(n, this.view.observer.selectionRange) && !(r && n.contains(r));
		if (!(i || t || a)) return;
		let o = this.forceSelection;
		this.forceSelection = !1;
		let s = this.view.state.selection.main, c, l;
		if (s.empty ? l = c = this.inlineDOMNearPos(s.anchor, s.assoc || 1) : (l = this.inlineDOMNearPos(s.head, s.head == s.from ? 1 : -1), c = this.inlineDOMNearPos(s.anchor, s.anchor == s.from ? 1 : -1)), G.gecko && s.empty && !this.hasComposition && mc(c)) {
			let e = document.createTextNode("");
			this.view.observer.ignore(() => c.node.insertBefore(e, c.node.childNodes[c.offset] || null)), c = l = new Po(e, 0), o = !0;
		}
		let u = this.view.observer.selectionRange;
		(o || !u.focusNode || (!po(c.node, c.offset, u.anchorNode, u.anchorOffset) || !po(l.node, l.offset, u.focusNode, u.focusOffset)) && !this.suppressWidgetCursorChange(u, s)) && (this.view.observer.ignore(() => {
			G.android && G.chrome && n.contains(u.focusNode) && Sc(u.focusNode, n) && (n.blur(), n.focus({ preventScroll: !0 }));
			let e = co(this.view.root);
			if (e) if (s.empty) {
				if (G.gecko) {
					let e = _c(c.node, c.offset);
					if (e && e != 3) {
						let t = (e == 1 ? Mo : No)(c.node, c.offset);
						t && (c = new Po(t.node, t.offset));
					}
				}
				e.collapse(c.node, c.offset), s.bidiLevel != null && e.caretBidiLevel !== void 0 && (e.caretBidiLevel = s.bidiLevel);
			} else if (e.extend) {
				e.collapse(c.node, c.offset);
				try {
					e.extend(l.node, l.offset);
				} catch {}
			} else {
				let t = document.createRange();
				s.anchor > s.head && ([c, l] = [l, c]), t.setEnd(l.node, l.offset), t.setStart(c.node, c.offset), e.removeAllRanges(), e.addRange(t);
			}
			a && this.view.root.activeElement == n && (n.blur(), r && r.focus());
		}), this.view.observer.setSelectionRange(c, l)), this.impreciseAnchor = c.precise ? null : new Po(u.anchorNode, u.anchorOffset), this.impreciseHead = l.precise ? null : new Po(u.focusNode, u.focusOffset);
	}
	suppressWidgetCursorChange(e, t) {
		return this.hasComposition && t.empty && po(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == t.head;
	}
	enforceCursorAssoc() {
		if (this.hasComposition) return;
		let { view: e } = this, t = e.state.selection.main, n = co(e.root), { anchorNode: r, anchorOffset: i } = e.observer.selectionRange;
		if (!n || !t.empty || !t.assoc || !n.modify) return;
		let a = this.lineAt(t.head, t.assoc);
		if (!a) return;
		let o = a.posAtStart;
		if (t.head == o || t.head == o + a.length) return;
		let s = this.coordsAt(t.head, -1), c = this.coordsAt(t.head, 1);
		if (!s || !c || s.bottom > c.top) return;
		let l = this.domAtPos(t.head + t.assoc, t.assoc);
		n.collapse(l.node, l.offset), n.modify("move", t.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
		let u = e.observer.selectionRange;
		e.docView.posFromDOM(u.anchorNode, u.anchorOffset) != t.from && n.collapse(r, i);
	}
	posFromDOM(e, t) {
		let n = this.tile.nearest(e);
		if (!n) return this.tile.dom.compareDocumentPosition(e) & 2 ? 0 : this.view.state.doc.length;
		let r = n.posAtStart;
		if (n.isComposite()) {
			let i;
			if (e == n.dom) i = n.dom.childNodes[t];
			else {
				let r = _o(e) == 0 ? 0 : t == 0 ? -1 : 1;
				for (;;) {
					let t = e.parentNode;
					if (t == n.dom) break;
					r == 0 && t.firstChild != t.lastChild && (r = e == t.firstChild ? -1 : 1), e = t;
				}
				i = r < 0 ? e : e.nextSibling;
			}
			if (i == n.dom.firstChild) return r;
			for (; i && !zs.get(i);) i = i.nextSibling;
			if (!i) return r + n.length;
			for (let e = 0, t = r;; e++) {
				let r = n.children[e];
				if (r.dom == i) return t;
				t += r.length + r.breakAfter;
			}
		} else if (n.isText()) return e == n.dom ? r + t : r + (t ? n.length : 0);
		else return r;
	}
	domAtPos(e, t) {
		let { tile: n, offset: r } = this.tile.resolveBlock(e, t);
		return n.isWidget() ? n.domPosFor(e, t) : n.domIn(r, t);
	}
	inlineDOMNearPos(e, t) {
		let n, r = -1, i = !1, a, o = -1, s = !1;
		return this.tile.blockTiles((t, c) => {
			if (t.isWidget()) {
				if (t.flags & 32 && c >= e) return !0;
				t.flags & 16 && (i = !0);
			} else {
				let l = c + t.length;
				if (c <= e && (n = t, r = e - c, i = l < e), l >= e && !a && (a = t, o = e - c, s = c > e), c > e && a) return !0;
			}
		}), !n && !a ? this.domAtPos(e, t) : (i && a ? n = null : s && n && (a = null), n && t < 0 || !a ? n.domIn(r, t) : a.domIn(o, t));
	}
	coordsAt(e, t) {
		let { tile: n, offset: r } = this.tile.resolveBlock(e, t);
		return n.isWidget() ? n.widget instanceof wc ? null : n.coordsInWidget(r, t, !0) : n.coordsIn(r, t);
	}
	lineAt(e, t) {
		let { tile: n } = this.tile.resolveBlock(e, t);
		return n.isLine() ? n : null;
	}
	coordsForChar(e) {
		let { tile: t, offset: n } = this.tile.resolveBlock(e, 1);
		if (!t.isLine()) return null;
		function r(e, t) {
			if (e.isComposite()) for (let n of e.children) {
				if (n.length >= t) {
					let e = r(n, t);
					if (e) return e;
				}
				if (t -= n.length, t < 0) break;
			}
			else if (e.isText() && t < e.length) {
				let n = Gr(e.text, t);
				if (n == t) return null;
				let r = Do(e.dom, t, n).getClientRects();
				for (let e = 0; e < r.length; e++) {
					let t = r[e];
					if (e == r.length - 1 || t.top < t.bottom && t.left < t.right) return t;
				}
			}
			return null;
		}
		return r(t, n);
	}
	measureVisibleLineHeights(e) {
		let t = [], { from: n, to: r } = e, i = this.view.contentDOM.clientWidth, a = i > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, o = -1, s = this.view.textDirection == Fo.LTR, c = 0, l = (e, u, d) => {
			for (let f = 0; f < e.children.length && !(u > r); f++) {
				let r = e.children[f], p = u + r.length, m = r.dom.getBoundingClientRect(), { height: h } = m;
				if (d && !f && (c += m.top - d.top), r instanceof Us) p > n && l(r, u, m);
				else if (u >= n && (c > 0 && t.push(-c), t.push(h + c), c = 0, a)) {
					let e = r.dom.lastChild, t = e ? fo(e) : [];
					if (t.length) {
						let e = t[t.length - 1], n = s ? e.right - m.left : m.right - e.left;
						n > o && (o = n, this.minWidth = i, this.minWidthFrom = u, this.minWidthTo = p);
					}
				}
				d && f == e.children.length - 1 && (c += d.bottom - m.bottom), u = p + r.breakAfter;
			}
		};
		return l(this.tile, 0, null), t;
	}
	textDirectionAt(e) {
		let { tile: t } = this.tile.resolveBlock(e, 1);
		return getComputedStyle(t.dom).direction == "rtl" ? Fo.RTL : Fo.LTR;
	}
	measureTextSize() {
		let e = this.tile.blockTiles((e) => {
			if (e.isLine() && e.children.length && e.length <= 20) {
				let t = 0, n;
				for (let r of e.children) {
					if (!r.isText() || /[^ -~]/.test(r.text)) return;
					let e = fo(r.dom);
					if (e.length != 1) return;
					t += e[0].width, n = e[0].height;
				}
				if (t) return {
					lineHeight: e.dom.getBoundingClientRect().height,
					charWidth: t / e.length,
					textHeight: n
				};
			}
		});
		if (e) return e;
		let t = document.createElement("div"), n, r, i;
		return t.className = "cm-line", t.style.width = "99999px", t.style.position = "absolute", t.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
			this.tile.dom.appendChild(t);
			let e = fo(t.firstChild)[0];
			n = t.getBoundingClientRect().height, r = e && e.width ? e.width / 27 : 7, i = e && e.height ? e.height : n, t.remove();
		}), {
			lineHeight: n,
			charWidth: r,
			textHeight: i
		};
	}
	computeBlockGapDeco() {
		let e = [], t = this.view.viewState;
		for (let n = 0, r = 0;; r++) {
			let i = r == t.viewports.length ? null : t.viewports[r], a = i ? i.from - 1 : this.view.state.doc.length;
			if (a > n) {
				let r = (t.lineBlockAt(a).bottom - t.lineBlockAt(n).top) / this.view.scaleY;
				e.push(K.replace({
					widget: new wc(r),
					block: !0,
					inclusive: !0,
					isBlockGap: !0
				}).range(n, a));
			}
			if (!i) break;
			n = i.to + 1;
		}
		return K.set(e);
	}
	updateDeco() {
		let e = 1, t = this.view.state.facet(Ds).map((t) => (this.dynamicDecorationMap[e++] = typeof t == "function") ? t(this.view) : t), n = !1, r = this.view.state.facet(ks).map((e, t) => {
			let r = typeof e == "function";
			return r && (n = !0), r ? e(this.view) : e;
		});
		for (r.length && (this.dynamicDecorationMap[e++] = n, t.push(aa.join(r))), this.decorations = [
			this.editContextFormatting,
			...t,
			this.computeBlockGapDeco(),
			this.view.viewState.lineGapDeco
		]; e < this.decorations.length;) this.dynamicDecorationMap[e++] = !1;
		this.blockWrappers = this.view.state.facet(Os).map((e) => typeof e == "function" ? e(this.view) : e);
	}
	scrollIntoView(e) {
		if (e.isSnapshot) {
			let t = this.view.viewState.lineBlockAt(e.range.head);
			this.view.scrollDOM.scrollTop = t.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
			return;
		}
		for (let t of this.view.state.facet(hs)) try {
			if (t(this.view, e.range, e)) return !0;
		} catch (e) {
			ys(this.view.state, e, "scroll handler");
		}
		let { range: t } = e, n = this.coordsAt(t.head, t.assoc ?? (t.empty ? 0 : t.head > t.anchor ? -1 : 1)), r;
		if (!n) return;
		!t.empty && (r = this.coordsAt(t.anchor, t.anchor > t.head ? -1 : 1)) && (n = {
			left: Math.min(n.left, r.left),
			top: Math.min(n.top, r.top),
			right: Math.max(n.right, r.right),
			bottom: Math.max(n.bottom, r.bottom)
		});
		let i = Ps(this.view), a = {
			left: n.left - i.left,
			top: n.top - i.top,
			right: n.right + i.right,
			bottom: n.bottom + i.bottom
		}, { offsetWidth: o, offsetHeight: s } = this.view.scrollDOM;
		if (xo(this.view.scrollDOM, a, t.head < t.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, o), -o), Math.max(Math.min(e.yMargin, s), -s), this.view.textDirection == Fo.LTR), window.visualViewport && window.innerHeight - window.visualViewport.height > 1 && (n.top > window.pageYOffset + window.visualViewport.offsetTop + window.visualViewport.height || n.bottom < window.pageYOffset + window.visualViewport.offsetTop)) {
			let e = this.view.docView.lineAt(t.head, 1);
			e && e.dom.scrollIntoView({ block: "nearest" });
		}
	}
	lineHasWidget(e) {
		let t = (e) => e.isWidget() || e.children.some(t);
		return t(this.tile.resolveBlock(e, 1).tile);
	}
	destroy() {
		pc(this.tile);
	}
};
function pc(e, t) {
	let n = t?.get(e);
	if (n != 1) {
		n ?? e.destroy();
		for (let n of e.children) pc(n, t);
	}
}
function mc(e) {
	return e.node.nodeType == 1 && e.node.firstChild && (e.offset == 0 || e.node.childNodes[e.offset - 1].contentEditable == "false") && (e.offset == e.node.childNodes.length || e.node.childNodes[e.offset].contentEditable == "false");
}
function hc(e, t) {
	let n = e.observer.selectionRange;
	if (!n.focusNode) return null;
	let r = Mo(n.focusNode, n.focusOffset), i = No(n.focusNode, n.focusOffset), a = r || i;
	if (i && r && i.node != r.node) {
		let t = zs.get(i.node);
		if (!t || t.isText() && t.text != i.node.nodeValue) a = i;
		else if (e.docView.lastCompositionAfterCursor) {
			let e = zs.get(r.node);
			!e || e.isText() && e.text != r.node.nodeValue || (a = i);
		}
	}
	if (e.docView.lastCompositionAfterCursor = a != r, !a) return null;
	let o = t - a.offset;
	return {
		from: o,
		to: o + a.node.nodeValue.length,
		node: a.node
	};
}
function gc(e, t, n) {
	let r = hc(e, n);
	if (!r) return null;
	let { node: i, from: a, to: o } = r, s = i.nodeValue;
	if (/[\n\r]/.test(s) || e.state.doc.sliceString(r.from, r.to) != s) return null;
	let c = t.invertedDesc;
	return {
		range: new Is(c.mapPos(a), c.mapPos(o), a, o),
		text: i
	};
}
function _c(e, t) {
	return e.nodeType == 1 ? (t && e.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < e.childNodes.length && e.childNodes[t].contentEditable == "false" ? 2 : 0) : 0;
}
var vc = class {
	constructor() {
		this.changes = [];
	}
	compareRange(e, t) {
		oo(e, t, this.changes);
	}
	comparePoint(e, t) {
		oo(e, t, this.changes);
	}
	boundChange(e) {
		oo(e, e, this.changes);
	}
};
function yc(e, t, n) {
	let r = new vc();
	return aa.compare(e, t, n, r), r.changes;
}
var bc = class {
	constructor() {
		this.changes = [];
	}
	compareRange(e, t) {
		oo(e, t, this.changes);
	}
	comparePoint() {}
	boundChange(e) {
		oo(e, e, this.changes);
	}
};
function xc(e, t, n) {
	let r = new bc();
	return aa.compare(e, t, n, r), r.changes;
}
function Sc(e, t) {
	for (let n = e; n && n != t; n = n.assignedSlot || n.parentNode) if (n.nodeType == 1 && n.contentEditable == "false") return !0;
	return !1;
}
function Cc(e, t) {
	let n = !1;
	return t && e.iterChangedRanges((e, r) => {
		e < t.to && r > t.from && (n = !0);
	}), n;
}
var wc = class extends $a {
	constructor(e) {
		super(), this.height = e;
	}
	toDOM() {
		let e = document.createElement("div");
		return e.className = "cm-gap", this.updateDOM(e), e;
	}
	eq(e) {
		return e.height == this.height;
	}
	updateDOM(e) {
		return e.style.height = this.height + "px", !0;
	}
	get editable() {
		return !0;
	}
	get estimatedHeight() {
		return this.height;
	}
	ignoreEvent() {
		return !1;
	}
};
function Tc(e, t, n = 1) {
	let r = e.charCategorizer(t), i = e.doc.lineAt(t), a = t - i.from;
	if (i.length == 0) return U.cursor(t);
	a == 0 ? n = 1 : a == i.length && (n = -1);
	let o = a, s = a;
	n < 0 ? o = Gr(i.text, a, !1) : s = Gr(i.text, a);
	let c = r(i.text.slice(o, s));
	for (; o > 0;) {
		let e = Gr(i.text, o, !1);
		if (r(i.text.slice(e, o)) != c) break;
		o = e;
	}
	for (; s < i.length;) {
		let e = Gr(i.text, s);
		if (r(i.text.slice(s, e)) != c) break;
		s = e;
	}
	return U.undirectionalRange(o + i.from, s + i.from);
}
function Ec(e, t, n, r, i) {
	let a = Math.round((r - t.left) * e.defaultCharacterWidth);
	if (e.lineWrapping && n.height > e.defaultLineHeight * 1.5) {
		let t = e.viewState.heightOracle.textHeight, r = Math.floor((i - n.top - (e.defaultLineHeight - t) * .5) / t);
		a += r * e.viewState.heightOracle.lineLength;
	}
	let o = e.state.sliceDoc(n.from, n.to);
	return n.from + ya(o, a, e.state.tabSize);
}
function Dc(e, t, n) {
	let r = e.lineBlockAt(t);
	if (Array.isArray(r.type)) {
		let e;
		for (let i of r.type) {
			if (i.from > t) break;
			if (!(i.to < t)) {
				if (i.from < t && i.to > t) return i;
				(!e || i.type == eo.Text && (e.type != i.type || (n < 0 ? i.from < t : i.to > t))) && (e = i);
			}
		}
		return e || r;
	}
	return r;
}
function Oc(e, t, n, r) {
	let i = Dc(e, t.head, t.assoc || -1), a = !r || i.type != eo.Text || !(e.lineWrapping || i.widgetLineBreaks) ? null : e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head);
	if (a) {
		let t = e.dom.getBoundingClientRect(), r = e.textDirectionAt(i.from), o = e.posAtCoords({
			x: n == (r == Fo.LTR) ? t.right - 1 : t.left + 1,
			y: (a.top + a.bottom) / 2
		});
		if (o != null) return U.cursor(o, n ? -1 : 1);
	}
	return U.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function kc(e, t, n, r) {
	let i = e.state.doc.lineAt(t.head), a = e.bidiSpans(i), o = e.textDirectionAt(i.from);
	for (let s = t, c = null;;) {
		let t = ns(i, a, o, s, n), l = ts;
		if (!t) {
			if (i.number == (n ? e.state.doc.lines : 1)) return s;
			l = "\n", i = e.state.doc.line(i.number + (n ? 1 : -1)), a = e.bidiSpans(i), t = e.visualLineSide(i, !n);
		}
		if (!c) {
			if (!r) return t;
			c = r(l);
		} else if (!c(l)) return s;
		s = t;
	}
}
function Ac(e, t, n) {
	let r = e.state.charCategorizer(t), i = r(n);
	return (e) => {
		let t = r(e);
		return i == qi.Space && (i = t), i == t;
	};
}
function jc(e, t, n, r) {
	let i = t.head, a = n ? 1 : -1;
	if (i == (n ? e.state.doc.length : 0)) return U.cursor(i, t.assoc);
	let o = t.goalColumn, s, c = e.contentDOM.getBoundingClientRect(), l = e.coordsAtPos(i, t.assoc || ((t.empty ? n : t.head == t.from) ? 1 : -1)), u = e.documentTop;
	if (l) o ??= l.left - c.left, s = a < 0 ? l.top : l.bottom;
	else {
		let t = e.viewState.lineBlockAt(i);
		o ??= Math.min(c.right - c.left, e.defaultCharacterWidth * (i - t.from)), s = (a < 0 ? t.top : t.bottom) + u;
	}
	let d = c.left + o, f = e.viewState.heightOracle.textHeight >> 1, p = r ?? f;
	for (let t = 0;; t += f) {
		let r = s + (p + t) * a, i = Ic(e, {
			x: d,
			y: r
		}, !1, a);
		if (n ? r > c.bottom : r < c.top) return U.cursor(i.pos, i.assoc);
		let l = e.coordsAtPos(i.pos, i.assoc), u = l ? (l.top + l.bottom) / 2 : 0;
		if (!l || (n ? u > s : u < s)) return U.cursor(i.pos, i.assoc, void 0, o);
	}
}
function Mc(e, t, n) {
	for (;;) {
		let r = 0;
		for (let i of e) i.between(t - 1, t + 1, (e, i, a) => {
			if (t > e && t < i) {
				let a = r || n || (t - e < i - t ? -1 : 1);
				t = a < 0 ? e : i, r = a;
			}
		});
		if (!r) return t;
	}
}
function Nc(e, t) {
	let n = null;
	for (let r = 0; r < t.ranges.length; r++) {
		let i = t.ranges[r], a = null;
		if (i.empty) {
			let t = Mc(e, i.from, 0);
			t != i.from && (a = U.cursor(t, -1));
		} else {
			let t = Mc(e, i.from, -1), n = Mc(e, i.to, 1);
			(t != i.from || n != i.to) && (a = i.undirectional ? U.undirectionalRange(i.from, i.to) : U.range(i.from == i.anchor ? t : n, i.from == i.head ? t : n));
		}
		a && (n ||= t.ranges.slice(), n[r] = a);
	}
	return n ? U.create(n, t.mainIndex) : t;
}
function Pc(e, t, n) {
	let r = Mc(e.state.facet(As).map((t) => t(e)), n.from, t.head > n.from ? -1 : 1);
	return r == n.from ? n : U.cursor(r, r < n.from ? 1 : -1);
}
var Fc = class {
	constructor(e, t) {
		this.pos = e, this.assoc = t;
	}
};
function Ic(e, t, n, r) {
	let i = e.contentDOM.getBoundingClientRect(), a = i.top + e.viewState.paddingTop, { x: o, y: s } = t, c = s - a, l;
	for (;;) {
		if (c < 0) return new Fc(0, 1);
		if (c > e.viewState.docHeight) return new Fc(e.state.doc.length, -1);
		if (l = e.elementAtHeight(c), r == null) break;
		if (l.type == eo.Text) {
			if (r < 0 ? l.to < e.viewport.from : l.from > e.viewport.to) break;
			let t = e.docView.coordsAt(r < 0 ? l.from : l.to, r > 0 ? -1 : 1);
			if (t && (r < 0 ? t.top <= c + a : t.bottom >= c + a)) break;
		}
		let t = e.viewState.heightOracle.textHeight / 2;
		c = r > 0 ? l.bottom + t : l.top - t;
	}
	if (e.viewport.from >= l.to || e.viewport.to <= l.from) {
		if (n) return null;
		if (l.type == eo.Text) {
			let t = Ec(e, i, l, o, s);
			return new Fc(t, t == l.from ? 1 : -1);
		}
	}
	if (l.type != eo.Text) return c < (l.top + l.bottom) / 2 ? new Fc(l.from, 1) : new Fc(l.to, -1);
	let u = e.docView.lineAt(l.from, 2);
	return (!u || u.length != l.length) && (u = e.docView.lineAt(l.from, -2)), new Lc(e, o, s, e.textDirectionAt(l.from)).scanTile(u, l.from);
}
var Lc = class {
	constructor(e, t, n, r) {
		this.view = e, this.x = t, this.y = n, this.baseDir = r, this.line = null, this.spans = null;
	}
	bidiSpansAt(e) {
		return (!this.line || this.line.from > e || this.line.to < e) && (this.line = this.view.state.doc.lineAt(e), this.spans = this.view.bidiSpans(this.line)), this;
	}
	baseDirAt(e, t) {
		let { line: n, spans: r } = this.bidiSpansAt(e);
		return r[Go.find(r, e - n.from, -1, t)].level == this.baseDir;
	}
	dirAt(e, t) {
		let { line: n, spans: r } = this.bidiSpansAt(e);
		return r[Go.find(r, e - n.from, -1, t)].dir;
	}
	bidiIn(e, t) {
		let { spans: n, line: r } = this.bidiSpansAt(e);
		return n.length > 1 || n.length && (n[0].level != this.baseDir || n[0].to + r.from < t);
	}
	scan(e, t, n = !1) {
		let r = 0, i = e.length - 1, a = /* @__PURE__ */ new Set(), o = this.bidiIn(e[0], e[i]), s, c, l = -1, u = 1e9, d;
		search: for (; r < i;) {
			let n = i - r, f = r + i >> 1;
			adjust: if (a.has(f)) {
				let e = r + Math.floor(Math.random() * n);
				for (let t = 0; t < n; t++) {
					if (!a.has(e)) {
						f = e;
						break adjust;
					}
					e++, e == i && (e = r);
				}
				break search;
			}
			a.add(f);
			let p = t(f);
			if (p) for (let t = 0; t < p.length; t++) {
				let n = p[t], a = 0;
				if (!(n.width == 0 && p.length > 1)) {
					if (n.bottom < this.y) (!s || s.bottom < n.bottom) && (s = n), a = 1;
					else if (n.top > this.y) (!c || c.top > n.top) && (c = n), a = -1;
					else {
						let e = n.left > this.x ? this.x - n.left : n.right < this.x ? this.x - n.right : 0, t = Math.abs(e);
						t < u && (l = f, u = t, d = n), e && (a = e < 0 == (this.baseDir == Fo.LTR) ? -1 : 1);
					}
					a == -1 && (!o || this.baseDirAt(e[f], 1)) ? i = f : a == 1 && (!o || this.baseDirAt(e[f + 1], -1)) && (r = f + 1);
				}
			}
		}
		if (!d) {
			if (!c && !s) return {
				i: e[0],
				after: !1
			};
			let n = s && (!c || this.y - s.bottom < c.top - this.y) ? s : c;
			return this.y = (n.top + n.bottom) / 2, this.scan(e, t, !0);
		}
		if (u && !n) {
			let { top: n, bottom: r } = d;
			if (s && s.bottom > (n + n + r) / 3) return this.y = s.bottom - 1, this.scan(e, t, !0);
			if (c && c.top < (n + r + r) / 3) return this.y = c.top + 1, this.scan(e, t, !0);
		}
		let f = (o ? this.dirAt(e[l], 1) : this.baseDir) == Fo.LTR;
		return {
			i: l,
			after: this.x > (d.left + d.right) / 2 == f
		};
	}
	scanText(e, t) {
		let n = [];
		for (let r = 0; r < e.length; r = Gr(e.text, r)) n.push(t + r);
		n.push(t + e.length);
		let r = this.scan(n, (r) => {
			let i = n[r] - t, a = n[r + 1] - t;
			return Do(e.dom, i, a).getClientRects();
		});
		return r.after ? new Fc(n[r.i + 1], -1) : new Fc(n[r.i], 1);
	}
	scanTile(e, t) {
		if (!e.length) return new Fc(t, 1);
		if (e.children.length == 1) {
			let n = e.children[0];
			if (n.isText()) return this.scanText(n, t);
			if (n.isComposite()) return this.scanTile(n, t);
		}
		let n = [t];
		for (let r = 0, i = t; r < e.children.length; r++) n.push(i += e.children[r].length);
		let r = this.scan(n, (t) => {
			let n = e.children[t];
			return n.flags & 48 ? null : (n.dom.nodeType == 1 ? n.dom : Do(n.dom, 0, n.length)).getClientRects();
		}), i = e.children[r.i], a = n[r.i];
		return i.isText() ? this.scanText(i, a) : i.isComposite() ? this.scanTile(i, a) : r.after ? new Fc(n[r.i + 1], -1) : new Fc(a, 1);
	}
}, Rc = "￿", zc = class {
	constructor(e, t) {
		this.points = e, this.view = t, this.text = "", this.lineSeparator = t.state.facet(Qi.lineSeparator);
	}
	append(e) {
		this.text += e;
	}
	lineBreak() {
		this.text += Rc;
	}
	readRange(e, t) {
		if (!e) return this;
		let n = e.parentNode;
		for (let r = e;;) {
			this.findPointBefore(n, r);
			let e = this.text.length;
			this.readNode(r);
			let i = zs.get(r), a = r.nextSibling;
			if (a == t) {
				i?.breakAfter && !a && n != this.view.contentDOM && this.lineBreak();
				break;
			}
			let o = zs.get(a);
			(i && o ? i.breakAfter : (i ? i.breakAfter : ho(r)) || ho(a) && (r.nodeName != "BR" || i?.isWidget()) && this.text.length > e) && !Vc(a, t) && this.lineBreak(), r = a;
		}
		return this.findPointBefore(n, t), this;
	}
	readTextNode(e) {
		let t = e.nodeValue;
		for (let n of this.points) n.node == e && (n.pos = this.text.length + Math.min(n.offset, t.length));
		for (let n = 0, r = this.lineSeparator ? null : /\r\n?|\n/g;;) {
			let i = -1, a = 1, o;
			if (this.lineSeparator ? (i = t.indexOf(this.lineSeparator, n), a = this.lineSeparator.length) : (o = r.exec(t)) && (i = o.index, a = o[0].length), this.append(t.slice(n, i < 0 ? t.length : i)), i < 0) break;
			if (this.lineBreak(), a > 1) for (let t of this.points) t.node == e && t.pos > this.text.length && (t.pos -= a - 1);
			n = i + a;
		}
	}
	readNode(e) {
		let t = zs.get(e), n = t && t.overrideDOMText;
		if (n != null) {
			this.findPointInside(e, n.length);
			for (let e = n.iter(); !e.next().done;) e.lineBreak ? this.lineBreak() : this.append(e.value);
		} else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
	}
	findPointBefore(e, t) {
		for (let n of this.points) n.node == e && e.childNodes[n.offset] == t && (n.pos = this.text.length);
	}
	findPointInside(e, t) {
		for (let n of this.points) (e.nodeType == 3 ? n.node == e : e.contains(n.node)) && (n.pos = this.text.length + (Bc(e, n.node, n.offset) ? t : 0));
	}
};
function Bc(e, t, n) {
	for (;;) {
		if (!t || n < _o(t)) return !1;
		if (t == e) return !0;
		n = mo(t) + 1, t = t.parentNode;
	}
}
function Vc(e, t) {
	let n;
	for (; !(e == t || !e); e = e.nextSibling) {
		let t = zs.get(e);
		if (!t?.isWidget()) return !1;
		t && (n ||= []).push(t);
	}
	if (n) {
		for (let e of n) if (e.overrideDOMText?.length) return !1;
	}
	return !0;
}
var Hc = class {
	constructor(e, t) {
		this.node = e, this.offset = t, this.pos = -1;
	}
}, Uc = class {
	constructor(e, t, n, r) {
		this.typeOver = r, this.bounds = null, this.text = "", this.domChanged = t > -1;
		let { impreciseHead: i, impreciseAnchor: a } = e.docView, o = e.state.selection;
		if (e.state.readOnly && t > -1) this.newSel = null;
		else if (t > -1 && (this.bounds = Wc(e.docView.tile, t, n, 0))) {
			let t = i || a ? [] : Yc(e), n = new zc(t, e);
			n.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = n.text, this.newSel = Xc(t, this.bounds.from);
		} else {
			let t = e.observer.selectionRange, n = i && i.node == t.focusNode && i.offset == t.focusOffset || !lo(e.contentDOM, t.focusNode) ? o.main.head : e.docView.posFromDOM(t.focusNode, t.focusOffset), r = a && a.node == t.anchorNode && a.offset == t.anchorOffset || !lo(e.contentDOM, t.anchorNode) ? o.main.anchor : e.docView.posFromDOM(t.anchorNode, t.anchorOffset), s = e.viewport;
			if ((G.ios || G.chrome) && n != r && Math.min(n, r) <= o.main.from && Math.max(n, r) >= o.main.to && (s.from > 0 || s.to < e.state.doc.length)) {
				let t = Math.min(n, r), i = Math.max(n, r), a = s.from - t, o = s.to - i;
				(a == 0 || a == 1 || t == 0) && (o == 0 || o == -1 || i == e.state.doc.length) && (n = 0, r = e.state.doc.length);
			}
			if (e.inputState.composing > -1 && o.ranges.length > 1) this.newSel = o.replaceRange(U.range(r, n));
			else if (e.lineWrapping && r == n && !(o.main.empty && o.main.head == n) && e.inputState.lastTouchTime > Date.now() - 100) {
				let t = e.coordsAtPos(n, -1), r = 0;
				t && (r = e.inputState.lastTouchY <= t.bottom ? -1 : 1), this.newSel = U.create([U.cursor(n, r)]);
			} else this.newSel = U.single(r, n);
		}
	}
};
function Wc(e, t, n, r) {
	if (e.isComposite()) {
		let i = -1, a = -1, o = -1, s = -1;
		for (let c = 0, l = r, u = r; c < e.children.length; c++) {
			let r = e.children[c], d = l + r.length;
			if (l < t && d > n) return Wc(r, t, n, l);
			if (d >= t && i == -1 && (i = c, a = l), l > n && r.dom.parentNode == e.dom) {
				o = c, s = u;
				break;
			}
			u = d, l = d + r.breakAfter;
		}
		return {
			from: a,
			to: s < 0 ? r + e.length : s,
			startDOM: (i ? e.children[i - 1].dom.nextSibling : null) || e.dom.firstChild,
			endDOM: o < e.children.length && o >= 0 ? e.children[o].dom : null
		};
	} else if (e.isText()) return {
		from: r,
		to: r + e.length,
		startDOM: e.dom,
		endDOM: e.dom.nextSibling
	};
	else return null;
}
function Gc(e, t) {
	let n, { newSel: r } = t, { state: i } = e, a = i.selection.main, o = e.inputState.lastKeyTime > Date.now() - 100 ? e.inputState.lastKeyCode : -1;
	if (t.bounds) {
		let { from: e, to: r } = t.bounds, s = a.from, c = null;
		(o === 8 || G.android && t.text.length < r - e) && (s = a.to, c = "end");
		let l = i.doc.sliceString(e, r, Rc), u, d;
		!a.empty && a.from >= e && a.to <= r && (t.typeOver || l != t.text) && l.slice(0, a.from - e) == t.text.slice(0, a.from - e) && l.slice(a.to - e) == t.text.slice(u = t.text.length - (l.length - (a.to - e))) ? n = {
			from: a.from,
			to: a.to,
			insert: Pr.of(t.text.slice(a.from - e, u).split(Rc))
		} : (d = Jc(l, t.text, s - e, c)) && (G.chrome && o == 13 && d.toB == d.from + 2 && t.text.slice(d.from, d.toB) == "￿￿" && d.toB--, n = {
			from: e + d.from,
			to: e + d.toA,
			insert: Pr.of(t.text.slice(d.from, d.toB).split(Rc))
		});
	} else r && (!e.hasFocus && i.facet(bs) || Zc(r, a)) && (r = null);
	if (!n && !r) return !1;
	if ((G.mac || G.android) && n && n.from == n.to && n.from == a.head - 1 && /^\. ?$/.test(n.insert.toString()) && e.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = U.single(r.main.anchor - 1, r.main.head - 1)), n = {
		from: n.from,
		to: n.to,
		insert: Pr.of([n.insert.toString().replace(".", " ")])
	}) : i.doc.lineAt(a.from).to < a.to && e.docView.lineHasWidget(a.to) && e.inputState.insertingTextAt > Date.now() - 50 ? n = {
		from: a.from,
		to: a.to,
		insert: i.toText(e.inputState.insertingText)
	} : G.chrome && n && n.from == n.to && n.from == a.head && n.insert.toString() == "\n " && e.lineWrapping && (r &&= U.single(r.main.anchor - 1, r.main.head - 1), n = {
		from: a.from,
		to: a.to,
		insert: Pr.of([" "])
	}), n) return Kc(e, n, r, o);
	if (r && !Zc(r, a)) {
		let t = !1, n = "select";
		return e.inputState.lastSelectionTime > Date.now() - 50 && (e.inputState.lastSelectionOrigin == "select" && (t = !0), n = e.inputState.lastSelectionOrigin, n == "select.pointer" && (r = Nc(i.facet(As).map((t) => t(e)), r))), e.dispatch({
			selection: r,
			scrollIntoView: t,
			userEvent: n
		}), !0;
	} else return !1;
}
function Kc(e, t, n, r = -1) {
	if (G.ios && e.inputState.flushIOSKey(t)) return !0;
	let i = e.state.selection.main;
	if (G.android && (t.to == i.to && (t.from == i.from || t.from == i.from - 1 && e.state.sliceDoc(t.from, i.from) == " ") && t.insert.length == 1 && t.insert.lines == 2 && Oo(e.contentDOM, "Enter", 13) || (t.from == i.from - 1 && t.to == i.to && t.insert.length == 0 || r == 8 && t.insert.length < t.to - t.from && t.to > i.head) && Oo(e.contentDOM, "Backspace", 8) || t.from == i.from && t.to == i.to + 1 && t.insert.length == 0 && Oo(e.contentDOM, "Delete", 46))) return !0;
	let a = t.insert.toString();
	e.inputState.composing >= 0 && e.inputState.composing++;
	let o, s = () => o ||= qc(e, t, n);
	return e.state.facet(ls).some((n) => n(e, t.from, t.to, a, s)) || e.dispatch(s()), !0;
}
function qc(e, t, n) {
	let r, i = e.state, a = i.selection.main, o = -1;
	if (t.from == t.to && t.from < a.from || t.from > a.to) {
		let n = t.from < a.from ? -1 : 1, r = n < 0 ? a.from : a.to, s = Mc(i.facet(As).map((t) => t(e)), r, n);
		t.from == s && (o = s);
	}
	if (o > -1) r = {
		changes: t,
		selection: U.cursor(t.from + t.insert.length, -1)
	};
	else if (t.from >= a.from && t.to <= a.to && t.to - t.from >= (a.to - a.from) / 3 && (!n || n.main.empty && n.main.from == t.from + t.insert.length) && e.inputState.composing < 0) {
		let n = a.from < t.from ? i.sliceDoc(a.from, t.from) : "", o = a.to > t.to ? i.sliceDoc(t.to, a.to) : "";
		r = i.replaceSelection(e.state.toText(n + t.insert.sliceString(0, void 0, e.state.lineBreak) + o));
	} else {
		let o = i.changes(t), s = n && n.main.to <= o.newLength ? n.main : void 0;
		if (i.selection.ranges.length > 1 && (e.inputState.composing >= 0 || e.inputState.compositionPendingChange) && t.to <= a.to + 10 && t.to >= a.to - 10) {
			let c = e.state.sliceDoc(t.from, t.to), l, u = n && hc(e, n.main.head);
			if (u) {
				let e = t.insert.length - (t.to - t.from);
				l = {
					from: u.from,
					to: u.to - e
				};
			} else l = e.state.doc.lineAt(a.head);
			let d = a.to - t.to;
			r = i.changeByRange((n) => {
				if (n.from == a.from && n.to == a.to) return {
					changes: o,
					range: s || n.map(o)
				};
				let r = n.to - d, u = r - c.length;
				if (e.state.sliceDoc(u, r) != c || r >= l.from && u <= l.to) return { range: n };
				let f = i.changes({
					from: u,
					to: r,
					insert: t.insert
				}), p = n.to - a.to;
				return {
					changes: f,
					range: s ? U.range(Math.max(0, s.anchor + p), Math.max(0, s.head + p)) : n.map(f)
				};
			});
		} else r = {
			changes: o,
			selection: s && i.selection.replaceRange(s)
		};
	}
	let s = "input.type";
	return (e.composing || e.inputState.compositionPendingChange && e.inputState.compositionEndedAt > Date.now() - 50) && (e.inputState.compositionPendingChange = !1, s += ".compose", e.inputState.compositionFirstChange && (s += ".start", e.inputState.compositionFirstChange = !1)), i.update(r, {
		userEvent: s,
		scrollIntoView: !0
	});
}
function Jc(e, t, n, r) {
	let i = Math.min(e.length, t.length), a = 0;
	for (; a < i && e.charCodeAt(a) == t.charCodeAt(a);) a++;
	if (a == i && e.length == t.length) return null;
	let o = e.length, s = t.length;
	for (; o > 0 && s > 0 && e.charCodeAt(o - 1) == t.charCodeAt(s - 1);) o--, s--;
	if (r == "end") {
		let e = Math.max(0, a - Math.min(o, s));
		n -= o + e - a;
	}
	if (o < a && e.length < t.length) {
		let e = n <= a && n >= o ? a - n : 0;
		a -= e, s = a + (s - o), o = a;
	} else if (s < a) {
		let e = n <= a && n >= s ? a - n : 0;
		a -= e, o = a + (o - s), s = a;
	}
	return {
		from: a,
		toA: o,
		toB: s
	};
}
function Yc(e) {
	let t = [];
	if (e.root.activeElement != e.contentDOM) return t;
	let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: a } = e.observer.selectionRange;
	return n && (t.push(new Hc(n, r)), (i != n || a != r) && t.push(new Hc(i, a))), t;
}
function Xc(e, t) {
	if (e.length == 0) return null;
	let n = e[0].pos, r = e.length == 2 ? e[1].pos : n;
	return n > -1 && r > -1 ? U.single(n + t, r + t) : null;
}
function Zc(e, t) {
	return t.head == e.main.head && t.anchor == e.main.anchor;
}
var Qc = class {
	setSelectionOrigin(e) {
		this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
	}
	constructor(e) {
		this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastTouchX = 0, this.lastTouchY = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.lastWheelEvent = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.insertingText = "", this.insertingTextAt = 0, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, G.safari && e.contentDOM.addEventListener("input", () => null), G.gecko && Fl(e.contentDOM.ownerDocument);
	}
	handleEvent(e) {
		!fl(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || (this.view.updateState == 0 ? this.runHandlers(e.type, e) : Promise.resolve().then(() => this.runHandlers(e.type, e)));
	}
	runHandlers(e, t) {
		let n = this.handlers[e];
		if (n) {
			for (let e of n.observers) e(this.view, t);
			for (let e of n.handlers) {
				if (t.defaultPrevented) break;
				if (e(this.view, t)) {
					t.preventDefault();
					break;
				}
			}
		}
	}
	ensureHandlers(e) {
		let t = tl(e), n = this.handlers, r = this.view.contentDOM;
		for (let e in t) if (e != "scroll") {
			let i = !t[e].handlers.length, a = n[e];
			a && i != !a.handlers.length && (r.removeEventListener(e, this.handleEvent), a = null), a || r.addEventListener(e, this.handleEvent, { passive: i });
		}
		for (let e in n) e != "scroll" && !t[e] && r.removeEventListener(e, this.handleEvent);
		this.handlers = t;
	}
	keydown(e) {
		if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return !0;
		if (this.tabFocusMode > 0 && e.keyCode != 27 && il.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), G.android && G.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8)) return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
		if (G.ios && !e.synthetic && !e.altKey && !e.metaKey && (nl.some((t) => t.keyCode == e.keyCode) && !e.ctrlKey || rl.indexOf(e.key) > -1 && e.ctrlKey)) {
			let t = {
				ctrlKey: e.ctrlKey,
				altKey: e.altKey,
				metaKey: e.metaKey,
				shiftKey: e.shiftKey
			};
			return t.shiftKey && G.ios && !/^(off|none)$/.test(this.view.contentDOM.autocapitalize) && $c(this.view.win) && (t.shiftKey = !1), this.pendingIOSKey = {
				key: e.key,
				keyCode: e.keyCode,
				mods: t
			}, setTimeout(() => this.flushIOSKey(), 250), !0;
		}
		return e.keyCode != 229 && this.view.observer.forceFlush(), !1;
	}
	flushIOSKey(e) {
		let t = this.pendingIOSKey;
		return !t || t.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, Oo(this.view.contentDOM, t.key, t.keyCode, t.mods));
	}
	ignoreDuringComposition(e) {
		return !/^key/.test(e.type) || e.synthetic ? !1 : this.composing > 0 ? !0 : G.safari && !G.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1;
	}
	startMouseSelection(e) {
		this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
	}
	update(e) {
		this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
	}
	destroy() {
		this.mouseSelection && this.mouseSelection.destroy();
	}
};
function $c(e) {
	return e.visualViewport ? e.visualViewport.height * e.visualViewport.scale / e.document.documentElement.clientHeight < .85 : !1;
}
function el(e, t) {
	return (n, r) => {
		try {
			return t.call(e, r, n);
		} catch (e) {
			ys(n.state, e);
		}
	};
}
function tl(e) {
	let t = Object.create(null);
	function n(e) {
		return t[e] || (t[e] = {
			observers: [],
			handlers: []
		});
	}
	for (let t of e) {
		let e = t.spec, r = e && e.plugin.domEventHandlers, i = e && e.plugin.domEventObservers;
		if (r) for (let e in r) {
			let i = r[e];
			i && n(e).handlers.push(el(t.value, i));
		}
		if (i) for (let e in i) {
			let r = i[e];
			r && n(e).observers.push(el(t.value, r));
		}
	}
	for (let e in pl) n(e).handlers.push(pl[e]);
	for (let e in ml) n(e).observers.push(ml[e]);
	return t;
}
var nl = [
	{
		key: "Backspace",
		keyCode: 8,
		inputType: "deleteContentBackward"
	},
	{
		key: "Enter",
		keyCode: 13,
		inputType: "insertParagraph"
	},
	{
		key: "Enter",
		keyCode: 13,
		inputType: "insertLineBreak"
	},
	{
		key: "Delete",
		keyCode: 46,
		inputType: "deleteContentForward"
	}
], rl = "dthko", il = [
	16,
	17,
	18,
	20,
	91,
	92,
	224,
	225
], al = 6;
function ol(e) {
	return Math.max(0, e) * .7 + 8;
}
function sl(e, t) {
	return Math.max(Math.abs(e.clientX - t.clientX), Math.abs(e.clientY - t.clientY));
}
var cl = class {
	constructor(e, t, n, r) {
		this.view = e, this.startEvent = t, this.style = n, this.mustSelect = r, this.scrollSpeed = {
			x: 0,
			y: 0
		}, this.scrolling = -1, this.lastEvent = t, this.scrollParents = So(e.contentDOM), this.atoms = e.state.facet(As).map((t) => t(e));
		let i = e.contentDOM.ownerDocument;
		i.addEventListener("mousemove", this.move = this.move.bind(this)), i.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = t.shiftKey, this.multiple = e.state.facet(Qi.allowMultipleSelections) && ll(e, t), this.dragging = dl(e, t) && wl(t) == 1 ? null : !1;
	}
	start(e) {
		this.dragging === !1 && this.select(e);
	}
	move(e) {
		if (e.buttons == 0) return this.destroy();
		if (this.dragging || this.dragging == null && sl(this.startEvent, e) < 10) return;
		this.select(this.lastEvent = e);
		let t = 0, n = 0, r = 0, i = 0, a = this.view.win.innerWidth, o = this.view.win.innerHeight;
		this.scrollParents.x && ({left: r, right: a} = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({top: i, bottom: o} = this.scrollParents.y.getBoundingClientRect());
		let s = Ps(this.view);
		e.clientX - s.left <= r + al ? t = -ol(r - e.clientX) : e.clientX + s.right >= a - al && (t = ol(e.clientX - a)), e.clientY - s.top <= i + al ? n = -ol(i - e.clientY) : e.clientY + s.bottom >= o - al && (n = ol(e.clientY - o)), this.setScrollSpeed(t, n);
	}
	up(e) {
		this.dragging ?? this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
	}
	destroy() {
		this.setScrollSpeed(0, 0);
		let e = this.view.contentDOM.ownerDocument;
		e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
	}
	setScrollSpeed(e, t) {
		this.scrollSpeed = {
			x: e,
			y: t
		}, e || t ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
	}
	scroll() {
		let { x: e, y: t } = this.scrollSpeed;
		e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), t && this.scrollParents.y && (this.scrollParents.y.scrollTop += t, t = 0), (e || t) && this.view.win.scrollBy(e, t), this.dragging === !1 && this.select(this.lastEvent);
	}
	select(e) {
		let { view: t } = this, n = Nc(this.atoms, this.style.get(e, this.extend, this.multiple));
		(this.mustSelect || !n.eq(t.state.selection, this.dragging === !1)) && this.view.dispatch({
			selection: n,
			userEvent: "select.pointer"
		}), this.mustSelect = !1;
	}
	update(e) {
		e.transactions.some((e) => e.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
	}
};
function ll(e, t) {
	let n = e.state.facet(is);
	return n.length ? n[0](t) : G.mac ? t.metaKey : t.ctrlKey;
}
function ul(e, t) {
	let n = e.state.facet(as);
	return n.length ? n[0](t) : G.mac ? !t.altKey : !t.ctrlKey;
}
function dl(e, t) {
	let { main: n } = e.state.selection;
	if (n.empty) return !1;
	let r = co(e.root);
	if (!r || r.rangeCount == 0) return !0;
	let i = r.getRangeAt(0).getClientRects();
	for (let e = 0; e < i.length; e++) {
		let n = i[e];
		if (n.left <= t.clientX && n.right >= t.clientX && n.top <= t.clientY && n.bottom >= t.clientY) return !0;
	}
	return !1;
}
function fl(e, t) {
	if (!t.bubbles) return !0;
	if (t.defaultPrevented) return !1;
	for (let n = t.target, r; n != e.contentDOM; n = n.parentNode) if (!n || n.nodeType == 11 || (r = zs.get(n)) && r.isWidget() && !r.isHidden && r.widget.ignoreEvent(t)) return !1;
	return !0;
}
var pl = /*@__PURE__*/ Object.create(null), ml = /*@__PURE__*/ Object.create(null), hl = G.ie && G.ie_version < 15 || G.ios && G.webkit_version < 604;
function gl(e) {
	let t = e.dom.parentNode;
	if (!t) return;
	let n = t.appendChild(document.createElement("textarea"));
	n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
		e.focus(), n.remove(), vl(e, n.value);
	}, 50);
}
function _l(e, t, n) {
	for (let r of e.facet(t)) n = r(n, e);
	return n;
}
function vl(e, t) {
	t = _l(e.state, ds, t);
	let { state: n } = e, r, i = 1, a = n.toText(t), o = a.lines == n.selection.ranges.length;
	if (Al != null && n.selection.ranges.every((e) => e.empty) && Al == a.toString()) {
		let e = -1;
		r = n.changeByRange((r) => {
			let s = n.doc.lineAt(r.from);
			if (s.from == e) return { range: r };
			e = s.from;
			let c = n.toText((o ? a.line(i++).text : t) + n.lineBreak);
			return {
				changes: {
					from: s.from,
					insert: c
				},
				range: U.cursor(r.from + c.length)
			};
		});
	} else r = o ? n.changeByRange((e) => {
		let t = a.line(i++);
		return {
			changes: {
				from: e.from,
				to: e.to,
				insert: t.text
			},
			range: U.cursor(e.from + t.length)
		};
	}) : n.replaceSelection(a);
	e.dispatch(r, {
		userEvent: "input.paste",
		scrollIntoView: !0
	});
}
ml.scroll = (e) => {
	e.inputState.lastScrollTop = e.scrollDOM.scrollTop, e.inputState.lastScrollLeft = e.scrollDOM.scrollLeft;
}, ml.wheel = ml.mousewheel = (e) => {
	e.inputState.lastWheelEvent = Date.now();
}, pl.keydown = (e, t) => (e.inputState.setSelectionOrigin("select"), t.keyCode == 27 && e.inputState.tabFocusMode != 0 && (e.inputState.tabFocusMode = Date.now() + 2e3), !1), ml.touchstart = (e, t) => {
	let n = e.inputState, r = t.targetTouches[0];
	n.lastTouchTime = Date.now(), r && (n.lastTouchX = r.clientX, n.lastTouchY = r.clientY), n.setSelectionOrigin("select.pointer");
}, ml.touchmove = (e) => {
	e.inputState.setSelectionOrigin("select.pointer");
}, pl.mousedown = (e, t) => {
	if (e.observer.flush(), e.inputState.lastTouchTime > Date.now() - 2e3) return !1;
	let n = null;
	for (let r of e.state.facet(os)) if (n = r(e, t), n) break;
	if (!n && t.button == 0 && (n = Tl(e, t)), n) {
		let r = !e.hasFocus;
		e.inputState.startMouseSelection(new cl(e, t, n, r)), r && e.observer.ignore(() => {
			To(e.contentDOM);
			let t = e.root.activeElement;
			t && !t.contains(e.contentDOM) && t.blur();
		});
		let i = e.inputState.mouseSelection;
		if (i) return i.start(t), i.dragging === !1;
	} else e.inputState.setSelectionOrigin("select.pointer");
	return !1;
};
function yl(e, t, n, r) {
	if (r == 1) return U.cursor(t, n);
	if (r == 2) return Tc(e.state, t, n);
	{
		let r = e.docView.lineAt(t, n), i = e.state.doc.lineAt(r ? r.posAtEnd : t), a = r ? r.posAtStart : i.from, o = r ? r.posAtEnd : i.to;
		return o < e.state.doc.length && o == i.to && o++, U.undirectionalRange(a, o);
	}
}
var bl = G.ie && G.ie_version <= 11, xl = null, Sl = 0, Cl = 0;
function wl(e) {
	if (!bl) return e.detail;
	let t = xl, n = Cl;
	return xl = e, Cl = Date.now(), Sl = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (Sl + 1) % 3 : 1;
}
function Tl(e, t) {
	let n = e.posAndSideAtCoords({
		x: t.clientX,
		y: t.clientY
	}, !1), r = wl(t), i = e.state.selection;
	return {
		update(e) {
			e.docChanged && (n.pos = e.changes.mapPos(n.pos), i = i.map(e.changes));
		},
		get(t, a, o) {
			let s = e.posAndSideAtCoords({
				x: t.clientX,
				y: t.clientY
			}, !1), c, l = yl(e, s.pos, s.assoc, r);
			if (n.pos != s.pos && !a) {
				let t = yl(e, n.pos, n.assoc, r), i = Math.min(t.from, l.from), a = Math.max(t.to, l.to);
				l = i < l.from ? U.range(i, a, l.assoc) : U.range(a, i, l.assoc);
			}
			return a ? i.replaceRange(i.main.extend(l.from, l.to, l.assoc)) : o && r == 1 && i.ranges.length > 1 && (c = El(i, s.pos)) ? c : o ? i.addRange(l) : U.create([l]);
		}
	};
}
function El(e, t) {
	for (let n = 0; n < e.ranges.length; n++) {
		let { from: r, to: i } = e.ranges[n];
		if (r <= t && i >= t) return U.create(e.ranges.slice(0, n).concat(e.ranges.slice(n + 1)), e.mainIndex == n ? 0 : e.mainIndex - +(e.mainIndex > n));
	}
	return null;
}
pl.dragstart = (e, t) => {
	let { selection: { main: n } } = e.state;
	if (t.target.draggable) {
		let r = e.docView.tile.nearest(t.target);
		if (r && r.isWidget()) {
			let e = r.posAtStart, t = e + r.length;
			(e >= n.to || t <= n.from) && (n = U.undirectionalRange(e, t));
		}
	}
	let { inputState: r } = e;
	return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, t.dataTransfer && (t.dataTransfer.setData("Text", _l(e.state, fs, e.state.sliceDoc(n.from, n.to))), t.dataTransfer.effectAllowed = "copyMove"), !1;
}, pl.dragend = (e) => (e.inputState.draggedContent = null, !1);
function Dl(e, t, n, r) {
	if (n = _l(e.state, ds, n), !n) return;
	let i = e.posAtCoords({
		x: t.clientX,
		y: t.clientY
	}, !1), { draggedContent: a } = e.inputState, o = r && a && ul(e, t) ? {
		from: a.from,
		to: a.to
	} : null, s = {
		from: i,
		insert: n
	}, c = e.state.changes(o ? [o, s] : s);
	e.focus(), e.dispatch({
		changes: c,
		selection: {
			anchor: c.mapPos(i, -1),
			head: c.mapPos(i, 1)
		},
		userEvent: o ? "move.drop" : "input.drop"
	}), e.inputState.draggedContent = null;
}
pl.drop = (e, t) => {
	if (!t.dataTransfer) return !1;
	if (e.state.readOnly) return !0;
	let n = t.dataTransfer.files;
	if (n && n.length) {
		let r = Array(n.length), i = 0, a = () => {
			++i == n.length && Dl(e, t, r.filter((e) => e != null).join(e.state.lineBreak), !1);
		};
		for (let e = 0; e < n.length; e++) {
			let t = new FileReader();
			t.onerror = a, t.onload = () => {
				/[\x00-\x08\x0e-\x1f]{2}/.test(t.result) || (r[e] = t.result), a();
			}, t.readAsText(n[e]);
		}
		return !0;
	} else {
		let n = t.dataTransfer.getData("Text");
		if (n) return Dl(e, t, n, !0), !0;
	}
	return !1;
}, pl.paste = (e, t) => {
	if (e.state.readOnly) return !0;
	e.observer.flush();
	let n = hl ? null : t.clipboardData;
	return n ? (vl(e, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (gl(e), !1);
};
function Ol(e, t) {
	let n = e.dom.parentNode;
	if (!n) return;
	let r = n.appendChild(document.createElement("textarea"));
	r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = t, r.focus(), r.selectionEnd = t.length, r.selectionStart = 0, setTimeout(() => {
		r.remove(), e.focus();
	}, 50);
}
function kl(e) {
	let t = [], n = [], r = !1;
	for (let r of e.selection.ranges) r.empty || (t.push(e.sliceDoc(r.from, r.to)), n.push(r));
	if (!t.length) {
		let i = -1;
		for (let { from: r } of e.selection.ranges) {
			let a = e.doc.lineAt(r);
			a.number > i && (t.push(a.text), n.push({
				from: a.from,
				to: Math.min(e.doc.length, a.to + 1)
			})), i = a.number;
		}
		r = !0;
	}
	return {
		text: _l(e, fs, t.join(e.lineBreak)),
		ranges: n,
		linewise: r
	};
}
var Al = null;
pl.copy = pl.cut = (e, t) => {
	if (!uo(e.contentDOM, e.observer.selectionRange)) return !1;
	let { text: n, ranges: r, linewise: i } = kl(e.state);
	if (!n && !i) return !1;
	Al = i ? n : null, t.type == "cut" && !e.state.readOnly && e.dispatch({
		changes: r,
		scrollIntoView: !0,
		userEvent: "delete.cut"
	});
	let a = hl ? null : t.clipboardData;
	return a ? (a.clearData(), a.setData("text/plain", n), !0) : (Ol(e, n), !1);
};
var jl = /*@__PURE__*/ Pi.define();
function Ml(e, t) {
	let n = [];
	for (let r of e.facet(us)) {
		let i = r(e, t);
		i && n.push(i);
	}
	return n.length ? e.update({
		effects: n,
		annotations: jl.of(!0)
	}) : null;
}
function Nl(e) {
	setTimeout(() => {
		let t = e.hasFocus;
		if (t != e.inputState.notifiedFocused) {
			let n = Ml(e.state, t);
			n ? e.dispatch(n) : e.update([]);
		}
	}, 10);
}
ml.focus = (e) => {
	e.inputState.lastFocusTime = Date.now(), !e.scrollDOM.scrollTop && (e.inputState.lastScrollTop || e.inputState.lastScrollLeft) && (e.scrollDOM.scrollTop = e.inputState.lastScrollTop, e.scrollDOM.scrollLeft = e.inputState.lastScrollLeft), Nl(e);
}, ml.blur = (e) => {
	e.observer.clearSelectionRange(), Nl(e);
}, ml.compositionstart = ml.compositionupdate = (e) => {
	e.observer.editContext || (e.inputState.compositionFirstChange ?? (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0));
}, ml.compositionend = (e) => {
	e.observer.editContext || (e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionPendingKey = !0, e.inputState.compositionPendingChange = e.observer.pendingRecords().length > 0, e.inputState.compositionFirstChange = null, G.chrome && G.android ? e.observer.flushSoon() : e.inputState.compositionPendingChange ? Promise.resolve().then(() => e.observer.flush()) : setTimeout(() => {
		e.inputState.composing < 0 && e.docView.hasComposition && e.update([]);
	}, 50));
}, ml.contextmenu = (e) => {
	e.inputState.lastContextMenu = Date.now();
}, pl.beforeinput = (e, t) => {
	if ((t.inputType == "insertText" || t.inputType == "insertCompositionText") && (e.inputState.insertingText = t.data, e.inputState.insertingTextAt = Date.now()), t.inputType == "insertReplacementText" && e.observer.editContext) {
		let n = t.dataTransfer?.getData("text/plain"), r = t.getTargetRanges();
		if (n && r.length) {
			let t = r[0];
			return Kc(e, {
				from: e.posAtDOM(t.startContainer, t.startOffset),
				to: e.posAtDOM(t.endContainer, t.endOffset),
				insert: e.state.toText(n)
			}, null), !0;
		}
	}
	let n;
	if (G.chrome && G.android && (n = nl.find((e) => e.inputType == t.inputType)) && (e.observer.delayAndroidKey(n.key, n.keyCode), n.key == "Backspace" || n.key == "Delete")) {
		let t = window.visualViewport?.height || 0;
		setTimeout(() => {
			(window.visualViewport?.height || 0) > t + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
		}, 100);
	}
	return G.ios && t.inputType == "deleteContentForward" && e.observer.flushSoon(), G.safari && t.inputType == "insertText" && e.inputState.composing >= 0 && setTimeout(() => ml.compositionend(e, t), 20), !1;
};
var Pl = /*@__PURE__*/ new Set();
function Fl(e) {
	Pl.has(e) || (Pl.add(e), e.addEventListener("copy", () => {}), e.addEventListener("cut", () => {}));
}
var Il = [
	"pre-wrap",
	"normal",
	"pre-line",
	"break-spaces"
], Ll = !1;
function Rl() {
	Ll = !1;
}
var zl = class {
	constructor(e) {
		this.lineWrapping = e, this.doc = Pr.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
	}
	heightForGap(e, t) {
		let n = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
		return this.lineWrapping && (n += Math.max(0, Math.ceil((t - e - n * this.lineLength * .5) / this.lineLength))), this.lineHeight * n;
	}
	heightForLine(e) {
		return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / Math.max(1, this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
	}
	setDoc(e) {
		return this.doc = e, this;
	}
	mustRefreshForWrapping(e) {
		return Il.indexOf(e) > -1 != this.lineWrapping;
	}
	mustRefreshForHeights(e) {
		let t = !1;
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			r < 0 ? n++ : this.heightSamples[Math.floor(r * 10)] || (t = !0, this.heightSamples[Math.floor(r * 10)] = !0);
		}
		return t;
	}
	refresh(e, t, n, r, i, a) {
		let o = Il.indexOf(e) > -1, s = Math.abs(t - this.lineHeight) > .3 || this.lineWrapping != o;
		if (this.lineWrapping = o, this.lineHeight = t, this.charWidth = n, this.textHeight = r, this.lineLength = i, s) {
			this.heightSamples = {};
			for (let e = 0; e < a.length; e++) {
				let t = a[e];
				t < 0 ? e++ : this.heightSamples[Math.floor(t * 10)] = !0;
			}
		}
		return s;
	}
}, Bl = class {
	constructor(e, t) {
		this.from = e, this.heights = t, this.index = 0;
	}
	get more() {
		return this.index < this.heights.length;
	}
}, Vl = class e {
	constructor(e, t, n, r, i) {
		this.from = e, this.length = t, this.top = n, this.height = r, this._content = i;
	}
	get type() {
		return typeof this._content == "number" ? eo.Text : Array.isArray(this._content) ? this._content : this._content.type;
	}
	get to() {
		return this.from + this.length;
	}
	get bottom() {
		return this.top + this.height;
	}
	get widget() {
		return this._content instanceof ro ? this._content.widget : null;
	}
	get widgetLineBreaks() {
		return typeof this._content == "number" ? this._content : 0;
	}
	join(t) {
		let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t._content) ? t._content : [t]);
		return new e(this.from, this.length + t.length, this.top, this.height + t.height, n);
	}
}, Hl = /*@__PURE__*/ (function(e) {
	return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
})(Hl ||= {}), Ul = .001, Wl = class e {
	constructor(e, t, n = 2) {
		this.length = e, this.height = t, this.flags = n;
	}
	get outdated() {
		return (this.flags & 2) > 0;
	}
	set outdated(e) {
		this.flags = (e ? 2 : 0) | this.flags & -3;
	}
	setHeight(e) {
		this.height != e && (Math.abs(this.height - e) > Ul && (Ll = !0), this.height = e);
	}
	replace(t, n, r) {
		return e.of(r);
	}
	decomposeLeft(e, t) {
		t.push(this);
	}
	decomposeRight(e, t) {
		t.push(this);
	}
	applyChanges(e, t, n, r) {
		let i = this, a = n.doc;
		for (let o = r.length - 1; o >= 0; o--) {
			let { fromA: s, toA: c, fromB: l, toB: u } = r[o], d = i.lineAt(s, Hl.ByPosNoHeight, n.setDoc(t), 0, 0), f = d.to >= c ? d : i.lineAt(c, Hl.ByPosNoHeight, n, 0, 0);
			for (u += f.to - c, c = f.to; o > 0 && d.from <= r[o - 1].toA;) s = r[o - 1].fromA, l = r[o - 1].fromB, o--, s < d.from && (d = i.lineAt(s, Hl.ByPosNoHeight, n, 0, 0));
			l += d.from - s, s = d.from;
			let p = $l.build(n.setDoc(a), e, l, u);
			i = Gl(i, i.replace(s, c, p));
		}
		return i.updateHeight(n, 0);
	}
	static empty() {
		return new Jl(0, 0, 0);
	}
	static of(t) {
		if (t.length == 1) return t[0];
		let n = 0, r = t.length, i = 0, a = 0;
		for (;;) if (n == r) if (i > a * 2) {
			let e = t[n - 1];
			e.break ? t.splice(--n, 1, e.left, null, e.right) : t.splice(--n, 1, e.left, e.right), r += 1 + e.break, i -= e.size;
		} else if (a > i * 2) {
			let e = t[r];
			e.break ? t.splice(r, 1, e.left, null, e.right) : t.splice(r, 1, e.left, e.right), r += 2 + e.break, a -= e.size;
		} else break;
		else if (i < a) {
			let e = t[n++];
			e && (i += e.size);
		} else {
			let e = t[--r];
			e && (a += e.size);
		}
		let o = 0;
		return t[n - 1] == null ? (o = 1, n--) : t[n] ?? (o = 1, r++), new Xl(e.of(t.slice(0, n)), o, e.of(t.slice(r)));
	}
};
function Gl(e, t) {
	return e == t ? e : (e.constructor != t.constructor && (Ll = !0), t);
}
Wl.prototype.size = 1;
var Kl = /*@__PURE__*/ K.replace({}), ql = class extends Wl {
	constructor(e, t, n) {
		super(e, t), this.deco = n, this.spaceAbove = 0;
	}
	mainBlock(e, t) {
		return new Vl(t, this.length, e + this.spaceAbove, this.height - this.spaceAbove, this.deco || 0);
	}
	blockAt(e, t, n, r) {
		return this.spaceAbove && e < n + this.spaceAbove ? new Vl(r, 0, n, this.spaceAbove, Kl) : this.mainBlock(n, r);
	}
	lineAt(e, t, n, r, i) {
		let a = this.mainBlock(r, i);
		return this.spaceAbove ? this.blockAt(0, n, r, i).join(a) : a;
	}
	forEachLine(e, t, n, r, i, a) {
		e <= i + this.length && t >= i && a(this.lineAt(0, Hl.ByPos, n, r, i));
	}
	setMeasuredHeight(e) {
		let t = e.heights[e.index++];
		t < 0 ? (this.spaceAbove = -t, t = e.heights[e.index++]) : this.spaceAbove = 0, this.setHeight(t);
	}
	updateHeight(e, t = 0, n = !1, r) {
		return r && r.from <= t && r.more && this.setMeasuredHeight(r), this.outdated = !1, this;
	}
	toString() {
		return `block(${this.length})`;
	}
}, Jl = class e extends ql {
	constructor(e, t, n) {
		super(e, t, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0, this.spaceAbove = n;
	}
	mainBlock(e, t) {
		return new Vl(t, this.length, e + this.spaceAbove, this.height - this.spaceAbove, this.breaks);
	}
	replace(t, n, r) {
		let i = r[0];
		return r.length == 1 && (i instanceof e || i instanceof Yl && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof Yl ? i = new e(i.length, this.height, this.spaceAbove) : i.height = this.height, this.outdated || (i.outdated = !1), i) : Wl.of(r);
	}
	updateHeight(e, t = 0, n = !1, r) {
		return r && r.from <= t && r.more ? this.setMeasuredHeight(r) : (n || this.outdated) && (this.spaceAbove = 0, this.setHeight(Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight)), this.outdated = !1, this;
	}
	toString() {
		return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
	}
}, Yl = class e extends Wl {
	constructor(e) {
		super(e, 0);
	}
	heightMetrics(e, t) {
		let n = e.doc.lineAt(t).number, r = e.doc.lineAt(t + this.length).number, i = r - n + 1, a, o = 0;
		if (e.lineWrapping) {
			let t = Math.min(this.height, e.lineHeight * i);
			a = t / i, this.length > i + 1 && (o = (this.height - t) / (this.length - i - 1));
		} else a = this.height / i;
		return {
			firstLine: n,
			lastLine: r,
			perLine: a,
			perChar: o
		};
	}
	blockAt(e, t, n, r) {
		let { firstLine: i, lastLine: a, perLine: o, perChar: s } = this.heightMetrics(t, r);
		if (t.lineWrapping) {
			let i = r + (e < t.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - n) / this.height)) * this.length)), a = t.doc.lineAt(i), c = o + a.length * s, l = Math.max(n, e - c / 2);
			return new Vl(a.from, a.length, l, c, 0);
		} else {
			let r = Math.max(0, Math.min(a - i, Math.floor((e - n) / o))), { from: s, length: c } = t.doc.line(i + r);
			return new Vl(s, c, n + o * r, o, 0);
		}
	}
	lineAt(e, t, n, r, i) {
		if (t == Hl.ByHeight) return this.blockAt(e, n, r, i);
		if (t == Hl.ByPosNoHeight) {
			let { from: t, to: r } = n.doc.lineAt(e);
			return new Vl(t, r - t, 0, 0, 0);
		}
		let { firstLine: a, perLine: o, perChar: s } = this.heightMetrics(n, i), c = n.doc.lineAt(e), l = o + c.length * s, u = c.number - a, d = r + o * u + s * (c.from - i - u);
		return new Vl(c.from, c.length, Math.max(r, Math.min(d, r + this.height - l)), l, 0);
	}
	forEachLine(e, t, n, r, i, a) {
		e = Math.max(e, i), t = Math.min(t, i + this.length);
		let { firstLine: o, perLine: s, perChar: c } = this.heightMetrics(n, i);
		for (let l = e, u = r; l <= t;) {
			let t = n.doc.lineAt(l);
			if (l == e) {
				let n = t.number - o;
				u += s * n + c * (e - i - n);
			}
			let r = s + c * t.length;
			a(new Vl(t.from, t.length, u, r, 0)), u += r, l = t.to + 1;
		}
	}
	replace(t, n, r) {
		let i = this.length - n;
		if (i > 0) {
			let t = r[r.length - 1];
			t instanceof e ? r[r.length - 1] = new e(t.length + i) : r.push(null, new e(i - 1));
		}
		if (t > 0) {
			let n = r[0];
			n instanceof e ? r[0] = new e(t + n.length) : r.unshift(new e(t - 1), null);
		}
		return Wl.of(r);
	}
	decomposeLeft(t, n) {
		n.push(new e(t - 1), null);
	}
	decomposeRight(t, n) {
		n.push(null, new e(this.length - t - 1));
	}
	updateHeight(t, n = 0, r = !1, i) {
		let a = n + this.length;
		if (i && i.from <= n + this.length && i.more) {
			let r = [], o = Math.max(n, i.from), s = -1;
			for (i.from > n && r.push(new e(i.from - n - 1).updateHeight(t, n)); o <= a && i.more;) {
				let e = t.doc.lineAt(o).length;
				r.length && r.push(null);
				let n = i.heights[i.index++], a = 0;
				n < 0 && (a = -n, n = i.heights[i.index++]), s == -1 ? s = n : Math.abs(n - s) >= Ul && (s = -2);
				let c = new Jl(e, n, a);
				c.outdated = !1, r.push(c), o += e + 1;
			}
			o <= a && r.push(null, new e(a - o).updateHeight(t, o));
			let c = Wl.of(r);
			return (s < 0 || Math.abs(c.height - this.height) >= Ul || Math.abs(s - this.heightMetrics(t, n).perLine) >= Ul) && (Ll = !0), Gl(this, c);
		} else (r || this.outdated) && (this.setHeight(t.heightForGap(n, n + this.length)), this.outdated = !1);
		return this;
	}
	toString() {
		return `gap(${this.length})`;
	}
}, Xl = class extends Wl {
	constructor(e, t, n) {
		super(e.length + t + n.length, e.height + n.height, t | (e.outdated || n.outdated ? 2 : 0)), this.left = e, this.right = n, this.size = e.size + n.size;
	}
	get break() {
		return this.flags & 1;
	}
	blockAt(e, t, n, r) {
		let i = n + this.left.height;
		return e < i ? this.left.blockAt(e, t, n, r) : this.right.blockAt(e, t, i, r + this.left.length + this.break);
	}
	lineAt(e, t, n, r, i) {
		let a = r + this.left.height, o = i + this.left.length + this.break, s = t == Hl.ByHeight ? e < a : e < o, c = s ? this.left.lineAt(e, t, n, r, i) : this.right.lineAt(e, t, n, a, o);
		if (this.break || (s ? c.to < o : c.from > o)) return c;
		let l = t == Hl.ByPosNoHeight ? Hl.ByPosNoHeight : Hl.ByPos;
		return s ? c.join(this.right.lineAt(o, l, n, a, o)) : this.left.lineAt(o, l, n, r, i).join(c);
	}
	forEachLine(e, t, n, r, i, a) {
		let o = r + this.left.height, s = i + this.left.length + this.break;
		if (this.break) e < s && this.left.forEachLine(e, t, n, r, i, a), t >= s && this.right.forEachLine(e, t, n, o, s, a);
		else {
			let c = this.lineAt(s, Hl.ByPos, n, r, i);
			e < c.from && this.left.forEachLine(e, c.from - 1, n, r, i, a), c.to >= e && c.from <= t && a(c), t > c.to && this.right.forEachLine(c.to + 1, t, n, o, s, a);
		}
	}
	replace(e, t, n) {
		let r = this.left.length + this.break;
		if (t < r) return this.balanced(this.left.replace(e, t, n), this.right);
		if (e > this.left.length) return this.balanced(this.left, this.right.replace(e - r, t - r, n));
		let i = [];
		e > 0 && this.decomposeLeft(e, i);
		let a = i.length;
		for (let e of n) i.push(e);
		if (e > 0 && Zl(i, a - 1), t < this.length) {
			let e = i.length;
			this.decomposeRight(t, i), Zl(i, e);
		}
		return Wl.of(i);
	}
	decomposeLeft(e, t) {
		let n = this.left.length;
		if (e <= n) return this.left.decomposeLeft(e, t);
		t.push(this.left), this.break && (n++, e >= n && t.push(null)), e > n && this.right.decomposeLeft(e - n, t);
	}
	decomposeRight(e, t) {
		let n = this.left.length, r = n + this.break;
		if (e >= r) return this.right.decomposeRight(e - r, t);
		e < n && this.left.decomposeRight(e, t), this.break && e < r && t.push(null), t.push(this.right);
	}
	balanced(e, t) {
		return e.size > 2 * t.size || t.size > 2 * e.size ? Wl.of(this.break ? [
			e,
			null,
			t
		] : [e, t]) : (this.left = Gl(this.left, e), this.right = Gl(this.right, t), this.setHeight(e.height + t.height), this.outdated = e.outdated || t.outdated, this.size = e.size + t.size, this.length = e.length + this.break + t.length, this);
	}
	updateHeight(e, t = 0, n = !1, r) {
		let { left: i, right: a } = this, o = t + i.length + this.break, s = null;
		return r && r.from <= t + i.length && r.more ? s = i = i.updateHeight(e, t, n, r) : i.updateHeight(e, t, n), r && r.from <= o + a.length && r.more ? s = a = a.updateHeight(e, o, n, r) : a.updateHeight(e, o, n), s ? this.balanced(i, a) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
	}
	toString() {
		return this.left + (this.break ? " " : "-") + this.right;
	}
};
function Zl(e, t) {
	let n, r;
	e[t] == null && (n = e[t - 1]) instanceof Yl && (r = e[t + 1]) instanceof Yl && e.splice(t - 1, 3, new Yl(n.length + 1 + r.length));
}
var Ql = 5, $l = class e {
	constructor(e, t) {
		this.pos = e, this.oracle = t, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
	}
	get isCovered() {
		return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
	}
	span(e, t) {
		if (this.lineStart > -1) {
			let e = Math.min(t, this.lineEnd), n = this.nodes[this.nodes.length - 1];
			n instanceof Jl ? n.length += e - this.pos : (e > this.pos || !this.isCovered) && this.nodes.push(new Jl(e - this.pos, -1, 0)), this.writtenTo = e, t > e && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
		}
		this.pos = t;
	}
	point(e, t, n) {
		if (e < t || n.heightRelevant) {
			let r = n.widget ? n.widget.estimatedHeight : 0, i = n.widget ? n.widget.lineBreaks : 0;
			r < 0 && (r = this.oracle.lineHeight);
			let a = t - e;
			n.block ? this.addBlock(new ql(a, r, n)) : (a || i || r >= Ql) && this.addLineDeco(r, i, a);
		} else t > e && this.span(e, t);
		this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
	}
	enterLine() {
		if (this.lineStart > -1) return;
		let { from: e, to: t } = this.oracle.doc.lineAt(this.pos);
		this.lineStart = e, this.lineEnd = t, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new Jl(this.pos - e, -1, 0)), this.writtenTo = this.pos;
	}
	blankContent(e, t) {
		let n = new Yl(t - e);
		return this.oracle.doc.lineAt(e).to == t && (n.flags |= 4), n;
	}
	ensureLine() {
		this.enterLine();
		let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
		if (e instanceof Jl) return e;
		let t = new Jl(0, -1, 0);
		return this.nodes.push(t), t;
	}
	addBlock(e) {
		this.enterLine();
		let t = e.deco;
		t && t.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos += e.length, t && t.endSide > 0 && (this.covering = e);
	}
	addLineDeco(e, t, n) {
		let r = this.ensureLine();
		r.length += n, r.collapsed += n, r.widgetHeight = Math.max(r.widgetHeight, e), r.breaks += t, this.writtenTo = this.pos += n;
	}
	finish(e) {
		let t = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
		this.lineStart > -1 && !(t instanceof Jl) && !this.isCovered ? this.nodes.push(new Jl(0, -1, 0)) : (this.writtenTo < this.pos || t == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
		let n = e;
		for (let e of this.nodes) e instanceof Jl && e.updateHeight(this.oracle, n), n += e ? e.length : 1;
		return this.nodes;
	}
	static build(t, n, r, i) {
		let a = new e(r, t);
		return aa.spans(n, r, i, a, 0), a.finish(r);
	}
};
function eu(e, t, n) {
	let r = new tu();
	return aa.compare(e, t, n, r, 0), r.changes;
}
var tu = class {
	constructor() {
		this.changes = [];
	}
	compareRange() {}
	comparePoint(e, t, n, r) {
		(e < t || n && n.heightRelevant || r && r.heightRelevant) && oo(e, t, this.changes, 5);
	}
};
function nu(e, t) {
	let n = e.getBoundingClientRect(), r = e.ownerDocument, i = r.defaultView || window, a = Math.max(0, n.left), o = Math.min(i.innerWidth, n.right), s = Math.max(0, n.top), c = Math.min(i.innerHeight, n.bottom);
	for (let t = e.parentNode; t && t != r.body;) if (t.nodeType == 1) {
		let n = t, r = window.getComputedStyle(n);
		if ((n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth) && r.overflow != "visible") {
			let r = n.getBoundingClientRect();
			a = Math.max(a, r.left), o = Math.min(o, r.right), s = Math.max(s, r.top), c = Math.min(t == e.parentNode ? i.innerHeight : c, r.bottom);
		}
		t = r.position == "absolute" || r.position == "fixed" ? n.offsetParent : n.parentNode;
	} else if (t.nodeType == 11) t = t.host;
	else break;
	return {
		left: a - n.left,
		right: Math.max(a, o) - n.left,
		top: s - (n.top + t),
		bottom: Math.max(s, c) - (n.top + t)
	};
}
function ru(e) {
	let t = e.getBoundingClientRect(), n = e.ownerDocument.defaultView || window;
	return t.left < n.innerWidth && t.right > 0 && t.top < n.innerHeight && t.bottom > 0;
}
function iu(e, t) {
	let n = e.getBoundingClientRect();
	return {
		left: 0,
		right: n.right - n.left,
		top: t,
		bottom: n.bottom - (n.top + t)
	};
}
var au = class {
	constructor(e, t, n, r) {
		this.from = e, this.to = t, this.size = n, this.displaySize = r;
	}
	static same(e, t) {
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = t[n];
			if (r.from != i.from || r.to != i.to || r.size != i.size) return !1;
		}
		return !0;
	}
	draw(e, t) {
		return K.replace({ widget: new ou(this.displaySize * (t ? e.scaleY : e.scaleX), t) }).range(this.from, this.to);
	}
}, ou = class extends $a {
	constructor(e, t) {
		super(), this.size = e, this.vertical = t;
	}
	eq(e) {
		return e.size == this.size && e.vertical == this.vertical;
	}
	toDOM() {
		let e = document.createElement("div");
		return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
	}
	get estimatedHeight() {
		return this.vertical ? this.size : -1;
	}
}, su = class {
	constructor(e, t) {
		this.view = e, this.state = t, this.pixelViewport = {
			left: 0,
			right: window.innerWidth,
			top: 0,
			bottom: 0
		}, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scaleX = 1, this.scaleY = 1, this.scrollOffset = 0, this.scrolledToBottom = !1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = pu, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Fo.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
		let n = t.facet(Es).some((e) => typeof e != "function" && e.class == "cm-lineWrapping");
		this.heightOracle = new zl(n), this.stateDeco = mu(t), this.heightMap = Wl.empty().applyChanges(this.stateDeco, Pr.empty, this.heightOracle.setDoc(t.doc), [new Is(0, 0, 0, t.doc.length)]);
		for (let e = 0; e < 2 && (this.viewport = this.getViewport(0, null), this.updateForViewport()); e++);
		this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = K.set(this.lineGaps.map((e) => e.draw(this, !1))), this.scrollParent = e.scrollDOM, this.computeVisibleRanges();
	}
	updateForViewport() {
		let e = [this.viewport], { main: t } = this.state.selection;
		for (let n = 0; n <= 1; n++) {
			let r = n ? t.head : t.anchor;
			if (!e.some(({ from: e, to: t }) => r >= e && r <= t)) {
				let { from: t, to: n } = this.lineBlockAt(r);
				e.push(new cu(t, n));
			}
		}
		return this.viewports = e.sort((e, t) => e.from - t.from), this.updateScaler();
	}
	updateScaler() {
		let e = this.scaler;
		return this.scaler = this.heightMap.height <= 7e6 ? pu : new hu(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
	}
	updateViewportLines() {
		this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
			this.viewportLines.push(gu(e, this.scaler));
		});
	}
	update(e, t = null) {
		this.state = e.state;
		let n = this.stateDeco;
		this.stateDeco = mu(this.state);
		let r = e.changedRanges, i = Is.extendWithRanges(r, eu(n, this.stateDeco, e ? e.changes : ei.empty(this.state.doc.length))), a = this.heightMap.height, o = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollOffset);
		Rl(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), i), (this.heightMap.height != a || Ll) && (e.flags |= 2), o ? (this.scrollAnchorPos = e.changes.mapPos(o.from, -1), this.scrollAnchorHeight = o.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = a);
		let s = i.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
		(t && (t.range.head < s.from || t.range.head > s.to) || !this.viewportIsAppropriate(s)) && (s = this.getViewport(0, t));
		let c = s.from != this.viewport.from || s.to != this.viewport.to;
		this.viewport = s, e.flags |= this.updateForViewport(), (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(e.changes), t && (this.scrollTarget = t), !this.mustEnforceCursorAssoc && (e.selectionSet || e.focusChanged) && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(ms) && (this.mustEnforceCursorAssoc = !0);
	}
	measure() {
		let { view: e } = this, t = e.contentDOM, n = window.getComputedStyle(t), r = this.heightOracle, i = n.whiteSpace;
		this.defaultTextDirection = n.direction == "rtl" ? Fo.RTL : Fo.LTR;
		let a = this.heightOracle.mustRefreshForWrapping(i) || this.mustMeasureContent === "refresh", o = t.getBoundingClientRect(), s = a || this.mustMeasureContent || this.contentDOMHeight != o.height;
		this.contentDOMHeight = o.height, this.mustMeasureContent = !1;
		let c = 0, l = 0;
		if (o.width && o.height) {
			let { scaleX: e, scaleY: n } = bo(t, o);
			(e > .005 && Math.abs(this.scaleX - e) > .005 || n > .005 && Math.abs(this.scaleY - n) > .005) && (this.scaleX = e, this.scaleY = n, c |= 16, a = s = !0);
		}
		let u = (parseInt(n.paddingTop) || 0) * this.scaleY, d = (parseInt(n.paddingBottom) || 0) * this.scaleY;
		(this.paddingTop != u || this.paddingBottom != d) && (this.paddingTop = u, this.paddingBottom = d, c |= 18), this.editorWidth != e.scrollDOM.clientWidth && (r.lineWrapping && (s = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 16);
		let f = So(this.view.contentDOM, !1).y;
		f != this.scrollParent && (this.scrollParent = f, this.scrollAnchorHeight = -1, this.scrollOffset = 0);
		let p = this.getScrollOffset();
		this.scrollOffset != p && (this.scrollAnchorHeight = -1, this.scrollOffset = p), this.scrolledToBottom = jo(this.scrollParent || e.win);
		let m = (this.printing ? iu : nu)(t, this.paddingTop), h = m.top - this.pixelViewport.top, g = m.bottom - this.pixelViewport.bottom;
		this.pixelViewport = m;
		let _ = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
		if (_ != this.inView && (this.inView = _, _ && (s = !0)), !this.inView && !this.scrollTarget && !ru(e.dom)) return 0;
		let v = o.width;
		if ((this.contentDOMWidth != v || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = o.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 16), s) {
			let t = e.docView.measureVisibleLineHeights(this.viewport);
			if (r.mustRefreshForHeights(t) && (a = !0), a || r.lineWrapping && Math.abs(v - this.contentDOMWidth) > r.charWidth) {
				let { lineHeight: n, charWidth: o, textHeight: s } = e.docView.measureTextSize();
				a = n > 0 && r.refresh(i, n, o, s, Math.max(5, v / o), t), a && (e.docView.minWidth = 0, c |= 16);
			}
			h > 0 && g > 0 ? l = Math.max(h, g) : h < 0 && g < 0 && (l = Math.min(h, g)), Rl();
			for (let n of this.viewports) {
				let i = n.from == this.viewport.from ? t : e.docView.measureVisibleLineHeights(n);
				this.heightMap = (a ? Wl.empty().applyChanges(this.stateDeco, Pr.empty, this.heightOracle, [new Is(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(r, 0, a, new Bl(n.from, i));
			}
			Ll && (c |= 2);
		}
		let y = !this.viewportIsAppropriate(this.viewport, l) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
		return y && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(l, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || y) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(a ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
	}
	get visibleTop() {
		return this.scaler.fromDOM(this.pixelViewport.top);
	}
	get visibleBottom() {
		return this.scaler.fromDOM(this.pixelViewport.bottom);
	}
	getViewport(e, t) {
		let n = .5 - Math.max(-.5, Math.min(.5, e / 1e3 / 2)), r = this.heightMap, i = this.heightOracle, { visibleTop: a, visibleBottom: o } = this, s = new cu(r.lineAt(a - n * 1e3, Hl.ByHeight, i, 0, 0).from, r.lineAt(o + (1 - n) * 1e3, Hl.ByHeight, i, 0, 0).to);
		if (t) {
			let { head: e } = t.range;
			if (e < s.from || e > s.to) {
				let n = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), a = r.lineAt(e, Hl.ByPos, i, 0, 0), o;
				o = t.y == "center" ? (a.top + a.bottom) / 2 - n / 2 : t.y == "start" || t.y == "nearest" && e < s.from ? a.top : a.bottom - n, s = new cu(r.lineAt(o - 1e3 / 2, Hl.ByHeight, i, 0, 0).from, r.lineAt(o + n + 1e3 / 2, Hl.ByHeight, i, 0, 0).to);
			}
		}
		return s;
	}
	mapViewport(e, t) {
		let n = t.mapPos(e.from, -1), r = t.mapPos(e.to, 1);
		return new cu(this.heightMap.lineAt(n, Hl.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(r, Hl.ByPos, this.heightOracle, 0, 0).to);
	}
	viewportIsAppropriate({ from: e, to: t }, n = 0) {
		if (!this.inView) return !0;
		let { top: r } = this.heightMap.lineAt(e, Hl.ByPos, this.heightOracle, 0, 0), { bottom: i } = this.heightMap.lineAt(t, Hl.ByPos, this.heightOracle, 0, 0), { visibleTop: a, visibleBottom: o } = this;
		return (e == 0 || r <= a - Math.max(10, Math.min(-n, 250))) && (t == this.state.doc.length || i >= o + Math.max(10, Math.min(n, 250))) && r > a - 2 * 1e3 && i < o + 2 * 1e3;
	}
	mapLineGaps(e, t) {
		if (!e.length || t.empty) return e;
		let n = [];
		for (let r of e) t.touchesRange(r.from, r.to) || n.push(new au(t.mapPos(r.from), t.mapPos(r.to), r.size, r.displaySize));
		return n;
	}
	ensureLineGaps(e, t) {
		let n = this.heightOracle.lineWrapping, r = n ? 1e4 : 2e3, i = r >> 1, a = r << 1;
		if (this.defaultTextDirection != Fo.LTR && !n) return [];
		let o = [], s = (r, a, c, l) => {
			if (a - r < i) return;
			let u = this.state.selection.main, d = [u.from];
			u.empty || d.push(u.to);
			for (let e of d) if (e > r && e < a) {
				s(r, e - 10, c, l), s(e + 10, a, c, l);
				return;
			}
			let f = fu(e, (e) => e.from >= c.from && e.to <= c.to && Math.abs(e.from - r) < i && Math.abs(e.to - a) < i && !d.some((t) => e.from < t && e.to > t));
			if (!f) {
				if (a < c.to && t && n && t.visibleRanges.some((e) => e.from <= a && e.to >= a)) {
					let e = t.moveToLineBoundary(U.cursor(a), !1, !0).head;
					e > r && (a = e);
				}
				let e = this.gapSize(c, r, a, l);
				f = new au(r, a, e, n || e < 2e6 ? e : 2e6);
			}
			o.push(f);
		}, c = (t) => {
			if (t.length < a || t.type != eo.Text) return;
			let i = lu(t.from, t.to, this.stateDeco);
			if (i.total < a) return;
			let o = this.scrollTarget ? this.scrollTarget.range.head : null, c, l;
			if (n) {
				let e = r / this.heightOracle.lineLength * this.heightOracle.lineHeight, n, a;
				if (o != null) {
					let r = du(i, o), s = ((this.visibleBottom - this.visibleTop) / 2 + e) / t.height;
					n = r - s, a = r + s;
				} else n = (this.visibleTop - t.top - e) / t.height, a = (this.visibleBottom - t.top + e) / t.height;
				c = uu(i, n), l = uu(i, a);
			} else {
				let n = i.total * this.heightOracle.charWidth, a = r * this.heightOracle.charWidth, s = 0;
				if (n > 2e6) for (let n of e) n.from >= t.from && n.from < t.to && n.size != n.displaySize && n.from * this.heightOracle.charWidth + s < this.pixelViewport.left && (s = n.size - n.displaySize);
				let u = this.pixelViewport.left + s, d = this.pixelViewport.right + s, f, p;
				if (o != null) {
					let e = du(i, o), t = ((d - u) / 2 + a) / n;
					f = e - t, p = e + t;
				} else f = (u - a) / n, p = (d + a) / n;
				c = uu(i, f), l = uu(i, p);
			}
			c > t.from && s(t.from, c, t, i), l < t.to && s(l, t.to, t, i);
		};
		for (let e of this.viewportLines) Array.isArray(e.type) ? e.type.forEach(c) : c(e);
		return o;
	}
	gapSize(e, t, n, r) {
		let i = du(r, n) - du(r, t);
		return this.heightOracle.lineWrapping ? e.height * i : r.total * this.heightOracle.charWidth * i;
	}
	updateLineGaps(e) {
		au.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = K.set(e.map((e) => e.draw(this, this.heightOracle.lineWrapping))));
	}
	computeVisibleRanges(e) {
		let t = this.stateDeco;
		this.lineGaps.length && (t = t.concat(this.lineGapDeco));
		let n = [];
		aa.spans(t, this.viewport.from, this.viewport.to, {
			span(e, t) {
				n.push({
					from: e,
					to: t
				});
			},
			point() {}
		}, 20);
		let r = 0;
		if (n.length != this.visibleRanges.length) r = 12;
		else for (let t = 0; t < n.length && !(r & 8); t++) {
			let i = this.visibleRanges[t], a = n[t];
			(i.from != a.from || i.to != a.to) && (r |= 4, e && e.mapPos(i.from, -1) == a.from && e.mapPos(i.to, 1) == a.to || (r |= 8));
		}
		return this.visibleRanges = n, r;
	}
	lineBlockAt(e) {
		return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((t) => t.from <= e && t.to >= e) || gu(this.heightMap.lineAt(e, Hl.ByPos, this.heightOracle, 0, 0), this.scaler);
	}
	lineBlockAtHeight(e) {
		return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((t) => t.top <= e && t.bottom >= e) || gu(this.heightMap.lineAt(this.scaler.fromDOM(e), Hl.ByHeight, this.heightOracle, 0, 0), this.scaler);
	}
	getScrollOffset() {
		return (this.scrollParent == this.view.scrollDOM ? this.scrollParent.scrollTop : (this.scrollParent ? this.scrollParent.getBoundingClientRect().top : 0) - this.view.contentDOM.getBoundingClientRect().top) * this.scaleY;
	}
	scrollAnchorAt(e) {
		let t = this.lineBlockAtHeight(e + 8);
		return t.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? t : this.viewportLines[0];
	}
	elementAtHeight(e) {
		return gu(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
	}
	get docHeight() {
		return this.scaler.toDOM(this.heightMap.height);
	}
	get contentHeight() {
		return this.docHeight + this.paddingTop + this.paddingBottom;
	}
}, cu = class {
	constructor(e, t) {
		this.from = e, this.to = t;
	}
};
function lu(e, t, n) {
	let r = [], i = e, a = 0;
	return aa.spans(n, e, t, {
		span() {},
		point(e, t) {
			e > i && (r.push({
				from: i,
				to: e
			}), a += e - i), i = t;
		}
	}, 20), i < t && (r.push({
		from: i,
		to: t
	}), a += t - i), {
		total: a,
		ranges: r
	};
}
function uu({ total: e, ranges: t }, n) {
	if (n <= 0) return t[0].from;
	if (n >= 1) return t[t.length - 1].to;
	let r = Math.floor(e * n);
	for (let e = 0;; e++) {
		let { from: n, to: i } = t[e], a = i - n;
		if (r <= a) return n + r;
		r -= a;
	}
}
function du(e, t) {
	let n = 0;
	for (let { from: r, to: i } of e.ranges) {
		if (t <= i) {
			n += t - r;
			break;
		}
		n += i - r;
	}
	return n / e.total;
}
function fu(e, t) {
	for (let n of e) if (t(n)) return n;
}
var pu = {
	toDOM(e) {
		return e;
	},
	fromDOM(e) {
		return e;
	},
	scale: 1,
	eq(e) {
		return e == this;
	}
};
function mu(e) {
	let t = e.facet(Ds).filter((e) => typeof e != "function"), n = e.facet(ks).filter((e) => typeof e != "function");
	return n.length && t.push(aa.join(n)), t;
}
var hu = class e {
	constructor(e, t, n) {
		let r = 0, i = 0, a = 0;
		this.viewports = n.map(({ from: n, to: i }) => {
			let a = t.lineAt(n, Hl.ByPos, e, 0, 0).top, o = t.lineAt(i, Hl.ByPos, e, 0, 0).bottom;
			return r += o - a, {
				from: n,
				to: i,
				top: a,
				bottom: o,
				domTop: 0,
				domBottom: 0
			};
		}), this.scale = (7e6 - r) / (t.height - r);
		for (let e of this.viewports) e.domTop = a + (e.top - i) * this.scale, a = e.domBottom = e.domTop + (e.bottom - e.top), i = e.bottom;
	}
	toDOM(e) {
		for (let t = 0, n = 0, r = 0;; t++) {
			let i = t < this.viewports.length ? this.viewports[t] : null;
			if (!i || e < i.top) return r + (e - n) * this.scale;
			if (e <= i.bottom) return i.domTop + (e - i.top);
			n = i.bottom, r = i.domBottom;
		}
	}
	fromDOM(e) {
		for (let t = 0, n = 0, r = 0;; t++) {
			let i = t < this.viewports.length ? this.viewports[t] : null;
			if (!i || e < i.domTop) return n + (e - r) / this.scale;
			if (e <= i.domBottom) return i.top + (e - i.domTop);
			n = i.bottom, r = i.domBottom;
		}
	}
	eq(t) {
		return t instanceof e ? this.scale == t.scale && this.viewports.length == t.viewports.length && this.viewports.every((e, n) => e.from == t.viewports[n].from && e.to == t.viewports[n].to) : !1;
	}
};
function gu(e, t) {
	if (t.scale == 1) return e;
	let n = t.toDOM(e.top), r = t.toDOM(e.bottom);
	return new Vl(e.from, e.length, n, r - n, Array.isArray(e._content) ? e._content.map((e) => gu(e, t)) : e._content);
}
var _u = /*@__PURE__*/ W.define({ combine: (e) => e.join(" ") }), vu = /*@__PURE__*/ W.define({ combine: (e) => e.indexOf(!0) > -1 }), yu = /*@__PURE__*/ wa.newName(), bu = /*@__PURE__*/ wa.newName(), xu = /*@__PURE__*/ wa.newName(), Su = {
	"&light": "." + bu,
	"&dark": "." + xu
};
function Cu(e, t, n) {
	return new wa(t, { finish(t) {
		return /&/.test(t) ? t.replace(/&\w*/, (t) => {
			if (t == "&") return e;
			if (!n || !n[t]) throw RangeError(`Unsupported selector: ${t}`);
			return n[t];
		}) : e + " " + t;
	} });
}
var wu = /*@__PURE__*/ Cu("." + yu, {
	"&": {
		position: "relative !important",
		boxSizing: "border-box",
		"&.cm-focused": { outline: "1px dotted #212121" },
		display: "flex !important",
		flexDirection: "column"
	},
	".cm-scroller": {
		display: "flex !important",
		alignItems: "flex-start !important",
		fontFamily: "monospace",
		lineHeight: 1.4,
		height: "100%",
		overflowX: "auto",
		position: "relative",
		zIndex: 0,
		overflowAnchor: "none"
	},
	".cm-content": {
		margin: 0,
		flexGrow: 2,
		flexShrink: 0,
		display: "block",
		whiteSpace: "pre",
		wordWrap: "normal",
		boxSizing: "border-box",
		minHeight: "100%",
		padding: "4px 0",
		outline: "none",
		"&[contenteditable=true]": { WebkitUserModify: "read-write-plaintext-only" }
	},
	".cm-lineWrapping": {
		whiteSpace_fallback: "pre-wrap",
		whiteSpace: "break-spaces",
		wordBreak: "break-word",
		overflowWrap: "anywhere",
		flexShrink: 1
	},
	"&light .cm-content": { caretColor: "black" },
	"&dark .cm-content": { caretColor: "white" },
	".cm-line": {
		display: "block",
		padding: "0 2px 0 6px"
	},
	".cm-layer": {
		userSelect: "none",
		position: "absolute",
		left: 0,
		top: 0,
		contain: "size style",
		"& > *": { position: "absolute" }
	},
	"&light .cm-selectionBackground": { background: "#d9d9d9" },
	"&dark .cm-selectionBackground": { background: "#222" },
	"&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": { background: "#d7d4f0" },
	"&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": { background: "#233" },
	".cm-cursorLayer": { pointerEvents: "none" },
	"&.cm-focused > .cm-scroller > .cm-cursorLayer": { animation: "steps(1) cm-blink 1.2s infinite" },
	"@keyframes cm-blink": {
		"0%": {},
		"50%": { opacity: 0 },
		"100%": {}
	},
	"@keyframes cm-blink2": {
		"0%": {},
		"50%": { opacity: 0 },
		"100%": {}
	},
	".cm-cursor, .cm-dropCursor": {
		borderLeft: "1.2px solid black",
		marginLeft: "-0.6px",
		pointerEvents: "none"
	},
	".cm-cursor": { display: "none" },
	"&dark .cm-cursor": { borderLeftColor: "#ddd" },
	".cm-selectionHandle": {
		backgroundColor: "currentColor",
		width: "1.5px"
	},
	".cm-selectionHandle-start::before, .cm-selectionHandle-end::before": {
		content: "\"\"",
		backgroundColor: "inherit",
		borderRadius: "50%",
		width: "8px",
		height: "8px",
		position: "absolute",
		left: "-3.25px"
	},
	".cm-selectionHandle-start::before": { top: "-8px" },
	".cm-selectionHandle-end::before": { bottom: "-8px" },
	".cm-dropCursor": { position: "absolute" },
	"&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": { display: "block" },
	".cm-iso": { unicodeBidi: "isolate" },
	".cm-announced": {
		position: "fixed",
		top: "-10000px"
	},
	"@media print": { ".cm-announced": { display: "none" } },
	"&light .cm-activeLine": { backgroundColor: "#cceeff44" },
	"&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
	"&light .cm-specialChar": { color: "red" },
	"&dark .cm-specialChar": { color: "#f78" },
	".cm-gutters": {
		flexShrink: 0,
		display: "flex",
		height: "100%",
		boxSizing: "border-box",
		zIndex: 200
	},
	".cm-gutters-before": { insetInlineStart: 0 },
	".cm-gutters-after": { insetInlineEnd: 0 },
	"&light .cm-gutters": {
		backgroundColor: "#f5f5f5",
		color: "#6c6c6c",
		border: "0px solid #ddd",
		"&.cm-gutters-before": { borderRightWidth: "1px" },
		"&.cm-gutters-after": { borderLeftWidth: "1px" }
	},
	"&dark .cm-gutters": {
		backgroundColor: "#333338",
		color: "#ccc"
	},
	".cm-gutter": {
		display: "flex !important",
		flexDirection: "column",
		flexShrink: 0,
		boxSizing: "border-box",
		minHeight: "100%",
		overflow: "hidden"
	},
	".cm-gutterElement": { boxSizing: "border-box" },
	".cm-lineNumbers .cm-gutterElement": {
		padding: "0 3px 0 5px",
		minWidth: "20px",
		textAlign: "right",
		whiteSpace: "nowrap"
	},
	"&light .cm-activeLineGutter": { backgroundColor: "#e2f2ff" },
	"&dark .cm-activeLineGutter": { backgroundColor: "#222227" },
	".cm-panels": {
		boxSizing: "border-box",
		position: "sticky",
		left: 0,
		right: 0,
		zIndex: 300
	},
	"&light .cm-panels": {
		backgroundColor: "#f5f5f5",
		color: "black"
	},
	"&light .cm-panels-top": { borderBottom: "1px solid #ddd" },
	"&light .cm-panels-bottom": { borderTop: "1px solid #ddd" },
	"&dark .cm-panels": {
		backgroundColor: "#333338",
		color: "white"
	},
	".cm-dialog": {
		padding: "2px 19px 4px 6px",
		position: "relative",
		"& label": { fontSize: "80%" }
	},
	".cm-dialog-close": {
		position: "absolute",
		top: "3px",
		right: "4px",
		backgroundColor: "inherit",
		border: "none",
		font: "inherit",
		fontSize: "14px",
		padding: "0"
	},
	".cm-tab": {
		display: "inline-block",
		overflow: "hidden",
		verticalAlign: "bottom"
	},
	".cm-widgetBuffer": {
		verticalAlign: "text-top",
		height: "1em",
		width: 0,
		display: "inline"
	},
	".cm-placeholder": {
		color: "#888",
		display: "inline-block",
		verticalAlign: "top",
		userSelect: "none"
	},
	".cm-highlightSpace": {
		backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
		backgroundPosition: "center"
	},
	".cm-highlightTab": {
		backgroundImage: "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"200\" height=\"20\"><path stroke=\"%23888\" stroke-width=\"1\" fill=\"none\" d=\"M1 10H196L190 5M190 15L196 10M197 4L197 16\"/></svg>')",
		backgroundSize: "auto 100%",
		backgroundPosition: "right 90%",
		backgroundRepeat: "no-repeat"
	},
	".cm-trailingSpace": { backgroundColor: "#ff332255" },
	".cm-button": {
		verticalAlign: "middle",
		color: "inherit",
		fontSize: "70%",
		padding: ".2em 1em",
		borderRadius: "1px"
	},
	"&light .cm-button": {
		backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
		border: "1px solid #888",
		"&:active": { backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)" }
	},
	"&dark .cm-button": {
		backgroundImage: "linear-gradient(#393939, #111)",
		border: "1px solid #888",
		"&:active": { backgroundImage: "linear-gradient(#111, #333)" }
	},
	".cm-textfield": {
		verticalAlign: "middle",
		color: "inherit",
		fontSize: "70%",
		border: "1px solid silver",
		padding: ".2em .5em"
	},
	"&light .cm-textfield": { backgroundColor: "white" },
	"&dark .cm-textfield": {
		border: "1px solid #555",
		backgroundColor: "inherit"
	}
}, Su), Tu = {
	childList: !0,
	characterData: !0,
	subtree: !0,
	attributes: !0,
	characterDataOldValue: !0
}, Eu = G.ie && G.ie_version <= 11, Du = class {
	constructor(e) {
		this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new Co(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((t) => {
			for (let e of t) this.queue.push(e);
			(G.ie && G.ie_version <= 11 || G.ios && e.composing) && t.some((e) => e.type == "childList" && e.removedNodes.length || e.type == "characterData" && e.oldValue.length > e.target.nodeValue.length) ? this.flushSoon() : this.flush();
		}), window.EditContext && G.android && e.constructor.EDIT_CONTEXT !== !1 && !(G.chrome && G.chrome_version < 126) && (this.editContext = new ju(e), e.state.facet(bs) && (e.contentDOM.editContext = this.editContext.editContext)), Eu && (this.onCharData = (e) => {
			this.queue.push({
				target: e.target,
				type: "characterData",
				oldValue: e.prevValue
			}), this.flushSoon();
		}), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
			this.view.docView?.lastUpdate < Date.now() - 75 && this.onResize();
		}), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((e) => {
			this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), e.length > 0 && e[e.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
		}, { threshold: [0, .001] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((e) => {
			e.length > 0 && e[e.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
		}, {})), this.listenForScroll(), this.readSelectionRange();
	}
	onScrollChanged(e) {
		this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
	}
	onScroll(e) {
		this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
	}
	onResize() {
		this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
			this.resizeTimeout = -1, this.view.requestMeasure();
		}, 50));
	}
	onPrint(e) {
		(e.type == "change" || !e.type) && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
			this.view.viewState.printing = !1, this.view.requestMeasure();
		}, 500));
	}
	updateGaps(e) {
		if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((t, n) => t != e[n]))) {
			this.gapIntersection.disconnect();
			for (let t of e) this.gapIntersection.observe(t);
			this.gaps = e;
		}
	}
	onSelectionChange(e) {
		let t = this.selectionChanged;
		if (!this.readSelectionRange() || this.delayedAndroidKey) return;
		let { view: n } = this, r = this.selectionRange;
		if (n.state.facet(bs) ? n.root.activeElement != this.dom : !uo(this.dom, r)) return;
		let i = r.anchorNode && n.docView.tile.nearest(r.anchorNode);
		if (i && i.isWidget() && i.widget.ignoreEvent(e)) {
			t || (this.selectionChanged = !1);
			return;
		}
		(G.ie && G.ie_version <= 11 || G.android && G.chrome) && !n.state.selection.main.empty && r.focusNode && po(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset) ? this.flushSoon() : this.flush(!1);
	}
	readSelectionRange() {
		let { view: e } = this, t = co(e.root);
		if (!t) return !1;
		let n = G.safari && e.root.nodeType == 11 && e.root.activeElement == this.dom && Au(this.view, t) || t;
		if (!n || this.selectionRange.eq(n)) return !1;
		let r = uo(this.dom, n);
		return r && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && Ao(this.dom, n) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(n), r && (this.selectionChanged = !0), !0);
	}
	setSelectionRange(e, t) {
		this.selectionRange.set(e.node, e.offset, t.node, t.offset), this.selectionChanged = !1;
	}
	clearSelectionRange() {
		this.selectionRange.set(null, 0, null, 0);
	}
	listenForScroll() {
		this.parentCheck = -1;
		let e = 0, t = null;
		for (let n = this.dom; n;) if (n.nodeType == 1) !t && e < this.scrollTargets.length && this.scrollTargets[e] == n ? e++ : t ||= this.scrollTargets.slice(0, e), t && t.push(n), n = n.assignedSlot || n.parentNode;
		else if (n.nodeType == 11) n = n.host;
		else break;
		if (e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t) {
			for (let e of this.scrollTargets) e.removeEventListener("scroll", this.onScroll);
			for (let e of this.scrollTargets = t) e.addEventListener("scroll", this.onScroll);
		}
	}
	ignore(e) {
		if (!this.active) return e();
		try {
			return this.stop(), e();
		} finally {
			this.start(), this.clear();
		}
	}
	start() {
		this.active ||= (this.observer.observe(this.dom, Tu), Eu && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), !0);
	}
	stop() {
		this.active && (this.active = !1, this.observer.disconnect(), Eu && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
	}
	clear() {
		this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
	}
	delayAndroidKey(e, t) {
		if (!this.delayedAndroidKey) {
			let e = () => {
				let e = this.delayedAndroidKey;
				e && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = e.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && e.force && Oo(this.dom, e.key, e.keyCode));
			};
			this.flushingAndroidKey = this.view.win.requestAnimationFrame(e);
		}
		(!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
			key: e,
			keyCode: t,
			force: this.lastChange < Date.now() - 50 || !!this.delayedAndroidKey?.force
		});
	}
	clearDelayedAndroidKey() {
		this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
	}
	flushSoon() {
		this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
			this.delayedFlush = -1, this.flush();
		}));
	}
	forceFlush() {
		this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
	}
	pendingRecords() {
		for (let e of this.observer.takeRecords()) this.queue.push(e);
		return this.queue;
	}
	processRecords() {
		let e = this.pendingRecords();
		e.length && (this.queue = []);
		let t = -1, n = -1, r = !1;
		for (let i of e) {
			let e = this.readMutation(i);
			e && (e.typeOver && (r = !0), t == -1 ? {from: t, to: n} = e : (t = Math.min(e.from, t), n = Math.max(e.to, n)));
		}
		return {
			from: t,
			to: n,
			typeOver: r
		};
	}
	readChange() {
		let { from: e, to: t, typeOver: n } = this.processRecords(), r = this.selectionChanged && uo(this.dom, this.selectionRange);
		if (e < 0 && !r) return null;
		e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
		let i = new Uc(this.view, e, t, n);
		return this.view.docView.domChanged = { newSel: i.newSel ? i.newSel.main : null }, i;
	}
	flush(e = !0) {
		if (this.delayedFlush >= 0 || this.delayedAndroidKey) return !1;
		e && this.readSelectionRange();
		let t = this.readChange();
		if (!t) return this.view.requestMeasure(), !1;
		let n = this.view.state, r = Gc(this.view, t);
		return this.view.state == n && (t.domChanged || t.newSel && !Zc(this.view.state.selection, t.newSel.main)) && this.view.update([]), r;
	}
	readMutation(e) {
		let t = this.view.docView.tile.nearest(e.target);
		if (!t || t.isWidget()) return null;
		if (t.markDirty(e.type == "attributes"), e.type == "childList") {
			let n = Ou(t, e.previousSibling || e.target.previousSibling, -1), r = Ou(t, e.nextSibling || e.target.nextSibling, 1);
			return {
				from: n ? t.posAfter(n) : t.posAtStart,
				to: r ? t.posBefore(r) : t.posAtEnd,
				typeOver: !1
			};
		} else if (e.type == "characterData") return {
			from: t.posAtStart,
			to: t.posAtEnd,
			typeOver: e.target.nodeValue == e.oldValue
		};
		else return null;
	}
	setWindow(e) {
		e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
	}
	addWindowListeners(e) {
		e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
	}
	removeWindowListeners(e) {
		e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
	}
	update(e) {
		this.editContext && (this.editContext.update(e), e.startState.facet(bs) != e.state.facet(bs) && (e.view.contentDOM.editContext = e.state.facet(bs) ? this.editContext.editContext : null));
	}
	destroy() {
		var e, t, n;
		this.stop(), (e = this.intersection) == null || e.disconnect(), (t = this.gapIntersection) == null || t.disconnect(), (n = this.resizeScroll) == null || n.disconnect();
		for (let e of this.scrollTargets) e.removeEventListener("scroll", this.onScroll);
		this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
	}
};
function Ou(e, t, n) {
	for (; t;) {
		let r = zs.get(t);
		if (r && r.parent == e) return r;
		let i = t.parentNode;
		t = i == e.dom ? n > 0 ? t.nextSibling : t.previousSibling : i;
	}
	return null;
}
function ku(e, t) {
	let n = t.startContainer, r = t.startOffset, i = t.endContainer, a = t.endOffset, o = e.docView.domAtPos(e.state.selection.main.anchor, 1);
	return po(o.node, o.offset, i, a) && ([n, r, i, a] = [
		i,
		a,
		n,
		r
	]), {
		anchorNode: n,
		anchorOffset: r,
		focusNode: i,
		focusOffset: a
	};
}
function Au(e, t) {
	if (t.getComposedRanges) {
		let n = t.getComposedRanges(e.root)[0];
		if (n) return ku(e, n);
	}
	let n = null;
	function r(e) {
		e.preventDefault(), e.stopImmediatePropagation(), n = e.getTargetRanges()[0];
	}
	return e.contentDOM.addEventListener("beforeinput", r, !0), e.dom.ownerDocument.execCommand("indent"), e.contentDOM.removeEventListener("beforeinput", r, !0), n ? ku(e, n) : null;
}
var ju = class {
	constructor(e) {
		this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = Object.create(null), this.composing = null, this.resetRange(e.state);
		let t = this.editContext = new window.EditContext({
			text: e.state.doc.sliceString(this.from, this.to),
			selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))),
			selectionEnd: this.toContextPos(e.state.selection.main.head)
		});
		this.handlers.textupdate = (n) => {
			let r = e.state.selection.main, { anchor: i, head: a } = r, o = this.toEditorPos(n.updateRangeStart), s = this.toEditorPos(n.updateRangeEnd);
			e.inputState.composing >= 0 && !this.composing && (this.composing = {
				contextBase: n.updateRangeStart,
				editorBase: o,
				drifted: !1
			});
			let c = s - o > n.text.length;
			o == this.from && i < this.from ? o = i : s == this.to && i > this.to && (s = i);
			let l = Jc(e.state.sliceDoc(o, s), n.text, (c ? r.from : r.to) - o, c ? "end" : null);
			if (!l) {
				let t = U.single(this.toEditorPos(n.selectionStart), this.toEditorPos(n.selectionEnd));
				Zc(t, r) || e.dispatch({
					selection: t,
					userEvent: "select"
				});
				return;
			}
			let u = {
				from: l.from + o,
				to: l.toA + o,
				insert: Pr.of(n.text.slice(l.from, l.toB).split("\n"))
			};
			if ((G.mac || G.android) && u.from == a - 1 && /^\. ?$/.test(n.text) && e.contentDOM.getAttribute("autocorrect") == "off" && (u = {
				from: o,
				to: s,
				insert: Pr.of([n.text.replace(".", " ")])
			}), this.pendingContextChange = u, !e.state.readOnly) {
				let t = this.to - this.from + (u.to - u.from + u.insert.length);
				Kc(e, u, U.single(this.toEditorPos(n.selectionStart, t), this.toEditorPos(n.selectionEnd, t)));
			}
			this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state)), u.from < u.to && !u.insert.length && e.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(t.text.slice(Math.max(0, n.updateRangeStart - 1), Math.min(t.text.length, n.updateRangeStart + 1))) && this.handlers.compositionend(n);
		}, this.handlers.characterboundsupdate = (n) => {
			let r = [], i = null;
			for (let t = this.toEditorPos(n.rangeStart), a = this.toEditorPos(n.rangeEnd); t < a; t++) {
				let n = e.coordsForChar(t);
				i = n && new DOMRect(n.left, n.top, n.right - n.left, n.bottom - n.top) || i || new DOMRect(), r.push(i);
			}
			t.updateCharacterBounds(n.rangeStart, r);
		}, this.handlers.textformatupdate = (t) => {
			let n = [];
			for (let e of t.getTextFormats()) {
				let t = e.underlineStyle, r = e.underlineThickness;
				if (!/none/i.test(t) && !/none/i.test(r)) {
					let i = this.toEditorPos(e.rangeStart), a = this.toEditorPos(e.rangeEnd);
					if (i < a) {
						let e = `text-decoration: underline ${/^[a-z]/.test(t) ? t + " " : t == "Dashed" ? "dashed " : t == "Squiggle" ? "wavy " : ""}${/thin/i.test(r) ? 1 : 2}px`;
						n.push(K.mark({ attributes: { style: e } }).range(i, a));
					}
				}
			}
			e.dispatch({ effects: vs.of(K.set(n)) });
		}, this.handlers.compositionstart = () => {
			e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
		}, this.handlers.compositionend = () => {
			if (e.inputState.composing = -1, e.inputState.compositionFirstChange = null, this.composing) {
				let { drifted: t } = this.composing;
				this.composing = null, t && this.reset(e.state);
			}
		};
		for (let e in this.handlers) t.addEventListener(e, this.handlers[e]);
		this.measureReq = { read: (e) => {
			let t = co(e.root);
			t && t.rangeCount && this.editContext.updateSelectionBounds(t.getRangeAt(0).getBoundingClientRect());
		} };
	}
	applyEdits(e) {
		let t = 0, n = !1, r = this.pendingContextChange;
		return e.changes.iterChanges((i, a, o, s, c) => {
			if (n) return;
			let l = c.length - (a - i);
			if (r && a >= r.to) if (r.from == i && r.to == a && r.insert.eq(c)) {
				r = this.pendingContextChange = null, t += l, this.to += l;
				return;
			} else r = null, this.revertPending(e.state);
			if (i += t, a += t, a <= this.from) this.from += l, this.to += l;
			else if (i < this.to) {
				if (i < this.from || a > this.to || this.to - this.from + c.length > 3e4) {
					n = !0;
					return;
				}
				this.editContext.updateText(this.toContextPos(i), this.toContextPos(a), c.toString()), this.to += l;
			}
			t += l;
		}), r && !n && this.revertPending(e.state), !n;
	}
	update(e) {
		let t = this.pendingContextChange, n = e.startState.selection.main;
		this.composing && (this.composing.drifted || !e.changes.touchesRange(n.from, n.to) && e.transactions.some((e) => !e.isUserEvent("input.type") && e.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.reset(e.state)) : (e.docChanged || e.selectionSet || t) && this.setSelection(e.state), (e.geometryChanged || e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
	}
	resetRange(e) {
		let { head: t } = e.selection.main;
		this.from = Math.max(0, t - 1e4), this.to = Math.min(e.doc.length, t + 1e4);
	}
	reset(e) {
		this.resetRange(e), this.editContext.updateText(0, this.editContext.text.length, e.doc.sliceString(this.from, this.to)), this.setSelection(e);
	}
	revertPending(e) {
		let t = this.pendingContextChange;
		this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(t.from), this.toContextPos(t.from + t.insert.length), e.doc.sliceString(t.from, t.to));
	}
	setSelection(e) {
		let { main: t } = e.selection, n = this.toContextPos(Math.max(this.from, Math.min(this.to, t.anchor))), r = this.toContextPos(t.head);
		(this.editContext.selectionStart != n || this.editContext.selectionEnd != r) && this.editContext.updateSelection(n, r);
	}
	rangeIsValid(e) {
		let { head: t } = e.selection.main;
		return !(this.from > 0 && t - this.from < 500 || this.to < e.doc.length && this.to - t < 500 || this.to - this.from > 1e4 * 3);
	}
	toEditorPos(e, t = this.to - this.from) {
		e = Math.min(e, t);
		let n = this.composing;
		return n && n.drifted ? n.editorBase + (e - n.contextBase) : e + this.from;
	}
	toContextPos(e) {
		let t = this.composing;
		return t && t.drifted ? t.contextBase + (e - t.editorBase) : e - this.from;
	}
	destroy() {
		for (let e in this.handlers) this.editContext.removeEventListener(e, this.handlers[e]);
	}
}, q = class e {
	get state() {
		return this.viewState.state;
	}
	get viewport() {
		return this.viewState.viewport;
	}
	get visibleRanges() {
		return this.viewState.visibleRanges;
	}
	get inView() {
		return this.viewState.inView;
	}
	get composing() {
		return !!this.inputState && this.inputState.composing > 0;
	}
	get compositionStarted() {
		return !!this.inputState && this.inputState.composing >= 0;
	}
	get root() {
		return this._root;
	}
	get win() {
		return this.dom.ownerDocument.defaultView || window;
	}
	constructor(e = {}) {
		this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
		let { dispatch: t } = e;
		this.dispatchTransactions = e.dispatchTransactions || t && ((e) => e.forEach((e) => t(e, this))) || ((e) => this.update(e)), this.dispatch = this.dispatch.bind(this), this._root = e.root || ko(e.parent) || document, this.viewState = new su(this, e.state || Qi.create(e)), e.scrollTo && e.scrollTo.is(_s) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Ss).map((e) => new ws(e));
		for (let e of this.plugins) e.update(this);
		this.observer = new Du(this), this.inputState = new Qc(this), this.inputState.ensureHandlers(this.plugins), this.docView = new fc(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), document.fonts?.ready && document.fonts.ready.then(() => {
			this.viewState.mustMeasureContent = "refresh", this.requestMeasure();
		});
	}
	dispatch(...e) {
		let t = e.length == 1 && e[0] instanceof Ri ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
		this.dispatchTransactions(t, this);
	}
	update(t) {
		if (this.updateState != 0) throw Error("Calls to EditorView.update are not allowed while an update is in progress");
		let n = !1, r = !1, i, a = this.state;
		for (let e of t) {
			if (e.startState != a) throw RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
			a = e.state;
		}
		if (this.destroyed) {
			this.viewState.state = a;
			return;
		}
		let o = this.hasFocus, s = 0, c = null;
		t.some((e) => e.annotation(jl)) ? (this.inputState.notifiedFocused = o, s = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, c = Ml(a, o), c || (s = 1));
		let l = this.observer.delayedAndroidKey, u = null;
		if (l ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(a.doc) || !this.state.selection.eq(a.selection)) && (u = null)) : this.observer.clear(), a.facet(Qi.phrases) != this.state.facet(Qi.phrases)) return this.setState(a);
		i = Ls.create(this, a, t), i.flags |= s;
		let d = this.viewState.scrollTarget;
		try {
			this.updateState = 2;
			for (let n of t) {
				if (d &&= d.map(n.changes), n.scrollIntoView) {
					let { main: t } = n.state.selection, { x: r, y: i } = this.state.facet(e.cursorScrollMargin);
					d = new gs(t.empty ? t : U.cursor(t.head, t.head > t.anchor ? -1 : 1), "nearest", "nearest", i, r);
				}
				for (let e of n.effects) e.is(_s) && (d = e.value.clip(this.state));
			}
			this.viewState.update(i, d), this.bidiCache = Pu.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(Fs) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(n, t.some((e) => e.isUserEvent("select.pointer")));
		} finally {
			this.updateState = 0;
		}
		if (i.startState.facet(_u) != i.state.facet(_u) && (this.viewState.mustMeasureContent = !0), (n || r || d || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty) for (let e of this.state.facet(cs)) try {
			e(i);
		} catch (e) {
			ys(this.state, e, "update listener");
		}
		(c || u) && Promise.resolve().then(() => {
			c && this.state == c.startState && this.dispatch(c), u && !Gc(this, u) && l.force && Oo(this.contentDOM, l.key, l.keyCode);
		});
	}
	setState(e) {
		if (this.updateState != 0) throw Error("Calls to EditorView.setState are not allowed while an update is in progress");
		if (this.destroyed) {
			this.viewState.state = e;
			return;
		}
		this.updateState = 2;
		let t = this.hasFocus;
		try {
			for (let e of this.plugins) e.destroy(this);
			this.viewState = new su(this, e), this.plugins = e.facet(Ss).map((e) => new ws(e)), this.pluginMap.clear();
			for (let e of this.plugins) e.update(this);
			this.docView.destroy(), this.docView = new fc(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
		} finally {
			this.updateState = 0;
		}
		t && this.focus(), this.requestMeasure();
	}
	updatePlugins(e) {
		let t = e.startState.facet(Ss), n = e.state.facet(Ss);
		if (t != n) {
			let r = [];
			for (let i of n) {
				let n = t.indexOf(i);
				if (n < 0) r.push(new ws(i));
				else {
					let t = this.plugins[n];
					t.mustUpdate = e, r.push(t);
				}
			}
			for (let t of this.plugins) t.mustUpdate != e && t.destroy(this);
			this.plugins = r, this.pluginMap.clear();
		} else for (let t of this.plugins) t.mustUpdate = e;
		for (let e = 0; e < this.plugins.length; e++) this.plugins[e].update(this);
		t != n && this.inputState.ensureHandlers(this.plugins);
	}
	docViewUpdate() {
		for (let e of this.plugins) {
			let t = e.value;
			if (t && t.docViewUpdate) try {
				t.docViewUpdate(this);
			} catch (e) {
				ys(this.state, e, "doc view update listener");
			}
		}
	}
	measure(e = !0) {
		if (this.destroyed) return;
		if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
			this.measureScheduled = -1, this.requestMeasure();
			return;
		}
		this.measureScheduled = 0, e && this.observer.forceFlush();
		let t = null, n = this.viewState.scrollParent, r = this.viewState.getScrollOffset(), { scrollAnchorPos: i, scrollAnchorHeight: a } = this.viewState;
		Math.abs(r - this.viewState.scrollOffset) > 1 && (a = -1), this.viewState.scrollAnchorHeight = -1;
		try {
			for (let e = 0;; e++) {
				if (a < 0) if (jo(n || this.win)) i = -1, a = this.viewState.heightMap.height;
				else {
					let e = this.viewState.scrollAnchorAt(r);
					i = e.from, a = e.top;
				}
				this.updateState = 1;
				let o = this.viewState.measure();
				if (!o && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
				if (e > 5) {
					console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
					break;
				}
				let s = [];
				o & 4 || ([this.measureRequests, s] = [s, this.measureRequests]);
				let c = s.map((e) => {
					try {
						return e.read(this);
					} catch (e) {
						return ys(this.state, e), Nu;
					}
				}), l = Ls.create(this, this.state, []), u = !1;
				l.flags |= o, t ? t.flags |= o : t = l, this.updateState = 2, l.empty || (this.updatePlugins(l), this.inputState.update(l), this.updateAttrs(), u = this.docView.update(l), u && this.docViewUpdate());
				for (let e = 0; e < s.length; e++) if (c[e] != Nu) try {
					let t = s[e];
					t.write && t.write(c[e], this);
				} catch (e) {
					ys(this.state, e);
				}
				if (u && this.docView.updateSelection(!0), !l.viewportChanged && this.measureRequests.length == 0) {
					if (this.viewState.editorHeight) if (this.viewState.scrollTarget) {
						this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, a = -1;
						continue;
					} else {
						let e = ((i < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(i).top) - a) / this.scaleY;
						if ((e > 1 || e < -1) && (n == this.scrollDOM || this.hasFocus || Math.max(this.inputState.lastWheelEvent, this.inputState.lastTouchTime) > Date.now() - 100)) {
							r += e, n ? n.scrollTop += e : this.win.scrollBy(0, e), a = -1;
							continue;
						}
					}
					break;
				}
			}
		} finally {
			this.updateState = 0, this.measureScheduled = -1;
		}
		if (t && !t.empty) for (let e of this.state.facet(cs)) e(t);
	}
	get themeClasses() {
		return yu + " " + (this.state.facet(vu) ? xu : bu) + " " + this.state.facet(_u);
	}
	updateAttrs() {
		let e = Fu(this, Ts, { class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses }), t = {
			spellcheck: "false",
			autocorrect: "off",
			autocapitalize: "off",
			writingsuggestions: "false",
			translate: "no",
			contenteditable: this.state.facet(bs) ? "true" : "false",
			class: "cm-content",
			style: `${G.tabSize}: ${this.state.tabSize}`,
			role: "textbox",
			"aria-multiline": "true"
		};
		this.state.readOnly && (t["aria-readonly"] = "true"), Fu(this, Es, t);
		let n = this.observer.ignore(() => {
			let n = Za(this.contentDOM, this.contentAttrs, t), r = Za(this.dom, this.editorAttrs, e);
			return n || r;
		});
		return this.editorAttrs = e, this.contentAttrs = t, n;
	}
	showAnnouncements(t) {
		let n = !0;
		for (let r of t) for (let t of r.effects) if (t.is(e.announce)) {
			n && (this.announceDOM.textContent = ""), n = !1;
			let e = this.announceDOM.appendChild(document.createElement("div"));
			e.textContent = t.value;
		}
	}
	mountStyles() {
		this.styleModules = this.state.facet(Fs);
		let t = this.state.facet(e.cspNonce);
		wa.mount(this.root, this.styleModules.concat(wu).reverse(), t ? { nonce: t } : void 0);
	}
	readMeasured() {
		if (this.updateState == 2) throw Error("Reading the editor layout isn't allowed during an update");
		this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
	}
	requestMeasure(e) {
		if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
			if (this.measureRequests.indexOf(e) > -1) return;
			if (e.key != null) {
				for (let t = 0; t < this.measureRequests.length; t++) if (this.measureRequests[t].key === e.key) {
					this.measureRequests[t] = e;
					return;
				}
			}
			this.measureRequests.push(e);
		}
	}
	plugin(e) {
		let t = this.pluginMap.get(e);
		return (t === void 0 || t && t.plugin != e) && this.pluginMap.set(e, t = this.plugins.find((t) => t.plugin == e) || null), t && t.update(this).value;
	}
	get documentTop() {
		return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
	}
	get documentPadding() {
		return {
			top: this.viewState.paddingTop,
			bottom: this.viewState.paddingBottom
		};
	}
	get scaleX() {
		return this.viewState.scaleX;
	}
	get scaleY() {
		return this.viewState.scaleY;
	}
	elementAtHeight(e) {
		return this.readMeasured(), this.viewState.elementAtHeight(e);
	}
	lineBlockAtHeight(e) {
		return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
	}
	get viewportLineBlocks() {
		return this.viewState.viewportLines;
	}
	lineBlockAt(e) {
		return this.viewState.lineBlockAt(e);
	}
	get contentHeight() {
		return this.viewState.contentHeight;
	}
	moveByChar(e, t, n) {
		return Pc(this, e, kc(this, e, t, n));
	}
	moveByGroup(e, t) {
		return Pc(this, e, kc(this, e, t, (t) => Ac(this, e.head, t)));
	}
	visualLineSide(e, t) {
		let n = this.bidiSpans(e), r = this.textDirectionAt(e.from), i = n[t ? n.length - 1 : 0];
		return U.cursor(i.side(t, r) + e.from, i.forward(!t, r) ? 1 : -1);
	}
	moveToLineBoundary(e, t, n = !0) {
		return Oc(this, e, t, n);
	}
	moveVertically(e, t, n) {
		return Pc(this, e, jc(this, e, t, n));
	}
	domAtPos(e, t = 1) {
		return this.docView.domAtPos(e, t);
	}
	posAtDOM(e, t = 0) {
		return this.docView.posFromDOM(e, t);
	}
	posAtCoords(e, t = !0) {
		this.readMeasured();
		let n = Ic(this, e, t);
		return n && n.pos;
	}
	posAndSideAtCoords(e, t = !0) {
		return this.readMeasured(), Ic(this, e, t);
	}
	coordsAtPos(e, t = 1) {
		this.readMeasured();
		let n = this.docView.coordsAt(e, t);
		if (!n || n.left == n.right) return n;
		let r = this.state.doc.lineAt(e), i = this.bidiSpans(r), a = i[Go.find(i, e - r.from, -1, t)];
		return vo(n, a.dir == Fo.LTR == t > 0);
	}
	coordsForChar(e) {
		return this.readMeasured(), this.docView.coordsForChar(e);
	}
	get defaultCharacterWidth() {
		return this.viewState.heightOracle.charWidth;
	}
	get defaultLineHeight() {
		return this.viewState.heightOracle.lineHeight;
	}
	get textDirection() {
		return this.viewState.defaultTextDirection;
	}
	textDirectionAt(e) {
		return !this.state.facet(ps) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
	}
	get lineWrapping() {
		return this.viewState.heightOracle.lineWrapping;
	}
	bidiSpans(e) {
		if (e.length > Mu) return es(e.length);
		let t = this.textDirectionAt(e.from), n;
		for (let r of this.bidiCache) if (r.from == e.from && r.dir == t && (r.fresh || Ko(r.isolates, n = Ms(this, e)))) return r.order;
		n ||= Ms(this, e);
		let r = $o(e.text, t, n);
		return this.bidiCache.push(new Pu(e.from, e.to, t, n, !0, r)), r;
	}
	get hasFocus() {
		return (this.dom.ownerDocument.hasFocus() || G.safari && this.inputState?.lastContextMenu > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
	}
	focus() {
		this.observer.ignore(() => {
			To(this.contentDOM), this.docView.updateSelection();
		});
	}
	setRoot(e) {
		this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
	}
	destroy() {
		this.root.activeElement == this.contentDOM && this.contentDOM.blur();
		for (let e of this.plugins) e.destroy(this);
		this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
	}
	static scrollIntoView(e, t = {}) {
		return _s.of(new gs(typeof e == "number" ? U.cursor(e) : e, t.y ?? "nearest", t.x ?? "nearest", t.yMargin ?? 5, t.xMargin ?? 5));
	}
	scrollSnapshot() {
		let { scrollTop: e, scrollLeft: t } = this.scrollDOM, n = this.viewState.scrollAnchorAt(e);
		return _s.of(new gs(U.cursor(n.from), "start", "start", n.top - e, t, !0));
	}
	setTabFocusMode(e) {
		e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
	}
	static domEventHandlers(e) {
		return Cs.define(() => ({}), { eventHandlers: e });
	}
	static domEventObservers(e) {
		return Cs.define(() => ({}), { eventObservers: e });
	}
	static theme(e, t) {
		let n = wa.newName(), r = [_u.of(n), Fs.of(Cu(`.${n}`, e))];
		return t && t.dark && r.push(vu.of(!0)), r;
	}
	static baseTheme(e) {
		return yi.lowest(Fs.of(Cu("." + yu, e, Su)));
	}
	static findFromDOM(e) {
		let t = e.querySelector(".cm-content");
		return (t && zs.get(t) || zs.get(e))?.root?.view || null;
	}
};
q.styleModule = Fs, q.inputHandler = ls, q.clipboardInputFilter = ds, q.clipboardOutputFilter = fs, q.scrollHandler = hs, q.focusChangeEffect = us, q.perLineTextDirection = ps, q.exceptionSink = ss, q.updateListener = cs, q.editable = bs, q.mouseSelectionStyle = os, q.dragMovesSelection = as, q.clickAddsSelectionRange = is, q.decorations = Ds, q.blockWrappers = Os, q.outerDecorations = ks, q.atomicRanges = As, q.bidiIsolatedRanges = js, q.cursorScrollMargin = /*@__PURE__*/ W.define({ combine: (e) => {
	let t = 5, n = 5;
	for (let r of e) typeof r == "number" ? t = n = r : {x: t, y: n} = r;
	return {
		x: t,
		y: n
	};
} }), q.scrollMargins = Ns, q.darkTheme = vu, q.cspNonce = /*@__PURE__*/ W.define({ combine: (e) => e.length ? e[0] : "" }), q.contentAttributes = Es, q.editorAttributes = Ts, q.lineWrapping = /*@__PURE__*/ q.contentAttributes.of({ class: "cm-lineWrapping" }), q.announce = /*@__PURE__*/ Li.define();
var Mu = 4096, Nu = {}, Pu = class e {
	constructor(e, t, n, r, i, a) {
		this.from = e, this.to = t, this.dir = n, this.isolates = r, this.fresh = i, this.order = a;
	}
	static update(t, n) {
		if (n.empty && !t.some((e) => e.fresh)) return t;
		let r = [], i = t.length ? t[t.length - 1].dir : Fo.LTR;
		for (let a = Math.max(0, t.length - 10); a < t.length; a++) {
			let o = t[a];
			o.dir == i && !n.touchesRange(o.from, o.to) && r.push(new e(n.mapPos(o.from, 1), n.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
		}
		return r;
	}
};
function Fu(e, t, n) {
	for (let r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
		let t = r[i], a = typeof t == "function" ? t(e) : t;
		a && qa(a, n);
	}
	return n;
}
var Iu = G.mac ? "mac" : G.windows ? "win" : G.linux ? "linux" : "key";
function Lu(e, t) {
	let n = e.split(/-(?!$)/), r = n[n.length - 1];
	r == "Space" && (r = " ");
	let i, a, o, s;
	for (let e = 0; e < n.length - 1; ++e) {
		let r = n[e];
		if (/^(cmd|meta|m)$/i.test(r)) s = !0;
		else if (/^a(lt)?$/i.test(r)) i = !0;
		else if (/^(c|ctrl|control)$/i.test(r)) a = !0;
		else if (/^s(hift)?$/i.test(r)) o = !0;
		else if (/^mod$/i.test(r)) t == "mac" ? s = !0 : a = !0;
		else throw Error("Unrecognized modifier name: " + r);
	}
	return i && (r = "Alt-" + r), a && (r = "Ctrl-" + r), s && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function Ru(e, t, n) {
	return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n !== !1 && t.shiftKey && (e = "Shift-" + e), e;
}
var zu = /*@__PURE__*/ yi.default(/*@__PURE__*/ q.domEventHandlers({ keydown(e, t) {
	return Ju(Hu(t.state), e, t, "editor");
} })), Bu = /*@__PURE__*/ W.define({ enables: zu }), Vu = /*@__PURE__*/ new WeakMap();
function Hu(e) {
	let t = e.facet(Bu), n = Vu.get(t);
	return n || Vu.set(t, n = Ku(t.reduce((e, t) => e.concat(t), []))), n;
}
function Uu(e, t, n) {
	return Ju(Hu(e.state), t, e, n);
}
var Wu = null, Gu = 4e3;
function Ku(e, t = Iu) {
	let n = Object.create(null), r = Object.create(null), i = (e, t) => {
		let n = r[e];
		if (n == null) r[e] = t;
		else if (n != t) throw Error("Key binding " + e + " is used both as a regular binding and as a multi-stroke prefix");
	}, a = (e, r, a, o, s) => {
		let c = n[e] || (n[e] = Object.create(null)), l = r.split(/ (?!$)/).map((e) => Lu(e, t));
		for (let t = 1; t < l.length; t++) {
			let n = l.slice(0, t).join(" ");
			i(n, !0), c[n] || (c[n] = {
				preventDefault: !0,
				stopPropagation: !1,
				run: [(t) => {
					let r = Wu = {
						view: t,
						prefix: n,
						scope: e
					};
					return setTimeout(() => {
						Wu == r && (Wu = null);
					}, Gu), !0;
				}]
			});
		}
		let u = l.join(" ");
		i(u, !1);
		let d = c[u] || (c[u] = {
			preventDefault: !1,
			stopPropagation: !1,
			run: (c._any?.run)?.slice() || []
		});
		a && d.run.push(a), o && (d.preventDefault = !0), s && (d.stopPropagation = !0);
	};
	for (let r of e) {
		let e = r.scope ? r.scope.split(" ") : ["editor"];
		if (r.any) for (let t of e) {
			let e = n[t] || (n[t] = Object.create(null));
			e._any ||= {
				preventDefault: !1,
				stopPropagation: !1,
				run: []
			};
			let { any: i } = r;
			for (let t in e) e[t].run.push((e) => i(e, qu));
		}
		let i = r[t] || r.key;
		if (i) for (let t of e) a(t, i, r.run, r.preventDefault, r.stopPropagation), r.shift && a(t, "Shift-" + i, r.shift, r.preventDefault, r.stopPropagation);
	}
	return n;
}
var qu = null;
function Ju(e, t, n, r) {
	qu = t;
	let i = Na(t), a = Xr(Jr(i, 0)) == i.length && i != " ", o = "", s = !1, c = !1, l = !1;
	Wu && Wu.view == n && Wu.scope == r && (o = Wu.prefix + " ", il.indexOf(t.keyCode) < 0 && (c = !0, Wu = null));
	let u = /* @__PURE__ */ new Set(), d = (e) => {
		if (e) {
			for (let t of e.run) if (!u.has(t) && (u.add(t), t(n))) return e.stopPropagation && (l = !0), !0;
			e.preventDefault && (e.stopPropagation && (l = !0), c = !0);
		}
		return !1;
	}, f = e[r], p, m;
	return f && (d(f[o + Ru(i, t, !a)]) ? s = !0 : a && (t.altKey || t.metaKey || t.ctrlKey) && !(G.windows && t.ctrlKey && t.altKey) && !(G.mac && t.altKey && !(t.ctrlKey || t.metaKey)) && (p = Da[t.keyCode]) && p != i ? (d(f[o + Ru(p, t, !0)]) || t.shiftKey && (m = Oa[t.keyCode]) != i && m != p && d(f[o + Ru(m, t, !1)])) && (s = !0) : a && t.shiftKey && d(f[o + Ru(i, t, !0)]) && (s = !0), !s && d(f._any) && (s = !0)), c && (s = !0), s && l && t.stopPropagation(), qu = null, s;
}
var Yu = class e {
	constructor(e, t, n, r, i) {
		this.className = e, this.left = t, this.top = n, this.width = r, this.height = i;
	}
	draw() {
		let e = document.createElement("div");
		return e.className = this.className, this.adjust(e), e;
	}
	update(e, t) {
		return t.className == this.className ? (this.adjust(e), !0) : !1;
	}
	adjust(e) {
		e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
	}
	eq(e) {
		return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
	}
	static forRange(t, n, r) {
		if (r.empty) {
			let i = t.coordsAtPos(r.head, r.assoc || 1);
			if (!i) return [];
			let a = Xu(t);
			return [new e(n, i.left - a.left, i.top - a.top, null, i.bottom - i.top)];
		} else return Qu(t, n, r);
	}
};
function Xu(e) {
	let t = e.scrollDOM.getBoundingClientRect();
	return {
		left: (e.textDirection == Fo.LTR ? t.left : t.right - e.scrollDOM.clientWidth * e.scaleX) - e.scrollDOM.scrollLeft * e.scaleX,
		top: t.top - e.scrollDOM.scrollTop * e.scaleY
	};
}
function Zu(e, t, n, r) {
	let i = e.coordsAtPos(t, n * 2);
	if (!i) return r;
	let a = e.dom.getBoundingClientRect(), o = (i.top + i.bottom) / 2, s = e.posAtCoords({
		x: a.left + 1,
		y: o
	}), c = e.posAtCoords({
		x: a.right - 1,
		y: o
	});
	return s == null || c == null ? r : {
		from: Math.max(r.from, Math.min(s, c)),
		to: Math.min(r.to, Math.max(s, c))
	};
}
function Qu(e, t, n) {
	if (n.to <= e.viewport.from || n.from >= e.viewport.to) return [];
	let r = Math.max(n.from, e.viewport.from), i = Math.min(n.to, e.viewport.to), a = e.textDirection == Fo.LTR, o = e.contentDOM, s = o.getBoundingClientRect(), c = Xu(e), l = o.querySelector(".cm-line"), u = l && window.getComputedStyle(l), d = s.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), f = s.right - (u ? parseInt(u.paddingRight) : 0), p = Dc(e, r, 1), m = Dc(e, i, -1), h = p.type == eo.Text ? p : null, g = m.type == eo.Text ? m : null;
	if (h && (e.lineWrapping || p.widgetLineBreaks) && (h = Zu(e, r, 1, h)), g && (e.lineWrapping || m.widgetLineBreaks) && (g = Zu(e, i, -1, g)), h && g && h.from == g.from && h.to == g.to) return v(y(n.from, n.to, h));
	{
		let t = h ? y(n.from, null, h) : b(p, !1), r = g ? y(null, n.to, g) : b(m, !0), i = [];
		return (h || p).to < (g || m).from - (h && g ? 1 : 0) || p.widgetLineBreaks > 1 && t.bottom + e.defaultLineHeight / 2 < r.top ? i.push(_(d, t.bottom, f, r.top)) : t.bottom < r.top && e.elementAtHeight((t.bottom + r.top) / 2).type == eo.Text && (t.bottom = r.top = (t.bottom + r.top) / 2), v(t).concat(i).concat(v(r));
	}
	function _(e, n, r, i) {
		return new Yu(t, e - c.left, n - c.top, Math.max(0, r - e), i - n);
	}
	function v({ top: e, bottom: t, horizontal: n }) {
		let r = [];
		for (let i = 0; i < n.length; i += 2) r.push(_(n[i], e, n[i + 1], t));
		return r;
	}
	function y(t, n, r) {
		let i = 1e9, o = -1e9, s = [];
		function c(t, n, c, l, u) {
			let p = e.coordsAtPos(t, t == r.to ? -2 : 2), m = e.coordsAtPos(c, c == r.from ? 2 : -2);
			!p || !m || (i = Math.min(p.top, m.top, i), o = Math.max(p.bottom, m.bottom, o), u == Fo.LTR ? s.push(a && n ? d : p.left, a && l ? f : m.right) : s.push(!a && l ? d : m.left, !a && n ? f : p.right));
		}
		let l = t ?? r.from, u = n ?? r.to;
		for (let r of e.visibleRanges) if (r.to > l && r.from < u) for (let i = Math.max(r.from, l), a = Math.min(r.to, u);;) {
			let r = e.state.doc.lineAt(i);
			for (let o of e.bidiSpans(r)) {
				let e = o.from + r.from, s = o.to + r.from;
				if (e >= a) break;
				s > i && c(Math.max(e, i), t == null && e <= l, Math.min(s, a), n == null && s >= u, o.dir);
			}
			if (i = r.to + 1, i >= a) break;
		}
		return s.length == 0 && c(l, t == null, u, n == null, e.textDirection), {
			top: i,
			bottom: o,
			horizontal: s
		};
	}
	function b(e, t) {
		let n = s.top + (t ? e.top : e.bottom);
		return {
			top: n,
			bottom: n,
			horizontal: []
		};
	}
}
function $u(e, t) {
	return e.constructor == t.constructor && e.eq(t);
}
var ed = class {
	constructor(e, t) {
		this.view = e, this.layer = t, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = {
			read: this.measure.bind(this),
			write: this.draw.bind(this)
		}, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), t.above && this.dom.classList.add("cm-layer-above"), t.class && this.dom.classList.add(t.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), t.mount && t.mount(this.dom, e);
	}
	update(e) {
		e.startState.facet(td) != e.state.facet(td) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
	}
	docViewUpdate(e) {
		this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
	}
	setOrder(e) {
		let t = 0, n = e.facet(td);
		for (; t < n.length && n[t] != this.layer;) t++;
		this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - t);
	}
	measure() {
		return this.layer.markers(this.view);
	}
	scale() {
		let { scaleX: e, scaleY: t } = this.view;
		(e != this.scaleX || t != this.scaleY) && (this.scaleX = e, this.scaleY = t, this.dom.style.transform = `scale(${1 / e}, ${1 / t})`);
	}
	draw(e) {
		if (e.length != this.drawn.length || e.some((e, t) => !$u(e, this.drawn[t]))) {
			let t = this.dom.firstChild, n = 0;
			for (let r of e) r.update && t && r.constructor && this.drawn[n].constructor && r.update(t, this.drawn[n]) ? (t = t.nextSibling, n++) : this.dom.insertBefore(r.draw(), t);
			for (; t;) {
				let e = t.nextSibling;
				t.remove(), t = e;
			}
			this.drawn = e, G.webkit && (this.dom.style.display = this.dom.firstChild ? "" : "none");
		}
	}
	destroy() {
		this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
	}
}, td = /*@__PURE__*/ W.define();
function nd(e) {
	return [Cs.define((t) => new ed(t, e)), td.of(e)];
}
var rd = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		cursorBlinkRate: 1200,
		drawRangeCursor: !0,
		iosSelectionHandles: !0
	}, {
		cursorBlinkRate: (e, t) => Math.min(e, t),
		drawRangeCursor: (e, t) => e || t
	});
} });
function id(e = {}) {
	return [
		rd.of(e),
		od,
		cd,
		ld,
		ms.of(!0)
	];
}
function ad(e) {
	return e.startState.facet(rd) != e.state.facet(rd);
}
var od = /*@__PURE__*/ nd({
	above: !0,
	markers(e) {
		let { state: t } = e, n = t.facet(rd), r = [];
		for (let i of t.selection.ranges) {
			let a = i == t.selection.main;
			if (i.empty || n.drawRangeCursor && !(a && G.ios && n.iosSelectionHandles)) {
				let t = a ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", n = i.empty ? i : U.cursor(i.head, i.assoc);
				for (let i of Yu.forRange(e, t, n)) r.push(i);
			}
		}
		return r;
	},
	update(e, t) {
		e.transactions.some((e) => e.selection) && (t.style.animationName = t.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
		let n = ad(e);
		return n && sd(e.state, t), e.docChanged || e.selectionSet || n;
	},
	mount(e, t) {
		sd(t.state, e);
	},
	class: "cm-cursorLayer"
});
function sd(e, t) {
	t.style.animationDuration = e.facet(rd).cursorBlinkRate + "ms";
}
var cd = /*@__PURE__*/ nd({
	above: !1,
	markers(e) {
		let t = [], { main: n, ranges: r } = e.state.selection;
		for (let n of r) if (!n.empty) for (let r of Yu.forRange(e, "cm-selectionBackground", n)) t.push(r);
		if (G.ios && !n.empty && e.state.facet(rd).iosSelectionHandles) {
			for (let r of Yu.forRange(e, "cm-selectionHandle cm-selectionHandle-start", U.cursor(n.from, 1))) t.push(r);
			for (let r of Yu.forRange(e, "cm-selectionHandle cm-selectionHandle-end", U.cursor(n.to, 1))) t.push(r);
		}
		return t;
	},
	update(e, t) {
		return e.docChanged || e.selectionSet || e.viewportChanged || ad(e);
	},
	class: "cm-selectionLayer"
}), ld = /*@__PURE__*/ yi.highest(/*@__PURE__*/ q.theme({
	".cm-line": {
		"& ::selection, &::selection": { backgroundColor: "transparent !important" },
		caretColor: "transparent !important"
	},
	".cm-content": {
		caretColor: "transparent !important",
		"& :focus": {
			caretColor: "initial !important",
			"&::selection, & ::selection": { backgroundColor: "Highlight !important" }
		}
	}
})), ud = /*@__PURE__*/ Li.define({ map(e, t) {
	return e == null ? null : t.mapPos(e);
} }), dd = /*@__PURE__*/ gi.define({
	create() {
		return null;
	},
	update(e, t) {
		return e != null && (e = t.changes.mapPos(e)), t.effects.reduce((e, t) => t.is(ud) ? t.value : e, e);
	}
}), fd = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.cursor = null, this.measureReq = {
			read: this.readPos.bind(this),
			write: this.drawCursor.bind(this)
		};
	}
	update(e) {
		var t;
		let n = e.state.field(dd);
		n == null ? this.cursor != null && ((t = this.cursor) == null || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (e.startState.field(dd) != n || e.docChanged || e.geometryChanged) && this.view.requestMeasure(this.measureReq));
	}
	readPos() {
		let { view: e } = this, t = e.state.field(dd), n = t != null && e.coordsAtPos(t);
		if (!n) return null;
		let r = e.scrollDOM.getBoundingClientRect();
		return {
			left: n.left - r.left + e.scrollDOM.scrollLeft * e.scaleX,
			top: n.top - r.top + e.scrollDOM.scrollTop * e.scaleY,
			height: n.bottom - n.top
		};
	}
	drawCursor(e) {
		if (this.cursor) {
			let { scaleX: t, scaleY: n } = this.view;
			e ? (this.cursor.style.left = e.left / t + "px", this.cursor.style.top = e.top / n + "px", this.cursor.style.height = e.height / n + "px") : this.cursor.style.left = "-100000px";
		}
	}
	destroy() {
		this.cursor && this.cursor.remove();
	}
	setDropPos(e) {
		this.view.state.field(dd) != e && this.view.dispatch({ effects: ud.of(e) });
	}
}, { eventObservers: {
	dragover(e) {
		this.setDropPos(this.view.posAtCoords({
			x: e.clientX,
			y: e.clientY
		}));
	},
	dragleave(e) {
		(e.target == this.view.contentDOM || !this.view.contentDOM.contains(e.relatedTarget)) && this.setDropPos(null);
	},
	dragend() {
		this.setDropPos(null);
	},
	drop() {
		this.setDropPos(null);
	}
} });
function pd() {
	return [dd, fd];
}
function md(e, t, n, r, i) {
	t.lastIndex = 0;
	for (let a = e.iterRange(n, r), o = n, s; !a.next().done; o += a.value.length) if (!a.lineBreak) for (; s = t.exec(a.value);) i(o + s.index, s);
}
function hd(e, t) {
	let n = e.visibleRanges;
	if (n.length == 1 && n[0].from == e.viewport.from && n[0].to == e.viewport.to) return n;
	let r = [];
	for (let { from: i, to: a } of n) i = Math.max(e.state.doc.lineAt(i).from, i - t), a = Math.min(e.state.doc.lineAt(a).to, a + t), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = a : r.push({
		from: i,
		to: a
	});
	return r;
}
var gd = class {
	constructor(e) {
		let { regexp: t, decoration: n, decorate: r, boundary: i, maxLength: a = 1e3 } = e;
		if (!t.global) throw RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
		if (this.regexp = t, r) this.addMatch = (e, t, n, i) => r(i, n, n + e[0].length, e, t);
		else if (typeof n == "function") this.addMatch = (e, t, r, i) => {
			let a = n(e, t, r);
			a && i(r, r + e[0].length, a);
		};
		else if (n) this.addMatch = (e, t, r, i) => i(r, r + e[0].length, n);
		else throw RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
		this.boundary = i, this.maxLength = a;
	}
	createDeco(e) {
		let t = new sa(), n = t.add.bind(t);
		for (let { from: t, to: r } of hd(e, this.maxLength)) md(e.state.doc, this.regexp, t, r, (t, r) => this.addMatch(r, e, t, n));
		return t.finish();
	}
	updateDeco(e, t) {
		let n = 1e9, r = -1;
		return e.docChanged && e.changes.iterChanges((t, i, a, o) => {
			o >= e.view.viewport.from && a <= e.view.viewport.to && (n = Math.min(a, n), r = Math.max(o, r));
		}), e.viewportMoved || r - n > 1e3 ? this.createDeco(e.view) : r > -1 ? this.updateRange(e.view, t.map(e.changes), n, r) : t;
	}
	updateRange(e, t, n, r) {
		for (let i of e.visibleRanges) {
			let a = Math.max(i.from, n), o = Math.min(i.to, r);
			if (o >= a) {
				let n = e.state.doc.lineAt(a), r = n.to < o ? e.state.doc.lineAt(o) : n, s = Math.max(i.from, n.from), c = Math.min(i.to, r.to);
				if (this.boundary) {
					for (; a > n.from; a--) if (this.boundary.test(n.text[a - 1 - n.from])) {
						s = a;
						break;
					}
					for (; o < r.to; o++) if (this.boundary.test(r.text[o - r.from])) {
						c = o;
						break;
					}
				}
				let l = [], u, d = (e, t, n) => l.push(n.range(e, t));
				if (n == r) for (this.regexp.lastIndex = s - n.from; (u = this.regexp.exec(n.text)) && u.index < c - n.from;) this.addMatch(u, e, u.index + n.from, d);
				else md(e.state.doc, this.regexp, s, c, (t, n) => this.addMatch(n, e, t, d));
				t = t.update({
					filterFrom: s,
					filterTo: c,
					filter: (e, t) => e < s || t > c,
					add: l
				});
			}
		}
		return t;
	}
}, _d = /x/.unicode == null ? "g" : "gu", vd = /*@__PURE__*/ RegExp("[\0-\b\n--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩﻿￹-￼]", _d), yd = {
	0: "null",
	7: "bell",
	8: "backspace",
	10: "newline",
	11: "vertical tab",
	13: "carriage return",
	27: "escape",
	8203: "zero width space",
	8204: "zero width non-joiner",
	8205: "zero width joiner",
	8206: "left-to-right mark",
	8207: "right-to-left mark",
	8232: "line separator",
	8237: "left-to-right override",
	8238: "right-to-left override",
	8294: "left-to-right isolate",
	8295: "right-to-left isolate",
	8297: "pop directional isolate",
	8233: "paragraph separator",
	65279: "zero width no-break space",
	65532: "object replacement"
}, bd = null;
function xd() {
	if (bd == null && typeof document < "u" && document.body) {
		let e = document.body.style;
		bd = (e.tabSize ?? e.MozTabSize) != null;
	}
	return bd || !1;
}
var Sd = /*@__PURE__*/ W.define({ combine(e) {
	let t = $i(e, {
		render: null,
		specialChars: vd,
		addSpecialChars: null
	});
	return (t.replaceTabs = !xd()) && (t.specialChars = RegExp("	|" + t.specialChars.source, _d)), t.addSpecialChars && (t.specialChars = RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, _d)), t;
} });
function Cd(e = {}) {
	return [Sd.of(e), Td()];
}
var wd = null;
function Td() {
	return wd ||= Cs.fromClass(class {
		constructor(e) {
			this.view = e, this.decorations = K.none, this.decorationCache = Object.create(null), this.decorator = this.makeDecorator(e.state.facet(Sd)), this.decorations = this.decorator.createDeco(e);
		}
		makeDecorator(e) {
			return new gd({
				regexp: e.specialChars,
				decoration: (t, n, r) => {
					let { doc: i } = n.state, a = Jr(t[0], 0);
					if (a == 9) {
						let e = i.lineAt(r), t = n.state.tabSize, a = va(e.text, t, r - e.from);
						return K.replace({ widget: new kd((t - a % t) * this.view.defaultCharacterWidth / this.view.scaleX) });
					}
					return this.decorationCache[a] || (this.decorationCache[a] = K.replace({ widget: new Od(e, a) }));
				},
				boundary: e.replaceTabs ? void 0 : /[^]/
			});
		}
		update(e) {
			let t = e.state.facet(Sd);
			e.startState.facet(Sd) == t ? this.decorations = this.decorator.updateDeco(e, this.decorations) : (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(e.view));
		}
	}, { decorations: (e) => e.decorations });
}
var Ed = "•";
function Dd(e) {
	return e >= 32 ? Ed : e == 10 ? "␤" : String.fromCharCode(9216 + e);
}
var Od = class extends $a {
	constructor(e, t) {
		super(), this.options = e, this.code = t;
	}
	eq(e) {
		return e.code == this.code;
	}
	toDOM(e) {
		let t = Dd(this.code), n = e.state.phrase("Control character") + " " + (yd[this.code] || "0x" + this.code.toString(16)), r = this.options.render && this.options.render(this.code, n, t);
		if (r) return r;
		let i = document.createElement("span");
		return i.textContent = t, i.title = n, i.setAttribute("aria-label", n), i.className = "cm-specialChar", i;
	}
	ignoreEvent() {
		return !1;
	}
}, kd = class extends $a {
	constructor(e) {
		super(), this.width = e;
	}
	eq(e) {
		return e.width == this.width;
	}
	toDOM() {
		let e = document.createElement("span");
		return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
	}
	ignoreEvent() {
		return !1;
	}
};
function Ad() {
	return Md;
}
var jd = /*@__PURE__*/ K.line({ class: "cm-activeLine" }), Md = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.decorations = this.getDeco(e);
	}
	update(e) {
		(e.docChanged || e.selectionSet) && (this.decorations = this.getDeco(e.view));
	}
	getDeco(e) {
		let t = -1, n = [];
		for (let r of e.state.selection.ranges) {
			let i = e.lineBlockAt(r.head);
			i.from > t && (n.push(jd.range(i.from)), t = i.from);
		}
		return K.set(n);
	}
}, { decorations: (e) => e.decorations }), Nd = class extends $a {
	constructor(e) {
		super(), this.content = e;
	}
	toDOM(e) {
		let t = document.createElement("span");
		return t.className = "cm-placeholder", t.style.pointerEvents = "none", t.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(e) : this.content.cloneNode(!0)), t.setAttribute("aria-hidden", "true"), t;
	}
	coordsAt(e) {
		let t = e.firstChild ? fo(e.firstChild) : [];
		if (!t.length) return null;
		let n = window.getComputedStyle(e.parentNode), r = vo(t[0], n.direction != "rtl"), i = parseInt(n.lineHeight);
		return r.bottom - r.top > i * 1.5 ? {
			left: r.left,
			right: r.right,
			top: r.top,
			bottom: r.top + i
		} : r;
	}
	ignoreEvent() {
		return !1;
	}
};
function Pd(e) {
	let t = Cs.fromClass(class {
		constructor(t) {
			this.view = t, this.placeholder = e ? K.set([K.widget({
				widget: new Nd(e),
				side: 1
			}).range(0)]) : K.none;
		}
		get decorations() {
			return this.view.state.doc.length ? K.none : this.placeholder;
		}
	}, { decorations: (e) => e.decorations });
	return typeof e == "string" ? [t, q.contentAttributes.of({ "aria-placeholder": e })] : t;
}
var Fd = 2e3;
function Id(e, t, n) {
	let r = Math.min(t.line, n.line), i = Math.max(t.line, n.line), a = [];
	if (t.off > Fd || n.off > Fd || t.col < 0 || n.col < 0) {
		let o = Math.min(t.off, n.off), s = Math.max(t.off, n.off);
		for (let t = r; t <= i; t++) {
			let n = e.doc.line(t);
			n.length <= s && a.push(U.range(n.from + o, n.to + s));
		}
	} else {
		let o = Math.min(t.col, n.col), s = Math.max(t.col, n.col);
		for (let t = r; t <= i; t++) {
			let n = e.doc.line(t), r = ya(n.text, o, e.tabSize, !0);
			if (r < 0) a.push(U.cursor(n.to));
			else {
				let t = ya(n.text, s, e.tabSize);
				a.push(U.range(n.from + r, n.from + t));
			}
		}
	}
	return a;
}
function Ld(e, t) {
	let n = e.coordsAtPos(e.viewport.from);
	return n ? Math.round(Math.abs((n.left - t) / e.defaultCharacterWidth)) : -1;
}
function Rd(e, t) {
	let n = e.posAtCoords({
		x: t.clientX,
		y: t.clientY
	}, !1), r = e.state.doc.lineAt(n), i = n - r.from, a = i > Fd ? -1 : i == r.length ? Ld(e, t.clientX) : va(r.text, e.state.tabSize, n - r.from);
	return {
		line: r.number,
		col: a,
		off: i
	};
}
function zd(e, t) {
	let n = Rd(e, t), r = e.state.selection;
	return n ? {
		update(e) {
			if (e.docChanged) {
				let t = e.changes.mapPos(e.startState.doc.line(n.line).from), i = e.state.doc.lineAt(t);
				n = {
					line: i.number,
					col: n.col,
					off: Math.min(n.off, i.length)
				}, r = r.map(e.changes);
			}
		},
		get(t, i, a) {
			let o = Rd(e, t);
			if (!o) return r;
			let s = Id(e.state, n, o);
			return s.length ? a ? U.create(s.concat(r.ranges)) : U.create(s) : r;
		}
	} : null;
}
function Bd(e) {
	let t = e?.eventFilter || ((e) => e.altKey && e.button == 0);
	return q.mouseSelectionStyle.of((e, n) => t(n) ? zd(e, n) : null);
}
var Vd = {
	Alt: [18, (e) => !!e.altKey],
	Control: [17, (e) => !!e.ctrlKey],
	Shift: [16, (e) => !!e.shiftKey],
	Meta: [91, (e) => !!e.metaKey]
}, Hd = { style: "cursor: crosshair" };
function Ud(e = {}) {
	let [t, n] = Vd[e.key || "Alt"], r = Cs.fromClass(class {
		constructor(e) {
			this.view = e, this.isDown = !1;
		}
		set(e) {
			this.isDown != e && (this.isDown = e, this.view.update([]));
		}
	}, { eventObservers: {
		keydown(e) {
			this.set(e.keyCode == t || n(e));
		},
		keyup(e) {
			(e.keyCode == t || !n(e)) && this.set(!1);
		},
		mousemove(e) {
			this.set(n(e));
		}
	} });
	return [r, q.contentAttributes.of((e) => e.plugin(r)?.isDown ? Hd : null)];
}
var Wd = "-10000px", Gd = class {
	constructor(e, t, n, r) {
		this.facet = t, this.createTooltipView = n, this.removeTooltipView = r, this.input = e.state.facet(t), this.tooltips = this.input.filter((e) => e);
		let i = null;
		this.tooltipViews = this.tooltips.map((e) => i = n(e, i));
	}
	update(e, t) {
		var n;
		let r = e.state.facet(this.facet), i = r.filter((e) => e);
		if (r === this.input) {
			for (let t of this.tooltipViews) t.update && t.update(e);
			return !1;
		}
		let a = [], o = t ? [] : null;
		for (let n = 0; n < i.length; n++) {
			let r = i[n], s = -1;
			if (r) {
				for (let e = 0; e < this.tooltips.length; e++) {
					let t = this.tooltips[e];
					t && t.create == r.create && (s = e);
				}
				if (s < 0) a[n] = this.createTooltipView(r, n ? a[n - 1] : null), o && (o[n] = !!r.above);
				else {
					let r = a[n] = this.tooltipViews[s];
					o && (o[n] = t[s]), r.update && r.update(e);
				}
			}
		}
		for (let e of this.tooltipViews) a.indexOf(e) < 0 && (this.removeTooltipView(e), (n = e.destroy) == null || n.call(e));
		return t && (o.forEach((e, n) => t[n] = e), t.length = o.length), this.input = r, this.tooltips = i, this.tooltipViews = a, !0;
	}
};
function Kd(e) {
	let t = e.dom.ownerDocument.documentElement;
	return {
		top: 0,
		left: 0,
		bottom: t.clientHeight,
		right: t.clientWidth
	};
}
var qd = /*@__PURE__*/ W.define({ combine: (e) => ({
	position: G.ios ? "absolute" : e.find((e) => e.position)?.position || "fixed",
	parent: e.find((e) => e.parent)?.parent || null,
	tooltipSpace: e.find((e) => e.tooltipSpace)?.tooltipSpace || Kd
}) }), Jd = /*@__PURE__*/ new WeakMap(), Yd = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
		let t = e.state.facet(qd);
		this.position = t.position, this.parent = t.parent, this.classes = e.themeClasses, this.createContainer(), this.measureReq = {
			read: this.readMeasure.bind(this),
			write: this.writeMeasure.bind(this),
			key: this
		}, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new Gd(e, $d, (e, t) => this.createTooltip(e, t), (e) => {
			this.resizeObserver && this.resizeObserver.unobserve(e.dom), e.dom.remove();
		}), this.above = this.manager.tooltips.map((e) => !!e.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((e) => {
			Date.now() > this.lastTransaction - 50 && e.length > 0 && e[e.length - 1].intersectionRatio < 1 && this.measureSoon();
		}, { threshold: [1] }) : null, this.observeIntersection(), e.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
	}
	createContainer() {
		this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
	}
	observeIntersection() {
		if (this.intersectionObserver) {
			this.intersectionObserver.disconnect();
			for (let e of this.manager.tooltipViews) this.intersectionObserver.observe(e.dom);
		}
	}
	measureSoon() {
		this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
			this.measureTimeout = -1, this.maybeMeasure();
		}, 50));
	}
	update(e) {
		e.transactions.length && (this.lastTransaction = Date.now());
		let t = this.manager.update(e, this.above);
		t && this.observeIntersection();
		let n = t || e.geometryChanged, r = e.state.facet(qd);
		if (r.position != this.position && !this.madeAbsolute) {
			this.position = r.position;
			for (let e of this.manager.tooltipViews) e.dom.style.position = this.position;
			n = !0;
		}
		if (r.parent != this.parent) {
			this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
			for (let e of this.manager.tooltipViews) this.container.appendChild(e.dom);
			n = !0;
		} else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
		n && this.maybeMeasure();
	}
	createTooltip(e, t) {
		let n = e.create(this.view), r = t ? t.dom : null;
		if (n.dom.classList.add("cm-tooltip"), e.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
			let e = document.createElement("div");
			e.className = "cm-tooltip-arrow", n.dom.appendChild(e);
		}
		return n.dom.style.position = this.position, n.dom.style.top = Wd, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
	}
	destroy() {
		var e, t, n;
		this.view.win.removeEventListener("resize", this.measureSoon);
		for (let t of this.manager.tooltipViews) t.dom.remove(), (e = t.destroy) == null || e.call(t);
		this.parent && this.container.remove(), (t = this.resizeObserver) == null || t.disconnect(), (n = this.intersectionObserver) == null || n.disconnect(), clearTimeout(this.measureTimeout);
	}
	readMeasure() {
		let e = 1, t = 1, n = !1;
		if (this.position == "fixed" && this.manager.tooltipViews.length) {
			let { dom: e } = this.manager.tooltipViews[0];
			if (G.safari) {
				let t = e.getBoundingClientRect();
				n = Math.abs(t.top + 1e4) > 1 || Math.abs(t.left) > 1;
			} else n = !!e.offsetParent && e.offsetParent != this.container.ownerDocument.body;
		}
		if (n || this.position == "absolute") if (this.parent) {
			let n = this.parent.getBoundingClientRect();
			n.width && n.height && (e = n.width / this.parent.offsetWidth, t = n.height / this.parent.offsetHeight);
		} else ({scaleX: e, scaleY: t} = this.view.viewState);
		let r = this.view.scrollDOM.getBoundingClientRect(), i = Ps(this.view);
		return {
			visible: {
				left: r.left + i.left,
				top: r.top + i.top,
				right: r.right - i.right,
				bottom: r.bottom - i.bottom
			},
			parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
			pos: this.manager.tooltips.map((e, t) => {
				let n = this.manager.tooltipViews[t];
				return n.getCoords ? n.getCoords(e.pos) : this.view.coordsAtPos(e.pos);
			}),
			size: this.manager.tooltipViews.map(({ dom: e }) => e.getBoundingClientRect()),
			space: this.view.state.facet(qd).tooltipSpace(this.view),
			scaleX: e,
			scaleY: t,
			makeAbsolute: n
		};
	}
	writeMeasure(e) {
		if (e.makeAbsolute) {
			this.madeAbsolute = !0, this.position = "absolute";
			for (let e of this.manager.tooltipViews) e.dom.style.position = "absolute";
		}
		let { visible: t, space: n, scaleX: r, scaleY: i } = e, a = [];
		for (let o = 0; o < this.manager.tooltips.length; o++) {
			let s = this.manager.tooltips[o], c = this.manager.tooltipViews[o], { dom: l } = c, u = e.pos[o], d = e.size[o];
			if (!u || s.clip !== !1 && (u.bottom <= Math.max(t.top, n.top) || u.top >= Math.min(t.bottom, n.bottom) || u.right < Math.max(t.left, n.left) - .1 || u.left > Math.min(t.right, n.right) + .1)) {
				l.style.top = Wd;
				continue;
			}
			let f = s.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, p = f ? 7 : 0, m = d.right - d.left, h = Jd.get(c) ?? d.bottom - d.top, g = c.offset || Qd, _ = this.view.textDirection == Fo.LTR, v = d.width > n.right - n.left ? _ ? n.left : n.right - d.width : _ ? Math.max(n.left, Math.min(u.left - (f ? 14 : 0) + g.x, n.right - m)) : Math.min(Math.max(n.left, u.left - m + (f ? 14 : 0) - g.x), n.right - m), y = this.above[o];
			!s.strictSide && (y ? u.top - h - p - g.y < n.top : u.bottom + h + p + g.y > n.bottom) && y == n.bottom - u.bottom > u.top - n.top && (y = this.above[o] = !y);
			let b = (y ? u.top - n.top : n.bottom - u.bottom) - p;
			if (b < h && c.resize !== !1) {
				if (b < this.view.defaultLineHeight) {
					l.style.top = Wd;
					continue;
				}
				Jd.set(c, h), l.style.height = (h = b) / i + "px";
			} else l.style.height && (l.style.height = "");
			let x = y ? u.top - h - p - g.y : u.bottom + p + g.y, S = v + m;
			if (c.overlap !== !0) for (let e of a) e.left < S && e.right > v && e.top < x + h && e.bottom > x && (x = y ? e.top - h - 2 - p : e.bottom + p + 2);
			if (this.position == "absolute" ? (l.style.top = (x - e.parent.top) / i + "px", Xd(l, (v - e.parent.left) / r)) : (l.style.top = x / i + "px", Xd(l, v / r)), f) {
				let e = u.left + (_ ? g.x : -g.x) - (v + 14 - 7);
				f.style.left = e / r + "px";
			}
			c.overlap !== !0 && a.push({
				left: v,
				top: x,
				right: S,
				bottom: x + h
			}), l.classList.toggle("cm-tooltip-above", y), l.classList.toggle("cm-tooltip-below", !y), c.positioned && c.positioned(e.space);
		}
	}
	maybeMeasure() {
		if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) for (let e of this.manager.tooltipViews) e.dom.style.top = Wd;
	}
}, { eventObservers: { scroll() {
	this.maybeMeasure();
} } });
function Xd(e, t) {
	let n = parseInt(e.style.left, 10);
	(isNaN(n) || Math.abs(t - n) > 1) && (e.style.left = t + "px");
}
var Zd = /*@__PURE__*/ q.baseTheme({
	".cm-tooltip": {
		zIndex: 500,
		boxSizing: "border-box"
	},
	"&light .cm-tooltip": {
		border: "1px solid #bbb",
		backgroundColor: "#f5f5f5"
	},
	"&light .cm-tooltip-section:not(:first-child)": { borderTop: "1px solid #bbb" },
	"&dark .cm-tooltip": {
		backgroundColor: "#333338",
		color: "white"
	},
	".cm-tooltip-arrow": {
		height: "7px",
		width: "14px",
		position: "absolute",
		zIndex: -1,
		overflow: "hidden",
		"&:before, &:after": {
			content: "''",
			position: "absolute",
			width: 0,
			height: 0,
			borderLeft: "7px solid transparent",
			borderRight: "7px solid transparent"
		},
		".cm-tooltip-above &": {
			bottom: "-7px",
			"&:before": { borderTop: "7px solid #bbb" },
			"&:after": {
				borderTop: "7px solid #f5f5f5",
				bottom: "1px"
			}
		},
		".cm-tooltip-below &": {
			top: "-7px",
			"&:before": { borderBottom: "7px solid #bbb" },
			"&:after": {
				borderBottom: "7px solid #f5f5f5",
				top: "1px"
			}
		}
	},
	"&dark .cm-tooltip .cm-tooltip-arrow": {
		"&:before": {
			borderTopColor: "#333338",
			borderBottomColor: "#333338"
		},
		"&:after": {
			borderTopColor: "transparent",
			borderBottomColor: "transparent"
		}
	}
}), Qd = {
	x: 0,
	y: 0
}, $d = /*@__PURE__*/ W.define({ enables: [Yd, Zd] }), ef = /*@__PURE__*/ W.define({ combine: (e) => e.reduce((e, t) => e.concat(t), []) }), tf = class e {
	static create(t) {
		return new e(t);
	}
	constructor(e) {
		this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new Gd(e, ef, (e, t) => this.createHostedView(e, t), (e) => e.dom.remove());
	}
	createHostedView(e, t) {
		let n = e.create(this.view);
		return n.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(n.dom, t ? t.dom.nextSibling : this.dom.firstChild), this.mounted && n.mount && n.mount(this.view), n;
	}
	mount(e) {
		for (let t of this.manager.tooltipViews) t.mount && t.mount(e);
		this.mounted = !0;
	}
	positioned(e) {
		for (let t of this.manager.tooltipViews) t.positioned && t.positioned(e);
	}
	update(e) {
		this.manager.update(e);
	}
	destroy() {
		var e;
		for (let t of this.manager.tooltipViews) (e = t.destroy) == null || e.call(t);
	}
	passProp(e) {
		let t;
		for (let n of this.manager.tooltipViews) {
			let r = n[e];
			if (r !== void 0) {
				if (t === void 0) t = r;
				else if (t !== r) return;
			}
		}
		return t;
	}
	get offset() {
		return this.passProp("offset");
	}
	get getCoords() {
		return this.passProp("getCoords");
	}
	get overlap() {
		return this.passProp("overlap");
	}
	get resize() {
		return this.passProp("resize");
	}
}, nf = /*@__PURE__*/ $d.compute([ef], (e) => {
	let t = e.facet(ef);
	return t.length === 0 ? null : {
		pos: Math.min(...t.map((e) => e.pos)),
		end: Math.max(...t.map((e) => e.end ?? e.pos)),
		create: tf.create,
		above: t[0].above,
		arrow: t.some((e) => e.arrow)
	};
}), rf = /*@__PURE__*/ W.define(), af = class {
	constructor(e, t, n, r, i, a) {
		this.view = e, this.source = t, this.field = n, this.locked = r, this.setHover = i, this.hoverTime = a, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = {
			x: 0,
			y: 0,
			target: e.dom,
			time: 0
		}, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
	}
	update(e) {
		this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
	}
	get active() {
		return this.view.state.field(this.field);
	}
	checkHover() {
		if (this.hoverTimeout = -1, this.active.length) return;
		let e = Date.now() - this.lastMove.time;
		e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
	}
	startHover() {
		clearTimeout(this.restartTimeout);
		let { view: e, lastMove: t } = this, n = e.docView.tile.nearest(t.target);
		if (!n) return;
		let r, i = 1;
		if (n.isWidget()) r = n.posAtStart;
		else {
			if (r = e.posAtCoords(t), r == null) return;
			let n = e.coordsAtPos(r);
			if (!n || t.y < n.top || t.y > n.bottom || t.x < n.left - e.defaultCharacterWidth || t.x > n.right + e.defaultCharacterWidth) return;
			let a = e.bidiSpans(e.state.doc.lineAt(r)).find((e) => e.from <= r && e.to >= r), o = a && a.dir == Fo.RTL ? -1 : 1;
			i = t.x < n.left ? -o : o;
		}
		this.activateHover(e, r, i);
	}
	activateHover(e, t, n, r) {
		let i = this.source(e, t, n), a = (t) => {
			if (t && !(Array.isArray(t) && !t.length)) {
				let n = Array.isArray(t) ? t : [t];
				r && this.locked.set(n, r), e.dispatch({ effects: this.setHover.of(n) });
			}
		};
		if (i && "then" in i) {
			let n = this.pending = { pos: t };
			i.then((e) => {
				this.pending == n && (this.pending = null, a(e));
			}, (t) => ys(e.state, t, "hover tooltip"));
		} else a(i);
	}
	get tooltip() {
		let e = this.view.plugin(Yd), t = e ? e.manager.tooltips.findIndex((e) => e.create == tf.create) : -1;
		return t > -1 ? e.manager.tooltipViews[t] : null;
	}
	mousemove(e) {
		this.lastMove = {
			x: e.clientX,
			y: e.clientY,
			target: e.target,
			time: Date.now()
		}, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
		let { active: t, tooltip: n } = this;
		if (t.length && !this.locked.has(t) && n && !sf(n.dom, e) || this.pending) {
			let { pos: n } = t[0] || this.pending, r = t[0]?.end ?? n;
			(n == r ? this.view.posAtCoords(this.lastMove) != n : !cf(this.view, n, r, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
		}
	}
	mouseleave(e) {
		clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
		let { active: t } = this;
		if (t.length && !this.locked.has(t)) {
			let { tooltip: t } = this;
			t && t.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(t.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
		}
	}
	watchTooltipLeave(e) {
		let t = (n) => {
			e.removeEventListener("mouseleave", t);
			let { active: r } = this;
			r.length && !this.locked.has(r) && !this.view.dom.contains(n.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
		};
		e.addEventListener("mouseleave", t);
	}
	destroy() {
		clearTimeout(this.hoverTimeout), clearTimeout(this.restartTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
	}
}, of = 4;
function sf(e, t) {
	let { left: n, right: r, top: i, bottom: a } = e.getBoundingClientRect(), o;
	if (o = e.querySelector(".cm-tooltip-arrow")) {
		let e = o.getBoundingClientRect();
		i = Math.min(e.top, i), a = Math.max(e.bottom, a);
	}
	return t.clientX >= n - of && t.clientX <= r + of && t.clientY >= i - of && t.clientY <= a + of;
}
function cf(e, t, n, r, i, a) {
	let o = e.scrollDOM.getBoundingClientRect(), s = e.documentTop + e.documentPadding.top + e.contentHeight;
	if (o.left > r || o.right < r || o.top > i || Math.min(o.bottom, s) < i) return !1;
	let c = e.posAtCoords({
		x: r,
		y: i
	}, !1);
	return c >= t && c <= n;
}
function lf(e, t = {}) {
	let n = Li.define(), r = /* @__PURE__ */ new WeakMap(), i = gi.define({
		create() {
			return [];
		},
		update(e, a) {
			let o = r.get(e);
			if (e.length && (t.hideOnChange && (a.docChanged || a.selection) || o && o(a) ? e = [] : t.hideOn && (e = e.filter((e) => !t.hideOn(a, e)))), a.docChanged && e.length) {
				let t = [];
				for (let n of e) {
					let e = a.changes.mapPos(n.pos, -1, Qr.TrackDel);
					if (e != null) {
						let r = Object.assign(Object.create(null), n);
						r.pos = e, r.end != null && (r.end = a.changes.mapPos(r.end)), t.push(r);
					}
				}
				e = t;
			}
			for (let t of a.effects) t.is(n) && (e = t.value, o = void 0), (t.is(ff) && !t.value || t.value == i) && (e = []);
			return e.length && o && r.set(e, o), e;
		},
		provide: (e) => ef.from(e)
	}), a = Cs.define((a) => new af(a, e, i, r, n, t.hoverTime || 300));
	return {
		active: i,
		extension: [
			i,
			a,
			rf.of(a),
			nf
		]
	};
}
function uf(e, t, n, r = {}) {
	let i = e.state.facet(rf).map((t) => e.plugin(t)).filter((e) => !!e);
	if (r.tooltip && r.tooltip.active) {
		let e = i.find((e) => e.field == r.tooltip.active);
		e && (i = [e]);
	}
	for (let a of i) a.activateHover(e, t, n, r.until ?? (() => !1));
}
function df(e, t) {
	let n = e.plugin(Yd);
	if (!n) return null;
	let r = n.manager.tooltips.indexOf(t);
	return r < 0 ? null : n.manager.tooltipViews[r];
}
var ff = /*@__PURE__*/ Li.define(), pf = /*@__PURE__*/ W.define({ combine(e) {
	let t, n;
	for (let r of e) t ||= r.topContainer, n ||= r.bottomContainer;
	return {
		topContainer: t,
		bottomContainer: n
	};
} });
function mf(e, t) {
	let n = e.plugin(hf), r = n ? n.specs.indexOf(t) : -1;
	return r > -1 ? n.panels[r] : null;
}
var hf = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.input = e.state.facet(vf), this.specs = this.input.filter((e) => e), this.panels = this.specs.map((t) => t(e));
		let t = e.state.facet(pf);
		this.top = new gf(e, !0, t.topContainer), this.bottom = new gf(e, !1, t.bottomContainer), this.top.sync(this.panels.filter((e) => e.top)), this.bottom.sync(this.panels.filter((e) => !e.top));
		for (let e of this.panels) e.dom.classList.add("cm-panel"), e.mount && e.mount();
	}
	update(e) {
		let t = e.state.facet(pf);
		this.top.container != t.topContainer && (this.top.sync([]), this.top = new gf(e.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new gf(e.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
		let n = e.state.facet(vf);
		if (n != this.input) {
			let t = n.filter((e) => e), r = [], i = [], a = [], o = [];
			for (let n of t) {
				let t = this.specs.indexOf(n), s;
				t < 0 ? (s = n(e.view), o.push(s)) : (s = this.panels[t], s.update && s.update(e)), r.push(s), (s.top ? i : a).push(s);
			}
			this.specs = t, this.panels = r, this.top.sync(i), this.bottom.sync(a);
			for (let e of o) e.dom.classList.add("cm-panel"), e.mount && e.mount();
		} else for (let t of this.panels) t.update && t.update(e);
	}
	destroy() {
		this.top.sync([]), this.bottom.sync([]);
	}
}, { provide: (e) => q.scrollMargins.of((t) => {
	let n = t.plugin(e);
	return n && {
		top: n.top.scrollMargin(),
		bottom: n.bottom.scrollMargin()
	};
}) }), gf = class {
	constructor(e, t, n) {
		this.view = e, this.top = t, this.container = n, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
	}
	sync(e) {
		for (let t of this.panels) t.destroy && e.indexOf(t) < 0 && t.destroy();
		this.panels = e, this.syncDOM();
	}
	syncDOM() {
		if (this.panels.length == 0) {
			this.dom &&= (this.dom.remove(), void 0);
			return;
		}
		if (!this.dom) {
			this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
			let e = this.container || this.view.dom;
			e.insertBefore(this.dom, this.top ? e.firstChild : null);
		}
		let e = this.dom.firstChild;
		for (let t of this.panels) if (t.dom.parentNode == this.dom) {
			for (; e != t.dom;) e = _f(e);
			e = e.nextSibling;
		} else this.dom.insertBefore(t.dom, e);
		for (; e;) e = _f(e);
	}
	scrollMargin() {
		return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
	}
	syncClasses() {
		if (!(!this.container || this.classes == this.view.themeClasses)) {
			for (let e of this.classes.split(" ")) e && this.container.classList.remove(e);
			for (let e of (this.classes = this.view.themeClasses).split(" ")) e && this.container.classList.add(e);
		}
	}
};
function _f(e) {
	let t = e.nextSibling;
	return e.remove(), t;
}
var vf = /*@__PURE__*/ W.define({ enables: hf });
function yf(e, t) {
	let n, r = new Promise((e) => n = e), i = (e) => Cf(e, t, n);
	e.state.field(bf, !1) ? e.dispatch({ effects: xf.of(i) }) : e.dispatch({ effects: Li.appendConfig.of(bf.init(() => [i])) });
	let a = Sf.of(i);
	return {
		close: a,
		result: r.then((t) => ((e.win.queueMicrotask || ((t) => e.win.setTimeout(t, 10)))(() => {
			e.state.field(bf).indexOf(i) > -1 && e.dispatch({ effects: a });
		}), t))
	};
}
var bf = /*@__PURE__*/ gi.define({
	create() {
		return [];
	},
	update(e, t) {
		for (let n of t.effects) n.is(xf) ? e = [n.value].concat(e) : n.is(Sf) && (e = e.filter((e) => e != n.value));
		return e;
	},
	provide: (e) => vf.computeN([e], (t) => t.field(e))
}), xf = /*@__PURE__*/ Li.define(), Sf = /*@__PURE__*/ Li.define();
function Cf(e, t, n) {
	let r = t.content ? t.content(e, () => o(null)) : null;
	if (!r) {
		if (r = Pa("form"), t.input) {
			let e = Pa("input", t.input);
			/^(text|password|number|email|tel|url)$/.test(e.type) && e.classList.add("cm-textfield"), e.name ||= "input", r.appendChild(Pa("label", (t.label || "") + ": ", e));
		} else r.appendChild(document.createTextNode(t.label || ""));
		r.appendChild(document.createTextNode(" ")), r.appendChild(Pa("button", {
			class: "cm-button",
			type: "submit"
		}, t.submitLabel || "OK"));
	}
	let i = r.nodeName == "FORM" ? [r] : r.querySelectorAll("form");
	for (let e = 0; e < i.length; e++) {
		let t = i[e];
		t.addEventListener("keydown", (e) => {
			e.keyCode == 27 ? (e.preventDefault(), o(null)) : e.keyCode == 13 && (e.preventDefault(), o(t));
		}), t.addEventListener("submit", (e) => {
			e.preventDefault(), o(t);
		});
	}
	let a = Pa("div", r, Pa("button", {
		onclick: () => o(null),
		"aria-label": e.state.phrase("close"),
		class: "cm-dialog-close",
		type: "button"
	}, ["×"]));
	t.class && (a.className = t.class), a.classList.add("cm-dialog");
	function o(t) {
		a.contains(a.ownerDocument.activeElement) && e.focus(), n(t);
	}
	return {
		dom: a,
		top: t.top,
		mount: () => {
			if (t.focus) {
				let e;
				e = typeof t.focus == "string" ? r.querySelector(t.focus) : r.querySelector("input") || r.querySelector("button"), e && "select" in e ? e.select() : e && "focus" in e && e.focus();
			}
		}
	};
}
var wf = class extends ea {
	compare(e) {
		return this == e || this.constructor == e.constructor && this.eq(e);
	}
	eq(e) {
		return !1;
	}
	destroy(e) {}
};
wf.prototype.elementClass = "", wf.prototype.toDOM = void 0, wf.prototype.mapMode = Qr.TrackBefore, wf.prototype.startSide = wf.prototype.endSide = -1, wf.prototype.point = !0;
var Tf = /*@__PURE__*/ W.define(), Ef = /*@__PURE__*/ W.define(), Df = {
	class: "",
	renderEmptyElements: !1,
	elementStyle: "",
	markers: () => aa.empty,
	lineMarker: () => null,
	widgetMarker: () => null,
	lineMarkerChange: null,
	initialSpacer: null,
	updateSpacer: null,
	domEventHandlers: {},
	side: "before"
}, Of = /*@__PURE__*/ W.define();
function kf(e) {
	return [jf(), Of.of({
		...Df,
		...e
	})];
}
var Af = /*@__PURE__*/ W.define({ combine: (e) => e.some((e) => e) });
function jf(e) {
	let t = [Mf];
	return e && e.fixed === !1 && t.push(Af.of(!0)), t;
}
var Mf = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.domAfter = null, this.prevViewport = e.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters cm-gutters-before", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = e.state.facet(Of).map((t) => new If(e, t)), this.fixed = !e.state.facet(Af);
		for (let e of this.gutters) e.config.side == "after" ? this.getDOMAfter().appendChild(e.dom) : this.dom.appendChild(e.dom);
		this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), e.scrollDOM.insertBefore(this.dom, e.contentDOM);
	}
	getDOMAfter() {
		return this.domAfter || (this.domAfter = document.createElement("div"), this.domAfter.className = "cm-gutters cm-gutters-after", this.domAfter.setAttribute("aria-hidden", "true"), this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.domAfter.style.position = this.fixed ? "sticky" : "", this.view.scrollDOM.appendChild(this.domAfter)), this.domAfter;
	}
	update(e) {
		if (this.updateGutters(e)) {
			let t = this.prevViewport, n = e.view.viewport, r = Math.min(t.to, n.to) - Math.max(t.from, n.from);
			this.syncGutters(r < (n.to - n.from) * .8);
		}
		if (e.geometryChanged) {
			let e = this.view.contentHeight / this.view.scaleY + "px";
			this.dom.style.minHeight = e, this.domAfter && (this.domAfter.style.minHeight = e);
		}
		this.view.state.facet(Af) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : "", this.domAfter && (this.domAfter.style.position = this.fixed ? "sticky" : "")), this.prevViewport = e.view.viewport;
	}
	syncGutters(e) {
		let t = this.dom.nextSibling;
		e && (this.dom.remove(), this.domAfter && this.domAfter.remove());
		let n = aa.iter(this.view.state.facet(Tf), this.view.viewport.from), r = [], i = this.gutters.map((e) => new Ff(e, this.view.viewport, -this.view.documentPadding.top));
		for (let e of this.view.viewportLineBlocks) if (r.length && (r = []), Array.isArray(e.type)) {
			let t = !0;
			for (let a of e.type) if (a.type == eo.Text && t) {
				Pf(n, r, a.from);
				for (let e of i) e.line(this.view, a, r);
				t = !1;
			} else if (a.widget) for (let e of i) e.widget(this.view, a);
		} else if (e.type == eo.Text) {
			Pf(n, r, e.from);
			for (let t of i) t.line(this.view, e, r);
		} else if (e.widget) for (let t of i) t.widget(this.view, e);
		for (let e of i) e.finish();
		e && (this.view.scrollDOM.insertBefore(this.dom, t), this.domAfter && this.view.scrollDOM.appendChild(this.domAfter));
	}
	updateGutters(e) {
		let t = e.startState.facet(Of), n = e.state.facet(Of), r = e.docChanged || e.heightChanged || e.viewportChanged || !aa.eq(e.startState.facet(Tf), e.state.facet(Tf), e.view.viewport.from, e.view.viewport.to);
		if (t == n) for (let t of this.gutters) t.update(e) && (r = !0);
		else {
			r = !0;
			let i = [];
			for (let r of n) {
				let n = t.indexOf(r);
				n < 0 ? i.push(new If(this.view, r)) : (this.gutters[n].update(e), i.push(this.gutters[n]));
			}
			for (let e of this.gutters) e.dom.remove(), i.indexOf(e) < 0 && e.destroy();
			for (let e of i) e.config.side == "after" ? this.getDOMAfter().appendChild(e.dom) : this.dom.appendChild(e.dom);
			this.gutters = i;
		}
		return r;
	}
	destroy() {
		for (let e of this.gutters) e.destroy();
		this.dom.remove(), this.domAfter && this.domAfter.remove();
	}
}, { provide: (e) => q.scrollMargins.of((t) => {
	let n = t.plugin(e);
	if (!n || n.gutters.length == 0 || !n.fixed) return null;
	let r = n.dom.offsetWidth * t.scaleX, i = n.domAfter ? n.domAfter.offsetWidth * t.scaleX : 0;
	return t.textDirection == Fo.LTR ? {
		left: r,
		right: i
	} : {
		right: r,
		left: i
	};
}) });
function Nf(e) {
	return Array.isArray(e) ? e : [e];
}
function Pf(e, t, n) {
	for (; e.value && e.from <= n;) e.from == n && t.push(e.value), e.next();
}
var Ff = class {
	constructor(e, t, n) {
		this.gutter = e, this.height = n, this.i = 0, this.cursor = aa.iter(e.markers, t.from);
	}
	addElement(e, t, n) {
		let { gutter: r } = this, i = (t.top - this.height) / e.scaleY, a = t.height / e.scaleY;
		if (this.i == r.elements.length) {
			let t = new Lf(e, a, i, n);
			r.elements.push(t), r.dom.appendChild(t.dom);
		} else r.elements[this.i].update(e, a, i, n);
		this.height = t.bottom, this.i++;
	}
	line(e, t, n) {
		let r = [];
		Pf(this.cursor, r, t.from), n.length && (r = r.concat(n));
		let i = this.gutter.config.lineMarker(e, t, r);
		i && r.unshift(i);
		let a = this.gutter;
		r.length == 0 && !a.config.renderEmptyElements || this.addElement(e, t, r);
	}
	widget(e, t) {
		let n = this.gutter.config.widgetMarker(e, t.widget, t), r = n ? [n] : null;
		for (let n of e.state.facet(Ef)) {
			let i = n(e, t.widget, t);
			i && (r ||= []).push(i);
		}
		r && this.addElement(e, t, r);
	}
	finish() {
		let e = this.gutter;
		for (; e.elements.length > this.i;) {
			let t = e.elements.pop();
			e.dom.removeChild(t.dom), t.destroy();
		}
	}
}, If = class {
	constructor(e, t) {
		this.view = e, this.config = t, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
		for (let n in t.domEventHandlers) this.dom.addEventListener(n, (r) => {
			let i = r.target, a;
			if (i != this.dom && this.dom.contains(i)) {
				for (; i.parentNode != this.dom;) i = i.parentNode;
				let e = i.getBoundingClientRect();
				a = (e.top + e.bottom) / 2;
			} else a = r.clientY;
			let o = e.lineBlockAtHeight(a - e.documentTop);
			t.domEventHandlers[n](e, o, r) && r.preventDefault();
		});
		this.markers = Nf(t.markers(e)), t.initialSpacer && (this.spacer = new Lf(e, 0, 0, [t.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
	}
	update(e) {
		let t = this.markers;
		if (this.markers = Nf(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
			let t = this.config.updateSpacer(this.spacer.markers[0], e);
			t != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [t]);
		}
		let n = e.view.viewport;
		return !aa.eq(this.markers, t, n.from, n.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
	}
	destroy() {
		for (let e of this.elements) e.destroy();
	}
}, Lf = class {
	constructor(e, t, n, r) {
		this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, t, n, r);
	}
	update(e, t, n, r) {
		this.height != t && (this.height = t, this.dom.style.height = t + "px"), this.above != n && (this.dom.style.marginTop = (this.above = n) ? n + "px" : ""), Rf(this.markers, r) || this.setMarkers(e, r);
	}
	setMarkers(e, t) {
		let n = "cm-gutterElement", r = this.dom.firstChild;
		for (let i = 0, a = 0;;) {
			let o = a, s = i < t.length ? t[i++] : null, c = !1;
			if (s) {
				let e = s.elementClass;
				e && (n += " " + e);
				for (let e = a; e < this.markers.length; e++) if (this.markers[e].compare(s)) {
					o = e, c = !0;
					break;
				}
			} else o = this.markers.length;
			for (; a < o;) {
				let e = this.markers[a++];
				if (e.toDOM) {
					e.destroy(r);
					let t = r.nextSibling;
					r.remove(), r = t;
				}
			}
			if (!s) break;
			s.toDOM && (c ? r = r.nextSibling : this.dom.insertBefore(s.toDOM(e), r)), c && a++;
		}
		this.dom.className = n, this.markers = t;
	}
	destroy() {
		this.setMarkers(null, []);
	}
};
function Rf(e, t) {
	if (e.length != t.length) return !1;
	for (let n = 0; n < e.length; n++) if (!e[n].compare(t[n])) return !1;
	return !0;
}
var zf = /*@__PURE__*/ W.define(), Bf = /*@__PURE__*/ W.define(), Vf = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		formatNumber: String,
		domEventHandlers: {}
	}, { domEventHandlers(e, t) {
		let n = Object.assign({}, e);
		for (let e in t) {
			let r = n[e], i = t[e];
			n[e] = r ? (e, t, n) => r(e, t, n) || i(e, t, n) : i;
		}
		return n;
	} });
} }), Hf = class extends wf {
	constructor(e) {
		super(), this.number = e;
	}
	eq(e) {
		return this.number == e.number;
	}
	toDOM() {
		return document.createTextNode(this.number);
	}
};
function Uf(e, t) {
	return e.state.facet(Vf).formatNumber(t, e.state);
}
var Wf = /*@__PURE__*/ Of.compute([Vf], (e) => ({
	class: "cm-lineNumbers",
	renderEmptyElements: !1,
	markers(e) {
		return e.state.facet(zf);
	},
	lineMarker(e, t, n) {
		return n.some((e) => e.toDOM) ? null : new Hf(Uf(e, e.state.doc.lineAt(t.from).number));
	},
	widgetMarker: (e, t, n) => {
		for (let r of e.state.facet(Bf)) {
			let i = r(e, t, n);
			if (i) return i;
		}
		return null;
	},
	lineMarkerChange: (e) => e.startState.facet(Vf) != e.state.facet(Vf),
	initialSpacer(e) {
		return new Hf(Uf(e, Kf(e.state.doc.lines)));
	},
	updateSpacer(e, t) {
		let n = Uf(t.view, Kf(t.view.state.doc.lines));
		return n == e.number ? e : new Hf(n);
	},
	domEventHandlers: e.facet(Vf).domEventHandlers,
	side: "before"
}));
function Gf(e = {}) {
	return [
		Vf.of(e),
		jf(),
		Wf
	];
}
function Kf(e) {
	let t = 9;
	for (; t < e;) t = t * 10 + 9;
	return t;
}
var qf = /*@__PURE__*/ new class extends wf {
	constructor() {
		super(...arguments), this.elementClass = "cm-activeLineGutter";
	}
}(), Jf = /*@__PURE__*/ Tf.compute(["selection"], (e) => {
	let t = [], n = -1;
	for (let r of e.selection.ranges) {
		let i = e.doc.lineAt(r.head).from;
		i > n && (n = i, t.push(qf.range(i)));
	}
	return aa.of(t);
});
function Yf() {
	return Jf;
}
//#endregion
//#region ../../../node_modules/@lezer/common/dist/index.js
var Xf = 1024, Zf = 0, Qf = class {
	constructor(e, t) {
		this.from = e, this.to = t;
	}
}, $f = class {
	constructor(e = {}) {
		this.id = Zf++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
			throw Error("This node type doesn't define a deserialize function");
		}), this.combine = e.combine || null;
	}
	add(e) {
		if (this.perNode) throw RangeError("Can't add per-node props to node types");
		return typeof e != "function" && (e = np.match(e)), (t) => {
			let n = e(t);
			return n === void 0 ? null : [this, n];
		};
	}
};
$f.closedBy = new $f({ deserialize: (e) => e.split(" ") }), $f.openedBy = new $f({ deserialize: (e) => e.split(" ") }), $f.group = new $f({ deserialize: (e) => e.split(" ") }), $f.isolate = new $f({ deserialize: (e) => {
	if (e && e != "rtl" && e != "ltr" && e != "auto") throw RangeError("Invalid value for isolate: " + e);
	return e || "auto";
} }), $f.contextHash = new $f({ perNode: !0 }), $f.lookAhead = new $f({ perNode: !0 }), $f.mounted = new $f({ perNode: !0 });
var ep = class {
	constructor(e, t, n, r = !1) {
		this.tree = e, this.overlay = t, this.parser = n, this.bracketed = r;
	}
	static get(e) {
		return e && e.props && e.props[$f.mounted.id];
	}
}, tp = Object.create(null), np = class e {
	constructor(e, t, n, r = 0) {
		this.name = e, this.props = t, this.id = n, this.flags = r;
	}
	static define(t) {
		let n = t.props && t.props.length ? Object.create(null) : tp, r = !!t.top | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new e(t.name || "", n, t.id, r);
		if (t.props) {
			for (let e of t.props) if (Array.isArray(e) || (e = e(i)), e) {
				if (e[0].perNode) throw RangeError("Can't store a per-node prop on a node type");
				n[e[0].id] = e[1];
			}
		}
		return i;
	}
	prop(e) {
		return this.props[e.id];
	}
	get isTop() {
		return (this.flags & 1) > 0;
	}
	get isSkipped() {
		return (this.flags & 2) > 0;
	}
	get isError() {
		return (this.flags & 4) > 0;
	}
	get isAnonymous() {
		return (this.flags & 8) > 0;
	}
	is(e) {
		if (typeof e == "string") {
			if (this.name == e) return !0;
			let t = this.prop($f.group);
			return t ? t.indexOf(e) > -1 : !1;
		}
		return this.id == e;
	}
	static match(e) {
		let t = Object.create(null);
		for (let n in e) for (let r of n.split(" ")) t[r] = e[n];
		return (e) => {
			for (let n = e.prop($f.group), r = -1; r < (n ? n.length : 0); r++) {
				let i = t[r < 0 ? e.name : n[r]];
				if (i) return i;
			}
		};
	}
};
np.none = new np("", Object.create(null), 0, 8);
var rp = class e {
	constructor(e) {
		this.types = e;
		for (let t = 0; t < e.length; t++) if (e[t].id != t) throw RangeError("Node type ids should correspond to array positions when creating a node set");
	}
	extend(...t) {
		let n = [];
		for (let e of this.types) {
			let r = null;
			for (let n of t) {
				let t = n(e);
				if (t) {
					r ||= Object.assign({}, e.props);
					let n = t[1], i = t[0];
					i.combine && i.id in r && (n = i.combine(r[i.id], n)), r[i.id] = n;
				}
			}
			n.push(r ? new np(e.name, r, e.id, e.flags) : e);
		}
		return new e(n);
	}
}, ip = /* @__PURE__ */ new WeakMap(), ap = /* @__PURE__ */ new WeakMap(), op;
(function(e) {
	e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays", e[e.EnterBracketed = 16] = "EnterBracketed";
})(op ||= {});
var sp = class e {
	constructor(e, t, n, r, i) {
		if (this.type = e, this.children = t, this.positions = n, this.length = r, this.props = null, i && i.length) {
			this.props = Object.create(null);
			for (let [e, t] of i) this.props[typeof e == "number" ? e : e.id] = t;
		}
	}
	toString() {
		let e = ep.get(this);
		if (e && !e.overlay) return e.tree.toString();
		let t = "";
		for (let e of this.children) {
			let n = e.toString();
			n && (t && (t += ","), t += n);
		}
		return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (t.length ? "(" + t + ")" : "") : t;
	}
	cursor(e = 0) {
		return new xp(this.topNode, e);
	}
	cursorAt(e, t = 0, n = 0) {
		let r = new xp(ip.get(this) || this.topNode);
		return r.moveTo(e, t), ip.set(this, r._tree), r;
	}
	get topNode() {
		return new pp(this, 0, 0, null);
	}
	resolve(e, t = 0) {
		let n = dp(ip.get(this) || this.topNode, e, t, !1);
		return ip.set(this, n), n;
	}
	resolveInner(e, t = 0) {
		let n = dp(ap.get(this) || this.topNode, e, t, !0);
		return ap.set(this, n), n;
	}
	resolveStack(e, t = 0) {
		return bp(this, e, t);
	}
	iterate(e) {
		let { enter: t, leave: n, from: r = 0, to: i = this.length } = e, a = e.mode || 0, o = (a & op.IncludeAnonymous) > 0;
		for (let e = this.cursor(a | op.IncludeAnonymous);;) {
			let a = !1;
			if (e.from <= i && e.to >= r && (!o && e.type.isAnonymous || t(e) !== !1)) {
				if (e.firstChild()) continue;
				a = !0;
			}
			for (; a && n && (o || !e.type.isAnonymous) && n(e), !e.nextSibling();) {
				if (!e.parent()) return;
				a = !0;
			}
		}
	}
	prop(e) {
		return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
	}
	get propValues() {
		let e = [];
		if (this.props) for (let t in this.props) e.push([+t, this.props[t]]);
		return e;
	}
	balance(t = {}) {
		return this.children.length <= 8 ? this : Ep(np.none, this.children, this.positions, 0, this.children.length, 0, this.length, (t, n, r) => new e(this.type, t, n, r, this.propValues), t.makeTree || ((t, n, r) => new e(np.none, t, n, r)));
	}
	static build(e) {
		return Cp(e);
	}
};
sp.empty = new sp(np.none, [], [], 0);
var cp = class e {
	constructor(e, t) {
		this.buffer = e, this.index = t;
	}
	get id() {
		return this.buffer[this.index - 4];
	}
	get start() {
		return this.buffer[this.index - 3];
	}
	get end() {
		return this.buffer[this.index - 2];
	}
	get size() {
		return this.buffer[this.index - 1];
	}
	get pos() {
		return this.index;
	}
	next() {
		this.index -= 4;
	}
	fork() {
		return new e(this.buffer, this.index);
	}
}, lp = class e {
	constructor(e, t, n) {
		this.buffer = e, this.length = t, this.set = n;
	}
	get type() {
		return np.none;
	}
	toString() {
		let e = [];
		for (let t = 0; t < this.buffer.length;) e.push(this.childString(t)), t = this.buffer[t + 3];
		return e.join(",");
	}
	childString(e) {
		let t = this.buffer[e], n = this.buffer[e + 3], r = this.set.types[t], i = r.name;
		if (/\W/.test(i) && !r.isError && (i = JSON.stringify(i)), e += 4, n == e) return i;
		let a = [];
		for (; e < n;) a.push(this.childString(e)), e = this.buffer[e + 3];
		return i + "(" + a.join(",") + ")";
	}
	findChild(e, t, n, r, i) {
		let { buffer: a } = this, o = -1;
		for (let s = e; s != t && !(up(i, r, a[s + 1], a[s + 2]) && (o = s, n > 0)); s = a[s + 3]);
		return o;
	}
	slice(t, n, r) {
		let i = this.buffer, a = new Uint16Array(n - t), o = 0;
		for (let e = t, s = 0; e < n;) {
			a[s++] = i[e++], a[s++] = i[e++] - r;
			let n = a[s++] = i[e++] - r;
			a[s++] = i[e++] - t, o = Math.max(o, n);
		}
		return new e(a, o, this.set);
	}
};
function up(e, t, n, r) {
	switch (e) {
		case -2: return n < t;
		case -1: return r >= t && n < t;
		case 0: return n < t && r > t;
		case 1: return n <= t && r > t;
		case 2: return r > t;
		case 4: return !0;
	}
}
function dp(e, t, n, r) {
	for (; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t);) {
		let t = !r && e instanceof pp && e.index < 0 ? null : e.parent;
		if (!t) return e;
		e = t;
	}
	let i = r ? 0 : op.IgnoreOverlays;
	if (r) for (let r = e, a = r.parent; a; r = a, a = r.parent) r instanceof pp && r.index < 0 && a.enter(t, n, i)?.from != r.from && (e = a);
	for (;;) {
		let r = e.enter(t, n, i);
		if (!r) return e;
		e = r;
	}
}
var fp = class {
	cursor(e = 0) {
		return new xp(this, e);
	}
	getChild(e, t = null, n = null) {
		let r = mp(this, e, t, n);
		return r.length ? r[0] : null;
	}
	getChildren(e, t = null, n = null) {
		return mp(this, e, t, n);
	}
	resolve(e, t = 0) {
		return dp(this, e, t, !1);
	}
	resolveInner(e, t = 0) {
		return dp(this, e, t, !0);
	}
	matchContext(e) {
		return hp(this.parent, e);
	}
	enterUnfinishedNodesBefore(e) {
		let t = this.childBefore(e), n = this;
		for (; t;) {
			let e = t.lastChild;
			if (!e || e.to != t.to) break;
			e.type.isError && e.from == e.to ? (n = t, t = e.prevSibling) : t = e;
		}
		return n;
	}
	get node() {
		return this;
	}
	get next() {
		return this.parent;
	}
}, pp = class e extends fp {
	constructor(e, t, n, r) {
		super(), this._tree = e, this.from = t, this.index = n, this._parent = r;
	}
	get type() {
		return this._tree.type;
	}
	get name() {
		return this._tree.type.name;
	}
	get to() {
		return this.from + this._tree.length;
	}
	nextChild(t, n, r, i, a = 0) {
		for (let o = this;;) {
			for (let { children: s, positions: c } = o._tree, l = n > 0 ? s.length : -1; t != l; t += n) {
				let l = s[t], u = c[t] + o.from, d;
				if (!(!(a & op.EnterBracketed && l instanceof sp && (d = ep.get(l)) && !d.overlay && d.bracketed && r >= u && r <= u + l.length) && !up(i, r, u, u + l.length))) {
					if (l instanceof lp) {
						if (a & op.ExcludeBuffers) continue;
						let e = l.findChild(0, l.buffer.length, n, r - u, i);
						if (e > -1) return new _p(new gp(o, l, t, u), null, e);
					} else if (a & op.IncludeAnonymous || !l.type.isAnonymous || Sp(l)) {
						let s;
						if (!(a & op.IgnoreMounts) && (s = ep.get(l)) && !s.overlay) return new e(s.tree, u, t, o);
						let c = new e(l, u, t, o);
						return a & op.IncludeAnonymous || !c.type.isAnonymous ? c : c.nextChild(n < 0 ? l.children.length - 1 : 0, n, r, i, a);
					}
				}
			}
			if (a & op.IncludeAnonymous || !o.type.isAnonymous || (t = o.index >= 0 ? o.index + n : n < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o)) return null;
		}
	}
	get firstChild() {
		return this.nextChild(0, 1, 0, 4);
	}
	get lastChild() {
		return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
	}
	childAfter(e) {
		return this.nextChild(0, 1, e, 2);
	}
	childBefore(e) {
		return this.nextChild(this._tree.children.length - 1, -1, e, -2);
	}
	prop(e) {
		return this._tree.prop(e);
	}
	enter(t, n, r = 0) {
		let i;
		if (!(r & op.IgnoreOverlays) && (i = ep.get(this._tree)) && i.overlay) {
			let a = t - this.from, o = r & op.EnterBracketed && i.bracketed;
			for (let { from: t, to: r } of i.overlay) if ((n > 0 || o ? t <= a : t < a) && (n < 0 || o ? r >= a : r > a)) return new e(i.tree, i.overlay[0].from + this.from, -1, this);
		}
		return this.nextChild(0, 1, t, n, r);
	}
	nextSignificantParent() {
		let e = this;
		for (; e.type.isAnonymous && e._parent;) e = e._parent;
		return e;
	}
	get parent() {
		return this._parent ? this._parent.nextSignificantParent() : null;
	}
	get nextSibling() {
		return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
	}
	get prevSibling() {
		return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
	}
	get tree() {
		return this._tree;
	}
	toTree() {
		return this._tree;
	}
	toString() {
		return this._tree.toString();
	}
};
function mp(e, t, n, r) {
	let i = e.cursor(), a = [];
	if (!i.firstChild()) return a;
	if (n != null) {
		for (let e = !1; !e;) if (e = i.type.is(n), !i.nextSibling()) return a;
	}
	for (;;) {
		if (r != null && i.type.is(r)) return a;
		if (i.type.is(t) && a.push(i.node), !i.nextSibling()) return r == null ? a : [];
	}
}
function hp(e, t, n = t.length - 1) {
	for (let r = e; n >= 0; r = r.parent) {
		if (!r) return !1;
		if (!r.type.isAnonymous) {
			if (t[n] && t[n] != r.name) return !1;
			n--;
		}
	}
	return !0;
}
var gp = class {
	constructor(e, t, n, r) {
		this.parent = e, this.buffer = t, this.index = n, this.start = r;
	}
}, _p = class e extends fp {
	get name() {
		return this.type.name;
	}
	get from() {
		return this.context.start + this.context.buffer.buffer[this.index + 1];
	}
	get to() {
		return this.context.start + this.context.buffer.buffer[this.index + 2];
	}
	constructor(e, t, n) {
		super(), this.context = e, this._parent = t, this.index = n, this.type = e.buffer.set.types[e.buffer.buffer[n]];
	}
	child(t, n, r) {
		let { buffer: i } = this.context, a = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
		return a < 0 ? null : new e(this.context, this, a);
	}
	get firstChild() {
		return this.child(1, 0, 4);
	}
	get lastChild() {
		return this.child(-1, 0, 4);
	}
	childAfter(e) {
		return this.child(1, e, 2);
	}
	childBefore(e) {
		return this.child(-1, e, -2);
	}
	prop(e) {
		return this.type.prop(e);
	}
	enter(t, n, r = 0) {
		if (r & op.ExcludeBuffers) return null;
		let { buffer: i } = this.context, a = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
		return a < 0 ? null : new e(this.context, this, a);
	}
	get parent() {
		return this._parent || this.context.parent.nextSignificantParent();
	}
	externalSibling(e) {
		return this._parent ? null : this.context.parent.nextChild(this.context.index + e, e, 0, 4);
	}
	get nextSibling() {
		let { buffer: t } = this.context, n = t.buffer[this.index + 3];
		return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new e(this.context, this._parent, n) : this.externalSibling(1);
	}
	get prevSibling() {
		let { buffer: t } = this.context, n = this._parent ? this._parent.index + 4 : 0;
		return this.index == n ? this.externalSibling(-1) : new e(this.context, this._parent, t.findChild(n, this.index, -1, 0, 4));
	}
	get tree() {
		return null;
	}
	toTree() {
		let e = [], t = [], { buffer: n } = this.context, r = this.index + 4, i = n.buffer[this.index + 3];
		if (i > r) {
			let a = n.buffer[this.index + 1];
			e.push(n.slice(r, i, a)), t.push(0);
		}
		return new sp(this.type, e, t, this.to - this.from);
	}
	toString() {
		return this.context.buffer.childString(this.index);
	}
};
function vp(e) {
	if (!e.length) return null;
	let t = 0, n = e[0];
	for (let r = 1; r < e.length; r++) {
		let i = e[r];
		(i.from > n.from || i.to < n.to) && (n = i, t = r);
	}
	let r = n instanceof pp && n.index < 0 ? null : n.parent, i = e.slice();
	return r ? i[t] = r : i.splice(t, 1), new yp(i, n);
}
var yp = class {
	constructor(e, t) {
		this.heads = e, this.node = t;
	}
	get next() {
		return vp(this.heads);
	}
};
function bp(e, t, n) {
	let r = e.resolveInner(t, n), i = null;
	for (let e = r instanceof pp ? r : r.context.parent; e; e = e.parent) if (e.index < 0) {
		let a = e.parent;
		(i ||= [r]).push(a.resolve(t, n)), e = a;
	} else {
		let a = ep.get(e.tree);
		if (a && a.overlay && a.overlay[0].from <= t && a.overlay[a.overlay.length - 1].to >= t) {
			let o = new pp(a.tree, a.overlay[0].from + e.from, -1, e);
			(i ||= [r]).push(dp(o, t, n, !1));
		}
	}
	return i ? vp(i) : r;
}
var xp = class {
	get name() {
		return this.type.name;
	}
	constructor(e, t = 0) {
		if (this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, this.mode = t & ~op.EnterBracketed, e instanceof pp) this.yieldNode(e);
		else {
			this._tree = e.context.parent, this.buffer = e.context;
			for (let t = e._parent; t; t = t._parent) this.stack.unshift(t.index);
			this.bufferNode = e, this.yieldBuf(e.index);
		}
	}
	yieldNode(e) {
		return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
	}
	yieldBuf(e, t) {
		this.index = e;
		let { start: n, buffer: r } = this.buffer;
		return this.type = t || r.set.types[r.buffer[e]], this.from = n + r.buffer[e + 1], this.to = n + r.buffer[e + 2], !0;
	}
	yield(e) {
		return e ? e instanceof pp ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
	}
	toString() {
		return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
	}
	enterChild(e, t, n) {
		if (!this.buffer) return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
		let { buffer: r } = this.buffer, i = r.findChild(this.index + 4, r.buffer[this.index + 3], e, t - this.buffer.start, n);
		return i < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(i));
	}
	firstChild() {
		return this.enterChild(1, 0, 4);
	}
	lastChild() {
		return this.enterChild(-1, 0, 4);
	}
	childAfter(e) {
		return this.enterChild(1, e, 2);
	}
	childBefore(e) {
		return this.enterChild(-1, e, -2);
	}
	enter(e, t, n = this.mode) {
		return this.buffer ? n & op.ExcludeBuffers ? !1 : this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
	}
	parent() {
		if (!this.buffer) return this.yieldNode(this.mode & op.IncludeAnonymous ? this._tree._parent : this._tree.parent);
		if (this.stack.length) return this.yieldBuf(this.stack.pop());
		let e = this.mode & op.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
		return this.buffer = null, this.yieldNode(e);
	}
	sibling(e) {
		if (!this.buffer) return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
		let { buffer: t } = this.buffer, n = this.stack.length - 1;
		if (e < 0) {
			let e = n < 0 ? 0 : this.stack[n] + 4;
			if (this.index != e) return this.yieldBuf(t.findChild(e, this.index, -1, 0, 4));
		} else {
			let e = t.buffer[this.index + 3];
			if (e < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3])) return this.yieldBuf(e);
		}
		return n < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
	}
	nextSibling() {
		return this.sibling(1);
	}
	prevSibling() {
		return this.sibling(-1);
	}
	atLastNode(e) {
		let t, n, { buffer: r } = this;
		if (r) {
			if (e > 0) {
				if (this.index < r.buffer.buffer.length) return !1;
			} else for (let e = 0; e < this.index; e++) if (r.buffer.buffer[e + 3] < this.index) return !1;
			({index: t, parent: n} = r);
		} else ({index: t, _parent: n} = this._tree);
		for (; n; {index: t, _parent: n} = n) if (t > -1) for (let r = t + e, i = e < 0 ? -1 : n._tree.children.length; r != i; r += e) {
			let e = n._tree.children[r];
			if (this.mode & op.IncludeAnonymous || e instanceof lp || !e.type.isAnonymous || Sp(e)) return !1;
		}
		return !0;
	}
	move(e, t) {
		if (t && this.enterChild(e, 0, 4)) return !0;
		for (;;) {
			if (this.sibling(e)) return !0;
			if (this.atLastNode(e) || !this.parent()) return !1;
		}
	}
	next(e = !0) {
		return this.move(1, e);
	}
	prev(e = !0) {
		return this.move(-1, e);
	}
	moveTo(e, t = 0) {
		for (; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent(););
		for (; this.enterChild(1, e, t););
		return this;
	}
	get node() {
		if (!this.buffer) return this._tree;
		let e = this.bufferNode, t = null, n = 0;
		if (e && e.context == this.buffer) scan: for (let r = this.index, i = this.stack.length; i >= 0;) {
			for (let a = e; a; a = a._parent) if (a.index == r) {
				if (r == this.index) return a;
				t = a, n = i + 1;
				break scan;
			}
			r = this.stack[--i];
		}
		for (let e = n; e < this.stack.length; e++) t = new _p(this.buffer, t, this.stack[e]);
		return this.bufferNode = new _p(this.buffer, t, this.index);
	}
	get tree() {
		return this.buffer ? null : this._tree._tree;
	}
	iterate(e, t) {
		for (let n = 0;;) {
			let r = !1;
			if (this.type.isAnonymous || e(this) !== !1) {
				if (this.firstChild()) {
					n++;
					continue;
				}
				this.type.isAnonymous || (r = !0);
			}
			for (;;) {
				if (r && t && t(this), r = this.type.isAnonymous, !n) return;
				if (this.nextSibling()) break;
				this.parent(), n--, r = !0;
			}
		}
	}
	matchContext(e) {
		if (!this.buffer) return hp(this.node.parent, e);
		let { buffer: t } = this.buffer, { types: n } = t.set;
		for (let r = e.length - 1, i = this.stack.length - 1; r >= 0; i--) {
			if (i < 0) return hp(this._tree, e, r);
			let a = n[t.buffer[this.stack[i]]];
			if (!a.isAnonymous) {
				if (e[r] && e[r] != a.name) return !1;
				r--;
			}
		}
		return !0;
	}
};
function Sp(e) {
	return e.children.some((e) => e instanceof lp || !e.type.isAnonymous || Sp(e));
}
function Cp(e) {
	let { buffer: t, nodeSet: n, maxBufferLength: r = Xf, reused: i = [], minRepeatType: a = n.types.length } = e, o = Array.isArray(t) ? new cp(t, t.length) : t, s = n.types, c = 0, l = 0;
	function u(e, t, _, v, y, b) {
		let { id: x, start: S, end: C, size: w } = o, T = l, E = c;
		if (w < 0) if (o.next(), w == -1) {
			let t = i[x];
			_.push(t), v.push(S - e);
			return;
		} else if (w == -3) {
			c = x;
			return;
		} else if (w == -4) {
			l = x;
			return;
		} else throw RangeError(`Unrecognized record size: ${w}`);
		let D = s[x], O, k, ee = S - e;
		if (C - S <= r && (k = h(o.pos - t, y))) {
			let t = new Uint16Array(k.size - k.skip), r = o.pos - k.size, i = t.length;
			for (; o.pos > r;) i = g(k.start, t, i);
			O = new lp(t, C - k.start, n), ee = k.start - e;
		} else {
			let e = o.pos - w;
			o.next();
			let t = [], n = [], i = x >= a ? x : -1, s = 0, c = C;
			for (; o.pos > e;) i >= 0 && o.id == i && o.size >= 0 ? (o.end <= c - r && (p(t, n, S, s, o.end, c, i, T, E), s = t.length, c = o.end), o.next()) : b > 2500 ? d(S, e, t, n) : u(S, e, t, n, i, b + 1);
			if (i >= 0 && s > 0 && s < t.length && p(t, n, S, s, S, c, i, T, E), t.reverse(), n.reverse(), i > -1 && s > 0) {
				let e = f(D, E);
				O = Ep(D, t, n, 0, t.length, 0, C - S, e, e);
			} else O = m(D, t, n, C - S, T - C, E);
		}
		_.push(O), v.push(ee);
	}
	function d(e, t, i, a) {
		let s = [], c = 0, l = -1;
		for (; o.pos > t;) {
			let { id: e, start: t, end: n, size: i } = o;
			if (i > 4) o.next();
			else if (l > -1 && t < l) break;
			else l < 0 && (l = n - r), s.push(e, t, n), c++, o.next();
		}
		if (c) {
			let t = new Uint16Array(c * 4), r = s[s.length - 2];
			for (let e = s.length - 3, n = 0; e >= 0; e -= 3) t[n++] = s[e], t[n++] = s[e + 1] - r, t[n++] = s[e + 2] - r, t[n++] = n;
			i.push(new lp(t, s[2] - r, n)), a.push(r - e);
		}
	}
	function f(e, t) {
		return (n, r, i) => {
			let a = 0, o = n.length - 1, s, c;
			if (o >= 0 && (s = n[o]) instanceof sp) {
				if (!o && s.type == e && s.length == i) return s;
				(c = s.prop($f.lookAhead)) && (a = r[o] + s.length + c);
			}
			return m(e, n, r, i, a, t);
		};
	}
	function p(e, t, r, i, a, o, s, c, l) {
		let u = [], d = [];
		for (; e.length > i;) u.push(e.pop()), d.push(t.pop() + r - a);
		e.push(m(n.types[s], u, d, o - a, c - o, l)), t.push(a - r);
	}
	function m(e, t, n, r, i, a, o) {
		if (a) {
			let e = [$f.contextHash, a];
			o = o ? [e].concat(o) : [e];
		}
		if (i > 25) {
			let e = [$f.lookAhead, i];
			o = o ? [e].concat(o) : [e];
		}
		return new sp(e, t, n, r, o);
	}
	function h(e, t) {
		let n = o.fork(), i = 0, s = 0, c = 0, l = n.end - r, u = {
			size: 0,
			start: 0,
			skip: 0
		};
		scan: for (let r = n.pos - e; n.pos > r;) {
			let e = n.size;
			if (n.id == t && e >= 0) {
				u.size = i, u.start = s, u.skip = c, c += 4, i += 4, n.next();
				continue;
			}
			let o = n.pos - e;
			if (e < 0 || o < r || n.start < l) break;
			let d = n.id >= a ? 4 : 0, f = n.start;
			for (n.next(); n.pos > o;) {
				if (n.size < 0) if (n.size == -3 || n.size == -4) d += 4;
				else break scan;
				else n.id >= a && (d += 4);
				n.next();
			}
			s = f, i += e, c += d;
		}
		return (t < 0 || i == e) && (u.size = i, u.start = s, u.skip = c), u.size > 4 ? u : void 0;
	}
	function g(e, t, n) {
		let { id: r, start: i, end: s, size: u } = o;
		if (o.next(), u >= 0 && r < a) {
			let a = n;
			if (u > 4) {
				let r = o.pos - (u - 4);
				for (; o.pos > r;) n = g(e, t, n);
			}
			t[--n] = a, t[--n] = s - e, t[--n] = i - e, t[--n] = r;
		} else u == -3 ? c = r : u == -4 && (l = r);
		return n;
	}
	let _ = [], v = [];
	for (; o.pos > 0;) u(e.start || 0, e.bufferStart || 0, _, v, -1, 0);
	let y = e.length ?? (_.length ? v[0] + _[0].length : 0);
	return new sp(s[e.topID], _.reverse(), v.reverse(), y);
}
var wp = /* @__PURE__ */ new WeakMap();
function Tp(e, t) {
	if (!e.isAnonymous || t instanceof lp || t.type != e) return 1;
	let n = wp.get(t);
	if (n == null) {
		n = 1;
		for (let r of t.children) {
			if (r.type != e || !(r instanceof sp)) {
				n = 1;
				break;
			}
			n += Tp(e, r);
		}
		wp.set(t, n);
	}
	return n;
}
function Ep(e, t, n, r, i, a, o, s, c) {
	let l = 0;
	for (let n = r; n < i; n++) l += Tp(e, t[n]);
	let u = Math.ceil(l * 1.5 / 8), d = [], f = [];
	function p(t, n, r, i, o) {
		for (let s = r; s < i;) {
			let r = s, l = n[s], m = Tp(e, t[s]);
			for (s++; s < i; s++) {
				let n = Tp(e, t[s]);
				if (m + n >= u) break;
				m += n;
			}
			if (s == r + 1) {
				if (m > u) {
					let e = t[r];
					p(e.children, e.positions, 0, e.children.length, n[r] + o);
					continue;
				}
				d.push(t[r]);
			} else {
				let i = n[s - 1] + t[s - 1].length - l;
				d.push(Ep(e, t, n, r, s, l, i, null, c));
			}
			f.push(l + o - a);
		}
	}
	return p(t, n, r, i, 0), (s || c)(d, f, o);
}
var Dp = class {
	constructor() {
		this.map = /* @__PURE__ */ new WeakMap();
	}
	setBuffer(e, t, n) {
		let r = this.map.get(e);
		r || this.map.set(e, r = /* @__PURE__ */ new Map()), r.set(t, n);
	}
	getBuffer(e, t) {
		let n = this.map.get(e);
		return n && n.get(t);
	}
	set(e, t) {
		e instanceof _p ? this.setBuffer(e.context.buffer, e.index, t) : e instanceof pp && this.map.set(e.tree, t);
	}
	get(e) {
		return e instanceof _p ? this.getBuffer(e.context.buffer, e.index) : e instanceof pp ? this.map.get(e.tree) : void 0;
	}
	cursorSet(e, t) {
		e.buffer ? this.setBuffer(e.buffer.buffer, e.index, t) : this.map.set(e.tree, t);
	}
	cursorGet(e) {
		return e.buffer ? this.getBuffer(e.buffer.buffer, e.index) : this.map.get(e.tree);
	}
}, Op = class e {
	constructor(e, t, n, r, i = !1, a = !1) {
		this.from = e, this.to = t, this.tree = n, this.offset = r, this.open = !!i | (a ? 2 : 0);
	}
	get openStart() {
		return (this.open & 1) > 0;
	}
	get openEnd() {
		return (this.open & 2) > 0;
	}
	static addTree(t, n = [], r = !1) {
		let i = [new e(0, t.length, t, 0, !1, r)];
		for (let e of n) e.to > t.length && i.push(e);
		return i;
	}
	static applyChanges(t, n, r = 128) {
		if (!n.length) return t;
		let i = [], a = 1, o = t.length ? t[0] : null;
		for (let s = 0, c = 0, l = 0;; s++) {
			let u = s < n.length ? n[s] : null, d = u ? u.fromA : 1e9;
			if (d - c >= r) for (; o && o.from < d;) {
				let n = o;
				if (c >= n.from || d <= n.to || l) {
					let t = Math.max(n.from, c) - l, r = Math.min(n.to, d) - l;
					n = t >= r ? null : new e(t, r, n.tree, n.offset + l, s > 0, !!u);
				}
				if (n && i.push(n), o.to > d) break;
				o = a < t.length ? t[a++] : null;
			}
			if (!u) break;
			c = u.toA, l = u.toA - u.toB;
		}
		return i;
	}
}, kp = class {
	startParse(e, t, n) {
		return typeof e == "string" && (e = new Ap(e)), n = n ? n.length ? n.map((e) => new Qf(e.from, e.to)) : [new Qf(0, 0)] : [new Qf(0, e.length)], this.createParse(e, t || [], n);
	}
	parse(e, t, n) {
		let r = this.startParse(e, t, n);
		for (;;) {
			let e = r.advance();
			if (e) return e;
		}
	}
}, Ap = class {
	constructor(e) {
		this.string = e;
	}
	get length() {
		return this.string.length;
	}
	chunk(e) {
		return this.string.slice(e);
	}
	get lineChunks() {
		return !1;
	}
	read(e, t) {
		return this.string.slice(e, t);
	}
};
new $f({ perNode: !0 });
//#endregion
//#region ../../../node_modules/@lezer/highlight/dist/index.js
var jp = 0, Mp = class e {
	constructor(e, t, n, r) {
		this.name = e, this.set = t, this.base = n, this.modified = r, this.id = jp++;
	}
	toString() {
		let { name: e } = this;
		for (let t of this.modified) t.name && (e = `${t.name}(${e})`);
		return e;
	}
	static define(t, n) {
		let r = typeof t == "string" ? t : "?";
		if (t instanceof e && (n = t), n?.base) throw Error("Can not derive from a modified tag");
		let i = new e(r, [], null, []);
		if (i.set.push(i), n) for (let e of n.set) i.set.push(e);
		return i;
	}
	static defineModifier(e) {
		let t = new Pp(e);
		return (e) => e.modified.indexOf(t) > -1 ? e : Pp.get(e.base || e, e.modified.concat(t).sort((e, t) => e.id - t.id));
	}
}, Np = 0, Pp = class e {
	constructor(e) {
		this.name = e, this.instances = [], this.id = Np++;
	}
	static get(t, n) {
		if (!n.length) return t;
		let r = n[0].instances.find((e) => e.base == t && Fp(n, e.modified));
		if (r) return r;
		let i = [], a = new Mp(t.name, i, t, n);
		for (let e of n) e.instances.push(a);
		let o = Ip(n);
		for (let n of t.set) if (!n.modified.length) for (let t of o) i.push(e.get(n, t));
		return a;
	}
};
function Fp(e, t) {
	return e.length == t.length && e.every((e, n) => e == t[n]);
}
function Ip(e) {
	let t = [[]];
	for (let n = 0; n < e.length; n++) for (let r = 0, i = t.length; r < i; r++) t.push(t[r].concat(e[n]));
	return t.sort((e, t) => t.length - e.length);
}
function Lp(e) {
	let t = Object.create(null);
	for (let n in e) {
		let r = e[n];
		Array.isArray(r) || (r = [r]);
		for (let e of n.split(" ")) if (e) {
			let n = [], i = 2, a = e;
			for (let t = 0;;) {
				if (a == "..." && t > 0 && t + 3 == e.length) {
					i = 1;
					break;
				}
				let r = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
				if (!r) throw RangeError("Invalid path: " + e);
				if (n.push(r[0] == "*" ? "" : r[0][0] == "\"" ? JSON.parse(r[0]) : r[0]), t += r[0].length, t == e.length) break;
				let o = e[t++];
				if (t == e.length && o == "!") {
					i = 0;
					break;
				}
				if (o != "/") throw RangeError("Invalid path: " + e);
				a = e.slice(t);
			}
			let o = n.length - 1, s = n[o];
			if (!s) throw RangeError("Invalid path: " + e);
			t[s] = new zp(r, i, o > 0 ? n.slice(0, o) : null).sort(t[s]);
		}
	}
	return Rp.add(t);
}
var Rp = new $f({ combine(e, t) {
	let n, r, i;
	for (; e || t;) {
		if (!e || t && e.depth >= t.depth ? (i = t, t = t.next) : (i = e, e = e.next), n && n.mode == i.mode && !i.context && !n.context) continue;
		let a = new zp(i.tags, i.mode, i.context);
		n ? n.next = a : r = a, n = a;
	}
	return r;
} }), zp = class {
	constructor(e, t, n, r) {
		this.tags = e, this.mode = t, this.context = n, this.next = r;
	}
	get opaque() {
		return this.mode == 0;
	}
	get inherit() {
		return this.mode == 1;
	}
	sort(e) {
		return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
	}
	get depth() {
		return this.context ? this.context.length : 0;
	}
};
zp.empty = new zp([], 2, null);
function Bp(e, t) {
	let n = Object.create(null);
	for (let t of e) if (!Array.isArray(t.tag)) n[t.tag.id] = t.class;
	else for (let e of t.tag) n[e.id] = t.class;
	let { scope: r, all: i = null } = t || {};
	return {
		style: (e) => {
			let t = i;
			for (let r of e) for (let e of r.set) {
				let r = n[e.id];
				if (r) {
					t = t ? t + " " + r : r;
					break;
				}
			}
			return t;
		},
		scope: r
	};
}
function Vp(e, t) {
	let n = null;
	for (let r of e) {
		let e = r.style(t);
		e && (n = n ? n + " " + e : e);
	}
	return n;
}
function Hp(e, t, n, r = 0, i = e.length) {
	let a = new Up(r, Array.isArray(t) ? t : [t], n);
	a.highlightRange(e.cursor(), r, i, "", a.highlighters), a.flush(i);
}
var Up = class {
	constructor(e, t, n) {
		this.at = e, this.highlighters = t, this.span = n, this.class = "";
	}
	startSpan(e, t) {
		t != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = t);
	}
	flush(e) {
		e > this.at && this.class && this.span(this.at, e, this.class);
	}
	highlightRange(e, t, n, r, i) {
		let { type: a, from: o, to: s } = e;
		if (o >= n || s <= t) return;
		a.isTop && (i = this.highlighters.filter((e) => !e.scope || e.scope(a)));
		let c = r, l = Wp(e) || zp.empty, u = Vp(i, l.tags);
		if (u && (c && (c += " "), c += u, l.mode == 1 && (r += (r ? " " : "") + u)), this.startSpan(Math.max(t, o), c), l.opaque) return;
		let d = e.tree && e.tree.prop($f.mounted);
		if (d && d.overlay) {
			let a = e.node.enter(d.overlay[0].from + o, 1), l = this.highlighters.filter((e) => !e.scope || e.scope(d.tree.type)), u = e.firstChild();
			for (let f = 0, p = o;; f++) {
				let m = f < d.overlay.length ? d.overlay[f] : null, h = m ? m.from + o : s, g = Math.max(t, p), _ = Math.min(n, h);
				if (g < _ && u) for (; e.from < _ && (this.highlightRange(e, g, _, r, i), this.startSpan(Math.min(_, e.to), c), !(e.to >= h || !e.nextSibling())););
				if (!m || h > n) break;
				p = m.to + o, p > t && (this.highlightRange(a.cursor(), Math.max(t, m.from + o), Math.min(n, p), "", l), this.startSpan(Math.min(n, p), c));
			}
			u && e.parent();
		} else if (e.firstChild()) {
			d && (r = "");
			do {
				if (e.to <= t) continue;
				if (e.from >= n) break;
				this.highlightRange(e, t, n, r, i), this.startSpan(Math.min(n, e.to), c);
			} while (e.nextSibling());
			e.parent();
		}
	}
};
function Wp(e) {
	let t = e.type.prop(Rp);
	for (; t && t.context && !e.matchContext(t.context);) t = t.next;
	return t || null;
}
var J = Mp.define, Gp = J(), Kp = J(), qp = J(Kp), Jp = J(Kp), Yp = J(), Xp = J(Yp), Zp = J(Yp), Qp = J(), $p = J(Qp), em = J(), tm = J(), nm = J(), rm = J(nm), im = J(), Y = {
	comment: Gp,
	lineComment: J(Gp),
	blockComment: J(Gp),
	docComment: J(Gp),
	name: Kp,
	variableName: J(Kp),
	typeName: qp,
	tagName: J(qp),
	propertyName: Jp,
	attributeName: J(Jp),
	className: J(Kp),
	labelName: J(Kp),
	namespace: J(Kp),
	macroName: J(Kp),
	literal: Yp,
	string: Xp,
	docString: J(Xp),
	character: J(Xp),
	attributeValue: J(Xp),
	number: Zp,
	integer: J(Zp),
	float: J(Zp),
	bool: J(Yp),
	regexp: J(Yp),
	escape: J(Yp),
	color: J(Yp),
	url: J(Yp),
	keyword: em,
	self: J(em),
	null: J(em),
	atom: J(em),
	unit: J(em),
	modifier: J(em),
	operatorKeyword: J(em),
	controlKeyword: J(em),
	definitionKeyword: J(em),
	moduleKeyword: J(em),
	operator: tm,
	derefOperator: J(tm),
	arithmeticOperator: J(tm),
	logicOperator: J(tm),
	bitwiseOperator: J(tm),
	compareOperator: J(tm),
	updateOperator: J(tm),
	definitionOperator: J(tm),
	typeOperator: J(tm),
	controlOperator: J(tm),
	punctuation: nm,
	separator: J(nm),
	bracket: rm,
	angleBracket: J(rm),
	squareBracket: J(rm),
	paren: J(rm),
	brace: J(rm),
	content: Qp,
	heading: $p,
	heading1: J($p),
	heading2: J($p),
	heading3: J($p),
	heading4: J($p),
	heading5: J($p),
	heading6: J($p),
	contentSeparator: J(Qp),
	list: J(Qp),
	quote: J(Qp),
	emphasis: J(Qp),
	strong: J(Qp),
	link: J(Qp),
	monospace: J(Qp),
	strikethrough: J(Qp),
	inserted: J(),
	deleted: J(),
	changed: J(),
	invalid: J(),
	meta: im,
	documentMeta: J(im),
	annotation: J(im),
	processingInstruction: J(im),
	definition: Mp.defineModifier("definition"),
	constant: Mp.defineModifier("constant"),
	function: Mp.defineModifier("function"),
	standard: Mp.defineModifier("standard"),
	local: Mp.defineModifier("local"),
	special: Mp.defineModifier("special")
};
for (let e in Y) {
	let t = Y[e];
	t instanceof Mp && (t.name = e);
}
Bp([
	{
		tag: Y.link,
		class: "tok-link"
	},
	{
		tag: Y.heading,
		class: "tok-heading"
	},
	{
		tag: Y.emphasis,
		class: "tok-emphasis"
	},
	{
		tag: Y.strong,
		class: "tok-strong"
	},
	{
		tag: Y.keyword,
		class: "tok-keyword"
	},
	{
		tag: Y.atom,
		class: "tok-atom"
	},
	{
		tag: Y.bool,
		class: "tok-bool"
	},
	{
		tag: Y.url,
		class: "tok-url"
	},
	{
		tag: Y.labelName,
		class: "tok-labelName"
	},
	{
		tag: Y.inserted,
		class: "tok-inserted"
	},
	{
		tag: Y.deleted,
		class: "tok-deleted"
	},
	{
		tag: Y.literal,
		class: "tok-literal"
	},
	{
		tag: Y.string,
		class: "tok-string"
	},
	{
		tag: Y.number,
		class: "tok-number"
	},
	{
		tag: [
			Y.regexp,
			Y.escape,
			Y.special(Y.string)
		],
		class: "tok-string2"
	},
	{
		tag: Y.variableName,
		class: "tok-variableName"
	},
	{
		tag: Y.local(Y.variableName),
		class: "tok-variableName tok-local"
	},
	{
		tag: Y.definition(Y.variableName),
		class: "tok-variableName tok-definition"
	},
	{
		tag: Y.special(Y.variableName),
		class: "tok-variableName2"
	},
	{
		tag: Y.definition(Y.propertyName),
		class: "tok-propertyName tok-definition"
	},
	{
		tag: Y.typeName,
		class: "tok-typeName"
	},
	{
		tag: Y.namespace,
		class: "tok-namespace"
	},
	{
		tag: Y.className,
		class: "tok-className"
	},
	{
		tag: Y.macroName,
		class: "tok-macroName"
	},
	{
		tag: Y.propertyName,
		class: "tok-propertyName"
	},
	{
		tag: Y.operator,
		class: "tok-operator"
	},
	{
		tag: Y.comment,
		class: "tok-comment"
	},
	{
		tag: Y.meta,
		class: "tok-meta"
	},
	{
		tag: Y.invalid,
		class: "tok-invalid"
	},
	{
		tag: Y.punctuation,
		class: "tok-punctuation"
	}
]);
//#endregion
//#region ../../../node_modules/@codemirror/language/dist/index.js
var am = /*@__PURE__*/ new $f();
function om(e) {
	return W.define({ combine: e ? (t) => t.concat(e) : void 0 });
}
var sm = /*@__PURE__*/ new $f(), cm = class {
	constructor(e, t, n = [], r = "") {
		this.data = e, this.name = r, Qi.prototype.hasOwnProperty("tree") || Object.defineProperty(Qi.prototype, "tree", { get() {
			return dm(this);
		} }), this.parser = t, this.extension = [bm.of(this), Qi.languageData.of((e, t, n) => {
			let r = lm(e, t, n), i = r.type.prop(am);
			if (!i) return [];
			let a = e.facet(i), o = r.type.prop(sm);
			if (o) {
				let i = r.resolve(t - r.from, n);
				for (let t of o) if (t.test(i, e)) {
					let n = e.facet(t.facet);
					return t.type == "replace" ? n : n.concat(a);
				}
			}
			return a;
		})].concat(n);
	}
	isActiveAt(e, t, n = -1) {
		return lm(e, t, n).type.prop(am) == this.data;
	}
	findRegions(e) {
		let t = e.facet(bm);
		if (t?.data == this.data) return [{
			from: 0,
			to: e.doc.length
		}];
		if (!t || !t.allowsNesting) return [];
		let n = [], r = (e, t) => {
			if (e.prop(am) == this.data) {
				n.push({
					from: t,
					to: t + e.length
				});
				return;
			}
			let i = e.prop($f.mounted);
			if (i) {
				if (i.tree.prop(am) == this.data) {
					if (i.overlay) for (let e of i.overlay) n.push({
						from: e.from + t,
						to: e.to + t
					});
					else n.push({
						from: t,
						to: t + e.length
					});
					return;
				} else if (i.overlay) {
					let e = n.length;
					if (r(i.tree, i.overlay[0].from + t), n.length > e) return;
				}
			}
			for (let n = 0; n < e.children.length; n++) {
				let i = e.children[n];
				i instanceof sp && r(i, e.positions[n] + t);
			}
		};
		return r(dm(e), 0), n;
	}
	get allowsNesting() {
		return !0;
	}
};
cm.setState = /*@__PURE__*/ Li.define();
function lm(e, t, n) {
	let r = e.facet(bm), i = dm(e).topNode;
	if (!r || r.allowsNesting) for (let e = i; e; e = e.enter(t, n, op.ExcludeBuffers | op.EnterBracketed)) e.type.isTop && (i = e);
	return i;
}
var um = class e extends cm {
	constructor(e, t, n) {
		super(e, t, [], n), this.parser = t;
	}
	static define(t) {
		let n = om(t.languageData);
		return new e(n, t.parser.configure({ props: [am.add((e) => e.isTop ? n : void 0)] }), t.name);
	}
	configure(t, n) {
		return new e(this.data, this.parser.configure(t), n || this.name);
	}
	get allowsNesting() {
		return this.parser.hasWrappers();
	}
};
function dm(e) {
	let t = e.field(cm.state, !1);
	return t ? t.tree : sp.empty;
}
var fm = class {
	constructor(e) {
		this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
	}
	get length() {
		return this.doc.length;
	}
	syncTo(e) {
		return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
	}
	chunk(e) {
		return this.syncTo(e), this.string;
	}
	get lineChunks() {
		return !0;
	}
	read(e, t) {
		let n = this.cursorPos - this.string.length;
		return e < n || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - n, t - n);
	}
}, pm = null, mm = class e {
	constructor(e, t, n = [], r, i, a, o, s) {
		this.parser = e, this.state = t, this.fragments = n, this.tree = r, this.treeLen = i, this.viewport = a, this.skipped = o, this.scheduleOn = s, this.parse = null, this.tempSkipped = [];
	}
	static create(t, n, r) {
		return new e(t, n, [], sp.empty, 0, r, [], null);
	}
	startParse() {
		return this.parser.startParse(new fm(this.state.doc), this.fragments);
	}
	work(e, t) {
		return t != null && t >= this.state.doc.length && (t = void 0), this.tree != sp.empty && this.isDone(t ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
			if (typeof e == "number") {
				let t = Date.now() + e;
				e = () => Date.now() > t;
			}
			for (this.parse ||= this.startParse(), t != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > t) && t < this.state.doc.length && this.parse.stopAt(t);;) {
				let n = this.parse.advance();
				if (n) if (this.fragments = this.withoutTempSkipped(Op.addTree(n, this.fragments, this.parse.stoppedAt != null)), this.treeLen = this.parse.stoppedAt ?? this.state.doc.length, this.tree = n, this.parse = null, this.treeLen < (t ?? this.state.doc.length)) this.parse = this.startParse();
				else return !0;
				if (e()) return !1;
			}
		});
	}
	takeTree() {
		let e, t;
		this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
			for (; !(t = this.parse.advance()););
		}), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(Op.addTree(this.tree, this.fragments, !0)), this.parse = null);
	}
	withContext(e) {
		let t = pm;
		pm = this;
		try {
			return e();
		} finally {
			pm = t;
		}
	}
	withoutTempSkipped(e) {
		for (let t; t = this.tempSkipped.pop();) e = hm(e, t.from, t.to);
		return e;
	}
	changes(t, n) {
		let { fragments: r, tree: i, treeLen: a, viewport: o, skipped: s } = this;
		if (this.takeTree(), !t.empty) {
			let e = [];
			if (t.iterChangedRanges((t, n, r, i) => e.push({
				fromA: t,
				toA: n,
				fromB: r,
				toB: i
			})), r = Op.applyChanges(r, e), i = sp.empty, a = 0, o = {
				from: t.mapPos(o.from, -1),
				to: t.mapPos(o.to, 1)
			}, this.skipped.length) {
				s = [];
				for (let e of this.skipped) {
					let n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
					n < r && s.push({
						from: n,
						to: r
					});
				}
			}
		}
		return new e(this.parser, n, r, i, a, o, s, this.scheduleOn);
	}
	updateViewport(e) {
		if (this.viewport.from == e.from && this.viewport.to == e.to) return !1;
		this.viewport = e;
		let t = this.skipped.length;
		for (let t = 0; t < this.skipped.length; t++) {
			let { from: n, to: r } = this.skipped[t];
			n < e.to && r > e.from && (this.fragments = hm(this.fragments, n, r), this.skipped.splice(t--, 1));
		}
		return this.skipped.length >= t ? !1 : (this.reset(), !0);
	}
	reset() {
		this.parse &&= (this.takeTree(), null);
	}
	skipUntilInView(e, t) {
		this.skipped.push({
			from: e,
			to: t
		});
	}
	static getSkippingParser(e) {
		return new class extends kp {
			createParse(t, n, r) {
				let i = r[0].from, a = r[r.length - 1].to;
				return {
					parsedPos: i,
					advance() {
						let t = pm;
						if (t) {
							for (let e of r) t.tempSkipped.push(e);
							e && (t.scheduleOn = t.scheduleOn ? Promise.all([t.scheduleOn, e]) : e);
						}
						return this.parsedPos = a, new sp(np.none, [], [], a - i);
					},
					stoppedAt: null,
					stopAt() {}
				};
			}
		}();
	}
	isDone(e) {
		e = Math.min(e, this.state.doc.length);
		let t = this.fragments;
		return this.treeLen >= e && t.length && t[0].from == 0 && t[0].to >= e;
	}
	static get() {
		return pm;
	}
};
function hm(e, t, n) {
	return Op.applyChanges(e, [{
		fromA: t,
		toA: n,
		fromB: t,
		toB: n
	}]);
}
var gm = class e {
	constructor(e) {
		this.context = e, this.tree = e.tree;
	}
	apply(t) {
		if (!t.docChanged && this.tree == this.context.tree) return this;
		let n = this.context.changes(t.changes, t.state), r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
		return n.work(20, r) || n.takeTree(), new e(n);
	}
	static init(t) {
		let n = Math.min(3e3, t.doc.length), r = mm.create(t.facet(bm).parser, t, {
			from: 0,
			to: n
		});
		return r.work(20, n) || r.takeTree(), new e(r);
	}
};
cm.state = /*@__PURE__*/ gi.define({
	create: gm.init,
	update(e, t) {
		for (let e of t.effects) if (e.is(cm.setState)) return e.value;
		return t.startState.facet(bm) == t.state.facet(bm) ? e.apply(t) : gm.init(t.state);
	}
});
var _m = (e) => {
	let t = setTimeout(() => e(), 500);
	return () => clearTimeout(t);
};
typeof requestIdleCallback < "u" && (_m = (e) => {
	let t = -1, n = setTimeout(() => {
		t = requestIdleCallback(e, { timeout: 400 });
	}, 100);
	return () => t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
});
var vm = typeof navigator < "u" && navigator.scheduling?.isInputPending ? () => navigator.scheduling.isInputPending() : null, ym = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
	}
	update(e) {
		let t = this.view.state.field(cm.state).context;
		(t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
	}
	scheduleWork() {
		if (this.working) return;
		let { state: e } = this.view, t = e.field(cm.state);
		(t.tree != t.context.tree || !t.context.isDone(e.doc.length)) && (this.working = _m(this.work));
	}
	work(e) {
		this.working = null;
		let t = Date.now();
		if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0) return;
		let { state: n, viewport: { to: r } } = this.view, i = n.field(cm.state);
		if (i.tree == i.context.tree && i.context.isDone(r + 1e5)) return;
		let a = Date.now() + Math.min(this.chunkBudget, 100, e && !vm ? Math.max(25, e.timeRemaining() - 5) : 1e9), o = i.context.treeLen < r && n.doc.length > r + 1e3, s = i.context.work(() => vm && vm() || Date.now() > a, r + (o ? 0 : 1e5));
		this.chunkBudget -= Date.now() - t, (s || this.chunkBudget <= 0) && (i.context.takeTree(), this.view.dispatch({ effects: cm.setState.of(new gm(i.context)) })), this.chunkBudget > 0 && !(s && !o) && this.scheduleWork(), this.checkAsyncSchedule(i.context);
	}
	checkAsyncSchedule(e) {
		e.scheduleOn &&= (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((e) => ys(this.view.state, e)).then(() => this.workScheduled--), null);
	}
	destroy() {
		this.working && this.working();
	}
	isWorking() {
		return !!(this.working || this.workScheduled > 0);
	}
}, { eventHandlers: { focus() {
	this.scheduleWork();
} } }), bm = /*@__PURE__*/ W.define({
	combine(e) {
		return e.length ? e[0] : null;
	},
	enables: (e) => [
		cm.state,
		ym,
		q.contentAttributes.compute([e], (t) => {
			let n = t.facet(e);
			return n && n.name ? { "data-language": n.name } : {};
		})
	]
}), xm = class {
	constructor(e, t = []) {
		this.language = e, this.support = t, this.extension = [e, t];
	}
}, Sm = /*@__PURE__*/ W.define(), Cm = /*@__PURE__*/ W.define({ combine: (e) => {
	if (!e.length) return "  ";
	let t = e[0];
	if (!t || /\S/.test(t) || Array.from(t).some((e) => e != t[0])) throw Error("Invalid indent unit: " + JSON.stringify(e[0]));
	return t;
} });
function wm(e) {
	let t = e.facet(Cm);
	return t.charCodeAt(0) == 9 ? e.tabSize * t.length : t.length;
}
function Tm(e, t) {
	let n = "", r = e.tabSize, i = e.facet(Cm)[0];
	if (i == "	") {
		for (; t >= r;) n += "	", t -= r;
		i = " ";
	}
	for (let e = 0; e < t; e++) n += i;
	return n;
}
function Em(e, t) {
	e instanceof Qi && (e = new Dm(e));
	for (let n of e.state.facet(Sm)) {
		let r = n(e, t);
		if (r !== void 0) return r;
	}
	let n = dm(e.state);
	return n.length >= t ? km(e, n, t) : null;
}
var Dm = class {
	constructor(e, t = {}) {
		this.state = e, this.options = t, this.unit = wm(e);
	}
	lineAt(e, t = 1) {
		let n = this.state.doc.lineAt(e), { simulateBreak: r, simulateDoubleBreak: i } = this.options;
		return r != null && r >= n.from && r <= n.to ? i && r == e ? {
			text: "",
			from: e
		} : (t < 0 ? r < e : r <= e) ? {
			text: n.text.slice(r - n.from),
			from: r
		} : {
			text: n.text.slice(0, r - n.from),
			from: n.from
		} : n;
	}
	textAfterPos(e, t = 1) {
		if (this.options.simulateDoubleBreak && e == this.options.simulateBreak) return "";
		let { text: n, from: r } = this.lineAt(e, t);
		return n.slice(e - r, Math.min(n.length, e + 100 - r));
	}
	column(e, t = 1) {
		let { text: n, from: r } = this.lineAt(e, t), i = this.countColumn(n, e - r), a = this.options.overrideIndentation ? this.options.overrideIndentation(r) : -1;
		return a > -1 && (i += a - this.countColumn(n, n.search(/\S|$/))), i;
	}
	countColumn(e, t = e.length) {
		return va(e, this.state.tabSize, t);
	}
	lineIndent(e, t = 1) {
		let { text: n, from: r } = this.lineAt(e, t), i = this.options.overrideIndentation;
		if (i) {
			let e = i(r);
			if (e > -1) return e;
		}
		return this.countColumn(n, n.search(/\S|$/));
	}
	get simulatedBreak() {
		return this.options.simulateBreak || null;
	}
}, Om = /*@__PURE__*/ new $f();
function km(e, t, n) {
	let r = t.resolveStack(n), i = t.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
	if (i != r.node) {
		let e = [];
		for (let t = i; t && !(t.from < r.node.from || t.to > r.node.to || t.from == r.node.from && t.type == r.node.type); t = t.parent) e.push(t);
		for (let t = e.length - 1; t >= 0; t--) r = {
			node: e[t],
			next: r
		};
	}
	return Am(r, e, n);
}
function Am(e, t, n) {
	for (let r = e; r; r = r.next) {
		let e = Mm(r.node);
		if (e) return e(Pm.create(t, n, r));
	}
	return 0;
}
function jm(e) {
	return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
}
function Mm(e) {
	let t = e.type.prop(Om);
	if (t) return t;
	let n = e.firstChild, r;
	if (n && (r = n.type.prop($f.closedBy))) {
		let t = e.lastChild, n = t && r.indexOf(t.name) > -1;
		return (e) => Rm(e, !0, 1, void 0, n && !jm(e) ? t.from : void 0);
	}
	return e.parent == null ? Nm : null;
}
function Nm() {
	return 0;
}
var Pm = class e extends Dm {
	constructor(e, t, n) {
		super(e.state, e.options), this.base = e, this.pos = t, this.context = n;
	}
	get node() {
		return this.context.node;
	}
	static create(t, n, r) {
		return new e(t, n, r);
	}
	get textAfter() {
		return this.textAfterPos(this.pos);
	}
	get baseIndent() {
		return this.baseIndentFor(this.node);
	}
	baseIndentFor(e) {
		let t = this.state.doc.lineAt(e.from);
		for (;;) {
			let n = e.resolve(t.from);
			for (; n.parent && n.parent.from == n.from;) n = n.parent;
			if (Fm(n, e)) break;
			t = this.state.doc.lineAt(n.from);
		}
		return this.lineIndent(t.from);
	}
	continue() {
		return Am(this.context.next, this.base, this.pos);
	}
};
function Fm(e, t) {
	for (let n = t; n; n = n.parent) if (e == n) return !0;
	return !1;
}
function Im(e) {
	let t = e.node, n = t.childAfter(t.from), r = t.lastChild;
	if (!n) return null;
	let i = e.options.simulateBreak, a = e.state.doc.lineAt(n.from), o = i == null || i <= a.from ? a.to : Math.min(a.to, i);
	for (let e = n.to;;) {
		let i = t.childAfter(e);
		if (!i || i == r) return null;
		if (!i.type.isSkipped) {
			if (i.from >= o) return null;
			let e = /^ */.exec(a.text.slice(n.to - a.from))[0].length;
			return {
				from: n.from,
				to: n.to + e
			};
		}
		e = i.to;
	}
}
function Lm({ closing: e, align: t = !0, units: n = 1 }) {
	return (r) => Rm(r, t, n, e);
}
function Rm(e, t, n, r, i) {
	let a = e.textAfter, o = a.match(/^\s*/)[0].length, s = r && a.slice(o, o + r.length) == r || i == e.pos + o, c = t ? Im(e) : null;
	return c ? s ? e.column(c.from) : e.column(c.to) : e.baseIndent + (s ? 0 : e.unit * n);
}
var zm = (e) => e.baseIndent;
function Bm({ except: e, units: t = 1 } = {}) {
	return (n) => {
		let r = e && e.test(n.textAfter);
		return n.baseIndent + (r ? 0 : t * n.unit);
	};
}
var Vm = 200;
function Hm() {
	return Qi.transactionFilter.of((e) => {
		if (!e.docChanged || !e.isUserEvent("input.type") && !e.isUserEvent("input.complete")) return e;
		let t = e.startState.languageDataAt("indentOnInput", e.startState.selection.main.head);
		if (!t.length) return e;
		let n = e.newDoc, { head: r } = e.newSelection.main, i = n.lineAt(r);
		if (r > i.from + Vm) return e;
		let a = n.sliceString(i.from, r);
		if (!t.some((e) => e.test(a))) return e;
		let { state: o } = e, s = -1, c = [];
		for (let { head: e } of o.selection.ranges) {
			let t = o.doc.lineAt(e);
			if (t.from == s) continue;
			s = t.from;
			let n = Em(o, t.from);
			if (n == null) continue;
			let r = /^\s*/.exec(t.text)[0], i = Tm(o, n);
			r != i && c.push({
				from: t.from,
				to: t.from + r.length,
				insert: i
			});
		}
		return c.length ? [e, {
			changes: c,
			sequential: !0
		}] : e;
	});
}
var Um = /*@__PURE__*/ W.define(), Wm = /*@__PURE__*/ new $f();
function Gm(e) {
	let t = e.firstChild, n = e.lastChild;
	return t && t.to < n.from ? {
		from: t.to,
		to: n.type.isError ? e.to : n.from
	} : null;
}
function Km(e, t, n) {
	let r = dm(e);
	if (r.length < n) return null;
	let i = r.resolveStack(n, 1), a = null;
	for (let o = i; o; o = o.next) {
		let i = o.node;
		if (i.to <= n || i.from > n) continue;
		if (a && i.from < t) break;
		let s = i.type.prop(Wm);
		if (s && (i.to < r.length - 50 || r.length == e.doc.length || !qm(i))) {
			let r = s(i, e);
			r && r.from <= n && r.from >= t && r.to > n && (a = r);
		}
	}
	return a;
}
function qm(e) {
	let t = e.lastChild;
	return t && t.to == e.to && t.type.isError;
}
function Jm(e, t, n) {
	for (let r of e.facet(Um)) {
		let i = r(e, t, n);
		if (i) return i;
	}
	return Km(e, t, n);
}
function Ym(e, t) {
	let n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
	return n >= r ? void 0 : {
		from: n,
		to: r
	};
}
var Xm = /*@__PURE__*/ Li.define({ map: Ym }), Zm = /*@__PURE__*/ Li.define({ map: Ym });
function Qm(e) {
	let t = [];
	for (let { head: n } of e.state.selection.ranges) t.some((e) => e.from <= n && e.to >= n) || t.push(e.lineBlockAt(n));
	return t;
}
var $m = /*@__PURE__*/ gi.define({
	create() {
		return K.none;
	},
	update(e, t) {
		t.isUserEvent("delete") && t.changes.iterChangedRanges((t, n) => e = eh(e, t, n)), e = e.map(t.changes);
		let n = [];
		for (let r of t.effects) r.is(Xm) && !nh(e, r.value.from, r.value.to) ? n.push(r.value) : r.is(Zm) && (e = e.update({
			filter: (e, t) => r.value.from != e || r.value.to != t,
			filterFrom: r.value.from,
			filterTo: r.value.to
		}));
		if (n.length) {
			let { preparePlaceholder: r } = t.state.facet(lh), i = n.map((e) => (r ? K.replace({ widget: new ph(r(t.state, e)) }) : fh).range(e.from, e.to));
			e = e.update({ add: i });
		}
		return t.selection && (e = eh(e, t.selection.main.head)), e;
	},
	provide: (e) => q.decorations.from(e),
	toJSON(e, t) {
		let n = [];
		return e.between(0, t.doc.length, (e, t) => {
			n.push(e, t);
		}), n;
	},
	fromJSON(e) {
		if (!Array.isArray(e) || e.length % 2) throw RangeError("Invalid JSON for fold state");
		let t = [];
		for (let n = 0; n < e.length;) {
			let r = e[n++], i = e[n++];
			if (typeof r != "number" || typeof i != "number") throw RangeError("Invalid JSON for fold state");
			t.push(fh.range(r, i));
		}
		return K.set(t, !0);
	}
});
function eh(e, t, n = t) {
	let r = !1;
	return e.between(t, n, (e, i) => {
		e < n && i > t && (r = !0);
	}), r ? e.update({
		filterFrom: t,
		filterTo: n,
		filter: (e, r) => e >= n || r <= t
	}) : e;
}
function th(e, t, n) {
	var r;
	let i = null;
	return (r = e.field($m, !1)) == null || r.between(t, n, (e, t) => {
		(!i || i.from > e) && (i = {
			from: e,
			to: t
		});
	}), i;
}
function nh(e, t, n) {
	let r = !1;
	return e.between(t, t, (e, i) => {
		e == t && i == n && (r = !0);
	}), r;
}
function rh(e, t) {
	return e.field($m, !1) ? t : t.concat(Li.appendConfig.of(uh()));
}
var ih = (e) => {
	for (let t of Qm(e)) {
		let n = Jm(e.state, t.from, t.to);
		if (n) return e.dispatch({ effects: rh(e.state, [Xm.of(n), oh(e, n)]) }), !0;
	}
	return !1;
}, ah = (e) => {
	if (!e.state.field($m, !1)) return !1;
	let t = [];
	for (let n of Qm(e)) {
		let r = th(e.state, n.from, n.to);
		r && t.push(Zm.of(r), oh(e, r, !1));
	}
	return t.length && e.dispatch({ effects: t }), t.length > 0;
};
function oh(e, t, n = !0) {
	let r = e.state.doc.lineAt(t.from).number, i = e.state.doc.lineAt(t.to).number;
	return q.announce.of(`${e.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${e.state.phrase("to")} ${i}.`);
}
var sh = [
	{
		key: "Ctrl-Shift-[",
		mac: "Cmd-Alt-[",
		run: ih
	},
	{
		key: "Ctrl-Shift-]",
		mac: "Cmd-Alt-]",
		run: ah
	},
	{
		key: "Ctrl-Alt-[",
		run: (e) => {
			let { state: t } = e, n = [];
			for (let r = 0; r < t.doc.length;) {
				let i = e.lineBlockAt(r), a = Jm(t, i.from, i.to);
				a && n.push(Xm.of(a)), r = (a ? e.lineBlockAt(a.to) : i).to + 1;
			}
			return n.length && e.dispatch({ effects: rh(e.state, n) }), !!n.length;
		}
	},
	{
		key: "Ctrl-Alt-]",
		run: (e) => {
			let t = e.state.field($m, !1);
			if (!t || !t.size) return !1;
			let n = [];
			return t.between(0, e.state.doc.length, (e, t) => {
				n.push(Zm.of({
					from: e,
					to: t
				}));
			}), e.dispatch({ effects: n }), !0;
		}
	}
], ch = {
	placeholderDOM: null,
	preparePlaceholder: null,
	placeholderText: "…"
}, lh = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, ch);
} });
function uh(e) {
	let t = [$m, _h];
	return e && t.push(lh.of(e)), t;
}
function dh(e, t) {
	let { state: n } = e, r = n.facet(lh), i = (t) => {
		let n = e.lineBlockAt(e.posAtDOM(t.target)), r = th(e.state, n.from, n.to);
		r && e.dispatch({ effects: Zm.of(r) }), t.preventDefault();
	};
	if (r.placeholderDOM) return r.placeholderDOM(e, i, t);
	let a = document.createElement("span");
	return a.textContent = r.placeholderText, a.setAttribute("aria-label", n.phrase("folded code")), a.title = n.phrase("unfold"), a.className = "cm-foldPlaceholder", a.onclick = i, a;
}
var fh = /*@__PURE__*/ K.replace({ widget: /*@__PURE__*/ new class extends $a {
	toDOM(e) {
		return dh(e, null);
	}
}() }), ph = class extends $a {
	constructor(e) {
		super(), this.value = e;
	}
	eq(e) {
		return this.value == e.value;
	}
	toDOM(e) {
		return dh(e, this.value);
	}
}, mh = {
	openText: "⌄",
	closedText: "›",
	markerDOM: null,
	domEventHandlers: {},
	foldingChanged: () => !1
}, hh = class extends wf {
	constructor(e, t) {
		super(), this.config = e, this.open = t;
	}
	eq(e) {
		return this.config == e.config && this.open == e.open;
	}
	toDOM(e) {
		if (this.config.markerDOM) return this.config.markerDOM(this.open);
		let t = document.createElement("span");
		return t.textContent = this.open ? this.config.openText : this.config.closedText, t.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), t;
	}
};
function gh(e = {}) {
	let t = {
		...mh,
		...e
	}, n = new hh(t, !0), r = new hh(t, !1), i = Cs.fromClass(class {
		constructor(e) {
			this.from = e.viewport.from, this.markers = this.buildMarkers(e);
		}
		update(e) {
			(e.docChanged || e.viewportChanged || e.startState.facet(bm) != e.state.facet(bm) || e.startState.field($m, !1) != e.state.field($m, !1) || dm(e.startState) != dm(e.state) || t.foldingChanged(e)) && (this.markers = this.buildMarkers(e.view));
		}
		buildMarkers(e) {
			let t = new sa();
			for (let i of e.viewportLineBlocks) {
				let a = th(e.state, i.from, i.to) ? r : Jm(e.state, i.from, i.to) ? n : null;
				a && t.add(i.from, i.from, a);
			}
			return t.finish();
		}
	}), { domEventHandlers: a } = t;
	return [
		i,
		kf({
			class: "cm-foldGutter",
			markers(e) {
				return e.plugin(i)?.markers || aa.empty;
			},
			initialSpacer() {
				return new hh(t, !1);
			},
			domEventHandlers: {
				...a,
				click: (e, t, n) => {
					if (a.click && a.click(e, t, n)) return !0;
					let r = th(e.state, t.from, t.to);
					if (r) return e.dispatch({ effects: Zm.of(r) }), !0;
					let i = Jm(e.state, t.from, t.to);
					return i ? (e.dispatch({ effects: Xm.of(i) }), !0) : !1;
				}
			}
		}),
		uh()
	];
}
var _h = /*@__PURE__*/ q.baseTheme({
	".cm-foldPlaceholder": {
		backgroundColor: "#eee",
		border: "1px solid #ddd",
		color: "#888",
		borderRadius: ".2em",
		margin: "0 1px",
		padding: "0 1px",
		cursor: "pointer"
	},
	".cm-foldGutter span": {
		padding: "0 1px",
		cursor: "pointer"
	}
}), vh = class e {
	constructor(e, t) {
		this.specs = e;
		let n;
		function r(e) {
			let t = wa.newName();
			return (n ||= Object.create(null))["." + t] = e, t;
		}
		let i = typeof t.all == "string" ? t.all : t.all ? r(t.all) : void 0, a = t.scope;
		this.scope = a instanceof cm ? (e) => e.prop(am) == a.data : a ? (e) => e == a : void 0, this.style = Bp(e.map((e) => ({
			tag: e.tag,
			class: e.class || r(Object.assign({}, e, { tag: null }))
		})), { all: i }).style, this.module = n ? new wa(n) : null, this.themeType = t.themeType;
	}
	static define(t, n) {
		return new e(t, n || {});
	}
}, yh = /*@__PURE__*/ W.define(), bh = /*@__PURE__*/ W.define({ combine(e) {
	return e.length ? [e[0]] : null;
} });
function xh(e) {
	let t = e.facet(yh);
	return t.length ? t : e.facet(bh);
}
function Sh(e, t) {
	let n = [wh], r;
	return e instanceof vh && (e.module && n.push(q.styleModule.of(e.module)), r = e.themeType), t?.fallback ? n.push(bh.of(e)) : r ? n.push(yh.computeN([q.darkTheme], (t) => t.facet(q.darkTheme) == (r == "dark") ? [e] : [])) : n.push(yh.of(e)), n;
}
var Ch = class {
	constructor(e) {
		this.markCache = Object.create(null), this.tree = dm(e.state), this.decorations = this.buildDeco(e, xh(e.state)), this.decoratedTo = e.viewport.to;
	}
	update(e) {
		let t = dm(e.state), n = xh(e.state), r = n != xh(e.startState), { viewport: i } = e.view, a = e.changes.mapPos(this.decoratedTo, 1);
		t.length < i.to && !r && t.type == this.tree.type && a >= i.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = a) : (t != this.tree || e.viewportChanged || r) && (this.tree = t, this.decorations = this.buildDeco(e.view, n), this.decoratedTo = i.to);
	}
	buildDeco(e, t) {
		if (!t || !this.tree.length) return K.none;
		let n = new sa();
		for (let { from: r, to: i } of e.visibleRanges) Hp(this.tree, t, (e, t, r) => {
			n.add(e, t, this.markCache[r] || (this.markCache[r] = K.mark({ class: r })));
		}, r, i);
		return n.finish();
	}
}, wh = /*@__PURE__*/ yi.high(/*@__PURE__*/ Cs.fromClass(Ch, { decorations: (e) => e.decorations })), Th = /*@__PURE__*/ vh.define([
	{
		tag: Y.meta,
		color: "#404740"
	},
	{
		tag: Y.link,
		textDecoration: "underline"
	},
	{
		tag: Y.heading,
		textDecoration: "underline",
		fontWeight: "bold"
	},
	{
		tag: Y.emphasis,
		fontStyle: "italic"
	},
	{
		tag: Y.strong,
		fontWeight: "bold"
	},
	{
		tag: Y.strikethrough,
		textDecoration: "line-through"
	},
	{
		tag: Y.keyword,
		color: "#708"
	},
	{
		tag: [
			Y.atom,
			Y.bool,
			Y.url,
			Y.contentSeparator,
			Y.labelName
		],
		color: "#219"
	},
	{
		tag: [Y.literal, Y.inserted],
		color: "#164"
	},
	{
		tag: [Y.string, Y.deleted],
		color: "#a11"
	},
	{
		tag: [
			Y.regexp,
			Y.escape,
			/*@__PURE__*/ Y.special(Y.string)
		],
		color: "#e40"
	},
	{
		tag: /*@__PURE__*/ Y.definition(Y.variableName),
		color: "#00f"
	},
	{
		tag: /*@__PURE__*/ Y.local(Y.variableName),
		color: "#30a"
	},
	{
		tag: [Y.typeName, Y.namespace],
		color: "#085"
	},
	{
		tag: Y.className,
		color: "#167"
	},
	{
		tag: [/*@__PURE__*/ Y.special(Y.variableName), Y.macroName],
		color: "#256"
	},
	{
		tag: /*@__PURE__*/ Y.definition(Y.propertyName),
		color: "#00c"
	},
	{
		tag: Y.comment,
		color: "#940"
	},
	{
		tag: Y.invalid,
		color: "#f00"
	}
]), Eh = /*@__PURE__*/ q.baseTheme({
	"&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
	"&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), Dh = 1e4, Oh = "()[]{}", kh = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		afterCursor: !0,
		brackets: Oh,
		maxScanDistance: Dh,
		renderMatch: Mh
	});
} }), Ah = /*@__PURE__*/ K.mark({ class: "cm-matchingBracket" }), jh = /*@__PURE__*/ K.mark({ class: "cm-nonmatchingBracket" });
function Mh(e) {
	let t = [], n = e.matched ? Ah : jh;
	return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
function Nh(e) {
	let t = [], n = e.facet(kh);
	for (let r of e.selection.ranges) {
		if (!r.empty) continue;
		let i = zh(e, r.head, -1, n) || r.head > 0 && zh(e, r.head - 1, 1, n) || n.afterCursor && (zh(e, r.head, 1, n) || r.head < e.doc.length && zh(e, r.head + 1, -1, n));
		i && (t = t.concat(n.renderMatch(i, e)));
	}
	return K.set(t, !0);
}
var Ph = [/* @__PURE__ */ Cs.fromClass(class {
	constructor(e) {
		this.paused = !1, this.decorations = Nh(e.state);
	}
	update(e) {
		(e.docChanged || e.selectionSet || this.paused) && (e.view.composing ? (this.decorations = this.decorations.map(e.changes), this.paused = !0) : (this.decorations = Nh(e.state), this.paused = !1));
	}
}, { decorations: (e) => e.decorations }), Eh];
function Fh(e = {}) {
	return [kh.of(e), Ph];
}
var Ih = /*@__PURE__*/ new $f();
function Lh(e, t, n) {
	let r = e.prop(t < 0 ? $f.openedBy : $f.closedBy);
	if (r) return r;
	if (e.name.length == 1) {
		let r = n.indexOf(e.name);
		if (r > -1 && r % 2 == +(t < 0)) return [n[r + t]];
	}
	return null;
}
function Rh(e) {
	let t = e.type.prop(Ih);
	return t ? t(e.node) : e;
}
function zh(e, t, n, r = {}) {
	let i = r.maxScanDistance || Dh, a = r.brackets || Oh, o = dm(e), s = o.resolveInner(t, n);
	for (let r = s; r; r = r.parent) {
		let i = Lh(r.type, n, a);
		if (i && r.from < r.to) {
			let o = Rh(r);
			if (o && (n > 0 ? t >= o.from && t < o.to : t > o.from && t <= o.to)) return Bh(e, t, n, r, o, i, a);
		}
	}
	return Vh(e, t, n, o, s.type, i, a);
}
function Bh(e, t, n, r, i, a, o) {
	let s = r.parent, c = {
		from: i.from,
		to: i.to
	}, l = 0, u = s?.cursor();
	if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to))) do
		if (n < 0 ? u.to <= r.from : u.from >= r.to) {
			if (l == 0 && a.indexOf(u.type.name) > -1 && u.from < u.to) {
				let e = Rh(u);
				return {
					start: c,
					end: e ? {
						from: e.from,
						to: e.to
					} : void 0,
					matched: !0
				};
			} else if (Lh(u.type, n, o)) l++;
			else if (Lh(u.type, -n, o)) {
				if (l == 0) {
					let e = Rh(u);
					return {
						start: c,
						end: e && e.from < e.to ? {
							from: e.from,
							to: e.to
						} : void 0,
						matched: !1
					};
				}
				l--;
			}
		}
	while (n < 0 ? u.prevSibling() : u.nextSibling());
	return {
		start: c,
		matched: !1
	};
}
function Vh(e, t, n, r, i, a, o) {
	if (n < 0 ? !t : t == e.doc.length) return null;
	let s = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1), c = o.indexOf(s);
	if (c < 0 || c % 2 == 0 != n > 0) return null;
	let l = {
		from: n < 0 ? t - 1 : t,
		to: n > 0 ? t + 1 : t
	}, u = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), d = 0;
	for (let e = 0; !u.next().done && e <= a;) {
		let a = u.value;
		n < 0 && (e += a.length);
		let s = t + e * n;
		for (let e = n > 0 ? 0 : a.length - 1, t = n > 0 ? a.length : -1; e != t; e += n) {
			let t = o.indexOf(a[e]);
			if (!(t < 0 || r.resolveInner(s + e, 1).type != i)) if (t % 2 == 0 == n > 0) d++;
			else if (d == 1) return {
				start: l,
				end: {
					from: s + e,
					to: s + e + 1
				},
				matched: t >> 1 == c >> 1
			};
			else d--;
		}
		n > 0 && (e += a.length);
	}
	return u.done ? {
		start: l,
		matched: !1
	} : null;
}
var Hh = /*@__PURE__*/ Object.create(null), Uh = [np.none], Wh = [], Gh = /*@__PURE__*/ Object.create(null), Kh = /*@__PURE__*/ Object.create(null);
for (let [e, t] of [
	["variable", "variableName"],
	["variable-2", "variableName.special"],
	["string-2", "string.special"],
	["def", "variableName.definition"],
	["tag", "tagName"],
	["attribute", "attributeName"],
	["type", "typeName"],
	["builtin", "variableName.standard"],
	["qualifier", "modifier"],
	["error", "invalid"],
	["header", "heading"],
	["property", "propertyName"]
]) Kh[e] = /*@__PURE__*/ Jh(Hh, t);
function qh(e, t) {
	Wh.indexOf(e) > -1 || (Wh.push(e), console.warn(t));
}
function Jh(e, t) {
	let n = [];
	for (let r of t.split(" ")) {
		let t = [];
		for (let n of r.split(".")) {
			let r = e[n] || Y[n];
			r ? typeof r == "function" ? t.length ? t = t.map(r) : qh(n, `Modifier ${n} used at start of tag`) : t.length ? qh(n, `Tag ${n} used as modifier`) : t = Array.isArray(r) ? r : [r] : qh(n, `Unknown highlighting tag ${n}`);
		}
		for (let e of t) n.push(e);
	}
	if (!n.length) return 0;
	let r = t.replace(/ /g, "_"), i = r + " " + n.map((e) => e.id), a = Gh[i];
	if (a) return a.id;
	let o = Gh[i] = np.define({
		id: Uh.length,
		name: r,
		props: [Lp({ [r]: n })]
	});
	return Uh.push(o), o.id;
}
Fo.RTL, Fo.LTR;
//#endregion
//#region ../../../node_modules/@codemirror/commands/dist/index.js
var Yh = (e) => {
	let { state: t } = e, n = t.doc.lineAt(t.selection.main.from), r = eg(e.state, n.from);
	return r.line ? Zh(e) : r.block ? $h(e) : !1;
};
function Xh(e, t) {
	return ({ state: n, dispatch: r }) => {
		if (n.readOnly) return !1;
		let i = e(t, n);
		return i ? (r(n.update(i)), !0) : !1;
	};
}
var Zh = /*@__PURE__*/ Xh(ag, 0), Qh = /*@__PURE__*/ Xh(ig, 0), $h = /*@__PURE__*/ Xh((e, t) => ig(e, t, rg(t)), 0);
function eg(e, t) {
	let n = e.languageDataAt("commentTokens", t, 1);
	return n.length ? n[0] : {};
}
var tg = 50;
function ng(e, { open: t, close: n }, r, i) {
	let a = e.sliceDoc(r - tg, r), o = e.sliceDoc(i, i + tg), s = /\s*$/.exec(a)[0].length, c = /^\s*/.exec(o)[0].length, l = a.length - s;
	if (a.slice(l - t.length, l) == t && o.slice(c, c + n.length) == n) return {
		open: {
			pos: r - s,
			margin: s && 1
		},
		close: {
			pos: i + c,
			margin: c && 1
		}
	};
	let u, d;
	i - r <= 2 * tg ? u = d = e.sliceDoc(r, i) : (u = e.sliceDoc(r, r + tg), d = e.sliceDoc(i - tg, i));
	let f = /^\s*/.exec(u)[0].length, p = /\s*$/.exec(d)[0].length, m = d.length - p - n.length;
	return u.slice(f, f + t.length) == t && d.slice(m, m + n.length) == n ? {
		open: {
			pos: r + f + t.length,
			margin: +!!/\s/.test(u.charAt(f + t.length))
		},
		close: {
			pos: i - p - n.length,
			margin: +!!/\s/.test(d.charAt(m - 1))
		}
	} : null;
}
function rg(e) {
	let t = [];
	for (let n of e.selection.ranges) {
		let r = e.doc.lineAt(n.from), i = n.to <= r.to ? r : e.doc.lineAt(n.to);
		i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : e.doc.lineAt(n.to - 1));
		let a = t.length - 1;
		a >= 0 && t[a].to > r.from ? t[a].to = i.to : t.push({
			from: r.from + /^\s*/.exec(r.text)[0].length,
			to: i.to
		});
	}
	return t;
}
function ig(e, t, n = t.selection.ranges) {
	let r = n.map((e) => eg(t, e.from).block);
	if (!r.every((e) => e)) return null;
	let i = n.map((e, n) => ng(t, r[n], e.from, e.to));
	if (e != 2 && !i.every((e) => e)) return { changes: t.changes(n.map((e, t) => i[t] ? [] : [{
		from: e.from,
		insert: r[t].open + " "
	}, {
		from: e.to,
		insert: " " + r[t].close
	}])) };
	if (e != 1 && i.some((e) => e)) {
		let e = [];
		for (let t = 0, n; t < i.length; t++) if (n = i[t]) {
			let i = r[t], { open: a, close: o } = n;
			e.push({
				from: a.pos - i.open.length,
				to: a.pos + a.margin
			}, {
				from: o.pos - o.margin,
				to: o.pos + i.close.length
			});
		}
		return { changes: e };
	}
	return null;
}
function ag(e, t, n = t.selection.ranges) {
	let r = [], i = -1;
	ranges: for (let { from: e, to: a } of n) {
		let n = r.length, o = 1e9, s;
		for (let n = e; n <= a;) {
			let c = t.doc.lineAt(n);
			if (s == null && (s = eg(t, c.from).line, !s)) continue ranges;
			if (c.from > i && (e == a || a > c.from)) {
				i = c.from;
				let e = /^\s*/.exec(c.text)[0].length, t = e == c.length, n = c.text.slice(e, e + s.length) == s ? e : -1;
				e < c.text.length && e < o && (o = e), r.push({
					line: c,
					comment: n,
					token: s,
					indent: e,
					empty: t,
					single: !1
				});
			}
			n = c.to + 1;
		}
		if (o < 1e9) for (let e = n; e < r.length; e++) r[e].indent < r[e].line.text.length && (r[e].indent = o);
		r.length == n + 1 && (r[n].single = !0);
	}
	if (e != 2 && r.some((e) => e.comment < 0 && (!e.empty || e.single))) {
		let e = [];
		for (let { line: t, token: n, indent: i, empty: a, single: o } of r) (o || !a) && e.push({
			from: t.from + i,
			insert: n + " "
		});
		let n = t.changes(e);
		return {
			changes: n,
			selection: t.selection.map(n, 1)
		};
	} else if (e != 1 && r.some((e) => e.comment >= 0)) {
		let e = [];
		for (let { line: t, comment: n, token: i } of r) if (n >= 0) {
			let r = t.from + n, a = r + i.length;
			t.text[a - t.from] == " " && a++, e.push({
				from: r,
				to: a
			});
		}
		return { changes: e };
	}
	return null;
}
var og = /*@__PURE__*/ Pi.define(), sg = /*@__PURE__*/ Pi.define(), cg = /*@__PURE__*/ W.define(), lg = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		minDepth: 100,
		newGroupDelay: 500,
		joinToEvent: (e, t) => t
	}, {
		minDepth: Math.max,
		newGroupDelay: Math.min,
		joinToEvent: (e, t) => (n, r) => e(n, r) || t(n, r)
	});
} }), ug = /*@__PURE__*/ gi.define({
	create() {
		return kg.empty;
	},
	update(e, t) {
		let n = t.state.facet(lg), r = t.annotation(og);
		if (r) {
			let i = _g.fromTransaction(t, r.selection), a = r.side, o = a == 0 ? e.undone : e.done;
			return o = i ? vg(o, o.length, n.minDepth, i) : wg(o, t.startState.selection), new kg(a == 0 ? r.rest : o, a == 0 ? o : r.rest);
		}
		let i = t.annotation(sg);
		if ((i == "full" || i == "before") && (e = e.isolate()), t.annotation(Ri.addToHistory) === !1) return t.changes.empty ? e : e.addMapping(t.changes.desc);
		let a = _g.fromTransaction(t), o = t.annotation(Ri.time), s = t.annotation(Ri.userEvent);
		return a ? e = e.addChanges(a, o, s, n, t) : t.selection && (e = e.addSelection(t.startState.selection, o, s, n.newGroupDelay)), (i == "full" || i == "after") && (e = e.isolate()), e;
	},
	toJSON(e) {
		return {
			done: e.done.map((e) => e.toJSON()),
			undone: e.undone.map((e) => e.toJSON())
		};
	},
	fromJSON(e) {
		return new kg(e.done.map(_g.fromJSON), e.undone.map(_g.fromJSON));
	}
});
function dg(e = {}) {
	return [
		ug,
		lg.of(e),
		q.domEventHandlers({ beforeinput(e, t) {
			let n = e.inputType == "historyUndo" ? pg : e.inputType == "historyRedo" ? mg : null;
			return n ? (e.preventDefault(), n(t)) : !1;
		} })
	];
}
function fg(e, t) {
	return function({ state: n, dispatch: r }) {
		if (!t && n.readOnly) return !1;
		let i = n.field(ug, !1);
		if (!i) return !1;
		let a = i.pop(e, n, t);
		return a ? (r(a), !0) : !1;
	};
}
var pg = /*@__PURE__*/ fg(0, !1), mg = /*@__PURE__*/ fg(1, !1), hg = /*@__PURE__*/ fg(0, !0), gg = /*@__PURE__*/ fg(1, !0), _g = class e {
	constructor(e, t, n, r, i) {
		this.changes = e, this.effects = t, this.mapped = n, this.startSelection = r, this.selectionsAfter = i;
	}
	setSelAfter(t) {
		return new e(this.changes, this.effects, this.mapped, this.startSelection, t);
	}
	toJSON() {
		return {
			changes: this.changes?.toJSON(),
			mapped: this.mapped?.toJSON(),
			startSelection: this.startSelection?.toJSON(),
			selectionsAfter: this.selectionsAfter.map((e) => e.toJSON())
		};
	}
	static fromJSON(t) {
		return new e(t.changes && ei.fromJSON(t.changes), [], t.mapped && $r.fromJSON(t.mapped), t.startSelection && U.fromJSON(t.startSelection), t.selectionsAfter.map(U.fromJSON));
	}
	static fromTransaction(t, n) {
		let r = Sg;
		for (let e of t.startState.facet(cg)) {
			let n = e(t);
			n.length && (r = r.concat(n));
		}
		return !r.length && t.changes.empty ? null : new e(t.changes.invert(t.startState.doc), r, void 0, n || t.startState.selection, Sg);
	}
	static selection(t) {
		return new e(void 0, Sg, void 0, void 0, t);
	}
};
function vg(e, t, n, r) {
	let i = t + 1 > n + 20 ? t - n - 1 : 0, a = e.slice(i, t);
	return a.push(r), a;
}
function yg(e, t) {
	let n = [], r = !1;
	return e.iterChangedRanges((e, t) => n.push(e, t)), t.iterChangedRanges((e, t, i, a) => {
		for (let e = 0; e < n.length;) {
			let t = n[e++], o = n[e++];
			a >= t && i <= o && (r = !0);
		}
	}), r;
}
function bg(e, t) {
	return e.ranges.length == t.ranges.length && e.ranges.filter((e, n) => e.empty != t.ranges[n].empty).length === 0;
}
function xg(e, t) {
	return e.length ? t.length ? e.concat(t) : e : t;
}
var Sg = [], Cg = 200;
function wg(e, t) {
	if (e.length) {
		let n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - Cg));
		return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), vg(e, e.length - 1, 1e9, n.setSelAfter(r)));
	} else return [_g.selection([t])];
}
function Tg(e) {
	let t = e[e.length - 1], n = e.slice();
	return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function Eg(e, t) {
	if (!e.length) return e;
	let n = e.length, r = Sg;
	for (; n;) {
		let i = Dg(e[n - 1], t, r);
		if (i.changes && !i.changes.empty || i.effects.length) {
			let t = e.slice(0, n);
			return t[n - 1] = i, t;
		} else t = i.mapped, n--, r = i.selectionsAfter;
	}
	return r.length ? [_g.selection(r)] : Sg;
}
function Dg(e, t, n) {
	let r = xg(e.selectionsAfter.length ? e.selectionsAfter.map((e) => e.map(t)) : Sg, n);
	if (!e.changes) return _g.selection(r);
	let i = e.changes.map(t), a = t.mapDesc(e.changes, !0), o = e.mapped ? e.mapped.composeDesc(a) : a;
	return new _g(i, Li.mapEffects(e.effects, t), o, e.startSelection.map(a), r);
}
var Og = /^(input\.type|delete)($|\.)/, kg = class e {
	constructor(e, t, n = 0, r = void 0) {
		this.done = e, this.undone = t, this.prevTime = n, this.prevUserEvent = r;
	}
	isolate() {
		return this.prevTime ? new e(this.done, this.undone) : this;
	}
	addChanges(t, n, r, i, a) {
		let o = this.done, s = o[o.length - 1];
		return o = s && s.changes && !s.changes.empty && t.changes && (!r || Og.test(r)) && (!s.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(a, yg(s.changes, t.changes)) || r == "input.type.compose") ? vg(o, o.length - 1, i.minDepth, new _g(t.changes.compose(s.changes), xg(Li.mapEffects(t.effects, s.changes), s.effects), s.mapped, s.startSelection, Sg)) : vg(o, o.length, i.minDepth, t), new e(o, Sg, n, r);
	}
	addSelection(t, n, r, i) {
		let a = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Sg;
		return a.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && bg(a[a.length - 1], t) ? this : new e(wg(this.done, t), this.undone, n, r);
	}
	addMapping(t) {
		return new e(Eg(this.done, t), Eg(this.undone, t), this.prevTime, this.prevUserEvent);
	}
	pop(e, t, n) {
		let r = e == 0 ? this.done : this.undone;
		if (r.length == 0) return null;
		let i = r[r.length - 1], a = i.selectionsAfter[0] || (i.startSelection ? i.startSelection.map(i.changes.invertedDesc, 1) : t.selection);
		if (n && i.selectionsAfter.length) return t.update({
			selection: i.selectionsAfter[i.selectionsAfter.length - 1],
			annotations: og.of({
				side: e,
				rest: Tg(r),
				selection: a
			}),
			userEvent: e == 0 ? "select.undo" : "select.redo",
			scrollIntoView: !0
		});
		if (i.changes) {
			let n = r.length == 1 ? Sg : r.slice(0, r.length - 1);
			return i.mapped && (n = Eg(n, i.mapped)), t.update({
				changes: i.changes,
				selection: i.startSelection,
				effects: i.effects,
				annotations: og.of({
					side: e,
					rest: n,
					selection: a
				}),
				filter: !1,
				userEvent: e == 0 ? "undo" : "redo",
				scrollIntoView: !0
			});
		} else return null;
	}
};
kg.empty = /*@__PURE__*/ new kg(Sg, Sg);
var Ag = [
	{
		key: "Mod-z",
		run: pg,
		preventDefault: !0
	},
	{
		key: "Mod-y",
		mac: "Mod-Shift-z",
		run: mg,
		preventDefault: !0
	},
	{
		linux: "Ctrl-Shift-z",
		run: mg,
		preventDefault: !0
	},
	{
		key: "Mod-u",
		run: hg,
		preventDefault: !0
	},
	{
		key: "Alt-u",
		mac: "Mod-Shift-u",
		run: gg,
		preventDefault: !0
	}
];
function jg(e, t) {
	return U.create(e.ranges.map(t), e.mainIndex);
}
function Mg(e, t) {
	return e.update({
		selection: t,
		scrollIntoView: !0,
		userEvent: "select"
	});
}
function Ng({ state: e, dispatch: t }, n) {
	let r = jg(e.selection, n);
	return r.eq(e.selection, !0) ? !1 : (t(Mg(e, r)), !0);
}
function Pg(e, t) {
	return U.cursor(t ? e.to : e.from);
}
function Fg(e, t) {
	return Ng(e, (n) => n.empty ? e.moveByChar(n, t) : Pg(n, t));
}
function Ig(e) {
	return e.textDirectionAt(e.state.selection.main.head) == Fo.LTR;
}
var Lg = (e) => Fg(e, !Ig(e)), Rg = (e) => Fg(e, Ig(e));
function zg(e, t) {
	return Ng(e, (n) => n.empty ? e.moveByGroup(n, t) : Pg(n, t));
}
var Bg = (e) => zg(e, !Ig(e)), Vg = (e) => zg(e, Ig(e));
typeof Intl < "u" && Intl.Segmenter;
function Hg(e, t, n) {
	if (t.type.prop(n)) return !0;
	let r = t.to - t.from;
	return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function Ug(e, t, n) {
	let r = dm(e).resolveInner(t.head), i = n ? $f.closedBy : $f.openedBy;
	for (let a = t.head;;) {
		let t = n ? r.childAfter(a) : r.childBefore(a);
		if (!t) break;
		Hg(e, t, i) ? r = t : a = n ? t.to : t.from;
	}
	let a = r.type.prop(i), o, s;
	return s = a && (o = n ? zh(e, r.from, 1) : zh(e, r.to, -1)) && o.matched ? n ? o.end.to : o.end.from : n ? r.to : r.from, U.cursor(s, n ? -1 : 1);
}
var Wg = (e) => Ng(e, (t) => Ug(e.state, t, !Ig(e))), Gg = (e) => Ng(e, (t) => Ug(e.state, t, Ig(e)));
function Kg(e, t) {
	return Ng(e, (n) => {
		if (!n.empty) return Pg(n, t);
		let r = e.moveVertically(n, t);
		return r.head == n.head ? e.moveToLineBoundary(n, t) : r;
	});
}
var qg = (e) => Kg(e, !1), Jg = (e) => Kg(e, !0);
function Yg(e) {
	let t = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
	if (t) {
		for (let t of e.state.facet(q.scrollMargins)) {
			let i = t(e);
			i?.top && (n = Math.max(i?.top, n)), i?.bottom && (r = Math.max(i?.bottom, r));
		}
		i = e.scrollDOM.clientHeight - n - r;
	} else i = (e.dom.ownerDocument.defaultView || window).innerHeight;
	return {
		marginTop: n,
		marginBottom: r,
		selfScroll: t,
		height: Math.max(e.defaultLineHeight, i - 5)
	};
}
function Xg(e, t) {
	let n = Yg(e), { state: r } = e, i = jg(r.selection, (r) => r.empty ? e.moveVertically(r, t, n.height) : Pg(r, t));
	if (i.eq(r.selection)) return !1;
	let a;
	if (n.selfScroll) {
		let t = e.coordsAtPos(r.selection.main.head), o = e.scrollDOM.getBoundingClientRect(), s = o.top + n.marginTop, c = o.bottom - n.marginBottom;
		t && t.top > s && t.bottom < c && (a = q.scrollIntoView(i.main.head, {
			y: "start",
			yMargin: t.top - s
		}));
	}
	return e.dispatch(Mg(r, i), { effects: a }), !0;
}
var Zg = (e) => Xg(e, !1), Qg = (e) => Xg(e, !0);
function $g(e, t, n) {
	let r = e.lineBlockAt(t.head), i = e.moveToLineBoundary(t, n);
	if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
		let n = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
		n && t.head != r.from + n && (i = U.cursor(r.from + n));
	}
	return i;
}
var e_ = (e) => Ng(e, (t) => $g(e, t, !0)), t_ = (e) => Ng(e, (t) => $g(e, t, !1)), n_ = (e) => Ng(e, (t) => $g(e, t, !Ig(e))), r_ = (e) => Ng(e, (t) => $g(e, t, Ig(e))), i_ = (e) => Ng(e, (t) => U.cursor(e.lineBlockAt(t.head).from, 1)), a_ = (e) => Ng(e, (t) => U.cursor(e.lineBlockAt(t.head).to, -1));
function o_(e, t, n) {
	let r = !1, i = jg(e.selection, (t) => {
		let i = zh(e, t.head, -1) || zh(e, t.head, 1) || t.head > 0 && zh(e, t.head - 1, 1) || t.head < e.doc.length && zh(e, t.head + 1, -1);
		if (!i || !i.end) return t;
		r = !0;
		let a = i.start.from == t.head ? i.end.to : i.end.from;
		return n ? U.range(t.anchor, a) : U.cursor(a);
	});
	return r ? (t(Mg(e, i)), !0) : !1;
}
var s_ = ({ state: e, dispatch: t }) => o_(e, t, !1);
function c_(e, t, n) {
	let r = jg(e.state.selection, (e) => {
		e.undirectional && e.head >= e.anchor != t && (e = U.range(e.head, e.anchor));
		let r = n(e);
		return U.range(e.anchor, r.head, r.goalColumn, r.bidiLevel || void 0, r.assoc);
	});
	return r.eq(e.state.selection) ? !1 : (e.dispatch(Mg(e.state, r)), !0);
}
function l_(e, t) {
	return c_(e, t, (n) => e.moveByChar(n, t));
}
var u_ = (e) => l_(e, !Ig(e)), d_ = (e) => l_(e, Ig(e));
function f_(e, t) {
	return c_(e, t, (n) => e.moveByGroup(n, t));
}
var p_ = (e) => f_(e, !Ig(e)), m_ = (e) => f_(e, Ig(e)), h_ = (e) => {
	let t = !Ig(e);
	return c_(e, t, (n) => Ug(e.state, n, t));
}, g_ = (e) => {
	let t = Ig(e);
	return c_(e, t, (n) => Ug(e.state, n, t));
};
function __(e, t) {
	return c_(e, t, (n) => e.moveVertically(n, t));
}
var v_ = (e) => __(e, !1), y_ = (e) => __(e, !0);
function b_(e, t) {
	return c_(e, t, (n) => e.moveVertically(n, t, Yg(e).height));
}
var x_ = (e) => b_(e, !1), S_ = (e) => b_(e, !0), C_ = (e) => c_(e, !0, (t) => $g(e, t, !0)), w_ = (e) => c_(e, !1, (t) => $g(e, t, !1)), T_ = (e) => {
	let t = !Ig(e);
	return c_(e, t, (n) => $g(e, n, t));
}, E_ = (e) => {
	let t = Ig(e);
	return c_(e, t, (n) => $g(e, n, t));
}, D_ = (e) => c_(e, !1, (t) => U.cursor(e.lineBlockAt(t.head).from)), O_ = (e) => c_(e, !0, (t) => U.cursor(e.lineBlockAt(t.head).to)), k_ = ({ state: e, dispatch: t }) => (t(Mg(e, { anchor: 0 })), !0), A_ = ({ state: e, dispatch: t }) => (t(Mg(e, { anchor: e.doc.length })), !0), j_ = ({ state: e, dispatch: t }) => (t(Mg(e, {
	anchor: e.selection.main.anchor,
	head: 0
})), !0), M_ = ({ state: e, dispatch: t }) => (t(Mg(e, {
	anchor: e.selection.main.anchor,
	head: e.doc.length
})), !0), N_ = ({ state: e, dispatch: t }) => (t(e.update({
	selection: {
		anchor: 0,
		head: e.doc.length
	},
	userEvent: "select"
})), !0), P_ = ({ state: e, dispatch: t }) => {
	let n = $_(e).map(({ from: t, to: n }) => U.range(t, Math.min(n + 1, e.doc.length)));
	return t(e.update({
		selection: U.create(n),
		userEvent: "select"
	})), !0;
}, F_ = ({ state: e, dispatch: t }) => {
	let n = jg(e.selection, (t) => {
		let n = dm(e), r = n.resolveStack(t.from, 1);
		if (t.empty) {
			let e = n.resolveStack(t.from, -1);
			e.node.from >= r.node.from && e.node.to <= r.node.to && (r = e);
		}
		for (let e = r; e; e = e.next) {
			let { node: n } = e;
			if ((n.from < t.from && n.to >= t.to || n.to > t.to && n.from <= t.from) && e.next) return U.range(n.to, n.from);
		}
		return t;
	});
	return n.eq(e.selection) ? !1 : (t(Mg(e, n)), !0);
};
function I_(e, t) {
	let { state: n } = e, r = n.selection, i = n.selection.ranges.slice();
	for (let r of n.selection.ranges) {
		let a = n.doc.lineAt(r.head);
		if (t ? a.to < e.state.doc.length : a.from > 0) for (let n = r;;) {
			let r = e.moveVertically(n, t);
			if (r.head < a.from || r.head > a.to) {
				i.some((e) => e.head == r.head) || i.push(r);
				break;
			} else if (r.head == n.head) break;
			else n = r;
		}
	}
	return i.length == r.ranges.length ? !1 : (e.dispatch(Mg(n, U.create(i, i.length - 1))), !0);
}
var L_ = (e) => I_(e, !1), R_ = (e) => I_(e, !0), z_ = ({ state: e, dispatch: t }) => {
	let n = e.selection, r = null;
	return n.ranges.length > 1 ? r = U.create([n.main]) : n.main.empty || (r = U.create([U.cursor(n.main.head)])), r ? (t(Mg(e, r)), !0) : !1;
};
function B_(e, t) {
	if (e.state.readOnly) return !1;
	let n = "delete.selection", { state: r } = e, i = r.changeByRange((r) => {
		let { from: i, to: a } = r;
		if (i == a) {
			let o = t(r);
			o < i ? (n = "delete.backward", o = V_(e, o, !1)) : o > i && (n = "delete.forward", o = V_(e, o, !0)), i = Math.min(i, o), a = Math.max(a, o);
		} else i = V_(e, i, !1), a = V_(e, a, !0);
		return i == a ? { range: r } : {
			changes: {
				from: i,
				to: a
			},
			range: U.cursor(i, i < r.head ? -1 : 1)
		};
	});
	return i.changes.empty ? !1 : (e.dispatch(r.update(i, {
		scrollIntoView: !0,
		userEvent: n,
		effects: n == "delete.selection" ? q.announce.of(r.phrase("Selection deleted")) : void 0
	})), !0);
}
function V_(e, t, n) {
	if (e instanceof q) for (let r of e.state.facet(q.atomicRanges).map((t) => t(e))) r.between(t, t, (e, r) => {
		e < t && r > t && (t = n ? r : e);
	});
	return t;
}
var H_ = (e, t, n) => B_(e, (r) => {
	let i = r.from, { state: a } = e, o = a.doc.lineAt(i), s, c;
	if (n && !t && i > o.from && i < o.from + 200 && !/[^ \t]/.test(s = o.text.slice(0, i - o.from))) {
		if (s[s.length - 1] == "	") return i - 1;
		let e = va(s, a.tabSize) % wm(a) || wm(a);
		for (let t = 0; t < e && s[s.length - 1 - t] == " "; t++) i--;
		c = i;
	} else c = Gr(o.text, i - o.from, t, t) + o.from, c == i && o.number != (t ? a.doc.lines : 1) ? c += t ? 1 : -1 : !t && /[\ufe00-\ufe0f]/.test(o.text.slice(c - o.from, i - o.from)) && (c = Gr(o.text, c - o.from, !1, !1) + o.from);
	return c;
}), U_ = (e) => H_(e, !1, !0), W_ = (e) => H_(e, !0, !1), G_ = (e, t) => B_(e, (n) => {
	let r = n.head, { state: i } = e, a = i.doc.lineAt(r), o = i.charCategorizer(r);
	for (let e = null;;) {
		if (r == (t ? a.to : a.from)) {
			r == n.head && a.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
			break;
		}
		let s = Gr(a.text, r - a.from, t) + a.from, c = a.text.slice(Math.min(r, s) - a.from, Math.max(r, s) - a.from), l = o(c);
		if (e != null && l != e) break;
		(c != " " || r != n.head) && (e = l), r = s;
	}
	return r;
}), K_ = (e) => G_(e, !1), q_ = (e) => G_(e, !0), J_ = (e) => B_(e, (t) => {
	let n = e.lineBlockAt(t.head).to;
	return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), Y_ = (e) => B_(e, (t) => {
	let n = e.moveToLineBoundary(t, !1).head;
	return t.head > n ? n : Math.max(0, t.head - 1);
}), X_ = (e) => B_(e, (t) => {
	let n = e.moveToLineBoundary(t, !0).head;
	return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), Z_ = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = e.changeByRange((e) => ({
		changes: {
			from: e.from,
			to: e.to,
			insert: Pr.of(["", ""])
		},
		range: U.cursor(e.from)
	}));
	return t(e.update(n, {
		scrollIntoView: !0,
		userEvent: "input"
	})), !0;
}, Q_ = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = e.changeByRange((t) => {
		if (!t.empty || t.from == 0 || t.from == e.doc.length) return { range: t };
		let n = t.from, r = e.doc.lineAt(n), i = n == r.from ? n - 1 : Gr(r.text, n - r.from, !1) + r.from, a = n == r.to ? n + 1 : Gr(r.text, n - r.from, !0) + r.from;
		return {
			changes: {
				from: i,
				to: a,
				insert: e.doc.slice(n, a).append(e.doc.slice(i, n))
			},
			range: U.cursor(a)
		};
	});
	return n.changes.empty ? !1 : (t(e.update(n, {
		scrollIntoView: !0,
		userEvent: "move.character"
	})), !0);
};
function $_(e) {
	let t = [], n = -1;
	for (let r of e.selection.ranges) {
		let i = e.doc.lineAt(r.from), a = e.doc.lineAt(r.to);
		if (!r.empty && r.to == a.from && (a = e.doc.lineAt(r.to - 1)), n >= i.number) {
			let e = t[t.length - 1];
			e.to = a.to, e.ranges.push(r);
		} else t.push({
			from: i.from,
			to: a.to,
			ranges: [r]
		});
		n = a.number + 1;
	}
	return t;
}
function ev(e, t, n) {
	if (e.readOnly) return !1;
	let r = [], i = [];
	for (let t of $_(e)) {
		if (n ? t.to == e.doc.length : t.from == 0) continue;
		let a = e.doc.lineAt(n ? t.to + 1 : t.from - 1), o = a.length + 1;
		if (n) {
			r.push({
				from: t.to,
				to: a.to
			}, {
				from: t.from,
				insert: a.text + e.lineBreak
			});
			for (let n of t.ranges) i.push(U.range(Math.min(e.doc.length, n.anchor + o), Math.min(e.doc.length, n.head + o)));
		} else {
			r.push({
				from: a.from,
				to: t.from
			}, {
				from: t.to,
				insert: e.lineBreak + a.text
			});
			for (let e of t.ranges) i.push(U.range(e.anchor - o, e.head - o));
		}
	}
	return r.length ? (t(e.update({
		changes: r,
		scrollIntoView: !0,
		selection: U.create(i, e.selection.mainIndex),
		userEvent: "move.line"
	})), !0) : !1;
}
var tv = ({ state: e, dispatch: t }) => ev(e, t, !1), nv = ({ state: e, dispatch: t }) => ev(e, t, !0);
function rv(e, t, n) {
	if (e.readOnly) return !1;
	let r = [];
	for (let t of $_(e)) n ? r.push({
		from: t.from,
		insert: e.doc.slice(t.from, t.to) + e.lineBreak
	}) : r.push({
		from: t.to,
		insert: e.lineBreak + e.doc.slice(t.from, t.to)
	});
	let i = e.changes(r);
	return t(e.update({
		changes: i,
		selection: e.selection.map(i, n ? 1 : -1),
		scrollIntoView: !0,
		userEvent: "input.copyline"
	})), !0;
}
var iv = ({ state: e, dispatch: t }) => rv(e, t, !1), av = ({ state: e, dispatch: t }) => rv(e, t, !0), ov = (e) => {
	if (e.state.readOnly) return !1;
	let { state: t } = e, n = t.changes($_(t).map(({ from: e, to: n }) => (e > 0 ? e-- : n < t.doc.length && n++, {
		from: e,
		to: n
	}))), r = jg(t.selection, (t) => {
		let n;
		if (e.lineWrapping) {
			let r = e.lineBlockAt(t.head), i = e.coordsAtPos(t.head, t.assoc || 1);
			i && (n = r.bottom + e.documentTop - i.bottom + e.defaultLineHeight / 2);
		}
		return e.moveVertically(t, !0, n);
	}).map(n);
	return e.dispatch({
		changes: n,
		selection: r,
		scrollIntoView: !0,
		userEvent: "delete.line"
	}), !0;
};
function sv(e, t) {
	if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1))) return {
		from: t,
		to: t
	};
	let n = dm(e).resolveInner(t), r = n.childBefore(t), i = n.childAfter(t), a;
	return r && i && r.to <= t && i.from >= t && (a = r.type.prop($f.closedBy)) && a.indexOf(i.name) > -1 && e.doc.lineAt(r.to).from == e.doc.lineAt(i.from).from && !/\S/.test(e.sliceDoc(r.to, i.from)) ? {
		from: r.to,
		to: i.from
	} : null;
}
var cv = /*@__PURE__*/ uv(!1), lv = /*@__PURE__*/ uv(!0);
function uv(e) {
	return ({ state: t, dispatch: n }) => {
		if (t.readOnly) return !1;
		let r = t.changeByRange((n) => {
			let { from: r, to: i } = n, a = t.doc.lineAt(r), o = !e && r == i && sv(t, r);
			e && (r = i = (i <= a.to ? a : t.doc.lineAt(i)).to);
			let s = new Dm(t, {
				simulateBreak: r,
				simulateDoubleBreak: !!o
			}), c = Em(s, r);
			for (c ??= va(/^\s*/.exec(t.doc.lineAt(r).text)[0], t.tabSize); i < a.to && /\s/.test(a.text[i - a.from]);) i++;
			o ? {from: r, to: i} = o : r > a.from && r < a.from + 100 && !/\S/.test(a.text.slice(0, r)) && (r = a.from);
			let l = ["", Tm(t, c)];
			return o && l.push(Tm(t, s.lineIndent(a.from, -1))), {
				changes: {
					from: r,
					to: i,
					insert: Pr.of(l)
				},
				range: U.cursor(r + 1 + l[1].length)
			};
		});
		return n(t.update(r, {
			scrollIntoView: !0,
			userEvent: "input"
		})), !0;
	};
}
function dv(e, t) {
	let n = -1;
	return e.changeByRange((r) => {
		let i = [];
		for (let a = r.from; a <= r.to;) {
			let o = e.doc.lineAt(a);
			o.number > n && (r.empty || r.to > o.from) && (t(o, i, r), n = o.number), a = o.to + 1;
		}
		let a = e.changes(i);
		return {
			changes: i,
			range: U.range(a.mapPos(r.anchor, 1), a.mapPos(r.head, 1))
		};
	});
}
var fv = ({ state: e, dispatch: t }) => {
	if (e.readOnly) return !1;
	let n = Object.create(null), r = new Dm(e, { overrideIndentation: (e) => n[e] ?? -1 }), i = dv(e, (t, i, a) => {
		let o = Em(r, t.from);
		if (o == null) return;
		/\S/.test(t.text) || (o = 0);
		let s = /^\s*/.exec(t.text)[0], c = Tm(e, o);
		(s != c || a.from < t.from + s.length) && (n[t.from] = o, i.push({
			from: t.from,
			to: t.from + s.length,
			insert: c
		}));
	});
	return i.changes.empty || t(e.update(i, { userEvent: "indent" })), !0;
}, pv = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(dv(e, (t, n) => {
	n.push({
		from: t.from,
		insert: e.facet(Cm)
	});
}), { userEvent: "input.indent" })), !0), mv = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(dv(e, (t, n) => {
	let r = /^\s*/.exec(t.text)[0];
	if (!r) return;
	let i = va(r, e.tabSize), a = 0, o = Tm(e, Math.max(0, i - wm(e)));
	for (; a < r.length && a < o.length && r.charCodeAt(a) == o.charCodeAt(a);) a++;
	n.push({
		from: t.from + a,
		to: t.from + r.length,
		insert: o.slice(a)
	});
}), { userEvent: "delete.dedent" })), !0), hv = (e) => (e.setTabFocusMode(), !0), gv = [
	{
		key: "Ctrl-b",
		run: Lg,
		shift: u_,
		preventDefault: !0
	},
	{
		key: "Ctrl-f",
		run: Rg,
		shift: d_
	},
	{
		key: "Ctrl-p",
		run: qg,
		shift: v_
	},
	{
		key: "Ctrl-n",
		run: Jg,
		shift: y_
	},
	{
		key: "Ctrl-a",
		run: i_,
		shift: D_
	},
	{
		key: "Ctrl-e",
		run: a_,
		shift: O_
	},
	{
		key: "Ctrl-d",
		run: W_
	},
	{
		key: "Ctrl-h",
		run: U_
	},
	{
		key: "Ctrl-k",
		run: J_
	},
	{
		key: "Ctrl-Alt-h",
		run: K_
	},
	{
		key: "Ctrl-o",
		run: Z_
	},
	{
		key: "Ctrl-t",
		run: Q_
	},
	{
		key: "Ctrl-v",
		run: Qg
	}
], _v = /*@__PURE__*/ [
	{
		key: "ArrowLeft",
		run: Lg,
		shift: u_,
		preventDefault: !0
	},
	{
		key: "Mod-ArrowLeft",
		mac: "Alt-ArrowLeft",
		run: Bg,
		shift: p_,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowLeft",
		run: n_,
		shift: T_,
		preventDefault: !0
	},
	{
		key: "ArrowRight",
		run: Rg,
		shift: d_,
		preventDefault: !0
	},
	{
		key: "Mod-ArrowRight",
		mac: "Alt-ArrowRight",
		run: Vg,
		shift: m_,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowRight",
		run: r_,
		shift: E_,
		preventDefault: !0
	},
	{
		key: "ArrowUp",
		run: qg,
		shift: v_,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowUp",
		run: k_,
		shift: j_
	},
	{
		mac: "Ctrl-ArrowUp",
		run: Zg,
		shift: x_
	},
	{
		key: "ArrowDown",
		run: Jg,
		shift: y_,
		preventDefault: !0
	},
	{
		mac: "Cmd-ArrowDown",
		run: A_,
		shift: M_
	},
	{
		mac: "Ctrl-ArrowDown",
		run: Qg,
		shift: S_
	},
	{
		key: "PageUp",
		run: Zg,
		shift: x_
	},
	{
		key: "PageDown",
		run: Qg,
		shift: S_
	},
	{
		key: "Home",
		run: t_,
		shift: w_,
		preventDefault: !0
	},
	{
		key: "Mod-Home",
		run: k_,
		shift: j_
	},
	{
		key: "End",
		run: e_,
		shift: C_,
		preventDefault: !0
	},
	{
		key: "Mod-End",
		run: A_,
		shift: M_
	},
	{
		key: "Enter",
		run: cv,
		shift: cv
	},
	{
		key: "Mod-a",
		run: N_
	},
	{
		key: "Backspace",
		run: U_,
		shift: U_,
		preventDefault: !0
	},
	{
		key: "Delete",
		run: W_,
		preventDefault: !0
	},
	{
		key: "Mod-Backspace",
		mac: "Alt-Backspace",
		run: K_,
		preventDefault: !0
	},
	{
		key: "Mod-Delete",
		mac: "Alt-Delete",
		run: q_,
		preventDefault: !0
	},
	{
		mac: "Mod-Backspace",
		run: Y_,
		preventDefault: !0
	},
	{
		mac: "Mod-Delete",
		run: X_,
		preventDefault: !0
	}
].concat(/*@__PURE__*/ gv.map((e) => ({
	mac: e.key,
	run: e.run,
	shift: e.shift
}))), vv = /*@__PURE__*/ [
	{
		key: "Alt-ArrowLeft",
		mac: "Ctrl-ArrowLeft",
		run: Wg,
		shift: h_
	},
	{
		key: "Alt-ArrowRight",
		mac: "Ctrl-ArrowRight",
		run: Gg,
		shift: g_
	},
	{
		key: "Alt-ArrowUp",
		run: tv
	},
	{
		key: "Shift-Alt-ArrowUp",
		run: iv
	},
	{
		key: "Alt-ArrowDown",
		run: nv
	},
	{
		key: "Shift-Alt-ArrowDown",
		run: av
	},
	{
		key: "Mod-Alt-ArrowUp",
		run: L_
	},
	{
		key: "Mod-Alt-ArrowDown",
		run: R_
	},
	{
		key: "Escape",
		run: z_
	},
	{
		key: "Mod-Enter",
		run: lv
	},
	{
		key: "Alt-l",
		mac: "Ctrl-l",
		run: P_
	},
	{
		key: "Mod-i",
		run: F_,
		preventDefault: !0
	},
	{
		key: "Mod-[",
		run: mv
	},
	{
		key: "Mod-]",
		run: pv
	},
	{
		key: "Mod-Alt-\\",
		run: fv
	},
	{
		key: "Shift-Mod-k",
		run: ov
	},
	{
		key: "Shift-Mod-\\",
		run: s_
	},
	{
		key: "Mod-/",
		run: Yh
	},
	{
		key: "Alt-A",
		run: Qh
	},
	{
		key: "Ctrl-m",
		mac: "Shift-Alt-m",
		run: hv
	}
].concat(_v), yv = {
	key: "Tab",
	run: pv,
	shift: mv
}, bv = typeof String.prototype.normalize == "function" ? (e) => e.normalize("NFKD") : (e) => e, xv = class {
	constructor(e, t, n = 0, r = e.length, i, a) {
		this.test = a, this.value = {
			from: 0,
			to: 0,
			precise: !1
		}, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(n, r), this.bufferStart = n, this.normalize = i ? (e) => i(bv(e)) : bv, this.query = this.normalize(t);
	}
	peek() {
		if (this.bufferPos == this.buffer.length) {
			if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done) return -1;
			this.bufferPos = 0, this.buffer = this.iter.value;
		}
		return Jr(this.buffer, this.bufferPos);
	}
	next() {
		for (; this.matches.length;) this.matches.pop();
		return this.nextOverlapping();
	}
	nextOverlapping() {
		for (;;) {
			let e = this.peek();
			if (e < 0) return this.done = !0, this;
			let t = Yr(e), n = this.bufferStart + this.bufferPos;
			this.bufferPos += Xr(e);
			let r = this.normalize(t);
			if (r.length) for (let e = 0, i = n, a = !0;; e++) {
				let n = r.charCodeAt(e), o = this.match(n, i, a, this.bufferPos + this.bufferStart, e == r.length - 1);
				if (o) return this.value = o, this;
				if (e == r.length - 1) break;
				a && e < t.length && t.charCodeAt(e) == n ? i++ : a = !1;
			}
		}
	}
	match(e, t, n, r, i) {
		let a = null;
		for (let t = 0; t < this.matches.length;) {
			let n = this.matches[t], o = !1;
			this.query.charCodeAt(n.index) == e && (n.index == this.query.length - 1 ? a = {
				from: n.from,
				to: r,
				precise: i && n.precise
			} : (n.index++, o = !0)), o ? t++ : this.matches.splice(t, 1);
		}
		return this.query.charCodeAt(0) == e && (this.query.length == 1 ? a = {
			from: t,
			to: r,
			precise: n && i
		} : this.matches.push({
			from: t,
			index: 1,
			precise: n
		})), a && this.test && !this.test(a.from, a.to, this.buffer, this.bufferStart) && (a = null), a;
	}
};
typeof Symbol < "u" && (xv.prototype[Symbol.iterator] = function() {
	return this;
});
var Sv = {
	from: -1,
	to: -1,
	match: /*@__PURE__*/ /.*/.exec(""),
	precise: !0
}, Cv = "gm" + (/x/.unicode == null ? "" : "u"), wv = class {
	constructor(e, t, n, r = 0, i = e.length) {
		if (this.text = e, this.to = i, this.curLine = "", this.done = !1, this.value = Sv, /\\[sWDnr]|\n|\r|\[\^/.test(t)) return new Dv(e, t, n, r, i);
		this.re = new RegExp(t, Cv + (n?.ignoreCase ? "i" : "")), this.test = n?.test, this.iter = e.iter();
		let a = e.lineAt(r);
		this.curLineStart = a.from, this.matchPos = kv(e, r), this.getLine(this.curLineStart);
	}
	getLine(e) {
		this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
	}
	nextLine() {
		this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
	}
	next() {
		for (let e = this.matchPos - this.curLineStart;;) {
			this.re.lastIndex = e;
			let t = this.matchPos <= this.to && this.re.exec(this.curLine);
			if (t) {
				let n = this.curLineStart + t.index, r = n + t[0].length;
				if (this.matchPos = kv(this.text, r + +(n == r)), n == this.curLineStart + this.curLine.length && this.nextLine(), (n < r || n > this.value.to) && (!this.test || this.test(n, r, t))) return this.value = {
					from: n,
					to: r,
					precise: !0,
					match: t
				}, this;
				e = this.matchPos - this.curLineStart;
			} else if (this.curLineStart + this.curLine.length < this.to) this.nextLine(), e = 0;
			else return this.done = !0, this;
		}
	}
}, Tv = /*@__PURE__*/ new WeakMap(), Ev = class e {
	constructor(e, t) {
		this.from = e, this.text = t;
	}
	get to() {
		return this.from + this.text.length;
	}
	static get(t, n, r) {
		let i = Tv.get(t);
		if (!i || i.from >= r || i.to <= n) {
			let i = new e(n, t.sliceString(n, r));
			return Tv.set(t, i), i;
		}
		if (i.from == n && i.to == r) return i;
		let { text: a, from: o } = i;
		return o > n && (a = t.sliceString(n, o) + a, o = n), i.to < r && (a += t.sliceString(i.to, r)), Tv.set(t, new e(o, a)), new e(n, a.slice(n - o, r - o));
	}
}, Dv = class {
	constructor(e, t, n, r, i) {
		this.text = e, this.to = i, this.done = !1, this.value = Sv, this.matchPos = kv(e, r), this.re = new RegExp(t, Cv + (n?.ignoreCase ? "i" : "")), this.test = n?.test, this.flat = Ev.get(e, r, this.chunkEnd(r + 5e3));
	}
	chunkEnd(e) {
		return e >= this.to ? this.to : this.text.lineAt(e).to;
	}
	next() {
		for (;;) {
			let e = this.re.lastIndex = this.matchPos - this.flat.from, t = this.re.exec(this.flat.text);
			if (t && !t[0] && t.index == e && (this.re.lastIndex = e + 1, t = this.re.exec(this.flat.text)), t) {
				let e = this.flat.from + t.index, n = e + t[0].length;
				if ((this.flat.to >= this.to || t.index + t[0].length <= this.flat.text.length - 10) && (!this.test || this.test(e, n, t))) return this.value = {
					from: e,
					to: n,
					precise: !0,
					match: t
				}, this.matchPos = kv(this.text, n + +(e == n)), this;
			}
			if (this.flat.to == this.to) return this.done = !0, this;
			this.flat = Ev.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
		}
	}
};
typeof Symbol < "u" && (wv.prototype[Symbol.iterator] = Dv.prototype[Symbol.iterator] = function() {
	return this;
});
function Ov(e) {
	try {
		return new RegExp(e, Cv), !0;
	} catch {
		return !1;
	}
}
function kv(e, t) {
	if (t >= e.length) return t;
	let n = e.lineAt(t), r;
	for (; t < n.to && (r = n.text.charCodeAt(t - n.from)) >= 56320 && r < 57344;) t++;
	return t;
}
var Av = (e) => {
	let { state: t } = e, n = String(t.doc.lineAt(e.state.selection.main.head).number), { close: r, result: i } = yf(e, {
		label: t.phrase("Go to line"),
		input: {
			type: "text",
			name: "line",
			value: n
		},
		focus: !0,
		submitLabel: t.phrase("go")
	});
	return i.then((n) => {
		let i = n && /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.elements.line.value);
		if (!i) {
			e.dispatch({ effects: r });
			return;
		}
		let a = t.doc.lineAt(t.selection.main.head), [, o, s, c, l] = i, u = c ? +c.slice(1) : 0, d = s ? +s : a.number;
		if (s && l) {
			let e = d / 100;
			o && (e = e * (o == "-" ? -1 : 1) + a.number / t.doc.lines), d = Math.round(t.doc.lines * e);
		} else s && o && (d = d * (o == "-" ? -1 : 1) + a.number);
		let f = t.doc.line(Math.max(1, Math.min(t.doc.lines, d))), p = U.cursor(f.from + Math.max(0, Math.min(u, f.length)));
		e.dispatch({
			effects: [r, q.scrollIntoView(p.from, { y: "center" })],
			selection: p
		});
	}), !0;
}, jv = {
	highlightWordAroundCursor: !1,
	minSelectionLength: 1,
	maxMatches: 100,
	wholeWords: !1
}, Mv = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, jv, {
		highlightWordAroundCursor: (e, t) => e || t,
		minSelectionLength: Math.min,
		maxMatches: Math.min
	});
} });
function Nv(e) {
	let t = [zv, Rv];
	return e && t.push(Mv.of(e)), t;
}
var Pv = /*@__PURE__*/ K.mark({ class: "cm-selectionMatch" }), Fv = /*@__PURE__*/ K.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function Iv(e, t, n, r) {
	return (n == 0 || e(t.sliceDoc(n - 1, n)) != qi.Word) && (r == t.doc.length || e(t.sliceDoc(r, r + 1)) != qi.Word);
}
function Lv(e, t, n, r) {
	return e(t.sliceDoc(n, n + 1)) == qi.Word && e(t.sliceDoc(r - 1, r)) == qi.Word;
}
var Rv = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.decorations = this.getDeco(e);
	}
	update(e) {
		(e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
	}
	getDeco(e) {
		let t = e.state.facet(Mv), { state: n } = e, r = n.selection;
		if (r.ranges.length > 1) return K.none;
		let i = r.main, a, o = null;
		if (i.empty) {
			if (!t.highlightWordAroundCursor) return K.none;
			let e = n.wordAt(i.head);
			if (!e) return K.none;
			o = n.charCategorizer(i.head), a = n.sliceDoc(e.from, e.to);
		} else {
			let e = i.to - i.from;
			if (e < t.minSelectionLength || e > 200) return K.none;
			if (t.wholeWords) {
				if (a = n.sliceDoc(i.from, i.to), o = n.charCategorizer(i.head), !(Iv(o, n, i.from, i.to) && Lv(o, n, i.from, i.to))) return K.none;
			} else if (a = n.sliceDoc(i.from, i.to), !a) return K.none;
		}
		let s = [];
		for (let r of e.visibleRanges) {
			let e = new xv(n.doc, a, r.from, r.to);
			for (; !e.next().done;) {
				let { from: r, to: a } = e.value;
				if ((!o || Iv(o, n, r, a)) && (i.empty && r <= i.from && a >= i.to ? s.push(Fv.range(r, a)) : (r >= i.to || a <= i.from) && s.push(Pv.range(r, a)), s.length > t.maxMatches)) return K.none;
			}
		}
		return K.set(s);
	}
}, { decorations: (e) => e.decorations }), zv = /*@__PURE__*/ q.baseTheme({
	".cm-selectionMatch": { backgroundColor: "#99ff7780" },
	".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), Bv = ({ state: e, dispatch: t }) => {
	let { selection: n } = e, r = U.create(n.ranges.map((t) => e.wordAt(t.head) || U.cursor(t.head)), n.mainIndex);
	return r.eq(n) ? !1 : (t(e.update({ selection: r })), !0);
};
function Vv(e, t) {
	let { main: n, ranges: r } = e.selection, i = e.wordAt(n.head), a = i && i.from == n.from && i.to == n.to;
	for (let n = !1, i = new xv(e.doc, t, r[r.length - 1].to);;) if (i.next(), i.done) {
		if (n) return null;
		i = new xv(e.doc, t, 0, Math.max(0, r[r.length - 1].from - 1)), n = !0;
	} else {
		if (n && r.some((e) => e.from == i.value.from)) continue;
		if (a) {
			let t = e.wordAt(i.value.from);
			if (!t || t.from != i.value.from || t.to != i.value.to) continue;
		}
		return i.value;
	}
}
var Hv = ({ state: e, dispatch: t }) => {
	let { ranges: n } = e.selection;
	if (n.some((e) => e.from === e.to)) return Bv({
		state: e,
		dispatch: t
	});
	let r = e.sliceDoc(n[0].from, n[0].to);
	if (e.selection.ranges.some((t) => e.sliceDoc(t.from, t.to) != r)) return !1;
	let i = Vv(e, r);
	return i ? (t(e.update({
		selection: e.selection.addRange(U.range(i.from, i.to), !1),
		effects: q.scrollIntoView(i.to)
	})), !0) : !1;
}, Uv = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		top: !1,
		caseSensitive: !1,
		literal: !1,
		regexp: !1,
		wholeWord: !1,
		createPanel: (e) => new Cy(e),
		scrollToMatch: (e) => q.scrollIntoView(e)
	});
} }), Wv = class {
	constructor(e) {
		this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || Ov(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord, this.test = e.test;
	}
	unquote(e) {
		return this.literal ? e : e.replace(/\\([nrt\\])/g, (e, t) => t == "n" ? "\n" : t == "r" ? "\r" : t == "t" ? "	" : "\\");
	}
	eq(e) {
		return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord && this.test == e.test;
	}
	create() {
		return this.regexp ? new ty(this) : new Yv(this);
	}
	getCursor(e, t = 0, n) {
		let r = e.doc ? e : Qi.create({ doc: e });
		return n ??= r.doc.length, this.regexp ? Zv(this, r, t, n) : qv(this, r, t, n);
	}
}, Gv = class {
	constructor(e) {
		this.spec = e;
	}
};
function Kv(e, t, n) {
	return (r, i, a, o) => n && !n(r, i, a, o) ? !1 : e(r >= o && i <= o + a.length ? a.slice(r - o, i - o) : t.doc.sliceString(r, i), t, r, i);
}
function qv(e, t, n, r) {
	let i;
	return e.wholeWord && (i = Jv(t.doc, t.charCategorizer(t.selection.main.head))), e.test && (i = Kv(e.test, t, i)), new xv(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : (e) => e.toLowerCase(), i);
}
function Jv(e, t) {
	return (n, r, i, a) => ((a > n || a + i.length < r) && (a = Math.max(0, n - 2), i = e.sliceString(a, Math.min(e.length, r + 2))), (t(Qv(i, n - a)) != qi.Word || t($v(i, n - a)) != qi.Word) && (t($v(i, r - a)) != qi.Word || t(Qv(i, r - a)) != qi.Word));
}
var Yv = class extends Gv {
	constructor(e) {
		super(e);
	}
	nextMatch(e, t, n) {
		let r = qv(this.spec, e, n, e.doc.length).nextOverlapping();
		if (r.done) {
			let n = Math.min(e.doc.length, t + this.spec.unquoted.length);
			r = qv(this.spec, e, 0, n).nextOverlapping();
		}
		return r.done || r.value.from == t && r.value.to == n ? null : r.value;
	}
	prevMatchInRange(e, t, n) {
		for (let r = n;;) {
			let n = Math.max(t, r - 1e4 - this.spec.unquoted.length), i = qv(this.spec, e, n, r), a = null;
			for (; !i.nextOverlapping().done;) a = i.value;
			if (a) return a;
			if (n == t) return null;
			r -= 1e4;
		}
	}
	prevMatch(e, t, n) {
		let r = this.prevMatchInRange(e, 0, t);
		return r ||= this.prevMatchInRange(e, Math.max(0, n - this.spec.unquoted.length), e.doc.length), r && (r.from != t || r.to != n) ? r : null;
	}
	getReplacement(e) {
		return this.spec.unquote(this.spec.replace);
	}
	matchAll(e, t) {
		let n = qv(this.spec, e, 0, e.doc.length), r = [];
		for (; !n.next().done;) {
			if (r.length >= t) return null;
			r.push(n.value);
		}
		return r;
	}
	highlight(e, t, n, r) {
		let i = qv(this.spec, e, Math.max(0, t - this.spec.unquoted.length), Math.min(n + this.spec.unquoted.length, e.doc.length));
		for (; !i.next().done;) r(i.value.from, i.value.to);
	}
};
function Xv(e, t, n) {
	return (r, i, a) => (!n || n(r, i, a)) && e(a[0], t, r, i);
}
function Zv(e, t, n, r) {
	let i;
	return e.wholeWord && (i = ey(t.charCategorizer(t.selection.main.head))), e.test && (i = Xv(e.test, t, i)), new wv(t.doc, e.search, {
		ignoreCase: !e.caseSensitive,
		test: i
	}, n, r);
}
function Qv(e, t) {
	return e.slice(Gr(e, t, !1), t);
}
function $v(e, t) {
	return e.slice(t, Gr(e, t));
}
function ey(e) {
	return (t, n, r) => !r[0].length || (e(Qv(r.input, r.index)) != qi.Word || e($v(r.input, r.index)) != qi.Word) && (e($v(r.input, r.index + r[0].length)) != qi.Word || e(Qv(r.input, r.index + r[0].length)) != qi.Word);
}
var ty = class extends Gv {
	nextMatch(e, t, n) {
		let r = Zv(this.spec, e, n, e.doc.length).next();
		return r.done && (r = Zv(this.spec, e, 0, t).next()), r.done ? null : r.value;
	}
	prevMatchInRange(e, t, n) {
		for (let r = 1;; r++) {
			let i = Math.max(t, n - r * 1e4), a = Zv(this.spec, e, i, n), o = null;
			for (; !a.next().done;) o = a.value;
			if (o && (i == t || o.from > i + 10)) return o;
			if (i == t) return null;
		}
	}
	prevMatch(e, t, n) {
		return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, n, e.doc.length);
	}
	getReplacement(e) {
		return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (t, n) => {
			if (n == "&") return e.match[0];
			if (n == "$") return "$";
			for (let t = n.length; t > 0; t--) {
				let r = +n.slice(0, t);
				if (r > 0 && r < e.match.length) return e.match[r] + n.slice(t);
			}
			return t;
		});
	}
	matchAll(e, t) {
		let n = Zv(this.spec, e, 0, e.doc.length), r = [];
		for (; !n.next().done;) {
			if (r.length >= t) return null;
			r.push(n.value);
		}
		return r;
	}
	highlight(e, t, n, r) {
		let i = Zv(this.spec, e, Math.max(0, t - 250), Math.min(n + 250, e.doc.length));
		for (; !i.next().done;) r(i.value.from, i.value.to);
	}
}, ny = /*@__PURE__*/ Li.define(), ry = /*@__PURE__*/ Li.define(), iy = /*@__PURE__*/ gi.define({
	create(e) {
		return new ay(_y(e).create(), null);
	},
	update(e, t) {
		for (let n of t.effects) n.is(ny) ? e = new ay(n.value.create(), e.panel) : n.is(ry) && (e = new ay(e.query, n.value ? gy : null));
		return e;
	},
	provide: (e) => vf.from(e, (e) => e.panel)
}), ay = class {
	constructor(e, t) {
		this.query = e, this.panel = t;
	}
}, oy = /*@__PURE__*/ K.mark({ class: "cm-searchMatch" }), sy = /*@__PURE__*/ K.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), cy = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.decorations = this.highlight(e.state.field(iy));
	}
	update(e) {
		let t = e.state.field(iy);
		(t != e.startState.field(iy) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
	}
	highlight({ query: e, panel: t }) {
		if (!t || !e.spec.valid) return K.none;
		let { view: n } = this, r = new sa();
		for (let t = 0, i = n.visibleRanges, a = i.length; t < a; t++) {
			let { from: o, to: s } = i[t];
			for (; t < a - 1 && s > i[t + 1].from - 500;) s = i[++t].to;
			e.highlight(n.state, o, s, (e, t) => {
				let i = n.state.selection.ranges.some((n) => n.from == e && n.to == t);
				r.add(e, t, i ? sy : oy);
			});
		}
		return r.finish();
	}
}, { decorations: (e) => e.decorations });
function ly(e) {
	return (t) => {
		let n = t.state.field(iy, !1);
		return n && n.query.spec.valid ? e(t, n) : by(t);
	};
}
var uy = /*@__PURE__*/ ly((e, { query: t }) => {
	let { to: n } = e.state.selection.main, r = t.nextMatch(e.state, n, n);
	if (!r) return !1;
	let i = U.single(r.from, r.to), a = e.state.facet(Uv);
	return e.dispatch({
		selection: i,
		effects: [Dy(e, r), a.scrollToMatch(i.main, e)],
		userEvent: "select.search"
	}), yy(e), !0;
}), dy = /*@__PURE__*/ ly((e, { query: t }) => {
	let { state: n } = e, { from: r } = n.selection.main, i = t.prevMatch(n, r, r);
	if (!i) return !1;
	let a = U.single(i.from, i.to), o = e.state.facet(Uv);
	return e.dispatch({
		selection: a,
		effects: [Dy(e, i), o.scrollToMatch(a.main, e)],
		userEvent: "select.search"
	}), yy(e), !0;
}), fy = /*@__PURE__*/ ly((e, { query: t }) => {
	let n = t.matchAll(e.state, 1e3);
	return !n || !n.length ? !1 : (e.dispatch({
		selection: U.create(n.map((e) => U.range(e.from, e.to))),
		userEvent: "select.search.matches"
	}), !0);
}), py = ({ state: e, dispatch: t }) => {
	let n = e.selection;
	if (n.ranges.length > 1 || n.main.empty) return !1;
	let { from: r, to: i } = n.main, a = [], o = 0;
	for (let t = new xv(e.doc, e.sliceDoc(r, i)); !t.next().done;) {
		if (a.length > 1e3) return !1;
		t.value.from == r && (o = a.length), a.push(U.range(t.value.from, t.value.to));
	}
	return t(e.update({
		selection: U.create(a, o),
		userEvent: "select.search.matches"
	})), !0;
}, my = /*@__PURE__*/ ly((e, { query: t }) => {
	let { state: n } = e, { from: r, to: i } = n.selection.main;
	if (n.readOnly) return !1;
	let a = t.nextMatch(n, r, r);
	if (!a) return !1;
	let o = a, s = [], c, l, u = [];
	o.precise ? o.from == r && o.to == i && (l = n.toText(t.getReplacement(o)), s.push({
		from: o.from,
		to: o.to,
		insert: l
	}), o = t.nextMatch(n, o.from, o.to), u.push(q.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))) : o = t.nextMatch(n, o.from, o.to);
	let d = e.state.changes(s);
	return o && (c = U.single(o.from, o.to).map(d), u.push(Dy(e, o)), u.push(n.facet(Uv).scrollToMatch(c.main, e))), e.dispatch({
		changes: d,
		selection: c,
		effects: u,
		userEvent: "input.replace"
	}), !0;
}), hy = /*@__PURE__*/ ly((e, { query: t }) => {
	if (e.state.readOnly) return !1;
	let n = [];
	for (let r of t.matchAll(e.state, 1e9)) {
		let { from: e, to: i, precise: a } = r;
		a && n.push({
			from: e,
			to: i,
			insert: t.getReplacement(r)
		});
	}
	if (!n.length) return !1;
	let r = e.state.phrase("replaced $ matches", n.length) + ".";
	return e.dispatch({
		changes: n,
		effects: q.announce.of(r),
		userEvent: "input.replace.all"
	}), !0;
});
function gy(e) {
	return e.state.facet(Uv).createPanel(e);
}
function _y(e, t) {
	let n = e.selection.main, r = n.empty || n.to > n.from + 100 ? "" : e.sliceDoc(n.from, n.to);
	if (t && !r) return t;
	let i = e.facet(Uv);
	return new Wv({
		search: t?.literal ?? i.literal ? r : r.replace(/\n/g, "\\n"),
		caseSensitive: t?.caseSensitive ?? i.caseSensitive,
		literal: t?.literal ?? i.literal,
		regexp: t?.regexp ?? i.regexp,
		wholeWord: t?.wholeWord ?? i.wholeWord
	});
}
function vy(e) {
	let t = mf(e, gy);
	return t && t.dom.querySelector("[main-field]");
}
function yy(e) {
	let t = vy(e);
	t && t == e.root.activeElement && t.select();
}
var by = (e) => {
	let t = e.state.field(iy, !1);
	if (t && t.panel) {
		let n = vy(e);
		if (n && n != e.root.activeElement) {
			let r = _y(e.state, t.query.spec);
			r.valid && e.dispatch({ effects: ny.of(r) }), n.focus(), n.select();
		}
	} else e.dispatch({ effects: [ry.of(!0), t ? ny.of(_y(e.state, t.query.spec)) : Li.appendConfig.of(ky)] });
	return !0;
}, xy = (e) => {
	let t = e.state.field(iy, !1);
	if (!t || !t.panel) return !1;
	let n = mf(e, gy);
	return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({ effects: ry.of(!1) }), !0;
}, Sy = [
	{
		key: "Mod-f",
		run: by,
		scope: "editor search-panel"
	},
	{
		key: "F3",
		run: uy,
		shift: dy,
		scope: "editor search-panel",
		preventDefault: !0
	},
	{
		key: "Mod-g",
		run: uy,
		shift: dy,
		scope: "editor search-panel",
		preventDefault: !0
	},
	{
		key: "Escape",
		run: xy,
		scope: "editor search-panel"
	},
	{
		key: "Mod-Shift-l",
		run: py
	},
	{
		key: "Mod-Alt-g",
		run: Av
	},
	{
		key: "Mod-d",
		run: Hv,
		preventDefault: !0
	}
], Cy = class {
	constructor(e) {
		this.view = e;
		let t = this.query = e.state.field(iy).query.spec;
		this.commit = this.commit.bind(this), this.searchField = Pa("input", {
			value: t.search,
			placeholder: wy(e, "Find"),
			"aria-label": wy(e, "Find"),
			class: "cm-textfield",
			name: "search",
			form: "",
			"main-field": "true",
			onchange: this.commit,
			onkeyup: this.commit
		}), this.replaceField = Pa("input", {
			value: t.replace,
			placeholder: wy(e, "Replace"),
			"aria-label": wy(e, "Replace"),
			class: "cm-textfield",
			name: "replace",
			form: "",
			onchange: this.commit,
			onkeyup: this.commit
		}), this.caseField = Pa("input", {
			type: "checkbox",
			name: "case",
			form: "",
			checked: t.caseSensitive,
			onchange: this.commit
		}), this.reField = Pa("input", {
			type: "checkbox",
			name: "re",
			form: "",
			checked: t.regexp,
			onchange: this.commit
		}), this.wordField = Pa("input", {
			type: "checkbox",
			name: "word",
			form: "",
			checked: t.wholeWord,
			onchange: this.commit
		});
		function n(e, t, n) {
			return Pa("button", {
				class: "cm-button",
				name: e,
				onclick: t,
				type: "button"
			}, n);
		}
		this.dom = Pa("div", {
			onkeydown: (e) => this.keydown(e),
			class: "cm-search"
		}, [
			this.searchField,
			n("next", () => uy(e), [wy(e, "next")]),
			n("prev", () => dy(e), [wy(e, "previous")]),
			n("select", () => fy(e), [wy(e, "all")]),
			Pa("label", null, [this.caseField, wy(e, "match case")]),
			Pa("label", null, [this.reField, wy(e, "regexp")]),
			Pa("label", null, [this.wordField, wy(e, "by word")]),
			...e.state.readOnly ? [] : [
				Pa("br"),
				this.replaceField,
				n("replace", () => my(e), [wy(e, "replace")]),
				n("replaceAll", () => hy(e), [wy(e, "replace all")])
			],
			Pa("button", {
				name: "close",
				onclick: () => xy(e),
				"aria-label": wy(e, "close"),
				type: "button"
			}, ["×"])
		]);
	}
	commit() {
		let e = new Wv({
			search: this.searchField.value,
			caseSensitive: this.caseField.checked,
			regexp: this.reField.checked,
			wholeWord: this.wordField.checked,
			replace: this.replaceField.value
		});
		e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: ny.of(e) }));
	}
	keydown(e) {
		Uu(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? dy : uy)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), my(this.view));
	}
	update(e) {
		for (let t of e.transactions) for (let e of t.effects) e.is(ny) && !e.value.eq(this.query) && this.setQuery(e.value);
	}
	setQuery(e) {
		this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
	}
	mount() {
		this.searchField.select();
	}
	get pos() {
		return 80;
	}
	get top() {
		return this.view.state.facet(Uv).top;
	}
};
function wy(e, t) {
	return e.state.phrase(t);
}
var Ty = 30, Ey = /[\s\.,:;?!]/;
function Dy(e, { from: t, to: n }) {
	let r = e.state.doc.lineAt(t), i = e.state.doc.lineAt(n).to, a = Math.max(r.from, t - Ty), o = Math.min(i, n + Ty), s = e.state.sliceDoc(a, o);
	if (a != r.from) {
		for (let e = 0; e < Ty; e++) if (!Ey.test(s[e + 1]) && Ey.test(s[e])) {
			s = s.slice(e);
			break;
		}
	}
	if (o != i) {
		for (let e = s.length - 1; e > s.length - Ty; e--) if (!Ey.test(s[e - 1]) && Ey.test(s[e])) {
			s = s.slice(0, e);
			break;
		}
	}
	return q.announce.of(`${e.state.phrase("current match")}. ${s} ${e.state.phrase("on line")} ${r.number}.`);
}
var Oy = /*@__PURE__*/ q.baseTheme({
	".cm-panel.cm-search": {
		padding: "2px 6px 4px",
		position: "relative",
		"& [name=close]": {
			position: "absolute",
			top: "0",
			right: "4px",
			backgroundColor: "inherit",
			border: "none",
			font: "inherit",
			padding: 0,
			margin: 0
		},
		"& input, & button, & label": { margin: ".2em .6em .2em 0" },
		"& input[type=checkbox]": { marginRight: ".2em" },
		"& label": {
			fontSize: "80%",
			whiteSpace: "pre"
		}
	},
	"&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
	"&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
	"&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
	"&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), ky = [
	iy,
	/*@__PURE__*/ yi.low(cy),
	Oy
], Ay = class {
	constructor(e, t, n, r) {
		this.state = e, this.pos = t, this.explicit = n, this.view = r, this.abortListeners = [], this.abortOnDocChange = !1;
	}
	tokenBefore(e) {
		let t = dm(this.state).resolveInner(this.pos, -1);
		for (; t && e.indexOf(t.name) < 0;) t = t.parent;
		return t ? {
			from: t.from,
			to: this.pos,
			text: this.state.sliceDoc(t.from, this.pos),
			type: t.type
		} : null;
	}
	matchBefore(e) {
		let t = this.state.doc.lineAt(this.pos), n = Math.max(t.from, this.pos - 250), r = t.text.slice(n - t.from, this.pos - t.from), i = r.search(Ly(e, !1));
		return i < 0 ? null : {
			from: n + i,
			to: this.pos,
			text: r.slice(i)
		};
	}
	get aborted() {
		return this.abortListeners == null;
	}
	addEventListener(e, t, n) {
		e == "abort" && this.abortListeners && (this.abortListeners.push(t), n && n.onDocChange && (this.abortOnDocChange = !0));
	}
};
function jy(e) {
	let t = Object.keys(e).join(""), n = /\w/.test(t);
	return n && (t = t.replace(/\w/g, "")), `[${n ? "\\w" : ""}${t.replace(/[^\w\s]/g, "\\$&")}]`;
}
function My(e) {
	let t = Object.create(null), n = Object.create(null);
	for (let { label: r } of e) {
		t[r[0]] = !0;
		for (let e = 1; e < r.length; e++) n[r[e]] = !0;
	}
	let r = jy(t) + jy(n) + "*$";
	return [RegExp("^" + r), new RegExp(r)];
}
function Ny(e) {
	let t = e.map((e) => typeof e == "string" ? { label: e } : e), [n, r] = t.every((e) => /^\w+$/.test(e.label)) ? [/\w*$/, /\w+$/] : My(t);
	return (e) => {
		let i = e.matchBefore(r);
		return i || e.explicit ? {
			from: i ? i.from : e.pos,
			options: t,
			validFor: n
		} : null;
	};
}
function Py(e, t) {
	return (n) => {
		for (let t = dm(n.state).resolveInner(n.pos, -1); t; t = t.parent) {
			if (e.indexOf(t.name) > -1) return null;
			if (t.type.isTop) break;
		}
		return t(n);
	};
}
var Fy = class {
	constructor(e, t, n, r) {
		this.completion = e, this.source = t, this.match = n, this.score = r;
	}
};
function Iy(e) {
	return e.selection.main.from;
}
function Ly(e, t) {
	let { source: n } = e, r = t && n[0] != "^", i = n[n.length - 1] != "$";
	return !r && !i ? e : RegExp(`${r ? "^" : ""}(?:${n})${i ? "$" : ""}`, e.flags ?? (e.ignoreCase ? "i" : ""));
}
var Ry = /*@__PURE__*/ Pi.define();
function zy(e, t, n, r) {
	let { main: i } = e.selection, a = n - i.from, o = r - i.from;
	return {
		...e.changeByRange((s) => {
			if (s != i && n != r && e.sliceDoc(s.from + a, s.from + o) != e.sliceDoc(n, r)) return { range: s };
			let c = e.toText(t);
			return {
				changes: {
					from: s.from + a,
					to: r == i.from ? s.to : s.from + o,
					insert: c
				},
				range: U.cursor(s.from + a + c.length)
			};
		}),
		scrollIntoView: !0,
		userEvent: "input.complete"
	};
}
var By = /*@__PURE__*/ new WeakMap();
function Vy(e) {
	if (!Array.isArray(e)) return e;
	let t = By.get(e);
	return t || By.set(e, t = Ny(e)), t;
}
var Hy = /*@__PURE__*/ Li.define(), Uy = /*@__PURE__*/ Li.define(), Wy = class {
	constructor(e) {
		this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
		for (let t = 0; t < e.length;) {
			let n = Jr(e, t), r = Xr(n);
			this.chars.push(n);
			let i = e.slice(t, t + r), a = i.toUpperCase();
			this.folded.push(Jr(a == i ? i.toLowerCase() : a, 0)), t += r;
		}
		this.astral = e.length != this.chars.length;
	}
	ret(e, t) {
		return this.score = e, this.matched = t, this;
	}
	match(e) {
		if (this.pattern.length == 0) return this.ret(-100, []);
		if (e.length < this.pattern.length) return null;
		let { chars: t, folded: n, any: r, precise: i, byWord: a } = this;
		if (t.length == 1) {
			let r = Jr(e, 0), i = Xr(r), a = i == e.length ? 0 : -100;
			if (r != t[0]) if (r == n[0]) a += -200;
			else return null;
			return this.ret(a, [0, i]);
		}
		let o = e.indexOf(this.pattern);
		if (o == 0) return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
		let s = t.length, c = 0;
		if (o < 0) {
			for (let i = 0, a = Math.min(e.length, 200); i < a && c < s;) {
				let a = Jr(e, i);
				(a == t[c] || a == n[c]) && (r[c++] = i), i += Xr(a);
			}
			if (c < s) return null;
		}
		let l = 0, u = 0, d = !1, f = 0, p = -1, m = -1, h = /[a-z]/.test(e), g = !0;
		for (let r = 0, c = Math.min(e.length, 200), _ = 0; r < c && u < s;) {
			let c = Jr(e, r);
			o < 0 && (l < s && c == t[l] && (i[l++] = r), f < s && (c == t[f] || c == n[f] ? (f == 0 && (p = r), m = r + 1, f++) : f = 0));
			let v, y = c < 255 ? c >= 48 && c <= 57 || c >= 97 && c <= 122 ? 2 : +(c >= 65 && c <= 90) : (v = Yr(c)) == v.toLowerCase() ? v == v.toUpperCase() ? 0 : 2 : 1;
			(!r || y == 1 && h || _ == 0 && y != 0) && (t[u] == c || n[u] == c && (d = !0) ? a[u++] = r : a.length && (g = !1)), _ = y, r += Xr(c);
		}
		return u == s && a[0] == 0 && g ? this.result(-100 + (d ? -200 : 0), a, e) : f == s && p == 0 ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m]) : o > -1 ? this.ret(-700 - e.length, [o, o + this.pattern.length]) : f == s ? this.ret(-900 - e.length, [p, m]) : u == s ? this.result(-100 + (d ? -200 : 0) + -700 + (g ? 0 : -1100), a, e) : t.length == 2 ? null : this.result((r[0] ? -700 : 0) + -200 + -1100, r, e);
	}
	result(e, t, n) {
		let r = [], i = 0;
		for (let e of t) {
			let t = e + (this.astral ? Xr(Jr(n, e)) : 1);
			i && r[i - 1] == e ? r[i - 1] = t : (r[i++] = e, r[i++] = t);
		}
		return this.ret(e - n.length, r);
	}
}, Gy = class {
	constructor(e) {
		this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
	}
	match(e) {
		if (e.length < this.pattern.length) return null;
		let t = e.slice(0, this.pattern.length), n = t == this.pattern ? 0 : t.toLowerCase() == this.folded ? -200 : null;
		return n == null ? null : (this.matched = [0, t.length], this.score = n + (e.length == this.pattern.length ? 0 : -100), this);
	}
}, Ky = /*@__PURE__*/ W.define({ combine(e) {
	return $i(e, {
		activateOnTyping: !0,
		activateOnCompletion: () => !1,
		activateOnTypingDelay: 100,
		selectOnOpen: !0,
		override: null,
		closeOnBlur: !0,
		maxRenderedOptions: 100,
		defaultKeymap: !0,
		tooltipClass: () => "",
		optionClass: () => "",
		aboveCursor: !1,
		icons: !0,
		addToOptions: [],
		positionInfo: Jy,
		filterStrict: !1,
		compareCompletions: (e, t) => (e.sortText || e.label).localeCompare(t.sortText || t.label),
		interactionDelay: 75,
		updateSyncTime: 100
	}, {
		defaultKeymap: (e, t) => e && t,
		closeOnBlur: (e, t) => e && t,
		icons: (e, t) => e && t,
		tooltipClass: (e, t) => (n) => qy(e(n), t(n)),
		optionClass: (e, t) => (n) => qy(e(n), t(n)),
		addToOptions: (e, t) => e.concat(t),
		filterStrict: (e, t) => e || t
	});
} });
function qy(e, t) {
	return e ? t ? e + " " + t : e : t;
}
function Jy(e, t, n, r, i, a) {
	let o = e.textDirection == Fo.RTL, s = o, c = !1, l = "top", u, d, f = t.left - i.left, p = i.right - t.right, m = r.right - r.left, h = r.bottom - r.top;
	if (s && f < Math.min(m, p) ? s = !1 : !s && p < Math.min(m, f) && (s = !0), m <= (s ? f : p)) u = Math.max(i.top, Math.min(n.top, i.bottom - h)) - t.top, d = Math.min(400, s ? f : p);
	else {
		c = !0, d = Math.min(400, (o ? t.right : i.right - t.left) - 30);
		let e = i.bottom - t.bottom;
		e >= h || e > t.top ? u = n.bottom - t.top : (l = "bottom", u = t.bottom - n.top);
	}
	let g = (t.bottom - t.top) / a.offsetHeight, _ = (t.right - t.left) / a.offsetWidth;
	return {
		style: `${l}: ${u / g}px; max-width: ${d / _}px`,
		class: "cm-completionInfo-" + (c ? o ? "left-narrow" : "right-narrow" : s ? "left" : "right")
	};
}
var Yy = /*@__PURE__*/ Li.define();
function Xy(e) {
	let t = e.addToOptions.slice();
	return e.icons && t.push({
		render(e) {
			let t = document.createElement("div");
			return t.classList.add("cm-completionIcon"), e.type && t.classList.add(...e.type.split(/\s+/g).map((e) => "cm-completionIcon-" + e)), t.setAttribute("aria-hidden", "true"), t;
		},
		position: 20
	}), t.push({
		render(e, t, n, r) {
			let i = document.createElement("span");
			i.className = "cm-completionLabel";
			let a = e.displayLabel || e.label, o = 0;
			for (let e = 0; e < r.length;) {
				let t = r[e++], n = r[e++];
				t > o && i.appendChild(document.createTextNode(a.slice(o, t)));
				let s = i.appendChild(document.createElement("span"));
				s.appendChild(document.createTextNode(a.slice(t, n))), s.className = "cm-completionMatchedText", o = n;
			}
			return o < a.length && i.appendChild(document.createTextNode(a.slice(o))), i;
		},
		position: 50
	}, {
		render(e) {
			if (!e.detail) return null;
			let t = document.createElement("span");
			return t.className = "cm-completionDetail", t.textContent = e.detail, t;
		},
		position: 80
	}), t.sort((e, t) => e.position - t.position).map((e) => e.render);
}
function Zy(e, t, n) {
	if (e <= n) return {
		from: 0,
		to: e
	};
	if (t < 0 && (t = 0), t <= e >> 1) {
		let e = Math.floor(t / n);
		return {
			from: e * n,
			to: (e + 1) * n
		};
	}
	let r = Math.ceil((e - t) / n);
	return {
		from: e - r * n,
		to: e - (r - 1) * n
	};
}
var Qy = class {
	constructor(e, t, n) {
		this.view = e, this.stateField = t, this.applyCompletion = n, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
			read: () => this.measureInfo(),
			write: (e) => this.placeInfo(e),
			key: this
		}, this.space = null, this.currentClass = "";
		let r = e.state.field(t), { options: i, selected: a } = r.open, o = e.state.facet(Ky);
		this.optionContent = Xy(o), this.optionClass = o.optionClass, this.tooltipClass = o.tooltipClass, this.range = Zy(i.length, a, o.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (n) => {
			let { options: r } = e.state.field(t).open;
			for (let t = n.target, i; t && t != this.dom; t = t.parentNode) if (t.nodeName == "LI" && (i = /-(\d+)$/.exec(t.id)) && +i[1] < r.length) {
				this.applyCompletion(e, r[+i[1]]), n.preventDefault();
				return;
			}
			if (n.target == this.list) {
				let t = this.list.classList.contains("cm-completionListIncompleteTop") && n.clientY < this.list.firstChild.getBoundingClientRect().top ? this.range.from - 1 : this.list.classList.contains("cm-completionListIncompleteBottom") && n.clientY > this.list.lastChild.getBoundingClientRect().bottom ? this.range.to : null;
				t != null && (e.dispatch({ effects: Yy.of(t) }), n.preventDefault());
			}
		}), this.dom.addEventListener("focusout", (t) => {
			let n = e.state.field(this.stateField, !1);
			n && n.tooltip && e.state.facet(Ky).closeOnBlur && t.relatedTarget != e.contentDOM && e.dispatch({ effects: Uy.of(null) });
		}), this.showOptions(i, r.id);
	}
	mount() {
		this.updateSel();
	}
	showOptions(e, t) {
		this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", () => {
			this.info && this.view.requestMeasure(this.placeInfoReq);
		});
	}
	update(e) {
		let t = e.state.field(this.stateField), n = e.startState.field(this.stateField);
		if (this.updateTooltipClass(e.state), t != n) {
			let { options: r, selected: i, disabled: a } = t.open;
			(!n.open || n.open.options != r) && (this.range = Zy(r.length, i, e.state.facet(Ky).maxRenderedOptions), this.showOptions(r, t.id)), this.updateSel(), a != n.open?.disabled && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
		}
	}
	updateTooltipClass(e) {
		let t = this.tooltipClass(e);
		if (t != this.currentClass) {
			for (let e of this.currentClass.split(" ")) e && this.dom.classList.remove(e);
			for (let e of t.split(" ")) e && this.dom.classList.add(e);
			this.currentClass = t;
		}
	}
	positioned(e) {
		this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
	}
	updateSel() {
		let e = this.view.state.field(this.stateField), t = e.open;
		(t.selected > -1 && t.selected < this.range.from || t.selected >= this.range.to) && (this.range = Zy(t.options.length, t.selected, this.view.state.facet(Ky).maxRenderedOptions), this.showOptions(t.options, e.id));
		let n = this.updateSelectedOption(t.selected);
		if (n) {
			this.destroyInfo();
			let { completion: r } = t.options[t.selected], { info: i } = r;
			if (!i) return;
			let a = typeof i == "string" ? document.createTextNode(i) : i(r);
			if (!a) return;
			"then" in a ? a.then((t) => {
				t && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(t, r);
			}).catch((e) => ys(this.view.state, e, "completion info")) : (this.addInfoPane(a, r), n.setAttribute("aria-describedby", this.info.id));
		}
	}
	addInfoPane(e, t) {
		this.destroyInfo();
		let n = this.info = document.createElement("div");
		if (n.className = "cm-tooltip cm-completionInfo", n.id = "cm-completionInfo-" + Math.floor(Math.random() * 65535).toString(16), e.nodeType != null) n.appendChild(e), this.infoDestroy = null;
		else {
			let { dom: t, destroy: r } = e;
			n.appendChild(t), this.infoDestroy = r || null;
		}
		this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq);
	}
	updateSelectedOption(e) {
		let t = null;
		for (let n = this.list.firstChild, r = this.range.from; n; n = n.nextSibling, r++) n.nodeName != "LI" || !n.id ? r-- : r == e ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), t = n) : n.hasAttribute("aria-selected") && (n.removeAttribute("aria-selected"), n.removeAttribute("aria-describedby"));
		return t && eb(this.list, t), t;
	}
	measureInfo() {
		let e = this.dom.querySelector("[aria-selected]");
		if (!e || !this.info) return null;
		let t = this.dom.getBoundingClientRect(), n = this.info.getBoundingClientRect(), r = e.getBoundingClientRect(), i = this.space;
		if (!i) {
			let e = this.dom.ownerDocument.documentElement;
			i = {
				left: 0,
				top: 0,
				right: e.clientWidth,
				bottom: e.clientHeight
			};
		}
		return r.top > Math.min(i.bottom, t.bottom) - 10 || r.bottom < Math.max(i.top, t.top) + 10 ? null : this.view.state.facet(Ky).positionInfo(this.view, t, r, n, i, this.dom);
	}
	placeInfo(e) {
		this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
	}
	createListBox(e, t, n) {
		let r = document.createElement("ul");
		r.id = t, r.setAttribute("role", "listbox"), r.setAttribute("aria-expanded", "true"), r.setAttribute("aria-label", this.view.state.phrase("Completions")), r.addEventListener("mousedown", (e) => {
			e.target == r && e.preventDefault();
		});
		let i = null;
		for (let a = n.from; a < n.to; a++) {
			let { completion: o, match: s } = e[a], { section: c } = o;
			if (c) {
				let e = typeof c == "string" ? c : c.name;
				if (e != i && (a > n.from || n.from == 0)) if (i = e, typeof c != "string" && c.header) r.appendChild(c.header(c));
				else {
					let t = r.appendChild(document.createElement("completion-section"));
					t.textContent = e;
				}
			}
			let l = r.appendChild(document.createElement("li"));
			l.id = t + "-" + a, l.setAttribute("role", "option");
			let u = this.optionClass(o);
			u && (l.className = u);
			for (let e of this.optionContent) {
				let t = e(o, this.view.state, this.view, s);
				t && l.appendChild(t);
			}
		}
		return n.from && r.classList.add("cm-completionListIncompleteTop"), n.to < e.length && r.classList.add("cm-completionListIncompleteBottom"), r;
	}
	destroyInfo() {
		this.info &&= (this.infoDestroy && this.infoDestroy(), this.info.remove(), null);
	}
	destroy() {
		this.destroyInfo();
	}
};
function $y(e, t) {
	return (n) => new Qy(n, e, t);
}
function eb(e, t) {
	let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.height / e.offsetHeight;
	r.top < n.top ? e.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / i);
}
function tb(e) {
	return (e.boost || 0) * 100 + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + +!!e.type;
}
function nb(e, t) {
	let n = [], r = null, i = null, a = (e) => {
		n.push(e);
		let { section: t } = e.completion;
		if (t) {
			r ||= [];
			let e = typeof t == "string" ? t : t.name;
			r.some((t) => t.name == e) || r.push(typeof t == "string" ? { name: e } : t);
		}
	}, o = t.facet(Ky);
	for (let r of e) if (r.hasResult()) {
		let e = r.result.getMatch;
		if (r.result.filter === !1) for (let t of r.result.options) a(new Fy(t, r.source, e ? e(t) : [], 1e9 - n.length));
		else {
			let n = t.sliceDoc(r.from, r.to), s, c = o.filterStrict ? new Gy(n) : new Wy(n);
			for (let t of r.result.options) if (s = c.match(t.label)) {
				let n = t.displayLabel ? e ? e(t, s.matched) : [] : s.matched, o = s.score + (t.boost || 0);
				if (a(new Fy(t, r.source, n, o)), typeof t.section == "object" && t.section.rank === "dynamic") {
					let { name: e } = t.section;
					i ||= Object.create(null), i[e] = Math.max(o, i[e] || -1e9);
				}
			}
		}
	}
	if (r) {
		let e = Object.create(null), t = 0, a = (e, t) => (e.rank === "dynamic" && t.rank === "dynamic" ? i[t.name] - i[e.name] : 0) || (typeof e.rank == "number" ? e.rank : 1e9) - (typeof t.rank == "number" ? t.rank : 1e9) || (e.name < t.name ? -1 : 1);
		for (let n of r.sort(a)) t -= 1e5, e[n.name] = t;
		for (let t of n) {
			let { section: n } = t.completion;
			n && (t.score += e[typeof n == "string" ? n : n.name]);
		}
	}
	let s = [], c = null, l = o.compareCompletions;
	for (let e of n.sort((e, t) => t.score - e.score || l(e.completion, t.completion))) {
		let t = e.completion;
		!c || c.label != t.label || c.detail != t.detail || c.type != null && t.type != null && c.type != t.type || c.apply != t.apply || c.boost != t.boost ? s.push(e) : tb(e.completion) > tb(c) && (s[s.length - 1] = e), c = e.completion;
	}
	return s;
}
var rb = class e {
	constructor(e, t, n, r, i, a) {
		this.options = e, this.attrs = t, this.tooltip = n, this.timestamp = r, this.selected = i, this.disabled = a;
	}
	setSelected(t, n) {
		return t == this.selected || t >= this.options.length ? this : new e(this.options, cb(n, t), this.tooltip, this.timestamp, t, this.disabled);
	}
	static build(t, n, r, i, a, o) {
		if (i && !o && t.some((e) => e.isPending)) return i.setDisabled();
		let s = nb(t, n);
		if (!s.length) return i && t.some((e) => e.isPending) ? i.setDisabled() : null;
		let c = n.facet(Ky).selectOnOpen ? 0 : -1;
		if (i && i.selected != c && i.selected != -1) {
			let e = i.options[i.selected].completion;
			for (let t = 0; t < s.length; t++) if (s[t].completion == e) {
				c = t;
				break;
			}
		}
		return new e(s, cb(r, c), {
			pos: t.reduce((e, t) => t.hasResult() ? Math.min(e, t.from) : e, 1e8),
			create: _b,
			above: a.aboveCursor
		}, i ? i.timestamp : Date.now(), c, !1);
	}
	map(t) {
		return new e(this.options, this.attrs, {
			...this.tooltip,
			pos: t.mapPos(this.tooltip.pos)
		}, this.timestamp, this.selected, this.disabled);
	}
	setDisabled() {
		return new e(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
	}
}, ib = class e {
	constructor(e, t, n) {
		this.active = e, this.id = t, this.open = n;
	}
	static start() {
		return new e(lb, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
	}
	update(t) {
		let { state: n } = t, r = n.facet(Ky), i = (r.override || n.languageDataAt("autocomplete", Iy(n)).map(Vy)).map((e) => (this.active.find((t) => t.source == e) || new db(e, +!!this.active.some((e) => e.state != 0))).update(t, r));
		i.length == this.active.length && i.every((e, t) => e == this.active[t]) && (i = this.active);
		let a = this.open, o = t.effects.some((e) => e.is(mb));
		a && t.docChanged && (a = a.map(t.changes)), t.selection || i.some((e) => e.hasResult() && t.changes.touchesRange(e.from, e.to)) || !ab(i, this.active) || o ? a = rb.build(i, n, this.id, a, r, o) : a && a.disabled && !i.some((e) => e.isPending) && (a = null), !a && i.every((e) => !e.isPending) && i.some((e) => e.hasResult()) && (i = i.map((e) => e.hasResult() ? new db(e.source, 0) : e));
		for (let e of t.effects) e.is(Yy) && (a &&= a.setSelected(e.value, this.id));
		return i == this.active && a == this.open ? this : new e(i, this.id, a);
	}
	get tooltip() {
		return this.open ? this.open.tooltip : null;
	}
	get attrs() {
		return this.open ? this.open.attrs : this.active.length ? ob : sb;
	}
};
function ab(e, t) {
	if (e == t) return !0;
	for (let n = 0, r = 0;;) {
		for (; n < e.length && !e[n].hasResult();) n++;
		for (; r < t.length && !t[r].hasResult();) r++;
		let i = n == e.length, a = r == t.length;
		if (i || a) return i == a;
		if (e[n++].result != t[r++].result) return !1;
	}
}
var ob = { "aria-autocomplete": "list" }, sb = {};
function cb(e, t) {
	let n = {
		"aria-autocomplete": "list",
		"aria-haspopup": "listbox",
		"aria-controls": e
	};
	return t > -1 && (n["aria-activedescendant"] = e + "-" + t), n;
}
var lb = [];
function ub(e, t) {
	if (e.isUserEvent("input.complete")) {
		let n = e.annotation(Ry);
		if (n && t.activateOnCompletion(n)) return 12;
	}
	let n = e.isUserEvent("input.type");
	return n && t.activateOnTyping ? 5 : n ? 1 : e.isUserEvent("delete.backward") ? 2 : e.selection ? 8 : e.docChanged ? 16 : 0;
}
var db = class e {
	constructor(e, t, n = !1) {
		this.source = e, this.state = t, this.explicit = n;
	}
	hasResult() {
		return !1;
	}
	get isPending() {
		return this.state == 1;
	}
	update(t, n) {
		let r = ub(t, n), i = this;
		(r & 8 || r & 16 && this.touches(t)) && (i = new e(i.source, 0)), r & 4 && i.state == 0 && (i = new e(this.source, 1)), i = i.updateFor(t, r);
		for (let n of t.effects) if (n.is(Hy)) i = new e(i.source, 1, n.value);
		else if (n.is(Uy)) i = new e(i.source, 0);
		else if (n.is(mb)) for (let e of n.value) e.source == i.source && (i = e);
		return i;
	}
	updateFor(e, t) {
		return this.map(e.changes);
	}
	map(e) {
		return this;
	}
	touches(e) {
		return e.changes.touchesRange(Iy(e.state));
	}
}, fb = class e extends db {
	constructor(e, t, n, r, i, a) {
		super(e, 3, t), this.limit = n, this.result = r, this.from = i, this.to = a;
	}
	hasResult() {
		return !0;
	}
	updateFor(t, n) {
		if (!(n & 3)) return this.map(t.changes);
		let r = this.result;
		r.map && !t.changes.empty && (r = r.map(r, t.changes));
		let i = t.changes.mapPos(this.from), a = t.changes.mapPos(this.to, 1), o = Iy(t.state);
		if (o > a || !r || n & 2 && (Iy(t.startState) == this.from || o < this.limit)) return new db(this.source, n & 4 ? 1 : 0);
		let s = t.changes.mapPos(this.limit);
		return pb(r.validFor, t.state, i, a) ? new e(this.source, this.explicit, s, r, i, a) : r.update && (r = r.update(r, i, a, new Ay(t.state, o, !1))) ? new e(this.source, this.explicit, s, r, r.from, r.to ?? Iy(t.state)) : new db(this.source, 1, this.explicit);
	}
	map(t) {
		if (t.empty) return this;
		let n = this.result.map ? this.result.map(this.result, t) : this.result;
		return n ? new e(this.source, this.explicit, t.mapPos(this.limit), n, t.mapPos(this.from), t.mapPos(this.to, 1)) : new db(this.source, 0);
	}
	touches(e) {
		return e.changes.touchesRange(this.from, this.to);
	}
};
function pb(e, t, n, r) {
	if (!e) return !1;
	let i = t.sliceDoc(n, r);
	return typeof e == "function" ? e(i, n, r, t) : Ly(e, !0).test(i);
}
var mb = /*@__PURE__*/ Li.define({ map(e, t) {
	return e.map((e) => e.map(t));
} }), hb = /*@__PURE__*/ gi.define({
	create() {
		return ib.start();
	},
	update(e, t) {
		return e.update(t);
	},
	provide: (e) => [$d.from(e, (e) => e.tooltip), q.contentAttributes.from(e, (e) => e.attrs)]
});
function gb(e, t) {
	let n = t.completion.apply || t.completion.label, r = e.state.field(hb).active.find((e) => e.source == t.source);
	return r instanceof fb ? (typeof n == "string" ? e.dispatch({
		...zy(e.state, n, r.from, r.to),
		annotations: Ry.of(t.completion)
	}) : n(e, t.completion, r.from, r.to), !0) : !1;
}
var _b = /*@__PURE__*/ $y(hb, gb);
function vb(e, t = "option") {
	return (n) => {
		let r = n.state.field(hb, !1);
		if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(Ky).interactionDelay) return !1;
		let i = 1, a;
		t == "page" && (a = df(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(a.dom.offsetHeight / a.dom.querySelector("li").offsetHeight) - 1));
		let { length: o } = r.open.options, s = r.open.selected > -1 ? r.open.selected + i * (e ? 1 : -1) : e ? 0 : o - 1;
		return s < 0 ? s = t == "page" ? 0 : o - 1 : s >= o && (s = t == "page" ? o - 1 : 0), n.dispatch({ effects: Yy.of(s) }), !0;
	};
}
var yb = (e) => {
	let t = e.state.field(hb, !1);
	return e.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < e.state.facet(Ky).interactionDelay ? !1 : gb(e, t.open.options[t.open.selected]);
}, bb = (e) => e.state.field(hb, !1) ? (e.dispatch({ effects: Hy.of(!0) }), !0) : !1, xb = (e) => {
	let t = e.state.field(hb, !1);
	return !t || !t.active.some((e) => e.state != 0) ? !1 : (e.dispatch({ effects: Uy.of(null) }), !0);
}, Sb = class {
	constructor(e, t) {
		this.active = e, this.context = t, this.time = Date.now(), this.updates = [], this.done = void 0;
	}
}, Cb = 50, wb = 1e3, Tb = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
		for (let t of e.state.field(hb).active) t.isPending && this.startQuery(t);
	}
	update(e) {
		let t = e.state.field(hb), n = e.state.facet(Ky);
		if (!e.selectionSet && !e.docChanged && e.startState.field(hb) == t) return;
		let r = e.transactions.some((e) => {
			let t = ub(e, n);
			return t & 8 || (e.selection || e.docChanged) && !(t & 3);
		});
		for (let t = 0; t < this.running.length; t++) {
			let n = this.running[t];
			if (r || n.context.abortOnDocChange && e.docChanged || n.updates.length + e.transactions.length > Cb && Date.now() - n.time > wb) {
				for (let e of n.context.abortListeners) try {
					e();
				} catch (e) {
					ys(this.view.state, e);
				}
				n.context.abortListeners = null, this.running.splice(t--, 1);
			} else n.updates.push(...e.transactions);
		}
		this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), e.transactions.some((e) => e.effects.some((e) => e.is(Hy))) && (this.pendingStart = !0);
		let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
		if (this.debounceUpdate = t.active.some((e) => e.isPending && !this.running.some((t) => t.active.source == e.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0) for (let t of e.transactions) t.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && t.selection && (this.composing = 3);
	}
	startUpdate() {
		this.debounceUpdate = -1, this.pendingStart = !1;
		let { state: e } = this.view, t = e.field(hb);
		for (let e of t.active) e.isPending && !this.running.some((t) => t.active.source == e.source) && this.startQuery(e);
		this.running.length && t.open && t.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Ky).updateSyncTime));
	}
	startQuery(e) {
		let { state: t } = this.view, n = new Ay(t, Iy(t), e.explicit, this.view), r = new Sb(e, n);
		this.running.push(r), Promise.resolve(e.source(n)).then((e) => {
			r.context.aborted || (r.done = e || null, this.scheduleAccept());
		}, (e) => {
			this.view.dispatch({ effects: Uy.of(null) }), ys(this.view.state, e);
		});
	}
	scheduleAccept() {
		this.running.every((e) => e.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Ky).updateSyncTime));
	}
	accept() {
		this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
		let e = [], t = this.view.state.facet(Ky), n = this.view.state.field(hb);
		for (let r = 0; r < this.running.length; r++) {
			let i = this.running[r];
			if (i.done === void 0) continue;
			if (this.running.splice(r--, 1), i.done) {
				let n = Iy(i.updates.length ? i.updates[0].startState : this.view.state), r = Math.min(n, i.done.from + +!i.active.explicit), a = new fb(i.active.source, i.active.explicit, r, i.done, i.done.from, i.done.to ?? n);
				for (let e of i.updates) a = a.update(e, t);
				if (a.hasResult()) {
					e.push(a);
					continue;
				}
			}
			let a = n.active.find((e) => e.source == i.active.source);
			if (a && a.isPending) if (i.done == null) {
				let n = new db(i.active.source, 0);
				for (let e of i.updates) n = n.update(e, t);
				n.isPending || e.push(n);
			} else this.startQuery(a);
		}
		(e.length || n.open && n.open.disabled) && this.view.dispatch({ effects: mb.of(e) });
	}
}, { eventHandlers: {
	blur(e) {
		let t = this.view.state.field(hb, !1);
		if (t && t.tooltip && this.view.state.facet(Ky).closeOnBlur) {
			let n = t.open && df(this.view, t.open.tooltip);
			(!n || !n.dom.contains(e.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: Uy.of(null) }), 10);
		}
	},
	compositionstart() {
		this.composing = 1;
	},
	compositionend() {
		this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: Hy.of(!1) }), 20), this.composing = 0;
	}
} }), Eb = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform), Db = /*@__PURE__*/ yi.highest(/*@__PURE__*/ q.domEventHandlers({ keydown(e, t) {
	let n = t.state.field(hb, !1);
	if (!n || !n.open || n.open.disabled || n.open.selected < 0 || e.key.length > 1 || e.ctrlKey && !(Eb && e.altKey) || e.metaKey) return !1;
	let r = n.open.options[n.open.selected], i = n.active.find((e) => e.source == r.source), a = r.completion.commitCharacters || i.result.commitCharacters;
	return a && a.indexOf(e.key) > -1 && gb(t, r), !1;
} })), Ob = /*@__PURE__*/ q.baseTheme({
	".cm-tooltip.cm-tooltip-autocomplete": { "& > ul": {
		fontFamily: "monospace",
		whiteSpace: "nowrap",
		overflow: "hidden auto",
		maxWidth_fallback: "700px",
		maxWidth: "min(700px, 95vw)",
		minWidth: "250px",
		maxHeight: "10em",
		height: "100%",
		listStyle: "none",
		margin: 0,
		padding: 0,
		"& > li, & > completion-section": {
			padding: "1px 3px",
			lineHeight: 1.2
		},
		"& > li": {
			overflowX: "hidden",
			textOverflow: "ellipsis",
			cursor: "pointer"
		},
		"& > completion-section": {
			display: "list-item",
			borderBottom: "1px solid silver",
			paddingLeft: "0.5em",
			opacity: .7
		}
	} },
	"&light .cm-tooltip-autocomplete ul li[aria-selected]": {
		background: "#17c",
		color: "white"
	},
	"&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#777" },
	"&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
		background: "#347",
		color: "white"
	},
	"&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#444" },
	".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
		content: "\"···\"",
		opacity: .5,
		display: "block",
		textAlign: "center",
		cursor: "pointer"
	},
	".cm-tooltip.cm-completionInfo": {
		position: "absolute",
		padding: "3px 9px",
		width: "max-content",
		maxWidth: "400px",
		boxSizing: "border-box",
		whiteSpace: "pre-line"
	},
	".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
	".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
	".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
	".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
	"&light .cm-snippetField": { backgroundColor: "#00000022" },
	"&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
	".cm-snippetFieldPosition": {
		verticalAlign: "text-top",
		width: 0,
		height: "1.15em",
		display: "inline-block",
		margin: "0 -0.7px -.7em",
		borderLeft: "1.4px dotted #888"
	},
	".cm-completionMatchedText": { textDecoration: "underline" },
	".cm-completionDetail": {
		marginLeft: "0.5em",
		fontStyle: "italic"
	},
	".cm-completionIcon": {
		fontSize: "90%",
		width: ".8em",
		display: "inline-block",
		textAlign: "center",
		paddingRight: ".6em",
		opacity: "0.6",
		boxSizing: "content-box"
	},
	".cm-completionIcon-function, .cm-completionIcon-method": { "&:after": { content: "'ƒ'" } },
	".cm-completionIcon-class": { "&:after": { content: "'○'" } },
	".cm-completionIcon-interface": { "&:after": { content: "'◌'" } },
	".cm-completionIcon-variable": { "&:after": { content: "'𝑥'" } },
	".cm-completionIcon-constant": { "&:after": { content: "'𝐶'" } },
	".cm-completionIcon-type": { "&:after": { content: "'𝑡'" } },
	".cm-completionIcon-enum": { "&:after": { content: "'∪'" } },
	".cm-completionIcon-property": { "&:after": { content: "'□'" } },
	".cm-completionIcon-keyword": { "&:after": { content: "'🔑︎'" } },
	".cm-completionIcon-namespace": { "&:after": { content: "'▢'" } },
	".cm-completionIcon-text": { "&:after": {
		content: "'abc'",
		fontSize: "50%",
		verticalAlign: "middle"
	} }
}), kb = class {
	constructor(e, t, n, r) {
		this.field = e, this.line = t, this.from = n, this.to = r;
	}
}, Ab = class e {
	constructor(e, t, n) {
		this.field = e, this.from = t, this.to = n;
	}
	map(t) {
		let n = t.mapPos(this.from, -1, Qr.TrackDel), r = t.mapPos(this.to, 1, Qr.TrackDel);
		return n == null || r == null ? null : new e(this.field, n, r);
	}
}, jb = class e {
	constructor(e, t) {
		this.lines = e, this.fieldPositions = t;
	}
	instantiate(e, t) {
		let n = [], r = [t], i = e.doc.lineAt(t), a = /^\s*/.exec(i.text)[0];
		for (let i of this.lines) {
			if (n.length) {
				let n = a, o = /^\t*/.exec(i)[0].length;
				for (let t = 0; t < o; t++) n += e.facet(Cm);
				r.push(t + n.length - o), i = n + i.slice(o);
			}
			n.push(i), t += i.length + 1;
		}
		return {
			text: n,
			ranges: this.fieldPositions.map((e) => new Ab(e.field, r[e.line] + e.from, r[e.line] + e.to))
		};
	}
	static parse(t) {
		let n = [], r = [], i = [], a;
		for (let e of t.split(/\r\n?|\n/)) {
			for (; a = /[#$]\{(?:(\d+)(?::([^{}]*))?|((?:\\[{}]|[^{}])*))\}/.exec(e);) {
				let t = a[1] ? +a[1] : null, o = a[2] || a[3] || "", s = -1;
				t === 0 && (t = 1e9);
				let c = o.replace(/\\[{}]/g, (e) => e[1]);
				for (let e = 0; e < n.length; e++) (t == null ? c && n[e].name == c : n[e].seq == t) && (s = e);
				if (s < 0) {
					let e = 0;
					for (; e < n.length && (t == null || n[e].seq != null && n[e].seq < t);) e++;
					n.splice(e, 0, {
						seq: t,
						name: c
					}), s = e;
					for (let e of i) e.field >= s && e.field++;
				}
				for (let e of i) if (e.line == r.length && e.from > a.index) {
					let t = a[2] ? 3 + (a[1] || "").length : 2;
					e.from -= t, e.to -= t;
				}
				i.push(new kb(s, r.length, a.index, a.index + c.length)), e = e.slice(0, a.index) + o + e.slice(a.index + a[0].length);
			}
			e = e.replace(/\\([{}])/g, (e, t, n) => {
				for (let e of i) e.line == r.length && e.from > n && (e.from--, e.to--);
				return t;
			}), r.push(e);
		}
		return new e(r, i);
	}
}, Mb = /*@__PURE__*/ K.widget({ widget: /*@__PURE__*/ new class extends $a {
	toDOM() {
		let e = document.createElement("span");
		return e.className = "cm-snippetFieldPosition", e;
	}
	ignoreEvent() {
		return !1;
	}
}() }), Nb = /*@__PURE__*/ K.mark({ class: "cm-snippetField" }), Pb = class e {
	constructor(e, t) {
		this.ranges = e, this.active = t, this.deco = K.set(e.map((e) => (e.from == e.to ? Mb : Nb).range(e.from, e.to)), !0);
	}
	map(t) {
		let n = [];
		for (let e of this.ranges) {
			let r = e.map(t);
			if (!r) return null;
			n.push(r);
		}
		return new e(n, this.active);
	}
	selectionInsideField(e) {
		return e.ranges.every((e) => this.ranges.some((t) => t.field == this.active && t.from <= e.from && t.to >= e.to));
	}
}, Fb = /*@__PURE__*/ Li.define({ map(e, t) {
	return e && e.map(t);
} }), Ib = /*@__PURE__*/ Li.define(), Lb = /*@__PURE__*/ gi.define({
	create() {
		return null;
	},
	update(e, t) {
		for (let n of t.effects) {
			if (n.is(Fb)) return n.value;
			if (n.is(Ib) && e) return new Pb(e.ranges, n.value);
		}
		return e && t.docChanged && (e = e.map(t.changes)), e && t.selection && !e.selectionInsideField(t.selection) && (e = null), e;
	},
	provide: (e) => q.decorations.from(e, (e) => e ? e.deco : K.none)
});
function Rb(e, t) {
	return U.create(e.filter((e) => e.field == t).map((e) => U.range(e.from, e.to)));
}
function zb(e) {
	let t = jb.parse(e);
	return (e, n, r, i) => {
		let { text: a, ranges: o } = t.instantiate(e.state, r), { main: s } = e.state.selection, c = {
			changes: {
				from: r,
				to: i == s.from ? s.to : i,
				insert: Pr.of(a)
			},
			scrollIntoView: !0,
			annotations: n ? [Ry.of(n), Ri.userEvent.of("input.complete")] : void 0
		};
		if (o.length && (c.selection = Rb(o, 0)), o.some((e) => e.field > 0)) {
			let t = new Pb(o, 0), n = c.effects = [Fb.of(t)];
			e.state.field(Lb, !1) === void 0 && n.push(Li.appendConfig.of([
				Lb,
				Ub,
				Gb,
				Ob
			]));
		}
		e.dispatch(e.state.update(c));
	};
}
function Bb(e) {
	return ({ state: t, dispatch: n }) => {
		let r = t.field(Lb, !1);
		if (!r || e < 0 && r.active == 0) return !1;
		let i = r.active + e, a = e > 0 && !r.ranges.some((t) => t.field == i + e);
		return n(t.update({
			selection: Rb(r.ranges, i),
			effects: Fb.of(a ? null : new Pb(r.ranges, i)),
			scrollIntoView: !0
		})), !0;
	};
}
var Vb = [{
	key: "Tab",
	run: /* @__PURE__ */ Bb(1),
	shift: /* @__PURE__ */ Bb(-1)
}, {
	key: "Escape",
	run: ({ state: e, dispatch: t }) => e.field(Lb, !1) ? (t(e.update({ effects: Fb.of(null) })), !0) : !1
}], Hb = /*@__PURE__*/ W.define({ combine(e) {
	return e.length ? e[0] : Vb;
} }), Ub = /*@__PURE__*/ yi.highest(/*@__PURE__*/ Bu.compute([Hb], (e) => e.facet(Hb)));
function Wb(e, t) {
	return {
		...t,
		apply: zb(e)
	};
}
var Gb = /*@__PURE__*/ q.domEventHandlers({ mousedown(e, t) {
	let n = t.state.field(Lb, !1), r;
	if (!n || (r = t.posAtCoords({
		x: e.clientX,
		y: e.clientY
	})) == null) return !1;
	let i = n.ranges.find((e) => e.from <= r && e.to >= r);
	return !i || i.field == n.active ? !1 : (t.dispatch({
		selection: Rb(n.ranges, i.field),
		effects: Fb.of(n.ranges.some((e) => e.field > i.field) ? new Pb(n.ranges, i.field) : null),
		scrollIntoView: !0
	}), !0);
} }), Kb = {
	brackets: [
		"(",
		"[",
		"{",
		"'",
		"\""
	],
	before: ")]}:;>",
	stringPrefixes: []
}, qb = /*@__PURE__*/ Li.define({ map(e, t) {
	return t.mapPos(e, -1, Qr.TrackAfter) ?? void 0;
} }), Jb = /*@__PURE__*/ new class extends ea {}();
Jb.startSide = 1, Jb.endSide = -1;
var Yb = /*@__PURE__*/ gi.define({
	create() {
		return aa.empty;
	},
	update(e, t) {
		if (e = e.map(t.changes), t.selection) {
			let n = t.state.doc.lineAt(t.selection.main.head);
			e = e.update({ filter: (e) => e >= n.from && e <= n.to });
		}
		for (let n of t.effects) n.is(qb) && (e = e.update({ add: [Jb.range(n.value, n.value + 1)] }));
		return e;
	}
});
function Xb() {
	return [tx, Yb];
}
var Zb = "()[]{}<>«»»«［］｛｝";
function Qb(e) {
	for (let t = 0; t < 16; t += 2) if (Zb.charCodeAt(t) == e) return Zb.charAt(t + 1);
	return Yr(e < 128 ? e : e + 1);
}
function $b(e, t) {
	return e.languageDataAt("closeBrackets", t)[0] || Kb;
}
var ex = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent), tx = /*@__PURE__*/ q.inputHandler.of((e, t, n, r) => {
	if ((ex ? e.composing : e.compositionStarted) || e.state.readOnly) return !1;
	let i = e.state.selection.main;
	if (r.length > 2 || r.length == 2 && Xr(Jr(r, 0)) == 1 || t != i.from || n != i.to) return !1;
	let a = rx(e.state, r);
	return a ? (e.dispatch(a), !0) : !1;
}), nx = [{
	key: "Backspace",
	run: ({ state: e, dispatch: t }) => {
		if (e.readOnly) return !1;
		let n = $b(e, e.selection.main.head).brackets || Kb.brackets, r = null, i = e.changeByRange((t) => {
			if (t.empty) {
				let r = ox(e.doc, t.head);
				for (let i of n) if (i == r && ax(e.doc, t.head) == Qb(Jr(i, 0))) return {
					changes: {
						from: t.head - i.length,
						to: t.head + i.length
					},
					range: U.cursor(t.head - i.length)
				};
			}
			return { range: r = t };
		});
		return r || t(e.update(i, {
			scrollIntoView: !0,
			userEvent: "delete.backward"
		})), !r;
	}
}];
function rx(e, t) {
	let n = $b(e, e.selection.main.head), r = n.brackets || Kb.brackets;
	for (let i of r) {
		let a = Qb(Jr(i, 0));
		if (t == i) return a == i ? lx(e, i, r.indexOf(i + i + i) > -1, n) : sx(e, i, a, n.before || Kb.before);
		if (t == a && ix(e, e.selection.main.from)) return cx(e, i, a);
	}
	return null;
}
function ix(e, t) {
	let n = !1;
	return e.field(Yb).between(0, e.doc.length, (e) => {
		e == t && (n = !0);
	}), n;
}
function ax(e, t) {
	let n = e.sliceString(t, t + 2);
	return n.slice(0, Xr(Jr(n, 0)));
}
function ox(e, t) {
	let n = e.sliceString(t - 2, t);
	return Xr(Jr(n, 0)) == n.length ? n : n.slice(1);
}
function sx(e, t, n, r) {
	let i = null, a = e.changeByRange((a) => {
		if (!a.empty) return {
			changes: [{
				insert: t,
				from: a.from
			}, {
				insert: n,
				from: a.to
			}],
			effects: qb.of(a.to + t.length),
			range: U.range(a.anchor + t.length, a.head + t.length)
		};
		let o = ax(e.doc, a.head);
		return !o || /\s/.test(o) || r.indexOf(o) > -1 ? {
			changes: {
				insert: t + n,
				from: a.head
			},
			effects: qb.of(a.head + t.length),
			range: U.cursor(a.head + t.length)
		} : { range: i = a };
	});
	return i ? null : e.update(a, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function cx(e, t, n) {
	let r = null, i = e.changeByRange((t) => t.empty && ax(e.doc, t.head) == n ? {
		changes: {
			from: t.head,
			to: t.head + n.length,
			insert: n
		},
		range: U.cursor(t.head + n.length)
	} : r = { range: t });
	return r ? null : e.update(i, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function lx(e, t, n, r) {
	let i = r.stringPrefixes || Kb.stringPrefixes, a = null, o = e.changeByRange((r) => {
		if (!r.empty) return {
			changes: [{
				insert: t,
				from: r.from
			}, {
				insert: t,
				from: r.to
			}],
			effects: qb.of(r.to + t.length),
			range: U.range(r.anchor + t.length, r.head + t.length)
		};
		let o = r.head, s = ax(e.doc, o), c;
		if (s == t) {
			if (ux(e, o)) return {
				changes: {
					insert: t + t,
					from: o
				},
				effects: qb.of(o + t.length),
				range: U.cursor(o + t.length)
			};
			if (ix(e, o)) {
				let r = n && e.sliceDoc(o, o + t.length * 3) == t + t + t ? t + t + t : t;
				return {
					changes: {
						from: o,
						to: o + r.length,
						insert: r
					},
					range: U.cursor(o + r.length)
				};
			}
		} else if (n && e.sliceDoc(o - 2 * t.length, o) == t + t && (c = fx(e, o - 2 * t.length, i)) > -1 && ux(e, c)) return {
			changes: {
				insert: t + t + t + t,
				from: o
			},
			effects: qb.of(o + t.length),
			range: U.cursor(o + t.length)
		};
		else if (e.charCategorizer(o)(s) != qi.Word && fx(e, o, i) > -1 && !dx(e, o, t, i)) return {
			changes: {
				insert: t + t,
				from: o
			},
			effects: qb.of(o + t.length),
			range: U.cursor(o + t.length)
		};
		return { range: a = r };
	});
	return a ? null : e.update(o, {
		scrollIntoView: !0,
		userEvent: "input.type"
	});
}
function ux(e, t) {
	let n = dm(e).resolveInner(t + 1);
	return n.parent && n.from == t;
}
function dx(e, t, n, r) {
	let i = dm(e).resolveInner(t, -1), a = r.reduce((e, t) => Math.max(e, t.length), 0);
	for (let o = 0; o < 5; o++) {
		let o = e.sliceDoc(i.from, Math.min(i.to, i.from + n.length + a)), s = o.indexOf(n);
		if (!s || s > -1 && r.indexOf(o.slice(0, s)) > -1) {
			let t = i.firstChild;
			for (; t && t.from == i.from && t.to - t.from > n.length + s;) {
				if (e.sliceDoc(t.to - n.length, t.to) == n) return !1;
				t = t.firstChild;
			}
			return !0;
		}
		let c = i.to == t && i.parent;
		if (!c) break;
		i = c;
	}
	return !1;
}
function fx(e, t, n) {
	let r = e.charCategorizer(t);
	if (r(e.sliceDoc(t - 1, t)) != qi.Word) return t;
	for (let i of n) {
		let n = t - i.length;
		if (e.sliceDoc(n, t) == i && r(e.sliceDoc(n - 1, n)) != qi.Word) return n;
	}
	return -1;
}
function px(e = {}) {
	return [
		Db,
		hb,
		Ky.of(e),
		Tb,
		hx,
		Ob
	];
}
var mx = [
	{
		key: "Ctrl-Space",
		run: bb
	},
	{
		mac: "Alt-`",
		run: bb
	},
	{
		mac: "Alt-i",
		run: bb
	},
	{
		key: "Escape",
		run: xb
	},
	{
		key: "ArrowDown",
		run: /*@__PURE__*/ vb(!0)
	},
	{
		key: "ArrowUp",
		run: /*@__PURE__*/ vb(!1)
	},
	{
		key: "PageDown",
		run: /*@__PURE__*/ vb(!0, "page")
	},
	{
		key: "PageUp",
		run: /*@__PURE__*/ vb(!1, "page")
	},
	{
		key: "Enter",
		run: yb
	}
], hx = /*@__PURE__*/ yi.highest(/*@__PURE__*/ Bu.computeN([Ky], (e) => e.facet(Ky).defaultKeymap ? [mx] : [])), gx = class {
	constructor(e, t, n) {
		this.from = e, this.to = t, this.diagnostic = n;
	}
}, _x = class e {
	constructor(e, t, n) {
		this.diagnostics = e, this.panel = t, this.selected = n;
	}
	static init(t, n, r) {
		let i = r.facet(Px).markerFilter;
		i && (t = i(t, r));
		let a = t.slice().sort((e, t) => e.from - t.from || e.to - t.to), o = new sa(), s = [], c = 0, l = r.doc.iter(), u = 0, d = r.doc.length;
		for (let e = 0;;) {
			let t = e == a.length ? null : a[e];
			if (!t && !s.length) break;
			let n, r;
			if (s.length) n = c, r = s.reduce((e, t) => Math.min(e, t.to), t && t.from > n ? t.from : 1e8);
			else {
				if (n = t.from, n > d) break;
				r = t.to, s.push(t), e++;
			}
			for (; e < a.length;) {
				let t = a[e];
				if (t.from == n && (t.to > t.from || t.to == n)) s.push(t), e++, r = Math.min(t.to, r);
				else {
					r = Math.min(t.from, r);
					break;
				}
			}
			r = Math.min(r, d);
			let i = !1;
			if (s.some((e) => e.from == n && (e.to == r || r == d)) && (i = n == r, !i && r - n < 10)) {
				let e = n - (u + l.value.length);
				e > 0 && (l.next(e), u = n);
				for (let e = n;;) {
					if (e >= r) {
						i = !0;
						break;
					}
					if (!l.lineBreak && u + l.value.length > e) break;
					e = u + l.value.length, u += l.value.length, l.next();
				}
			}
			let f = Kx(s);
			if (i) o.add(n, n, K.widget({
				widget: new zx(f),
				diagnostics: s.slice()
			}));
			else {
				let e = s.reduce((e, t) => t.markClass ? e + " " + t.markClass : e, "");
				o.add(n, r, K.mark({
					class: "cm-lintRange cm-lintRange-" + f + e,
					diagnostics: s.slice(),
					inclusiveEnd: s.some((e) => e.to > r)
				}));
			}
			if (c = r, c == d) break;
			for (let e = 0; e < s.length; e++) s[e].to <= c && s.splice(e--, 1);
		}
		let f = o.finish();
		return new e(f, n, vx(f));
	}
};
function vx(e, t = null, n = 0) {
	let r = null;
	return e.between(n, 1e9, (e, n, { spec: i }) => {
		if (!(t && i.diagnostics.indexOf(t) < 0)) if (!r) r = new gx(e, n, t || i.diagnostics[0]);
		else if (i.diagnostics.indexOf(r.diagnostic) < 0) return !1;
		else r = new gx(r.from, n, r.diagnostic);
	}), r;
}
function yx(e, t) {
	let n = t.pos, r = t.end || n, i = e.state.facet(Px).hideOn(e, n, r);
	if (i != null) return i;
	let a = e.startState.doc.lineAt(t.pos);
	return !!(e.effects.some((e) => e.is(Sx)) || e.changes.touchesRange(a.from, Math.max(a.to, r)));
}
function bx(e, t) {
	return e.field(Tx, !1) ? t : t.concat(Li.appendConfig.of(Jx));
}
function xx(e, t) {
	return { effects: bx(e, [Sx.of(t)]) };
}
var Sx = /*@__PURE__*/ Li.define(), Cx = /*@__PURE__*/ Li.define(), wx = /*@__PURE__*/ Li.define(), Tx = /*@__PURE__*/ gi.define({
	create() {
		return new _x(K.none, null, null);
	},
	update(e, t) {
		if (t.docChanged && e.diagnostics.size) {
			let n = e.diagnostics.map(t.changes), r = null, i = e.panel;
			if (e.selected) {
				let i = t.changes.mapPos(e.selected.from, 1);
				r = vx(n, e.selected.diagnostic, i) || vx(n, null, i);
			}
			!n.size && i && t.state.facet(Px).autoPanel && (i = null), e = new _x(n, i, r);
		}
		for (let n of t.effects) if (n.is(Sx)) {
			let r = t.state.facet(Px).autoPanel ? n.value.length ? Vx.open : null : e.panel;
			e = _x.init(n.value, r, t.state);
		} else n.is(Cx) ? e = new _x(e.diagnostics, n.value ? Vx.open : null, e.selected) : n.is(wx) && (e = new _x(e.diagnostics, e.panel, n.value));
		return e;
	},
	provide: (e) => [vf.from(e, (e) => e.panel), q.decorations.from(e, (e) => e.diagnostics)]
}), Ex = /*@__PURE__*/ K.mark({ class: "cm-lintRange cm-lintRange-active" });
function Dx(e, t, n) {
	let { diagnostics: r } = e.state.field(Tx), i, a = -1, o = -1;
	r.between(t - +(n < 0), t + +(n > 0), (e, r, { spec: s }) => {
		if (t >= e && t <= r && (e == r || (t > e || n > 0) && (t < r || n < 0))) return i = s.diagnostics, a = e, o = r, !1;
	});
	let s = e.state.facet(Px).tooltipFilter;
	return i && s && (i = s(i, e.state)), i ? {
		pos: a,
		end: o,
		above: !0,
		create() {
			return { dom: Ox(e, i) };
		}
	} : null;
}
function Ox(e, t) {
	return Pa("ul", { class: "cm-tooltip-lint" }, t.map((t) => Rx(e, t, !1)));
}
var kx = (e) => {
	let t = e.state.field(Tx, !1);
	(!t || !t.panel) && e.dispatch({ effects: bx(e.state, [Cx.of(!0)]) });
	let n = mf(e, Vx.open);
	return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, Ax = (e) => {
	let t = e.state.field(Tx, !1);
	return !t || !t.panel ? !1 : (e.dispatch({ effects: Cx.of(!1) }), !0);
}, jx = [{
	key: "Mod-Shift-m",
	run: kx,
	preventDefault: !0
}, {
	key: "F8",
	run: (e) => {
		let t = e.state.field(Tx, !1);
		if (!t) return !1;
		let n = e.state.selection.main, r = vx(t.diagnostics, null, n.to + 1);
		return !r && (r = vx(t.diagnostics, null, 0), !r || r.from == n.from && r.to == n.to) ? !1 : (e.dispatch({
			selection: {
				anchor: r.from,
				head: r.to
			},
			scrollIntoView: !0
		}), uf(e, r.from, 1, {
			tooltip: qx,
			until: (e) => e.docChanged || e.newSelection.main.head < r.from || e.newSelection.main.head > r.to
		}), !0);
	}
}], Mx = /*@__PURE__*/ Cs.fromClass(class {
	constructor(e) {
		this.view = e, this.timeout = -1, this.set = !0;
		let { delay: t } = e.state.facet(Px);
		this.lintTime = Date.now() + t, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, t);
	}
	run() {
		clearTimeout(this.timeout);
		let e = Date.now();
		if (e < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - e);
		else {
			this.set = !1;
			let { state: e } = this.view, { sources: t } = e.facet(Px);
			t.length && Nx(t.map((e) => Promise.resolve(e(this.view))), (t) => {
				this.view.state.doc == e.doc && this.view.dispatch(xx(this.view.state, t.reduce((e, t) => e.concat(t))));
			}, (e) => {
				ys(this.view.state, e);
			});
		}
	}
	update(e) {
		let t = e.state.facet(Px);
		(e.docChanged || t != e.startState.facet(Px) || t.needsRefresh && t.needsRefresh(e)) && (this.lintTime = Date.now() + t.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, t.delay)));
	}
	force() {
		this.set && (this.lintTime = Date.now(), this.run());
	}
	destroy() {
		clearTimeout(this.timeout);
	}
});
function Nx(e, t, n) {
	let r = [], i = -1;
	for (let a of e) a.then((n) => {
		r.push(n), clearTimeout(i), r.length == e.length ? t(r) : i = setTimeout(() => t(r), 200);
	}, n);
}
var Px = /*@__PURE__*/ W.define({ combine(e) {
	return {
		sources: e.map((e) => e.source).filter((e) => e != null),
		...$i(e.map((e) => e.config), {
			delay: 750,
			markerFilter: null,
			tooltipFilter: null,
			needsRefresh: null,
			hideOn: () => null
		}, {
			delay: Math.max,
			markerFilter: Fx,
			tooltipFilter: Fx,
			needsRefresh: (e, t) => e ? t ? (n) => e(n) || t(n) : e : t,
			hideOn: (e, t) => e ? t ? (n, r, i) => e(n, r, i) || t(n, r, i) : e : t,
			autoPanel: (e, t) => e || t
		})
	};
} });
function Fx(e, t) {
	return e ? t ? (n, r) => t(e(n, r), r) : e : t;
}
function Ix(e, t = {}) {
	return [
		Px.of({
			source: e,
			config: t
		}),
		Mx,
		Jx
	];
}
function Lx(e) {
	let t = [];
	if (e) actions: for (let { name: n } of e) {
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			if (/[a-zA-Z]/.test(r) && !t.some((e) => e.toLowerCase() == r.toLowerCase())) {
				t.push(r);
				continue actions;
			}
		}
		t.push("");
	}
	return t;
}
function Rx(e, t, n) {
	let r = n ? Lx(t.actions) : [];
	return Pa("li", { class: "cm-diagnostic cm-diagnostic-" + t.severity }, Pa("span", { class: "cm-diagnosticText" }, t.renderMessage ? t.renderMessage(e) : t.message), t.actions?.map((n, i) => {
		let a = !1, o = (r) => {
			if (r.preventDefault(), a) return;
			a = !0;
			let i = vx(e.state.field(Tx).diagnostics, t);
			i && n.apply(e, i.from, i.to);
		}, { name: s } = n, c = r[i] ? s.indexOf(r[i]) : -1, l = c < 0 ? s : [
			s.slice(0, c),
			Pa("u", s.slice(c, c + 1)),
			s.slice(c + 1)
		];
		return Pa("button", {
			type: "button",
			class: "cm-diagnosticAction" + (n.markClass ? " " + n.markClass : ""),
			onclick: o,
			onmousedown: o,
			"aria-label": ` Action: ${s}${c < 0 ? "" : ` (access key "${r[i]})"`}.`
		}, l);
	}), t.source && Pa("div", { class: "cm-diagnosticSource" }, t.source));
}
var zx = class extends $a {
	constructor(e) {
		super(), this.sev = e;
	}
	eq(e) {
		return e.sev == this.sev;
	}
	toDOM() {
		return Pa("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
	}
}, Bx = class {
	constructor(e, t) {
		this.diagnostic = t, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = Rx(e, t, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
	}
}, Vx = class e {
	constructor(e) {
		this.view = e, this.items = [];
		let t = (t) => {
			if (!(t.ctrlKey || t.altKey || t.metaKey)) {
				if (t.keyCode == 27) Ax(this.view), this.view.focus();
				else if (t.keyCode == 38 || t.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
				else if (t.keyCode == 40 || t.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
				else if (t.keyCode == 36) this.moveSelection(0);
				else if (t.keyCode == 35) this.moveSelection(this.items.length - 1);
				else if (t.keyCode == 13) this.view.focus();
				else if (t.keyCode >= 65 && t.keyCode <= 90 && this.selectedIndex >= 0) {
					let { diagnostic: n } = this.items[this.selectedIndex], r = Lx(n.actions);
					for (let i = 0; i < r.length; i++) if (r[i].toUpperCase().charCodeAt(0) == t.keyCode) {
						let t = vx(this.view.state.field(Tx).diagnostics, n);
						t && n.actions[i].apply(e, t.from, t.to);
					}
				} else return;
				t.preventDefault();
			}
		}, n = (e) => {
			for (let t = 0; t < this.items.length; t++) this.items[t].dom.contains(e.target) && this.moveSelection(t);
		};
		this.list = Pa("ul", {
			tabIndex: 0,
			role: "listbox",
			"aria-label": this.view.state.phrase("Diagnostics"),
			onkeydown: t,
			onclick: n
		}), this.dom = Pa("div", { class: "cm-panel-lint" }, this.list, Pa("button", {
			type: "button",
			name: "close",
			"aria-label": this.view.state.phrase("close"),
			onclick: () => Ax(this.view)
		}, "×")), this.update();
	}
	get selectedIndex() {
		let e = this.view.state.field(Tx).selected;
		if (!e) return -1;
		for (let t = 0; t < this.items.length; t++) if (this.items[t].diagnostic == e.diagnostic) return t;
		return -1;
	}
	update() {
		let { diagnostics: e, selected: t } = this.view.state.field(Tx), n = 0, r = !1, i = null, a = /* @__PURE__ */ new Set();
		for (e.between(0, this.view.state.doc.length, (e, o, { spec: s }) => {
			for (let e of s.diagnostics) {
				if (a.has(e)) continue;
				a.add(e);
				let o = -1, s;
				for (let t = n; t < this.items.length; t++) if (this.items[t].diagnostic == e) {
					o = t;
					break;
				}
				o < 0 ? (s = new Bx(this.view, e), this.items.splice(n, 0, s), r = !0) : (s = this.items[o], o > n && (this.items.splice(n, o - n), r = !0)), t && s.diagnostic == t.diagnostic ? s.dom.hasAttribute("aria-selected") || (s.dom.setAttribute("aria-selected", "true"), i = s) : s.dom.hasAttribute("aria-selected") && s.dom.removeAttribute("aria-selected"), n++;
			}
		}); n < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0);) r = !0, this.items.pop();
		this.items.length == 0 && (this.items.push(new Bx(this.view, {
			from: -1,
			to: -1,
			severity: "info",
			message: this.view.state.phrase("No diagnostics")
		})), r = !0), i ? (this.list.setAttribute("aria-activedescendant", i.id), this.view.requestMeasure({
			key: this,
			read: () => ({
				sel: i.dom.getBoundingClientRect(),
				panel: this.list.getBoundingClientRect()
			}),
			write: ({ sel: e, panel: t }) => {
				let n = t.height / this.list.offsetHeight;
				e.top < t.top ? this.list.scrollTop -= (t.top - e.top) / n : e.bottom > t.bottom && (this.list.scrollTop += (e.bottom - t.bottom) / n);
			}
		})) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), r && this.sync();
	}
	sync() {
		let e = this.list.firstChild;
		function t() {
			let t = e;
			e = t.nextSibling, t.remove();
		}
		for (let n of this.items) if (n.dom.parentNode == this.list) {
			for (; e != n.dom;) t();
			e = n.dom.nextSibling;
		} else this.list.insertBefore(n.dom, e);
		for (; e;) t();
	}
	moveSelection(e) {
		if (this.selectedIndex < 0) return;
		let t = vx(this.view.state.field(Tx).diagnostics, this.items[e].diagnostic);
		t && this.view.dispatch({
			selection: {
				anchor: t.from,
				head: t.to
			},
			scrollIntoView: !0,
			effects: wx.of(t)
		});
	}
	static open(t) {
		return new e(t);
	}
};
function Hx(e, t = "viewBox=\"0 0 40 40\"") {
	return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${t}>${encodeURIComponent(e)}</svg>')`;
}
function Ux(e) {
	return Hx(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${e}" fill="none" stroke-width=".7"/>`, "width=\"6\" height=\"3\"");
}
var Wx = /*@__PURE__*/ q.baseTheme({
	".cm-diagnostic": {
		padding: "3px 6px 3px 8px",
		marginLeft: "-1px",
		display: "block",
		whiteSpace: "pre-wrap"
	},
	".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
	".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
	".cm-diagnostic-info": { borderLeft: "5px solid #999" },
	".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
	".cm-diagnosticAction": {
		font: "inherit",
		border: "none",
		padding: "2px 4px",
		backgroundColor: "#444",
		color: "white",
		borderRadius: "3px",
		marginLeft: "8px",
		cursor: "pointer"
	},
	".cm-diagnosticSource": {
		fontSize: "70%",
		opacity: .7
	},
	".cm-lintRange": {
		backgroundPosition: "left bottom",
		backgroundRepeat: "repeat-x",
		paddingBottom: "0.7px"
	},
	".cm-lintRange-error": { backgroundImage: /*@__PURE__*/ Ux("#f11") },
	".cm-lintRange-warning": { backgroundImage: /*@__PURE__*/ Ux("orange") },
	".cm-lintRange-info": { backgroundImage: /*@__PURE__*/ Ux("#999") },
	".cm-lintRange-hint": { backgroundImage: /*@__PURE__*/ Ux("#66d") },
	".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
	".cm-tooltip-lint": {
		padding: 0,
		margin: 0
	},
	".cm-lintPoint": {
		position: "relative",
		"&:after": {
			content: "\"\"",
			position: "absolute",
			bottom: 0,
			left: "-2px",
			borderLeft: "3px solid transparent",
			borderRight: "3px solid transparent",
			borderBottom: "4px solid #d11"
		}
	},
	".cm-lintPoint-warning": { "&:after": { borderBottomColor: "orange" } },
	".cm-lintPoint-info": { "&:after": { borderBottomColor: "#999" } },
	".cm-lintPoint-hint": { "&:after": { borderBottomColor: "#66d" } },
	".cm-panel.cm-panel-lint": {
		position: "relative",
		"& ul": {
			maxHeight: "100px",
			overflowY: "auto",
			"& [aria-selected]": {
				backgroundColor: "#ddd",
				"& u": { textDecoration: "underline" }
			},
			"&:focus [aria-selected]": {
				background_fallback: "#bdf",
				backgroundColor: "Highlight",
				color_fallback: "white",
				color: "HighlightText"
			},
			"& u": { textDecoration: "none" },
			padding: 0,
			margin: 0
		},
		"& [name=close]": {
			position: "absolute",
			top: "0",
			right: "2px",
			background: "inherit",
			border: "none",
			font: "inherit",
			padding: 0,
			margin: 0
		}
	},
	"&dark .cm-lintRange-active": { backgroundColor: "#86714a80" },
	"&dark .cm-panel.cm-panel-lint ul": { "& [aria-selected]": { backgroundColor: "#2e343e" } }
});
function Gx(e) {
	return e == "error" ? 4 : e == "warning" ? 3 : e == "info" ? 2 : 1;
}
function Kx(e) {
	let t = "hint", n = 1;
	for (let r of e) {
		let e = Gx(r.severity);
		e > n && (n = e, t = r.severity);
	}
	return t;
}
var qx = /*@__PURE__*/ lf(Dx, { hideOn: yx }), Jx = [
	Tx,
	/*@__PURE__*/ q.decorations.compute([Tx], (e) => {
		let { selected: t, panel: n } = e.field(Tx);
		return !t || !n || t.from == t.to ? K.none : K.set([Ex.range(t.from, t.to)]);
	}),
	qx,
	Wx
], Yx = [
	Gf(),
	Yf(),
	Cd(),
	dg(),
	gh(),
	id(),
	pd(),
	Qi.allowMultipleSelections.of(!0),
	Hm(),
	Sh(Th, { fallback: !0 }),
	Fh(),
	Xb(),
	px(),
	Bd(),
	Ud(),
	Ad(),
	Nv(),
	Bu.of([
		...nx,
		...vv,
		...Sy,
		...Ag,
		...sh,
		...mx,
		...jx
	])
], Xx = Object.freeze({
	autofocus: !1,
	disabled: !1,
	indentWithTab: !0,
	tabSize: 2,
	placeholder: "",
	autoDestroy: !0,
	extensions: [Yx]
}), Zx = Symbol("vue-codemirror-global-config"), Qx, $x = function(e) {
	var t = e.onUpdate, n = e.onChange, r = e.onFocus, i = e.onBlur, a = function(e, t) {
		var n = {};
		for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
		if (e != null && typeof Object.getOwnPropertySymbols == "function") {
			var i = 0;
			for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
		}
		return n;
	}(e, [
		"onUpdate",
		"onChange",
		"onFocus",
		"onBlur"
	]);
	return Qi.create({
		doc: a.doc,
		selection: a.selection,
		extensions: (Array.isArray(a.extensions) ? a.extensions : [a.extensions]).concat([q.updateListener.of((function(e) {
			t(e), e.docChanged && n(e.state.doc.toString(), e), e.focusChanged && (e.view.hasFocus ? r(e) : i(e));
		}))])
	});
}, eS = function(e) {
	var t = new xi();
	return {
		compartment: t,
		run: function(n) {
			t.get(e.state) ? e.dispatch({ effects: t.reconfigure(n) }) : e.dispatch({ effects: Li.appendConfig.of(t.of(n)) });
		}
	};
}, tS = function(e, t) {
	var n = eS(e), r = n.compartment, i = n.run;
	return function(n) {
		var a = r.get(e.state);
		i(n ?? a !== t ? t : []);
	};
}, nS = {
	type: Boolean,
	default: void 0
}, rS = {
	autofocus: nS,
	disabled: nS,
	indentWithTab: nS,
	tabSize: Number,
	placeholder: String,
	style: Object,
	autoDestroy: nS,
	phrases: Object,
	root: Object,
	extensions: Array,
	selection: Object
}, iS = { modelValue: {
	type: String,
	default: ""
} }, aS = Object.assign(Object.assign({}, rS), iS);
(function(e) {
	e.Change = "change", e.Update = "update", e.Focus = "focus", e.Blur = "blur", e.Ready = "ready", e.ModelUpdate = "update:modelValue";
})(Qx ||= {});
var oS = {};
oS[Qx.Change] = function(e, t) {
	return !0;
}, oS[Qx.Update] = function(e) {
	return !0;
}, oS[Qx.Focus] = function(e) {
	return !0;
}, oS[Qx.Blur] = function(e) {
	return !0;
}, oS[Qx.Ready] = function(e) {
	return !0;
};
var sS = {};
sS[Qx.ModelUpdate] = oS[Qx.Change];
var cS = Object.assign(Object.assign({}, oS), sS), lS = d({
	name: "VueCodemirror",
	props: Object.assign({}, aS),
	emits: Object.assign({}, cS),
	setup: function(e, t) {
		var r = ne(), i = ne(), a = ne(), o = Object.assign(Object.assign({}, Xx), h(Zx, {})), s = n((function() {
			var t = {};
			return Object.keys(ie(e)).forEach((function(n) {
				n !== "modelValue" && (t[n] = e[n] ?? o[n]);
			})), t;
		}));
		return E((function() {
			i.value = $x({
				doc: e.modelValue,
				selection: s.value.selection,
				extensions: o.extensions ?? [],
				onFocus: function(e) {
					return t.emit(Qx.Focus, e);
				},
				onBlur: function(e) {
					return t.emit(Qx.Blur, e);
				},
				onUpdate: function(e) {
					return t.emit(Qx.Update, e);
				},
				onChange: function(n, r) {
					n !== e.modelValue && (t.emit(Qx.Change, n, r), t.emit(Qx.ModelUpdate, n, r));
				}
			}), a.value = function(e) {
				return new q(Object.assign({}, e));
			}({
				state: i.value,
				parent: r.value,
				root: s.value.root
			});
			var n = function(e) {
				var t = function() {
					return e.state.doc.toString();
				}, n = eS(e).run, r = tS(e, [q.editable.of(!1), Qi.readOnly.of(!0)]), i = tS(e, Bu.of([yv])), a = eS(e).run, o = eS(e).run, s = eS(e).run, c = eS(e).run;
				return {
					focus: function() {
						return e.focus();
					},
					getDoc: t,
					setDoc: function(n) {
						n !== t() && e.dispatch({ changes: {
							from: 0,
							to: e.state.doc.length,
							insert: n
						} });
					},
					reExtensions: n,
					toggleDisabled: r,
					toggleIndentWithTab: i,
					setTabSize: function(e) {
						a([Qi.tabSize.of(e), Cm.of(" ".repeat(e))]);
					},
					setPhrases: function(e) {
						o([Qi.phrases.of(e)]);
					},
					setPlaceholder: function(e) {
						s(Pd(e));
					},
					setStyle: function(e) {
						e === void 0 && (e = {}), c(q.theme({ "&": Object.assign({}, e) }));
					}
				};
			}(a.value);
			I((function() {
				return e.modelValue;
			}), (function(e) {
				e !== n.getDoc() && n.setDoc(e);
			})), I((function() {
				return e.extensions;
			}), (function(e) {
				return n.reExtensions(e || []);
			}), { immediate: !0 }), I((function() {
				return s.value.disabled;
			}), (function(e) {
				return n.toggleDisabled(e);
			}), { immediate: !0 }), I((function() {
				return s.value.indentWithTab;
			}), (function(e) {
				return n.toggleIndentWithTab(e);
			}), { immediate: !0 }), I((function() {
				return s.value.tabSize;
			}), (function(e) {
				return n.setTabSize(e);
			}), { immediate: !0 }), I((function() {
				return s.value.phrases;
			}), (function(e) {
				return n.setPhrases(e || {});
			}), { immediate: !0 }), I((function() {
				return s.value.placeholder;
			}), (function(e) {
				return n.setPlaceholder(e);
			}), { immediate: !0 }), I((function() {
				return s.value.style;
			}), (function(e) {
				return n.setStyle(e);
			}), { immediate: !0 }), s.value.autofocus && n.focus(), t.emit(Qx.Ready, {
				state: i.value,
				view: a.value,
				container: r.value
			});
		})), w((function() {
			s.value.autoDestroy && a.value && function(e) {
				e.destroy();
			}(a.value);
		})), function() {
			return m("div", {
				class: "v-codemirror",
				style: { display: "contents" },
				ref: r
			});
		};
	}
}), uS = class e {
	constructor(e, t, n, r, i, a, o, s, c, l = 0, u) {
		this.p = e, this.stack = t, this.state = n, this.reducePos = r, this.pos = i, this.score = a, this.buffer = o, this.bufferBase = s, this.curContext = c, this.lookAhead = l, this.parent = u;
	}
	toString() {
		return `[${this.stack.filter((e, t) => t % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
	}
	static start(t, n, r = 0) {
		let i = t.parser.context;
		return new e(t, [], n, r, r, 0, [], 0, i ? new dS(i, i.start) : null, 0, null);
	}
	get context() {
		return this.curContext ? this.curContext.context : null;
	}
	pushState(e, t) {
		this.stack.push(this.state, t, this.bufferBase + this.buffer.length), this.state = e;
	}
	reduce(e) {
		let t = e >> 19, n = e & 65535, { parser: r } = this.p, i = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos), a = r.dynamicPrecedence(n);
		if (a && (this.score += a), t == 0) {
			n < r.minRepeatTerm && this.reducePos < this.pos && (this.reducePos = this.pos), this.pushState(r.getGoto(this.state, n, !0), this.reducePos), n < r.minRepeatTerm && this.storeNode(n, this.reducePos, this.reducePos, i ? 8 : 4, !0), this.reduceContext(n, this.reducePos);
			return;
		}
		let o = this.stack.length - (t - 1) * 3 - (e & 262144 ? 6 : 0), s = o ? this.stack[o - 2] : this.p.ranges[0].from;
		n < r.minRepeatTerm && s == this.reducePos && this.reducePos < this.pos && (this.reducePos = this.pos);
		let c = this.reducePos - s;
		c >= 2e3 && !this.p.parser.nodeSet.types[n]?.isAnonymous && (s == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = c) : this.p.lastBigReductionSize < c && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = s, this.p.lastBigReductionSize = c));
		let l = o ? this.stack[o - 1] : 0, u = this.bufferBase + this.buffer.length - l;
		if (n < r.minRepeatTerm || e & 131072) {
			let e = r.stateFlag(this.state, 1) ? this.pos : this.reducePos;
			this.storeNode(n, s, e, u + 4, !0);
		}
		if (e & 262144) this.state = this.stack[o];
		else {
			let e = this.stack[o - 3];
			this.state = r.getGoto(e, n, !0);
		}
		for (; this.stack.length > o;) this.stack.pop();
		this.reduceContext(n, s);
	}
	storeNode(e, t, n, r = 4, i = !1) {
		if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
			let e = this.buffer.length;
			if (e > 0 && this.buffer[e - 4] == 0 && this.buffer[e - 1] > -1) {
				if (t == n) return;
				if (this.buffer[e - 2] >= t) {
					this.buffer[e - 2] = n;
					return;
				}
			}
		}
		if (!i || this.pos == n) this.buffer.push(e, t, n, r);
		else {
			let i = this.buffer.length;
			if (i > 0 && (this.buffer[i - 4] != 0 || this.buffer[i - 1] < 0)) {
				let e = !1;
				for (let t = i; t > 0 && this.buffer[t - 2] > n; t -= 4) if (this.buffer[t - 1] >= 0) {
					e = !0;
					break;
				}
				if (e) for (; i > 0 && this.buffer[i - 2] > n;) this.buffer[i] = this.buffer[i - 4], this.buffer[i + 1] = this.buffer[i - 3], this.buffer[i + 2] = this.buffer[i - 2], this.buffer[i + 3] = this.buffer[i - 1], i -= 4, r > 4 && (r -= 4);
			}
			this.buffer[i] = e, this.buffer[i + 1] = t, this.buffer[i + 2] = n, this.buffer[i + 3] = r;
		}
	}
	shift(e, t, n, r) {
		if (e & 131072) this.pushState(e & 65535, this.pos);
		else if (e & 262144) this.pos = r, this.shiftContext(t, n), t <= this.p.parser.maxNode && this.buffer.push(t, n, r, 4);
		else {
			let i = e, { parser: a } = this.p;
			this.pos = r;
			let o = a.stateFlag(i, 1);
			!o && (r > n || t <= a.maxNode) && (this.reducePos = r), this.pushState(i, o ? n : Math.min(n, this.reducePos)), this.shiftContext(t, n), t <= a.maxNode && this.buffer.push(t, n, r, 4);
		}
	}
	apply(e, t, n, r) {
		e & 65536 ? this.reduce(e) : this.shift(e, t, n, r);
	}
	useNode(e, t) {
		let n = this.p.reused.length - 1;
		(n < 0 || this.p.reused[n] != e) && (this.p.reused.push(e), n++);
		let r = this.pos;
		this.reducePos = this.pos = r + e.length, this.pushState(t, r), this.buffer.push(n, r, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
	}
	split() {
		let t = this, n = t.buffer.length;
		for (n && t.buffer[n - 4] == 0 && (n -= 4); n > 0 && t.buffer[n - 2] > t.reducePos;) n -= 4;
		let r = t.buffer.slice(n), i = t.bufferBase + n;
		for (; t && i == t.bufferBase;) t = t.parent;
		return new e(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, t);
	}
	recoverByDelete(e, t) {
		let n = e <= this.p.parser.maxNode;
		n && this.storeNode(e, this.pos, t, 4), this.storeNode(0, this.pos, t, n ? 8 : 4), this.pos = this.reducePos = t, this.score -= 190;
	}
	canShift(e) {
		for (let t = new fS(this);;) {
			let n = this.p.parser.stateSlot(t.state, 4) || this.p.parser.hasAction(t.state, e);
			if (n == 0) return !1;
			if (!(n & 65536)) return !0;
			t.reduce(n);
		}
	}
	recoverByInsert(e) {
		if (this.stack.length >= 300) return [];
		let t = this.p.parser.nextStates(this.state);
		if (t.length > 8 || this.stack.length >= 120) {
			let n = [];
			for (let r = 0, i; r < t.length; r += 2) (i = t[r + 1]) != this.state && this.p.parser.hasAction(i, e) && n.push(t[r], i);
			if (this.stack.length < 120) for (let e = 0; n.length < 8 && e < t.length; e += 2) {
				let r = t[e + 1];
				n.some((e, t) => t & 1 && e == r) || n.push(t[e], r);
			}
			t = n;
		}
		let n = [];
		for (let e = 0; e < t.length && n.length < 4; e += 2) {
			let r = t[e + 1];
			if (r == this.state) continue;
			let i = this.split();
			i.pushState(r, this.pos), i.storeNode(0, i.pos, i.pos, 4, !0), i.shiftContext(t[e], this.pos), i.reducePos = this.pos, i.score -= 200, n.push(i);
		}
		return n;
	}
	forceReduce() {
		let { parser: e } = this.p, t = e.stateSlot(this.state, 5);
		if (!(t & 65536)) return !1;
		if (!e.validAction(this.state, t)) {
			let n = t >> 19, r = t & 65535, i = this.stack.length - n * 3;
			if (i < 0 || e.getGoto(this.stack[i], r, !1) < 0) {
				let e = this.findForcedReduction();
				if (e == null) return !1;
				t = e;
			}
			this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
		}
		return this.reducePos = this.pos, this.reduce(t), !0;
	}
	findForcedReduction() {
		let { parser: e } = this.p, t = [], n = (r, i) => {
			if (!t.includes(r)) return t.push(r), e.allActions(r, (t) => {
				if (!(t & 393216)) if (t & 65536) {
					let n = (t >> 19) - i;
					if (n > 1) {
						let r = t & 65535, i = this.stack.length - n * 3;
						if (i >= 0 && e.getGoto(this.stack[i], r, !1) >= 0) return n << 19 | 65536 | r;
					}
				} else {
					let e = n(t, i + 1);
					if (e != null) return e;
				}
			});
		};
		return n(this.state, 0);
	}
	forceAll() {
		for (; !this.p.parser.stateFlag(this.state, 2);) if (!this.forceReduce()) {
			this.storeNode(0, this.pos, this.pos, 4, !0);
			break;
		}
		return this;
	}
	get deadEnd() {
		if (this.stack.length != 3) return !1;
		let { parser: e } = this.p;
		return e.data[e.stateSlot(this.state, 1)] == 65535 && !e.stateSlot(this.state, 4);
	}
	restart() {
		this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
	}
	sameState(e) {
		if (this.state != e.state || this.stack.length != e.stack.length) return !1;
		for (let t = 0; t < this.stack.length; t += 3) if (this.stack[t] != e.stack[t]) return !1;
		return !0;
	}
	get parser() {
		return this.p.parser;
	}
	dialectEnabled(e) {
		return this.p.parser.dialect.flags[e];
	}
	shiftContext(e, t) {
		this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)));
	}
	reduceContext(e, t) {
		this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)));
	}
	emitContext() {
		let e = this.buffer.length - 1;
		(e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
	}
	emitLookAhead() {
		let e = this.buffer.length - 1;
		(e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
	}
	updateContext(e) {
		if (e != this.curContext.context) {
			let t = new dS(this.curContext.tracker, e);
			t.hash != this.curContext.hash && this.emitContext(), this.curContext = t;
		}
	}
	setLookAhead(e) {
		return e <= this.lookAhead ? !1 : (this.emitLookAhead(), this.lookAhead = e, !0);
	}
	close() {
		this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
	}
}, dS = class {
	constructor(e, t) {
		this.tracker = e, this.context = t, this.hash = e.strict ? e.hash(t) : 0;
	}
}, fS = class {
	constructor(e) {
		this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
	}
	reduce(e) {
		let t = e & 65535, n = e >> 19;
		n == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (n - 1) * 3;
		let r = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
		this.state = r;
	}
}, pS = class e {
	constructor(e, t, n) {
		this.stack = e, this.pos = t, this.index = n, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
	}
	static create(t, n = t.bufferBase + t.buffer.length) {
		return new e(t, n, n - t.bufferBase);
	}
	maybeNext() {
		let e = this.stack.parent;
		e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
	}
	get id() {
		return this.buffer[this.index - 4];
	}
	get start() {
		return this.buffer[this.index - 3];
	}
	get end() {
		return this.buffer[this.index - 2];
	}
	get size() {
		return this.buffer[this.index - 1];
	}
	next() {
		this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
	}
	fork() {
		return new e(this.stack, this.pos, this.index);
	}
};
function mS(e, t = Uint16Array) {
	if (typeof e != "string") return e;
	let n = null;
	for (let r = 0, i = 0; r < e.length;) {
		let a = 0;
		for (;;) {
			let t = e.charCodeAt(r++), n = !1;
			if (t == 126) {
				a = 65535;
				break;
			}
			t >= 92 && t--, t >= 34 && t--;
			let i = t - 32;
			if (i >= 46 && (i -= 46, n = !0), a += i, n) break;
			a *= 46;
		}
		n ? n[i++] = a : n = new t(a);
	}
	return n;
}
var hS = class {
	constructor() {
		this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
	}
}, gS = new hS(), _S = class {
	constructor(e, t) {
		this.input = e, this.ranges = t, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = gS, this.rangeIndex = 0, this.pos = this.chunkPos = t[0].from, this.range = t[0], this.end = t[t.length - 1].to, this.readNext();
	}
	resolveOffset(e, t) {
		let n = this.range, r = this.rangeIndex, i = this.pos + e;
		for (; i < n.from;) {
			if (!r) return null;
			let e = this.ranges[--r];
			i -= n.from - e.to, n = e;
		}
		for (; t < 0 ? i > n.to : i >= n.to;) {
			if (r == this.ranges.length - 1) return null;
			let e = this.ranges[++r];
			i += e.from - n.to, n = e;
		}
		return i;
	}
	clipPos(e) {
		if (e >= this.range.from && e < this.range.to) return e;
		for (let t of this.ranges) if (t.to > e) return Math.max(e, t.from);
		return this.end;
	}
	peek(e) {
		let t = this.chunkOff + e, n, r;
		if (t >= 0 && t < this.chunk.length) n = this.pos + e, r = this.chunk.charCodeAt(t);
		else {
			let t = this.resolveOffset(e, 1);
			if (t == null) return -1;
			if (n = t, n >= this.chunk2Pos && n < this.chunk2Pos + this.chunk2.length) r = this.chunk2.charCodeAt(n - this.chunk2Pos);
			else {
				let e = this.rangeIndex, t = this.range;
				for (; t.to <= n;) t = this.ranges[++e];
				this.chunk2 = this.input.chunk(this.chunk2Pos = n), n + this.chunk2.length > t.to && (this.chunk2 = this.chunk2.slice(0, t.to - n)), r = this.chunk2.charCodeAt(0);
			}
		}
		return n >= this.token.lookAhead && (this.token.lookAhead = n + 1), r;
	}
	acceptToken(e, t = 0) {
		let n = t ? this.resolveOffset(t, -1) : this.pos;
		if (n == null || n < this.token.start) throw RangeError("Token end out of bounds");
		this.token.value = e, this.token.end = n;
	}
	acceptTokenTo(e, t) {
		this.token.value = e, this.token.end = t;
	}
	getChunk() {
		if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
			let { chunk: e, chunkPos: t } = this;
			this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = t, this.chunkOff = this.pos - this.chunkPos;
		} else {
			this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
			let e = this.input.chunk(this.pos), t = this.pos + e.length;
			this.chunk = t > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
		}
	}
	readNext() {
		return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
	}
	advance(e = 1) {
		for (this.chunkOff += e; this.pos + e >= this.range.to;) {
			if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
			e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
		}
		return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
	}
	setDone() {
		return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
	}
	reset(e, t) {
		if (t ? (this.token = t, t.start = e, t.lookAhead = e + 1, t.value = t.extended = -1) : this.token = gS, this.pos != e) {
			if (this.pos = e, e == this.end) return this.setDone(), this;
			for (; e < this.range.from;) this.range = this.ranges[--this.rangeIndex];
			for (; e >= this.range.to;) this.range = this.ranges[++this.rangeIndex];
			e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
		}
		return this;
	}
	read(e, t) {
		if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length) return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
		if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
		if (e >= this.range.from && t <= this.range.to) return this.input.read(e, t);
		let n = "";
		for (let r of this.ranges) {
			if (r.from >= t) break;
			r.to > e && (n += this.input.read(Math.max(r.from, e), Math.min(r.to, t)));
		}
		return n;
	}
}, vS = class {
	constructor(e, t) {
		this.data = e, this.id = t;
	}
	token(e, t) {
		let { parser: n } = t.p;
		xS(this.data, e, t, this.id, n.data, n.tokenPrecTable);
	}
};
vS.prototype.contextual = vS.prototype.fallback = vS.prototype.extend = !1;
var yS = class {
	constructor(e, t, n) {
		this.precTable = t, this.elseToken = n, this.data = typeof e == "string" ? mS(e) : e;
	}
	token(e, t) {
		let n = e.pos, r = 0;
		for (;;) {
			let n = e.next < 0, i = e.resolveOffset(1, 1);
			if (xS(this.data, e, t, 0, this.data, this.precTable), e.token.value > -1) break;
			if (this.elseToken == null) return;
			if (n || r++, i == null) break;
			e.reset(i, e.token);
		}
		r && (e.reset(n, e.token), e.acceptToken(this.elseToken, r));
	}
};
yS.prototype.contextual = vS.prototype.fallback = vS.prototype.extend = !1;
var bS = class {
	constructor(e, t = {}) {
		this.token = e, this.contextual = !!t.contextual, this.fallback = !!t.fallback, this.extend = !!t.extend;
	}
};
function xS(e, t, n, r, i, a) {
	let o = 0, s = 1 << r, { dialect: c } = n.p.parser;
	scan: for (; (s & e[o]) != 0;) {
		let n = e[o + 1];
		for (let r = o + 3; r < n; r += 2) if ((e[r + 1] & s) > 0) {
			let n = e[r];
			if (c.allows(n) && (t.token.value == -1 || t.token.value == n || CS(n, t.token.value, i, a))) {
				t.acceptToken(n);
				break;
			}
		}
		let r = t.next, l = 0, u = e[o + 2];
		if (t.next < 0 && u > l && e[n + u * 3 - 3] == 65535) {
			o = e[n + u * 3 - 1];
			continue scan;
		}
		for (; l < u;) {
			let i = l + u >> 1, a = n + i + (i << 1), s = e[a], c = e[a + 1] || 65536;
			if (r < s) u = i;
			else if (r >= c) l = i + 1;
			else {
				o = e[a + 2], t.advance();
				continue scan;
			}
		}
		break;
	}
}
function SS(e, t, n) {
	for (let r = t, i; (i = e[r]) != 65535; r++) if (i == n) return r - t;
	return -1;
}
function CS(e, t, n, r) {
	let i = SS(n, r, t);
	return i < 0 || SS(n, r, e) < i;
}
var wS = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG), TS = null;
function ES(e, t, n) {
	let r = e.cursor(op.IncludeAnonymous);
	for (r.moveTo(t);;) if (!(n < 0 ? r.childBefore(t) : r.childAfter(t))) for (;;) {
		if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError) return n < 0 ? Math.max(0, Math.min(r.to - 1, t - 25)) : Math.min(e.length, Math.max(r.from + 1, t + 25));
		if (n < 0 ? r.prevSibling() : r.nextSibling()) break;
		if (!r.parent()) return n < 0 ? 0 : e.length;
	}
}
var DS = class {
	constructor(e, t) {
		this.fragments = e, this.nodeSet = t, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
	}
	nextFragment() {
		let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
		if (e) {
			for (this.safeFrom = e.openStart ? ES(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? ES(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length;) this.trees.pop(), this.start.pop(), this.index.pop();
			this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
		} else this.nextStart = 1e9;
	}
	nodeAt(e) {
		if (e < this.nextStart) return null;
		for (; this.fragment && this.safeTo <= e;) this.nextFragment();
		if (!this.fragment) return null;
		for (;;) {
			let t = this.trees.length - 1;
			if (t < 0) return this.nextFragment(), null;
			let n = this.trees[t], r = this.index[t];
			if (r == n.children.length) {
				this.trees.pop(), this.start.pop(), this.index.pop();
				continue;
			}
			let i = n.children[r], a = this.start[t] + n.positions[r];
			if (a > e) return this.nextStart = a, null;
			if (i instanceof sp) {
				if (a == e) {
					if (a < this.safeFrom) return null;
					let e = a + i.length;
					if (e <= this.safeTo) {
						let t = i.prop($f.lookAhead);
						if (!t || e + t < this.fragment.to) return i;
					}
				}
				this.index[t]++, a + i.length >= Math.max(this.safeFrom, e) && (this.trees.push(i), this.start.push(a), this.index.push(0));
			} else this.index[t]++, this.nextStart = a + i.length;
		}
	}
}, OS = class {
	constructor(e, t) {
		this.stream = t, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((e) => new hS());
	}
	getActions(e) {
		let t = 0, n = null, { parser: r } = e.p, { tokenizers: i } = r, a = r.stateSlot(e.state, 3), o = e.curContext ? e.curContext.hash : 0, s = 0;
		for (let r = 0; r < i.length; r++) {
			if (!(1 << r & a)) continue;
			let c = i[r], l = this.tokens[r];
			if (!(n && !c.fallback) && ((c.contextual || l.start != e.pos || l.mask != a || l.context != o) && (this.updateCachedToken(l, c, e), l.mask = a, l.context = o), l.lookAhead > l.end + 25 && (s = Math.max(l.lookAhead, s)), l.value != 0)) {
				let r = t;
				if (l.extended > -1 && (t = this.addActions(e, l.extended, l.end, t)), t = this.addActions(e, l.value, l.end, t), !c.extend && (n = l, t > r)) break;
			}
		}
		for (; this.actions.length > t;) this.actions.pop();
		return s && e.setLookAhead(s), !n && e.pos == this.stream.end && (n = new hS(), n.value = e.p.parser.eofTerm, n.start = n.end = e.pos, t = this.addActions(e, n.value, n.end, t)), this.mainToken = n, this.actions;
	}
	getMainToken(e) {
		if (this.mainToken) return this.mainToken;
		let t = new hS(), { pos: n, p: r } = e;
		return t.start = n, t.end = Math.min(n + 1, r.stream.end), t.value = n == r.stream.end ? r.parser.eofTerm : 0, t;
	}
	updateCachedToken(e, t, n) {
		let r = this.stream.clipPos(n.pos);
		if (t.token(this.stream.reset(r, e), n), e.value > -1) {
			let { parser: t } = n.p;
			for (let r = 0; r < t.specialized.length; r++) if (t.specialized[r] == e.value) {
				let i = t.specializers[r](this.stream.read(e.start, e.end), n);
				if (i >= 0 && n.p.parser.dialect.allows(i >> 1)) {
					i & 1 ? e.extended = i >> 1 : e.value = i >> 1;
					break;
				}
			}
		} else e.value = 0, e.end = this.stream.clipPos(r + 1);
	}
	putAction(e, t, n, r) {
		for (let t = 0; t < r; t += 3) if (this.actions[t] == e) return r;
		return this.actions[r++] = e, this.actions[r++] = t, this.actions[r++] = n, r;
	}
	addActions(e, t, n, r) {
		let { state: i } = e, { parser: a } = e.p, { data: o } = a;
		for (let e = 0; e < 2; e++) for (let s = a.stateSlot(i, e ? 2 : 1);; s += 3) {
			if (o[s] == 65535) if (o[s + 1] == 1) s = FS(o, s + 2);
			else {
				r == 0 && o[s + 1] == 2 && (r = this.putAction(FS(o, s + 2), t, n, r));
				break;
			}
			o[s] == t && (r = this.putAction(FS(o, s + 1), t, n, r));
		}
		return r;
	}
}, kS = class {
	constructor(e, t, n, r) {
		this.parser = e, this.input = t, this.ranges = r, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new _S(t, r), this.tokens = new OS(e, this.stream), this.topTerm = e.top[1];
		let { from: i } = r[0];
		this.stacks = [uS.start(this, e.top[0], i)], this.fragments = n.length && this.stream.end - i > e.bufferLength * 4 ? new DS(n, e.nodeSet) : null;
	}
	get parsedPos() {
		return this.minStackPos;
	}
	advance() {
		let e = this.stacks, t = this.minStackPos, n = this.stacks = [], r, i;
		if (this.bigReductionCount > 300 && e.length == 1) {
			let [t] = e;
			for (; t.forceReduce() && t.stack.length && t.stack[t.stack.length - 2] >= this.lastBigReductionStart;);
			this.bigReductionCount = this.lastBigReductionSize = 0;
		}
		for (let a = 0; a < e.length; a++) {
			let o = e[a];
			for (;;) {
				if (this.tokens.mainToken = null, o.pos > t) n.push(o);
				else if (this.advanceStack(o, n, e)) continue;
				else {
					r || (r = [], i = []), r.push(o);
					let e = this.tokens.getMainToken(o);
					i.push(e.value, e.end);
				}
				break;
			}
		}
		if (!n.length) {
			let e = r && IS(r);
			if (e) return wS && console.log("Finish with " + this.stackID(e)), this.stackToTree(e);
			if (this.parser.strict) throw wS && r && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), SyntaxError("No parse at " + t);
			this.recovering ||= 5;
		}
		if (this.recovering && r) {
			let e = this.stoppedAt != null && r[0].pos > this.stoppedAt ? r[0] : this.runRecovery(r, i, n);
			if (e) return wS && console.log("Force-finish " + this.stackID(e)), this.stackToTree(e.forceAll());
		}
		if (this.recovering) {
			let e = this.recovering == 1 ? 1 : this.recovering * 3;
			if (n.length > e) for (n.sort((e, t) => t.score - e.score); n.length > e;) n.pop();
			n.some((e) => e.reducePos > t) && this.recovering--;
		} else if (n.length > 1) {
			outer: for (let e = 0; e < n.length - 1; e++) {
				let t = n[e];
				for (let r = e + 1; r < n.length; r++) {
					let i = n[r];
					if (t.sameState(i) || t.buffer.length > 500 && i.buffer.length > 500) if ((t.score - i.score || t.buffer.length - i.buffer.length) > 0) n.splice(r--, 1);
					else {
						n.splice(e--, 1);
						continue outer;
					}
				}
			}
			n.length > 12 && (n.sort((e, t) => t.score - e.score), n.splice(12, n.length - 12));
		}
		this.minStackPos = n[0].pos;
		for (let e = 1; e < n.length; e++) n[e].pos < this.minStackPos && (this.minStackPos = n[e].pos);
		return null;
	}
	stopAt(e) {
		if (this.stoppedAt != null && this.stoppedAt < e) throw RangeError("Can't move stoppedAt forward");
		this.stoppedAt = e;
	}
	advanceStack(e, t, n) {
		let r = e.pos, { parser: i } = this, a = wS ? this.stackID(e) + " -> " : "";
		if (this.stoppedAt != null && r > this.stoppedAt) return e.forceReduce() ? e : null;
		if (this.fragments) {
			let t = e.curContext && e.curContext.tracker.strict, n = t ? e.curContext.hash : 0;
			for (let o = this.fragments.nodeAt(r); o;) {
				let r = this.parser.nodeSet.types[o.type.id] == o.type ? i.getGoto(e.state, o.type.id) : -1;
				if (r > -1 && o.length && (!t || (o.prop($f.contextHash) || 0) == n)) return e.useNode(o, r), wS && console.log(a + this.stackID(e) + ` (via reuse of ${i.getName(o.type.id)})`), !0;
				if (!(o instanceof sp) || o.children.length == 0 || o.positions[0] > 0) break;
				let s = o.children[0];
				if (s instanceof sp && o.positions[0] == 0) o = s;
				else break;
			}
		}
		let o = i.stateSlot(e.state, 4);
		if (o > 0) return e.reduce(o), wS && console.log(a + this.stackID(e) + ` (via always-reduce ${i.getName(o & 65535)})`), !0;
		if (e.stack.length >= 8400) for (; e.stack.length > 6e3 && e.forceReduce(););
		let s = this.tokens.getActions(e);
		for (let o = 0; o < s.length;) {
			let c = s[o++], l = s[o++], u = s[o++], d = o == s.length || !n, f = d ? e : e.split(), p = this.tokens.mainToken;
			if (f.apply(c, l, p ? p.start : f.pos, u), wS && console.log(a + this.stackID(f) + ` (via ${c & 65536 ? `reduce of ${i.getName(c & 65535)}` : "shift"} for ${i.getName(l)} @ ${r}${f == e ? "" : ", split"})`), d) return !0;
			f.pos > r ? t.push(f) : n.push(f);
		}
		return !1;
	}
	advanceFully(e, t) {
		let n = e.pos;
		for (;;) {
			if (!this.advanceStack(e, null, null)) return !1;
			if (e.pos > n) return AS(e, t), !0;
		}
	}
	runRecovery(e, t, n) {
		let r = null, i = !1;
		for (let a = 0; a < e.length; a++) {
			let o = e[a], s = t[a << 1], c = t[(a << 1) + 1], l = wS ? this.stackID(o) + " -> " : "";
			if (o.deadEnd && (i || (i = !0, o.restart(), wS && console.log(l + this.stackID(o) + " (restarted)"), this.advanceFully(o, n)))) continue;
			let u = o.split(), d = l;
			for (let e = 0; e < 10 && u.forceReduce() && (wS && console.log(d + this.stackID(u) + " (via force-reduce)"), !this.advanceFully(u, n)); e++) wS && (d = this.stackID(u) + " -> ");
			for (let e of o.recoverByInsert(s)) wS && console.log(l + this.stackID(e) + " (via recover-insert)"), this.advanceFully(e, n);
			this.stream.end > o.pos ? (c == o.pos && (c++, s = 0), o.recoverByDelete(s, c), wS && console.log(l + this.stackID(o) + ` (via recover-delete ${this.parser.getName(s)})`), AS(o, n)) : (!r || r.score < u.score) && (r = u);
		}
		return r;
	}
	stackToTree(e) {
		return e.close(), sp.build({
			buffer: pS.create(e),
			nodeSet: this.parser.nodeSet,
			topID: this.topTerm,
			maxBufferLength: this.parser.bufferLength,
			reused: this.reused,
			start: this.ranges[0].from,
			length: e.pos - this.ranges[0].from,
			minRepeatType: this.parser.minRepeatTerm
		});
	}
	stackID(e) {
		let t = (TS ||= /* @__PURE__ */ new WeakMap()).get(e);
		return t || TS.set(e, t = String.fromCodePoint(this.nextStackID++)), t + e;
	}
};
function AS(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (r.pos == e.pos && r.sameState(e)) {
			t[n].score < e.score && (t[n] = e);
			return;
		}
	}
	t.push(e);
}
var jS = class {
	constructor(e, t, n) {
		this.source = e, this.flags = t, this.disabled = n;
	}
	allows(e) {
		return !this.disabled || this.disabled[e] == 0;
	}
}, MS = (e) => e, NS = class {
	constructor(e) {
		this.start = e.start, this.shift = e.shift || MS, this.reduce = e.reduce || MS, this.reuse = e.reuse || MS, this.hash = e.hash || (() => 0), this.strict = e.strict !== !1;
	}
}, PS = class e extends kp {
	constructor(e) {
		if (super(), this.wrappers = [], e.version != 14) throw RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
		let t = e.nodeNames.split(" ");
		this.minRepeatTerm = t.length;
		for (let n = 0; n < e.repeatNodeCount; n++) t.push("");
		let n = Object.keys(e.topRules).map((t) => e.topRules[t][1]), r = [];
		for (let e = 0; e < t.length; e++) r.push([]);
		function i(e, t, n) {
			r[e].push([t, t.deserialize(String(n))]);
		}
		if (e.nodeProps) for (let t of e.nodeProps) {
			let e = t[0];
			typeof e == "string" && (e = $f[e]);
			for (let n = 1; n < t.length;) {
				let r = t[n++];
				if (r >= 0) i(r, e, t[n++]);
				else {
					let a = t[n + -r];
					for (let o = -r; o > 0; o--) i(t[n++], e, a);
					n++;
				}
			}
		}
		this.nodeSet = new rp(t.map((t, i) => np.define({
			name: i >= this.minRepeatTerm ? void 0 : t,
			id: i,
			props: r[i],
			top: n.indexOf(i) > -1,
			error: i == 0,
			skipped: e.skippedNodes && e.skippedNodes.indexOf(i) > -1
		}))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = Xf;
		let a = mS(e.tokenData);
		this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
		for (let e = 0; e < this.specializerSpecs.length; e++) this.specialized[e] = this.specializerSpecs[e].term;
		this.specializers = this.specializerSpecs.map(LS), this.states = mS(e.states, Uint32Array), this.data = mS(e.stateData), this.goto = mS(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((e) => typeof e == "number" ? new vS(a, e) : e), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
	}
	createParse(e, t, n) {
		let r = new kS(this, e, t, n);
		for (let i of this.wrappers) r = i(r, e, t, n);
		return r;
	}
	getGoto(e, t, n = !1) {
		let r = this.goto;
		if (t >= r[0]) return -1;
		for (let i = r[t + 1];;) {
			let t = r[i++], a = t & 1, o = r[i++];
			if (a && n) return o;
			for (let n = i + (t >> 1); i < n; i++) if (r[i] == e) return o;
			if (a) return -1;
		}
	}
	hasAction(e, t) {
		let n = this.data;
		for (let r = 0; r < 2; r++) for (let i = this.stateSlot(e, r ? 2 : 1), a;; i += 3) {
			if ((a = n[i]) == 65535) if (n[i + 1] == 1) a = n[i = FS(n, i + 2)];
			else if (n[i + 1] == 2) return FS(n, i + 2);
			else break;
			if (a == t || a == 0) return FS(n, i + 1);
		}
		return 0;
	}
	stateSlot(e, t) {
		return this.states[e * 6 + t];
	}
	stateFlag(e, t) {
		return (this.stateSlot(e, 0) & t) > 0;
	}
	validAction(e, t) {
		return !!this.allActions(e, (e) => e == t ? !0 : null);
	}
	allActions(e, t) {
		let n = this.stateSlot(e, 4), r = n ? t(n) : void 0;
		for (let n = this.stateSlot(e, 1); r == null; n += 3) {
			if (this.data[n] == 65535) if (this.data[n + 1] == 1) n = FS(this.data, n + 2);
			else break;
			r = t(FS(this.data, n + 1));
		}
		return r;
	}
	nextStates(e) {
		let t = [];
		for (let n = this.stateSlot(e, 1);; n += 3) {
			if (this.data[n] == 65535) if (this.data[n + 1] == 1) n = FS(this.data, n + 2);
			else break;
			if (!(this.data[n + 2] & 1)) {
				let e = this.data[n + 1];
				t.some((t, n) => n & 1 && t == e) || t.push(this.data[n], e);
			}
		}
		return t;
	}
	configure(t) {
		let n = Object.assign(Object.create(e.prototype), this);
		if (t.props && (n.nodeSet = this.nodeSet.extend(...t.props)), t.top) {
			let e = this.topRules[t.top];
			if (!e) throw RangeError(`Invalid top rule name ${t.top}`);
			n.top = e;
		}
		return t.tokenizers && (n.tokenizers = this.tokenizers.map((e) => {
			let n = t.tokenizers.find((t) => t.from == e);
			return n ? n.to : e;
		})), t.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((e, r) => {
			let i = t.specializers.find((t) => t.from == e.external);
			if (!i) return e;
			let a = Object.assign(Object.assign({}, e), { external: i.to });
			return n.specializers[r] = LS(a), a;
		})), t.contextTracker && (n.context = t.contextTracker), t.dialect && (n.dialect = this.parseDialect(t.dialect)), t.strict != null && (n.strict = t.strict), t.wrap && (n.wrappers = n.wrappers.concat(t.wrap)), t.bufferLength != null && (n.bufferLength = t.bufferLength), n;
	}
	hasWrappers() {
		return this.wrappers.length > 0;
	}
	getName(e) {
		return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
	}
	get eofTerm() {
		return this.maxNode + 1;
	}
	get topNode() {
		return this.nodeSet.types[this.top[1]];
	}
	dynamicPrecedence(e) {
		let t = this.dynamicPrecedences;
		return t == null ? 0 : t[e] || 0;
	}
	parseDialect(e) {
		let t = Object.keys(this.dialects), n = t.map(() => !1);
		if (e) for (let r of e.split(" ")) {
			let e = t.indexOf(r);
			e >= 0 && (n[e] = !0);
		}
		let r = null;
		for (let e = 0; e < t.length; e++) if (!n[e]) for (let n = this.dialects[t[e]], i; (i = this.data[n++]) != 65535;) (r ||= new Uint8Array(this.maxTerm + 1))[i] = 1;
		return new jS(e, n, r);
	}
	static deserialize(t) {
		return new e(t);
	}
};
function FS(e, t) {
	return e[t] | e[t + 1] << 16;
}
function IS(e) {
	let t = null;
	for (let n of e) {
		let e = n.p.stoppedAt;
		(n.pos == n.p.stream.end || e != null && n.pos > e) && n.p.parser.stateFlag(n.state, 2) && (!t || t.score < n.score) && (t = n);
	}
	return t;
}
function LS(e) {
	if (e.external) {
		let t = +!!e.extend;
		return (n, r) => e.external(n, r) << 1 | t;
	}
	return e.get;
}
//#endregion
//#region ../../../node_modules/@lezer/json/dist/index.js
var RS = Lp({
	String: Y.string,
	Number: Y.number,
	"True False": Y.bool,
	PropertyName: Y.propertyName,
	Null: Y.null,
	", :": Y.separator,
	"[ ]": Y.squareBracket,
	"{ }": Y.brace
}), zS = PS.deserialize({
	version: 14,
	states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
	stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
	goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
	nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
	maxTerm: 25,
	nodeProps: [
		[
			"isolate",
			-2,
			6,
			11,
			""
		],
		[
			"openedBy",
			7,
			"{",
			14,
			"["
		],
		[
			"closedBy",
			8,
			"}",
			15,
			"]"
		]
	],
	propSources: [RS],
	skippedNodes: [0],
	repeatNodeCount: 2,
	tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
	tokenizers: [0],
	topRules: { JsonText: [0, 1] },
	tokenPrec: 0
}), BS = () => (e) => {
	try {
		JSON.parse(e.state.doc.toString());
	} catch (t) {
		if (!(t instanceof SyntaxError)) throw t;
		let n = VS(t, e.state.doc);
		return [{
			from: n,
			message: t.message,
			severity: "error",
			to: n
		}];
	}
	return [];
};
function VS(e, t) {
	let n;
	return (n = e.message.match(/at position (\d+)/)) ? Math.min(+n[1], t.length) : (n = e.message.match(/at line (\d+) column (\d+)/)) ? Math.min(t.line(+n[1]).from + +n[2] - 1, t.length) : 0;
}
var HS = /*@__PURE__*/ um.define({
	name: "json",
	parser: /*@__PURE__*/ zS.configure({ props: [/*@__PURE__*/ Om.add({
		Object: /*@__PURE__*/ Bm({ except: /^\s*\}/ }),
		Array: /*@__PURE__*/ Bm({ except: /^\s*\]/ })
	}), /*@__PURE__*/ Wm.add({ "Object Array": Gm })] }),
	languageData: {
		closeBrackets: { brackets: [
			"[",
			"{",
			"\""
		] },
		indentOnInput: /^\s*[\}\]]$/
	}
});
function US() {
	return new xm(HS);
}
//#endregion
//#region ../../../node_modules/@lezer/javascript/dist/index.js
var WS = 316, GS = 317, KS = 1, qS = 2, JS = 3, YS = 4, XS = 318, ZS = 320, QS = 321, $S = 5, eC = 6, tC = 0, nC = [
	9,
	10,
	11,
	12,
	13,
	32,
	133,
	160,
	5760,
	8192,
	8193,
	8194,
	8195,
	8196,
	8197,
	8198,
	8199,
	8200,
	8201,
	8202,
	8232,
	8233,
	8239,
	8287,
	12288
], rC = 125, iC = 59, aC = 47, oC = 42, sC = 43, cC = 45, lC = 60, uC = 44, dC = 63, fC = 46, pC = 91, mC = new NS({
	start: !1,
	shift(e, t) {
		return t == $S || t == eC || t == ZS ? e : t == QS;
	},
	strict: !1
}), hC = new bS((e, t) => {
	let { next: n } = e;
	(n == rC || n == -1 || t.context) && e.acceptToken(XS);
}, {
	contextual: !0,
	fallback: !0
}), gC = new bS((e, t) => {
	let { next: n } = e, r;
	nC.indexOf(n) > -1 || n == aC && ((r = e.peek(1)) == aC || r == oC) || n != rC && n != iC && n != -1 && !t.context && e.acceptToken(WS);
}, { contextual: !0 }), _C = new bS((e, t) => {
	e.next == pC && !t.context && e.acceptToken(GS);
}, { contextual: !0 }), vC = new bS((e, t) => {
	let { next: n } = e;
	if (n == sC || n == cC) {
		if (e.advance(), n == e.next) {
			e.advance();
			let n = !t.context && t.canShift(KS);
			e.acceptToken(n ? KS : qS);
		}
	} else n == dC && e.peek(1) == fC && (e.advance(), e.advance(), (e.next < 48 || e.next > 57) && e.acceptToken(JS));
}, { contextual: !0 });
function yC(e, t) {
	return e >= 65 && e <= 90 || e >= 97 && e <= 122 || e == 95 || e >= 192 || !t && e >= 48 && e <= 57;
}
var bC = new bS((e, t) => {
	if (e.next != lC || !t.dialectEnabled(tC) || (e.advance(), e.next == aC)) return;
	let n = 0;
	for (; nC.indexOf(e.next) > -1;) e.advance(), n++;
	if (yC(e.next, !0)) {
		for (e.advance(), n++; yC(e.next, !1);) e.advance(), n++;
		for (; nC.indexOf(e.next) > -1;) e.advance(), n++;
		if (e.next == uC) return;
		for (let t = 0;; t++) {
			if (t == 7) {
				if (!yC(e.next, !0)) return;
				break;
			}
			if (e.next != "extends".charCodeAt(t)) break;
			e.advance(), n++;
		}
	}
	e.acceptToken(YS, -n);
}), xC = Lp({
	"get set async static": Y.modifier,
	"for while do if else switch try catch finally return throw break continue default case defer": Y.controlKeyword,
	"in of await yield void typeof delete instanceof as satisfies": Y.operatorKeyword,
	"let var const using function class extends": Y.definitionKeyword,
	"import export from": Y.moduleKeyword,
	"with debugger new": Y.keyword,
	TemplateString: Y.special(Y.string),
	super: Y.atom,
	BooleanLiteral: Y.bool,
	this: Y.self,
	null: Y.null,
	Star: Y.modifier,
	VariableName: Y.variableName,
	"CallExpression/VariableName TaggedTemplateExpression/VariableName": Y.function(Y.variableName),
	VariableDefinition: Y.definition(Y.variableName),
	Label: Y.labelName,
	PropertyName: Y.propertyName,
	PrivatePropertyName: Y.special(Y.propertyName),
	"CallExpression/MemberExpression/PropertyName": Y.function(Y.propertyName),
	"FunctionDeclaration/VariableDefinition": Y.function(Y.definition(Y.variableName)),
	"ClassDeclaration/VariableDefinition": Y.definition(Y.className),
	"NewExpression/VariableName": Y.className,
	PropertyDefinition: Y.definition(Y.propertyName),
	PrivatePropertyDefinition: Y.definition(Y.special(Y.propertyName)),
	UpdateOp: Y.updateOperator,
	"LineComment Hashbang": Y.lineComment,
	BlockComment: Y.blockComment,
	Number: Y.number,
	String: Y.string,
	Escape: Y.escape,
	ArithOp: Y.arithmeticOperator,
	LogicOp: Y.logicOperator,
	BitOp: Y.bitwiseOperator,
	CompareOp: Y.compareOperator,
	RegExp: Y.regexp,
	Equals: Y.definitionOperator,
	Arrow: Y.function(Y.punctuation),
	": Spread": Y.punctuation,
	"( )": Y.paren,
	"[ ]": Y.squareBracket,
	"{ }": Y.brace,
	"InterpolationStart InterpolationEnd": Y.special(Y.brace),
	".": Y.derefOperator,
	", ;": Y.separator,
	"@": Y.meta,
	TypeName: Y.typeName,
	TypeDefinition: Y.definition(Y.typeName),
	"type enum interface implements namespace module declare": Y.definitionKeyword,
	"abstract global Privacy readonly override": Y.modifier,
	"is keyof unique infer asserts": Y.operatorKeyword,
	JSXAttributeValue: Y.attributeValue,
	JSXText: Y.content,
	"JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": Y.angleBracket,
	"JSXIdentifier JSXNameSpacedName": Y.tagName,
	"JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": Y.attributeName,
	"JSXBuiltin/JSXIdentifier": Y.standard(Y.tagName)
}), SC = {
	__proto__: null,
	export: 20,
	as: 25,
	from: 33,
	default: 36,
	async: 41,
	function: 42,
	in: 52,
	out: 55,
	const: 56,
	extends: 60,
	this: 64,
	true: 72,
	false: 72,
	null: 84,
	void: 88,
	typeof: 92,
	super: 108,
	new: 142,
	delete: 154,
	yield: 163,
	await: 167,
	class: 172,
	public: 235,
	private: 235,
	protected: 235,
	readonly: 237,
	instanceof: 256,
	satisfies: 259,
	import: 292,
	keyof: 349,
	unique: 353,
	infer: 359,
	asserts: 395,
	is: 397,
	abstract: 417,
	implements: 419,
	type: 421,
	let: 424,
	var: 426,
	using: 429,
	interface: 435,
	enum: 439,
	namespace: 445,
	module: 447,
	declare: 451,
	global: 455,
	defer: 471,
	for: 476,
	of: 485,
	while: 488,
	with: 492,
	do: 496,
	if: 500,
	else: 502,
	switch: 506,
	case: 512,
	try: 518,
	catch: 522,
	finally: 526,
	return: 530,
	throw: 534,
	break: 538,
	continue: 542,
	debugger: 546
}, CC = {
	__proto__: null,
	async: 129,
	get: 131,
	set: 133,
	declare: 195,
	public: 197,
	private: 197,
	protected: 197,
	static: 199,
	abstract: 201,
	override: 203,
	readonly: 209,
	accessor: 211,
	new: 401
}, wC = {
	__proto__: null,
	"<": 193
}, TC = PS.deserialize({
	version: 14,
	states: "$F|Q%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#DaO.QQlO'#DgO.bQlO'#DrO%[QlO'#DzO0fQlO'#ESOOQ!0Lf'#E['#E[O1PQ`O'#EXOOQO'#Ep'#EpOOQO'#Il'#IlO1XQ`O'#GsO1dQ`O'#EoO1iQ`O'#EoO3hQ!0MxO'#JrO6[Q!0MxO'#JsO6uQ`O'#F]O6zQ,UO'#FtOOQ!0Lf'#Ff'#FfO7VO7dO'#FfO9XQMhO'#F|O9`Q`O'#F{OOQ!0Lf'#Js'#JsOOQ!0Lb'#Jr'#JrO9eQ`O'#GwOOQ['#K_'#K_O9pQ`O'#IYO9uQ!0LrO'#IZOOQ['#J`'#J`OOQ['#I_'#I_Q`QlOOQ`QlOOO9}Q!L^O'#DvO:UQlO'#EOO:]QlO'#EQO9kQ`O'#GsO:dQMhO'#CoO:rQ`O'#EnO:}Q`O'#EyO;hQMhO'#FeO;xQ`O'#GsOOQO'#K`'#K`O;}Q`O'#K`O<]Q`O'#G{O<]Q`O'#G|O<]Q`O'#HOO9kQ`O'#HRO=SQ`O'#HUO>kQ`O'#CeO>{Q`O'#HcO?TQ`O'#HiO?TQ`O'#HkO`QlO'#HmO?TQ`O'#HoO?TQ`O'#HrO?YQ`O'#HxO?_Q!0LsO'#IOO%[QlO'#IQO?jQ!0LsO'#ISO?uQ!0LsO'#IUO9uQ!0LrO'#IWO@QQ!0MxO'#CiOASQpO'#DlQOQ`OOO%[QlO'#EQOAjQ`O'#ETO:dQMhO'#EnOAuQ`O'#EnOBQQ!bO'#FeOOQ['#Cg'#CgOOQ!0Lb'#Dq'#DqOOQ!0Lb'#Jv'#JvO%[QlO'#JvOOQO'#Jy'#JyOOQO'#Ih'#IhOCQQpO'#EgOOQ!0Lb'#Ef'#EfOOQ!0Lb'#J}'#J}OC|Q!0MSO'#EgODWQpO'#EWOOQO'#Jx'#JxODlQpO'#JyOEyQpO'#EWODWQpO'#EgPFWO&2DjO'#CbPOOO)CD})CD}OOOO'#I`'#I`OFcO#tO,59UOOQ!0Lh,59U,59UOOOO'#Ia'#IaOFqO&jO,59UOGPQ!L^O'#DcOOOO'#Ic'#IcOGWO#@ItO,59{OOQ!0Lf,59{,59{OGfQlO'#IdOGyQ`O'#JtOIxQ!fO'#JtO+}QlO'#JtOJPQ`O,5:ROJgQ`O'#EpOJtQ`O'#KTOKPQ`O'#KSOKPQ`O'#KSOKXQ`O,5;^OK^Q`O'#KROOQ!0Ln,5:^,5:^OKeQlO,5:^OMcQ!0MxO,5:fONSQ`O,5:nONmQ!0LrO'#KQONtQ`O'#KPO9eQ`O'#KPO! YQ`O'#KPO! bQ`O,5;]O! gQ`O'#KPO!#lQ!fO'#JsOOQ!0Lh'#Ci'#CiO%[QlO'#ESO!$[Q!fO,5:sOOQS'#Jz'#JzOOQO-E<j-E<jO9kQ`O,5=_O!$rQ`O,5=_O!$wQlO,5;ZO!&zQMhO'#EkO!(eQ`O,5;ZO!(jQlO'#DyO!(tQpO,5;dO!(|QpO,5;dO%[QlO,5;dOOQ['#FT'#FTOOQ['#FV'#FVO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eO%[QlO,5;eOOQ['#FZ'#FZO!)[QlO,5;tOOQ!0Lf,5;y,5;yOOQ!0Lf,5;z,5;zOOQ!0Lf,5;|,5;|O%[QlO'#IpO!+_Q!0LrO,5<iO%[QlO,5;eO!&zQMhO,5;eO!+|QMhO,5;eO!-nQMhO'#E^O%[QlO,5;wOOQ!0Lf,5;{,5;{O!-uQ,UO'#FjO!.rQ,UO'#KXO!.^Q,UO'#KXO!.yQ,UO'#KXOOQO'#KX'#KXO!/_Q,UO,5<SOOOW,5<`,5<`O!/pQlO'#FvOOOW'#Io'#IoO7VO7dO,5<QO!/wQ,UO'#FxOOQ!0Lf,5<Q,5<QO!0hQ$IUO'#CyOOQ!0Lh'#C}'#C}O!0{O#@ItO'#DRO!1iQMjO,5<eO!1pQ`O,5<hO!3YQ(CWO'#GXO!3jQ`O'#GYO!3oQ`O'#GYO!5_Q(CWO'#G^O!6dQpO'#GbOOQO'#Gn'#GnO!,TQMhO'#GmOOQO'#Gp'#GpO!,TQMhO'#GoO!7VQ$IUO'#JlOOQ!0Lh'#Jl'#JlO!7aQ`O'#JkO!7oQ`O'#JjO!7wQ`O'#CuOOQ!0Lh'#C{'#C{O!8YQ`O'#C}OOQ!0Lh'#DV'#DVOOQ!0Lh'#DX'#DXO!8_Q`O,5<eO1SQ`O'#DZO!,TQMhO'#GPO!,TQMhO'#GRO!8gQ`O'#GTO!8lQ`O'#GUO!3oQ`O'#G[O!,TQMhO'#GaO<]Q`O'#JkO!8qQ`O'#EqO!9`Q`O,5<gOOQ!0Lb'#Cr'#CrO!9hQ`O'#ErO!:bQpO'#EsOOQ!0Lb'#KR'#KRO!:iQ!0LrO'#KaO9uQ!0LrO,5=cO`QlO,5>tOOQ['#Jh'#JhOOQ[,5>u,5>uOOQ[-E<]-E<]O!<hQ!0MxO,5:bO!:]QpO,5:`O!?RQ!0MxO,5:jO%[QlO,5:jO!AiQ!0MxO,5:lOOQO,5@z,5@zO!BYQMhO,5=_O!BhQ!0LrO'#JiO9`Q`O'#JiO!ByQ!0LrO,59ZO!CUQpO,59ZO!C^QMhO,59ZO:dQMhO,59ZO!CiQ`O,5;ZO!CqQ`O'#HbO!DVQ`O'#KdO%[QlO,5;}O!:]QpO,5<PO!D_Q`O,5=zO!DdQ`O,5=zO!DiQ`O,5=zO!DwQ`O,5=zO9uQ!0LrO,5=zO<]Q`O,5=jOOQO'#Cy'#CyO!EOQpO,5=gO!EWQMhO,5=hO!EcQ`O,5=jO!EhQ!bO,5=mO!EpQ`O'#K`O?YQ`O'#HWO9kQ`O'#HYO!EuQ`O'#HYO:dQMhO'#H[O!EzQ`O'#H[OOQ[,5=p,5=pO!FPQ`O'#H]O!FbQ`O'#CoO!FgQ`O,59PO!FqQ`O,59PO!HvQlO,59POOQ[,59P,59PO!IWQ!0LrO,59PO%[QlO,59PO!KcQlO'#HeOOQ['#Hf'#HfOOQ['#Hg'#HgO`QlO,5=}O!KyQ`O,5=}O`QlO,5>TO`QlO,5>VO!LOQ`O,5>XO`QlO,5>ZO!LTQ`O,5>^O!LYQlO,5>dOOQ[,5>j,5>jO%[QlO,5>jO9uQ!0LrO,5>lOOQ[,5>n,5>nO#!dQ`O,5>nOOQ[,5>p,5>pO#!dQ`O,5>pOOQ[,5>r,5>rO##QQpO'#D_O%[QlO'#JvO##sQpO'#JvO##}QpO'#DmO#$`QpO'#DmO#&qQlO'#DmO#&xQ`O'#JuO#'QQ`O,5:WO#'VQ`O'#EtO#'eQ`O'#KUO#'mQ`O,5;_O#'rQpO'#DmO#(PQpO'#EVOOQ!0Lf,5:o,5:oO%[QlO,5:oO#(WQ`O,5:oO?YQ`O,5;YO!CUQpO,5;YO!C^QMhO,5;YO:dQMhO,5;YO#(`Q`O,5@bO#(eQ07dO,5:sOOQO-E<f-E<fO#)kQ!0MSO,5;RODWQpO,5:rO#)uQpO,5:rODWQpO,5;RO!ByQ!0LrO,5:rOOQ!0Lb'#Ej'#EjOOQO,5;R,5;RO%[QlO,5;RO#*SQ!0LrO,5;RO#*_Q!0LrO,5;RO!CUQpO,5:rOOQO,5;X,5;XO#*mQ!0LrO,5;RPOOO'#I^'#I^P#+RO&2DjO,58|POOO,58|,58|OOOO-E<^-E<^OOQ!0Lh1G.p1G.pOOOO-E<_-E<_OOOO,59},59}O#+^Q!bO,59}OOOO-E<a-E<aOOQ!0Lf1G/g1G/gO#+cQ!fO,5?OO+}QlO,5?OOOQO,5?U,5?UO#+mQlO'#IdOOQO-E<b-E<bO#+zQ`O,5@`O#,SQ!fO,5@`O#,ZQ`O,5@nOOQ!0Lf1G/m1G/mO%[QlO,5@oO#,cQ`O'#IjOOQO-E<h-E<hO#,ZQ`O,5@nOOQ!0Lb1G0x1G0xOOQ!0Ln1G/x1G/xOOQ!0Ln1G0Y1G0YO%[QlO,5@lO#,wQ!0LrO,5@lO#-YQ!0LrO,5@lO#-aQ`O,5@kO9eQ`O,5@kO#-iQ`O,5@kO#-wQ`O'#ImO#-aQ`O,5@kOOQ!0Lb1G0w1G0wO!(tQpO,5:uO!)PQpO,5:uOOQS,5:w,5:wO#.iQdO,5:wO#.qQMhO1G2yO9kQ`O1G2yOOQ!0Lf1G0u1G0uO#/PQ!0MxO1G0uO#0UQ!0MvO,5;VOOQ!0Lh'#GW'#GWO#0rQ!0MzO'#JlO!$wQlO1G0uO#2}Q!fO'#JwO%[QlO'#JwO#3XQ`O,5:eOOQ!0Lh'#D_'#D_OOQ!0Lf1G1O1G1OO%[QlO1G1OOOQ!0Lf1G1f1G1fO#3^Q`O1G1OO#5rQ!0MxO1G1PO#5yQ!0MxO1G1PO#8aQ!0MxO1G1PO#8hQ!0MxO1G1PO#;OQ!0MxO1G1PO#=fQ!0MxO1G1PO#=mQ!0MxO1G1PO#=tQ!0MxO1G1PO#@[Q!0MxO1G1PO#@cQ!0MxO1G1PO#BpQ?MtO'#CiO#DkQ?MtO1G1`O#DrQ?MtO'#JsO#EVQ!0MxO,5?[OOQ!0Lb-E<n-E<nO#GdQ!0MxO1G1PO#HaQ!0MzO1G1POOQ!0Lf1G1P1G1PO#IdQMjO'#J|O#InQ`O,5:xO#IsQ!0MxO1G1cO#JgQ,UO,5<WO#JoQ,UO,5<XO#JwQ,UO'#FoO#K`Q`O'#FnOOQO'#KY'#KYOOQO'#In'#InO#KeQ,UO1G1nOOQ!0Lf1G1n1G1nOOOW1G1y1G1yO#KvQ?MtO'#JrO#LQQ`O,5<bO!)[QlO,5<bOOOW-E<m-E<mOOQ!0Lf1G1l1G1lO#LVQpO'#KXOOQ!0Lf,5<d,5<dO#L_QpO,5<dO#LdQMhO'#DTOOOO'#Ib'#IbO#LkO#@ItO,59mOOQ!0Lh,59m,59mO%[QlO1G2PO!8lQ`O'#IrO#LvQ`O,5<zOOQ!0Lh,5<w,5<wO!,TQMhO'#IuO#MdQMjO,5=XO!,TQMhO'#IwO#NVQMjO,5=ZO!&zQMhO,5=]OOQO1G2S1G2SO#NaQ!dO'#CrO#NtQ(CWO'#ErO$ |QpO'#GbO$!dQ!dO,5<sO$!kQ`O'#K[O9eQ`O'#K[O$!yQ`O,5<uO$#aQ!dO'#C{O!,TQMhO,5<tO$#kQ`O'#GZO$$PQ`O,5<tO$$UQ!dO'#GWO$$cQ!dO'#K]O$$mQ`O'#K]O!&zQMhO'#K]O$$rQ`O,5<xO$$wQlO'#JvO$%RQpO'#GcO#$`QpO'#GcO$%dQ`O'#GgO!3oQ`O'#GkO$%iQ!0LrO'#ItO$%tQpO,5<|OOQ!0Lp,5<|,5<|O$%{QpO'#GcO$&YQpO'#GdO$&kQpO'#GdO$&pQMjO,5=XO$'QQMjO,5=ZOOQ!0Lh,5=^,5=^O!,TQMhO,5@VO!,TQMhO,5@VO$'bQ`O'#IyO$'vQ`O,5@UO$(OQ`O,59aOOQ!0Lh,59i,59iO$(TQ`O,5@VO$)TQ$IYO,59uOOQ!0Lh'#Jp'#JpO$)vQMjO,5<kO$*iQMjO,5<mO@zQ`O,5<oOOQ!0Lh,5<p,5<pO$*sQ`O,5<vO$*xQMjO,5<{O$+YQ`O'#KPO!$wQlO1G2RO$+_Q`O1G2RO9eQ`O'#KSO9eQ`O'#EtO%[QlO'#EtO9eQ`O'#I{O$+dQ!0LrO,5@{OOQ[1G2}1G2}OOQ[1G4`1G4`OOQ!0Lf1G/|1G/|OOQ!0Lf1G/z1G/zO$-fQ!0MxO1G0UOOQ[1G2y1G2yO!&zQMhO1G2yO%[QlO1G2yO#.tQ`O1G2yO$/jQMhO'#EkOOQ!0Lb,5@T,5@TO$/wQ!0LrO,5@TOOQ[1G.u1G.uO!ByQ!0LrO1G.uO!CUQpO1G.uO!C^QMhO1G.uO$0YQ`O1G0uO$0_Q`O'#CiO$0jQ`O'#KeO$0rQ`O,5=|O$0wQ`O'#KeO$0|Q`O'#KeO$1[Q`O'#JRO$1jQ`O,5AOO$1rQ!fO1G1iOOQ!0Lf1G1k1G1kO9kQ`O1G3fO@zQ`O1G3fO$1yQ`O1G3fO$2OQ`O1G3fO!DiQ`O1G3fO9uQ!0LrO1G3fOOQ[1G3f1G3fO!EcQ`O1G3UO!&zQMhO1G3RO$2TQ`O1G3ROOQ[1G3S1G3SO!&zQMhO1G3SO$2YQ`O1G3SO$2bQpO'#HQOOQ[1G3U1G3UO!6_QpO'#I}O!EhQ!bO1G3XOOQ[1G3X1G3XOOQ[,5=r,5=rO$2jQMhO,5=tO9kQ`O,5=tO$%dQ`O,5=vO9`Q`O,5=vO!CUQpO,5=vO!C^QMhO,5=vO:dQMhO,5=vO$2xQ`O'#KcO$3TQ`O,5=wOOQ[1G.k1G.kO$3YQ!0LrO1G.kO@zQ`O1G.kO$3eQ`O1G.kO9uQ!0LrO1G.kO$5mQ!fO,5AQO$5zQ`O,5AQO9eQ`O,5AQO$6VQlO,5>PO$6^Q`O,5>POOQ[1G3i1G3iO`QlO1G3iOOQ[1G3o1G3oOOQ[1G3q1G3qO?TQ`O1G3sO$6cQlO1G3uO$:gQlO'#HtOOQ[1G3x1G3xO$:tQ`O'#HzO?YQ`O'#H|OOQ[1G4O1G4OO$:|QlO1G4OO9uQ!0LrO1G4UOOQ[1G4W1G4WOOQ!0Lb'#G_'#G_O9uQ!0LrO1G4YO9uQ!0LrO1G4[O$?TQ`O,5@bO!)[QlO,5;`O9eQ`O,5;`O?YQ`O,5:XO!)[QlO,5:XO!CUQpO,5:XO$?YQ?MtO,5:XOOQO,5;`,5;`O$?dQpO'#IeO$?zQ`O,5@aOOQ!0Lf1G/r1G/rO$@SQpO'#IkO$@^Q`O,5@pOOQ!0Lb1G0y1G0yO#$`QpO,5:XOOQO'#Ig'#IgO$@fQpO,5:qOOQ!0Ln,5:q,5:qO#(ZQ`O1G0ZOOQ!0Lf1G0Z1G0ZO%[QlO1G0ZOOQ!0Lf1G0t1G0tO?YQ`O1G0tO!CUQpO1G0tO!C^QMhO1G0tOOQ!0Lb1G5|1G5|O!ByQ!0LrO1G0^OOQO1G0m1G0mO%[QlO1G0mO$@mQ!0LrO1G0mO$@xQ!0LrO1G0mO!CUQpO1G0^ODWQpO1G0^O$AWQ!0LrO1G0mOOQO1G0^1G0^O$AlQ!0MxO1G0mPOOO-E<[-E<[POOO1G.h1G.hOOOO1G/i1G/iO$AvQ!bO,5<iO$BOQ!fO1G4jOOQO1G4p1G4pO%[QlO,5?OO$BYQ`O1G5zO$BbQ`O1G6YO$BjQ!fO1G6ZO9eQ`O,5?UO$BtQ!0MxO1G6WO%[QlO1G6WO$CUQ!0LrO1G6WO$CgQ`O1G6VO$CgQ`O1G6VO9eQ`O1G6VO$CoQ`O,5?XO9eQ`O,5?XOOQO,5?X,5?XO$DTQ`O,5?XO$+YQ`O,5?XOOQO-E<k-E<kOOQS1G0a1G0aOOQS1G0c1G0cO#.lQ`O1G0cOOQ[7+(e7+(eO!&zQMhO7+(eO%[QlO7+(eO$DcQ`O7+(eO$DnQMhO7+(eO$D|Q!0MzO,5=XO$GXQ!0MzO,5=ZO$IdQ!0MzO,5=XO$KuQ!0MzO,5=ZO$NWQ!0MzO,59uO%!]Q!0MzO,5<kO%$hQ!0MzO,5<mO%&sQ!0MzO,5<{OOQ!0Lf7+&a7+&aO%)UQ!0MxO7+&aO%)xQlO'#IfO%*VQ`O,5@cO%*_Q!fO,5@cOOQ!0Lf1G0P1G0PO%*iQ`O7+&jOOQ!0Lf7+&j7+&jO%*nQ?MtO,5:fO%[QlO7+&zO%*xQ?MtO,5:bO%+VQ?MtO,5:jO%+aQ?MtO,5:lO%+kQMhO'#IiO%+uQ`O,5@hOOQ!0Lh1G0d1G0dOOQO1G1r1G1rOOQO1G1s1G1sO%+}Q!jO,5<ZO!)[QlO,5<YOOQO-E<l-E<lOOQ!0Lf7+'Y7+'YOOOW7+'e7+'eOOOW1G1|1G1|O%,YQ`O1G1|OOQ!0Lf1G2O1G2OOOOO,59o,59oO%,_Q!dO,59oOOOO-E<`-E<`OOQ!0Lh1G/X1G/XO%,fQ!0MxO7+'kOOQ!0Lh,5?^,5?^O%-YQMhO1G2fP%-aQ`O'#IrPOQ!0Lh-E<p-E<pO%-}QMjO,5?aOOQ!0Lh-E<s-E<sO%.pQMjO,5?cOOQ!0Lh-E<u-E<uO%.zQ!dO1G2wO%/RQ!dO'#CrO%/iQMhO'#KSO$$wQlO'#JvOOQ!0Lh1G2_1G2_O%/sQ`O'#IqO%0[Q`O,5@vO%0[Q`O,5@vO%0dQ`O,5@vO%0oQ`O,5@vOOQO1G2a1G2aO%0}QMjO1G2`O$+YQ`O'#K[O!,TQMhO1G2`O%1_Q(CWO'#IsO%1lQ`O,5@wO!&zQMhO,5@wO%1tQ!dO,5@wOOQ!0Lh1G2d1G2dO%4UQ!fO'#CiO%4`Q`O,5=POOQ!0Lb,5<},5<}O%4hQpO,5<}OOQ!0Lb,5=O,5=OOCwQ`O,5<}O%4sQpO,5<}OOQ!0Lb,5=R,5=RO$+YQ`O,5=VOOQO,5?`,5?`OOQO-E<r-E<rOOQ!0Lp1G2h1G2hO#$`QpO,5<}O$$wQlO,5=PO%5RQ`O,5=OO%5^QpO,5=OO!,TQMhO'#IuO%6WQMjO1G2sO!,TQMhO'#IwO%6yQMjO1G2uO%7TQMjO1G5qO%7_QMjO1G5qOOQO,5?e,5?eOOQO-E<w-E<wOOQO1G.{1G.{O!,TQMhO1G5qO!,TQMhO1G5qO!:]QpO,59wO%[QlO,59wOOQ!0Lh,5<j,5<jO%7lQ`O1G2ZO!,TQMhO1G2bO%7qQ!0MxO7+'mOOQ!0Lf7+'m7+'mO!$wQlO7+'mO%8eQ`O,5;`OOQ!0Lb,5?g,5?gOOQ!0Lb-E<y-E<yO%8jQ!dO'#K^O#(ZQ`O7+(eO4UQ!fO7+(eO$DfQ`O7+(eO%8tQ!0MvO'#CiO%9XQ!0MvO,5=SO%9lQ`O,5=SO%9tQ`O,5=SOOQ!0Lb1G5o1G5oOOQ[7+$a7+$aO!ByQ!0LrO7+$aO!CUQpO7+$aO!$wQlO7+&aO%9yQ`O'#JQO%:bQ`O,5APOOQO1G3h1G3hO9kQ`O,5APO%:bQ`O,5APO%:jQ`O,5APOOQO,5?m,5?mOOQO-E=P-E=POOQ!0Lf7+'T7+'TO%:oQ`O7+)QO9uQ!0LrO7+)QO9kQ`O7+)QO@zQ`O7+)QO%:tQ`O7+)QOOQ[7+)Q7+)QOOQ[7+(p7+(pO%:yQ!0MvO7+(mO!&zQMhO7+(mO!E^Q`O7+(nOOQ[7+(n7+(nO!&zQMhO7+(nO%;TQ`O'#KbO%;`Q`O,5=lOOQO,5?i,5?iOOQO-E<{-E<{OOQ[7+(s7+(sO%<rQpO'#HZOOQ[1G3`1G3`O!&zQMhO1G3`O%[QlO1G3`O%<yQ`O1G3`O%=UQMhO1G3`O9uQ!0LrO1G3bO$%dQ`O1G3bO9`Q`O1G3bO!CUQpO1G3bO!C^QMhO1G3bO%=dQ`O'#JPO%=xQ`O,5@}O%>QQpO,5@}OOQ!0Lb1G3c1G3cOOQ[7+$V7+$VO@zQ`O7+$VO9uQ!0LrO7+$VO%>]Q`O7+$VO%[QlO1G6lO%[QlO1G6mO%>bQ!0LrO1G6lO%>lQlO1G3kO%>sQ`O1G3kO%>xQlO1G3kOOQ[7+)T7+)TO9uQ!0LrO7+)_O`QlO7+)aOOQ['#Kh'#KhOOQ['#JS'#JSO%?PQlO,5>`OOQ[,5>`,5>`O%[QlO'#HuO%?^Q`O'#HwOOQ[,5>f,5>fO9eQ`O,5>fOOQ[,5>h,5>hOOQ[7+)j7+)jOOQ[7+)p7+)pOOQ[7+)t7+)tOOQ[7+)v7+)vO%?cQpO1G5|O%?}Q?MtO1G0zO%@XQ`O1G0zOOQO1G/s1G/sO%@dQ?MtO1G/sO?YQ`O1G/sO!)[QlO'#DmOOQO,5?P,5?POOQO-E<c-E<cOOQO,5?V,5?VOOQO-E<i-E<iO!CUQpO1G/sOOQO-E<e-E<eOOQ!0Ln1G0]1G0]OOQ!0Lf7+%u7+%uO#(ZQ`O7+%uOOQ!0Lf7+&`7+&`O?YQ`O7+&`O!CUQpO7+&`OOQO7+%x7+%xO$AlQ!0MxO7+&XOOQO7+&X7+&XO%[QlO7+&XO%@nQ!0LrO7+&XO!ByQ!0LrO7+%xO!CUQpO7+%xO%@yQ!0LrO7+&XO%AXQ!0MxO7++rO%[QlO7++rO%AiQ`O7++qO%AiQ`O7++qOOQO1G4s1G4sO9eQ`O1G4sO%AqQ`O1G4sOOQS7+%}7+%}O#(ZQ`O<<LPO4UQ!fO<<LPO%BPQ`O<<LPOOQ[<<LP<<LPO!&zQMhO<<LPO%[QlO<<LPO%BXQ`O<<LPO%BdQ!0MzO,5?aO%DoQ!0MzO,5?cO%FzQ!0MzO1G2`O%I]Q!0MzO1G2sO%KhQ!0MzO1G2uO%MsQ!fO,5?QO%[QlO,5?QOOQO-E<d-E<dO%M}Q`O1G5}OOQ!0Lf<<JU<<JUO%NVQ?MtO1G0uO&!^Q?MtO1G1PO&!eQ?MtO1G1PO&$fQ?MtO1G1PO&$mQ?MtO1G1PO&&nQ?MtO1G1PO&(oQ?MtO1G1PO&(vQ?MtO1G1PO&(}Q?MtO1G1PO&+OQ?MtO1G1PO&+VQ?MtO1G1PO&+^Q!0MxO<<JfO&-UQ?MtO1G1PO&.RQ?MvO1G1PO&/UQ?MvO'#JlO&1[Q?MtO1G1cO&1iQ?MtO1G0UO&1sQMjO,5?TOOQO-E<g-E<gO!)[QlO'#FqOOQO'#KZ'#KZOOQO1G1u1G1uO&1}Q`O1G1tO&2SQ?MtO,5?[OOOW7+'h7+'hOOOO1G/Z1G/ZO&2^Q!dO1G4xOOQ!0Lh7+(Q7+(QP!&zQMhO,5?^O!,TQMhO7+(cO&2eQ`O,5?]O9eQ`O,5?]O$+YQ`O,5?]OOQO-E<o-E<oO&2sQ`O1G6bO&2sQ`O1G6bO&2{Q`O1G6bO&3WQMjO7+'zO&3hQ!dO,5?_O&3rQ`O,5?_O!&zQMhO,5?_OOQO-E<q-E<qO&3wQ!dO1G6cO&4RQ`O1G6cO&4ZQ`O1G2kO!&zQMhO1G2kOOQ!0Lb1G2i1G2iOOQ!0Lb1G2j1G2jO%4hQpO1G2iO!CUQpO1G2iOCwQ`O1G2iOOQ!0Lb1G2q1G2qO&4`QpO1G2iO&4nQ`O1G2kO$+YQ`O1G2jOCwQ`O1G2jO$$wQlO1G2kO&4vQ`O1G2jO&5jQMjO,5?aOOQ!0Lh-E<t-E<tO&6]QMjO,5?cOOQ!0Lh-E<v-E<vO!,TQMhO7++]O&6gQMjO7++]O&6qQMjO7++]OOQ!0Lh1G/c1G/cO&7OQ`O1G/cOOQ!0Lh7+'u7+'uO&7TQMjO7+'|O&7eQ!0MxO<<KXOOQ!0Lf<<KX<<KXO&8XQ`O1G0zO!&zQMhO'#IzO&8^Q`O,5@xO&:`Q!fO<<LPO!&zQMhO1G2nO&:gQ!0LrO1G2nOOQ[<<G{<<G{O!ByQ!0LrO<<G{O&:xQ!0MxO<<I{OOQ!0Lf<<I{<<I{OOQO,5?l,5?lO&;lQ`O,5?lO&;qQ`O,5?lOOQO-E=O-E=OO&<PQ`O1G6kO&<PQ`O1G6kO9kQ`O1G6kO@zQ`O<<LlOOQ[<<Ll<<LlO&<XQ`O<<LlO9uQ!0LrO<<LlO9kQ`O<<LlOOQ[<<LX<<LXO%:yQ!0MvO<<LXOOQ[<<LY<<LYO!E^Q`O<<LYO&<^QpO'#I|O&<iQ`O,5@|O!)[QlO,5@|OOQ[1G3W1G3WOOQO'#JO'#JOO9uQ!0LrO'#JOO&<qQpO,5=uOOQ[,5=u,5=uO&<xQpO'#EgO&=PQpO'#GeO&=UQ`O7+(zO&=ZQ`O7+(zOOQ[7+(z7+(zO!&zQMhO7+(zO%[QlO7+(zO&=cQ`O7+(zOOQ[7+(|7+(|O9uQ!0LrO7+(|O$%dQ`O7+(|O9`Q`O7+(|O!CUQpO7+(|O&=nQ`O,5?kOOQO-E<}-E<}OOQO'#H^'#H^O&=yQ`O1G6iO9uQ!0LrO<<GqOOQ[<<Gq<<GqO@zQ`O<<GqO&>RQ`O7+,WO&>WQ`O7+,XO%[QlO7+,WO%[QlO7+,XOOQ[7+)V7+)VO&>]Q`O7+)VO&>bQlO7+)VO&>iQ`O7+)VOOQ[<<Ly<<LyOOQ[<<L{<<L{OOQ[-E=Q-E=QOOQ[1G3z1G3zO&>nQ`O,5>aOOQ[,5>c,5>cO&>sQ`O1G4QO9eQ`O7+&fO!)[QlO7+&fOOQO7+%_7+%_O&>xQ?MtO1G6ZO?YQ`O7+%_OOQ!0Lf<<Ia<<IaOOQ!0Lf<<Iz<<IzO?YQ`O<<IzOOQO<<Is<<IsO$AlQ!0MxO<<IsO%[QlO<<IsOOQO<<Id<<IdO!ByQ!0LrO<<IdO&?SQ!0LrO<<IsO&?_Q!0MxO<= ^O&?oQ`O<= ]OOQO7+*_7+*_O9eQ`O7+*_OOQ[ANAkANAkO&?wQ!fOANAkO!&zQMhOANAkO#(ZQ`OANAkO4UQ!fOANAkO&@OQ`OANAkO%[QlOANAkO&@WQ!0MzO7+'zO&BiQ!0MzO,5?aO&DtQ!0MzO,5?cO&GPQ!0MzO7+'|O&IbQ!fO1G4lO&IlQ?MtO7+&aO&KpQ?MvO,5=XO&MwQ?MvO,5=ZO&NXQ?MvO,5=XO&NiQ?MvO,5=ZO&NyQ?MvO,59uO'#PQ?MvO,5<kO'%SQ?MvO,5<mO''hQ?MvO,5<{O')^Q?MtO7+'kO')kQ?MtO7+'mO')xQ`O,5<]OOQO7+'`7+'`OOQ!0Lh7+*d7+*dO')}QMjO<<K}OOQO1G4w1G4wO'*UQ`O1G4wO'*aQ`O1G4wO'*oQ`O7++|O'*oQ`O7++|O!&zQMhO1G4yO'*wQ!dO1G4yO'+RQ`O7++}O'+ZQ`O7+(VO'+fQ!dO7+(VOOQ!0Lb7+(T7+(TOOQ!0Lb7+(U7+(UO!CUQpO7+(TOCwQ`O7+(TO'+pQ`O7+(VO!&zQMhO7+(VO$+YQ`O7+(UO'+uQ`O7+(VOCwQ`O7+(UO'+}QMjO<<NwO!,TQMhO<<NwOOQ!0Lh7+$}7+$}O',XQ!dO,5?fOOQO-E<x-E<xO',cQ!0MvO7+(YO!&zQMhO7+(YOOQ[AN=gAN=gO9kQ`O1G5WOOQO1G5W1G5WO',sQ`O1G5WO',xQ`O7+,VO',xQ`O7+,VO9uQ!0LrOANBWO@zQ`OANBWOOQ[ANBWANBWO'-QQ`OANBWOOQ[ANAsANAsOOQ[ANAtANAtO'-VQ`O,5?hOOQO-E<z-E<zO'-bQ?MtO1G6hOOQO,5?j,5?jOOQO-E<|-E<|OOQ[1G3a1G3aO'-lQ`O,5=POOQ[<<Lf<<LfO!&zQMhO<<LfO&=UQ`O<<LfO'-qQ`O<<LfO%[QlO<<LfOOQ[<<Lh<<LhO9uQ!0LrO<<LhO$%dQ`O<<LhO9`Q`O<<LhO'-yQpO1G5VO'.UQ`O7+,TOOQ[AN=]AN=]O9uQ!0LrOAN=]OOQ[<= r<= rOOQ[<= s<= sO'.^Q`O<= rO'.cQ`O<= sOOQ[<<Lq<<LqO'.hQ`O<<LqO'.mQlO<<LqOOQ[1G3{1G3{O?YQ`O7+)lO'.tQ`O<<JQO'/PQ?MtO<<JQOOQO<<Hy<<HyOOQ!0LfAN?fAN?fOOQOAN?_AN?_O$AlQ!0MxOAN?_OOQOAN?OAN?OO%[QlOAN?_OOQO<<My<<MyOOQ[G27VG27VO!&zQMhOG27VO#(ZQ`OG27VO'/ZQ!fOG27VO4UQ!fOG27VO'/bQ`OG27VO'/jQ?MtO<<JfO'/wQ?MvO1G2`O'1mQ?MvO,5?aO'3pQ?MvO,5?cO'5sQ?MvO1G2sO'7vQ?MvO1G2uO'9yQ?MtO<<KXO':WQ?MtO<<I{OOQO1G1w1G1wO!,TQMhOANAiOOQO7+*c7+*cO':eQ`O7+*cO':pQ`O<= hO':xQ!dO7+*eOOQ!0Lb<<Kq<<KqO$+YQ`O<<KqOCwQ`O<<KqO';SQ`O<<KqO!&zQMhO<<KqOOQ!0Lb<<Ko<<KoO!CUQpO<<KoO';_Q!dO<<KqOOQ!0Lb<<Kp<<KpO';iQ`O<<KqO!&zQMhO<<KqO$+YQ`O<<KpO';nQMjOANDcO';xQ!0MvO<<KtOOQO7+*r7+*rO9kQ`O7+*rO'<YQ`O<= qOOQ[G27rG27rO9uQ!0LrOG27rO@zQ`OG27rO!)[QlO1G5SO'<bQ`O7+,SO'<jQ`O1G2kO&=UQ`OANBQOOQ[ANBQANBQO!&zQMhOANBQO'<oQ`OANBQOOQ[ANBSANBSO9uQ!0LrOANBSO$%dQ`OANBSOOQO'#H_'#H_OOQO7+*q7+*qOOQ[G22wG22wOOQ[ANE^ANE^OOQ[ANE_ANE_OOQ[ANB]ANB]O'<wQ`OANB]OOQ[<<MW<<MWO!)[QlOAN?lOOQOG24yG24yO$AlQ!0MxOG24yO#(ZQ`OLD,qOOQ[LD,qLD,qO!&zQMhOLD,qO'<|Q!fOLD,qO'=TQ?MvO7+'zO'>yQ?MvO,5?aO'@|Q?MvO,5?cO'CPQ?MvO7+'|O'DuQMjOG27TOOQO<<M}<<M}OOQ!0LbANA]ANA]O$+YQ`OANA]OCwQ`OANA]O'EVQ!dOANA]OOQ!0LbANAZANAZO'E^Q`OANA]O!&zQMhOANA]O'EiQ!dOANA]OOQ!0LbANA[ANA[OOQO<<N^<<N^OOQ[LD-^LD-^O9uQ!0LrOLD-^O'EsQ?MtO7+*nOOQO'#Gf'#GfOOQ[G27lG27lO&=UQ`OG27lO!&zQMhOG27lOOQ[G27nG27nO9uQ!0LrOG27nOOQ[G27wG27wO'E}Q?MtOG25WOOQOLD*eLD*eOOQ[!$(!]!$(!]O#(ZQ`O!$(!]O!&zQMhO!$(!]O'FXQ!0MzOG27TOOQ!0LbG26wG26wO$+YQ`OG26wO'HjQ`OG26wOCwQ`OG26wO'HuQ!dOG26wO!&zQMhOG26wOOQ[!$(!x!$(!xOOQ[LD-WLD-WO&=UQ`OLD-WOOQ[LD-YLD-YOOQ[!)9Ew!)9EwO#(ZQ`O!)9EwOOQ!0LbLD,cLD,cO$+YQ`OLD,cOCwQ`OLD,cO'H|Q`OLD,cO'IXQ!dOLD,cOOQ[!$(!r!$(!rOOQ[!.K;c!.K;cO'I`Q?MvOG27TOOQ!0Lb!$( }!$( }O$+YQ`O!$( }OCwQ`O!$( }O'KUQ`O!$( }OOQ!0Lb!)9Ei!)9EiO$+YQ`O!)9EiOCwQ`O!)9EiOOQ!0Lb!.K;T!.K;TO$+YQ`O!.K;TOOQ!0Lb!4/0o!4/0oO!)[QlO'#DzO1PQ`O'#EXO'KaQ!fO'#JrO'KhQ!L^O'#DvO'KoQlO'#EOO'KvQ!fO'#CiO'N^Q!fO'#CiO!)[QlO'#EQO'NnQlO,5;ZO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO,5;eO!)[QlO'#IpO(!qQ`O,5<iO!)[QlO,5;eO(!yQMhO,5;eO($dQMhO,5;eO!)[QlO,5;wO!&zQMhO'#GmO(!yQMhO'#GmO!&zQMhO'#GoO(!yQMhO'#GoO1SQ`O'#DZO1SQ`O'#DZO!&zQMhO'#GPO(!yQMhO'#GPO!&zQMhO'#GRO(!yQMhO'#GRO!&zQMhO'#GaO(!yQMhO'#GaO!)[QlO,5:jO($kQpO'#D_O($uQpO'#JvO!)[QlO,5@oO'NnQlO1G0uO(%PQ?MtO'#CiO!)[QlO1G2PO!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO(%ZQ!dO'#CrO!&zQMhO,5<tO(!yQMhO,5<tO'NnQlO1G2RO!)[QlO7+&zO!&zQMhO1G2`O(!yQMhO1G2`O!&zQMhO'#IuO(!yQMhO'#IuO!&zQMhO'#IwO(!yQMhO'#IwO!&zQMhO1G2bO(!yQMhO1G2bO'NnQlO7+'mO'NnQlO7+&aO!&zQMhOANAiO(!yQMhOANAiO(%nQ`O'#EoO(%sQ`O'#EoO(%{Q`O'#F]O(&QQ`O'#EyO(&VQ`O'#KTO(&bQ`O'#KRO(&mQ`O,5;ZO(&rQMjO,5<eO(&yQ`O'#GYO('OQ`O'#GYO('TQ`O,5<eO(']Q`O,5<gO('eQ`O,5;ZO('mQ?MtO1G1`O('tQ`O,5<tO('yQ`O,5<tO((OQ`O,5<vO((TQ`O,5<vO((YQ`O1G2RO((_Q`O1G0uO((dQMjO<<K}O((kQMjO<<K}O((rQMhO'#F|O9`Q`O'#F{OAuQ`O'#EnO!)[QlO,5;tO!3oQ`O'#GYO!3oQ`O'#GYO!3oQ`O'#G[O!3oQ`O'#G[O!,TQMhO7+(cO!,TQMhO7+(cO%.zQ!dO1G2wO%.zQ!dO1G2wO!&zQMhO,5=]O!&zQMhO,5=]",
	stateData: "()x~O'|OS'}OSTOS(ORQ~OPYOQYOSfOY!VOaqOdzOeyOl!POpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!uwO!xxO!|]O$W|O$niO%h}O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO&W!WO&^!XO&`!YO&b!ZO&d![O&g!]O&m!^O&s!_O&u!`O&w!aO&y!bO&{!cO(TSO(VTO(YUO(aVO(o[O~OWtO~P`OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa!wOs!nO!S!oO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!xO#W!pO#X!pO#[!zO#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O(O!{O~OP]XR]X[]Xa]Xj]Xr]X!Q]X!S]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X'z]X(a]X(r]X(y]X(z]X~O!g%RX~P(qO_!}O(V#PO(W!}O(X#PO~O_#QO(X#PO(Y#PO(Z#QO~Ox#SO!U#TO(b#TO(c#VO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T<ZO(VTO(YUO(aVO(o[O~O![#ZO!]#WO!Y(hP!Y(vP~P+}O!^#cO~P`OPYOQYOSfOd!jOe!iOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(VTO(YUO(aVO(o[O~Op#mO![#iO!|]O#i#lO#j#iO(T<[O!k(sP~P.iO!l#oO(T#nO~O!x#sO!|]O%h#tO~O#k#uO~O!g#vO#k#uO~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!]$_O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa(fX'z(fX'w(fX!k(fX!Y(fX!_(fX%i(fX!g(fX~P1qO#S$dO#`$eO$Q$eOP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX!_(gX%i(gX~Oa(gX'z(gX'w(gX!Y(gX!k(gXv(gX!g(gX~P4UO#`$eO~O$]$hO$_$gO$f$mO~OSfO!_$nO$i$oO$k$qO~Oh%VOj%dOk%dOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T$sO(VTO(YUO(a$uO(y$}O(z%POg(^P~Ol%[O~P7eO!l%eO~O!S%hO!_%iO(T%gO~O!g%mO~Oa%nO'z%nO~O!Q%rO~P%[O(U!lO~P%[O%n%vO~P%[Oh%VO!l%eO(T%gO(U!lO~Oe%}O!l%eO(T%gO~Oj$RO~O!_&PO(T%gO(U!lO(VTO(YUO`)WP~O!Q&SO!l&RO%j&VO&T&WO~P;SO!x#sO~O%s&YO!S)SX!_)SX(T)SX~O(T&ZO~Ol!PO!u&`O%j!QO%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO~Od&eOe&dO!x&bO%h&cO%{&aO~P<bOd&hOeyOl!PO!_&gO!u&`O!xxO!|]O%h}O%l!OO%m!OO%n!OO%q!RO%s!SO%v!TO%w!TO%y!UO~Ob&kO#`&nO%j&iO(U!lO~P=gO!l&oO!u&sO~O!l#oO~O!_XO~Oa%nO'x&{O'z%nO~Oa%nO'x'OO'z%nO~Oa%nO'x'QO'z%nO~O'w]X!Y]Xv]X!k]X&[]X!_]X%i]X!g]X~P(qO!b'_O!c'WO!d'WO(U!lO(VTO(YUO~Os'UO!S'TO!['XO(e'SO!^(iP!^(xP~P@nOn'bO!_'`O(T%gO~Oe'gO!l%eO(T%gO~O!Q&SO!l&RO~Os!nO!S!oO!|<VO#T!pO#U!pO#W!pO#X!pO(U!lO(VTO(YUO(e!mO(o!sO~O!b'mO!c'lO!d'lO#V!pO#['nO#]'nO~PBYOa%nOh%VO!g#vO!l%eO'z%nO(r'pO~O!p'tO#`'rO~PChOs!nO!S!oO(VTO(YUO(e!mO(o!sO~O!_XOs(mX!S(mX!b(mX!c(mX!d(mX!|(mX#T(mX#U(mX#V(mX#W(mX#X(mX#[(mX#](mX(U(mX(V(mX(Y(mX(e(mX(o(mX~O!c'lO!d'lO(U!lO~PDWO(P'xO(Q'xO(R'zO~O_!}O(V'|O(W!}O(X'|O~O_#QO(X'|O(Y'|O(Z#QO~Ov(OO~P%[Ox#SO!U#TO(b#TO(c(RO~O![(TO!Y'WX!Y'^X!]'WX!]'^X~P+}O!](VO!Y(hX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!](VO!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~O!Y(hX~PHRO!Y([O~O!Y(uX!](uX!g(uX!k(uX(r(uX~O#`(uX#k#dX!^(uX~PJUO#`(]O!Y(wX!](wX~O!](^O!Y(vX~O!Y(aO~O#`$eO~PJUO!^(bO~P`OR#zO!Q#yO!S#{O!l#xO(aVOP!na[!naj!nar!na!]!na!p!na#R!na#n!na#o!na#p!na#q!na#r!na#s!na#t!na#u!na#v!na#x!na#z!na#{!na(r!na(y!na(z!na~Oa!na'z!na'w!na!Y!na!k!nav!na!_!na%i!na!g!na~PKlO!k(cO~O!g#vO#`(dO(r'pO!](tXa(tX'z(tX~O!k(tX~PNXO!S%hO!_%iO!|]O#i(iO#j(hO(T%gO~O!](jO!k(sX~O!k(lO~O!S%hO!_%iO#j(hO(T%gO~OP(gXR(gX[(gXj(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~O!g#vO!k(gX~P! uOR(nO!Q(mO!l#xO#S$dO!|!{a!S!{a~O!x!{a%h!{a!_!{a#i!{a#j!{a(T!{a~P!#vO!x(rO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_XO!iuO!lZO!oYO!pYO!qYO!svO!u!gO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~O#k(xO~O![(zO!k(kP~P%[O(e(|O(o[O~O!S)OO!l#xO(e(|O(o[O~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]$_Oa$qa'z$qa'w$qa!k$qa!Y$qa!_$qa%i$qa!g$qa~Ol)dO~P!&zOh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O%]O!S${O!_$|O!i%bO!l$xO#j%cO$W%`O$t%^O$v%_O$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Og(pP~P!,TO!Q)iO!g)hO!_$^X$Z$^X$]$^X$_$^X$f$^X~O!g)hO!_({X$Z({X$]({X$_({X$f({X~O!Q)iO~P!.^O!Q)iO!_({X$Z({X$]({X$_({X$f({X~O!_)kO$Z)oO$])jO$_)jO$f)pO~O![)sO~P!)[O$]$hO$_$gO$f)wO~On$zX!Q$zX#S$zX'y$zX(y$zX(z$zX~OgmXg$zXnmX!]mX#`mX~P!0SOx)yO(b)zO(c)|O~On*VO!Q*OO'y*PO(y$}O(z%PO~Og)}O~P!1WOg*WO~Oh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S*YO!_*ZO!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op*`O![*^O(T*XO!k)OP~P!1uO#k*aO~O!l*bO~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(T*dO(VTO(YUO(a$uO(y$}O(z%PO~O![*gO!Y)PP~P!3tOr*sOs!nO!S*iO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO(e!mO~O!^*pO~P!5iO#S$dOn(`X!Q(`X'y(`X(y(`X(z(`X!](`X#`(`X~Og(`X$O(`X~P!6kOn*xO#`*wOg(_X!](_X~O!]*yOg(^X~Oj%dOk%dOl%dO(T&ZOg(^P~Os*|O~Og)}O(T&ZO~O!l+SO~O(T(vO~Op+WO!S%hO![#iO!_%iO!|]O#i#lO#j#iO(T%gO!k(sP~O!g#vO#k+XO~O!S%hO![+ZO!](^O!_%iO(T%gO!Y(vP~Os'[O!S+]O![+[O(VTO(YUO(e(|O~O!^(xP~P!9|O!]+^Oa)TX'z)TX~OP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO#z$WO#{$XO(aVO(r$YO(y#|O(z#}O~Oa!ja!]!ja'z!ja'w!ja!Y!ja!k!jav!ja!_!ja%i!ja!g!ja~P!:tOR#zO!Q#yO!S#{O!l#xO(aVOP!ra[!raj!rar!ra!]!ra!p!ra#R!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#v!ra#x!ra#z!ra#{!ra(r!ra(y!ra(z!ra~Oa!ra'z!ra'w!ra!Y!ra!k!rav!ra!_!ra%i!ra!g!ra~P!=[OR#zO!Q#yO!S#{O!l#xO(aVOP!ta[!taj!tar!ta!]!ta!p!ta#R!ta#n!ta#o!ta#p!ta#q!ta#r!ta#s!ta#t!ta#u!ta#v!ta#x!ta#z!ta#{!ta(r!ta(y!ta(z!ta~Oa!ta'z!ta'w!ta!Y!ta!k!tav!ta!_!ta%i!ta!g!ta~P!?rOh%VOn+gO!_'`O%i+fO~O!g+iOa(]X!_(]X'z(]X!](]X~Oa%nO!_XO'z%nO~Oh%VO!l%eO~Oh%VO!l%eO(T%gO~O!g#vO#k(xO~Ob+tO%j+uO(T+qO(VTO(YUO!^)XP~O!]+vO`)WX~O[+zO~O`+{O~O!_&PO(T%gO(U!lO`)WP~O%j,OO~P;SOh%VO#`,SO~Oh%VOn,VO!_$|O~O!_,XO~O!Q,ZO!_XO~O%n%vO~O!x,`O~Oe,eO~Ob,fO(T#nO(VTO(YUO!^)VP~Oe%}O~O%j!QO(T&ZO~P=gO[,kO`,jO~OPYOQYOSfOdzOeyOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!iuO!lZO!oYO!pYO!qYO!svO!xxO!|]O$niO%h}O(VTO(YUO(aVO(o[O~O!_!eO!u!gO$W!kO(T!dO~P!FyO`,jOa%nO'z%nO~OPYOQYOSfOd!jOe!iOpkOrYOskOtkOzkO|YO!OYO!SWO!WkO!XkO!_!eO!iuO!lZO!oYO!pYO!qYO!svO!x!hO$W!kO$niO(T!dO(VTO(YUO(aVO(o[O~Oa,pOl!OO!uwO%l!OO%m!OO%n!OO~P!IcO!l&oO~O&^,vO~O!_,xO~O&o,zO&q,{OP&laQ&laS&laY&laa&lad&lae&lal&lap&lar&las&lat&laz&la|&la!O&la!S&la!W&la!X&la!_&la!i&la!l&la!o&la!p&la!q&la!s&la!u&la!x&la!|&la$W&la$n&la%h&la%j&la%l&la%m&la%n&la%q&la%s&la%v&la%w&la%y&la&W&la&^&la&`&la&b&la&d&la&g&la&m&la&s&la&u&la&w&la&y&la&{&la'w&la(T&la(V&la(Y&la(a&la(o&la!^&la&e&lab&la&j&la~O(T-QO~Oh!eX!]!RX!^!RX!g!RX!g!eX!l!eX#`!RX~O!]!eX!^!eX~P#!iO!g-VO#`-UOh(jX!]#hX!^#hX!g(jX!l(jX~O!](jX!^(jX~P##[Oh%VO!g-XO!l%eO!]!aX!^!aX~Os!nO!S!oO(VTO(YUO(e!mO~OP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_!eO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(VTO(YUO(aVO(o[O~O(T=QO~P#$qO!]-]O!^(iX~O!^-_O~O!g-VO#`-UO!]#hX!^#hX~O!]-`O!^(xX~O!^-bO~O!c-cO!d-cO(U!lO~P#$`O!^-fO~P'_On-iO!_'`O~O!Y-nO~Os!{a!b!{a!c!{a!d!{a#T!{a#U!{a#V!{a#W!{a#X!{a#[!{a#]!{a(U!{a(V!{a(Y!{a(e!{a(o!{a~P!#vO!p-sO#`-qO~PChO!c-uO!d-uO(U!lO~PDWOa%nO#`-qO'z%nO~Oa%nO!g#vO#`-qO'z%nO~Oa%nO!g#vO!p-sO#`-qO'z%nO(r'pO~O(P'xO(Q'xO(R-zO~Ov-{O~O!Y'Wa!]'Wa~P!:tO![.PO!Y'WX!]'WX~P%[O!](VO!Y(ha~O!Y(ha~PHRO!](^O!Y(va~O!S%hO![.TO!_%iO(T%gO!Y'^X!]'^X~O#`.VO!](ta!k(taa(ta'z(ta~O!g#vO~P#,wO!](jO!k(sa~O!S%hO!_%iO#j.ZO(T%gO~Op.`O!S%hO![.]O!_%iO!|]O#i._O#j.]O(T%gO!]'aX!k'aX~OR.dO!l#xO~Oh%VOn.gO!_'`O%i.fO~Oa#ci!]#ci'z#ci'w#ci!Y#ci!k#civ#ci!_#ci%i#ci!g#ci~P!:tOn>]O!Q*OO'y*PO(y$}O(z%PO~O#k#_aa#_a#`#_a'z#_a!]#_a!k#_a!_#_a!Y#_a~P#/sO#k(`XP(`XR(`X[(`Xa(`Xj(`Xr(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X'z(`X(a(`X(r(`X!k(`X!Y(`X'w(`Xv(`X!_(`X%i(`X!g(`X~P!6kO!].tO!k(kX~P!:tO!k.wO~O!Y.yO~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mia#mij#mir#mi!]#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#n#mi~P#3cO#n$OO~P#3cOP$[OR#zOr$aO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO[#mia#mij#mi!]#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#r#mi~P#6QO#r$QO~P#6QOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO(aVOa#mi!]#mi#x#mi#z#mi#{#mi'z#mi(r#mi(y#mi(z#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#v#mi~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO(aVO(z#}Oa#mi!]#mi#z#mi#{#mi'z#mi(r#mi(y#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#x$UO~P#;VO#x#mi~P#;VO#v$SO~P#8oOP$[OR#zO[$cOj$ROr$aO!Q#yO!S#{O!l#xO!p$[O#R$RO#n$OO#o$PO#p$PO#q$PO#r$QO#s$RO#t$RO#u$bO#v$SO#x$UO(aVO(y#|O(z#}Oa#mi!]#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~O#z#mi~P#={O#z$WO~P#={OP]XR]X[]Xj]Xr]X!Q]X!S]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X!]]X!^]X~O$O]X~P#@jOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO#z<gO#{<hO(aVO(r$YO(y#|O(z#}O~O$O.{O~P#BwO#S$dO#`<nO$Q<nO$O(gX!^(gX~P! uOa'da!]'da'z'da'w'da!k'da!Y'dav'da!_'da%i'da!g'da~P!:tO[#mia#mij#mir#mi!]#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi'z#mi(r#mi'w#mi!Y#mi!k#miv#mi!_#mi%i#mi!g#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n$OO#o$PO#p$PO#q$PO(aVO(y#mi(z#mi~P#EyOn>]O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P#EyO!]/POg(pX~P!1WOg/RO~Oa$Pi!]$Pi'z$Pi'w$Pi!Y$Pi!k$Piv$Pi!_$Pi%i$Pi!g$Pi~P!:tO$]/SO$_/SO~O$]/TO$_/TO~O!g)hO#`/UO!_$cX$Z$cX$]$cX$_$cX$f$cX~O![/VO~O!_)kO$Z/XO$])jO$_)jO$f/YO~O!]<iO!^(fX~P#BwO!^/ZO~O!g)hO$f({X~O$f/]O~Ov/^O~P!&zOx)yO(b)zO(c/aO~O!S/dO~O(y$}On%aa!Q%aa'y%aa(z%aa!]%aa#`%aa~Og%aa$O%aa~P#L{O(z%POn%ca!Q%ca'y%ca(y%ca!]%ca#`%ca~Og%ca$O%ca~P#MnO!]fX!gfX!kfX!k$zX(rfX~P!0SOp%WO![/mO!](^O(T/lO!Y(vP!Y)PP~P!1uOr*sO!b*qO!c*kO!d*kO!l*bO#[*rO%`*mO(U!lO(VTO(YUO~Os<}O!S/nO![+[O!^*pO(e<|O!^(xP~P$ [O!k/oO~P#/sO!]/pO!g#vO(r'pO!k)OX~O!k/uO~OnoX!QoX'yoX(yoX(zoX~O!g#vO!koX~P$#OOp/wO!S%hO![*^O!_%iO(T%gO!k)OP~O#k/xO~O!Y$zX!]$zX!g%RX~P!0SO!]/yO!Y)PX~P#/sO!g/{O~O!Y/}O~OpkO(T0OO~P.iOh%VOr0TO!g#vO!l%eO(r'pO~O!g+iO~Oa%nO!]0XO'z%nO~O!^0ZO~P!5iO!c0[O!d0[O(U!lO~P#$`Os!nO!S0]O(VTO(YUO(e!mO~O#[0_O~Og%aa!]%aa#`%aa$O%aa~P!1WOg%ca!]%ca#`%ca$O%ca~P!1WOj%dOk%dOl%dO(T&ZOg'mX!]'mX~O!]*yOg(^a~Og0hO~On0jO#`0iOg(_a!](_a~OR0kO!Q0kO!S0lO#S$dOn}a'y}a(y}a(z}a!]}a#`}a~Og}a$O}a~P$(cO!Q*OO'y*POn$sa(y$sa(z$sa!]$sa#`$sa~Og$sa$O$sa~P$)_O!Q*OO'y*POn$ua(y$ua(z$ua!]$ua#`$ua~Og$ua$O$ua~P$*QO#k0oO~Og%Ta!]%Ta#`%Ta$O%Ta~P!1WO!g#vO~O#k0rO~O!]+^Oa)Ta'z)Ta~OR#zO!Q#yO!S#{O!l#xO(aVOP!ri[!rij!rir!ri!]!ri!p!ri#R!ri#n!ri#o!ri#p!ri#q!ri#r!ri#s!ri#t!ri#u!ri#v!ri#x!ri#z!ri#{!ri(r!ri(y!ri(z!ri~Oa!ri'z!ri'w!ri!Y!ri!k!riv!ri!_!ri%i!ri!g!ri~P$+oOh%VOr%XOs$tOt$tOz%YO|%ZO!O<sO!S${O!_$|O!i>VO!l$xO#j<yO$W%`O$t<uO$v<wO$y%aO(VTO(YUO(a$uO(y$}O(z%PO~Op0{O%]0|O(T0zO~P$.VO!g+iOa(]a!_(]a'z(]a!](]a~O#k1SO~O[]X!]fX!^fX~O!]1TO!^)XX~O!^1VO~O[1WO~Ob1YO(T+qO(VTO(YUO~O!_&PO(T%gO`'uX!]'uX~O!]+vO`)Wa~O!k1]O~P!:tO[1`O~O`1aO~O#`1fO~On1iO!_$|O~O(e(|O!^)UP~Oh%VOn1rO!_1oO%i1qO~O[1|O!]1zO!^)VX~O!^1}O~O`2POa%nO'z%nO~O(T#nO(VTO(YUO~O#S$dO#`$eO$Q$eOP(gXR(gX[(gXr(gX!Q(gX!S(gX!](gX!l(gX!p(gX#R(gX#n(gX#o(gX#p(gX#q(gX#r(gX#s(gX#t(gX#u(gX#v(gX#x(gX#z(gX#{(gX(a(gX(r(gX(y(gX(z(gX~Oj2SO&[2TOa(gX~P$3pOj2SO#`$eO&[2TO~Oa2VO~P%[Oa2XO~O&e2[OP&ciQ&ciS&ciY&cia&cid&cie&cil&cip&cir&cis&cit&ciz&ci|&ci!O&ci!S&ci!W&ci!X&ci!_&ci!i&ci!l&ci!o&ci!p&ci!q&ci!s&ci!u&ci!x&ci!|&ci$W&ci$n&ci%h&ci%j&ci%l&ci%m&ci%n&ci%q&ci%s&ci%v&ci%w&ci%y&ci&W&ci&^&ci&`&ci&b&ci&d&ci&g&ci&m&ci&s&ci&u&ci&w&ci&y&ci&{&ci'w&ci(T&ci(V&ci(Y&ci(a&ci(o&ci!^&cib&ci&j&ci~Ob2bO!^2`O&j2aO~P`O!_XO!l2dO~O&q,{OP&liQ&liS&liY&lia&lid&lie&lil&lip&lir&lis&lit&liz&li|&li!O&li!S&li!W&li!X&li!_&li!i&li!l&li!o&li!p&li!q&li!s&li!u&li!x&li!|&li$W&li$n&li%h&li%j&li%l&li%m&li%n&li%q&li%s&li%v&li%w&li%y&li&W&li&^&li&`&li&b&li&d&li&g&li&m&li&s&li&u&li&w&li&y&li&{&li'w&li(T&li(V&li(Y&li(a&li(o&li!^&li&e&lib&li&j&li~O!Y2jO~O!]!aa!^!aa~P#BwOs!nO!S!oO![2pO(e!mO!]'XX!^'XX~P@nO!]-]O!^(ia~O!]'_X!^'_X~P!9|O!]-`O!^(xa~O!^2wO~P'_Oa%nO#`3QO'z%nO~Oa%nO!g#vO#`3QO'z%nO~Oa%nO!g#vO!p3UO#`3QO'z%nO(r'pO~Oa%nO'z%nO~P!:tO!]$_Ov$qa~O!Y'Wi!]'Wi~P!:tO!](VO!Y(hi~O!](^O!Y(vi~O!Y(wi!](wi~P!:tO!](ti!k(tia(ti'z(ti~P!:tO#`3WO!](ti!k(tia(ti'z(ti~O!](jO!k(si~O!S%hO!_%iO!|]O#i3]O#j3[O(T%gO~O!S%hO!_%iO#j3[O(T%gO~On3dO!_'`O%i3cO~Oh%VOn3dO!_'`O%i3cO~O#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aav%aa!_%aa%i%aa!g%aa~P#L{O#k%caP%caR%ca[%caa%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%cav%ca!_%ca%i%ca!g%ca~P#MnO#k%aaP%aaR%aa[%aaa%aaj%aar%aa!S%aa!]%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa'z%aa(a%aa(r%aa!k%aa!Y%aa'w%aa#`%aav%aa!_%aa%i%aa!g%aa~P#/sO#k%caP%caR%ca[%caa%caj%car%ca!S%ca!]%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca'z%ca(a%ca(r%ca!k%ca!Y%ca'w%ca#`%cav%ca!_%ca%i%ca!g%ca~P#/sO#k}aP}a[}aa}aj}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a'z}a(a}a(r}a!k}a!Y}a'w}av}a!_}a%i}a!g}a~P$(cO#k$saP$saR$sa[$saa$saj$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa'z$sa(a$sa(r$sa!k$sa!Y$sa'w$sav$sa!_$sa%i$sa!g$sa~P$)_O#k$uaP$uaR$ua[$uaa$uaj$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua'z$ua(a$ua(r$ua!k$ua!Y$ua'w$uav$ua!_$ua%i$ua!g$ua~P$*QO#k%TaP%TaR%Ta[%Taa%Taj%Tar%Ta!S%Ta!]%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta'z%Ta(a%Ta(r%Ta!k%Ta!Y%Ta'w%Ta#`%Tav%Ta!_%Ta%i%Ta!g%Ta~P#/sOa#cq!]#cq'z#cq'w#cq!Y#cq!k#cqv#cq!_#cq%i#cq!g#cq~P!:tO![3lO!]'YX!k'YX~P%[O!].tO!k(ka~O!].tO!k(ka~P!:tO!Y3oO~O$O!na!^!na~PKlO$O!ja!]!ja!^!ja~P#BwO$O!ra!^!ra~P!=[O$O!ta!^!ta~P!?rOg']X!]']X~P!,TO!]/POg(pa~OSfO!_4TO$d4UO~O!^4YO~Ov4ZO~P#/sOa$mq!]$mq'z$mq'w$mq!Y$mq!k$mqv$mq!_$mq%i$mq!g$mq~P!:tO!Y4]O~P!&zO!S4^O~O!Q*OO'y*PO(z%POn'ia(y'ia!]'ia#`'ia~Og'ia$O'ia~P%-fO!Q*OO'y*POn'ka(y'ka(z'ka!]'ka#`'ka~Og'ka$O'ka~P%.XO(r$YO~P#/sO!YfX!Y$zX!]fX!]$zX!g%RX#`fX~P!0SOp%WO(T=WO~P!1uOp4bO!S%hO![4aO!_%iO(T%gO!]'eX!k'eX~O!]/pO!k)Oa~O!]/pO!g#vO!k)Oa~O!]/pO!g#vO(r'pO!k)Oa~Og$|i!]$|i#`$|i$O$|i~P!1WO![4jO!Y'gX!]'gX~P!3tO!]/yO!Y)Pa~O!]/yO!Y)Pa~P#/sOP]XR]X[]Xj]Xr]X!Q]X!S]X!Y]X!]]X!l]X!p]X#R]X#S]X#`]X#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~Oj%YX!g%YX~P%2OOj4oO!g#vO~Oh%VO!g#vO!l%eO~Oh%VOr4tO!l%eO(r'pO~Or4yO!g#vO(r'pO~Os!nO!S4zO(VTO(YUO(e!mO~O(y$}On%ai!Q%ai'y%ai(z%ai!]%ai#`%ai~Og%ai$O%ai~P%5oO(z%POn%ci!Q%ci'y%ci(y%ci!]%ci#`%ci~Og%ci$O%ci~P%6bOg(_i!](_i~P!1WO#`5QOg(_i!](_i~P!1WO!k5VO~Oa$oq!]$oq'z$oq'w$oq!Y$oq!k$oqv$oq!_$oq%i$oq!g$oq~P!:tO!Y5ZO~O!]5[O!_)QX~P#/sOa$zX!_$zX%^]X'z$zX!]$zX~P!0SO%^5_OaoX!_oX'zoX!]oX~P$#OOp5`O(T#nO~O%^5_O~Ob5fO%j5gO(T+qO(VTO(YUO!]'tX!^'tX~O!]1TO!^)Xa~O[5kO~O`5lO~O[5pO~Oa%nO'z%nO~P#/sO!]5uO#`5wO!^)UX~O!^5xO~Or6OOs!nO!S*iO!b!yO!c!vO!d!vO!|<VO#T!pO#U!pO#V!pO#W!pO#X!pO#[5}O#]!zO(U!lO(VTO(YUO(e!mO(o!sO~O!^5|O~P%;eOn6TO!_1oO%i6SO~Oh%VOn6TO!_1oO%i6SO~Ob6[O(T#nO(VTO(YUO!]'sX!^'sX~O!]1zO!^)Va~O(VTO(YUO(e6^O~O`6bO~Oj6eO&[6fO~PNXO!k6gO~P%[Oa6iO~Oa6iO~P%[Ob2bO!^6nO&j2aO~P`O!g6pO~O!g6rOh(ji!](ji!^(ji!g(ji!l(jir(ji(r(ji~O!]#hi!^#hi~P#BwO#`6sO!]#hi!^#hi~O!]!ai!^!ai~P#BwOa%nO#`6|O'z%nO~Oa%nO!g#vO#`6|O'z%nO~O!](tq!k(tqa(tq'z(tq~P!:tO!](jO!k(sq~O!S%hO!_%iO#j7TO(T%gO~O!_'`O%i7WO~On7[O!_'`O%i7WO~O#k'iaP'iaR'ia['iaa'iaj'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia'z'ia(a'ia(r'ia!k'ia!Y'ia'w'iav'ia!_'ia%i'ia!g'ia~P%-fO#k'kaP'kaR'ka['kaa'kaj'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka'z'ka(a'ka(r'ka!k'ka!Y'ka'w'kav'ka!_'ka%i'ka!g'ka~P%.XO#k$|iP$|iR$|i[$|ia$|ij$|ir$|i!S$|i!]$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i'z$|i(a$|i(r$|i!k$|i!Y$|i'w$|i#`$|iv$|i!_$|i%i$|i!g$|i~P#/sO#k%aiP%aiR%ai[%aia%aij%air%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai'z%ai(a%ai(r%ai!k%ai!Y%ai'w%aiv%ai!_%ai%i%ai!g%ai~P%5oO#k%ciP%ciR%ci[%cia%cij%cir%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci'z%ci(a%ci(r%ci!k%ci!Y%ci'w%civ%ci!_%ci%i%ci!g%ci~P%6bO!]'Ya!k'Ya~P!:tO!].tO!k(ki~O$O#ci!]#ci!^#ci~P#BwOP$[OR#zO!Q#yO!S#{O!l#xO!p$[O(aVO[#mij#mir#mi#R#mi#o#mi#p#mi#q#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#n#mi~P%NdO#n<_O~P%NdOP$[OR#zOr<kO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO[#mij#mi#R#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#r#mi~P&!lO#r<aO~P&!lOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO(aVO#x#mi#z#mi#{#mi$O#mi(r#mi(y#mi(z#mi!]#mi!^#mi~O#v#mi~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO(aVO(z#}O#z#mi#{#mi$O#mi(r#mi(y#mi!]#mi!^#mi~O#x<eO~P&&uO#x#mi~P&&uO#v<cO~P&$tOP$[OR#zO[<mOj<bOr<kO!Q#yO!S#{O!l#xO!p$[O#R<bO#n<_O#o<`O#p<`O#q<`O#r<aO#s<bO#t<bO#u<lO#v<cO#x<eO(aVO(y#|O(z#}O#{#mi$O#mi(r#mi!]#mi!^#mi~O#z#mi~P&)UO#z<gO~P&)UOa#|y!]#|y'z#|y'w#|y!Y#|y!k#|yv#|y!_#|y%i#|y!g#|y~P!:tO[#mij#mir#mi#R#mi#r#mi#s#mi#t#mi#u#mi#v#mi#x#mi#z#mi#{#mi$O#mi(r#mi!]#mi!^#mi~OP$[OR#zO!Q#yO!S#{O!l#xO!p$[O#n<_O#o<`O#p<`O#q<`O(aVO(y#mi(z#mi~P&,QOn>^O!Q*OO'y*PO(y$}O(z%POP#miR#mi!S#mi!l#mi!p#mi#n#mi#o#mi#p#mi#q#mi(a#mi~P&,QO#S$dOP(`XR(`X[(`Xj(`Xn(`Xr(`X!Q(`X!S(`X!l(`X!p(`X#R(`X#n(`X#o(`X#p(`X#q(`X#r(`X#s(`X#t(`X#u(`X#v(`X#x(`X#z(`X#{(`X$O(`X'y(`X(a(`X(r(`X(y(`X(z(`X!](`X!^(`X~O$O$Pi!]$Pi!^$Pi~P#BwO$O!ri!^!ri~P$+oOg']a!]']a~P!1WO!^7nO~O!]'da!^'da~P#BwO!Y7oO~P#/sO!g#vO(r'pO!]'ea!k'ea~O!]/pO!k)Oi~O!]/pO!g#vO!k)Oi~Og$|q!]$|q#`$|q$O$|q~P!1WO!Y'ga!]'ga~P#/sO!g7vO~O!]/yO!Y)Pi~P#/sO!]/yO!Y)Pi~O!Y7yO~Oh%VOr8OO!l%eO(r'pO~Oj8QO!g#vO~Or8TO!g#vO(r'pO~O!Q*OO'y*PO(z%POn'ja(y'ja!]'ja#`'ja~Og'ja$O'ja~P&5RO!Q*OO'y*POn'la(y'la(z'la!]'la#`'la~Og'la$O'la~P&5tOg(_q!](_q~P!1WO#`8VOg(_q!](_q~P!1WO!Y8WO~Og%Oq!]%Oq#`%Oq$O%Oq~P!1WOa$oy!]$oy'z$oy'w$oy!Y$oy!k$oyv$oy!_$oy%i$oy!g$oy~P!:tO!g6rO~O!]5[O!_)Qa~O!_'`OP$TaR$Ta[$Taj$Tar$Ta!Q$Ta!S$Ta!]$Ta!l$Ta!p$Ta#R$Ta#n$Ta#o$Ta#p$Ta#q$Ta#r$Ta#s$Ta#t$Ta#u$Ta#v$Ta#x$Ta#z$Ta#{$Ta(a$Ta(r$Ta(y$Ta(z$Ta~O%i7WO~P&8fO%^8[Oa%[i!_%[i'z%[i!]%[i~Oa#cy!]#cy'z#cy'w#cy!Y#cy!k#cyv#cy!_#cy%i#cy!g#cy~P!:tO[8^O~Ob8`O(T+qO(VTO(YUO~O!]1TO!^)Xi~O`8dO~O(e(|O!]'pX!^'pX~O!]5uO!^)Ua~O!^8nO~P%;eO(o!sO~P$&YO#[8oO~O!_1oO~O!_1oO%i8qO~On8tO!_1oO%i8qO~O[8yO!]'sa!^'sa~O!]1zO!^)Vi~O!k8}O~O!k9OO~O!k9RO~O!k9RO~P%[Oa9TO~O!g9UO~O!k9VO~O!](wi!^(wi~P#BwOa%nO#`9_O'z%nO~O!](ty!k(tya(ty'z(ty~P!:tO!](jO!k(sy~O%i9bO~P&8fO!_'`O%i9bO~O#k$|qP$|qR$|q[$|qa$|qj$|qr$|q!S$|q!]$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q'z$|q(a$|q(r$|q!k$|q!Y$|q'w$|q#`$|qv$|q!_$|q%i$|q!g$|q~P#/sO#k'jaP'jaR'ja['jaa'jaj'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja'z'ja(a'ja(r'ja!k'ja!Y'ja'w'jav'ja!_'ja%i'ja!g'ja~P&5RO#k'laP'laR'la['laa'laj'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la'z'la(a'la(r'la!k'la!Y'la'w'lav'la!_'la%i'la!g'la~P&5tO#k%OqP%OqR%Oq[%Oqa%Oqj%Oqr%Oq!S%Oq!]%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq'z%Oq(a%Oq(r%Oq!k%Oq!Y%Oq'w%Oq#`%Oqv%Oq!_%Oq%i%Oq!g%Oq~P#/sO!]'Yi!k'Yi~P!:tO$O#cq!]#cq!^#cq~P#BwO(y$}OP%aaR%aa[%aaj%aar%aa!S%aa!l%aa!p%aa#R%aa#n%aa#o%aa#p%aa#q%aa#r%aa#s%aa#t%aa#u%aa#v%aa#x%aa#z%aa#{%aa$O%aa(a%aa(r%aa!]%aa!^%aa~On%aa!Q%aa'y%aa(z%aa~P&IyO(z%POP%caR%ca[%caj%car%ca!S%ca!l%ca!p%ca#R%ca#n%ca#o%ca#p%ca#q%ca#r%ca#s%ca#t%ca#u%ca#v%ca#x%ca#z%ca#{%ca$O%ca(a%ca(r%ca!]%ca!^%ca~On%ca!Q%ca'y%ca(y%ca~P&LQOn>^O!Q*OO'y*PO(z%PO~P&IyOn>^O!Q*OO'y*PO(y$}O~P&LQOR0kO!Q0kO!S0lO#S$dOP}a[}aj}an}ar}a!l}a!p}a#R}a#n}a#o}a#p}a#q}a#r}a#s}a#t}a#u}a#v}a#x}a#z}a#{}a$O}a'y}a(a}a(r}a(y}a(z}a!]}a!^}a~O!Q*OO'y*POP$saR$sa[$saj$san$sar$sa!S$sa!l$sa!p$sa#R$sa#n$sa#o$sa#p$sa#q$sa#r$sa#s$sa#t$sa#u$sa#v$sa#x$sa#z$sa#{$sa$O$sa(a$sa(r$sa(y$sa(z$sa!]$sa!^$sa~O!Q*OO'y*POP$uaR$ua[$uaj$uan$uar$ua!S$ua!l$ua!p$ua#R$ua#n$ua#o$ua#p$ua#q$ua#r$ua#s$ua#t$ua#u$ua#v$ua#x$ua#z$ua#{$ua$O$ua(a$ua(r$ua(y$ua(z$ua!]$ua!^$ua~On>^O!Q*OO'y*PO(y$}O(z%PO~OP%TaR%Ta[%Taj%Tar%Ta!S%Ta!l%Ta!p%Ta#R%Ta#n%Ta#o%Ta#p%Ta#q%Ta#r%Ta#s%Ta#t%Ta#u%Ta#v%Ta#x%Ta#z%Ta#{%Ta$O%Ta(a%Ta(r%Ta!]%Ta!^%Ta~P''VO$O$mq!]$mq!^$mq~P#BwO$O$oq!]$oq!^$oq~P#BwO!^9oO~O$O9pO~P!1WO!g#vO!]'ei!k'ei~O!g#vO(r'pO!]'ei!k'ei~O!]/pO!k)Oq~O!Y'gi!]'gi~P#/sO!]/yO!Y)Pq~Or9wO!g#vO(r'pO~O[9yO!Y9xO~P#/sO!Y9xO~Oj:PO!g#vO~Og(_y!](_y~P!1WO!]'na!_'na~P#/sOa%[q!_%[q'z%[q!]%[q~P#/sO[:UO~O!]1TO!^)Xq~O`:YO~O#`:ZO!]'pa!^'pa~O!]5uO!^)Ui~P#BwO!S:]O~O!_1oO%i:`O~O(VTO(YUO(e:eO~O!]1zO!^)Vq~O!k:hO~O!k:iO~O!k:jO~O!k:jO~P%[O#`:mO!]#hy!^#hy~O!]#hy!^#hy~P#BwO%i:rO~P&8fO!_'`O%i:rO~O$O#|y!]#|y!^#|y~P#BwOP$|iR$|i[$|ij$|ir$|i!S$|i!l$|i!p$|i#R$|i#n$|i#o$|i#p$|i#q$|i#r$|i#s$|i#t$|i#u$|i#v$|i#x$|i#z$|i#{$|i$O$|i(a$|i(r$|i!]$|i!^$|i~P''VO!Q*OO'y*PO(z%POP'iaR'ia['iaj'ian'iar'ia!S'ia!l'ia!p'ia#R'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#v'ia#x'ia#z'ia#{'ia$O'ia(a'ia(r'ia(y'ia!]'ia!^'ia~O!Q*OO'y*POP'kaR'ka['kaj'kan'kar'ka!S'ka!l'ka!p'ka#R'ka#n'ka#o'ka#p'ka#q'ka#r'ka#s'ka#t'ka#u'ka#v'ka#x'ka#z'ka#{'ka$O'ka(a'ka(r'ka(y'ka(z'ka!]'ka!^'ka~O(y$}OP%aiR%ai[%aij%ain%air%ai!Q%ai!S%ai!l%ai!p%ai#R%ai#n%ai#o%ai#p%ai#q%ai#r%ai#s%ai#t%ai#u%ai#v%ai#x%ai#z%ai#{%ai$O%ai'y%ai(a%ai(r%ai(z%ai!]%ai!^%ai~O(z%POP%ciR%ci[%cij%cin%cir%ci!Q%ci!S%ci!l%ci!p%ci#R%ci#n%ci#o%ci#p%ci#q%ci#r%ci#s%ci#t%ci#u%ci#v%ci#x%ci#z%ci#{%ci$O%ci'y%ci(a%ci(r%ci(y%ci!]%ci!^%ci~O$O$oy!]$oy!^$oy~P#BwO$O#cy!]#cy!^#cy~P#BwO!g#vO!]'eq!k'eq~O!]/pO!k)Oy~O!Y'gq!]'gq~P#/sOr:|O!g#vO(r'pO~O[;QO!Y;PO~P#/sO!Y;PO~Og(_!R!](_!R~P!1WOa%[y!_%[y'z%[y!]%[y~P#/sO!]1TO!^)Xy~O!]5uO!^)Uq~O(T;XO~O!_1oO%i;[O~O!k;_O~O%i;dO~P&8fOP$|qR$|q[$|qj$|qr$|q!S$|q!l$|q!p$|q#R$|q#n$|q#o$|q#p$|q#q$|q#r$|q#s$|q#t$|q#u$|q#v$|q#x$|q#z$|q#{$|q$O$|q(a$|q(r$|q!]$|q!^$|q~P''VO!Q*OO'y*PO(z%POP'jaR'ja['jaj'jan'jar'ja!S'ja!l'ja!p'ja#R'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#v'ja#x'ja#z'ja#{'ja$O'ja(a'ja(r'ja(y'ja!]'ja!^'ja~O!Q*OO'y*POP'laR'la['laj'lan'lar'la!S'la!l'la!p'la#R'la#n'la#o'la#p'la#q'la#r'la#s'la#t'la#u'la#v'la#x'la#z'la#{'la$O'la(a'la(r'la(y'la(z'la!]'la!^'la~OP%OqR%Oq[%Oqj%Oqr%Oq!S%Oq!l%Oq!p%Oq#R%Oq#n%Oq#o%Oq#p%Oq#q%Oq#r%Oq#s%Oq#t%Oq#u%Oq#v%Oq#x%Oq#z%Oq#{%Oq$O%Oq(a%Oq(r%Oq!]%Oq!^%Oq~P''VOg%e!Z!]%e!Z#`%e!Z$O%e!Z~P!1WO!Y;hO~P#/sOr;iO!g#vO(r'pO~O[;kO!Y;hO~P#/sO!]'pq!^'pq~P#BwO!]#h!Z!^#h!Z~P#BwO#k%e!ZP%e!ZR%e!Z[%e!Za%e!Zj%e!Zr%e!Z!S%e!Z!]%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z'z%e!Z(a%e!Z(r%e!Z!k%e!Z!Y%e!Z'w%e!Z#`%e!Zv%e!Z!_%e!Z%i%e!Z!g%e!Z~P#/sOr;tO!g#vO(r'pO~O!Y;uO~P#/sOr;|O!g#vO(r'pO~O!Y;}O~P#/sOP%e!ZR%e!Z[%e!Zj%e!Zr%e!Z!S%e!Z!l%e!Z!p%e!Z#R%e!Z#n%e!Z#o%e!Z#p%e!Z#q%e!Z#r%e!Z#s%e!Z#t%e!Z#u%e!Z#v%e!Z#x%e!Z#z%e!Z#{%e!Z$O%e!Z(a%e!Z(r%e!Z!]%e!Z!^%e!Z~P''VOr<QO!g#vO(r'pO~Ov(fX~P1qO!Q%rO~P!)[O(U!lO~P!)[O!YfX!]fX#`fX~P%2OOP]XR]X[]Xj]Xr]X!Q]X!S]X!]]X!]fX!l]X!p]X#R]X#S]X#`]X#`fX#kfX#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#v]X#x]X#z]X#{]X$Q]X(a]X(r]X(y]X(z]X~O!gfX!k]X!kfX(rfX~P'LTOP<UOQ<UOSfOd>ROe!iOpkOr<UOskOtkOzkO|<UO!O<UO!SWO!WkO!XkO!_XO!i<XO!lZO!o<UO!p<UO!q<UO!s<YO!u<]O!x!hO$W!kO$n>PO(T)]O(VTO(YUO(aVO(o[O~O!]<iO!^$qa~Oh%VOp%WOr%XOs$tOt$tOz%YO|%ZO!O<tO!S${O!_$|O!i>WO!l$xO#j<zO$W%`O$t<vO$v<xO$y%aO(T(vO(VTO(YUO(a$uO(y$}O(z%PO~Ol)dO~P(!yOr!eX(r!eX~P#!iOr(jX(r(jX~P##[O!^]X!^fX~P'LTO!YfX!Y$zX!]fX!]$zX#`fX~P!0SO#k<^O~O!g#vO#k<^O~O#`<nO~Oj<bO~O#`=OO!](wX!^(wX~O#`<nO!](uX!^(uX~O#k=PO~Og=RO~P!1WO#k=XO~O#k=YO~Og=RO(T&ZO~O!g#vO#k=ZO~O!g#vO#k=PO~O$O=[O~P#BwO#k=]O~O#k=^O~O#k=cO~O#k=dO~O#k=eO~O#k=fO~O$O=gO~P!1WO$O=hO~P!1WOl=sO~P7eOk#S#T#U#W#X#[#i#j#u$n$t$v$y%]%^%h%i%j%q%s%v%w%y%{~(OT#o!X'|(U#ps#n#qr!Q'}$]'}(T$_(e~",
	goto: "$9Y)]PPPPPP)^PP)aP)rP+W/]PPPP6mPP7TPP=QPPP@tPA^PA^PPPA^PCfPA^PA^PA^PCjPCoPD^PIWPPPI[PPPPI[L_PPPLeMVPI[PI[PP! eI[PPPI[PI[P!#lI[P!'S!(X!(bP!)U!)Y!)U!,gPPPPPPP!-W!(XPP!-h!/YP!2iI[I[!2n!5z!:h!:h!>gPPP!>oI[PPPPPPPPP!BOP!C]PPI[!DnPI[PI[I[I[I[I[PI[!FQP!I[P!LbP!Lf!Lp!Lt!LtP!IXP!Lx!LxP#!OP#!SI[PI[#!Y#%_CjA^PA^PA^A^P#&lA^A^#)OA^#+vA^#.SA^A^#.r#1W#1W#1]#1f#1W#1qPP#1WPA^#2ZA^#6YA^A^6mPPP#:_PPP#:x#:xP#:xP#;`#:xPP#;fP#;]P#;]#;y#;]#<e#<k#<n)aP#<q)aP#<z#<z#<zP)aP)aP)aP)aPP)aP#=Q#=TP#=T)aP#=XP#=[P)aP)aP)aP)aP)aP)a)aPP#=b#=h#=s#=y#>P#>V#>]#>k#>q#>{#?R#?]#?c#?s#?y#@k#@}#AT#AZ#Ai#BO#Cs#DR#DY#Et#FS#Gt#HS#HY#H`#Hf#Hp#Hv#H|#IW#Ij#IpPPPPPPPPPPP#IvPPPPPPP#Jk#Mx$ b$ i$ qPPP$']P$'f$*_$0x$0{$1O$1}$2Q$2X$2aP$2g$2jP$3W$3[$4S$5b$5g$5}PP$6S$6Y$6^$6a$6e$6i$7e$7|$8e$8i$8l$8o$8y$8|$9Q$9UR!|RoqOXst!Z#d%m&r&t&u&w,s,x2[2_Y!vQ'`-e1o5{Q%tvQ%|yQ&T|Q&j!VS'W!e-]Q'f!iS'l!r!yU*k$|*Z*oQ+o%}S+|&V&WQ,d&dQ-c'_Q-m'gQ-u'mQ0[*qQ1b,OQ1y,eR<{<Y%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_S#q]<V!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU+P%]<s<tQ+t&PQ,f&gQ,m&oQ0x+gQ0}+iQ1Y+uQ2R,kQ3`.gQ5`0|Q5f1TQ6[1zQ7Y3dQ8`5gR9e7['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S!S!nQ!r!v!y!z$|'W'_'`'l'm'n*k*o*q*r-]-c-e-u0[0_1o5{5}%[$ti#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q&X|Q'U!eS'[%i-`Q+t&PQ,P&WQ,f&gQ0n+SQ1Y+uQ1_+{Q2Q,jQ2R,kQ5f1TQ5o1aQ6[1zQ6_1|Q6`2PQ8`5gQ8c5lQ8|6bQ:X8dQ:f8yQ;V:YR<}*ZrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R,h&k&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'b'r(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>R>S[#]WZ#W#Z'X(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ%wxQ%{yW&Q|&V&W,OQ&_!TQ'c!hQ'e!iQ(q#sS+n%|%}Q+r&PQ,_&bQ,c&dS-l'f'gQ.i(rQ1R+oQ1X+uQ1Z+vQ1^+zQ1t,`S1x,d,eQ2|-mQ5e1TQ5i1WQ5n1`Q6Z1yQ8_5gQ8b5kQ8f5pQ:T8^R;T:U!U$zi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y!^%yy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{Q+h%wQ,T&[Q,W&]Q,b&dQ.h(qQ1s,_U1w,c,d,eQ3e.iQ6U1tS6Y1x1yQ8x6Z#f>T#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o>U<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hW%Ti%V*y>PS&[!Q&iQ&]!RQ&^!SU*}%[%d=sR,R&Y%]%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^T)z$u){V+P%]<s<tW'[!e%i*Z-`S(}#y#zQ+c%rQ+y&SS.b(m(nQ1j,XQ5T0kR8i5u'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S$i$^c#Y#e%q%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.|.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ'Y!eR2q-]!W!nQ!e!r!v!y!z$|'W'_'`'l'm'n*Z*k*o*q*r-]-c-e-u0[0_1o5{5}R1l,ZnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&y!^Q'v!xS(s#u<^Q+l%zQ,]&_Q,^&aQ-j'dQ-w'oS.r(x=PS0q+X=ZQ1P+mQ1n,[Q2c,zQ2e,{Q2m-WQ2z-kQ2}-oS5Y0r=eQ5a1QS5d1S=fQ6t2oQ6x2{Q6}3SQ8]5bQ9Y6vQ9Z6yQ9^7OR:l9V$d$]c#Y#e%s%u(S(Y(t(y)R)S)T)U)V)W)X)Y)Z)[)^)`)b)g)q+d+x-Z-x-}.S.U.s.v.z.}/O/b0p2k2n3O3V3k3p3q3r3s3t3u3v3w3x3y3z3{3|4P4Q4X5X5c6u6{7Q7a7b7k7l8k9X9]9g9m9n:o;W;`<W=vS(o#p'iQ)P#zS+b%q.|S.c(n(pR3^.d'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS#q]<VQ&t!XQ&u!YQ&w![Q&x!]R2Z,vQ'a!hQ+e%wQ-h'cS.e(q+hQ2x-gW3b.h.i0w0yQ6w2yW7U3_3a3e5^U9a7V7X7ZU:q9c9d9fS;b:p:sQ;p;cR;x;qU!wQ'`-eT5y1o5{!Q_OXZ`st!V!Z#d#h%e%m&i&k&r&t&u&w(j,s,x.[2[2_]!pQ!r'`-e1o5{T#q]<V%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S(}#y#zS.b(m(n!s=l$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SU$fd)_,mS(p#p'iU*v%R(w4OU0m+O.n7gQ5^0xQ7V3`Q9d7YR:s9em!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}Q't!uS(f#g2US-s'k'wQ/s*]Q0R*jQ3U-vQ4f/tQ4r0TQ4s0UQ4x0^Q7r4`S7}4t4vS8R4y4{Q9r7sQ9v7yQ9{8OQ:Q8TS:{9w9xS;g:|;PS;s;h;iS;{;t;uS<P;|;}R<S<QQ#wbQ's!uS(e#g2US(g#m+WQ+Y%fQ+j%xQ+p&OU-r'k't'wQ.W(fU/r*]*`/wQ0S*jQ0V*lQ1O+kQ1u,aS3R-s-vQ3Z.`S4e/s/tQ4n0PS4q0R0^Q4u0WQ6W1vQ7P3US7q4`4bQ7u4fU7|4r4x4{Q8P4wQ8v6XS9q7r7sQ9u7yQ9}8RQ:O8SQ:c8wQ:y9rS:z9v9xQ;S:QQ;^:dS;f:{;PS;r;g;hS;z;s;uS<O;{;}Q<R<PQ<T<SQ=o=jQ={=tR=|=uV!wQ'`-e%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_S#wz!j!r=i$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=o>R%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Q%fj!^%xy!i!u%{%|%}'V'e'f'g'k'u*j+n+o-Y-l-m-t0R0U1R2u2|3T4r4s4v7}9{S&Oz!jQ+k%yQ,a&dW1v,b,c,d,eU6X1w1x1yS8w6Y6ZQ:d8x!r=j$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ=t>QR=u>R%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_Y#bWZ#W#Z(T!b%jm#h#i#l$x%e%h(^(h(i(j*Y*^*b+Z+[+^,o-V.T.Z.[.]._/m/p2d3[3]4a6r7TQ,n&o!p=k$Z$n)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SR=n'XU']!e%i*ZR2s-`%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+],p,s,x-i-q.P.V.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3l4z6T6e6f6i6|8t9T9_!r)_$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SQ,m&oQ0x+gQ3`.gQ7Y3dR9e7[!b$Tc#Y%q(S(Y(t(y)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!P<d)^)q-Z.|2k2n3p3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!f$Vc#Y%q(S(Y(t(y)W)X)Z)[)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<W!T<f)^)q-Z.|2k2n3p3v3w3y3z4P4X6u7b7k7l8k9X9g9m9n;W;`=v!^$Zc#Y%q(S(Y(t(y)`)g+x-x-}.S.U.s.v/b0p3O3V3k3{5X5c6{7Q7a9]:o<WQ4_/kz>S)^)q-Z.|2k2n3p4P4X6u7b7k7l8k9X9g9m9n;W;`=vQ>X>ZR>Y>['QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>SS$oh$pR4U/U'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$kf$qQ$ifS)j$l)nR)v$qT$jf$qT)l$l)n'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%m%t&R&k&n&o&r&t&u&w&{'T'X'b'r(T(V(](d(x(z)O)s)}*i+X+]+g,p,s,x-U-X-i-q.P.V.g.t.{/U/V/n0]0l0r1S1r2S2T2V2X2[2_2a2p3Q3W3d3l4T4z5w6T6e6f6i6s6|7[8t9T9_:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>ST$oh$pQ$rhR)u$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%m%t&R&k&n&o&r&t&u&w&{'T'b'r(T(V(](d(x(z)O)}*i+X+]+g,p,s,x-i-q.P.V.g.t.{/n0]0l0r1S1r2S2T2V2X2[2_2a3Q3W3d3l4z6T6e6f6i6|7[8t9T9_!s>Q$Z$n'X)s-U-X/V2p4T5w6s:Z:m<U<X<Y<]<^<_<`<a<b<c<d<e<f<g<h<i<k<n<{=O=P=R=Z=[=e=f>S#glOPXZst!Z!`!o#S#d#o#{$n%m&k&n&o&r&t&u&w&{'T'b)O)s*i+]+g,p,s,x-i.g/V/n0]0l1r2S2T2V2X2[2_2a3d4T4z6T6e6f6i7[8t9T!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^Q+T%aQ/c*Oo4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!U$yi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>YQ*c$zU*l$|*Z*oQ+U%bQ0W*m#f=q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n=r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hQ=w>TQ=x>UQ=y>VR=z>W!U%Ri$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y#f(w#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^o4O<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=hnoOXst!Z#d%m&r&t&u&w,s,x2[2_S*f${*YQ-R'OQ-S'QR4i/y%[%Si#v$b$c$d$x${%O%Q%^%_%c)y*R*T*V*Y*a*g*w*x+f+i,S,V.f/P/d/m/x/y/{0`0b0i0j0o1f1i1q3c4^4_4j4o5Q5[5_6S7W7v8Q8V8[8q9b9p9y:P:`:r;Q;[;d;k<l<m<o<p<q<r<u<v<w<x<y<z=S=T=U=V=X=Y=]=^=_=`=a=b=c=d=g=h>P>X>Y>]>^Q,U&]Q1h,WQ5s1gR8h5tV*n$|*Z*oU*n$|*Z*oT5z1o5{S0P*i/nQ4w0]T8S4z:]Q+j%xQ0V*lQ1O+kQ1u,aQ6W1vQ8v6XQ:c8wR;^:d!U%Oi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Yx*R$v)e*S*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>OS0`*t0a#f<o#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<p<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!d=S(u)c*[*e.j.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[`=T3}7c7f7j9h:t:w;yS=_.l3iT=`7e9k!U%Qi$d%O%Q%^%_%c*R*T*a*w*x/P/x0`0b0i0j0o4_5Q8V9p>P>X>Y|*T$v)e*U*t+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>OS0b*u0c#f<q#v$b$c$x${)y*V*Y*g+f+i,S,V.f/d/m/y/{1f1i1q3c4^4j4o5[5_6S7W7v8Q8[8q9b9y:P:`:r;Q;[;d;k<o<q<u<w<y=S=U=X=]=_=a=c=g>]>^n<r<l<m<p<r<v<x<z=T=V=Y=^=`=b=d=h!h=U(u)c*[*e.k.l.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[d=V3}7d7e7j9h9i:t:u:w;yS=a.m3jT=b7f9lrnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q&f!UR,p&ornOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_R&f!UQ,Y&^R1d,RsnOXst!V!Z#d%m&i&r&t&u&w,s,x2[2_Q1p,_S6R1s1tU8p6P6Q6US:_8r8sS;Y:^:aQ;m;ZR;w;nQ&m!VR,i&iR6_1|R:f8yW&Q|&V&W,OR1Z+vQ&r!WR,s&sR,y&xT2],x2_R,}&yQ,|&yR2f,}Q'y!{R-y'ySsOtQ#dXT%ps#dQ#OTR'{#OQ#RUR'}#RQ){$uR/`){Q#UVR(Q#UQ#XWU(W#X(X.QQ(X#YR.Q(YQ-^'YR2r-^Q.u(yS3m.u3nR3n.vQ-e'`R2v-eY!rQ'`-e1o5{R'j!rQ/Q)eR4S/QU#_W%h*YU(_#_(`.RQ(`#`R.R(ZQ-a']R2t-at`OXst!V!Z#d%m&i&k&r&t&u&w,s,x2[2_S#hZ%eU#r`#h.[R.[(jQ(k#jQ.X(gW.a(k.X3X7RQ3X.YR7R3YQ)n$lR/W)nQ$phR)t$pQ$`cU)a$`-|<jQ-|<WR<j)qQ/q*]W4c/q4d7t9sU4d/r/s/tS7t4e4fR9s7u$e*Q$v(u)c)e*[*e*t*u+Q+R+V.l.m.o.p.q/_/g/i/k/v/|0d0e0v1e3f3g3h3}4R4[4g4h4l4|5O5R5S5W5r7]7^7_7`7e7f7h7i7j7p7w7z8U8X8Z9h9i9j9t9|:R:S:t:u:v:w:x:};R;e;j;v;y=p=}>O>Z>[Q/z*eU4k/z4m7xQ4m/|R7x4lS*o$|*ZR0Y*ox*S$v)e*t*u+V/v0d0e4R4g5R5S5W7p8U:R:x=p=}>O!d.j(u)c*[*e.l.m.q/_/k/|0v1e3h4[4h4l5r7]7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/h*S.j7ca7c3}7e7f7j9h:t:w;yQ0a*tQ3i.lU4}0a3i9kR9k7e|*U$v)e*t*u+V/g/v0d0e4R4g4|5R5S5W7p8U:R:x=p=}>O!h.k(u)c*[*e.l.m.q/_/k/|0v1e3f3h4[4h4l5r7]7^7`7w7z8X8Z9t9|:S:};R;e;j;v>Z>[U/j*U.k7de7d3}7e7f7j9h9i:t:u:w;yQ0c*uQ3j.mU5P0c3j9lR9l7fQ*z%UR0g*zQ5]0vR8Y5]Q+_%kR0u+_Q5v1jS8j5v:[R:[8kQ,[&_R1m,[Q5{1oR8m5{Q1{,fS6]1{8zR8z6_Q1U+rW5h1U5j8a:VQ5j1XQ8a5iR:V8bQ+w&QR1[+wQ2_,xR6m2_YrOXst#dQ&v!ZQ+a%mQ,r&rQ,t&tQ,u&uQ,w&wQ2Y,sS2],x2_R6l2[Q%opQ&z!_Q&}!aQ'P!bQ'R!cQ'q!uQ+`%lQ+l%zQ,Q&XQ,h&mQ-P&|W-p'k's't'wQ-w'oQ0X*nQ1P+mQ1c,PS2O,i,lQ2g-OQ2h-RQ2i-SQ2}-oW3P-r-s-v-xQ5a1QQ5m1_Q5q1eQ6V1uQ6a2QQ6k2ZU6z3O3R3UQ6}3SQ8]5bQ8e5oQ8g5rQ8l5zQ8u6WQ8{6`S9[6{7PQ9^7OQ:W8cQ:b8vQ:g8|Q:n9]Q;U:XQ;]:cQ;a:oQ;l;VR;o;^Q%zyQ'd!iQ'o!uU+m%{%|%}Q-W'VU-k'e'f'gS-o'k'uQ0Q*jS1Q+n+oQ2o-YS2{-l-mQ3S-tS4p0R0UQ5b1RQ6v2uQ6y2|Q7O3TU7{4r4s4vQ9z7}R;O9{S$wi>PR*{%VU%Ui%V>PR0f*yQ$viS(u#v+iS)c$b$cQ)e$dQ*[$xS*e${*YQ*t%OQ*u%QQ+Q%^Q+R%_Q+V%cQ.l<oQ.m<qQ.o<uQ.p<wQ.q<yQ/_)yQ/g*RQ/i*TQ/k*VQ/v*aS/|*g/mQ0d*wQ0e*xl0v+f,V.f1i1q3c6S7W8q9b:`:r;[;dQ1e,SQ3f=SQ3g=UQ3h=XS3}<l<mQ4R/PS4[/d4^Q4g/xQ4h/yQ4l/{Q4|0`Q5O0bQ5R0iQ5S0jQ5W0oQ5r1fQ7]=]Q7^=_Q7_=aQ7`=cQ7e<pQ7f<rQ7h<vQ7i<xQ7j<zQ7p4_Q7w4jQ7z4oQ8U5QQ8X5[Q8Z5_Q9h=YQ9i=TQ9j=VQ9t7vQ9|8QQ:R8VQ:S8[Q:t=^Q:u=`Q:v=bQ:w=dQ:x9pQ:}9yQ;R:PQ;e=gQ;j;QQ;v;kQ;y=hQ=p>PQ=}>XQ>O>YQ>Z>]R>[>^Q+O%]Q.n<sR7g<tnpOXst!Z#d%m&r&t&u&w,s,x2[2_Q!fPS#fZ#oQ&|!`W'h!o*i0]4zQ(P#SQ)Q#{Q)r$nS,l&k&nQ,q&oQ-O&{S-T'T/nQ-g'bQ.x)OQ/[)sQ0s+]Q0y+gQ2W,pQ2y-iQ3a.gQ4W/VQ5U0lQ6Q1rQ6c2SQ6d2TQ6h2VQ6j2XQ6o2aQ7Z3dQ7m4TQ8s6TQ9P6eQ9Q6fQ9S6iQ9f7[Q:a8tR:k9T#[cOPXZst!Z!`!o#d#o#{%m&k&n&o&r&t&u&w&{'T'b)O*i+]+g,p,s,x-i.g/n0]0l1r2S2T2V2X2[2_2a3d4z6T6e6f6i7[8t9TQ#YWQ#eYQ%quQ%svS%uw!gS(S#W(VQ(Y#ZQ(t#uQ(y#xQ)R$OQ)S$PQ)T$QQ)U$RQ)V$SQ)W$TQ)X$UQ)Y$VQ)Z$WQ)[$XQ)^$ZQ)`$_Q)b$aQ)g$eW)q$n)s/V4TQ+d%tQ+x&RS-Z'X2pQ-x'rS-}(T.PQ.S(]Q.U(dQ.s(xQ.v(zQ.z<UQ.|<XQ.}<YQ/O<]Q/b)}Q0p+XQ2k-UQ2n-XQ3O-qQ3V.VQ3k.tQ3p<^Q3q<_Q3r<`Q3s<aQ3t<bQ3u<cQ3v<dQ3w<eQ3x<fQ3y<gQ3z<hQ3{.{Q3|<kQ4P<nQ4Q<{Q4X<iQ5X0rQ5c1SQ6u=OQ6{3QQ7Q3WQ7a3lQ7b=PQ7k=RQ7l=ZQ8k5wQ9X6sQ9]6|Q9g=[Q9m=eQ9n=fQ:o9_Q;W:ZQ;`:mQ<W#SR=v>SR#[WR'Z!el!tQ!r!v!y!z'`'l'm'n-e-u1o5{5}S'V!e-]U*j$|*Z*oS-Y'W'_S0U*k*qQ0^*rQ2u-cQ4v0[R4{0_R({#xQ!fQT-d'`-e]!qQ!r'`-e1o5{Q#p]R'i<VR)f$dY!uQ'`-e1o5{Q'k!rS'u!v!yS'w!z5}S-t'l'mQ-v'nR3T-uT#kZ%eS#jZ%eS%km,oU(g#h#i#lS.Y(h(iQ.^(jQ0t+^Q3Y.ZU3Z.[.]._S7S3[3]R9`7Td#^W#W#Z%h(T(^*Y+Z.T/mr#gZm#h#i#l%e(h(i(j+^.Z.[.]._3[3]7TS*]$x*bQ/t*^Q2U,oQ2l-VQ4`/pQ6q2dQ7s4aQ9W6rT=m'X+[V#aW%h*YU#`W%h*YS(U#W(^U(Z#Z+Z/mS-['X+[T.O(T.TV'^!e%i*ZQ$lfR)x$qT)m$l)nR4V/UT*_$x*bT*h${*YQ0w+fQ1g,VQ3_.fQ5t1iQ6P1qQ7X3cQ8r6SQ9c7WQ:^8qQ:p9bQ;Z:`Q;c:rQ;n;[R;q;dnqOXst!Z#d%m&r&t&u&w,s,x2[2_Q&l!VR,h&itmOXst!U!V!Z#d%m&i&r&t&u&w,s,x2[2_R,o&oT%lm,oR1k,XR,g&gQ&U|S+}&V&WR1^,OR+s&PT&p!W&sT&q!W&sT2^,x2_",
	nodeNames: "⚠ ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList in out const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration defer ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
	maxTerm: 380,
	context: mC,
	nodeProps: [
		[
			"isolate",
			-8,
			5,
			6,
			14,
			37,
			39,
			51,
			53,
			55,
			""
		],
		[
			"group",
			-26,
			9,
			17,
			19,
			68,
			207,
			211,
			215,
			216,
			218,
			221,
			224,
			234,
			237,
			243,
			245,
			247,
			249,
			252,
			258,
			264,
			266,
			268,
			270,
			272,
			274,
			275,
			"Statement",
			-34,
			13,
			14,
			32,
			35,
			36,
			42,
			51,
			54,
			55,
			57,
			62,
			70,
			72,
			76,
			80,
			82,
			84,
			85,
			110,
			111,
			120,
			121,
			136,
			139,
			141,
			142,
			143,
			144,
			145,
			147,
			148,
			167,
			169,
			171,
			"Expression",
			-23,
			31,
			33,
			37,
			41,
			43,
			45,
			173,
			175,
			177,
			178,
			180,
			181,
			182,
			184,
			185,
			186,
			188,
			189,
			190,
			201,
			203,
			205,
			206,
			"Type",
			-3,
			88,
			103,
			109,
			"ClassItem"
		],
		[
			"openedBy",
			23,
			"<",
			38,
			"InterpolationStart",
			56,
			"[",
			60,
			"{",
			73,
			"(",
			160,
			"JSXStartCloseTag"
		],
		[
			"closedBy",
			-2,
			24,
			168,
			">",
			40,
			"InterpolationEnd",
			50,
			"]",
			61,
			"}",
			74,
			")",
			165,
			"JSXEndTag"
		]
	],
	propSources: [xC],
	skippedNodes: [
		0,
		5,
		6,
		278
	],
	repeatNodeCount: 37,
	tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$i&j(Wp(Z!b'|0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(X#S$i&j'}0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$i&j(Wp(Z!b'}0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$i&j!p),Q(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#v(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(V':f$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$i&j(Z!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$i&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$d`$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$d``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$d`$i&j(Z!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(Z!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$d`(Z!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$i&j(Wp(Z!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$i&j(Wp(Z!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$i&j(Z!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$i&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(Z!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$i&j(WpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(WpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Wp(Z!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$i&j(o%1l(Wp(Z!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$i&j(Wp(Z!b$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$i&j(Wp(Z!b$]#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$i&j(Wp(Z!b#p(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$i&j$Q(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(z+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$i&j#z(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(Y';W$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$i&j(WpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$i&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$d`$i&j(WpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(WpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$d`(WpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!l/.^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!k!Lf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$i&j(Wp(Z!b(U%&f#q(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$i&j(Wp(Z!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$i&j(Wp(Z!br+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!]+Jf$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$i&j(Wp(Z!b!Q.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_![!L^$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$i&j(Wp(Z!b#o(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$i&j(Z!b!X7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$i&j!X7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$i&j!X7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!X7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!X7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$i&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$i&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$i&j(Z!b!X7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(Z!b!X7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(Z!b!X7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(Z!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$i&j(Z!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$i&j(Wp!X7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$i&j(Wp!X7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Wp!X7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Wp!X7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(WpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$i&j(WpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$i&j(Wp(Z!b!X7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Wp(Z!b!X7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Wp(Z!b!X7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Wp(Z!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$i&j(Wp(Z!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$i&j(Wp(Z!b(O0/l!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$i&j(Wp(Z!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$i&j(Z!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$i&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(Z!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$i&j(WpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(WpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Wp(Z!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$i&j$Q(Ch(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Z#t$i&j(Wp(Z!b!X7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$i&j(Wp(Z!bs'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!g$b$i&j$O)Lv(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#R-<U(Wp(Z!b$n7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$k&j(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#r(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$Q(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#s(Ch(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#`*!Y$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#k(Cl$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#s(Ch$f#|$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#s(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#r(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(r(Ct$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$i&j#{(Ch(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!|$Ip$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!S0,v$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$i&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$i&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$i&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$i&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$i&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$i&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!Y#)l$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#x(Ch$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$i&j(Wp(Z!b(a+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$i&j(Wp(Z!b(T,2j$_#t(e$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$i&j(Wp(Z!b$_#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!_#Hb(Wp(Z!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(y+JY$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_!^(CdvBr$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!q7`$i&j(Wp(Z!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$i&j(Wp(Z!b'|0/l$]#t(T,2j(e$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$i&j(Wp(Z!b'}0/l$]#t(T,2j(e$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
	tokenizers: [
		gC,
		_C,
		vC,
		bC,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		hC,
		new yS("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOx~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!U~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(c~~", 141, 340),
		new yS("j~RQYZXz{^~^O(Q~~aP!P!Qd~iO(R~~", 25, 323)
	],
	topRules: {
		Script: [0, 7],
		SingleExpression: [1, 276],
		SingleClassItem: [2, 277]
	},
	dialects: {
		jsx: 0,
		ts: 15175
	},
	dynamicPrecedences: {
		80: 1,
		82: 1,
		94: 1,
		169: 1,
		199: 1
	},
	specialized: [
		{
			term: 327,
			get: (e) => SC[e] || -1
		},
		{
			term: 343,
			get: (e) => CC[e] || -1
		},
		{
			term: 95,
			get: (e) => wC[e] || -1
		}
	],
	tokenPrec: 15201
}), EC = [
	/*@__PURE__*/ Wb("function ${name}(${params}) {\n	${}\n}", {
		label: "function",
		detail: "definition",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
		label: "for",
		detail: "loop",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("for (let ${name} of ${collection}) {\n	${}\n}", {
		label: "for",
		detail: "of loop",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("do {\n	${}\n} while (${})", {
		label: "do",
		detail: "loop",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("while (${}) {\n	${}\n}", {
		label: "while",
		detail: "loop",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("try {\n	${}\n} catch (${error}) {\n	${}\n}", {
		label: "try",
		detail: "/ catch block",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("if (${}) {\n	${}\n}", {
		label: "if",
		detail: "block",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("if (${}) {\n	${}\n} else {\n	${}\n}", {
		label: "if",
		detail: "/ else block",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("class ${name} {\n	constructor(${params}) {\n		${}\n	}\n}", {
		label: "class",
		detail: "definition",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("import {${names}} from \"${module}\"\n${}", {
		label: "import",
		detail: "named",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("import ${name} from \"${module}\"\n${}", {
		label: "import",
		detail: "default",
		type: "keyword"
	})
], DC = /*@__PURE__*/ EC.concat([
	/*@__PURE__*/ Wb("interface ${name} {\n	${}\n}", {
		label: "interface",
		detail: "definition",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("type ${name} = ${type}", {
		label: "type",
		detail: "definition",
		type: "keyword"
	}),
	/*@__PURE__*/ Wb("enum ${name} {\n	${}\n}", {
		label: "enum",
		detail: "definition",
		type: "keyword"
	})
]), OC = /*@__PURE__*/ new Dp(), kC = /*@__PURE__*/ new Set([
	"Script",
	"Block",
	"FunctionExpression",
	"FunctionDeclaration",
	"ArrowFunction",
	"MethodDeclaration",
	"ForStatement"
]);
function AC(e) {
	return (t, n) => {
		let r = t.node.getChild("VariableDefinition");
		return r && n(r, e), !0;
	};
}
var jC = ["FunctionDeclaration"], MC = {
	FunctionDeclaration: /*@__PURE__*/ AC("function"),
	ClassDeclaration: /*@__PURE__*/ AC("class"),
	ClassExpression: () => !0,
	EnumDeclaration: /*@__PURE__*/ AC("constant"),
	TypeAliasDeclaration: /*@__PURE__*/ AC("type"),
	NamespaceDeclaration: /*@__PURE__*/ AC("namespace"),
	VariableDefinition(e, t) {
		e.matchContext(jC) || t(e, "variable");
	},
	TypeDefinition(e, t) {
		t(e, "type");
	},
	__proto__: null
};
function NC(e, t) {
	let n = OC.get(t);
	if (n) return n;
	let r = [], i = !0;
	function a(t, n) {
		let i = e.sliceString(t.from, t.to);
		r.push({
			label: i,
			type: n
		});
	}
	return t.cursor(op.IncludeAnonymous).iterate((t) => {
		if (i) i = !1;
		else if (t.name) {
			let e = MC[t.name];
			if (e && e(t, a) || kC.has(t.name)) return !1;
		} else if (t.to - t.from > 8192) {
			for (let n of NC(e, t.node)) r.push(n);
			return !1;
		}
	}), OC.set(t, r), r;
}
var PC = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/, FC = [
	"TemplateString",
	"String",
	"RegExp",
	"LineComment",
	"BlockComment",
	"VariableDefinition",
	"TypeDefinition",
	"Label",
	"PropertyDefinition",
	"PropertyName",
	"PrivatePropertyDefinition",
	"PrivatePropertyName",
	"JSXText",
	"JSXAttributeValue",
	"JSXOpenTag",
	"JSXCloseTag",
	"JSXSelfClosingTag",
	".",
	"?."
];
function IC(e) {
	let t = dm(e.state).resolveInner(e.pos, -1);
	if (FC.indexOf(t.name) > -1) return null;
	let n = t.name == "VariableName" || t.to - t.from < 20 && PC.test(e.state.sliceDoc(t.from, t.to));
	if (!n && !e.explicit) return null;
	let r = [];
	for (let n = t; n; n = n.parent) kC.has(n.name) && (r = r.concat(NC(e.state.doc, n)));
	return {
		options: r,
		from: n ? t.from : e.pos,
		validFor: PC
	};
}
var LC = /*@__PURE__*/ um.define({
	name: "javascript",
	parser: /*@__PURE__*/ TC.configure({ props: [/*@__PURE__*/ Om.add({
		IfStatement: /*@__PURE__*/ Bm({ except: /^\s*({|else\b)/ }),
		TryStatement: /*@__PURE__*/ Bm({ except: /^\s*({|catch\b|finally\b)/ }),
		LabeledStatement: zm,
		SwitchBody: (e) => {
			let t = e.textAfter, n = /^\s*\}/.test(t), r = /^\s*(case|default)\b/.test(t);
			return e.baseIndent + (n ? 0 : r ? 1 : 2) * e.unit;
		},
		Block: /*@__PURE__*/ Lm({ closing: "}" }),
		ArrowFunction: (e) => e.baseIndent + e.unit,
		"TemplateString BlockComment": () => null,
		"Statement Property": /*@__PURE__*/ Bm({ except: /^\s*{/ }),
		JSXElement(e) {
			let t = /^\s*<\//.test(e.textAfter);
			return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
		},
		JSXEscape(e) {
			let t = /\s*\}/.test(e.textAfter);
			return e.lineIndent(e.node.from) + (t ? 0 : e.unit);
		},
		"JSXOpenTag JSXSelfClosingTag"(e) {
			return e.column(e.node.from) + e.unit;
		}
	}), /*@__PURE__*/ Wm.add({
		"Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": Gm,
		BlockComment(e) {
			return {
				from: e.from + 2,
				to: e.to - 2
			};
		},
		JSXElement(e) {
			let t = e.firstChild;
			if (!t || t.name == "JSXSelfClosingTag") return null;
			let n = e.lastChild;
			return {
				from: t.to,
				to: n.type.isError ? e.to : n.from
			};
		},
		"JSXSelfClosingTag JSXOpenTag"(e) {
			let t = e.firstChild?.nextSibling, n = e.lastChild;
			return !t || t.type.isError ? null : {
				from: t.to,
				to: n.type.isError ? e.to : n.from
			};
		}
	})] }),
	languageData: {
		closeBrackets: { brackets: [
			"(",
			"[",
			"{",
			"'",
			"\"",
			"`"
		] },
		commentTokens: {
			line: "//",
			block: {
				open: "/*",
				close: "*/"
			}
		},
		indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
		wordChars: "$"
	}
}), RC = {
	test: (e) => /^JSX/.test(e.name),
	facet: /*@__PURE__*/ om({ commentTokens: { block: {
		open: "{/*",
		close: "*/}"
	} } })
}, zC = /*@__PURE__*/ LC.configure({ dialect: "ts" }, "typescript"), BC = /*@__PURE__*/ LC.configure({
	dialect: "jsx",
	props: [/*@__PURE__*/ sm.add((e) => e.isTop ? [RC] : void 0)]
}), VC = /*@__PURE__*/ LC.configure({
	dialect: "jsx ts",
	props: [/*@__PURE__*/ sm.add((e) => e.isTop ? [RC] : void 0)]
}, "typescript"), HC = (e) => ({
	label: e,
	type: "keyword"
}), UC = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map(HC), WC = /*@__PURE__*/ UC.concat(/*@__PURE__*/ [
	"declare",
	"implements",
	"private",
	"protected",
	"public"
].map(HC));
function GC(e = {}) {
	let t = e.jsx ? e.typescript ? VC : BC : e.typescript ? zC : LC, n = e.typescript ? DC.concat(WC) : EC.concat(UC);
	return new xm(t, [
		LC.data.of({ autocomplete: Py(FC, Ny(n)) }),
		LC.data.of({ autocomplete: IC }),
		e.jsx ? YC : []
	]);
}
function KC(e) {
	for (;;) {
		if (e.name == "JSXOpenTag" || e.name == "JSXSelfClosingTag" || e.name == "JSXFragmentTag") return e;
		if (e.name == "JSXEscape" || !e.parent) return null;
		e = e.parent;
	}
}
function qC(e, t, n = e.length) {
	for (let r = t?.firstChild; r; r = r.nextSibling) if (r.name == "JSXIdentifier" || r.name == "JSXBuiltin" || r.name == "JSXNamespacedName" || r.name == "JSXMemberExpression") return e.sliceString(r.from, Math.min(r.to, n));
	return "";
}
var JC = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent), YC = /*@__PURE__*/ q.inputHandler.of((e, t, n, r, i) => {
	if ((JC ? e.composing : e.compositionStarted) || e.state.readOnly || t != n || r != ">" && r != "/" || !LC.isActiveAt(e.state, t, -1)) return !1;
	let a = i(), { state: o } = a, s = o.changeByRange((e) => {
		let { head: t } = e, n = dm(o).resolveInner(t - 1, -1), i;
		if (n.name == "JSXStartTag" && (n = n.parent), !(o.doc.sliceString(t - 1, t) != r || n.name == "JSXAttributeValue" && n.to > t)) {
			if (r == ">" && n.name == "JSXFragmentTag") return {
				range: e,
				changes: {
					from: t,
					insert: "</>"
				}
			};
			if (r == "/" && n.name == "JSXStartCloseTag") {
				let e = n.parent, r = e.parent;
				if (r && e.from == t - 2 && ((i = qC(o.doc, r.firstChild, t)) || r.firstChild?.name == "JSXFragmentTag")) {
					let e = `${i}>`;
					return {
						range: U.cursor(t + e.length, -1),
						changes: {
							from: t,
							insert: e
						}
					};
				}
			} else if (r == ">") {
				let r = KC(n);
				if (r && r.name == "JSXOpenTag" && !/^\/?>|^<\//.test(o.doc.sliceString(t, t + 2)) && (i = qC(o.doc, r, t))) return {
					range: e,
					changes: {
						from: t,
						insert: `</${i}>`
					}
				};
			}
		}
		return { range: e };
	});
	return s.changes.empty ? !1 : (e.dispatch([a, o.update(s, {
		userEvent: "input.complete",
		scrollIntoView: !0
	})]), !0);
}), XC = ["aria-label"], ZC = { class: "code-editor-actions" }, QC = {
	key: 0,
	class: "code-editor-hint-message"
}, $C = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HFormCodeEditor",
	inheritAttrs: !1
}, {
	__name: "form-code-editor",
	props: {
		modelValue: {
			type: String,
			default: ""
		},
		language: {
			type: String,
			default: "json",
			validator: (e) => [
				"json",
				"javascript",
				"text"
			].includes(e)
		},
		label: {
			type: String,
			default: void 0
		},
		icon: {
			type: String,
			default: "mdi:mdi-code-json"
		},
		iconColor: {
			type: String,
			default: void 0
		},
		iconSize: {
			type: String,
			default: "small"
		},
		required: {
			type: Boolean,
			default: !1
		},
		error: {
			type: Boolean,
			default: void 0
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: "outlined"
		},
		bgColor: {
			type: String,
			default: "white"
		},
		color: {
			type: String,
			default: "on-surface"
		},
		baseColor: {
			type: String,
			default: "on-surface-variant"
		},
		rounded: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		density: {
			type: String,
			default: "comfortable"
		},
		hideDetails: {
			type: [Boolean, String],
			default: "auto"
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		rows: {
			type: [String, Number],
			default: 8
		},
		autoGrow: {
			type: Boolean,
			default: !0
		},
		placeholder: {
			type: String,
			default: ""
		},
		rules: {
			type: Array,
			default: () => []
		},
		hint: {
			type: String,
			default: void 0
		},
		persistentHint: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: s }) {
		let c = z(e, "HFormCodeEditor"), u = s, d = ne(null), f = A(null), p = A(""), m = A(!1), h = A(""), g = n(() => {
			let e = f.value?.isValid === !1;
			return m.value || e;
		}), _ = n(() => [...c.rules, (e) => {
			if (!e || e.trim() === "") return !0;
			if (c.language === "json") try {
				return JSON.parse(e), !0;
			} catch (e) {
				return `${B("json_invalid")}: ${e.message}`;
			}
			if (c.language === "javascript") try {
				return Function(e), !0;
			} catch (e) {
				return `${B("javascript_invalid")}: ${e.message}`;
			}
			return !0;
		}]), v = n(() => ["json"].includes(c.language)), b = n(() => ({
			json: "Format JSON",
			javascript: "Format JavaScript",
			text: "Plain text"
		})[c.language] || "Format Code"), S = n(() => `${(c.density === "compact" ? 20 : c.density === "comfortable" ? 24 : 28) * Number(c.rows)}px`), w = n(() => {
			let e = c.label || B("code_editor"), t = [
				q.lineWrapping,
				q.editable.of(!c.disabled),
				q.contentAttributes.of({
					"aria-label": e,
					"aria-multiline": "true"
				})
			];
			return c.language === "json" ? t.unshift(US(), Ix(BS())) : c.language === "javascript" && t.unshift(GC()), t;
		});
		function T(e) {
			d.value = e.view;
		}
		function E(e) {
			e.key === "Enter" && e.stopPropagation();
		}
		function D(e) {
			ee(e);
		}
		function k() {
			j();
		}
		I(() => c.modelValue, (e) => {
			if (e !== p.value && (p.value = e || "", e)) if (c.language === "json") try {
				let t = JSON.parse(e);
				p.value = JSON.stringify(t, null, 2), m.value = !1, h.value = "";
			} catch {
				ee(e);
			}
			else c.language === "javascript" && ee(e);
		}, { immediate: !0 }), I(p, (e) => {
			u("update:modelValue", e);
		});
		function ee(e = p.value) {
			if (!e || e.trim() === "") return m.value = !1, h.value = "", !0;
			if (c.language === "json") try {
				return JSON.parse(e), m.value = !1, h.value = "", !0;
			} catch (e) {
				return m.value = !0, h.value = `${B("json_invalid")}: ${e.message}`, !1;
			}
			if (c.language === "javascript") try {
				return Function(e), m.value = !1, h.value = "", !0;
			} catch (e) {
				return m.value = !0, h.value = `${B("javascript_invalid")}: ${e.message}`, !1;
			}
			return !0;
		}
		function j() {
			if (!p.value || p.value.trim() === "") {
				m.value = !1, h.value = "";
				return;
			}
			if (c.language === "json") try {
				let e = JSON.parse(p.value);
				p.value = JSON.stringify(e, null, 2), m.value = !1, h.value = "";
			} catch (e) {
				m.value = !0, h.value = `${B("json_invalid")}: ${e.message}`;
			}
			c.language;
		}
		function M() {
			d.value && d.value.focus();
		}
		return t({
			view: d,
			focus: M,
			formatCode: j,
			validateCode: ee
		}), (t, n) => (O(), r(ir, {
			label: e.label,
			icon: e.icon,
			"icon-color": e.iconColor,
			"icon-size": e.iconSize,
			required: e.required,
			error: e.error || g.value,
			"aria-label": e.ariaLabel
		}, {
			default: L(() => [l(ot, {
				ref_key: "vInputRef",
				ref: f,
				modelValue: p.value,
				"onUpdate:modelValue": n[1] ||= (e) => p.value = e,
				rules: _.value,
				"hide-details": "auto",
				class: "code-editor-v-input"
			}, {
				default: L(() => [o("div", {
					class: "code-editor-wrapper",
					role: "application",
					"aria-label": e.label || F(B)("code_editor"),
					onKeydown: E
				}, [o("div", { class: x(["code-editor-container", {
					"code-editor-error": g.value,
					"code-editor-disabled": e.disabled
				}]) }, [l(F(lS), {
					modelValue: p.value,
					"onUpdate:modelValue": n[0] ||= (e) => p.value = e,
					placeholder: e.placeholder,
					style: C({ height: S.value }),
					"indent-with-tab": !0,
					"tab-size": 2,
					extensions: w.value,
					disabled: e.disabled,
					onReady: T,
					onChange: D,
					onBlur: k
				}, null, 8, [
					"modelValue",
					"placeholder",
					"style",
					"extensions",
					"disabled"
				]), o("div", ZC, [v.value ? (O(), r(qe, {
					key: 0,
					text: b.value,
					location: "top"
				}, {
					activator: L(({ props: t }) => [l(V, y(t, {
						icon: "mdi:mdi-code-braces",
						size: "small",
						role: "button",
						tabindex: "0",
						"aria-label": F(B)("format_code"),
						class: "cursor-pointer",
						disabled: e.disabled || g.value,
						onClick: j
					}), null, 16, ["aria-label", "disabled"])]),
					_: 1
				}, 8, ["text"])) : i("", !0), g.value ? (O(), r(V, {
					key: 1,
					icon: "mdi:mdi-alert-circle",
					size: "small",
					color: "error"
				})) : p.value && !g.value ? (O(), r(V, {
					key: 2,
					icon: "mdi:mdi-check-circle",
					size: "small",
					color: "success"
				})) : i("", !0)])], 2), e.hint && (e.persistentHint || !g.value) ? (O(), a("div", QC, P(e.hint), 1)) : i("", !0)], 40, XC)]),
				_: 1
			}, 8, ["modelValue", "rules"])]),
			_: 1
		}, 8, [
			"label",
			"icon",
			"icon-color",
			"icon-size",
			"required",
			"error",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-374fe316"]]), ew = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({
	name: "HActionButton",
	inheritAttrs: !1
}, {
	__name: "action-button",
	props: {
		type: {
			type: String,
			default: "primary",
			validator: (e) => [
				"primary",
				"secondary",
				"info",
				"error",
				"warning",
				"success",
				"neutral",
				"custom"
			].includes(e)
		},
		name: {
			type: String,
			default: void 0,
			validator: (e) => e && !e.startsWith("HActionButton") ? (console.error(`[HActionButton] Invalid name "${e}": Theme scope names must start with "HActionButton" prefix. Example: "HActionButtonResetButton" instead of "${e}"`), !1) : !0
		},
		color: {
			type: String,
			default: void 0
		},
		variant: {
			type: String,
			default: void 0
		},
		active: Boolean,
		appendIcon: String,
		block: Boolean,
		border: [
			Boolean,
			Number,
			String
		],
		density: String,
		disabled: Boolean,
		elevation: [Number, String],
		exact: Boolean,
		flat: Boolean,
		height: [Number, String],
		href: String,
		icon: [Boolean, String],
		loading: [Boolean, String],
		location: String,
		maxHeight: [Number, String],
		maxWidth: [Number, String],
		minHeight: [Number, String],
		minWidth: [Number, String],
		position: String,
		prependIcon: String,
		replace: Boolean,
		ripple: {
			type: [Boolean, Object],
			default: !0
		},
		rounded: [
			Boolean,
			Number,
			String
		],
		size: {
			type: [String, Number],
			default: "default"
		},
		slim: Boolean,
		stacked: Boolean,
		tag: {
			type: String,
			default: "button"
		},
		text: String,
		theme: String,
		tile: Boolean,
		to: [String, Object],
		value: null,
		width: [Number, String]
	},
	setup(e) {
		let t = e, i = z(t, n(() => {
			if (t.name) return t.name;
			let e = t.type || "primary", n = `HActionButton${e.charAt(0).toUpperCase() + e.slice(1)}`;
			if (t.size && t.size !== "default") {
				let e = typeof t.size == "string" ? t.size.charAt(0).toUpperCase() + t.size.slice(1) : t.size;
				n += e;
			}
			return n;
		}).value), a = {
			primary: {
				color: "primary",
				variant: "flat",
				rounded: "sm"
			},
			secondary: {
				color: "secondary",
				variant: "flat",
				rounded: "sm"
			},
			info: {
				color: "info",
				variant: "flat",
				rounded: "sm"
			},
			error: {
				color: "error",
				variant: "flat",
				rounded: "sm"
			},
			warning: {
				color: "warning",
				variant: "flat",
				rounded: "sm"
			},
			success: {
				color: "success",
				variant: "flat",
				rounded: "sm"
			},
			neutral: {
				color: "neutral-100",
				variant: "flat",
				rounded: "sm"
			},
			custom: {}
		}, o = n(() => i.type === "custom" || t.color ? t.color : i.color ? i.color : a[i.type]?.color || "primary"), c = n(() => i.type === "custom" || t.variant ? t.variant : i.variant ? i.variant : a[i.type]?.variant || "elevated"), l = n(() => i.type === "custom" || t.rounded !== void 0 ? t.rounded : i.rounded === void 0 ? a[i.type]?.rounded || 4 : i.rounded), u = n(() => i.type === "custom" || t.elevation !== void 0 ? t.elevation : i.elevation === void 0 ? a[i.type]?.elevation || 0 : i.elevation), d = n(() => i.type === "custom" || t.border !== void 0 ? t.border : i.border === void 0 ? a[i.type]?.border : i.border);
		return (e, t) => (O(), r(Ke, y({
			ref: "componentRef",
			class: F(i).type === "custom" ? void 0 : ["h-action-button", `h-action-button--${F(i).type}`]
		}, {
			color: o.value,
			variant: c.value,
			elevation: u.value,
			rounded: l.value,
			border: d.value,
			...e.$attrs,
			active: F(i).active,
			appendIcon: F(i).appendIcon,
			block: F(i).block,
			density: F(i).density,
			disabled: F(i).disabled,
			exact: F(i).exact,
			flat: F(i).flat,
			height: F(i).height,
			href: F(i).href,
			icon: F(i).icon,
			loading: F(i).loading,
			location: F(i).location,
			maxHeight: F(i).maxHeight,
			maxWidth: F(i).maxWidth,
			minHeight: F(i).minHeight,
			minWidth: F(i).minWidth,
			position: F(i).position,
			prependIcon: F(i).prependIcon,
			replace: F(i).replace,
			ripple: F(i).ripple,
			size: F(i).size,
			slim: F(i).slim,
			stacked: F(i).stacked,
			tag: F(i).tag,
			text: F(i).text,
			theme: F(i).theme,
			tile: F(i).tile,
			to: F(i).to,
			value: F(i).value,
			width: F(i).width
		}), s({ _: 2 }, [j(e.$slots, (t, n) => ({
			name: n,
			fn: L((t) => [M(e.$slots, n, S(p(t || {})), void 0, !0)])
		}))]), 1040, ["class"]));
	}
}), [["__scopeId", "data-v-e71debd6"]]), tw = /* @__PURE__ */ d({
	__name: "route-renderer",
	props: { route: {} },
	setup(e) {
		let t = e;
		k(lt, t.route);
		let i = n(() => {
			let e = t.route?.matched[0]?.components?.default;
			return e ? m(e) : null;
		});
		return (e, t) => (O(), r(te(i.value)));
	}
}), nw = /* @__PURE__ */ function(e) {
	return e.SELF = "_self", e.BLANK = "_blank", e.MODAL = "_modal", e.WINDOW = "_window", e;
}({}), rw = ["href", "target"], iw = ["href", "onClick"], aw = ["href"], ow = ["href"], sw = [
	"name",
	"title",
	"src"
], cw = {
	key: 1,
	class: "h-dialog-internal__content"
}, lw = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "action-link",
	props: {
		activeClass: { default: "active" },
		inactiveClass: { default: "inactive" },
		target: { default: nw.SELF },
		dialogTitle: { default: "" },
		to: {},
		noRoute: {
			type: Boolean,
			default: !1
		},
		windowName: {}
	},
	setup(t) {
		let s = z(t, "HActionLink"), c = dt(), u = A(null), { baseUrl: d } = we(), f = n(() => {
			let [e] = s.to?.split("|") ?? [""];
			return e;
		});
		function p(e, t) {
			e.defaultPrevented || t(e);
		}
		function m(e) {
			e.defaultPrevented || (e.preventDefault(), T(!0));
		}
		function h() {
			let [, e] = s.to.split("|") ?? ["", ""], t = e?.split(",").reduce((e, t) => {
				let [n, r] = t.split("=");
				return r ? e[n] = r === "true" ? !0 : r === "false" ? !1 : r : e[n] = null, e;
			}, {}) ?? {};
			t.width = t.width ?? (window.innerWidth < 600 ? window.innerWidth * .9 : 600), t.height = t.height ?? (window.innerHeight < 600 ? window.innerHeight * .9 : 600), t.left = window.screenX + (t.left ? +t.left : (window.innerWidth - t.width) / 2), t.right = window.screenY + (t.top ? +t.top : (window.innerHeight - t.height) / 2);
			let n = Object.entries(t).map(([e, t]) => t === null ? e : `${e}=${t}`).join(",");
			window.open(_.value, s.windowName ?? `h-window-${crypto.randomUUID()}`, n);
		}
		let _ = n(() => ge(f.value, d, s.noRoute)), v = n(() => {
			let [, e] = s.to?.split("|") ?? ["", ""];
			return e ? e.split(",").reduce((e, t) => {
				let [n, r] = t.split(":");
				return e[n] = r === "true" ? !0 : r === "false" ? !1 : r, e;
			}, {}) : {};
		}), b = n(() => {
			let e = Object.assign({}, v.value);
			return e.fullscreen && (e.width = "100%", e.height = "100%"), e;
		}), S = n(() => v.value.fullscreen ? {
			height: "92%",
			position: "absolute"
		} : {}), [w, T] = yt(), E = n(() => _e(_.value)), D = n(() => E.value && !ve(f.value, d));
		return I(() => _.value, (e) => {
			e && ct(c.resolve(e)).then((e) => {
				u.value = e;
			}).catch(() => {
				u.value = null;
			});
		}, { immediate: !0 }), (n, s) => {
			let c = N("h-dialog");
			return t.target !== F(nw).MODAL && t.target !== F(nw).WINDOW ? (O(), a(e, { key: 0 }, [E.value ? (O(), a("a", y({
				key: 0,
				class: "h-action-link"
			}, n.$attrs, {
				href: _.value,
				target: t.target
			}), [M(n.$slots, "default", {}, void 0, !0)], 16, rw)) : (O(), r(F(st), y({ key: 1 }, n.$props, {
				to: _.value,
				custom: ""
			}), {
				default: L(({ isActive: e, href: r, navigate: i }) => [o("a", y(n.$attrs, {
					class: ["h-action-link", e ? t.activeClass : t.inactiveClass],
					href: r,
					onClick: (e) => p(e, i)
				}), [M(n.$slots, "default", {}, void 0, !0)], 16, iw)]),
				_: 3
			}, 16, ["to"]))], 64)) : t.target === F(nw).WINDOW ? (O(), a("a", y({ key: 1 }, n.$attrs, {
				class: "h-action-link",
				href: _.value,
				target: "_blank",
				onClick: s[0] ||= R((e) => h(), ["prevent"])
			}), [M(n.$slots, "default", {}, void 0, !0)], 16, aw)) : (O(), a(e, { key: 2 }, [o("a", {
				class: "h-action-link",
				href: _.value,
				onClick: m
			}, [M(n.$slots, "default", {}, void 0, !0)], 8, ow), l(c, y({
				modelValue: F(w),
				"onUpdate:modelValue": s[1] ||= (e) => g(w) ? w.value = e : null,
				class: "h-custom-dialog"
			}, b.value, { "dialog-height": D.value ? "50%" : "auto" }), {
				header: L(() => [o("h4", null, P(t.dialogTitle), 1)]),
				default: L(() => [o("div", { class: x(["h-100", { "h-dialog-internal__container": !D.value }]) }, [D.value ? (O(), a("iframe", {
					key: 0,
					name: t.windowName,
					title: t.dialogTitle,
					src: _.value,
					class: "h-dialog-external__content",
					style: C(S.value)
				}, null, 12, sw)) : (O(), a("div", cw, [u.value ? (O(), r(tw, {
					key: 0,
					route: u.value
				}, null, 8, ["route"])) : i("", !0)]))], 2)]),
				_: 1
			}, 16, ["modelValue", "dialog-height"])], 64));
		};
	}
}), [["__scopeId", "data-v-bc1e26c3"]]), uw = { class: "h-action-buttons" }, dw = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "HActionButtons" }, {
	__name: "action-buttons",
	props: {
		actions: {
			type: Array,
			default: () => [],
			validator: (e) => e.every((e) => typeof e == "object" && e.description)
		},
		variant: {
			type: String,
			default: "buttons",
			validator: (e) => [
				"buttons",
				"dropdown",
				"icons",
				"dots"
			].includes(e)
		},
		buttonProps: {
			type: Object,
			default: () => ({})
		}
	},
	setup(t) {
		function n(e, t) {
			e.callback && typeof e.callback == "function" && e.callback(e, t) === !1 && (t.preventDefault(), t.stopPropagation(), t.stopImmediatePropagation());
		}
		return (o, s) => (O(), a("div", uw, [
			t.variant === "buttons" ? (O(!0), a(e, { key: 0 }, j(t.actions, (t, i) => (O(), a(e, { key: i }, [t.url || t.to ? (O(), r(lw, {
				key: 0,
				to: t.url || t.to,
				target: t.target
			}, {
				default: L(() => [l(ew, {
					type: t.type,
					color: t.color,
					"prepend-icon": t.icon,
					text: t.description,
					class: "h-action-buttons__button",
					onClick: (e) => n(t, e)
				}, null, 8, [
					"type",
					"color",
					"prepend-icon",
					"text",
					"onClick"
				])]),
				_: 2
			}, 1032, ["to", "target"])) : (O(), r(ew, {
				key: 1,
				type: t.type,
				color: t.color,
				"prepend-icon": t.icon,
				text: t.description,
				class: "h-action-buttons__button",
				onClick: (e) => n(t, e)
			}, null, 8, [
				"type",
				"color",
				"prepend-icon",
				"text",
				"onClick"
			]))], 64))), 128)) : i("", !0),
			t.variant === "icons" ? (O(!0), a(e, { key: 1 }, j(t.actions, (t, i) => (O(), a(e, { key: i }, [t.url || t.to ? (O(), r(lw, {
				key: 0,
				to: t.url || t.to,
				target: t.target
			}, {
				default: L(() => [l(ew, {
					type: t.type,
					color: t.color,
					icon: !0,
					"aria-label": t.description,
					class: "h-action-buttons__icon",
					onClick: (e) => n(t, e)
				}, {
					default: L(() => [l(V, null, {
						default: L(() => [c(P(t.icon), 1)]),
						_: 2
					}, 1024), l(qe, {
						activator: "parent",
						location: "bottom"
					}, {
						default: L(() => [c(P(t.description), 1)]),
						_: 2
					}, 1024)]),
					_: 2
				}, 1032, [
					"type",
					"color",
					"aria-label",
					"onClick"
				])]),
				_: 2
			}, 1032, ["to", "target"])) : (O(), r(ew, {
				key: 1,
				type: t.type,
				color: t.color,
				icon: !0,
				"aria-label": t.description,
				class: "h-action-buttons__icon",
				onClick: (e) => n(t, e)
			}, {
				default: L(() => [l(V, null, {
					default: L(() => [c(P(t.icon), 1)]),
					_: 2
				}, 1024), l(qe, {
					activator: "parent",
					location: "bottom"
				}, {
					default: L(() => [c(P(t.description), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1032, [
				"type",
				"color",
				"aria-label",
				"onClick"
			]))], 64))), 128)) : i("", !0),
			t.variant === "dropdown" || t.variant === "dots" ? (O(), r(it, { key: 2 }, {
				activator: L(({ props: e }) => [t.variant === "dropdown" ? (O(), r(ew, y({ key: 0 }, {
					...e,
					...t.buttonProps
				}, {
					text: t.buttonProps?.text || F(B)("actions"),
					"append-icon": "mdi:mdi-chevron-down",
					class: "h-action-buttons__dropdown-trigger"
				}), null, 16, ["text"])) : (O(), r(ew, y({ key: 1 }, {
					...e,
					...t.buttonProps
				}, {
					icon: "mdi:mdi-dots-vertical",
					type: "custom",
					variant: "text",
					"aria-label": t.buttonProps?.["aria-label"] || F(B)("actions"),
					class: "h-action-buttons__dots-trigger"
				}), null, 16, ["aria-label"]))]),
				default: L(() => [l(St, { density: "compact" }, {
					default: L(() => [(O(!0), a(e, null, j(t.actions, (t, i) => (O(), a(e, { key: i }, [t.url || t.to ? (O(), r(lw, {
						key: 0,
						to: t.url || t.to,
						target: t.target
					}, {
						default: L(() => [l(wt, {
							"prepend-icon": t.icon,
							title: t.description,
							onClick: (e) => n(t, e)
						}, null, 8, [
							"prepend-icon",
							"title",
							"onClick"
						])]),
						_: 2
					}, 1032, ["to", "target"])) : (O(), r(wt, {
						key: 1,
						"prepend-icon": t.icon,
						title: t.description,
						onClick: (e) => n(t, e)
					}, null, 8, [
						"prepend-icon",
						"title",
						"onClick"
					]))], 64))), 128))]),
					_: 1
				})]),
				_: 1
			})) : i("", !0)
		]));
	}
}), [["__scopeId", "data-v-f5ac694b"]]), fw = { class: "h-admin-search-menu__settings" }, pw = /*#__PURE__*/ Vn({
	__name: "search",
	props: /*@__PURE__*/ v({
		autoSearchEnabled: {
			type: Boolean,
			default: !0
		},
		pageName: {
			type: String,
			default: ""
		},
		settingsMenu: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: {
			type: String,
			default: ""
		},
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ v(["update:autoSearchEnabled", "search"], ["update:modelValue"]),
	setup(t, { emit: n }) {
		let u = ce(t, "modelValue"), d = z(t, "HSearch"), f = n, p = A(u.value ?? ""), m = A(null), h = A(!1), g = A([]), _ = !1;
		I(h, async (e) => {
			e || (_ = !0, await b(), _ = !1);
		}, { flush: "sync" });
		function v(e) {
			e && d.settingsMenu && !_ && (h.value = !0);
		}
		function x() {
			w(), h.value = !1;
		}
		function S(e) {
			p.value = e, x();
		}
		I(u, (e) => {
			let t = e ?? "";
			p.value !== t && (p.value = t);
		}), I(p, (e) => {
			if (!d.autoSearchEnabled) return;
			let t = e ?? "";
			u.value !== t && (u.value = t);
		});
		function C() {
			let e = p.value ?? "";
			u.value !== e && (u.value = e);
		}
		function w() {
			C();
			let e = p.value.trim();
			d.settingsMenu && e && (g.value = [e, ...g.value.filter((t) => t !== e)].slice(0, 5), h.value = !1), d.autoSearchEnabled || f("search");
		}
		function T() {
			p.value = "", C(), d.autoSearchEnabled || f("search");
		}
		function E() {
			let e = !d.autoSearchEnabled;
			f("update:autoSearchEnabled", e), e && C();
		}
		return (n, u) => (O(), r(Ze, {
			ref_key: "searchField",
			ref: m,
			modelValue: p.value,
			"onUpdate:modelValue": u[1] ||= (e) => p.value = e,
			class: "h-search-field",
			label: t.pageName,
			type: "search",
			name: "search",
			autocomplete: "off",
			"data-1p-ignore": "",
			"data-lpignore": "true",
			variant: "solo",
			clearable: "",
			"hide-details": "",
			density: "compact",
			onKeyup: fe(w, ["enter"]),
			"onClick:clear": T,
			"onUpdate:focused": v
		}, s({
			"append-inner": L(() => [t.settingsMenu ? (O(), r(Ke, {
				key: 0,
				icon: "mdi:mdi-magnify",
				variant: "text",
				size: "small",
				"aria-label": t.pageName,
				onClick: R(x, ["stop"])
			}, null, 8, ["aria-label"])) : (O(), r(V, { key: 1 }, {
				default: L(() => [...u[2] ||= [c("mdi:mdi-magnify", -1)]]),
				_: 1
			})), t.settingsMenu ? (O(), r(it, {
				key: 2,
				modelValue: h.value,
				"onUpdate:modelValue": u[0] ||= (e) => h.value = e,
				activator: m.value?.$el?.querySelector("input"),
				target: m.value?.$el,
				"activator-props": {
					role: "combobox",
					"aria-haspopup": "dialog"
				},
				"open-on-click": !1,
				"close-on-content-click": !1,
				location: "bottom",
				"max-height": "360",
				"content-props": {
					class: "h-admin-search-menu",
					role: "dialog",
					"aria-label": F(B)("admin_search_settings")
				}
			}, {
				default: L(() => [l(Be, {
					rounded: "sm",
					color: "surface",
					class: "h-admin-search-menu__card"
				}, {
					default: L(() => [o("div", fw, [o("span", null, P(F(B)("admin_search_settings")), 1), l(nt, {
						"model-value": t.autoSearchEnabled,
						label: F(B)("admin_enable_auto_search"),
						color: "primary",
						"hide-details": "",
						density: "compact",
						inset: "",
						"onUpdate:modelValue": E
					}, null, 8, ["model-value", "label"])]), g.value.length ? (O(), r(St, {
						key: 0,
						density: "compact"
					}, {
						default: L(() => [l(Dt, null, {
							default: L(() => [c(P(F(B)("admin_recent_searches")), 1)]),
							_: 1
						}), (O(!0), a(e, null, j(g.value, (e) => (O(), r(wt, {
							key: e,
							title: e,
							onClick: (t) => S(e)
						}, null, 8, ["title", "onClick"]))), 128))]),
						_: 1
					})) : i("", !0)]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"modelValue",
				"activator",
				"target",
				"content-props"
			])) : i("", !0)]),
			_: 2
		}, [t.settingsMenu ? void 0 : {
			name: "append",
			fn: L(() => [l(qe, {
				text: t.autoSearchEnabled ? F(B)("auto_search_enabled") : F(B)("press_enter_to_search"),
				location: "bottom"
			}, {
				activator: L(({ props: e }) => [l(Ke, y(e, {
					icon: "",
					variant: "text",
					size: "small",
					color: t.autoSearchEnabled ? "primary" : "grey",
					"aria-label": t.autoSearchEnabled ? F(B)("auto_search_enabled") : F(B)("press_enter_to_search"),
					onClick: E
				}), {
					default: L(() => [l(V, null, {
						default: L(() => [c(P(t.autoSearchEnabled ? "mdi:mdi-flash" : "mdi:mdi-flash-off"), 1)]),
						_: 1
					})]),
					_: 1
				}, 16, ["color", "aria-label"])]),
				_: 1
			}, 8, ["text"])]),
			key: "0"
		}]), 1032, ["modelValue", "label"]));
	}
}, [["__scopeId", "data-v-a4acc3cb"]]), mw = { class: "h-filters-container-expansion-panel v-expansion-panels" }, hw = { class: "h-filters-container-expansion-panel-title py-2 font-weight-medium d-flex align-center justify-space-between px-4 w-100" }, gw = { class: "d-flex ga-2" }, _w = ["id"], vw = { class: "d-flex flex-wrap ga-2" }, yw = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "filters-container",
	props: /*@__PURE__*/ v({
		results: { default: 0 },
		hideToggle: { type: Boolean },
		panelId: {},
		hideClear: { type: Boolean },
		active: { type: Boolean },
		clearDisabled: { type: Boolean }
	}, {
		expanded: {},
		expandedModifiers: {}
	}),
	emits: /*@__PURE__*/ v(["clear-filters"], ["update:expanded"]),
	setup(e, { emit: t }) {
		let s = z(e, "HFiltersContainer"), u = `filters-${se()}`, d = n(() => s.panelId || u), f = t, p = ce(e, "expanded");
		function m() {
			p.value = !p.value;
		}
		return (t, n) => (O(), a("div", { class: x(["h-filters-container-main-expansion-panels", {
			"h-filters-container--active": e.active,
			"h-filters-container--expanded": p.value
		}]) }, [o("div", mw, [o("div", hw, [M(t.$slots, "results", {}, () => [c(P(F(B)("admin_filter_results", { results: e.results })), 1)], !0), o("div", gw, [!e.hideToggle || p.value ? (O(), r(Ke, {
			key: 0,
			density: "compact",
			size: "medium",
			class: "h-filters-container__toggle-filters text-label-small h-filters-container-toggle-btn",
			text: p.value ? F(B)("admin_hide_selected_filters") : F(B)("admin_show_selected_filters"),
			color: "warning",
			"aria-expanded": p.value ? "true" : "false",
			"aria-controls": d.value,
			onClick: n[0] ||= R((e) => m(), ["stop"])
		}, null, 8, [
			"text",
			"aria-expanded",
			"aria-controls"
		])) : i("", !0), e.hideClear ? i("", !0) : (O(), r(Ke, {
			key: 1,
			disabled: e.clearDisabled,
			density: "compact",
			size: "medium",
			class: "h-filters-container__clear-filters text-label-small h-filters-container-clear-btn",
			text: F(B)("admin_clear_filters"),
			color: "secondary",
			onClick: n[1] ||= R((e) => f("clear-filters"), ["stop"])
		}, null, 8, ["disabled", "text"]))])]), l(Ot, null, {
			default: L(() => [de(o("div", {
				id: d.value,
				class: "h-filters-container-expansion-panel-text pa-4 pt-2"
			}, [o("div", vw, [M(t.$slots, "filters", {}, void 0, !0)])], 8, _w), [[ue, p.value]])]),
			_: 3
		})])], 2));
	}
}), [["__scopeId", "data-v-be2e2a95"]]), bw = /*@__PURE__*/ Object.assign({
	name: "HTooltip",
	inheritAttrs: !1
}, {
	__name: "tooltip",
	props: {
		interactive: {
			type: Boolean,
			default: !1
		},
		stopPropagation: {
			type: Boolean,
			default: !0
		},
		modelValue: {
			type: Boolean,
			default: void 0
		},
		groupId: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let i = z(e, "HTooltip"), a = t, s = oe(), c = A(!1), l = A(!1), u = A(!1), d = null, { shouldOpen: p, setInactive: m, setHovered: h } = Re(i.groupId), g = () => u.value || l.value, _ = () => {
			d &&= (clearTimeout(d), null), h(!0), p.value && (c.value = !0);
		}, v = () => {
			d &&= (clearTimeout(d), null), d = setTimeout(() => {
				g() || (h(!1), m(), c.value = !1);
			}, 150);
		}, b = (e) => {
			e ? _() : v();
		}, x = (e) => ({
			...e,
			onMouseenter: (t) => {
				u.value = !0, b(!0), i.stopPropagation && t.stopPropagation(), e.onMouseenter && e.onMouseenter(t);
			},
			onMouseleave: (t) => {
				u.value = !1, b(!1), i.stopPropagation && t.stopPropagation(), e.onMouseleave && e.onMouseleave(t);
			}
		}), S = () => {
			l.value = !0, b(!0);
		}, C = () => {
			l.value = !1, b(!1);
		};
		I(c, (e) => {
			e && !p.value && (c.value = !1);
		}, { flush: "sync" }), I(p, (e) => {
			e && !c.value && g() ? c.value = !0 : !e && c.value && (c.value = !1);
		}), I(c, (e) => {
			i.modelValue !== void 0 && a("update:modelValue", e);
		}), I(() => i.modelValue, (e) => {
			e !== void 0 && e !== c.value && (c.value = e);
		});
		let T = (e) => {
			i.stopPropagation && e.stopPropagation();
		}, D = n(() => [i.interactive && "tooltip-interactive", s.contentClass].filter(Boolean).join(" "));
		E(() => {
			if (s.activator === "parent") {
				let e = f()?.vnode?.el?.parentElement;
				e && (e.addEventListener("mouseenter", k), e.addEventListener("mouseleave", ee));
			}
		}), w(() => {
			if (d && clearTimeout(d), s.activator === "parent") {
				let e = f()?.vnode?.el?.parentElement;
				e && (e.removeEventListener("mouseenter", k), e.removeEventListener("mouseleave", ee));
			}
		});
		let k = (e) => {
			u.value = !0, b(!0), i.stopPropagation && e.stopPropagation();
		}, ee = (e) => {
			u.value = !1, b(!1), i.stopPropagation && e.stopPropagation();
		};
		return (e, t) => (O(), r(qe, y(e.$attrs, {
			modelValue: c.value,
			"onUpdate:modelValue": t[0] ||= (e) => c.value = e,
			"content-class": D.value,
			onClick: R(T, ["stop"])
		}), {
			activator: L(({ props: t, isActive: n }) => [M(e.$slots, "activator", {
				props: x(t),
				isActive: n
			}, () => [o("span", y(x(t), { style: { display: "contents" } }), null, 16)])]),
			default: L(() => [o("div", {
				tabindex: "-1",
				onMouseenter: S,
				onMouseleave: C,
				onFocus: S,
				onBlur: C
			}, [M(e.$slots, "default")], 32)]),
			_: 3
		}, 16, ["modelValue", "content-class"]));
	}
}), xw = { class: "h-action-card__info-tooltip pa-2" }, Sw = {
	key: 0,
	class: "h-action-card__info-tooltip-text"
}, Cw = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "ActionCardInfoIcon" }, {
	__name: "action-card-info-icon",
	props: {
		text: {
			type: String,
			default: ""
		},
		url: {
			type: String,
			default: null
		},
		isHorizontal: {
			type: Boolean,
			default: !1
		},
		tooltipGroupId: {
			type: String,
			default: void 0
		}
	},
	setup(e) {
		let { text: t, url: n, isHorizontal: s, tooltipGroupId: c } = z(e, "ActionCardInfoIcon");
		return (e, u) => (O(), a("div", { class: x(["h-action-card__info-icon", { "h-action-card__info-icon--horizontal": F(s) }]) }, [l(V, {
			icon: "mdi:mdi-information-outline",
			size: "24",
			color: "on-surface"
		}), l(bw, {
			activator: "parent",
			location: "top",
			interactive: !!F(n),
			"group-id": F(c)
		}, {
			default: L(() => [o("div", xw, [F(t) ? (O(), a("div", Sw, P(F(t)), 1)) : i("", !0), F(n) ? (O(), r(ew, {
				key: 1,
				to: F(n),
				type: "secondary",
				size: "small",
				class: "mt-2",
				text: "Show more"
			}, null, 8, ["to"])) : i("", !0)])]),
			_: 1
		}, 8, ["interactive", "group-id"])], 2));
	}
}), [["__scopeId", "data-v-63ecef8f"]]), ww = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "ActionCardTags" }, {
	__name: "action-card-tags",
	props: {
		tags: {
			type: Array,
			default: () => [],
			validator: (e) => e.every((e) => typeof e == "object" && e.text)
		},
		variant: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		}
	},
	setup(t) {
		let { tags: o, variant: s } = z(t, "ActionCardTags"), l = n(() => s === "horizontal" ? "mt-1" : "");
		return (t, n) => F(o) && F(o).length ? (O(), a("div", {
			key: 0,
			class: x(["h-action-card__tags", l.value])
		}, [(O(!0), a(e, null, j(F(o), (e, t) => (O(), r(kt, {
			key: t,
			color: e.color || "info-lighten-4",
			size: "small",
			class: "h-action-card__tag"
		}, {
			default: L(() => [c(P(e.text), 1)]),
			_: 2
		}, 1032, ["color"]))), 128))], 2)) : i("", !0);
	}
}), [["__scopeId", "data-v-de4fc093"]]), Tw = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "ActionCardTitle" }, {
	__name: "action-card-title",
	props: {
		title: {
			type: String,
			required: !0
		},
		isHorizontal: {
			type: Boolean,
			default: !1
		},
		variantClass: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let { title: t, isHorizontal: n, variantClass: r } = z(e, "ActionCardTitle");
		return (e, i) => (O(), a("div", { class: x(["h-action-card__title-row", F(r)]) }, [o("div", { class: x(["h-action-card__title", { "h-action-card__title--horizontal": F(n) }]) }, P(F(t)), 3), l(V, {
			icon: "mdi:mdi-chevron-right",
			size: "24",
			class: "h-action-card__chevron"
		})], 2));
	}
}), [["__scopeId", "data-v-b34888e5"]]), Ew = {
	key: 0,
	class: "h-action-card__description text-body-medium text-medium-emphasis"
}, Dw = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "ActionCardDescription" }, {
	__name: "action-card-description",
	props: {
		description: {
			type: String,
			default: ""
		},
		maxLength: {
			type: Number,
			default: 100
		}
	},
	setup(e) {
		let { description: t, maxLength: s } = z(e, "ActionCardDescription"), l = A(!1), u = n(() => t.length > s), d = n(() => !u.value || l.value ? t : t.substring(0, s) + "...");
		return (e, n) => F(t) ? (O(), a("div", Ew, [o("span", null, P(d.value), 1), u.value ? (O(), r(Ke, {
			key: 0,
			variant: "text",
			size: "small",
			class: "h-action-card__description-toggle pa-0 ml-1",
			onClick: n[0] ||= R((e) => l.value = !l.value, ["stop"])
		}, {
			default: L(() => [c(P(l.value ? F(B)("show_less") : F(B)("show_more")), 1)]),
			_: 1
		})) : i("", !0)])) : i("", !0);
	}
}), [["__scopeId", "data-v-7c0750c4"]]), Ow = {
	key: 0,
	class: "h-action-card__notification-wrapper"
}, kw = {
	key: 0,
	class: "h-action-card__info-icon-slot"
}, Aw = { class: "h-action-card__icon-wrapper" }, jw = { class: "h-action-card__icon-wrapper h-action-card__icon-wrapper--horizontal" }, Mw = {
	key: 1,
	class: "h-action-card__info-icon-slot"
}, Nw = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "HActionCard" }, {
	__name: "action-card",
	props: {
		variant: {
			type: String,
			default: "vertical",
			validator: (e) => ["vertical", "horizontal"].includes(e)
		},
		description: {
			type: String,
			default: null
		},
		showDescriptionInline: {
			type: Boolean,
			default: !1
		},
		title: {
			type: String,
			required: !0
		},
		icon: {
			type: String,
			default: null
		},
		iconUrl: {
			type: String,
			default: null
		},
		tags: {
			type: Array,
			default: () => []
		},
		showNotification: {
			type: Boolean,
			default: !1
		},
		notificationCount: {
			type: [Number, String],
			default: 0
		},
		infoTooltip: {
			type: [String, Object],
			default: "",
			validator: (e) => typeof e == "string" ? !0 : typeof e == "object" && e ? e.text !== void 0 || e.url !== void 0 : !1
		},
		to: {
			type: [String, Object],
			default: null
		},
		href: {
			type: String,
			default: null
		},
		target: {
			type: String,
			default: null
		},
		showActionButton: {
			type: Boolean,
			default: !0
		},
		color: {
			type: String,
			default: null
		},
		actionButtonsProps: {
			type: Object,
			default: null
		}
	},
	emits: ["action-click"],
	setup(e, { emit: t }) {
		let s = `action-card-${f()?.uid}`, u = z(e, "HActionCard"), d = n(() => typeof u.infoTooltip == "string" ? u.infoTooltip : u.infoTooltip?.text || ""), m = n(() => typeof u.infoTooltip == "object" && u.infoTooltip !== null && u.infoTooltip.url || null), h = n(() => !!(u.to || u.href)), g = n(() => h.value ? lw : "div"), _ = n(() => h.value ? {
			to: u.to || u.href,
			target: u.target
		} : {}), v = n(() => h.value ? "h-action-card__link" : "");
		return (t, n) => (O(), r(te(g.value), y(_.value, { class: v.value }), {
			default: L(() => [l(Be, {
				class: x([
					"h-action-card",
					`h-action-card--${e.variant}`,
					{ "h-action-card--hoverable": h.value }
				]),
				color: e.color,
				elevation: 1
			}, {
				default: L(() => [e.description && !e.showDescriptionInline ? (O(), r(bw, {
					key: 0,
					activator: "parent",
					location: "top",
					"group-id": s
				}, {
					default: L(() => [c(P(e.description), 1)]),
					_: 1
				})) : i("", !0), e.variant === "vertical" ? (O(), r(We, {
					key: 1,
					class: x([
						"h-action-card__content",
						"pa-6",
						{ "pr-8": d.value || m.value }
					])
				}, {
					default: L(() => [
						e.showNotification ? (O(), a("div", Ow, [l(At, {
							content: e.notificationCount,
							color: "secondary",
							class: "h-action-card__notification-badge"
						}, null, 8, ["content"])])) : i("", !0),
						l(Ye, {
							"no-gutters": "",
							class: "h-action-card__header mb-3"
						}, {
							default: L(() => [l(H, { cols: "12" }, {
								default: L(() => [d.value || m.value ? (O(), a("div", kw, [l(Cw, {
									text: d.value,
									url: m.value,
									"tooltip-group-id": s
								}, null, 8, ["text", "url"])])) : i("", !0), o("div", Aw, [e.iconUrl ? (O(), r(jt, {
									key: 0,
									src: e.iconUrl,
									alt: e.title,
									class: "h-action-card__icon-image",
									width: 34,
									height: 34
								}, null, 8, ["src", "alt"])) : (O(), r(V, {
									key: 1,
									icon: e.icon || "mdi:mdi-file-document-outline",
									color: "info",
									size: "34"
								}, null, 8, ["icon"]))])]),
								_: 1
							})]),
							_: 1
						}),
						l(Tw, {
							title: e.title,
							"variant-class": "mb-3"
						}, null, 8, ["title"]),
						e.showDescriptionInline ? (O(), r(Dw, {
							key: 1,
							description: e.description,
							class: "mb-3"
						}, null, 8, ["description"])) : i("", !0),
						l(ww, {
							tags: e.tags,
							variant: "vertical"
						}, null, 8, ["tags"]),
						e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant !== "dots" ? (O(), a("div", {
							key: 2,
							class: "mt-3",
							onClick: n[0] ||= R(() => {}, ["stop"])
						}, [l(dw, S(p(e.actionButtonsProps)), null, 16)])) : i("", !0)
					]),
					_: 1
				}, 8, ["class"])) : (O(), r(We, {
					key: 2,
					class: x([
						"h-action-card__content",
						"pa-3",
						{ "pr-5": d.value || m.value }
					])
				}, {
					default: L(() => [l(Ye, {
						"no-gutters": "",
						class: "align-center"
					}, {
						default: L(() => [
							l(H, {
								cols: "auto",
								class: "mr-2"
							}, {
								default: L(() => [o("div", jw, [e.iconUrl ? (O(), r(jt, {
									key: 0,
									src: e.iconUrl,
									alt: e.title,
									class: "h-action-card__icon-image",
									width: 24,
									height: 24
								}, null, 8, ["src", "alt"])) : (O(), r(V, {
									key: 1,
									icon: e.icon || "mdi:mdi-file-document-outline",
									color: "info",
									size: "24"
								}, null, 8, ["icon"]))])]),
								_: 1
							}),
							l(H, { class: "flex-grow-1" }, {
								default: L(() => [
									l(Tw, {
										title: e.title,
										"is-horizontal": ""
									}, null, 8, ["title"]),
									e.showDescriptionInline ? (O(), r(Dw, {
										key: 0,
										description: e.description,
										class: "mt-1"
									}, null, 8, ["description"])) : i("", !0),
									l(ww, {
										tags: e.tags,
										variant: "horizontal"
									}, null, 8, ["tags"]),
									e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant !== "dots" ? (O(), a("div", {
										key: 1,
										class: "mt-2",
										onClick: n[1] ||= R(() => {}, ["stop"])
									}, [l(dw, S(p(e.actionButtonsProps)), null, 16)])) : i("", !0)
								]),
								_: 1
							}),
							e.showActionButton && e.actionButtonsProps && e.actionButtonsProps.variant === "dots" ? (O(), r(H, {
								key: 0,
								cols: "auto",
								class: "ml-2"
							}, {
								default: L(() => [o("div", { onClick: n[2] ||= R(() => {}, ["stop"]) }, [l(dw, S(p(e.actionButtonsProps)), null, 16)])]),
								_: 1
							})) : i("", !0),
							d.value || m.value ? (O(), a("div", Mw, [l(Cw, {
								text: d.value,
								url: m.value,
								"is-horizontal": "",
								"tooltip-group-id": s
							}, null, 8, ["text", "url"])])) : i("", !0)
						]),
						_: 1
					})]),
					_: 1
				}, 8, ["class"]))]),
				_: 1
			}, 8, ["class", "color"])]),
			_: 1
		}, 16, ["class"]));
	}
}), [["__scopeId", "data-v-3262236d"]]), Pw = {
	__name: "action-menu",
	props: {
		icon: {
			type: String,
			default: "mdi:mdi-dots-vertical"
		},
		options: {
			type: Array,
			required: !0
		}
	},
	setup(t) {
		return z(t, "HActionMenu"), (n, i) => {
			let o = N("h-action-link");
			return O(), r(it, {
				"close-on-content-click": !0,
				"offset-y": ""
			}, {
				activator: L(({ props: e }) => [l(Ke, y(e, { icon: "" }), {
					default: L(() => [l(V, null, {
						default: L(() => [c(P(t.icon), 1)]),
						_: 1
					})]),
					_: 1
				}, 16)]),
				default: L(() => [l(St, null, {
					default: L(() => [(O(!0), a(e, null, j(t.options, (t, n) => (O(), r(wt, {
						key: n,
						class: "action-menu",
						onClick: t.action
					}, {
						prepend: L(() => [l(V, { color: t.color }, {
							default: L(() => [c(P(t.icon), 1)]),
							_: 2
						}, 1032, ["color"])]),
						default: L(() => [t.url ? (O(), r(o, {
							key: 0,
							to: t.url,
							target: "_modal"
						}, {
							default: L(() => [c(P(t.label), 1)]),
							_: 2
						}, 1032, ["to"])) : (O(), a(e, { key: 1 }, [c(P(t.label), 1)], 64))]),
						_: 2
					}, 1032, ["onClick"]))), 128))]),
					_: 1
				})]),
				_: 1
			});
		};
	}
}, Fw = {
	key: 0,
	class: "h-data-table-selection"
}, Iw = { key: 1 }, Lw = ["onClick"], Rw = {
	key: 1,
	class: "d-flex justify-space-between"
}, zw = ["onMousedown"], Bw = [
	"title",
	"role",
	"tabindex",
	"onClick",
	"onKeydown"
], Vw = [
	"title",
	"role",
	"tabindex",
	"onClick",
	"onKeydown"
], Hw = { class: "h-data-table-actions d-flex 1" }, Uw = /* @__PURE__ */ d({
	__name: "data-table",
	props: /*@__PURE__*/ v({
		headers: { default: () => [] },
		data: {},
		isCellActive: {
			type: Function,
			default: () => !1
		},
		loading: {
			type: Boolean,
			default: !1
		},
		itemsPerPageOptions: { default: () => [
			10,
			25,
			50,
			100
		] },
		totalItemsLimit: { default: 1e4 },
		itemsPerPage: { default: 10 },
		showTotalRecordCount: {
			type: Boolean,
			default: !1
		},
		itemActions: { default: () => [] },
		pagination: {
			type: Boolean,
			default: !0
		},
		nonPaginatedLimit: {},
		page: { default: 1 },
		startingPage: {},
		sortBy: {},
		classPrefix: { default: "" },
		rowProps: {
			type: Function,
			default: void 0
		},
		showSelect: { type: Boolean },
		itemValue: {
			type: [String, Function],
			default: "id"
		},
		actionMenu: { type: Boolean }
	}, {
		selected: { default: () => [] },
		selectedModifiers: {}
	}),
	emits: /*@__PURE__*/ v([
		"update:sort",
		"update:page",
		"update:page-size",
		"clicked:cell"
	], ["update:selected"]),
	setup(t, { emit: u }) {
		let d = z(t, "HDataTable"), { locale: f } = ke(), m = u, h = ce(t, "selected"), g = A(null), _ = A(d.pagination ? d.itemsPerPage : d.nonPaginatedLimit), v = A(Number(d.page) || Number(d.startingPage) || 1), T = A(v.value), D = A(_.value), k = {}, ee = n(() => {
			let e = Number(d.data?.meta?.totalresults) || 0, t = d.totalItemsLimit ?? 1e4;
			return e < t ? e : t;
		});
		I(() => d.page, (e) => {
			let t = Number(e);
			Number.isFinite(t) && t > 0 && t !== v.value && (v.value = t, T.value = t);
		}), I(() => d.itemsPerPage, (e) => {
			!d.pagination || !e || e === _.value || (_.value = e, D.value = e);
		});
		let N = A(null), ne = A(0), re = A(0);
		function ie(e, t) {
			t < 0 || (N.value = t, ne.value = e.clientX, re.value = +(d.headers[t]?.width || 150), document.addEventListener("mousemove", ae), document.addEventListener("mouseup", oe));
		}
		let ae = (e) => {
			if (N.value === null) return;
			let t = e.clientX - ne.value, n = re.value + t;
			n > 20 && (d.headers[N.value] && (d.headers[N.value].width = n), document.querySelectorAll(`.h-datatable td:nth-child(${N.value + 1})`).forEach((e) => e.style.width = `${n}px`));
		}, oe = () => {
			document.removeEventListener("mousemove", ae), document.removeEventListener("mouseup", oe), N.value = null;
		};
		w(() => {
			document.removeEventListener("mousemove", ae), document.removeEventListener("mouseup", oe);
		});
		function se() {
			let e = g.value, t = e instanceof HTMLElement ? e : e?.$el;
			if (!(t instanceof HTMLElement)) return;
			let n = t.querySelector(".v-table__wrapper");
			n instanceof HTMLElement && (n.setAttribute("tabindex", "0"), n.setAttribute("role", "region"), n.getAttribute("aria-labelledby") || n.setAttribute("aria-label", B("data_table")));
		}
		E(() => {
			b(se);
		}), I(() => [
			d.data,
			d.loading,
			d.headers,
			f.value
		], () => {
			b(se);
		});
		function le(e) {
			let { page: t, itemsPerPage: n, sortBy: r } = e, i = r[0];
			if (n && n > 0 && n !== D.value && (_.value = n, D.value = n, m("update:page-size", _.value)), i) {
				let e = d.headers.find((e) => e.key === i.key);
				if (e) {
					let { customSortKey: t } = e;
					m("update:sort", {
						key: t ?? i.key,
						order: i.order
					});
				} else {
					let e = d.headers.find((e) => e.sortable && (e.key?.includes("date") || e.key?.includes("time"))) || d.headers.find((e) => e.sortable);
					e && m("update:sort", {
						key: e.customSortKey ?? e.key ?? i.key,
						order: i.order
					});
				}
			}
			Number.isFinite(t) && t > 0 && t !== T.value && (v.value = t, T.value = t, m("update:page", v.value)), he.value = {};
		}
		function ue(e, t) {
			return t.key && (e[t.key] === void 0 || e[t.key] === null) && t.defaultValue !== void 0 ? {
				...e,
				[t.key]: t.defaultValue
			} : e;
		}
		d.headers.forEach((e) => {
			k[e.key ?? ""] = e.filterOnClick;
		});
		function de(e, t) {
			k[e] && k[e](t), m("clicked:cell", e, t);
		}
		function pe(e) {
			return `item.${e}`;
		}
		function me(e, t) {
			if (!e.key) return "";
			let n = t?.[e.key], r = e.formatCell ? e.formatCell(n, t) : n;
			if (r == null || r === "") return "";
			if (Array.isArray(r) || typeof r == "object" && r.toString === Object.prototype.toString) try {
				return JSON.stringify(r, null, 2);
			} catch {
				return "";
			}
			return String(r);
		}
		let he = A({});
		function ge(e, t) {
			let n = `${e}__${t}`;
			he.value[n] ? delete he.value[n] : he.value[n] = !0;
		}
		function _e(e, t) {
			return !!he.value[`${e}__${t}`];
		}
		return (n, u) => (O(), r(Ft, {
			ref_key: "tableRef",
			ref: g,
			modelValue: h.value,
			"onUpdate:modelValue": u[3] ||= (e) => h.value = e,
			page: v.value,
			"onUpdate:page": u[4] ||= (e) => v.value = e,
			"items-per-page": _.value,
			"onUpdate:itemsPerPage": u[5] ||= (e) => _.value = e,
			headers: t.headers,
			items: t.data?.records || [],
			"items-length": ee.value,
			loading: t.loading,
			"items-per-page-options": t.itemsPerPageOptions,
			"sort-by": t.sortBy,
			"row-props": t.rowProps,
			"show-select": t.showSelect,
			"item-value": t.itemValue,
			"select-strategy": "page",
			class: x(["h-datatable h-data-table-main-server", { "h-datatable--has-actions": t.itemActions.length > 0 }]),
			"hide-default-footer": !F(d).pagination,
			"onUpdate:options": le
		}, s({
			"item.select": L(({ item: e }) => [l(Mt, {
				modelValue: h.value,
				"onUpdate:modelValue": u[0] ||= (e) => h.value = e,
				value: e,
				density: "compact",
				class: "h-data-table-select-checkbox"
			}, null, 8, ["modelValue", "value"])]),
			headers: L(({ columns: n, isSorted: s, getSortIcon: c, toggleSort: l, selectAll: d, allSelected: f, someSelected: p }) => [o("tr", null, [(O(!0), a(e, null, j(n, (e, n) => (O(), a("th", {
				key: e.key ?? n,
				class: "resizable-header",
				style: C({
					width: e.width + "px",
					minWidth: e.width + "px",
					cursor: e.sortable ? "pointer" : "default"
				}),
				onClick: () => e.sortable && l(e)
			}, [e.key === "data-table-select" ? (O(), r(Nt, {
				key: 0,
				"model-value": f,
				indeterminate: p && !f,
				"aria-label": F(B)("admin_select_page"),
				"onUpdate:modelValue": (e) => d(e)
			}, null, 8, [
				"model-value",
				"indeterminate",
				"aria-label",
				"onUpdate:modelValue"
			])) : (O(), a("div", Rw, [
				o("span", { class: x(["header-title", { "cursor-pointer": e.sortable }]) }, P(e.translate ? F(B)(e.title ?? "") : e.title), 3),
				s(e) ? (O(), r(V, {
					key: 0,
					icon: c(e),
					class: "h-data-table-sort-icon"
				}, null, 8, ["icon"])) : i("", !0),
				o("span", {
					class: "resizer",
					"aria-hidden": "true",
					onClick: u[2] ||= R(() => {}, ["stop"]),
					onMousedown: (n) => ie(n, t.headers.findIndex((t) => t.key === e.key))
				}, null, 40, zw)
			]))], 12, Lw))), 128))])]),
			"item.actions": L(({ item: n }) => [o("div", Hw, [(O(!0), a(e, null, j(t.actionMenu ? t.itemActions.slice(0, 2) : t.itemActions, (t, o) => (O(), a(e, { key: o }, [t.hidden?.(n) ? i("", !0) : (O(), r(Ke, {
				key: 0,
				color: t.color || "grey-darken-1",
				variant: "text",
				size: "small",
				density: "compact",
				icon: "",
				class: "h-data-table-action-btn",
				"aria-label": t.label,
				onClick: (e) => t.action(n)
			}, {
				default: L(() => [l(V, null, {
					default: L(() => [c(P(t.icon), 1)]),
					_: 2
				}, 1024), l(qe, {
					activator: "parent",
					location: "top"
				}, {
					default: L(() => [c(P(t.label), 1)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1032, [
				"color",
				"aria-label",
				"onClick"
			]))], 64))), 128)), t.actionMenu && t.itemActions.slice(2).some((e) => !e.hidden?.(n)) ? (O(), r(it, {
				key: 0,
				location: "bottom end"
			}, {
				activator: L(({ props: e }) => [l(Ke, y(e, {
					icon: "mdi:mdi-dots-horizontal",
					variant: "text",
					size: "small",
					density: "compact",
					class: "h-data-table-action-btn",
					"aria-label": F(B)("admin_more_actions")
				}), null, 16, ["aria-label"])]),
				default: L(() => [l(St, { density: "compact" }, {
					default: L(() => [(O(!0), a(e, null, j(t.itemActions.slice(2), (t, o) => (O(), a(e, { key: o }, [t.hidden?.(n) ? i("", !0) : (O(), r(wt, {
						key: 0,
						title: t.label,
						"prepend-icon": t.icon,
						onClick: (e) => t.action(n)
					}, null, 8, [
						"title",
						"prepend-icon",
						"onClick"
					]))], 64))), 128))]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024)) : i("", !0)])]),
			_: 2
		}, [
			t.showTotalRecordCount || t.showSelect && h.value.length ? {
				name: "top",
				fn: L(() => [t.showSelect && h.value.length ? (O(), a("div", Fw, [o("span", null, P(F(B)("admin_selected_rows", { count: h.value.length })), 1), l(Ke, {
					variant: "text",
					size: "small",
					onClick: u[1] ||= (e) => h.value = []
				}, {
					default: L(() => [c(P(F(B)("admin_clear_selection")), 1)]),
					_: 1
				})])) : i("", !0), t.showTotalRecordCount ? (O(), a("span", Iw, P(F(B)("total")) + ": " + P(t.data?.meta?.totalresults || 0), 1)) : i("", !0)]),
				key: "0"
			} : void 0,
			j(t.headers.filter((e) => e.key !== "actions"), (e) => ({
				name: pe(e.key),
				fn: L((i) => [M(n.$slots, pe(e.key), S(p({
					...i,
					header: e,
					isActive: t.isCellActive(e.key, i.item[e.key])
				})), () => [e.component ? (O(), r(te(e.component), y({
					key: 0,
					value: i.item[e.key] ?? e.defaultValue,
					item: ue(i.item, e),
					"filter-on-click": e.filterOnClick,
					"is-filter-active": e.isFilterActive,
					"format-cell": e.formatCell,
					"class-prefix": t.classPrefix,
					"cell-key": e.key
				}, e.componentProps), null, 16, [
					"value",
					"item",
					"filter-on-click",
					"is-filter-active",
					"format-cell",
					"class-prefix",
					"cell-key"
				])) : k[e.key] ? (O(), a("span", {
					key: 1,
					class: x(["h-datatable__field h-datatable__cell-truncated", {
						"h-datatable__field--active": t.isCellActive(e.key, i.item[e.key]),
						"font-weight-bold": e.isFilterActive && e.isFilterActive(i.item),
						"h-datatable__cell--expanded": _e(i.index, e.key)
					}]),
					title: me(e, i.item) || void 0,
					style: C(me(e, i.item) ? "cursor: pointer" : void 0),
					role: me(e, i.item) ? "button" : void 0,
					tabindex: me(e, i.item) ? 0 : void 0,
					onClick: (t) => {
						ge(i.index, e.key), de(e.key, i.item);
					},
					onKeydown: [fe((t) => de(e.key, i.item), ["enter"]), fe(R((t) => de(e.key, i.item), ["prevent"]), ["space"])]
				}, P(me(e, i.item)), 47, Bw)) : (O(), a("span", {
					key: 2,
					class: x(["h-datatable__cell-truncated", { "h-datatable__cell--expanded": _e(i.index, e.key) }]),
					title: me(e, i.item) || void 0,
					style: C(me(e, i.item) ? "cursor: pointer" : void 0),
					role: me(e, i.item) ? "button" : void 0,
					tabindex: me(e, i.item) ? 0 : void 0,
					onClick: (t) => ge(i.index, e.key),
					onKeydown: [fe((t) => ge(i.index, e.key), ["enter"]), fe(R((t) => ge(i.index, e.key), ["prevent"]), ["space"])]
				}, P(me(e, i.item)), 47, Vw))])])
			})),
			n.$slots.bottom ? {
				name: "bottom",
				fn: L(() => [M(n.$slots, "bottom"), F(d).pagination ? (O(), a(e, { key: 0 }, [l(It), l(Pt, { "items-per-page-options": t.itemsPerPageOptions }, null, 8, ["items-per-page-options"])], 64)) : i("", !0)]),
				key: "1"
			} : void 0
		]), 1032, [
			"modelValue",
			"page",
			"items-per-page",
			"headers",
			"items",
			"items-length",
			"loading",
			"items-per-page-options",
			"sort-by",
			"row-props",
			"show-select",
			"item-value",
			"class",
			"hide-default-footer"
		]));
	}
}), Ww = { class: "dialog-container__header" }, Gw = {
	__name: "view-code-dialog",
	props: {
		modelValue: Boolean,
		title: {
			type: String,
			default: ""
		},
		item: {
			type: Object,
			default: () => ({})
		},
		fieldName: {
			type: String,
			required: !0
		},
		fieldLabel: {
			type: String,
			required: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		z(e, "HViewCodeDialog");
		let a = t, s = (e) => {
			a("update:modelValue", e), e || (u.value = !0);
		}, u = A(!0), d = n(() => u.value ? "wrap" : "no-wrap"), f = async () => {
			u.value = !u.value, await b(), C();
		}, p = A(!1), m = n(() => p.value ? "100%" : "80%"), h = n(() => p.value ? "100vh" : "80%");
		function g() {
			p.value = !p.value;
		}
		let _ = A(null), v = A(!1), S = async () => {
			if (!_.value) return;
			let e = _.value.$el.querySelector("code");
			if (e) try {
				await navigator.clipboard.writeText(e.innerText), v.value = !0, setTimeout(() => v.value = !1, 2e3);
			} catch (e) {
				console.error("Error copying the code:", e);
			}
		}, C = () => {
			let e = _.value?.$el?.querySelector("code");
			e && (e.style.wordWrap = u.value ? "break-word" : "normal", e.style.whiteSpace = u.value ? "pre-wrap" : "pre", e.style.overflowX = u.value ? "hidden" : "auto");
		};
		return (t, n) => {
			let a = N("h-pretty-code"), b = N("h-dialog");
			return O(), r(b, {
				"model-value": e.modelValue,
				fullscreen: p.value,
				width: m.value,
				height: h.value,
				persistent: !1,
				class: "h-view-code-dialog",
				"onUpdate:modelValue": s
			}, {
				header: L(() => [o("div", Ww, [l(Ge, { class: "ml-1 px-0" }, {
					default: L(() => [o("strong", null, P(e.item.title), 1)]),
					_: 1
				}), l(Ue, { class: "ml-1 px-0" }, {
					default: L(() => [o("span", null, P(e.fieldLabel) + ":", 1), c(" " + P(e.item[e.fieldName]), 1)]),
					_: 1
				})])]),
				default: L(() => [l(Be, { class: "resizable-card" }, {
					default: L(() => [l(We, { class: "scrollable-content d-flex justify-end" }, {
						default: L(() => [l(a, {
							ref_key: "codeBlock",
							ref: _,
							class: x(["ma-0 view-code-dialog", d.value]),
							language: "javascript"
						}, {
							default: L(() => [M(t.$slots, "raw-json")]),
							_: 3
						}, 8, ["class"])]),
						_: 3
					}), l(Ve, {
						class: "d-flex justify-end",
						style: { padding: "2.3rem" }
					}, {
						default: L(() => [
							l(Xe),
							l(qe, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(V, y(e, {
									class: ["cursor-pointer wrap-icon", { "text-black": t.hoverSize || !u.value }],
									style: { color: t.hoverSize ? "purple" : u.value ? "black" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": u.value ? F(B)("disable_word_wrap") : F(B)("enable_word_wrap"),
									onClick: f,
									onKeydown: [fe(f, ["enter"]), fe(R(f, ["prevent"]), ["space"])],
									onMouseover: n[0] ||= (e) => t.hoverSize = !0,
									onMouseleave: n[1] ||= (e) => t.hoverSize = !1,
									onFocus: n[2] ||= (e) => t.hoverSize = !0,
									onBlur: n[3] ||= (e) => t.hoverSize = !1
								}), {
									default: L(() => [c(P(u.value ? "mdi:mdi-wrap" : "mdi:mdi-wrap-disabled"), 1)]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: L(() => [o("span", null, P(u.value ? F(B)("disable_word_wrap") : F(B)("enable_word_wrap")), 1)]),
								_: 1
							}),
							l(qe, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(V, y(e, {
									class: ["cursor-pointer copy-icon", { "text-green": v.value }],
									style: { color: v.value ? "green" : t.hoverCopy ? "purple" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": v.value ? F(B)("copied") : F(B)("copy_to_clipboard"),
									onClick: S,
									onKeydown: [fe(S, ["enter"]), fe(R(S, ["prevent"]), ["space"])],
									onMouseover: n[4] ||= (e) => t.hoverCopy = !0,
									onMouseleave: n[5] ||= (e) => t.hoverCopy = !1,
									onFocus: n[6] ||= (e) => t.hoverCopy = !0,
									onBlur: n[7] ||= (e) => t.hoverCopy = !1
								}), {
									default: L(() => [...n[12] ||= [c(" mdi:mdi-content-copy ", -1)]]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: L(() => [v.value ? (O(), r(V, {
									key: 0,
									class: "me-1"
								}, {
									default: L(() => [...n[13] ||= [c("mdi:mdi-check-circle", -1)]]),
									_: 1
								})) : i("", !0), o("span", null, P(v.value ? F(B)("copied") : F(B)("copy_to_clipboard")), 1)]),
								_: 1
							}),
							l(Xe),
							l(qe, {
								location: "bottom",
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(V, y(e, {
									class: ["cursor-pointer size-toggle-icon", { "text-purple": p.value }],
									style: { color: p.value || t.hoverSize ? "purple" : "inherit" },
									role: "button",
									tabindex: "0",
									"aria-label": p.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen"),
									onClick: g,
									onKeydown: [fe(g, ["enter"]), fe(R(g, ["prevent"]), ["space"])],
									onMouseover: n[8] ||= (e) => t.hoverSize = !0,
									onMouseleave: n[9] ||= (e) => t.hoverSize = !1,
									onFocus: n[10] ||= (e) => t.hoverSize = !0,
									onBlur: n[11] ||= (e) => t.hoverSize = !1
								}), {
									default: L(() => [c(P(p.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
									_: 1
								}, 16, [
									"class",
									"style",
									"aria-label",
									"onKeydown"
								])]),
								default: L(() => [o("span", null, P(p.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen")), 1)]),
								_: 1
							})
						]),
						_: 1
					})]),
					_: 3
				})]),
				_: 3
			}, 8, [
				"model-value",
				"fullscreen",
				"width",
				"height"
			]);
		};
	}
};
//#endregion
//#region ../../../node_modules/inherits-browser/dist/index.es.js
function Kw(e, t) {
	t && (e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} }));
}
//#endregion
//#region ../../../node_modules/min-dash/dist/index.js
var qw = Object.prototype.toString, Jw = Object.prototype.hasOwnProperty;
function Yw(e) {
	return e === void 0;
}
function Xw(e) {
	return e !== void 0;
}
function Zw(e) {
	return e == null;
}
function Qw(e) {
	return qw.call(e) === "[object Array]";
}
function $w(e) {
	return qw.call(e) === "[object Object]";
}
function eT(e) {
	return qw.call(e) === "[object Number]";
}
function tT(e) {
	let t = qw.call(e);
	return t === "[object Function]" || t === "[object AsyncFunction]" || t === "[object GeneratorFunction]" || t === "[object AsyncGeneratorFunction]" || t === "[object Proxy]";
}
function nT(e) {
	return qw.call(e) === "[object String]";
}
function rT(e, t) {
	return !Zw(e) && Jw.call(e, t);
}
function iT(e, t) {
	let n = fT(t), r;
	return X(e, function(e, t) {
		if (n(e, t)) return r = e, !1;
	}), r;
}
function aT(e, t) {
	let n = fT(t), r = Qw(e) ? -1 : void 0;
	return X(e, function(e, t) {
		if (n(e, t)) return r = t, !1;
	}), r;
}
function oT(e, t) {
	let n = fT(t), r = [];
	return X(e, function(e, t) {
		n(e, t) && r.push(e);
	}), r;
}
function X(e, t) {
	let n, r;
	if (Yw(e)) return;
	let i = Qw(e) ? mT : pT;
	for (let a in e) if (rT(e, a) && (n = e[a], r = t(n, i(a)), r === !1)) return n;
}
function sT(e, t, n) {
	return X(e, function(e, r) {
		n = t(n, e, r);
	}), n;
}
function cT(e, t) {
	return !!sT(e, function(e, n, r) {
		return e && t(n, r);
	}, !0);
}
function lT(e, t) {
	return !!iT(e, t);
}
function uT(e, t) {
	let n = [];
	return X(e, function(e, r) {
		n.push(t(e, r));
	}), n;
}
function dT(e) {
	return function(t) {
		return cT(e, function(e, n) {
			return t[n] === e;
		});
	};
}
function fT(e) {
	return tT(e) ? e : (t) => t === e;
}
function pT(e) {
	return e;
}
function mT(e) {
	return Number(e);
}
function hT(e, t) {
	let n, r, i, a;
	function o(n) {
		let o = Date.now(), l = n ? 0 : a + t - o;
		if (l > 0) return s(l);
		e.apply(i, r), c();
	}
	function s(e) {
		n = setTimeout(o, e);
	}
	function c() {
		n && clearTimeout(n), n = a = r = i = void 0;
	}
	function l() {
		n && o(!0), c();
	}
	function u(...e) {
		a = Date.now(), r = e, i = this, n || s(t);
	}
	return u.flush = l, u.cancel = c, u;
}
function gT(e, t) {
	return e.bind(t);
}
function Z(e, ...t) {
	return Object.assign(e, ...t);
}
function _T(e, t, n) {
	let r = e;
	return X(t, function(e, i) {
		if (typeof e != "number" && typeof e != "string") throw Error("illegal key type: " + typeof e + ". Key should be of type number or string.");
		if (e === "constructor") throw Error("illegal key: constructor");
		if (e === "__proto__") throw Error("illegal key: __proto__");
		let a = t[i + 1], o = r[e];
		Xw(a) && Zw(o) && (o = r[e] = isNaN(+a) ? {} : []), Yw(a) ? Yw(n) ? delete r[e] : r[e] = n : r = o;
	}), e;
}
function vT(e, t) {
	let n = {}, r = Object(e);
	return X(t, function(t) {
		t in r && (n[t] = e[t]);
	}), n;
}
function yT(e, t) {
	let n = {};
	return X(Object(e), function(e, r) {
		t.indexOf(r) === -1 && (n[r] = e);
	}), n;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/BaseRenderer.js
var bT = 1e3;
function xT(e, t) {
	var n = this;
	t ||= bT, e.on(["render.shape", "render.connection"], t, function(e, t) {
		var r = e.type, i = t.element, a = t.gfx, o = t.attrs;
		if (n.canRender(i)) return r === "render.shape" ? n.drawShape(a, i, o) : n.drawConnection(a, i, o);
	}), e.on(["render.getShapePath", "render.getConnectionPath"], t, function(e, t) {
		if (n.canRender(t)) return e.type === "render.getShapePath" ? n.getShapePath(t) : n.getConnectionPath(t);
	});
}
xT.prototype.canRender = function(e) {}, xT.prototype.drawShape = function(e, t) {}, xT.prototype.drawConnection = function(e, t) {}, xT.prototype.getShapePath = function(e) {}, xT.prototype.getConnectionPath = function(e) {};
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/ModelUtil.js
function Q(e, t) {
	var n = CT(e);
	return n && typeof n.$instanceOf == "function" && n.$instanceOf(t);
}
function ST(e, t) {
	return lT(t, function(t) {
		return Q(e, t);
	});
}
function CT(e) {
	return e && e.businessObject || e;
}
function wT(e) {
	return e && e.di;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/DiUtil.js
function TT(e, t) {
	return Q(e, "bpmn:CallActivity") ? !1 : Q(e, "bpmn:SubProcess") ? (t ||= wT(e), t && Q(t, "bpmndi:BPMNPlane") ? !0 : t && !!t.isExpanded) : Q(e, "bpmn:Participant") ? !!CT(e).processRef : !0;
}
function ET(e) {
	if (!(!Q(e, "bpmn:Participant") && !Q(e, "bpmn:Lane"))) {
		var t = wT(e).isHorizontal;
		return t === void 0 ? !0 : t;
	}
}
function DT(e) {
	return e && !!CT(e).triggeredByEvent;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/ModelUtil.js
function OT(e) {
	return $w(e) && rT(e, "waypoints");
}
function kT(e) {
	return $w(e) && rT(e, "labelTarget");
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/LabelUtil.js
var AT = {
	width: 90,
	height: 20
};
function jT(e) {
	return Q(e, "bpmn:Event") || Q(e, "bpmn:Gateway") || Q(e, "bpmn:DataStoreReference") || Q(e, "bpmn:DataObjectReference") || Q(e, "bpmn:DataInput") || Q(e, "bpmn:DataOutput") || Q(e, "bpmn:SequenceFlow") || Q(e, "bpmn:MessageFlow") || Q(e, "bpmn:Group");
}
function MT(e) {
	var t = e.length / 2 - 1, n = e[Math.floor(t)], r = e[Math.ceil(t + .01)], i = NT(e), a = Math.atan((r.y - n.y) / (r.x - n.x)), o = i.x, s = i.y;
	return Math.abs(a) < Math.PI / 2 ? s -= 15 : o += 15, {
		x: o,
		y: s
	};
}
function NT(e) {
	var t = e.length / 2 - 1, n = e[Math.floor(t)], r = e[Math.ceil(t + .01)];
	return {
		x: n.x + (r.x - n.x) / 2,
		y: n.y + (r.y - n.y) / 2
	};
}
function PT(e) {
	return e.waypoints ? MT(e.waypoints) : Q(e, "bpmn:Group") ? {
		x: e.x + e.width / 2,
		y: e.y + AT.height / 2
	} : {
		x: e.x + e.width / 2,
		y: e.y + e.height + AT.height / 2
	};
}
function FT(e, t) {
	var n, r, i, a = e.label;
	return a && a.bounds ? (i = a.bounds, r = {
		width: Math.max(AT.width, i.width),
		height: i.height
	}, n = {
		x: i.x + i.width / 2,
		y: i.y + i.height / 2
	}) : (n = PT(t), r = AT), Z({
		x: n.x - r.width / 2,
		y: n.y - r.height / 2
	}, r);
}
function IT(e) {
	if (Q(e, "bpmn:FlowElement") || Q(e, "bpmn:Participant") || Q(e, "bpmn:Lane") || Q(e, "bpmn:SequenceFlow") || Q(e, "bpmn:MessageFlow") || Q(e, "bpmn:DataInput") || Q(e, "bpmn:DataOutput")) return "name";
	if (Q(e, "bpmn:TextAnnotation")) return "text";
	if (Q(e, "bpmn:Group")) return "categoryValueRef";
}
function LT(e) {
	var t = e.categoryValueRef;
	return t && t.value || "";
}
function RT(e) {
	var t = e.businessObject, n = IT(t);
	if (n) return n === "categoryValueRef" ? LT(t) : t[n] || "";
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Elements.js
function zT(e, t) {
	t = !!t, Qw(e) || (e = [e]);
	var n, r, i, a;
	return X(e, function(e) {
		var o = e;
		e.waypoints && !t && (o = zT(e.waypoints, !0));
		var s = o.x, c = o.y, l = o.height || 0, u = o.width || 0;
		(s < n || n === void 0) && (n = s), (c < r || r === void 0) && (r = c), (s + u > i || i === void 0) && (i = s + u), (c + l > a || a === void 0) && (a = c + l);
	}), {
		x: n,
		y: r,
		height: a - r,
		width: i - n
	};
}
function BT(e) {
	return "waypoints" in e ? "connection" : "x" in e ? "shape" : "root";
}
function VT(e) {
	return !!(e && e.isFrame);
}
//#endregion
//#region ../../../node_modules/tiny-svg/dist/index.js
function HT(e, t) {
	if (e.ownerDocument !== t.ownerDocument) try {
		return t.ownerDocument.importNode(e, !0);
	} catch {}
	return e;
}
function UT(e, t) {
	return t.appendChild(HT(e, t));
}
function WT(e, t) {
	return UT(t, e), e;
}
var GT = 2, KT = {
	"alignment-baseline": 1,
	"baseline-shift": 1,
	clip: 1,
	"clip-path": 1,
	"clip-rule": 1,
	color: 1,
	"color-interpolation": 1,
	"color-interpolation-filters": 1,
	"color-profile": 1,
	"color-rendering": 1,
	cursor: 1,
	direction: 1,
	display: 1,
	"dominant-baseline": 1,
	"enable-background": 1,
	fill: 1,
	"fill-opacity": 1,
	"fill-rule": 1,
	filter: 1,
	"flood-color": 1,
	"flood-opacity": 1,
	font: 1,
	"font-family": 1,
	"font-size": GT,
	"font-size-adjust": 1,
	"font-stretch": 1,
	"font-style": 1,
	"font-variant": 1,
	"font-weight": 1,
	"glyph-orientation-horizontal": 1,
	"glyph-orientation-vertical": 1,
	"image-rendering": 1,
	kerning: 1,
	"letter-spacing": 1,
	"lighting-color": 1,
	marker: 1,
	"marker-end": 1,
	"marker-mid": 1,
	"marker-start": 1,
	mask: 1,
	opacity: 1,
	overflow: 1,
	"pointer-events": 1,
	"shape-rendering": 1,
	"stop-color": 1,
	"stop-opacity": 1,
	stroke: 1,
	"stroke-dasharray": 1,
	"stroke-dashoffset": 1,
	"stroke-linecap": 1,
	"stroke-linejoin": 1,
	"stroke-miterlimit": 1,
	"stroke-opacity": 1,
	"stroke-width": GT,
	"text-anchor": 1,
	"text-decoration": 1,
	"text-rendering": 1,
	"unicode-bidi": 1,
	visibility: 1,
	"word-spacing": 1,
	"writing-mode": 1
};
function qT(e, t) {
	return KT[t] ? e.style[t] : e.getAttributeNS(null, t);
}
function JT(e, t, n) {
	var r = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = KT[r];
	i ? (i === GT && typeof n == "number" && (n = String(n) + "px"), e.style[r] = n) : e.setAttributeNS(null, t, n);
}
function YT(e, t) {
	var n = Object.keys(t), r, i;
	for (r = 0; i = n[r]; r++) JT(e, i, t[i]);
}
function XT(e, t, n) {
	if (typeof t == "string") if (n !== void 0) JT(e, t, n);
	else return qT(e, t);
	else YT(e, t);
	return e;
}
var ZT = Object.prototype.toString;
function QT(e) {
	return new $T(e);
}
function $T(e) {
	if (!e || !e.nodeType) throw Error("A DOM element reference is required");
	this.el = e, this.list = e.classList;
}
$T.prototype.add = function(e) {
	return this.list.add(e), this;
}, $T.prototype.remove = function(e) {
	return ZT.call(e) == "[object RegExp]" ? this.removeMatching(e) : (this.list.remove(e), this);
}, $T.prototype.removeMatching = function(e) {
	let t = this.array();
	for (let n = 0; n < t.length; n++) e.test(t[n]) && this.remove(t[n]);
	return this;
}, $T.prototype.toggle = function(e, t) {
	return (t === void 0 || t !== this.list.toggle(e, t)) && this.list.toggle(e), this;
}, $T.prototype.array = function() {
	return Array.from(this.list);
}, $T.prototype.has = $T.prototype.contains = function(e) {
	return this.list.contains(e);
};
function eE(e) {
	for (var t; t = e.firstChild;) e.removeChild(t);
	return e;
}
var tE = { svg: "http://www.w3.org/2000/svg" }, nE = "<svg xmlns=\"" + tE.svg + "\"";
function rE(e) {
	var t = !1;
	e.substring(0, 4) === "<svg" ? e.indexOf(tE.svg) === -1 && (e = nE + e.substring(4)) : (e = nE + ">" + e + "</svg>", t = !0);
	var n = iE(e);
	if (!t) return n;
	for (var r = document.createDocumentFragment(), i = n.firstChild; i.firstChild;) r.appendChild(i.firstChild);
	return r;
}
function iE(e) {
	var t = new DOMParser();
	return t.async = !1, t.parseFromString(e, "text/xml");
}
function aE(e, t) {
	var n;
	return e = e.trim(), e.charAt(0) === "<" ? (n = rE(e).firstChild, n = document.importNode(n, !0)) : n = document.createElementNS(tE.svg, e), t && XT(n, t), n;
}
var oE = null;
function sE() {
	return oE === null && (oE = aE("svg")), oE;
}
function cE(e, t) {
	var n, r, i = Object.keys(t);
	for (n = 0; r = i[n]; n++) e[r] = t[r];
	return e;
}
function lE(e, t, n, r, i, a) {
	var o = sE().createSVGMatrix();
	switch (arguments.length) {
		case 0: return o;
		case 1: return cE(o, e);
		case 6: return cE(o, {
			a: e,
			b: t,
			c: n,
			d: r,
			e: i,
			f: a
		});
	}
}
function uE(e) {
	return e ? sE().createSVGTransformFromMatrix(e) : sE().createSVGTransform();
}
var dE = /([&<>]{1})/g, fE = /([&<>\n\r"]{1})/g, pE = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "'"
};
function mE(e, t) {
	function n(e, t) {
		return pE[t] || t;
	}
	return e.replace(t, n);
}
function hE(e, t) {
	var n, r, i, a, o;
	switch (e.nodeType) {
		case 3:
			t.push(mE(e.textContent, dE));
			break;
		case 1:
			if (t.push("<", e.tagName), e.hasAttributes()) for (i = e.attributes, n = 0, r = i.length; n < r; ++n) a = i.item(n), t.push(" ", a.name, "=\"", mE(a.value, fE), "\"");
			if (e.hasChildNodes()) {
				for (t.push(">"), o = e.childNodes, n = 0, r = o.length; n < r; ++n) hE(o.item(n), t);
				t.push("</", e.tagName, ">");
			} else t.push("/>");
			break;
		case 8:
			t.push("<!--", mE(e.nodeValue, dE), "-->");
			break;
		case 4:
			t.push("<![CDATA[", e.nodeValue, "]]>");
			break;
		default: throw Error("unable to handle node " + e.nodeType);
	}
	return t;
}
function gE(e, t) {
	var n = rE(t);
	if (eE(e), t) {
		vE(n) || (n = n.documentElement);
		for (var r = bE(n.childNodes), i = 0; i < r.length; i++) UT(r[i], e);
	}
}
function _E(e) {
	for (var t = e.firstChild, n = []; t;) hE(t, n), t = t.nextSibling;
	return n.join("");
}
function vE(e) {
	return e.nodeName === "#document-fragment";
}
function yE(e, t) {
	if (t !== void 0) {
		try {
			gE(e, t);
		} catch (e) {
			throw Error("error parsing SVG: " + e.message);
		}
		return e;
	} else return _E(e);
}
function bE(e) {
	return Array.prototype.slice.call(e);
}
function xE(e) {
	var t = e.parentNode;
	return t && t.removeChild(e), e;
}
function SE(e, t) {
	return t instanceof SVGMatrix ? e.createSVGTransformFromMatrix(t) : t;
}
function CE(e, t) {
	var n, r;
	for (e.clear(), n = 0; r = t[n]; n++) e.appendItem(SE(e, r));
}
function wE(e, t) {
	var n = e.transform.baseVal;
	return t && (Array.isArray(t) || (t = [t]), CE(n, t)), n.consolidate();
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/RenderUtil.js
function TE(e) {
	return e.flat().join(",").replace(/,?([A-Za-z]),?/g, "$1");
}
function EE(e) {
	return [
		"M",
		e.x,
		e.y
	];
}
function DE(e) {
	return [
		"L",
		e.x,
		e.y
	];
}
function OE(e, t, n) {
	return [
		"C",
		e.x,
		e.y,
		t.x,
		t.y,
		n.x,
		n.y
	];
}
function kE(e, t) {
	let n = e.length, r = [EE(e[0])];
	for (let i = 1; i < n; i++) {
		let n = e[i - 1], a = e[i], o = e[i + 1];
		if (!o || !t) {
			r.push(DE(a));
			continue;
		}
		let s = Math.min(t, jE(a.x - n.x, a.y - n.y), jE(o.x - a.x, o.y - a.y));
		if (!s) {
			r.push(DE(a));
			continue;
		}
		let c = AE(a, n, s), l = AE(a, n, s * .5), u = AE(a, o, s), d = AE(a, o, s * .5);
		r.push(DE(c)), r.push(OE(l, d, u));
	}
	return r;
}
function AE(e, t, n) {
	let r = t.x - e.x, i = t.y - e.y, a = n / jE(r, i);
	return {
		x: e.x + r * a,
		y: e.y + i * a
	};
}
function jE(e, t) {
	return Math.sqrt(e ** 2 + t ** 2);
}
function ME(e, t, n) {
	eT(t) && (n = t, t = null), t ||= {};
	let r = aE("path", t);
	return eT(n) && (r.dataset.cornerRadius = String(n)), NE(r, e);
}
function NE(e, t) {
	return XT(e, { d: TE(kE(t, parseInt(e.dataset.cornerRadius, 10) || 0)) }), e;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/BpmnRenderUtil.js
var PE = "hsl(225, 10%, 15%)";
function FE(e, t) {
	return lT(e.eventDefinitions, function(e) {
		return e.$type === t;
	});
}
function IE(e) {
	return e.$type === "bpmn:IntermediateThrowEvent" || e.$type === "bpmn:EndEvent";
}
function LE(e) {
	var t = e.dataObjectRef;
	return e.isCollection || t && t.isCollection;
}
function RE(e, t, n) {
	var r = wT(e);
	return n || r.get("color:background-color") || r.get("bioc:fill") || t || "white";
}
function $(e, t, n) {
	var r = wT(e);
	return n || r.get("color:border-color") || r.get("bioc:stroke") || t || "hsl(225, 10%, 15%)";
}
function zE(e, t, n, r) {
	var i = wT(e).get("label");
	return r || i && i.get("color:color") || t || $(e, n);
}
function BE(e) {
	var t = e.x + e.width / 2, n = e.y + e.height / 2, r = e.width / 2;
	return TE([
		[
			"M",
			t,
			n
		],
		[
			"m",
			0,
			-r
		],
		[
			"a",
			r,
			r,
			0,
			1,
			1,
			0,
			2 * r
		],
		[
			"a",
			r,
			r,
			0,
			1,
			1,
			0,
			-2 * r
		],
		["z"]
	]);
}
function VE(e, t) {
	var n = e.x, r = e.y, i = e.width, a = e.height;
	return TE([
		[
			"M",
			n + t,
			r
		],
		[
			"l",
			i - t * 2,
			0
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			t,
			t
		],
		[
			"l",
			0,
			a - t * 2
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			-t,
			t
		],
		[
			"l",
			t * 2 - i,
			0
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			-t,
			-t
		],
		[
			"l",
			0,
			t * 2 - a
		],
		[
			"a",
			t,
			t,
			0,
			0,
			1,
			t,
			-t
		],
		["z"]
	]);
}
function HE(e) {
	var t = e.width, n = e.height, r = e.x, i = e.y, a = t / 2, o = n / 2;
	return TE([
		[
			"M",
			r + a,
			i
		],
		[
			"l",
			a,
			o
		],
		[
			"l",
			-a,
			o
		],
		[
			"l",
			-a,
			-o
		],
		["z"]
	]);
}
function UE(e) {
	var t = e.x, n = e.y, r = e.width, i = e.height;
	return TE([
		[
			"M",
			t,
			n
		],
		[
			"l",
			r,
			0
		],
		[
			"l",
			0,
			i
		],
		[
			"l",
			-r,
			0
		],
		["z"]
	]);
}
function WE(e, t = {}) {
	return {
		width: GE(e, t),
		height: KE(e, t)
	};
}
function GE(e, t = {}) {
	return rT(t, "width") ? t.width : e.width;
}
function KE(e, t = {}) {
	return rT(t, "height") ? t.height : e.height;
}
//#endregion
//#region ../../../node_modules/domify/index.js
var qE = {
	legend: [
		1,
		"<fieldset>",
		"</fieldset>"
	],
	tr: [
		2,
		"<table><tbody>",
		"</tbody></table>"
	],
	col: [
		2,
		"<table><tbody></tbody><colgroup>",
		"</colgroup></table>"
	],
	_default: [
		0,
		"",
		""
	]
};
qE.td = qE.th = [
	3,
	"<table><tbody><tr>",
	"</tr></tbody></table>"
], qE.option = qE.optgroup = [
	1,
	"<select multiple=\"multiple\">",
	"</select>"
], qE.thead = qE.tbody = qE.colgroup = qE.caption = qE.tfoot = [
	1,
	"<table>",
	"</table>"
], qE.polyline = qE.ellipse = qE.polygon = qE.circle = qE.text = qE.line = qE.path = qE.rect = qE.g = [
	1,
	"<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\">",
	"</svg>"
];
function JE(e, t = globalThis.document) {
	if (typeof e != "string") throw TypeError("String expected");
	let n = /^<!--(.*?)-->$/s.exec(e);
	if (n) return t.createComment(n[1]);
	let r = /<([\w:]+)/.exec(e)?.[1];
	if (!r) return t.createTextNode(e);
	if (e = e.trim(), r === "body") {
		let n = t.createElement("html");
		n.innerHTML = e;
		let { lastChild: r } = n;
		return r.remove(), r;
	}
	let [i, a, o] = Object.hasOwn(qE, r) ? qE[r] : qE._default, s = t.createElement("div");
	for (s.innerHTML = a + e + o; i--;) s = s.lastChild;
	if (s.firstChild === s.lastChild) {
		let { firstChild: e } = s;
		return e.remove(), e;
	}
	let c = t.createDocumentFragment();
	return c.append(...s.childNodes), c;
}
//#endregion
//#region ../../../node_modules/min-dom/dist/index.js
function YE(e, t) {
	return t.forEach(function(t) {
		t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
			if (n !== "default" && !(n in e)) {
				var r = Object.getOwnPropertyDescriptor(t, n);
				Object.defineProperty(e, n, r.get ? r : {
					enumerable: !0,
					get: function() {
						return t[n];
					}
				});
			}
		});
	}), Object.freeze(e);
}
function XE(e, ...t) {
	let n = e.style;
	return X(t, function(e) {
		e && X(e, function(e, t) {
			n[t] = e;
		});
	}), e;
}
function ZE(e, t, n) {
	return arguments.length == 2 ? e.getAttribute(t) : n === null ? e.removeAttribute(t) : (e.setAttribute(t, n), e);
}
var QE = Object.prototype.toString;
function $E(e) {
	return new eD(e);
}
function eD(e) {
	if (!e || !e.nodeType) throw Error("A DOM element reference is required");
	this.el = e, this.list = e.classList;
}
eD.prototype.add = function(e) {
	return this.list.add(e), this;
}, eD.prototype.remove = function(e) {
	return QE.call(e) == "[object RegExp]" ? this.removeMatching(e) : (this.list.remove(e), this);
}, eD.prototype.removeMatching = function(e) {
	let t = this.array();
	for (let n = 0; n < t.length; n++) e.test(t[n]) && this.remove(t[n]);
	return this;
}, eD.prototype.toggle = function(e, t) {
	return (t === void 0 || t !== this.list.toggle(e, t)) && this.list.toggle(e), this;
}, eD.prototype.array = function() {
	return Array.from(this.list);
}, eD.prototype.has = eD.prototype.contains = function(e) {
	return this.list.contains(e);
};
function tD(e) {
	for (var t; t = e.firstChild;) e.removeChild(t);
	return e;
}
function nD(e, t, n) {
	var r = n ? e : e.parentNode;
	return r && typeof r.closest == "function" && r.closest(t) || null;
}
function rD(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var iD = {}, aD;
function oD() {
	if (aD) return iD;
	aD = 1;
	var e, t, n;
	function r() {
		e = window.addEventListener ? "addEventListener" : "attachEvent", t = window.removeEventListener ? "removeEventListener" : "detachEvent", n = e === "addEventListener" ? "" : "on";
	}
	return iD.bind = function(t, i, a, o) {
		return e || r(), t[e](n + i, a, o || !1), a;
	}, iD.unbind = function(e, i, a, o) {
		return t || r(), e[t](n + i, a, o || !1), a;
	}, iD;
}
var sD = oD(), cD = /*#__PURE__*/ YE({
	__proto__: null,
	default: /* @__PURE__ */ rD(sD)
}, [sD]), lD = ["focus", "blur"];
function uD(e, t, n, r, i) {
	return lD.indexOf(n) !== -1 && (i = !0), cD.bind(e, n, function(n) {
		n.delegateTarget = nD(n.target || n.srcElement, t, !0), n.delegateTarget && r.call(e, n);
	}, i);
}
function dD(e, t, n, r) {
	return lD.indexOf(t) !== -1 && (r = !0), cD.unbind(e, t, n, r);
}
var fD = {
	bind: uD,
	unbind: dD
};
function pD(e, t) {
	return t ||= document, t.querySelector(e);
}
function mD(e, t) {
	return t ||= document, t.querySelectorAll(e);
}
function hD(e) {
	e.parentNode && e.parentNode.removeChild(e);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/SvgTransformUtil.js
function gD(e, t, n, r, i) {
	var a = uE();
	a.setTranslate(t, n);
	var o = uE();
	o.setRotate(r || 0, 0, 0);
	var s = uE();
	s.setScale(i || 1, i || 1), wE(e, [
		a,
		o,
		s
	]);
}
function _D(e, t, n) {
	var r = uE();
	r.setTranslate(t, n), wE(e, r);
}
function vD(e, t) {
	var n = uE();
	n.setRotate(t, 0, 0), wE(e, n);
}
//#endregion
//#region ../../../node_modules/ids/dist/index.js
function yD(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bD = { exports: {} }, xD;
function SD() {
	if (xD) return bD.exports;
	xD = 1;
	var e = bD.exports = function(t, n) {
		if (n ||= 16, t === void 0 && (t = 128), t <= 0) return "0";
		for (var r = Math.log(2 ** t) / Math.log(n), i = 2; r === Infinity; i *= 2) r = Math.log(2 ** (t / i)) / Math.log(n) * i;
		for (var a = r - Math.floor(r), o = "", i = 0; i < Math.floor(r); i++) {
			var s = Math.floor(Math.random() * n).toString(n);
			o = s + o;
		}
		if (a) {
			var s = Math.floor(Math.random() * n ** +a).toString(n);
			o = s + o;
		}
		var c = parseInt(o, n);
		return c !== Infinity && c >= 2 ** t ? e(t, n) : o;
	};
	return e.rack = function(t, n, r) {
		var i = function(i) {
			var o = 0;
			do {
				if (o++ > 10) if (r) t += r;
				else throw Error("too many ID collisions, use more bits");
				var s = e(t, n);
			} while (Object.hasOwnProperty.call(a, s));
			return a[s] = i, s;
		}, a = i.hats = {};
		return i.get = function(e) {
			return i.hats[e];
		}, i.set = function(e, t) {
			return i.hats[e] = t, i;
		}, i.bits = t || 128, i.base = n || 16, i;
	}, bD.exports;
}
var CD = /*@__PURE__*/ yD(SD());
function wD(e) {
	if (!(this instanceof wD)) return new wD(e);
	e ||= [
		128,
		36,
		1
	], this._seed = e.length ? CD.rack(e[0], e[1], e[2]) : e;
}
wD.prototype.next = function(e) {
	return this._seed(e || !0);
}, wD.prototype.nextPrefixed = function(e, t) {
	var n;
	do
		n = e + this.next(!0);
	while (this.assigned(n));
	return this.claim(n, t), n;
}, wD.prototype.claim = function(e, t) {
	this._seed.set(e, t || !0);
}, wD.prototype.assigned = function(e) {
	return this._seed.get(e) || !1;
}, wD.prototype.unclaim = function(e) {
	delete this._seed.hats[e];
}, wD.prototype.clear = function() {
	var e = this._seed.hats, t;
	for (t in e) this.unclaim(t);
};
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/BpmnRenderer.js
var TD = new wD(), ED = 10, DD = 3, OD = 1.5, kD = 10, AD = 4, jD = .95, MD = 1, ND = .25;
function PD(e, t, n, r, i, a, o) {
	xT.call(this, t, o);
	var s = e && e.defaultFillColor, c = e && e.defaultStrokeColor, l = e && e.defaultLabelColor;
	function u(e) {
		return n.computeStyle(e, {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: PE,
			strokeWidth: 2,
			fill: "white"
		});
	}
	function d(e) {
		return n.computeStyle(e, ["no-fill"], {
			strokeLinecap: "round",
			strokeLinejoin: "round",
			stroke: PE,
			strokeWidth: 2
		});
	}
	function f(e, t) {
		var { ref: n = {
			x: 0,
			y: 0
		}, scale: r = 1, element: a, parentGfx: o = i._svg } = t, s = aE("marker", {
			id: e,
			viewBox: "0 0 20 20",
			refX: n.x,
			refY: n.y,
			markerWidth: 20 * r,
			markerHeight: 20 * r,
			orient: "auto"
		});
		WT(s, a);
		var c = pD(":scope > defs", o);
		c || (c = aE("defs"), WT(o, c)), WT(c, s);
	}
	function p(e, t, n, r) {
		var i = TD.nextPrefixed("marker-");
		return m(e, i, t, n, r), "url(#" + i + ")";
	}
	function m(e, t, n, r, i) {
		n === "sequenceflow-end" && f(t, {
			element: aE("path", {
				d: "M 1 5 L 11 10 L 1 15 Z",
				...u({
					fill: i,
					stroke: i,
					strokeWidth: 1
				})
			}),
			ref: {
				x: 11,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "messageflow-start" && f(t, {
			element: aE("circle", {
				cx: 6,
				cy: 6,
				r: 3.5,
				...u({
					fill: r,
					stroke: i,
					strokeWidth: 1,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 6,
				y: 6
			},
			parentGfx: e
		}), n === "messageflow-end" && f(t, {
			element: aE("path", {
				d: "m 1 5 l 0 -3 l 7 3 l -7 3 z",
				...u({
					fill: r,
					stroke: i,
					strokeWidth: 1,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 8.5,
				y: 5
			},
			parentGfx: e
		}), n === "association-start" && f(t, {
			element: aE("path", {
				d: "M 11 5 L 1 10 L 11 15",
				...d({
					fill: "none",
					stroke: i,
					strokeWidth: 1.5,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 1,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "association-end" && f(t, {
			element: aE("path", {
				d: "M 1 5 L 11 10 L 1 15",
				...d({
					fill: "none",
					stroke: i,
					strokeWidth: 1.5,
					strokeDasharray: [1e4, 1]
				})
			}),
			ref: {
				x: 11,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "conditional-flow-marker" && f(t, {
			element: aE("path", {
				d: "M 0 10 L 8 6 L 16 10 L 8 14 Z",
				...u({
					fill: r,
					stroke: i
				})
			}),
			ref: {
				x: -1,
				y: 10
			},
			scale: .5,
			parentGfx: e
		}), n === "conditional-default-flow-marker" && f(t, {
			element: aE("path", {
				d: "M 6 4 L 10 16",
				...u({
					stroke: i,
					fill: "none"
				})
			}),
			ref: {
				x: 0,
				y: 10
			},
			scale: .5,
			parentGfx: e
		});
	}
	function h(e, t, n, r, i = {}) {
		$w(r) && (i = r, r = 0), r ||= 0, i = u(i);
		var a = aE("circle", {
			cx: t / 2,
			cy: n / 2,
			r: Math.round((t + n) / 4 - r),
			...i
		});
		return WT(e, a), a;
	}
	function g(e, t, n, r, i, a) {
		$w(i) && (a = i, i = 0), i ||= 0, a = u(a);
		var o = aE("rect", {
			x: i,
			y: i,
			width: t - i * 2,
			height: n - i * 2,
			rx: r,
			ry: r,
			...a
		});
		return WT(e, o), o;
	}
	function _(e, t, n, r) {
		var i = t / 2, a = n / 2, o = [
			{
				x: i,
				y: 0
			},
			{
				x: t,
				y: a
			},
			{
				x: i,
				y: n
			},
			{
				x: 0,
				y: a
			}
		].map(function(e) {
			return e.x + "," + e.y;
		}).join(" ");
		r = u(r);
		var s = aE("polygon", {
			...r,
			points: o
		});
		return WT(e, s), s;
	}
	function v(e, t, n, r) {
		n = d(n);
		var i = ME(t, n, r);
		return WT(e, i), i;
	}
	function y(e, t, n) {
		return v(e, t, n, 5);
	}
	function b(e, t, n) {
		n = d(n);
		var r = aE("path", {
			...n,
			d: t
		});
		return WT(e, r), r;
	}
	function x(e, t, n, r) {
		return b(t, n, Z({ "data-marker": e }, r));
	}
	function S(e) {
		return oe[e];
	}
	function C(e) {
		return function(t, n, r) {
			return S(e)(t, n, r);
		};
	}
	var w = {
		"bpmn:MessageEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_MESSAGE", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .235,
					my: .315
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: i ? RE(t, s, n.fill) : $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:TimerEventDefinition": function(e, t, n = {}) {
			var i = n.width || t.width, a = n.height || t.height, o = n.width ? 1 : 2, l = h(e, i, a, .2 * a, {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: o
			});
			b(e, r.getScaledPath("EVENT_TIMER_WH", {
				xScaleFactor: .75,
				yScaleFactor: .75,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: .5,
					my: .5
				}
			}), {
				stroke: $(t, c, n.stroke),
				strokeWidth: o
			});
			for (var u = 0; u < 12; u++) {
				var d = r.getScaledPath("EVENT_TIMER_LINE", {
					xScaleFactor: .75,
					yScaleFactor: .75,
					containerWidth: i,
					containerHeight: a,
					position: {
						mx: .5,
						my: .5
					}
				}), f = i / 2, p = a / 2;
				b(e, d, {
					strokeWidth: 1,
					stroke: $(t, c, n.stroke),
					transform: "rotate(" + u * 30 + "," + p + "," + f + ")"
				});
			}
			return l;
		},
		"bpmn:EscalationEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_ESCALATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .2
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ConditionalEventDefinition": function(e, t, n = {}) {
			return b(e, r.getScaledPath("EVENT_CONDITIONAL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .222
				}
			}), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:LinkEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_LINK", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .57,
					my: .263
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ErrorEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_ERROR", {
				xScaleFactor: 1.1,
				yScaleFactor: 1.1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .2,
					my: .722
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:CancelEventDefinition": function(e, t, n = {}, i) {
			var a = b(e, r.getScaledPath("EVENT_CANCEL_45", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .638,
					my: -.055
				}
			}), {
				fill: i ? $(t, c, n.stroke) : "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
			return vD(a, 45), a;
		},
		"bpmn:CompensateEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_COMPENSATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .22,
					my: .5
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:SignalEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_SIGNAL", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .5,
					my: .2
				}
			}), {
				strokeWidth: 1,
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		"bpmn:MultipleEventDefinition": function(e, t, n = {}, i) {
			return b(e, r.getScaledPath("EVENT_MULTIPLE", {
				xScaleFactor: 1.1,
				yScaleFactor: 1.1,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .211,
					my: .36
				}
			}), {
				fill: i ? $(t, c, n.stroke) : RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:ParallelMultipleEventDefinition": function(e, t, n = {}) {
			return b(e, r.getScaledPath("EVENT_PARALLEL_MULTIPLE", {
				xScaleFactor: 1.2,
				yScaleFactor: 1.2,
				containerWidth: n.width || t.width,
				containerHeight: n.height || t.height,
				position: {
					mx: .458,
					my: .194
				}
			}), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
		},
		"bpmn:TerminateEventDefinition": function(e, t, n = {}) {
			return h(e, t.width, t.height, 8, {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 4
			});
		}
	};
	function T(e, t, n = {}, r) {
		var i = CT(e), a = IE(i), o = r || e;
		return i.get("eventDefinitions") && i.get("eventDefinitions").length > 1 ? i.get("parallelMultiple") ? w["bpmn:ParallelMultipleEventDefinition"](t, o, n, a) : w["bpmn:MultipleEventDefinition"](t, o, n, a) : FE(i, "bpmn:MessageEventDefinition") ? w["bpmn:MessageEventDefinition"](t, o, n, a) : FE(i, "bpmn:TimerEventDefinition") ? w["bpmn:TimerEventDefinition"](t, o, n, a) : FE(i, "bpmn:ConditionalEventDefinition") ? w["bpmn:ConditionalEventDefinition"](t, o, n, a) : FE(i, "bpmn:SignalEventDefinition") ? w["bpmn:SignalEventDefinition"](t, o, n, a) : FE(i, "bpmn:EscalationEventDefinition") ? w["bpmn:EscalationEventDefinition"](t, o, n, a) : FE(i, "bpmn:LinkEventDefinition") ? w["bpmn:LinkEventDefinition"](t, o, n, a) : FE(i, "bpmn:ErrorEventDefinition") ? w["bpmn:ErrorEventDefinition"](t, o, n, a) : FE(i, "bpmn:CancelEventDefinition") ? w["bpmn:CancelEventDefinition"](t, o, n, a) : FE(i, "bpmn:CompensateEventDefinition") ? w["bpmn:CompensateEventDefinition"](t, o, n, a) : FE(i, "bpmn:TerminateEventDefinition") ? w["bpmn:TerminateEventDefinition"](t, o, n, a) : null;
	}
	var E = {
		ParticipantMultiplicityMarker: function(e, t, n = {}) {
			var i = GE(t, n), a = KE(t, n);
			x("participant-multiplicity", e, r.getScaledPath("MARKER_PARALLEL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 - 6) / i,
					my: (a - 15) / a
				}
			}), {
				strokeWidth: 2,
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		SubProcessMarker: function(e, t, n = {}) {
			_D(g(e, 14, 14, 0, {
				strokeWidth: 1,
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			}), t.width / 2 - 7.5, t.height - 20), x("sub-process", e, r.getScaledPath("MARKER_SUB_PROCESS", {
				xScaleFactor: 1.5,
				yScaleFactor: 1.5,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 - 7.5) / t.width,
					my: (t.height - 20) / t.height
				}
			}), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		ParallelMarker: function(e, t, n) {
			var i = GE(t, n), a = KE(t, n);
			x("parallel", e, r.getScaledPath("MARKER_PARALLEL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.parallel) / i,
					my: (a - 20) / a
				}
			}), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		SequentialMarker: function(e, t, n) {
			x("sequential", e, r.getScaledPath("MARKER_SEQUENTIAL", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 + n.seq) / t.width,
					my: (t.height - 19) / t.height
				}
			}), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		CompensationMarker: function(e, t, n) {
			x("compensation", e, r.getScaledPath("MARKER_COMPENSATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: (t.width / 2 + n.compensation) / t.width,
					my: (t.height - 13) / t.height
				}
			}), {
				strokeWidth: 1,
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke)
			});
		},
		LoopMarker: function(e, t, n) {
			var i = GE(t, n), a = KE(t, n);
			x("loop", e, r.getScaledPath("MARKER_LOOP", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.loop) / i,
					my: (a - 7) / a
				}
			}), {
				strokeWidth: 1.5,
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeMiterlimit: .5
			});
		},
		AdhocMarker: function(e, t, n) {
			var i = GE(t, n), a = KE(t, n);
			x("adhoc", e, r.getScaledPath("MARKER_ADHOC", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: (i / 2 + n.adhoc) / i,
					my: (a - 15) / a
				}
			}), {
				strokeWidth: 1,
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke)
			});
		}
	};
	function D(e, t, n, r) {
		E[e](t, n, r);
	}
	function O(e, t, n = [], r = {}) {
		r = {
			fill: r.fill,
			stroke: r.stroke,
			width: GE(t, r),
			height: KE(t, r)
		};
		var i = CT(t), a = n.includes("SubProcessMarker");
		r = a ? {
			...r,
			seq: -21,
			parallel: -22,
			compensation: -25,
			loop: -18,
			adhoc: 10
		} : {
			...r,
			seq: -5,
			parallel: -6,
			compensation: -7,
			loop: 0,
			adhoc: -8
		}, i.get("isForCompensation") && n.push("CompensationMarker"), Q(i, "bpmn:AdHocSubProcess") && (n.push("AdhocMarker"), a || Z(r, { compensation: r.compensation - 18 }));
		var o = i.get("loopCharacteristics"), s = o && o.get("isSequential");
		o && (Z(r, { compensation: r.compensation - 18 }), n.includes("AdhocMarker") && Z(r, {
			seq: -23,
			loop: -18,
			parallel: -24
		}), s === void 0 && n.push("LoopMarker"), s === !1 && n.push("ParallelMarker"), s === !0 && n.push("SequentialMarker")), n.includes("CompensationMarker") && n.length === 1 && Z(r, { compensation: -8 }), X(n, function(n) {
			D(n, e, t, r);
		});
	}
	function k(e, t, n = {}) {
		n = Z({ size: { width: 100 } }, n);
		var r = a.createText(t || "", n);
		return QT(r).add("djs-label"), WT(e, r), r;
	}
	function ee(e, t, n, r = {}) {
		var i = CT(t), a = WE({
			x: t.x,
			y: t.y,
			width: t.width,
			height: t.height
		}, r);
		return k(e, i.name, {
			align: n,
			box: a,
			padding: 7,
			style: { fill: zE(t, l, c, r.stroke) }
		});
	}
	function A(e, t, n = {}) {
		var r = {
			width: t.width,
			height: t.height,
			x: t.width / 2 + t.x,
			y: t.height / 2 + t.y
		};
		return k(e, RT(t), {
			box: r,
			style: Z({}, a.getExternalStyle(), { fill: zE(t, l, c, n.stroke) })
		});
	}
	function j(e, t, n, r = {}) {
		var i = ET(n), a = k(e, t, {
			box: {
				height: 30,
				width: i ? KE(n, r) : GE(n, r)
			},
			align: "center-middle",
			style: { fill: zE(n, l, c, r.stroke) }
		});
		i && gD(a, 0, -(-1 * KE(n, r)), 270);
	}
	function M(e, t, n = {}) {
		var { width: r, height: i } = WE(t, n);
		return g(e, r, i, kD, {
			...n,
			fill: RE(t, s, n.fill),
			fillOpacity: jD,
			stroke: $(t, c, n.stroke)
		});
	}
	function N(e, t, n = {}) {
		var r = CT(t), i = RE(t, s, n.fill), a = $(t, c, n.stroke);
		return (r.get("associationDirection") === "One" || r.get("associationDirection") === "Both") && (n.markerEnd = p(e, "association-end", i, a)), r.get("associationDirection") === "Both" && (n.markerStart = p(e, "association-start", i, a)), n = FD(n, ["markerStart", "markerEnd"]), y(e, t.waypoints, {
			...n,
			stroke: a,
			strokeDasharray: "0, 5"
		});
	}
	function te(e, t, n = {}) {
		var i = RE(t, s, n.fill), a = $(t, c, n.stroke), o = b(e, r.getScaledPath("DATA_OBJECT_PATH", {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: t.width,
			containerHeight: t.height,
			position: {
				mx: .474,
				my: .296
			}
		}), {
			fill: i,
			fillOpacity: jD,
			stroke: a
		});
		return LE(CT(t)) && b(e, r.getScaledPath("DATA_OBJECT_COLLECTION_PATH", {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: t.width,
			containerHeight: t.height,
			position: {
				mx: .33,
				my: (t.height - 18) / t.height
			}
		}), {
			strokeWidth: 2,
			fill: i,
			stroke: a
		}), o;
	}
	function ne(e, t, n = {}) {
		return h(e, t.width, t.height, {
			fillOpacity: jD,
			...n,
			fill: RE(t, s, n.fill),
			stroke: $(t, c, n.stroke)
		});
	}
	function P(e, t, n = {}) {
		return _(e, t.width, t.height, {
			fill: RE(t, s, n.fill),
			fillOpacity: jD,
			stroke: $(t, c, n.stroke)
		});
	}
	function re(e, t, n = {}) {
		var r = g(e, GE(t, n), KE(t, n), 0, {
			fill: RE(t, s, n.fill),
			fillOpacity: n.fillOpacity || jD,
			stroke: $(t, c, n.stroke),
			strokeWidth: 1.5
		}), i = CT(t);
		return Q(i, "bpmn:Lane") && j(e, i.get("name"), t, n), r;
	}
	function ie(e, t, n = {}) {
		var r = M(e, t, n), i = TT(t);
		if (DT(t) && (XT(r, {
			strokeDasharray: "0, 5.5",
			strokeWidth: 2.5
		}), !i)) {
			var a = (CT(t).flowElements || []).filter((e) => Q(e, "bpmn:StartEvent"));
			a.length === 1 && ae(a[0], e, n, t);
		}
		return ee(e, t, i ? "center-top" : "center-middle", n), i ? O(e, t, void 0, n) : O(e, t, ["SubProcessMarker"], n), r;
	}
	function ae(e, t, n, r) {
		var i = 22, a = {
			fill: RE(r, s, n.fill),
			stroke: $(r, c, n.stroke),
			width: i,
			height: i
		}, o = CT(e).isInterrupting, l = o ? 0 : 3, u = o ? 1 : 1.2, d = 20, f = (i - d) / 2, p = "translate(" + f + "," + f + ")";
		h(t, d, d, {
			fill: a.fill,
			stroke: a.stroke,
			strokeWidth: u,
			strokeDasharray: l,
			transform: p
		}), T(e, t, a, r);
	}
	function F(e, t, n = {}) {
		var r = M(e, t, n);
		return ee(e, t, "center-middle", n), O(e, t, void 0, n), r;
	}
	var oe = this.handlers = {
		"bpmn:AdHocSubProcess": function(e, t, n = {}) {
			return n = TT(t) ? FD(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : FD(n, ["fill", "stroke"]), ie(e, t, n);
		},
		"bpmn:Association": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), N(e, t, n);
		},
		"bpmn:BoundaryEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = FD(n, ["fill", "stroke"]);
			var i = CT(t).get("cancelActivity");
			n = {
				strokeWidth: 1.5,
				fill: RE(t, s, n.fill),
				fillOpacity: MD,
				stroke: $(t, c, n.stroke)
			}, i || (n.strokeDasharray = "6");
			var a = ne(e, t, n);
			return h(e, t.width, t.height, DD, {
				...n,
				fill: "none"
			}), r && T(t, e, n), a;
		},
		"bpmn:BusinessRuleTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n);
			return XT(b(e, r.getScaledPath("TASK_TYPE_BUSINESS_RULE_MAIN", { abspos: {
				x: 8,
				y: 8
			} })), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), XT(b(e, r.getScaledPath("TASK_TYPE_BUSINESS_RULE_HEADER", { abspos: {
				x: 8,
				y: 8
			} })), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:CallActivity": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), ie(e, t, {
				strokeWidth: 5,
				...n
			});
		},
		"bpmn:ComplexGateway": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = P(e, t, n);
			return b(e, r.getScaledPath("GATEWAY_COMPLEX", {
				xScaleFactor: .5,
				yScaleFactor: .5,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .46,
					my: .26
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:DataInput": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = r.getRawPath("DATA_ARROW"), a = te(e, t, n);
			return b(e, i, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), a;
		},
		"bpmn:DataInputAssociation": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), N(e, t, {
				...n,
				markerEnd: p(e, "association-end", RE(t, s, n.fill), $(t, c, n.stroke))
			});
		},
		"bpmn:DataObject": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), te(e, t, n);
		},
		"bpmn:DataObjectReference": C("bpmn:DataObject"),
		"bpmn:DataOutput": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = r.getRawPath("DATA_ARROW"), a = te(e, t, n);
			return b(e, i, {
				strokeWidth: 1,
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke)
			}), a;
		},
		"bpmn:DataOutputAssociation": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), N(e, t, {
				...n,
				markerEnd: p(e, "association-end", RE(t, s, n.fill), $(t, c, n.stroke))
			});
		},
		"bpmn:DataStoreReference": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), b(e, r.getScaledPath("DATA_STORE", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: 0,
					my: .133
				}
			}), {
				fill: RE(t, s, n.fill),
				fillOpacity: jD,
				stroke: $(t, c, n.stroke),
				strokeWidth: 2
			});
		},
		"bpmn:EndEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = FD(n, ["fill", "stroke"]);
			var i = ne(e, t, {
				...n,
				strokeWidth: 4
			});
			return r && T(t, e, n), i;
		},
		"bpmn:EventBasedGateway": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = CT(t), a = P(e, t, n);
			h(e, t.width, t.height, t.height * .2, {
				fill: RE(t, "none", n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			});
			var o = i.get("eventGatewayType"), s = !!i.get("instantiate");
			function l() {
				b(e, r.getScaledPath("GATEWAY_EVENT_BASED", {
					xScaleFactor: .18,
					yScaleFactor: .18,
					containerWidth: t.width,
					containerHeight: t.height,
					position: {
						mx: .36,
						my: .44
					}
				}), {
					fill: "none",
					stroke: $(t, c, n.stroke),
					strokeWidth: 2
				});
			}
			return o === "Parallel" ? b(e, r.getScaledPath("GATEWAY_PARALLEL", {
				xScaleFactor: .4,
				yScaleFactor: .4,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .474,
					my: .296
				}
			}), {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}) : o === "Exclusive" && (s || h(e, t.width, t.height, t.height * .26, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), l()), a;
		},
		"bpmn:ExclusiveGateway": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = P(e, t, n), a = r.getScaledPath("GATEWAY_EXCLUSIVE", {
				xScaleFactor: .4,
				yScaleFactor: .4,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .32,
					my: .3
				}
			});
			return wT(t).get("isMarkerVisible") && b(e, a, {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:Gateway": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), P(e, t, n);
		},
		"bpmn:Group": function(e, t, n = {}) {
			return n = FD(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]), g(e, t.width, t.height, kD, {
				stroke: $(t, c, n.stroke),
				strokeWidth: 1.5,
				strokeDasharray: "10, 6, 0, 6",
				fill: "none",
				pointerEvents: "none",
				width: GE(t, n),
				height: KE(t, n)
			});
		},
		"bpmn:InclusiveGateway": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var r = P(e, t, n);
			return h(e, t.width, t.height, t.height * .24, {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 2.5
			}), r;
		},
		"bpmn:IntermediateEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = FD(n, ["fill", "stroke"]);
			var i = ne(e, t, {
				...n,
				strokeWidth: 1.5
			});
			return h(e, t.width, t.height, DD, {
				fill: "none",
				stroke: $(t, c, n.stroke),
				strokeWidth: 1.5
			}), r && T(t, e, n), i;
		},
		"bpmn:IntermediateCatchEvent": C("bpmn:IntermediateEvent"),
		"bpmn:IntermediateThrowEvent": C("bpmn:IntermediateEvent"),
		"bpmn:Lane": function(e, t, n = {}) {
			return n = FD(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]), re(e, t, {
				...n,
				fillOpacity: ND
			});
		},
		"bpmn:ManualTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_MANUAL", { abspos: {
				x: 17,
				y: 15
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), i;
		},
		"bpmn:MessageFlow": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = CT(t), a = wT(t), o = RE(t, s, n.fill), l = $(t, c, n.stroke), u = y(e, t.waypoints, {
				markerEnd: p(e, "messageflow-end", o, l),
				markerStart: p(e, "messageflow-start", o, l),
				stroke: l,
				strokeDasharray: "10, 11",
				strokeWidth: 1.5
			});
			if (i.get("messageRef")) {
				var d = u.getPointAtLength(u.getTotalLength() / 2), f = r.getScaledPath("MESSAGE_FLOW_MARKER", { abspos: {
					x: d.x,
					y: d.y
				} }), m = { strokeWidth: 1 };
				a.get("messageVisibleKind") === "initiating" ? (m.fill = o, m.stroke = l) : (m.fill = l, m.stroke = o);
				var h = b(e, f, m), g = k(e, i.get("messageRef").get("name"), {
					align: "center-top",
					fitBox: !0,
					style: { fill: l }
				}), _ = h.getBBox(), v = g.getBBox();
				gD(g, d.x - v.width / 2, d.y + _.height / 2 + ED, 0);
			}
			return u;
		},
		"bpmn:ParallelGateway": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = P(e, t, n);
			return b(e, r.getScaledPath("GATEWAY_PARALLEL", {
				xScaleFactor: .6,
				yScaleFactor: .6,
				containerWidth: t.width,
				containerHeight: t.height,
				position: {
					mx: .46,
					my: .2
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:Participant": function(e, t, n = {}) {
			n = FD(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]);
			var r = re(e, t, n), i = TT(t), a = ET(t), o = CT(t), s = o.get("name");
			if (i) v(e, a ? [{
				x: 30,
				y: 0
			}, {
				x: 30,
				y: KE(t, n)
			}] : [{
				x: 0,
				y: 30
			}, {
				x: GE(t, n),
				y: 30
			}], {
				stroke: $(t, c, n.stroke),
				strokeWidth: OD
			}), j(e, s, t, n);
			else {
				var u = WE(t, n);
				a || (u.height = GE(t, n), u.width = KE(t, n));
				var d = k(e, s, {
					box: u,
					align: "center-middle",
					style: { fill: zE(t, l, c, n.stroke) }
				});
				a || gD(d, 0, -(-1 * KE(t, n)), 270);
			}
			return o.get("participantMultiplicity") && D("ParticipantMultiplicityMarker", e, t, n), r;
		},
		"bpmn:ReceiveTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = CT(t), a = F(e, t, n), o;
			return i.get("instantiate") ? (h(e, 28, 28, 20 * .22, {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), o = r.getScaledPath("TASK_TYPE_INSTANTIATING_SEND", { abspos: {
				x: 7.77,
				y: 9.52
			} })) : o = r.getScaledPath("TASK_TYPE_SEND", {
				xScaleFactor: .9,
				yScaleFactor: .9,
				containerWidth: 21,
				containerHeight: 14,
				position: {
					mx: .3,
					my: .4
				}
			}), b(e, o, {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), a;
		},
		"bpmn:ScriptTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_SCRIPT", { abspos: {
				x: 15,
				y: 20
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:SendTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n);
			return b(e, r.getScaledPath("TASK_TYPE_SEND", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: 21,
				containerHeight: 14,
				position: {
					mx: .285,
					my: .357
				}
			}), {
				fill: $(t, c, n.stroke),
				stroke: RE(t, s, n.fill),
				strokeWidth: 1
			}), i;
		},
		"bpmn:SequenceFlow": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var r = RE(t, s, n.fill), i = $(t, c, n.stroke), a = y(e, t.waypoints, {
				markerEnd: p(e, "sequenceflow-end", r, i),
				stroke: i
			}), o = CT(t), { source: l } = t;
			if (l) {
				var u = CT(l);
				o.get("conditionExpression") && Q(u, "bpmn:Activity") && XT(a, { markerStart: p(e, "conditional-flow-marker", r, i) }), u.get("default") && (Q(u, "bpmn:Gateway") || Q(u, "bpmn:Activity")) && u.get("default") === o && XT(a, { markerStart: p(e, "conditional-default-flow-marker", r, i) });
			}
			return a;
		},
		"bpmn:ServiceTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n);
			return h(e, 10, 10, {
				fill: RE(t, s, n.fill),
				stroke: "none",
				transform: "translate(6, 6)"
			}), b(e, r.getScaledPath("TASK_TYPE_SERVICE", { abspos: {
				x: 12,
				y: 18
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), h(e, 10, 10, {
				fill: RE(t, s, n.fill),
				stroke: "none",
				transform: "translate(11, 10)"
			}), b(e, r.getScaledPath("TASK_TYPE_SERVICE", { abspos: {
				x: 17,
				y: 22
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: 1
			}), i;
		},
		"bpmn:StartEvent": function(e, t, n = {}) {
			var { renderIcon: r = !0 } = n;
			n = FD(n, ["fill", "stroke"]), CT(t).get("isInterrupting") || (n = {
				...n,
				strokeDasharray: "6"
			});
			var i = ne(e, t, n);
			return r && T(t, e, n), i;
		},
		"bpmn:SubProcess": function(e, t, n = {}) {
			return n = TT(t) ? FD(n, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : FD(n, ["fill", "stroke"]), ie(e, t, n);
		},
		"bpmn:Task": function(e, t, n = {}) {
			return n = FD(n, ["fill", "stroke"]), F(e, t, n);
		},
		"bpmn:TextAnnotation": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var { width: i, height: a } = WE(t, n), o = g(e, i, a, 0, 0, {
				fill: "none",
				stroke: "none"
			});
			return b(e, r.getScaledPath("TEXT_ANNOTATION", {
				xScaleFactor: 1,
				yScaleFactor: 1,
				containerWidth: i,
				containerHeight: a,
				position: {
					mx: 0,
					my: 0
				}
			}), { stroke: $(t, c, n.stroke) }), k(e, CT(t).get("text") || "", {
				align: "left-top",
				box: WE(t, n),
				padding: 7,
				style: { fill: zE(t, l, c, n.stroke) }
			}), o;
		},
		"bpmn:Transaction": function(e, t, r = {}) {
			r = TT(t) ? FD(r, [
				"fill",
				"stroke",
				"width",
				"height"
			]) : FD(r, ["fill", "stroke"]);
			var i = ie(e, t, {
				strokeWidth: 1.5,
				...r
			}), a = n.style(["no-fill", "no-events"], {
				stroke: $(t, c, r.stroke),
				strokeWidth: 1.5
			});
			return TT(t) || (r = {}), g(e, GE(t, r), KE(t, r), kD - DD, DD, a), i;
		},
		"bpmn:UserTask": function(e, t, n = {}) {
			n = FD(n, ["fill", "stroke"]);
			var i = F(e, t, n), a = 15, o = 12;
			return b(e, r.getScaledPath("TASK_TYPE_USER_1", { abspos: {
				x: a,
				y: o
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), b(e, r.getScaledPath("TASK_TYPE_USER_2", { abspos: {
				x: a,
				y: o
			} }), {
				fill: RE(t, s, n.fill),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), b(e, r.getScaledPath("TASK_TYPE_USER_3", { abspos: {
				x: a,
				y: o
			} }), {
				fill: $(t, c, n.stroke),
				stroke: $(t, c, n.stroke),
				strokeWidth: .5
			}), i;
		},
		label: function(e, t, n = {}) {
			return A(e, t, n);
		}
	};
	this._drawPath = b, this._renderer = S;
}
Kw(PD, xT), PD.$inject = [
	"config.bpmnRenderer",
	"eventBus",
	"styles",
	"pathMap",
	"canvas",
	"textRenderer"
], PD.prototype.canRender = function(e) {
	return Q(e, "bpmn:BaseElement");
}, PD.prototype.drawShape = function(e, t, n = {}) {
	var { type: r } = t;
	return this._renderer(r)(e, t, n);
}, PD.prototype.drawConnection = function(e, t, n = {}) {
	var { type: r } = t;
	return this._renderer(r)(e, t, n);
}, PD.prototype.getShapePath = function(e) {
	return kT(e) ? VE(e, AD) : Q(e, "bpmn:Event") ? BE(e) : Q(e, "bpmn:Activity") ? VE(e, kD) : Q(e, "bpmn:Gateway") ? HE(e) : UE(e);
};
function FD(e, t = []) {
	return t.reduce((t, n) => (e[n] && (t[n] = e[n]), t), {});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Text.js
var ID = 0, LD = {
	width: 150,
	height: 50
};
function RD(e) {
	var t = e.split("-");
	return {
		horizontal: t[0] || "center",
		vertical: t[1] || "top"
	};
}
function zD(e) {
	return $w(e) ? Z({
		top: 0,
		left: 0,
		right: 0,
		bottom: 0
	}, e) : {
		top: e,
		left: e,
		right: e,
		bottom: e
	};
}
var BD = null;
function VD() {
	return BD ||= document.createElement("canvas").getContext("2d"), BD;
}
function HD(e) {
	var t = [];
	return e.fontStyle && t.push(e.fontStyle), e.fontVariant && t.push(e.fontVariant), e.fontWeight && t.push(e.fontWeight), e.fontStretch && t.push(e.fontStretch), t.push(UD(e.fontSize) || "12px"), t.push(e.fontFamily || "sans-serif"), t.join(" ");
}
function UD(e) {
	if (e != null) return typeof e == "number" || /^-?\d+(\.\d+)?$/.test(e) ? e + "px" : e;
}
function WD(e, t) {
	var n = VD();
	if (!n) return {
		width: 0,
		height: 0
	};
	n.font = HD(t), "letterSpacing" in n && (n.letterSpacing = UD(t.letterSpacing) || "0px");
	var r = e === "", i = r ? "dummy" : e.replace(/\s+$/, ""), a = n.measureText(i);
	return {
		width: r ? 0 : a.width,
		height: "fontBoundingBoxAscent" in a ? a.fontBoundingBoxAscent + a.fontBoundingBoxDescent : a.actualBoundingBoxAscent + a.actualBoundingBoxDescent
	};
}
function GD(e, t, n) {
	for (var r = e.shift(), i = r, a;;) {
		if (a = WD(i, n), a.width = i ? a.width : 0, i === " " || i === "" || a.width < Math.round(t) || i.length < 2) return KD(e, i, r, a);
		i = YD(i, a.width, t);
	}
}
function KD(e, t, n, r) {
	if (t.length < n.length) {
		var i = n.slice(t.length).trim();
		e.unshift(i);
	}
	return {
		width: r.width,
		height: r.height,
		text: t
	};
}
var qD = "­";
function JD(e, t) {
	var n = e.split(/(\s|-|\u00AD)/g), r, i = [], a = 0;
	if (n.length > 1) for (; r = n.shift();) if (r.length + a < t) i.push(r), a += r.length;
	else {
		(r === "-" || r === qD) && i.pop();
		break;
	}
	var o = i[i.length - 1];
	return o && o === qD && (i[i.length - 1] = "-"), i.join("");
}
function YD(e, t, n) {
	var r = Math.max(e.length * (n / t), 1), i = JD(e, r);
	return i ||= e.slice(0, Math.max(Math.round(r - 1), 1)), i;
}
function XD(e) {
	this._config = Z({}, {
		size: LD,
		padding: ID,
		style: {},
		align: "center-top"
	}, e || {});
}
XD.prototype.createText = function(e, t) {
	return this.layoutText(e, t).element;
}, XD.prototype.getDimensions = function(e, t) {
	return this.layoutText(e, t).dimensions;
}, XD.prototype.layoutText = function(e, t) {
	for (var n = Z({}, this._config.size, t.box), r = Z({}, this._config.style, t.style), i = RD(t.align || this._config.align), a = zD(t.padding === void 0 ? this._config.padding : t.padding), o = t.fitBox || !1, s = ZD(r), c = e.split(/\u00AD?\r?\n/), l = [], u = n.width - a.left - a.right; c.length;) l.push(GD(c, u, r));
	i.vertical === "middle" && (a.top = a.bottom = 0);
	var d = sT(l, function(e, t, n) {
		return e + (s || t.height);
	}, 0) + a.top + a.bottom, f = sT(l, function(e, t, n) {
		return t.width > e ? t.width : e;
	}, 0), p = a.top;
	i.vertical === "middle" && (p += (n.height - d) / 2), p -= (s || l[0].height) / 4;
	var m = aE("text");
	return XT(m, r), X(l, function(e) {
		var t;
		switch (p += s || e.height, i.horizontal) {
			case "left":
				t = a.left;
				break;
			case "right":
				t = (o ? f : u) - a.right - e.width;
				break;
			default: t = Math.max(((o ? f : u) - e.width) / 2 + a.left, 0);
		}
		var n = aE("tspan");
		XT(n, {
			x: t,
			y: p
		}), n.textContent = e.text, WT(m, n);
	}), {
		dimensions: {
			width: f,
			height: d
		},
		element: m
	};
};
function ZD(e) {
	if ("fontSize" in e && "lineHeight" in e) return e.lineHeight * parseInt(e.fontSize, 10);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/TextRenderer.js
var QD = 12, $D = 1.2, eO = 40;
function tO(e) {
	var t = Z({
		fontFamily: "Arial, sans-serif",
		fontSize: QD,
		fontWeight: "normal",
		lineHeight: $D
	}, e && e.defaultStyle || {}), n = Z({}, t, { fontSize: parseInt(t.fontSize, 10) - 1 }, e && e.externalStyle || {}), r = new XD({ style: t });
	this.getExternalLabelBounds = function(e, t) {
		var r = i(t, {
			width: Math.max(e.width, AT.width),
			height: 30
		}, { style: n });
		return {
			x: Math.round(e.x + e.width / 2 - r.width / 2),
			y: e.y,
			width: Math.ceil(r.width),
			height: Math.ceil(r.height)
		};
	}, this.getTextAnnotationBounds = function(e, n) {
		var r = i(n, e, {
			style: t,
			align: "left-top",
			padding: 7
		});
		return {
			x: e.x,
			y: e.y,
			width: e.width,
			height: Math.max(eO, Math.round(r.height))
		};
	}, this.getDimensions = function(e, t) {
		return r.getDimensions(e, t || {});
	};
	function i(e, t, n) {
		return r.getDimensions(e, Z({ box: t }, n));
	}
	this.createText = function(e, t) {
		return r.createText(e, t || {});
	}, this.getDefaultStyle = function() {
		return t;
	}, this.getExternalStyle = function() {
		return n;
	};
}
tO.$inject = ["config.textRenderer"];
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/PathMap.js
function nO() {
	this.pathMap = {
		EVENT_MESSAGE: {
			d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
			height: 36,
			width: 36,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		EVENT_SIGNAL: {
			d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x1},0 Z",
			height: 36,
			width: 36,
			heightElements: [18],
			widthElements: [10, 20]
		},
		EVENT_ESCALATION: {
			d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x0},-{e.y1} l -{e.x0},{e.y1} Z",
			height: 36,
			width: 36,
			heightElements: [20, 7],
			widthElements: [8]
		},
		EVENT_CONDITIONAL: {
			d: "M {e.x0},{e.y0} l {e.x1},0 l 0,{e.y2} l -{e.x1},0 Z M {e.x2},{e.y3} l {e.x0},0 M {e.x2},{e.y4} l {e.x0},0 M {e.x2},{e.y5} l {e.x0},0 M {e.x2},{e.y6} l {e.x0},0 M {e.x2},{e.y7} l {e.x0},0 M {e.x2},{e.y8} l {e.x0},0 ",
			height: 36,
			width: 36,
			heightElements: [
				8.5,
				14.5,
				18,
				11.5,
				14.5,
				17.5,
				20.5,
				23.5,
				26.5
			],
			widthElements: [
				10.5,
				14.5,
				12.5
			]
		},
		EVENT_LINK: {
			d: "m {mx},{my} 0,{e.y0} -{e.x1},0 0,{e.y1} {e.x1},0 0,{e.y0} {e.x0},-{e.y2} -{e.x0},-{e.y2} z",
			height: 36,
			width: 36,
			heightElements: [
				4.4375,
				6.75,
				7.8125
			],
			widthElements: [9.84375, 13.5]
		},
		EVENT_ERROR: {
			d: "m {mx},{my} {e.x0},-{e.y0} {e.x1},-{e.y1} {e.x2},{e.y2} {e.x3},-{e.y3} -{e.x4},{e.y4} -{e.x5},-{e.y5} z",
			height: 36,
			width: 36,
			heightElements: [
				.023,
				8.737,
				8.151,
				16.564,
				10.591,
				8.714
			],
			widthElements: [
				.085,
				6.672,
				6.97,
				4.273,
				5.337,
				6.636
			]
		},
		EVENT_CANCEL_45: {
			d: "m {mx},{my} -{e.x1},0 0,{e.x0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
			height: 36,
			width: 36,
			heightElements: [4.75, 8.5],
			widthElements: [4.75, 8.5]
		},
		EVENT_COMPENSATION: {
			d: "m {mx},{my} {e.x0},-{e.y0} 0,{e.y1} z m {e.x1},-{e.y2} {e.x2},-{e.y3} 0,{e.y1} -{e.x2},-{e.y3} z",
			height: 36,
			width: 36,
			heightElements: [
				6.5,
				13,
				.4,
				6.1
			],
			widthElements: [
				9,
				9.3,
				8.7
			]
		},
		EVENT_TIMER_WH: {
			d: "M {mx},{my} l {e.x0},-{e.y0} m -{e.x0},{e.y0} l {e.x1},{e.y1} ",
			height: 36,
			width: 36,
			heightElements: [10, 2],
			widthElements: [3, 7]
		},
		EVENT_TIMER_LINE: {
			d: "M {mx},{my} m {e.x0},{e.y0} l -{e.x1},{e.y1} ",
			height: 36,
			width: 36,
			heightElements: [10, 3],
			widthElements: [0, 0]
		},
		EVENT_MULTIPLE: {
			d: "m {mx},{my} {e.x1},-{e.y0} {e.x1},{e.y0} -{e.x0},{e.y1} -{e.x2},0 z",
			height: 36,
			width: 36,
			heightElements: [6.28099, 12.56199],
			widthElements: [
				3.1405,
				9.42149,
				12.56198
			]
		},
		EVENT_PARALLEL_MULTIPLE: {
			d: "m {mx},{my} {e.x0},0 0,{e.y1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} -{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z",
			height: 36,
			width: 36,
			heightElements: [2.56228, 7.68683],
			widthElements: [2.56228, 7.68683]
		},
		GATEWAY_EXCLUSIVE: {
			d: "m {mx},{my} {e.x0},{e.y0} {e.x1},{e.y0} {e.x2},0 {e.x4},{e.y2} {e.x4},{e.y1} {e.x2},0 {e.x1},{e.y3} {e.x0},{e.y3} {e.x3},0 {e.x5},{e.y1} {e.x5},{e.y2} {e.x3},0 z",
			height: 17.5,
			width: 17.5,
			heightElements: [
				8.5,
				6.5312,
				-6.5312,
				-8.5
			],
			widthElements: [
				6.5,
				-6.5,
				3,
				-3,
				5,
				-5
			]
		},
		GATEWAY_PARALLEL: {
			d: "m {mx},{my} 0,{e.y1} -{e.x1},0 0,{e.y0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
			height: 30,
			width: 30,
			heightElements: [5, 12.5],
			widthElements: [5, 12.5]
		},
		GATEWAY_EVENT_BASED: {
			d: "m {mx},{my} {e.x0},{e.y0} {e.x0},{e.y1} {e.x1},{e.y2} {e.x2},0 z",
			height: 11,
			width: 11,
			heightElements: [
				-6,
				6,
				12,
				-12
			],
			widthElements: [
				9,
				-3,
				-12
			]
		},
		GATEWAY_COMPLEX: {
			d: "m {mx},{my} 0,{e.y0} -{e.x0},-{e.y1} -{e.x1},{e.y2} {e.x0},{e.y1} -{e.x2},0 0,{e.y3} {e.x2},0  -{e.x0},{e.y1} l {e.x1},{e.y2} {e.x0},-{e.y1} 0,{e.y0} {e.x3},0 0,-{e.y0} {e.x0},{e.y1} {e.x1},-{e.y2} -{e.x0},-{e.y1} {e.x2},0 0,-{e.y3} -{e.x2},0 {e.x0},-{e.y1} -{e.x1},-{e.y2} -{e.x0},{e.y1} 0,-{e.y0} -{e.x3},0 z",
			height: 17.125,
			width: 17.125,
			heightElements: [
				4.875,
				3.4375,
				2.125,
				3
			],
			widthElements: [
				3.4375,
				2.125,
				4.875,
				3
			]
		},
		DATA_OBJECT_PATH: {
			d: "m 0,0 {e.x1},0 {e.x0},{e.y0} 0,{e.y1} -{e.x2},0 0,-{e.y2} {e.x1},0 0,{e.y0} {e.x0},0",
			height: 61,
			width: 51,
			heightElements: [
				10,
				50,
				60
			],
			widthElements: [
				10,
				40,
				50,
				60
			]
		},
		DATA_OBJECT_COLLECTION_PATH: {
			d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		DATA_ARROW: {
			d: "m 5,9 9,0 0,-3 5,5 -5,5 0,-3 -9,0 z",
			height: 61,
			width: 51,
			heightElements: [],
			widthElements: []
		},
		DATA_STORE: {
			d: "m  {mx},{my} l  0,{e.y2} c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 l  0,-{e.y2} c -{e.x0},-{e.y1} -{e.x1},-{e.y1} -{e.x2},0c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1} {e.x2},0m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0",
			height: 61,
			width: 61,
			heightElements: [
				7,
				10,
				45
			],
			widthElements: [
				2,
				58,
				60
			]
		},
		TEXT_ANNOTATION: {
			d: "m {mx}, {my} m 10,0 l -10,0 l 0,{e.y0} l 10,0",
			height: 30,
			width: 10,
			heightElements: [30],
			widthElements: [10]
		},
		MARKER_SUB_PROCESS: {
			d: "m{mx},{my} m 7,2 l 0,10 m -5,-5 l 10,0",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_PARALLEL: {
			d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_SEQUENTIAL: {
			d: "m{mx},{my} m 0,3 l 10,0 m -10,3 l 10,0 m -10,3 l 10,0",
			height: 10,
			width: 10,
			heightElements: [],
			widthElements: []
		},
		MARKER_COMPENSATION: {
			d: "m {mx},{my} 7,-5 0,10 z m 7.1,-0.3 6.9,-4.7 0,10 -6.9,-4.7 z",
			height: 10,
			width: 21,
			heightElements: [],
			widthElements: []
		},
		MARKER_LOOP: {
			d: "m {mx},{my} c 3.526979,0 6.386161,-2.829858 6.386161,-6.320661 0,-3.490806 -2.859182,-6.320661 -6.386161,-6.320661 -3.526978,0 -6.38616,2.829855 -6.38616,6.320661 0,1.745402 0.714797,3.325567 1.870463,4.469381 0.577834,0.571908 1.265885,1.034728 2.029916,1.35457 l -0.718163,-3.909793 m 0.718163,3.909793 -3.885211,0.802902",
			height: 13.9,
			width: 13.7,
			heightElements: [],
			widthElements: []
		},
		MARKER_ADHOC: {
			d: "m {mx},{my} m 0.84461,2.64411 c 1.05533,-1.23780996 2.64337,-2.07882 4.29653,-1.97997996 2.05163,0.0805 3.85579,1.15803 5.76082,1.79107 1.06385,0.34139996 2.24454,0.1438 3.18759,-0.43767 0.61743,-0.33642 1.2775,-0.64078 1.7542,-1.17511 0,0.56023 0,1.12046 0,1.6807 -0.98706,0.96237996 -2.29792,1.62393996 -3.6918,1.66181996 -1.24459,0.0927 -2.46671,-0.2491 -3.59505,-0.74812 -1.35789,-0.55965 -2.75133,-1.33436996 -4.27027,-1.18121996 -1.37741,0.14601 -2.41842,1.13685996 -3.44288,1.96782996 z",
			height: 4,
			width: 15,
			heightElements: [],
			widthElements: []
		},
		TASK_TYPE_SEND: {
			d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
			height: 14,
			width: 21,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		TASK_TYPE_SCRIPT: {
			d: "m {mx},{my} c 9.966553,-6.27276 -8.000926,-7.91932 2.968968,-14.938 l -8.802728,0 c -10.969894,7.01868 6.997585,8.66524 -2.968967,14.938 z m -7,-12 l 5,0 m -4.5,3 l 4.5,0 m -3,3 l 5,0m -4,3 l 5,0",
			height: 15,
			width: 12.6,
			heightElements: [6, 14],
			widthElements: [10.5, 21]
		},
		TASK_TYPE_USER_1: { d: "m {mx},{my} c 0.909,-0.845 1.594,-2.049 1.594,-3.385 0,-2.554 -1.805,-4.62199999 -4.357,-4.62199999 -2.55199998,0 -4.28799998,2.06799999 -4.28799998,4.62199999 0,1.348 0.974,2.562 1.89599998,3.405 -0.52899998,0.187 -5.669,2.097 -5.794,4.7560005 v 6.718 h 17 v -6.718 c 0,-2.2980005 -5.5279996,-4.5950005 -6.0509996,-4.7760005 zm -8,6 l 0,5.5 m 11,0 l 0,-5" },
		TASK_TYPE_USER_2: { d: "m {mx},{my} m 2.162,1.009 c 0,2.4470005 -2.158,4.4310005 -4.821,4.4310005 -2.66499998,0 -4.822,-1.981 -4.822,-4.4310005 " },
		TASK_TYPE_USER_3: { d: "m {mx},{my} m -6.9,-3.80 c 0,0 2.25099998,-2.358 4.27399998,-1.177 2.024,1.181 4.221,1.537 4.124,0.965 -0.098,-0.57 -0.117,-3.79099999 -4.191,-4.13599999 -3.57499998,0.001 -4.20799998,3.36699999 -4.20699998,4.34799999 z" },
		TASK_TYPE_MANUAL: { d: "m {mx},{my} c 0.234,-0.01 5.604,0.008 8.029,0.004 0.808,0 1.271,-0.172 1.417,-0.752 0.227,-0.898 -0.334,-1.314 -1.338,-1.316 -2.467,-0.01 -7.886,-0.004 -8.108,-0.004 -0.014,-0.079 0.016,-0.533 0,-0.61 0.195,-0.042 8.507,0.006 9.616,0.002 0.877,-0.007 1.35,-0.438 1.353,-1.208 0.003,-0.768 -0.479,-1.09 -1.35,-1.091 -2.968,-0.002 -9.619,-0.013 -9.619,-0.013 v -0.591 c 0,0 5.052,-0.016 7.225,-0.016 0.888,-0.002 1.354,-0.416 1.351,-1.193 -0.006,-0.761 -0.492,-1.196 -1.361,-1.196 -3.473,-0.005 -10.86,-0.003 -11.0829995,-0.003 -0.022,-0.047 -0.045,-0.094 -0.069,-0.139 0.3939995,-0.319 2.0409995,-1.626 2.4149995,-2.017 0.469,-0.4870005 0.519,-1.1650005 0.162,-1.6040005 -0.414,-0.511 -0.973,-0.5 -1.48,-0.236 -1.4609995,0.764 -6.5999995,3.6430005 -7.7329995,4.2710005 -0.9,0.499 -1.516,1.253 -1.882,2.19 -0.37000002,0.95 -0.17,2.01 -0.166,2.979 0.004,0.718 -0.27300002,1.345 -0.055,2.063 0.629,2.087 2.425,3.312 4.859,3.318 4.6179995,0.014 9.2379995,-0.139 13.8569995,-0.158 0.755,-0.004 1.171,-0.301 1.182,-1.033 0.012,-0.754 -0.423,-0.969 -1.183,-0.973 -1.778,-0.01 -5.824,-0.004 -6.04,-0.004 10e-4,-0.084 0.003,-0.586 10e-4,-0.67 z" },
		TASK_TYPE_INSTANTIATING_SEND: { d: "m {mx},{my} l 0,8.4 l 12.6,0 l 0,-8.4 z l 6.3,3.6 l 6.3,-3.6" },
		TASK_TYPE_SERVICE: { d: "m {mx},{my} v -1.71335 c 0.352326,-0.0705 0.703932,-0.17838 1.047628,-0.32133 0.344416,-0.14465 0.665822,-0.32133 0.966377,-0.52145 l 1.19431,1.18005 1.567487,-1.57688 -1.195028,-1.18014 c 0.403376,-0.61394 0.683079,-1.29908 0.825447,-2.01824 l 1.622133,-0.01 v -2.2196 l -1.636514,0.01 c -0.07333,-0.35153 -0.178319,-0.70024 -0.323564,-1.04372 -0.145244,-0.34406 -0.321407,-0.6644 -0.522735,-0.96217 l 1.131035,-1.13631 -1.583305,-1.56293 -1.129598,1.13589 c -0.614052,-0.40108 -1.302883,-0.68093 -2.022633,-0.82247 l 0.0093,-1.61852 h -2.241173 l 0.0042,1.63124 c -0.353763,0.0736 -0.705369,0.17977 -1.049785,0.32371 -0.344415,0.14437 -0.665102,0.32092 -0.9635006,0.52046 l -1.1698628,-1.15823 -1.5667691,1.5792 1.1684265,1.15669 c -0.4026573,0.61283 -0.68308,1.29797 -0.8247287,2.01713 l -1.6588041,0.003 v 2.22174 l 1.6724648,-0.006 c 0.073327,0.35077 0.1797598,0.70243 0.3242851,1.04472 0.1452428,0.34448 0.3214064,0.6644 0.5227339,0.96066 l -1.1993431,1.19723 1.5840256,1.56011 1.1964668,-1.19348 c 0.6140517,0.40346 1.3028827,0.68232 2.0233517,0.82331 l 7.19e-4,1.69892 h 2.226848 z m 0.221462,-3.9957 c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z" },
		TASK_TYPE_SERVICE_FILL: { d: "m {mx},{my} c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z" },
		TASK_TYPE_BUSINESS_RULE_HEADER: { d: "m {mx},{my} 0,4 20,0 0,-4 z" },
		TASK_TYPE_BUSINESS_RULE_MAIN: { d: "m {mx},{my} 0,12 20,0 0,-12 zm 0,8 l 20,0 m -13,-4 l 0,8" },
		MESSAGE_FLOW_MARKER: { d: "m {mx},{my} m -10.5 ,-7 l 0,14 l 21,0 l 0,-14 z l 10.5,6 l 10.5,-6" }
	}, this.getRawPath = function(e) {
		return this.pathMap[e].d;
	}, this.getScaledPath = function(e, t) {
		var n = this.pathMap[e], r, i;
		t.abspos ? (r = t.abspos.x, i = t.abspos.y) : (r = t.containerWidth * t.position.mx, i = t.containerHeight * t.position.my);
		var a = {};
		if (t.position) {
			for (var o = t.containerHeight / n.height * t.yScaleFactor, s = t.containerWidth / n.width * t.xScaleFactor, c = 0; c < n.heightElements.length; c++) a["y" + c] = n.heightElements[c] * o;
			for (var l = 0; l < n.widthElements.length; l++) a["x" + l] = n.widthElements[l] * s;
		}
		return oO(n.d, {
			mx: r,
			my: i,
			e: a
		});
	};
}
var rO = /\{([^{}]+)\}/g, iO = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g;
function aO(e, t, n) {
	var r = n;
	return t.replace(iO, function(e, t, n, i, a) {
		t ||= i, r && (t in r && (r = r[t]), typeof r == "function" && a && (r = r()));
	}), r = (r == null || r == n ? e : r) + "", r;
}
function oO(e, t) {
	return String(e).replace(rO, function(e, n) {
		return aO(e, n, t);
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/draw/index.js
var sO = {
	__init__: ["bpmnRenderer"],
	bpmnRenderer: ["type", PD],
	textRenderer: ["type", tO],
	pathMap: ["type", nO]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/i18n/translate/translate.js
function cO(e, t) {
	return t ||= {}, e.replace(/{([^}]+)}/g, function(e, n) {
		return t[n] || "{" + n + "}";
	});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/i18n/translate/index.js
var lO = { translate: ["value", cO] }, uO = Math;
uO.PI, uO.min, uO.max, uO.pow, uO.abs, Array.isArray;
//#endregion
//#region ../../../node_modules/diagram-js/lib/layout/LayoutUtil.js
function dO(e) {
	return {
		x: Math.round(e.x),
		y: Math.round(e.y)
	};
}
function fO(e) {
	return {
		top: e.y,
		right: e.x + (e.width || 0),
		bottom: e.y + (e.height || 0),
		left: e.x
	};
}
function pO(e) {
	return {
		x: e.left,
		y: e.top,
		width: e.right - e.left,
		height: e.bottom - e.top
	};
}
function mO(e) {
	return dO({
		x: e.x + (e.width || 0) / 2,
		y: e.y + (e.height || 0) / 2
	});
}
function hO(e) {
	for (var t = e.waypoints, n = t.reduce(function(e, n, r) {
		var i = t[r - 1];
		if (i) {
			var a = e[e.length - 1], o = a && a.endLength || 0, s = _O(i, n);
			e.push({
				start: i,
				end: n,
				startLength: o,
				endLength: o + s,
				length: s
			});
		}
		return e;
	}, []), r = n.reduce(function(e, t) {
		return e + t.length;
	}, 0) / 2, i = 0, a = n[i]; a.endLength < r;) a = n[++i];
	var o = (r - a.startLength) / a.length;
	return {
		x: a.start.x + (a.end.x - a.start.x) * o,
		y: a.start.y + (a.end.y - a.start.y) * o
	};
}
function gO(e) {
	return OT(e) ? hO(e) : mO(e);
}
function _O(e, t) {
	return Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/Util.js
function vO(e) {
	return e ? "<" + e.$type + (e.id ? " id=\"" + e.id : "") + "\" />" : "<null>";
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/BpmnImporter.js
function yO(e, t, n) {
	return Z({
		id: e.id,
		type: e.$type,
		businessObject: e,
		di: t
	}, n);
}
function bO(e, t, n) {
	var r = e.waypoint;
	return !r || r.length < 2 ? [gO(t), gO(n)] : r.map(function(e) {
		return {
			x: e.x,
			y: e.y
		};
	});
}
function xO(e, t, n) {
	return /* @__PURE__ */ Error(`element ${vO(t)} referenced by ${vO(e)}#${n} not yet drawn`);
}
function SO(e, t, n, r, i) {
	this._eventBus = e, this._canvas = t, this._elementFactory = n, this._elementRegistry = r, this._textRenderer = i;
}
SO.$inject = [
	"eventBus",
	"canvas",
	"elementFactory",
	"elementRegistry",
	"textRenderer"
], SO.prototype.add = function(e, t, n) {
	var r, i, a;
	if (Q(t, "bpmndi:BPMNPlane")) {
		var o = Q(e, "bpmn:SubProcess") ? { id: e.id + "_plane" } : {};
		r = this._elementFactory.createRoot(yO(e, t, o)), this._canvas.addRootElement(r);
	} else if (Q(t, "bpmndi:BPMNShape")) {
		var s = !TT(e, t), c = wO(e);
		i = n && (n.hidden || n.collapsed);
		var l = t.bounds;
		r = this._elementFactory.createShape(yO(e, t, {
			collapsed: s,
			hidden: i,
			x: Math.round(l.x),
			y: Math.round(l.y),
			width: Math.round(l.width),
			height: Math.round(l.height),
			isFrame: c
		})), Q(e, "bpmn:BoundaryEvent") && this._attachBoundary(e, r), Q(e, "bpmn:Lane") && (a = 0), Q(e, "bpmn:DataStoreReference") && (CO(n, gO(l)) || (n = this._canvas.findRoot(n))), this._canvas.addShape(r, n, a);
	} else if (Q(t, "bpmndi:BPMNEdge")) {
		var u = this._getSource(e), d = this._getTarget(e);
		i = n && (n.hidden || n.collapsed), r = this._elementFactory.createConnection(yO(e, t, {
			hidden: i,
			source: u,
			target: d,
			waypoints: bO(t, u, d)
		})), Q(e, "bpmn:DataAssociation") && (n = this._canvas.findRoot(n)), this._canvas.addConnection(r, n, a);
	} else throw Error(`unknown di ${vO(t)} for element ${vO(e)}`);
	return jT(e) && RT(r) && this.addLabel(e, t, r), this._eventBus.fire("bpmnElement.added", { element: r }), r;
}, SO.prototype._attachBoundary = function(e, t) {
	var n = e.attachedToRef;
	if (!n) throw Error(`missing ${vO(e)}#attachedToRef`);
	var r = this._elementRegistry.get(n.id), i = r && r.attachers;
	if (!r) throw xO(e, n, "attachedToRef");
	t.host = r, i || (r.attachers = i = []), i.indexOf(t) === -1 && i.push(t);
}, SO.prototype.addLabel = function(e, t, n) {
	var r = FT(t, n), i = RT(n), a;
	return i && (r = this._textRenderer.getExternalLabelBounds(r, i)), a = this._elementFactory.createLabel(yO(e, t, {
		id: e.id + "_label",
		labelTarget: n,
		type: "label",
		hidden: n.hidden || !RT(n),
		x: Math.round(r.x),
		y: Math.round(r.y),
		width: Math.round(r.width),
		height: Math.round(r.height)
	})), this._canvas.addShape(a, n.parent);
}, SO.prototype._getConnectedElement = function(e, t) {
	var n, r, i = e.$type;
	if (r = e[t + "Ref"], t === "source" && i === "bpmn:DataInputAssociation" && (r &&= r[0]), (t === "source" && i === "bpmn:DataOutputAssociation" || t === "target" && i === "bpmn:DataInputAssociation") && (r = e.$parent), n = r && this._getElement(r), n) return n;
	throw r ? xO(e, r, t + "Ref") : Error(`${vO(e)}#${t} Ref not specified`);
}, SO.prototype._getSource = function(e) {
	return this._getConnectedElement(e, "source");
}, SO.prototype._getTarget = function(e) {
	return this._getConnectedElement(e, "target");
}, SO.prototype._getElement = function(e) {
	return this._elementRegistry.get(e.id);
};
function CO(e, t) {
	var n = t.x, r = t.y;
	return n >= e.x && n <= e.x + e.width && r >= e.y && r <= e.y + e.height;
}
function wO(e) {
	return Q(e, "bpmn:Group");
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/core/index.js
var TO = { __depends__: [sO, {
	__depends__: [lO],
	bpmnImporter: ["type", SO]
}] };
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/IdGenerator.js
function EO(e) {
	this._counter = 0, this._prefix = (e ? e + "-" : "") + Math.floor(Math.random() * 1e9) + "-";
}
EO.prototype.next = function() {
	return this._prefix + ++this._counter;
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/overlays/Overlays.js
var DO = new EO("ov"), OO = 500;
function kO(e, t, n, r) {
	this._eventBus = t, this._canvas = n, this._elementRegistry = r, this._ids = DO, this._overlayDefaults = Z({
		show: null,
		scale: !0
	}, e && e.defaults), this._overlays = {}, this._overlayContainers = [], this._overlayRoot = AO(n.getContainer()), this._init();
}
kO.$inject = [
	"config.overlays",
	"eventBus",
	"canvas",
	"elementRegistry"
], kO.prototype.get = function(e) {
	if (nT(e) && (e = { id: e }), nT(e.element) && (e.element = this._elementRegistry.get(e.element)), e.element) {
		var t = this._getOverlayContainer(e.element, !0);
		return t ? e.type ? oT(t.overlays, dT({ type: e.type })) : t.overlays.slice() : [];
	} else if (e.type) return oT(this._overlays, dT({ type: e.type }));
	else return e.id ? this._overlays[e.id] : null;
}, kO.prototype.add = function(e, t, n) {
	if ($w(t) && (n = t, t = null), e.id || (e = this._elementRegistry.get(e)), !n.position) throw Error("must specifiy overlay position");
	if (!n.html) throw Error("must specifiy overlay html");
	if (!e) throw Error("invalid element specified");
	var r = this._ids.next();
	return n = Z({}, this._overlayDefaults, n, {
		id: r,
		type: t,
		element: e,
		html: n.html
	}), this._addOverlay(n), r;
}, kO.prototype.remove = function(e) {
	var t = this.get(e) || [];
	Qw(t) || (t = [t]);
	var n = this;
	X(t, function(e) {
		var t = n._getOverlayContainer(e.element, !0);
		if (e && (hD(e.html), hD(e.htmlContainer), delete e.htmlContainer, delete e.element, delete n._overlays[e.id]), t) {
			var r = t.overlays.indexOf(e);
			r !== -1 && t.overlays.splice(r, 1);
		}
	});
}, kO.prototype.isShown = function() {
	return this._overlayRoot.style.display !== "none";
}, kO.prototype.show = function() {
	MO(this._overlayRoot);
}, kO.prototype.hide = function() {
	MO(this._overlayRoot, !1);
}, kO.prototype.clear = function() {
	this._overlays = {}, this._overlayContainers = [], tD(this._overlayRoot);
}, kO.prototype._updateOverlayContainer = function(e) {
	var t = e.element, n = e.html, r = t.x, i = t.y;
	if (t.waypoints) {
		var a = zT(t);
		r = a.x, i = a.y;
	}
	jO(n, r, i), ZE(e.html, "data-container-id", t.id);
}, kO.prototype._updateOverlay = function(e) {
	var t = e.position, n = e.htmlContainer, r = e.element, i = t.left, a = t.top;
	if (t.right !== void 0) {
		var o = r.waypoints ? zT(r).width : r.width;
		i = t.right * -1 + o;
	}
	if (t.bottom !== void 0) {
		var s = r.waypoints ? zT(r).height : r.height;
		a = t.bottom * -1 + s;
	}
	jO(n, i || 0, a || 0), this._updateOverlayVisibilty(e, this._canvas.viewbox());
}, kO.prototype._createOverlayContainer = function(e) {
	var t = JE("<div class=\"djs-overlays\" />");
	XE(t, { position: "absolute" }), this._overlayRoot.appendChild(t);
	var n = {
		html: t,
		element: e,
		overlays: []
	};
	return this._updateOverlayContainer(n), this._overlayContainers.push(n), n;
}, kO.prototype._updateRoot = function(e) {
	var t = e.scale || 1, n = "matrix(" + [
		t,
		0,
		0,
		t,
		-1 * e.x * t,
		-1 * e.y * t
	].join(",") + ")";
	NO(this._overlayRoot, n);
}, kO.prototype._getOverlayContainer = function(e, t) {
	var n = iT(this._overlayContainers, function(t) {
		return t.element === e;
	});
	return !n && !t ? this._createOverlayContainer(e) : n;
}, kO.prototype._addOverlay = function(e) {
	var t = e.id, n = e.element, r = e.html, i, a;
	r.get && r.constructor.prototype.jquery && (r = r.get(0)), nT(r) && (r = JE(r)), a = this._getOverlayContainer(n), i = JE("<div class=\"djs-overlay\" data-overlay-id=\"" + t + "\">"), XE(i, { position: "absolute" }), i.appendChild(r), e.type && $E(i).add("djs-overlay-" + e.type);
	var o = this._canvas.findRoot(n), s = this._canvas.getRootElement();
	MO(i, o === s), e.htmlContainer = i, a.overlays.push(e), a.html.appendChild(i), this._overlays[t] = e, this._updateOverlay(e), this._updateOverlayVisibilty(e, this._canvas.viewbox());
}, kO.prototype._updateOverlayVisibilty = function(e, t) {
	var n = e.show, r = this._canvas.findRoot(e.element), i = n && n.minZoom, a = n && n.maxZoom, o = e.htmlContainer, s = this._canvas.getRootElement(), c = !0;
	r === s ? n && (Xw(i) && i > t.scale || Xw(a) && a < t.scale) && (c = !1) : c = !1, MO(o, c), this._updateOverlayScale(e, t);
}, kO.prototype._updateOverlayScale = function(e, t) {
	var n = e.scale, r, i, a = e.htmlContainer, o, s = "";
	n !== !0 && (n === !1 ? (r = 1, i = 1) : (r = n.min, i = n.max), Xw(r) && t.scale < r && (o = (1 / t.scale || 1) * r), Xw(i) && t.scale > i && (o = (1 / t.scale || 1) * i)), Xw(o) && (s = "scale(" + o + "," + o + ")"), NO(a, s);
}, kO.prototype._updateOverlaysVisibilty = function(e) {
	var t = this;
	X(this._overlays, function(n) {
		t._updateOverlayVisibilty(n, e);
	});
}, kO.prototype._init = function() {
	var e = this._eventBus, t = this;
	function n(e) {
		t._updateRoot(e), t._updateOverlaysVisibilty(e), t.show();
	}
	e.on("canvas.viewbox.changing", function(e) {
		t.hide();
	}), e.on("canvas.viewbox.changed", function(e) {
		n(e.viewbox);
	}), e.on(["shape.remove", "connection.remove"], function(e) {
		var n = e.element;
		X(t.get({ element: n }), function(e) {
			t.remove(e.id);
		});
		var r = t._getOverlayContainer(n);
		if (r) {
			hD(r.html);
			var i = t._overlayContainers.indexOf(r);
			i !== -1 && t._overlayContainers.splice(i, 1);
		}
	}), e.on("element.changed", OO, function(e) {
		var n = e.element, r = t._getOverlayContainer(n, !0);
		r && (X(r.overlays, function(e) {
			t._updateOverlay(e);
		}), t._updateOverlayContainer(r));
	}), e.on("element.marker.update", function(e) {
		var n = t._getOverlayContainer(e.element, !0);
		n && $E(n.html)[e.add ? "add" : "remove"](e.marker);
	}), e.on("root.set", function() {
		t._updateOverlaysVisibilty(t._canvas.viewbox());
	}), e.on("diagram.clear", this.clear, this);
};
function AO(e) {
	var t = JE("<div class=\"djs-overlay-container\" />");
	return XE(t, {
		position: "absolute",
		width: 0,
		height: 0
	}), e.insertBefore(t, e.firstChild), t;
}
function jO(e, t, n) {
	XE(e, {
		left: t + "px",
		top: n + "px"
	});
}
function MO(e, t) {
	e.style.display = t === !1 ? "none" : "";
}
function NO(e, t) {
	e.style["transform-origin"] = "top left", [
		"",
		"-ms-",
		"-webkit-"
	].forEach(function(n) {
		e.style[n + "transform"] = t;
	});
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/overlays/index.js
var PO = {
	__init__: ["overlays"],
	overlays: ["type", kO]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/change-support/ChangeSupport.js
function FO(e, t, n, r) {
	e.on("element.changed", function(r) {
		var i = r.element;
		(i.parent || i === t.getRootElement()) && (r.gfx = n.getGraphics(i)), r.gfx && e.fire(BT(i) + ".changed", r);
	}), e.on("elements.changed", function(t) {
		var n = t.elements;
		n.forEach(function(t) {
			e.fire("element.changed", { element: t });
		}), r.updateContainments(n);
	}), e.on("shape.changed", function(e) {
		r.update("shape", e.element, e.gfx);
	}), e.on("connection.changed", function(e) {
		r.update("connection", e.element, e.gfx);
	});
}
FO.$inject = [
	"eventBus",
	"canvas",
	"elementRegistry",
	"graphicsFactory"
];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/change-support/index.js
var IO = {
	__init__: ["changeSupport"],
	changeSupport: ["type", FO]
}, LO = 1e3;
function RO(e) {
	this._eventBus = e;
}
RO.$inject = ["eventBus"];
function zO(e, t) {
	return function(n) {
		return e.call(t || null, n.context, n.command, n);
	};
}
RO.prototype.on = function(e, t, n, r, i, a) {
	if ((tT(t) || eT(t)) && (a = i, i = r, r = n, n = t, t = null), tT(n) && (a = i, i = r, r = n, n = LO), $w(i) && (a = i, i = !1), !tT(r)) throw Error("handlerFn must be a function");
	Qw(e) || (e = [e]);
	var o = this._eventBus;
	X(e, function(e) {
		var s = [
			"commandStack",
			e,
			t
		].filter(function(e) {
			return e;
		}).join(".");
		o.on(s, n, i ? zO(r, a) : r, a);
	});
}, RO.prototype.canExecute = BO("canExecute"), RO.prototype.preExecute = BO("preExecute"), RO.prototype.preExecuted = BO("preExecuted"), RO.prototype.execute = BO("execute"), RO.prototype.executed = BO("executed"), RO.prototype.postExecute = BO("postExecute"), RO.prototype.postExecuted = BO("postExecuted"), RO.prototype.revert = BO("revert"), RO.prototype.reverted = BO("reverted");
function BO(e) {
	return function(t, n, r, i, a) {
		(tT(t) || eT(t)) && (a = i, i = r, r = n, n = t, t = null), this.on(t, e, n, r, i, a);
	};
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/root-elements/RootElementsBehavior.js
function VO(e, t) {
	t.invoke(RO, this), this.executed(function(t) {
		var n = t.context;
		n.rootElement ? e.setRootElement(n.rootElement) : n.rootElement = e.getRootElement();
	}), this.revert(function(t) {
		var n = t.context;
		n.rootElement && e.setRootElement(n.rootElement);
	});
}
Kw(VO, RO), VO.$inject = ["canvas", "injector"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/root-elements/index.js
var HO = {
	__init__: ["rootElementsBehavior"],
	rootElementsBehavior: ["type", VO]
}, UO = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
};
function WO(e) {
	return e = "" + e, e && e.replace(/[&<>"']/g, function(e) {
		return UO[e];
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/util/DrilldownUtil.js
var GO = "_plane";
function KO(e) {
	var t = e.id;
	return Q(e, "bpmn:SubProcess") ? qO(t) : t;
}
function qO(e) {
	return e + GO;
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownBreadcrumbs.js
var JO = "bjs-breadcrumbs-shown";
function YO(e, t, n) {
	var r = JE("<ul class=\"bjs-breadcrumbs\"></ul>"), i = n.getContainer(), a = $E(i);
	i.appendChild(r);
	var o = [];
	e.on("element.changed", function(e) {
		var t = e.element, n = CT(t);
		iT(o, function(e) {
			return e === n;
		}) && s();
	});
	function s(e) {
		e && (o = XO(e));
		var i = o.flatMap(function(e) {
			var r = n.findRoot(KO(e)) || n.findRoot(e.id);
			if (!r && Q(e, "bpmn:Process")) {
				var i = t.find(function(t) {
					var n = CT(t);
					return n && n.get("processRef") === e;
				});
				r = i && n.findRoot(i.id);
			}
			if (!r) return [];
			var a = WO(e.name || e.id), o = JE("<li><span class=\"bjs-crumb\"><a title=\"" + a + "\">" + a + "</a></span></li>");
			return o.addEventListener("click", function() {
				n.setRootElement(r);
			}), o;
		});
		r.innerHTML = "";
		var s = i.length > 1;
		a.toggle(JO, s), i.forEach(function(e) {
			r.appendChild(e);
		});
	}
	e.on("root.set", function(e) {
		s(e.element);
	});
}
YO.$inject = [
	"eventBus",
	"elementRegistry",
	"canvas"
];
function XO(e) {
	for (var t = CT(e), n = [], r = t; r; r = r.$parent) (Q(r, "bpmn:SubProcess") || Q(r, "bpmn:Process")) && n.push(r);
	return n.reverse();
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownCentering.js
function ZO(e, t) {
	var n = null, r = new QO();
	e.on("root.set", function(e) {
		var i = e.element, a = t.viewbox(), o = r.get(i);
		if (r.set(n, {
			x: a.x,
			y: a.y,
			zoom: a.scale
		}), n = i, !(!Q(i, "bpmn:SubProcess") && !o)) {
			o ||= {
				x: 0,
				y: 0,
				zoom: 1
			};
			var s = (a.x - o.x) * a.scale, c = (a.y - o.y) * a.scale;
			(s !== 0 || c !== 0) && t.scroll({
				dx: s,
				dy: c
			}), o.zoom !== a.scale && t.zoom(o.zoom, {
				x: 0,
				y: 0
			});
		}
	}), e.on("diagram.clear", function() {
		r.clear(), n = null;
	});
}
ZO.$inject = ["eventBus", "canvas"];
function QO() {
	this._entries = [], this.set = function(e, t) {
		var n = !1;
		for (var r in this._entries) if (this._entries[r][0] === e) {
			this._entries[r][1] = t, n = !0;
			break;
		}
		n || this._entries.push([e, t]);
	}, this.get = function(e) {
		for (var t in this._entries) if (this._entries[t][0] === e) return this._entries[t][1];
		return null;
	}, this.clear = function() {
		this._entries.length = 0;
	}, this.remove = function(e) {
		var t = -1;
		for (var n in this._entries) if (this._entries[n][0] === e) {
			t = n;
			break;
		}
		t !== -1 && this._entries.splice(t, 1);
	};
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/SubprocessCompatibility.js
var $O = {
	x: 180,
	y: 160
};
function ek(e, t) {
	this._eventBus = e, this._moddle = t;
	var n = this;
	e.on("import.render.start", 1500, function(e, t) {
		n._handleImport(t.definitions);
	});
}
ek.prototype._handleImport = function(e) {
	if (e.diagrams) {
		var t = this;
		this._definitions = e, this._processToDiagramMap = {}, e.diagrams.forEach(function(e) {
			!e.plane || !e.plane.bpmnElement || (t._processToDiagramMap[e.plane.bpmnElement.id] = e);
		}), e.diagrams.filter((e) => e.plane).flatMap((e) => t._createNewDiagrams(e.plane)).forEach(function(e) {
			t._movePlaneElementsToOrigin(e.plane);
		});
	}
}, ek.prototype._createNewDiagrams = function(e) {
	var t = this, n = [], r = [];
	e.get("planeElement").forEach(function(t) {
		var i = t.bpmnElement;
		if (i) {
			var a = i.$parent;
			Q(i, "bpmn:SubProcess") && !t.isExpanded && n.push(i), rk(i, e) && r.push({
				diElement: t,
				parent: a
			});
		}
	});
	var i = [];
	return n.forEach(function(e) {
		if (!t._processToDiagramMap[e.id]) {
			var n = t._createDiagram(e);
			t._processToDiagramMap[e.id] = n, i.push(n);
		}
	}), r.forEach(function(e) {
		for (var r = e.diElement, i = e.parent; i && n.indexOf(i) === -1;) i = i.$parent;
		if (i) {
			var a = t._processToDiagramMap[i.id];
			t._moveToDiPlane(r, a.plane);
		}
	}), i;
}, ek.prototype._movePlaneElementsToOrigin = function(e) {
	var t = e.get("planeElement"), n = nk(e), r = {
		x: n.x - $O.x,
		y: n.y - $O.y
	};
	t.forEach(function(e) {
		e.waypoint ? e.waypoint.forEach(function(e) {
			e.x -= r.x, e.y -= r.y;
		}) : e.bounds && (e.bounds.x = e.bounds.x - r.x, e.bounds.y = e.bounds.y - r.y);
	});
}, ek.prototype._moveToDiPlane = function(e, t) {
	var n = tk(e).plane.get("planeElement");
	n.splice(n.indexOf(e), 1), t.get("planeElement").push(e);
}, ek.prototype._createDiagram = function(e) {
	var t = this._moddle.create("bpmndi:BPMNPlane", { bpmnElement: e }), n = this._moddle.create("bpmndi:BPMNDiagram", { plane: t });
	return t.$parent = n, t.bpmnElement = e, n.$parent = this._definitions, this._definitions.diagrams.push(n), n;
}, ek.$inject = ["eventBus", "moddle"];
function tk(e) {
	return Q(e, "bpmndi:BPMNDiagram") ? e : tk(e.$parent);
}
function nk(e) {
	var t = {
		top: Infinity,
		right: -Infinity,
		bottom: -Infinity,
		left: Infinity
	};
	return e.planeElement.forEach(function(e) {
		if (e.bounds) {
			var n = fO(e.bounds);
			t.top = Math.min(n.top, t.top), t.left = Math.min(n.left, t.left);
		}
	}), pO(t);
}
function rk(e, t) {
	var n = e.$parent;
	return !(!Q(n, "bpmn:SubProcess") || n === t.bpmnElement || ST(e, ["bpmn:DataInputAssociation", "bpmn:DataOutputAssociation"]));
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/DrilldownOverlayBehavior.js
var ik = 250, ak = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4.81801948,3.50735931 L10.4996894,9.1896894 L10.5,4 L12,4 L12,12 L4,12 L4,10.5 L9.6896894,10.4996894 L3.75735931,4.56801948 C3.46446609,4.27512627 3.46446609,3.80025253 3.75735931,3.50735931 C4.05025253,3.21446609 4.52512627,3.21446609 4.81801948,3.50735931 Z\"/></svg>", ok = "bjs-drilldown-empty";
function sk(e, t, n, r, i) {
	RO.call(this, t), this._canvas = e, this._eventBus = t, this._elementRegistry = n, this._overlays = r, this._translate = i;
	var a = this;
	this.executed("shape.toggleCollapse", ik, function(e) {
		var t = e.shape;
		a._canDrillDown(t) ? a._addOverlay(t) : a._removeOverlay(t);
	}, !0), this.reverted("shape.toggleCollapse", ik, function(e) {
		var t = e.shape;
		a._canDrillDown(t) ? a._addOverlay(t) : a._removeOverlay(t);
	}, !0), this.executed([
		"shape.create",
		"shape.move",
		"shape.delete"
	], ik, function(e) {
		var t = e.oldParent, n = e.newParent || e.parent, r = e.shape;
		a._canDrillDown(r) && a._addOverlay(r), a._updateDrilldownOverlay(t), a._updateDrilldownOverlay(n), a._updateDrilldownOverlay(r);
	}, !0), this.reverted([
		"shape.create",
		"shape.move",
		"shape.delete"
	], ik, function(e) {
		var t = e.oldParent, n = e.newParent || e.parent, r = e.shape;
		a._canDrillDown(r) && a._addOverlay(r), a._updateDrilldownOverlay(t), a._updateDrilldownOverlay(n), a._updateDrilldownOverlay(r);
	}, !0), t.on("import.render.complete", function() {
		n.filter(function(e) {
			return a._canDrillDown(e);
		}).map(function(e) {
			a._addOverlay(e);
		});
	});
}
Kw(sk, RO), sk.prototype._updateDrilldownOverlay = function(e) {
	var t = this._canvas;
	if (e) {
		var n = t.findRoot(e);
		n && this._updateOverlayVisibility(n);
	}
}, sk.prototype._canDrillDown = function(e) {
	var t = this._canvas;
	return Q(e, "bpmn:SubProcess") && t.findRoot(KO(e));
}, sk.prototype._updateOverlayVisibility = function(e) {
	var t = this._overlays, n = CT(e), r = t.get({
		element: n.id,
		type: "drilldown"
	})[0];
	if (r) {
		var i = n && n.get("flowElements") && n.get("flowElements").length;
		$E(r.html).toggle(ok, !i);
	}
}, sk.prototype._addOverlay = function(e) {
	var t = this._canvas, n = this._overlays, r = CT(e);
	n.get({
		element: e,
		type: "drilldown"
	}).length && this._removeOverlay(e);
	var i = JE("<button type=\"button\" class=\"bjs-drilldown\">" + ak + "</button>"), a = r.get("name") || r.get("id"), o = this._translate("Open {element}", { element: a });
	i.setAttribute("title", o), i.addEventListener("click", function() {
		t.setRootElement(t.findRoot(KO(e)));
	}), n.add(e, "drilldown", {
		position: {
			bottom: -7,
			right: -8
		},
		html: i
	}), this._updateOverlayVisibility(e);
}, sk.prototype._removeOverlay = function(e) {
	this._overlays.remove({
		element: e,
		type: "drilldown"
	});
}, sk.$inject = [
	"canvas",
	"eventBus",
	"elementRegistry",
	"overlays",
	"translate"
];
//#endregion
//#region ../../../node_modules/bpmn-js/lib/features/drilldown/index.js
var ck = {
	__depends__: [
		PO,
		IO,
		HO
	],
	__init__: [
		"drilldownBreadcrumbs",
		"drilldownOverlayBehavior",
		"drilldownCentering",
		"subprocessCompatibility"
	],
	drilldownBreadcrumbs: ["type", YO],
	drilldownCentering: ["type", ZO],
	drilldownOverlayBehavior: ["type", sk],
	subprocessCompatibility: ["type", ek]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Event.js
function lk(e) {
	return e.originalEvent || e.srcEvent;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Mouse.js
function uk(e, t) {
	return (lk(e) || e).button === t;
}
function dk(e) {
	return uk(e, 0);
}
function fk(e) {
	return uk(e, 1);
}
function pk(e) {
	var t = lk(e) || e;
	return dk(e) && t.shiftKey;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/interaction-events/InteractionEvents.js
function mk(e) {
	return !0;
}
function hk(e) {
	return dk(e) || fk(e);
}
var gk = 500;
function _k(e, t, n) {
	var r = this;
	function i(n, r, i) {
		if (!s(n, r)) {
			var a, o, c;
			i ? o = t.getGraphics(i) : (a = r.delegateTarget || r.target, a && (o = a, i = t.get(o))), !(!o || !i) && (c = e.fire(n, {
				element: i,
				gfx: o,
				originalEvent: r
			}), c === !1 && (r.stopPropagation(), r.preventDefault()));
		}
	}
	var a = {};
	function o(e) {
		return a[e];
	}
	function s(e, t) {
		return !(l[e] || dk)(t);
	}
	var c = {
		click: "element.click",
		contextmenu: "element.contextmenu",
		dblclick: "element.dblclick",
		mousedown: "element.mousedown",
		mousemove: "element.mousemove",
		mouseover: "element.hover",
		mouseout: "element.out",
		mouseup: "element.mouseup"
	}, l = {
		"element.contextmenu": mk,
		"element.mousedown": hk,
		"element.mouseup": hk,
		"element.click": hk,
		"element.dblclick": hk
	};
	function u(e, t, n) {
		var r = c[e];
		if (!r) throw Error("unmapped DOM event name <" + e + ">");
		return i(r, t, n);
	}
	var d = "svg, .djs-element";
	function f(e, t, n, r) {
		var o = a[n] = function(e) {
			i(n, e);
		};
		r && (l[n] = r), o.$delegate = fD.bind(e, d, t, o);
	}
	function p(e, t, n) {
		var r = o(n);
		r && fD.unbind(e, t, r.$delegate);
	}
	function m(e) {
		X(c, function(t, n) {
			f(e, n, t);
		});
	}
	function h(e) {
		X(c, function(t, n) {
			p(e, n, t);
		});
	}
	e.on("canvas.destroy", function(e) {
		h(e.svg);
	}), e.on("canvas.init", function(e) {
		m(e.svg);
	}), e.on(["shape.added", "connection.added"], function(t) {
		var n = t.element, r = t.gfx;
		e.fire("interactionEvents.createHit", {
			element: n,
			gfx: r
		});
	}), e.on(["shape.changed", "connection.changed"], gk, function(t) {
		var n = t.element, r = t.gfx;
		e.fire("interactionEvents.updateHit", {
			element: n,
			gfx: r
		});
	}), e.on("interactionEvents.createHit", gk, function(e) {
		var t = e.element, n = e.gfx;
		r.createDefaultHit(t, n);
	}), e.on("interactionEvents.updateHit", function(e) {
		var t = e.element, n = e.gfx;
		r.updateDefaultHit(t, n);
	});
	var g = y("djs-hit djs-hit-stroke"), _ = y("djs-hit djs-hit-click-stroke"), v = {
		all: y("djs-hit djs-hit-all"),
		"click-stroke": _,
		stroke: g,
		"no-move": y("djs-hit djs-hit-no-move")
	};
	function y(e, t) {
		return t = Z({
			stroke: "white",
			strokeWidth: 15
		}, t || {}), n.cls(e, ["no-fill", "no-border"], t);
	}
	function b(e, t) {
		var n = v[t];
		if (!n) throw Error("invalid hit type <" + t + ">");
		return XT(e, n), e;
	}
	function x(e, t) {
		WT(e, t);
	}
	this.removeHits = function(e) {
		X(mD(".djs-hit", e), xE);
	}, this.createDefaultHit = function(e, t) {
		var n = e.waypoints, r = e.isFrame, i;
		return n ? this.createWaypointsHit(t, n) : (i = r ? "stroke" : "all", this.createBoxHit(t, i, {
			width: e.width,
			height: e.height
		}));
	}, this.createWaypointsHit = function(e, t) {
		var n = ME(t);
		return b(n, "stroke"), x(e, n), n;
	}, this.createBoxHit = function(e, t, n) {
		n = Z({
			x: 0,
			y: 0
		}, n);
		var r = aE("rect");
		return b(r, t), XT(r, n), x(e, r), r;
	}, this.updateDefaultHit = function(e, t) {
		var n = pD(".djs-hit", t);
		if (n) return e.waypoints ? NE(n, e.waypoints) : XT(n, {
			width: e.width,
			height: e.height
		}), n;
	}, this.fire = i, this.triggerMouseEvent = u, this.mouseHandler = o, this.registerEvent = f, this.unregisterEvent = p;
}
_k.$inject = [
	"eventBus",
	"elementRegistry",
	"styles"
];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/interaction-events/index.js
var vk = {
	__init__: ["interactionEvents"],
	interactionEvents: ["type", _k]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/Selection.js
function yk(e, t) {
	this._eventBus = e, this._canvas = t, this._selectedElements = [];
	var n = this;
	e.on(["shape.remove", "connection.remove"], function(e) {
		var t = e.element;
		n.deselect(t);
	}), e.on(["diagram.clear", "root.set"], function(e) {
		n.select(null);
	});
}
yk.$inject = ["eventBus", "canvas"], yk.prototype.deselect = function(e) {
	var t = this._selectedElements, n = t.indexOf(e);
	if (n !== -1) {
		var r = t.slice();
		t.splice(n, 1), this._eventBus.fire("selection.changed", {
			oldSelection: r,
			newSelection: t
		});
	}
}, yk.prototype.get = function() {
	return this._selectedElements;
}, yk.prototype.isSelected = function(e) {
	return this._selectedElements.indexOf(e) !== -1;
}, yk.prototype.select = function(e, t) {
	var n = this._selectedElements, r = n.slice();
	Qw(e) || (e = e ? [e] : []);
	var i = this._canvas, a = i.getRootElement();
	e = e.filter(function(e) {
		return a === i.findRoot(e);
	}), t ? X(e, function(e) {
		n.indexOf(e) === -1 && n.push(e);
	}) : this._selectedElements = n = e.slice(), this._eventBus.fire("selection.changed", {
		oldSelection: r,
		newSelection: n
	});
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/SelectionVisuals.js
var bk = "hover", xk = "selected";
function Sk(e, t) {
	this._canvas = e;
	function n(t, n) {
		e.addMarker(t, n);
	}
	function r(t, n) {
		e.removeMarker(t, n);
	}
	t.on("element.hover", function(e) {
		n(e.element, bk);
	}), t.on("element.out", function(e) {
		r(e.element, bk);
	}), t.on("selection.changed", function(e) {
		function t(e) {
			r(e, xk);
		}
		function i(e) {
			n(e, xk);
		}
		var a = e.oldSelection, o = e.newSelection;
		X(a, function(e) {
			o.indexOf(e) === -1 && t(e);
		}), X(o, function(e) {
			a.indexOf(e) === -1 && i(e);
		});
	});
}
Sk.$inject = ["canvas", "eventBus"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/SelectionBehavior.js
function Ck(e, t, n, r) {
	e.on("create.end", 500, function(e) {
		var n = e.context, r = n.canExecute, i = n.elements, a = (n.hints || {}).autoSelect;
		if (r) {
			if (a === !1) return;
			Qw(a) ? t.select(a) : t.select(i.filter(wk));
		}
	}), e.on("connect.end", 500, function(e) {
		var n = e.context.connection;
		n && t.select(n);
	}), e.on("shape.move.end", 500, function(e) {
		var n = e.previousSelection || [], i = r.get(e.context.shape.id);
		iT(n, function(e) {
			return i.id === e.id;
		}) || t.select(i);
	}), e.on("element.click", function(e) {
		if (dk(e)) {
			var r = e.element;
			r === n.getRootElement() && (r = null);
			var i = t.isSelected(r), a = t.get().length > 1, o = pk(e);
			if (i && a) return o ? t.deselect(r) : t.select(r);
			i ? t.deselect(r) : t.select(r, o);
		}
	});
}
Ck.$inject = [
	"eventBus",
	"selection",
	"canvas",
	"elementRegistry"
];
function wk(e) {
	return !e.hidden;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/features/selection/index.js
var Tk = {
	__init__: ["selectionVisuals", "selectionBehavior"],
	__depends__: [vk],
	selection: ["type", yk],
	selectionVisuals: ["type", Sk],
	selectionBehavior: ["type", Ck]
}, Ek = /^class[ {]/;
function Dk(e) {
	return Ek.test(e.toString());
}
function Ok(e) {
	return Array.isArray(e);
}
function kk(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
function Ak(...e) {
	e.length === 1 && Ok(e[0]) && (e = e[0]), e = [...e];
	let t = e.pop();
	return t.$inject = e, t;
}
var jk = /constructor\s*[^(]*\(\s*([^)]*)\)/m, Mk = /^(?:async\s+)?(?:function\s*[^(]*)?(?:\(\s*([^)]*)\)|(\w+))/m, Nk = /\/\*([^*]*)\*\//m;
function Pk(e) {
	if (typeof e != "function") throw Error(`Cannot annotate "${e}". Expected a function!`);
	let t = e.toString().match(Dk(e) ? jk : Mk);
	if (!t) return [];
	let n = t[1] || t[2];
	return n && n.split(",").map((e) => {
		let t = e.match(Nk);
		return (t && t[1] || e).trim();
	}) || [];
}
function Fk(e, t) {
	let n = t || { get: function(e, t) {
		if (r.push(e), t === !1) return null;
		throw s(`No provider for "${e}"!`);
	} }, r = [], i = this._providers = Object.create(n._providers || null), a = this._instances = Object.create(null), o = a.injector = this, s = function(e) {
		let t = r.join(" -> ");
		return r.length = 0, Error(t ? `${e} (Resolving: ${t})` : e);
	};
	function c(e, t) {
		if (!i[e] && e.includes(".")) {
			let t = e.split("."), n = c(t.shift());
			for (; t.length;) n = n[t.shift()];
			return n;
		}
		if (kk(a, e)) return a[e];
		if (kk(i, e)) {
			if (r.indexOf(e) !== -1) throw r.push(e), s("Cannot resolve circular dependency!");
			return r.push(e), a[e] = i[e][0](i[e][1]), r.pop(), a[e];
		}
		return n.get(e, t);
	}
	function l(e, t) {
		if (t === void 0 && (t = {}), typeof e != "function") if (Ok(e)) e = Ak(e.slice());
		else throw s(`Cannot invoke "${e}". Expected a function!`);
		let n = (e.$inject || Pk(e)).map((e) => kk(t, e) ? t[e] : c(e));
		return {
			fn: e,
			dependencies: n
		};
	}
	function u(e) {
		let { fn: t, dependencies: n } = l(e);
		return new (Function.prototype.bind.call(t, null, ...n))();
	}
	function d(e, t, n) {
		let { fn: r, dependencies: i } = l(e, n);
		return r.apply(t, i);
	}
	function f(e) {
		return Ak((t) => e.get(t));
	}
	function p(e, t) {
		if (t && t.length) {
			let n = Object.create(null), r = Object.create(null), a = [], o = [], s = [], c, l, u, d;
			for (let e in i) c = i[e], t.indexOf(e) !== -1 && (c[2] === "private" ? (l = a.indexOf(c[3]), l === -1 ? (u = c[3].createChild([], t), d = f(u), a.push(c[3]), o.push(u), s.push(d), n[e] = [
				d,
				e,
				"private",
				u
			]) : n[e] = [
				s[l],
				e,
				"private",
				o[l]
			]) : n[e] = [c[2], c[1]], r[e] = !0), (c[2] === "factory" || c[2] === "type") && c[1].$scope && t.forEach((t) => {
				c[1].$scope.indexOf(t) !== -1 && (n[e] = [c[2], c[1]], r[t] = !0);
			});
			t.forEach((e) => {
				if (!r[e]) throw Error("No provider for \"" + e + "\". Cannot use provider from the parent!");
			}), e.unshift(n);
		}
		return new Fk(e, o);
	}
	let m = {
		factory: d,
		type: u,
		value: function(e) {
			return e;
		}
	};
	function h(e, t) {
		let n = e.__init__ || [];
		return function() {
			n.forEach((e) => {
				typeof e == "string" ? t.get(e) : t.invoke(e);
			});
		};
	}
	function g(e) {
		let t = e.__exports__;
		if (t) {
			let n = e.__modules__, r = Object.keys(e).reduce((t, n) => (n !== "__exports__" && n !== "__modules__" && n !== "__init__" && n !== "__depends__" && (t[n] = e[n]), t), Object.create(null)), a = p((n || []).concat(r)), o = Ak(function(e) {
				return a.get(e);
			});
			t.forEach(function(e) {
				i[e] = [
					o,
					e,
					"private",
					a
				];
			});
			let s = (e.__init__ || []).slice();
			return s.unshift(function() {
				a.init();
			}), e = Object.assign({}, e, { __init__: s }), h(e, a);
		}
		return Object.keys(e).forEach(function(t) {
			if (t === "__init__" || t === "__depends__") return;
			let n = e[t];
			if (n[2] === "private") {
				i[t] = n;
				return;
			}
			let r = n[0], a = n[1];
			i[t] = [
				m[r],
				Ik(r, a),
				r
			];
		}), h(e, o);
	}
	function _(e, t) {
		return e.indexOf(t) !== -1 || (e = (t.__depends__ || []).reduce(_, e), e.indexOf(t) !== -1) ? e : e.concat(t);
	}
	function v(e) {
		let t = e.reduce(_, []).map(g), n = !1;
		return function() {
			n || (n = !0, t.forEach((e) => e()));
		};
	}
	this.get = c, this.invoke = d, this.instantiate = u, this.createChild = p, this.init = v(e);
}
function Ik(e, t) {
	return e !== "value" && Ok(t) && (t = Ak(t.slice())), t;
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/DefaultRenderer.js
var Lk = 1;
function Rk(e, t) {
	xT.call(this, e, Lk), this.CONNECTION_STYLE = t.style(["no-fill"], {
		strokeWidth: 5,
		stroke: "fuchsia"
	}), this.SHAPE_STYLE = t.style({
		fill: "white",
		stroke: "fuchsia",
		strokeWidth: 2
	}), this.FRAME_STYLE = t.style(["no-fill"], {
		stroke: "fuchsia",
		strokeDasharray: 4,
		strokeWidth: 2
	});
}
Kw(Rk, xT), Rk.prototype.canRender = function() {
	return !0;
}, Rk.prototype.drawShape = function(e, t, n) {
	var r = aE("rect");
	return XT(r, {
		x: 0,
		y: 0,
		width: t.width || 0,
		height: t.height || 0
	}), VT(t) ? XT(r, Z({}, this.FRAME_STYLE, n || {})) : XT(r, Z({}, this.SHAPE_STYLE, n || {})), WT(e, r), r;
}, Rk.prototype.drawConnection = function(e, t, n) {
	var r = ME(t.waypoints, Z({}, this.CONNECTION_STYLE, n || {}));
	return WT(e, r), r;
}, Rk.prototype.getShapePath = function(e) {
	var t = e.x, n = e.y, r = e.width, i = e.height;
	return TE([
		[
			"M",
			t,
			n
		],
		[
			"l",
			r,
			0
		],
		[
			"l",
			0,
			i
		],
		[
			"l",
			-r,
			0
		],
		["z"]
	]);
}, Rk.prototype.getConnectionPath = function(e) {
	var t = e.waypoints, n, r, i = [];
	for (n = 0; r = t[n]; n++) r = r.original || r, i.push([
		n === 0 ? "M" : "L",
		r.x,
		r.y
	]);
	return TE(i);
}, Rk.$inject = ["eventBus", "styles"];
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/Styles.js
function zk() {
	var e = {
		"no-fill": { fill: "none" },
		"no-border": { strokeOpacity: 0 },
		"no-events": { pointerEvents: "none" }
	}, t = this;
	this.cls = function(e, t, n) {
		return Z(this.style(t, n), { class: e });
	}, this.style = function(t, n) {
		!Qw(t) && !n && (n = t, t = []);
		var r = sT(t, function(t, n) {
			return Z(t, e[n] || {});
		}, {});
		return n ? Z(r, n) : r;
	}, this.computeStyle = function(e, n, r) {
		return Qw(n) || (r = n, n = []), t.style(n || [], Z({}, r, e || {}));
	};
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/draw/index.js
var Bk = {
	__init__: ["defaultRenderer"],
	defaultRenderer: ["type", Rk],
	styles: ["type", zk]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/Collections.js
function Vk(e, t) {
	if (!e || !t) return -1;
	var n = e.indexOf(t);
	return n !== -1 && e.splice(n, 1), n;
}
function Hk(e, t, n) {
	if (!(!e || !t)) {
		typeof n != "number" && (n = -1);
		var r = e.indexOf(t);
		if (r !== -1) {
			if (r === n) return;
			if (n !== -1) e.splice(r, 1);
			else return;
		}
		n === -1 ? e.push(t) : e.splice(n, 0, t);
	}
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/Canvas.js
function Uk(e, t) {
	return Math.round(e * t) / t;
}
function Wk(e) {
	return eT(e) ? e + "px" : e;
}
function Gk(e) {
	for (; e.parent;) e = e.parent;
	return e;
}
function Kk(e) {
	e = Z({}, {
		width: "100%",
		height: "100%"
	}, e);
	let t = e.container || document.body, n = document.createElement("div");
	return n.setAttribute("class", "djs-container djs-parent"), XE(n, {
		position: "relative",
		overflow: "hidden",
		width: Wk(e.width),
		height: Wk(e.height)
	}), t.appendChild(n), n;
}
function qk(e, t, n) {
	let r = aE("g");
	QT(r).add(t);
	let i = n === void 0 ? e.childNodes.length - 1 : n;
	return e.insertBefore(r, e.childNodes[i] || null), r;
}
var Jk = "base", Yk = 0, Xk = 1, Zk = {
	shape: [
		"x",
		"y",
		"width",
		"height"
	],
	connection: ["waypoints"]
};
function Qk(e, t, n, r) {
	this._eventBus = t, this._elementRegistry = r, this._graphicsFactory = n, this._rootsIdx = 0, this._layers = {}, this._planes = [], this._rootElement = null, this._focused = !1, this._init(e || {});
}
Qk.$inject = [
	"config.canvas",
	"eventBus",
	"graphicsFactory",
	"elementRegistry"
], Qk.prototype._init = function(e) {
	let t = this._eventBus, n = this._container = Kk(e), r = this._svg = aE("svg");
	XT(r, {
		width: "100%",
		height: "100%"
	}), ZE(r, "tabindex", 0), e.autoFocus && t.on("element.hover", () => {
		this.restoreFocus();
	}), t.on("element.mousedown", 500, (e) => {
		this.focus();
	}), r.addEventListener("focusin", () => {
		this._setFocused(!0);
	}), r.addEventListener("focusout", () => {
		this._setFocused(!1);
	}), r.addEventListener("mouseover", () => {
		this._eventBus.fire("canvas.mouseover");
	}), r.addEventListener("mouseout", () => {
		this._eventBus.fire("canvas.mouseout");
	}), WT(n, r);
	let i = this._viewport = qk(r, "viewport");
	e.deferUpdate && (this._viewboxChanged = hT(gT(this._viewboxChanged, this), 300)), t.on("diagram.init", () => {
		t.fire("canvas.init", {
			svg: r,
			viewport: i
		});
	}), t.on([
		"shape.added",
		"connection.added",
		"shape.removed",
		"connection.removed",
		"elements.changed",
		"root.set"
	], () => {
		delete this._cachedViewbox;
	}), t.on("diagram.destroy", 500, this._destroy, this), t.on("diagram.clear", 500, this._clear, this);
}, Qk.prototype._destroy = function() {
	this._eventBus.fire("canvas.destroy", {
		svg: this._svg,
		viewport: this._viewport
	});
	let e = this._container.parentNode;
	e && e.removeChild(this._container), delete this._svg, delete this._container, delete this._layers, delete this._planes, delete this._rootElement, delete this._viewport;
}, Qk.prototype._setFocused = function(e) {
	e != this._focused && (this._focused = e, this._eventBus.fire("canvas.focus.changed", { focused: e }));
}, Qk.prototype._clear = function() {
	this._elementRegistry.getAll().forEach((e) => {
		let t = BT(e);
		t === "root" ? this.removeRootElement(e) : this._removeElement(e, t);
	}), this._planes = [], this._rootElement = null, delete this._cachedViewbox;
}, Qk.prototype.focus = function() {
	this._svg.focus({ preventScroll: !0 }), this._setFocused(!0);
}, Qk.prototype.restoreFocus = function() {
	document.activeElement === document.body && this.focus();
}, Qk.prototype.isFocused = function() {
	return this._focused;
}, Qk.prototype.getDefaultLayer = function() {
	return this.getLayer(Jk, Yk);
}, Qk.prototype.getLayer = function(e, t) {
	if (!e) throw Error("must specify a name");
	let n = this._layers[e];
	if (n ||= this._layers[e] = this._createLayer(e, t), t !== void 0 && n.index !== t) throw Error("layer <" + e + "> already created at index <" + t + ">");
	return n.group;
}, Qk.prototype._getChildIndex = function(e) {
	return sT(this._layers, function(t, n) {
		return n.visible && e >= n.index && t++, t;
	}, 0);
}, Qk.prototype._createLayer = function(e, t) {
	t === void 0 && (t = Xk);
	let n = this._getChildIndex(t);
	return {
		group: qk(this._viewport, "layer-" + e, n),
		index: t,
		visible: !0
	};
}, Qk.prototype.showLayer = function(e) {
	if (!e) throw Error("must specify a name");
	let t = this._layers[e];
	if (!t) throw Error("layer <" + e + "> does not exist");
	let n = this._viewport, r = t.group, i = t.index;
	if (t.visible) return r;
	let a = this._getChildIndex(i);
	return n.insertBefore(r, n.childNodes[a] || null), t.visible = !0, r;
}, Qk.prototype.hideLayer = function(e) {
	if (!e) throw Error("must specify a name");
	let t = this._layers[e];
	if (!t) throw Error("layer <" + e + "> does not exist");
	let n = t.group;
	return t.visible ? (xE(n), t.visible = !1, n) : n;
}, Qk.prototype._removeLayer = function(e) {
	let t = this._layers[e];
	t && (delete this._layers[e], xE(t.group));
}, Qk.prototype.getActiveLayer = function() {
	let e = this._findPlaneForRoot(this.getRootElement());
	return e ? e.layer : null;
}, Qk.prototype.findRoot = function(e) {
	if (typeof e == "string" && (e = this._elementRegistry.get(e)), e) return (this._findPlaneForRoot(Gk(e)) || {}).rootElement;
}, Qk.prototype.getRootElements = function() {
	return this._planes.map(function(e) {
		return e.rootElement;
	});
}, Qk.prototype._findPlaneForRoot = function(e) {
	return iT(this._planes, function(t) {
		return t.rootElement === e;
	});
}, Qk.prototype.getContainer = function() {
	return this._container;
}, Qk.prototype._updateMarker = function(e, t, n) {
	let r;
	e.id || (e = this._elementRegistry.get(e)), e.markers = e.markers || /* @__PURE__ */ new Set(), r = this._elementRegistry._elements[e.id], r && (X([r.gfx, r.secondaryGfx], function(r) {
		r && (n ? (e.markers.add(t), QT(r).add(t)) : (e.markers.delete(t), QT(r).remove(t)));
	}), this._eventBus.fire("element.marker.update", {
		element: e,
		gfx: r.gfx,
		marker: t,
		add: !!n
	}));
}, Qk.prototype.addMarker = function(e, t) {
	this._updateMarker(e, t, !0);
}, Qk.prototype.removeMarker = function(e, t) {
	this._updateMarker(e, t, !1);
}, Qk.prototype.hasMarker = function(e, t) {
	return e.id || (e = this._elementRegistry.get(e)), e.markers ? e.markers.has(t) : !1;
}, Qk.prototype.toggleMarker = function(e, t) {
	this.hasMarker(e, t) ? this.removeMarker(e, t) : this.addMarker(e, t);
}, Qk.prototype.getRootElement = function() {
	let e = this._rootElement;
	return e || this._planes.length ? e : this.setRootElement(this.addRootElement(null));
}, Qk.prototype.addRootElement = function(e) {
	let t = this._rootsIdx++;
	e ||= {
		id: "__implicitroot_" + t,
		children: [],
		isImplicit: !0
	};
	let n = e.layer = "root-" + t;
	this._ensureValid("root", e);
	let r = this.getLayer(n, Yk);
	return this.hideLayer(n), this._addRoot(e, r), this._planes.push({
		rootElement: e,
		layer: r
	}), e;
}, Qk.prototype.removeRootElement = function(e) {
	if (typeof e == "string" && (e = this._elementRegistry.get(e)), this._findPlaneForRoot(e)) return this._removeRoot(e), this._removeLayer(e.layer), this._planes = this._planes.filter(function(t) {
		return t.rootElement !== e;
	}), this._rootElement === e && (this._rootElement = null), e;
}, Qk.prototype.setRootElement = function(e) {
	if (e === this._rootElement) return e;
	let t;
	if (!e) throw Error("rootElement required");
	return t = this._findPlaneForRoot(e), t || (e = this.addRootElement(e)), this._setRoot(e), e;
}, Qk.prototype._removeRoot = function(e) {
	let t = this._elementRegistry, n = this._eventBus;
	n.fire("root.remove", { element: e }), n.fire("root.removed", { element: e }), t.remove(e);
}, Qk.prototype._addRoot = function(e, t) {
	let n = this._elementRegistry, r = this._eventBus;
	r.fire("root.add", { element: e }), n.add(e, t), r.fire("root.added", {
		element: e,
		gfx: t
	});
}, Qk.prototype._setRoot = function(e, t) {
	let n = this._rootElement;
	n && (this._elementRegistry.updateGraphics(n, null, !0), this.hideLayer(n.layer)), e && (t ||= this._findPlaneForRoot(e).layer, this._elementRegistry.updateGraphics(e, this._svg, !0), this.showLayer(e.layer)), this._rootElement = e, this._eventBus.fire("root.set", { element: e });
}, Qk.prototype._ensureValid = function(e, t) {
	if (!t.id) throw Error("element must have an id");
	if (this._elementRegistry.get(t.id)) throw Error("element <" + t.id + "> already exists");
	let n = Zk[e];
	if (!cT(n, function(e) {
		return t[e] !== void 0;
	})) throw Error("must supply { " + n.join(", ") + " } with " + e);
}, Qk.prototype._setParent = function(e, t, n) {
	Hk(t.children, e, n), e.parent = t;
}, Qk.prototype._addElement = function(e, t, n, r) {
	n ||= this.getRootElement();
	let i = this._eventBus, a = this._graphicsFactory;
	this._ensureValid(e, t), i.fire(e + ".add", {
		element: t,
		parent: n
	}), this._setParent(t, n, r);
	let o = a.create(e, t, r);
	return this._elementRegistry.add(t, o), a.update(e, t, o), i.fire(e + ".added", {
		element: t,
		gfx: o
	}), t;
}, Qk.prototype.addShape = function(e, t, n) {
	return this._addElement("shape", e, t, n);
}, Qk.prototype.addConnection = function(e, t, n) {
	return this._addElement("connection", e, t, n);
}, Qk.prototype._removeElement = function(e, t) {
	let n = this._elementRegistry, r = this._graphicsFactory, i = this._eventBus;
	if (e = n.get(e.id || e), e) return i.fire(t + ".remove", { element: e }), r.remove(e), Vk(e.parent && e.parent.children, e), e.parent = null, i.fire(t + ".removed", { element: e }), n.remove(e), e;
}, Qk.prototype.removeShape = function(e) {
	return this._removeElement(e, "shape");
}, Qk.prototype.removeConnection = function(e) {
	return this._removeElement(e, "connection");
}, Qk.prototype.getGraphics = function(e, t) {
	return this._elementRegistry.getGraphics(e, t);
}, Qk.prototype._changeViewbox = function(e) {
	this._eventBus.fire("canvas.viewbox.changing"), e.apply(this), this._cachedViewbox = null, this._viewboxChanged();
}, Qk.prototype._viewboxChanged = function() {
	this._eventBus.fire("canvas.viewbox.changed", { viewbox: this.viewbox() });
}, Qk.prototype.viewbox = function(e) {
	if (e === void 0 && this._cachedViewbox) return structuredClone(this._cachedViewbox);
	let t = this._viewport, n = this.getSize(), r, i, a, o, s, c, l;
	if (e) this._changeViewbox(function() {
		s = Math.min(n.width / e.width, n.height / e.height), wE(t, this._svg.createSVGMatrix().scale(s).translate(-e.x, -e.y));
	});
	else return a = this._rootElement ? this.getActiveLayer() : null, r = a && a.getBBox() || {}, o = wE(t), i = o ? o.matrix : lE(), s = Uk(i.a, 1e3), c = Uk(-i.e || 0, 1e3), l = Uk(-i.f || 0, 1e3), e = this._cachedViewbox = {
		x: c ? c / s : 0,
		y: l ? l / s : 0,
		width: n.width / s,
		height: n.height / s,
		scale: s,
		inner: {
			width: r.width || 0,
			height: r.height || 0,
			x: r.x || 0,
			y: r.y || 0
		},
		outer: n
	}, e;
	return e;
}, Qk.prototype.scroll = function(e) {
	let t = this._viewport, n = t.getCTM();
	return e && this._changeViewbox(function() {
		e = Z({
			dx: 0,
			dy: 0
		}, e || {}), n = this._svg.createSVGMatrix().translate(e.dx, e.dy).multiply(n), $k(t, n);
	}), {
		x: n.e,
		y: n.f
	};
}, Qk.prototype.scrollToElement = function(e, t) {
	let n = 100;
	typeof e == "string" && (e = this._elementRegistry.get(e));
	let r = this.findRoot(e);
	if (r !== this.getRootElement() && this.setRootElement(r), r === e) return;
	t ||= {}, typeof t == "number" && (n = t), t = {
		top: t.top || n,
		right: t.right || n,
		bottom: t.bottom || n,
		left: t.left || n
	};
	let i = zT(e), a = fO(i), o = this.viewbox(), s = this.zoom(), c, l;
	o.y += t.top / s, o.x += t.left / s, o.width -= (t.right + t.left) / s, o.height -= (t.bottom + t.top) / s;
	let u = fO(o);
	if (!(i.width < o.width && i.height < o.height)) c = i.x - o.x, l = i.y - o.y;
	else {
		let e = Math.max(0, a.right - u.right), t = Math.min(0, a.left - u.left), n = Math.max(0, a.bottom - u.bottom), r = Math.min(0, a.top - u.top);
		c = e || t, l = n || r;
	}
	this.scroll({
		dx: -c * s,
		dy: -l * s
	});
}, Qk.prototype.zoom = function(e, t) {
	if (!e) return this.viewbox(e).scale;
	if (e === "fit-viewport") return this._fitViewport(t);
	let n, r;
	return this._changeViewbox(function() {
		typeof t != "object" && (n = this.viewbox().outer, t = {
			x: n.width / 2,
			y: n.height / 2
		}), r = this._setZoom(e, t);
	}), Uk(r.a, 1e3);
};
function $k(e, t) {
	let n = "matrix(" + t.a + "," + t.b + "," + t.c + "," + t.d + "," + t.e + "," + t.f + ")";
	e.setAttribute("transform", n);
}
Qk.prototype._fitViewport = function(e) {
	let t = this.viewbox(), n = t.outer, r = t.inner, i, a;
	return r.x >= 0 && r.y >= 0 && r.x + r.width <= n.width && r.y + r.height <= n.height && !e ? a = {
		x: 0,
		y: 0,
		width: Math.max(r.width + r.x, n.width),
		height: Math.max(r.height + r.y, n.height)
	} : (i = Math.min(1, n.width / r.width, n.height / r.height), a = {
		x: r.x + (e ? r.width / 2 - n.width / i / 2 : 0),
		y: r.y + (e ? r.height / 2 - n.height / i / 2 : 0),
		width: n.width / i,
		height: n.height / i
	}), this.viewbox(a), this.viewbox(!1).scale;
}, Qk.prototype._setZoom = function(e, t) {
	let n = this._svg, r = this._viewport, i = n.createSVGMatrix(), a = n.createSVGPoint(), o, s, c, l, u;
	c = r.getCTM();
	let d = c.a;
	return t ? (o = Z(a, t), s = o.matrixTransform(c.inverse()), l = i.translate(s.x, s.y).scale(1 / d * e).translate(-s.x, -s.y), u = c.multiply(l)) : u = i.scale(e), $k(this._viewport, u), u;
}, Qk.prototype.getSize = function() {
	return {
		width: this._container.clientWidth,
		height: this._container.clientHeight
	};
}, Qk.prototype.getAbsoluteBBox = function(e) {
	let t = this.viewbox(), n;
	return n = e.waypoints ? this.getGraphics(e).getBBox() : e, {
		x: n.x * t.scale - t.x * t.scale,
		y: n.y * t.scale - t.y * t.scale,
		width: n.width * t.scale,
		height: n.height * t.scale
	};
}, Qk.prototype.resized = function() {
	delete this._cachedViewbox, this._eventBus.fire("canvas.resized");
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/ElementRegistry.js
var eA = "data-element-id";
function tA(e) {
	this._elements = {}, this._eventBus = e;
}
tA.$inject = ["eventBus"], tA.prototype.add = function(e, t, n) {
	var r = e.id;
	this._validateId(r), XT(t, eA, r), n && XT(n, eA, r), this._elements[r] = {
		element: e,
		gfx: t,
		secondaryGfx: n
	};
}, tA.prototype.remove = function(e) {
	var t = this._elements, n = e.id || e, r = n && t[n];
	r && (XT(r.gfx, eA, ""), r.secondaryGfx && XT(r.secondaryGfx, eA, ""), delete t[n]);
}, tA.prototype.updateId = function(e, t) {
	this._validateId(t), typeof e == "string" && (e = this.get(e)), this._eventBus.fire("element.updateId", {
		element: e,
		newId: t
	});
	var n = this.getGraphics(e), r = this.getGraphics(e, !0);
	this.remove(e), e.id = t, this.add(e, n, r);
}, tA.prototype.updateGraphics = function(e, t, n) {
	var r = e.id || e, i = this._elements[r];
	return n ? i.secondaryGfx = t : i.gfx = t, t && XT(t, eA, r), t;
}, tA.prototype.get = function(e) {
	var t = typeof e == "string" ? e : e && XT(e, eA), n = this._elements[t];
	return n && n.element;
}, tA.prototype.filter = function(e) {
	var t = [];
	return this.forEach(function(n, r) {
		e(n, r) && t.push(n);
	}), t;
}, tA.prototype.find = function(e) {
	for (var t = this._elements, n = Object.keys(t), r = 0; r < n.length; r++) {
		var i = t[n[r]], a = i.element, o = i.gfx;
		if (e(a, o)) return a;
	}
}, tA.prototype.getAll = function() {
	return this.filter(function(e) {
		return e;
	});
}, tA.prototype.forEach = function(e) {
	var t = this._elements;
	Object.keys(t).forEach(function(n) {
		var r = t[n], i = r.element, a = r.gfx;
		return e(i, a);
	});
}, tA.prototype.getGraphics = function(e, t) {
	var n = e.id || e, r = this._elements[n];
	return r && (t ? r.secondaryGfx : r.gfx);
}, tA.prototype._validateId = function(e) {
	if (!e) throw Error("element must have an id");
	if (this._elements[e]) throw Error("element with id " + e + " already added");
};
//#endregion
//#region ../../../node_modules/object-refs/dist/index.js
function nA(e, t, n, r) {
	var i = n.inverse;
	return Object.defineProperty(e, "remove", { value: function(e) {
		var n = this.indexOf(e);
		return n !== -1 && (this.splice(n, 1), t.unset(e, i, r)), e;
	} }), Object.defineProperty(e, "contains", { value: function(e) {
		return this.indexOf(e) !== -1;
	} }), Object.defineProperty(e, "add", { value: function(e, n) {
		var a = this.indexOf(e);
		if (n === void 0) {
			if (a !== -1) return;
			n = this.length;
		}
		a !== -1 && this.splice(a, 1), this.splice(n, 0, e), a === -1 && t.set(e, i, r);
	} }), Object.defineProperty(e, "__refs_collection", { value: !0 }), e;
}
function rA(e) {
	return e.__refs_collection === !0;
}
function iA(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t.name || t);
}
function aA(e, t, n) {
	var r = nA(n[t.name] || [], e, t, n);
	Object.defineProperty(n, t.name, {
		enumerable: t.enumerable,
		value: r
	}), r.length && r.forEach(function(r) {
		e.set(r, t.inverse, n);
	});
}
function oA(e, t, n) {
	var r = t.inverse, i = n[t.name];
	Object.defineProperty(n, t.name, {
		configurable: t.configurable,
		enumerable: t.enumerable,
		get: function() {
			return i;
		},
		set: function(t) {
			if (t !== i) {
				var a = i;
				i = null, a && e.unset(a, r, n), i = t, e.set(i, r, n);
			}
		}
	});
}
function sA(e, t) {
	if (!(this instanceof sA)) return new sA(e, t);
	e.inverse = t, t.inverse = e, this.props = {}, this.props[e.name] = e, this.props[t.name] = t;
}
sA.prototype.bind = function(e, t) {
	if (typeof t == "string") {
		if (!this.props[t]) throw Error("no property <" + t + "> in ref");
		t = this.props[t];
	}
	t.collection ? aA(this, t, e) : oA(this, t, e);
}, sA.prototype.ensureRefsCollection = function(e, t) {
	var n = e[t.name];
	return rA(n) || aA(this, t, e), n;
}, sA.prototype.ensureBound = function(e, t) {
	iA(e, t) || this.bind(e, t);
}, sA.prototype.unset = function(e, t, n) {
	e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).remove(n) : e[t.name] = void 0);
}, sA.prototype.set = function(e, t, n) {
	e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).add(n) : e[t.name] = n);
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/model/index.js
var cA = new sA({
	name: "children",
	enumerable: !0,
	collection: !0
}, { name: "parent" }), lA = new sA({
	name: "labels",
	enumerable: !0,
	collection: !0
}, { name: "labelTarget" }), uA = new sA({
	name: "attachers",
	collection: !0
}, { name: "host" }), dA = new sA({
	name: "outgoing",
	collection: !0
}, { name: "source" }), fA = new sA({
	name: "incoming",
	collection: !0
}, { name: "target" });
function pA() {
	Object.defineProperty(this, "businessObject", { writable: !0 }), Object.defineProperty(this, "label", {
		get: function() {
			return this.labels[0];
		},
		set: function(e) {
			var t = this.label, n = this.labels;
			!e && t ? n.remove(t) : n.add(e, 0);
		}
	}), cA.bind(this, "parent"), lA.bind(this, "labels"), dA.bind(this, "outgoing"), fA.bind(this, "incoming");
}
function mA() {
	pA.call(this), cA.bind(this, "children"), uA.bind(this, "host"), uA.bind(this, "attachers");
}
Kw(mA, pA);
function hA() {
	pA.call(this), cA.bind(this, "children");
}
Kw(hA, mA);
function gA() {
	mA.call(this), lA.bind(this, "labelTarget");
}
Kw(gA, mA);
function _A() {
	pA.call(this), dA.bind(this, "source"), fA.bind(this, "target");
}
Kw(_A, pA);
var vA = {
	connection: _A,
	shape: mA,
	label: gA,
	root: hA
};
function yA(e, t) {
	var n = vA[e];
	if (!n) throw Error("unknown type: <" + e + ">");
	return Z(new n(), t);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/ElementFactory.js
function bA() {
	this._uid = 12;
}
bA.prototype.createRoot = function(e) {
	return this.create("root", e);
}, bA.prototype.createLabel = function(e) {
	return this.create("label", e);
}, bA.prototype.createShape = function(e) {
	return this.create("shape", e);
}, bA.prototype.createConnection = function(e) {
	return this.create("connection", e);
}, bA.prototype.create = function(e, t) {
	return t = Z({}, t || {}), t.id ||= e + "_" + this._uid++, yA(e, t);
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/EventBus.js
var xA = "__fn", SA = 1e3, CA = Array.prototype.slice;
function wA() {
	this._listeners = {}, this.on("diagram.destroy", 1, this._destroy, this);
}
wA.prototype.on = function(e, t, n, r) {
	if (e = Qw(e) ? e : [e], tT(t) && (r = n, n = t, t = SA), !eT(t)) throw Error("priority must be a number");
	var i = n;
	r && (i = gT(n, r), i[xA] = n[xA] || n);
	var a = this;
	e.forEach(function(e) {
		a._addListener(e, {
			priority: t,
			callback: i,
			next: null
		});
	});
}, wA.prototype.once = function(e, t, n, r) {
	var i = this;
	if (tT(t) && (r = n, n = t, t = SA), !eT(t)) throw Error("priority must be a number");
	function a() {
		a.__isTomb = !0;
		var t = n.apply(r, arguments);
		return i.off(e, a), t;
	}
	a[xA] = n, this.on(e, t, a);
}, wA.prototype.off = function(e, t) {
	e = Qw(e) ? e : [e];
	var n = this;
	e.forEach(function(e) {
		n._removeListener(e, t);
	});
}, wA.prototype.createEvent = function(e) {
	var t = new TA();
	return t.init(e), t;
}, wA.prototype.fire = function(e, t) {
	var n, r, i, a = CA.call(arguments);
	if (typeof e == "object" && (t = e, e = t.type), !e) throw Error("no event type specified");
	if (r = this._listeners[e], r) {
		n = t instanceof TA ? t : this.createEvent(t), a[0] = n;
		var o = n.type;
		e !== o && (n.type = e);
		try {
			i = this._invokeListeners(n, a, r);
		} finally {
			e !== o && (n.type = o);
		}
		return i === void 0 && n.defaultPrevented && (i = !1), i;
	}
}, wA.prototype.handleError = function(e) {
	return this.fire("error", { error: e }) === !1;
}, wA.prototype._destroy = function() {
	this._listeners = {};
}, wA.prototype._invokeListeners = function(e, t, n) {
	for (var r; n && !e.cancelBubble;) r = this._invokeListener(e, t, n), n = n.next;
	return r;
}, wA.prototype._invokeListener = function(e, t, n) {
	var r;
	if (n.callback.__isTomb) return r;
	try {
		r = EA(n.callback, t), r !== void 0 && (e.returnValue = r, e.stopPropagation()), r === !1 && e.preventDefault();
	} catch (e) {
		if (!this.handleError(e)) throw console.error("unhandled error in event listener", e), e;
	}
	return r;
}, wA.prototype._addListener = function(e, t) {
	var n = this._getListeners(e), r;
	if (!n) {
		this._setListeners(e, t);
		return;
	}
	for (; n;) {
		if (n.priority < t.priority) {
			t.next = n, r ? r.next = t : this._setListeners(e, t);
			return;
		}
		r = n, n = n.next;
	}
	r.next = t;
}, wA.prototype._getListeners = function(e) {
	return this._listeners[e];
}, wA.prototype._setListeners = function(e, t) {
	this._listeners[e] = t;
}, wA.prototype._removeListener = function(e, t) {
	var n = this._getListeners(e), r, i, a;
	if (!t) {
		this._setListeners(e, null);
		return;
	}
	for (; n;) r = n.next, a = n.callback, (a === t || a[xA] === t) && (i ? i.next = r : this._setListeners(e, r)), i = n, n = r;
};
function TA() {}
TA.prototype.stopPropagation = function() {
	this.cancelBubble = !0;
}, TA.prototype.preventDefault = function() {
	this.defaultPrevented = !0;
}, TA.prototype.init = function(e) {
	Z(this, e || {});
};
function EA(e, t) {
	return e.apply(null, t);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/util/GraphicsUtil.js
function DA(e) {
	return e.childNodes[0];
}
function OA(e) {
	return e.parentNode.childNodes[1];
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/GraphicsFactory.js
function kA(e, t) {
	this._eventBus = e, this._elementRegistry = t;
}
kA.$inject = ["eventBus", "elementRegistry"], kA.prototype._getChildrenContainer = function(e) {
	var t = this._elementRegistry.getGraphics(e), n;
	return e.parent ? (n = OA(t), n || (n = aE("g"), QT(n).add("djs-children"), WT(t.parentNode, n))) : n = t, n;
}, kA.prototype._clear = function(e) {
	var t = DA(e);
	return tD(t), t;
}, kA.prototype._createContainer = function(e, t, n, r) {
	var i = aE("g");
	QT(i).add("djs-group"), n === void 0 ? WT(t, i) : AA(i, t, t.childNodes[n]);
	var a = aE("g");
	QT(a).add("djs-element"), QT(a).add("djs-" + e), r && QT(a).add("djs-frame"), WT(i, a);
	var o = aE("g");
	return QT(o).add("djs-visual"), WT(a, o), a;
}, kA.prototype.create = function(e, t, n) {
	var r = this._getChildrenContainer(t.parent);
	return this._createContainer(e, r, n, VT(t));
}, kA.prototype.updateContainments = function(e) {
	var t = this, n = this._elementRegistry;
	X(sT(e, function(e, t) {
		return t.parent && (e[t.parent.id] = t.parent), e;
	}, {}), function(e) {
		var r = e.children;
		if (r) {
			var i = t._getChildrenContainer(e);
			X(r.slice().reverse(), function(e) {
				AA(n.getGraphics(e).parentNode, i);
			});
		}
	});
}, kA.prototype.drawShape = function(e, t, n = {}) {
	return this._eventBus.fire("render.shape", {
		gfx: e,
		element: t,
		attrs: n
	});
}, kA.prototype.getShapePath = function(e) {
	return this._eventBus.fire("render.getShapePath", e);
}, kA.prototype.drawConnection = function(e, t, n = {}) {
	return this._eventBus.fire("render.connection", {
		gfx: e,
		element: t,
		attrs: n
	});
}, kA.prototype.getConnectionPath = function(e) {
	return this._eventBus.fire("render.getConnectionPath", e);
}, kA.prototype.update = function(e, t, n) {
	if (t.parent) {
		var r = this._clear(n);
		if (e === "shape") this.drawShape(r, t), _D(n, t.x, t.y);
		else if (e === "connection") this.drawConnection(r, t);
		else throw Error("unknown type: " + e);
		t.hidden ? XT(n, "display", "none") : XT(n, "display", "block");
	}
}, kA.prototype.remove = function(e) {
	xE(this._elementRegistry.getGraphics(e).parentNode);
};
function AA(e, t, n) {
	var r = n || t.firstChild;
	e !== r && t.insertBefore(e, r);
}
//#endregion
//#region ../../../node_modules/diagram-js/lib/core/index.js
var jA = {
	__depends__: [Bk],
	__init__: ["canvas"],
	canvas: ["type", Qk],
	elementRegistry: ["type", tA],
	elementFactory: ["type", bA],
	eventBus: ["type", wA],
	graphicsFactory: ["type", kA]
};
//#endregion
//#region ../../../node_modules/diagram-js/lib/Diagram.js
function MA(e) {
	var t = new Fk(e);
	return t.init(), t;
}
function NA(e) {
	return e ||= {}, MA([{ config: ["value", e] }, jA].concat(e.modules || []));
}
function PA(e, t) {
	this._injector = t || NA(e), this.get("eventBus").fire("diagram.init");
}
PA.prototype.get = function(e, t) {
	return this._injector.get(e, t);
}, PA.prototype.invoke = function(e, t, n) {
	return this._injector.invoke(e, t, n);
}, PA.prototype.destroy = function() {
	this.get("eventBus").fire("diagram.destroy");
}, PA.prototype.clear = function() {
	this.get("eventBus").fire("diagram.clear");
};
//#endregion
//#region ../../../node_modules/moddle/dist/index.js
function FA() {}
FA.prototype.get = function(e) {
	return this.$model.properties.get(this, e);
}, FA.prototype.set = function(e, t) {
	this.$model.properties.set(this, e, t);
};
function IA(e, t) {
	this.model = e, this.properties = t;
}
IA.prototype.createType = function(e) {
	var t = this.model, n = this.properties, r = Object.create(FA.prototype);
	X(e.properties, function(e) {
		!e.isMany && e.default !== void 0 && (r[e.name] = e.default);
	}), n.defineModel(r, t), n.defineDescriptor(r, e);
	var i = e.ns.name;
	function a(e) {
		n.define(this, "$type", {
			value: i,
			enumerable: !0
		}), n.define(this, "$attrs", { value: {} }), n.define(this, "$parent", { writable: !0 }), X(e, gT(function(e, t) {
			this.set(t, e);
		}, this));
	}
	return a.prototype = r, a.hasType = r.$instanceOf = this.model.hasType, n.defineModel(a, t), n.defineDescriptor(a, e), a;
};
var LA = {
	String: !0,
	Boolean: !0,
	Integer: !0,
	Real: !0,
	Element: !0
}, RA = {
	String: function(e) {
		return e;
	},
	Boolean: function(e) {
		return e === "true";
	},
	Integer: function(e) {
		return parseInt(e, 10);
	},
	Real: function(e) {
		return parseFloat(e);
	}
};
function zA(e, t) {
	var n = RA[e];
	return n ? n(t) : t;
}
function BA(e) {
	return !!LA[e];
}
function VA(e) {
	return !!RA[e];
}
function HA(e, t) {
	var n = e.split(/:/), r, i;
	if (n.length === 1) r = e, i = t;
	else if (n.length === 2) r = n[1], i = n[0];
	else throw Error("expected <prefix:localName> or <localName>, got " + e);
	return e = (i ? i + ":" : "") + r, {
		name: e,
		prefix: i,
		localName: r
	};
}
function UA(e) {
	this.ns = e, this.name = e.name, this.allTypes = [], this.allTypesByName = {}, this.properties = [], this.propertiesByName = {};
}
UA.prototype.build = function() {
	return vT(this, [
		"ns",
		"name",
		"allTypes",
		"allTypesByName",
		"properties",
		"propertiesByName",
		"bodyProperty",
		"idProperty"
	]);
}, UA.prototype.addProperty = function(e, t, n) {
	typeof t == "boolean" && (n = t, t = void 0), this.addNamedProperty(e, n !== !1);
	var r = this.properties;
	t === void 0 ? r.push(e) : r.splice(t, 0, e);
}, UA.prototype.replaceProperty = function(e, t, n) {
	var r = e.ns, i = this.properties, a = this.propertiesByName, o = e.name !== t.name;
	if (e.isId) {
		if (!t.isId) throw Error("property <" + t.ns.name + "> must be id property to refine <" + e.ns.name + ">");
		this.setIdProperty(t, !1);
	}
	if (e.isBody) {
		if (!t.isBody) throw Error("property <" + t.ns.name + "> must be body property to refine <" + e.ns.name + ">");
		this.setBodyProperty(t, !1);
	}
	var s = i.indexOf(e);
	if (s === -1) throw Error("property <" + r.name + "> not found in property list");
	i.splice(s, 1), this.addProperty(t, n ? void 0 : s, o), a[r.name] = a[r.localName] = t;
}, UA.prototype.redefineProperty = function(e, t, n) {
	var r = e.ns.prefix, i = t.split("#"), a = HA(i[0], r), o = HA(i[1], a.prefix).name, s = this.propertiesByName[o];
	if (s) this.replaceProperty(s, e, n);
	else throw Error("refined property <" + o + "> not found");
	delete e.redefines;
}, UA.prototype.addNamedProperty = function(e, t) {
	var n = e.ns, r = this.propertiesByName;
	t && (this.assertNotDefined(e, n.name), this.assertNotDefined(e, n.localName)), r[n.name] = r[n.localName] = e;
}, UA.prototype.removeNamedProperty = function(e) {
	var t = e.ns, n = this.propertiesByName;
	delete n[t.name], delete n[t.localName];
}, UA.prototype.setBodyProperty = function(e, t) {
	if (t && this.bodyProperty) throw Error("body property defined multiple times (<" + this.bodyProperty.ns.name + ">, <" + e.ns.name + ">)");
	this.bodyProperty = e;
}, UA.prototype.setIdProperty = function(e, t) {
	if (t && this.idProperty) throw Error("id property defined multiple times (<" + this.idProperty.ns.name + ">, <" + e.ns.name + ">)");
	this.idProperty = e;
}, UA.prototype.assertNotTrait = function(e) {
	if ((e.extends || []).length) throw Error(`cannot create <${e.name}> extending <${e.extends}>`);
}, UA.prototype.assertNotDefined = function(e, t) {
	var n = e.name, r = this.propertiesByName[n];
	if (r) throw Error("property <" + n + "> already defined; override of <" + r.definedBy.ns.name + "#" + r.ns.name + "> by <" + e.definedBy.ns.name + "#" + e.ns.name + "> not allowed without redefines");
}, UA.prototype.hasProperty = function(e) {
	return this.propertiesByName[e];
}, UA.prototype.addTrait = function(e, t) {
	t && this.assertNotTrait(e);
	var n = this.allTypesByName, r = this.allTypes, i = e.name;
	i in n || (X(e.properties, gT(function(n) {
		n = Z({}, n, {
			name: n.ns.localName,
			inherited: t
		}), Object.defineProperty(n, "definedBy", { value: e });
		var r = n.replaces, i = n.redefines;
		r || i ? this.redefineProperty(n, r || i, r) : (n.isBody && this.setBodyProperty(n), n.isId && this.setIdProperty(n), this.addProperty(n));
	}, this)), r.push(e), n[i] = e);
};
function WA(e, t) {
	this.packageMap = {}, this.typeMap = {}, this.packages = [], this.properties = t, X(e, gT(this.registerPackage, this));
}
WA.prototype.getPackage = function(e) {
	return this.packageMap[e];
}, WA.prototype.getPackages = function() {
	return this.packages;
}, WA.prototype.registerPackage = function(e) {
	e = Z({}, e);
	var t = this.packageMap;
	GA(t, e, "prefix"), GA(t, e, "uri"), X(e.types, gT(function(t) {
		this.registerType(t, e);
	}, this)), t[e.uri] = t[e.prefix] = e, this.packages.push(e);
}, WA.prototype.registerType = function(e, t) {
	e = Z({}, e, {
		superClass: (e.superClass || []).slice(),
		extends: (e.extends || []).slice(),
		properties: (e.properties || []).slice(),
		meta: Z(e.meta || {})
	});
	var n = HA(e.name, t.prefix), r = n.name, i = {};
	X(e.properties, gT(function(e) {
		var t = HA(e.name, n.prefix), r = t.name;
		BA(e.type) || (e.type = HA(e.type, t.prefix).name), Z(e, {
			ns: t,
			name: r
		}), i[r] = e;
	}, this)), Z(e, {
		ns: n,
		name: r,
		propertiesByName: i
	}), X(e.extends, gT(function(e) {
		var t = HA(e, n.prefix), i = this.typeMap[t.name];
		i.traits = i.traits || [], i.traits.push(r);
	}, this)), this.definePackage(e, t), this.typeMap[r] = e;
}, WA.prototype.mapTypes = function(e, t, n) {
	var r = BA(e.name) ? { name: e.name } : this.typeMap[e.name], i = this;
	function a(n, r) {
		var a = HA(n, BA(n) ? "" : e.prefix);
		i.mapTypes(a, t, r);
	}
	function o(e) {
		return a(e, !0);
	}
	function s(e) {
		return a(e, !1);
	}
	if (!r) throw Error("unknown type <" + e.name + ">");
	X(r.superClass, n ? o : s), t(r, !n), X(r.traits, o);
}, WA.prototype.getEffectiveDescriptor = function(e) {
	var t = HA(e), n = new UA(t);
	this.mapTypes(t, function(e, t) {
		n.addTrait(e, t);
	});
	var r = n.build();
	return this.definePackage(r, r.allTypes[r.allTypes.length - 1].$pkg), r;
}, WA.prototype.definePackage = function(e, t) {
	this.properties.define(e, "$pkg", { value: t });
};
function GA(e, t, n) {
	var r = t[n];
	if (r in e) throw Error("package with " + n + " <" + r + "> already defined");
}
function KA(e) {
	this.model = e;
}
KA.prototype.set = function(e, t, n) {
	if (!nT(t) || !t.length) throw TypeError("property name must be a non-empty string");
	var r = this.getProperty(e, t), i = r && r.name;
	qA(n) ? r ? delete e[i] : delete e.$attrs[YA(t)] : r ? i in e ? e[i] = n : JA(e, r, n) : e.$attrs[YA(t)] = n;
}, KA.prototype.get = function(e, t) {
	var n = this.getProperty(e, t);
	if (!n) return e.$attrs[YA(t)];
	var r = n.name;
	return !e[r] && n.isMany && JA(e, n, []), e[r];
}, KA.prototype.define = function(e, t, n) {
	if (!n.writable) {
		var r = n.value;
		n = Z({}, n, { get: function() {
			return r;
		} }), delete n.value;
	}
	Object.defineProperty(e, t, n);
}, KA.prototype.defineDescriptor = function(e, t) {
	this.define(e, "$descriptor", { value: t });
}, KA.prototype.defineModel = function(e, t) {
	this.define(e, "$model", { value: t });
}, KA.prototype.getProperty = function(e, t) {
	var n = this.model, r = n.getPropertyDescriptor(e, t);
	if (r) return r;
	if (t.includes(":")) return null;
	let i = n.config.strict;
	if (i !== void 0) {
		let n = /* @__PURE__ */ TypeError(`unknown property <${t}> on <${e.$type}>`);
		if (i) throw n;
		typeof console < "u" && console.warn(n);
	}
	return null;
};
function qA(e) {
	return e === void 0;
}
function JA(e, t, n) {
	Object.defineProperty(e, t.name, {
		enumerable: !t.isReference,
		writable: !0,
		value: n,
		configurable: !0
	});
}
function YA(e) {
	return e.replace(/^:/, "");
}
function XA(e, t = {}) {
	this.properties = new KA(this), this.factory = new IA(this, this.properties), this.registry = new WA(e, this.properties), this.typeCache = {}, this.config = t;
}
XA.prototype.create = function(e, t) {
	var n = this.getType(e);
	if (!n) throw Error("unknown type <" + e + ">");
	return new n(t);
}, XA.prototype.getType = function(e) {
	var t = this.typeCache, n = nT(e) ? e : e.ns.name, r = t[n];
	return r ||= (e = this.registry.getEffectiveDescriptor(n), t[n] = this.factory.createType(e)), r;
}, XA.prototype.createAny = function(e, t, n) {
	var r = HA(e), i = {
		$type: e,
		$instanceOf: function(e) {
			return e === this.$type;
		},
		get: function(e) {
			return this[e];
		},
		set: function(e, t) {
			_T(this, [e], t);
		}
	}, a = {
		name: e,
		isGeneric: !0,
		ns: {
			prefix: r.prefix,
			localName: r.localName,
			uri: t
		}
	};
	return this.properties.defineDescriptor(i, a), this.properties.defineModel(i, this), this.properties.define(i, "get", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "set", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "$parent", {
		enumerable: !1,
		writable: !0
	}), this.properties.define(i, "$instanceOf", {
		enumerable: !1,
		writable: !0
	}), X(n, function(e, t) {
		$w(e) && e.value !== void 0 ? i[e.name] = e.value : i[t] = e;
	}), i;
}, XA.prototype.getPackage = function(e) {
	return this.registry.getPackage(e);
}, XA.prototype.getPackages = function() {
	return this.registry.getPackages();
}, XA.prototype.getElementDescriptor = function(e) {
	return e.$descriptor;
}, XA.prototype.hasType = function(e, t) {
	t === void 0 && (t = e, e = this);
	var n = e.$model.getElementDescriptor(e);
	return t in n.allTypesByName;
}, XA.prototype.getPropertyDescriptor = function(e, t) {
	return this.getElementDescriptor(e).propertiesByName[t];
}, XA.prototype.getTypeDescriptor = function(e) {
	return this.registry.typeMap[e];
};
//#endregion
//#region ../../../node_modules/saxen/dist/index.js
var ZA = String.fromCharCode, QA = Object.prototype.hasOwnProperty, $A = /&#(\d+);|&#x([0-9a-f]+);|&(\w+);/gi, ej = {
	amp: "&",
	apos: "'",
	gt: ">",
	lt: "<",
	quot: "\""
};
Object.keys(ej).forEach(function(e) {
	ej[e.toUpperCase()] = ej[e];
});
function tj(e, t, n, r) {
	return r ? QA.call(ej, r) ? ej[r] : "&" + r + ";" : ZA(t || parseInt(n, 16));
}
function nj(e) {
	return e.length > 3 && e.indexOf("&") !== -1 ? e.replace($A, tj) : e;
}
var rj = "non-whitespace outside of root node";
function ij(e) {
	return Error(e);
}
function aj(e) {
	return "missing namespace for prefix <" + e + ">";
}
function oj(e) {
	return {
		get: e,
		enumerable: !0
	};
}
function sj(e) {
	var t = {}, n;
	for (n in e) t[n] = e[n];
	return t;
}
function cj(e) {
	return e + "$uri";
}
function lj(e) {
	var t = {}, n, r;
	for (n in e) r = e[n], t[r] = r, t[cj(r)] = n;
	return t;
}
function uj() {
	return {
		line: 0,
		column: 0
	};
}
function dj(e) {
	throw e;
}
function fj(e) {
	if (!this) return new fj(e);
	var t = e && e.proxy, n, r, i, a, o = dj, s, c, l, u, d = uj, f = !1, p = !1, m = null, h = !1, g;
	function _(e) {
		e instanceof Error || (e = ij(e)), m = e, o(e, d);
	}
	function v(e) {
		s && (e instanceof Error || (e = ij(e)), s(e, d));
	}
	this.on = function(e, t) {
		if (typeof t != "function") throw ij("required args <name, cb>");
		switch (e) {
			case "openTag":
				r = t;
				break;
			case "text":
				n = t;
				break;
			case "closeTag":
				i = t;
				break;
			case "error":
				o = t;
				break;
			case "warn":
				s = t;
				break;
			case "cdata":
				a = t;
				break;
			case "attention":
				u = t;
				break;
			case "question":
				l = t;
				break;
			case "comment":
				c = t;
				break;
			default: throw ij("unsupported event: " + e);
		}
		return this;
	}, this.ns = function(e) {
		if (e === void 0 && (e = {}), typeof e != "object") throw ij("required args <nsMap={}>");
		var t = {}, n;
		for (n in e) t[n] = e[n];
		return p = !0, g = t, this;
	}, this.parse = function(e) {
		if (typeof e != "string") throw ij("required args <xml=string>");
		return m = null, y(e), d = uj, h = !1, m;
	}, this.stop = function() {
		h = !0;
	};
	function y(e) {
		var o = p ? [] : null, s = p ? lj(g) : null, m, y = [], b = 0, x = !1, S = !1, C = 0, w = 0, T, E, D, O, k, ee, A, j, M, N = "", te = 0, ne;
		function P() {
			if (ne !== null) return ne;
			var e, t, n, r = p && s.xmlns, i = p && f ? [] : null, a = te, o = N, c = o.length, l, u, d, m, h, _ = {}, y = {}, x, S, C;
			parseAttr: for (; a < c; a++) if (x = !1, S = o.charCodeAt(a), !(S === 32 || S < 14 && S > 8)) {
				for ((S < 65 || S > 122 || S > 90 && S < 97) && S !== 95 && S !== 58 && (v("illegal first char attribute name"), x = !0), C = a + 1; C < c; C++) if (S = o.charCodeAt(C), !(S > 96 && S < 123 || S > 64 && S < 91 || S > 47 && S < 59 || S === 46 || S === 45 || S === 95)) {
					if (S === 32 || S < 14 && S > 8) {
						v("missing attribute value"), a = C;
						continue parseAttr;
					}
					if (S === 61) break;
					v("illegal attribute name char"), x = !0;
				}
				if (h = o.substring(a, C), h === "xmlns:xmlns" && (v("illegal declaration of xmlns"), x = !0), S = o.charCodeAt(C + 1), S === 34) C = o.indexOf("\"", a = C + 2), C === -1 && (C = o.indexOf("'", a), C !== -1 && (v("attribute value quote missmatch"), x = !0));
				else if (S === 39) C = o.indexOf("'", a = C + 2), C === -1 && (C = o.indexOf("\"", a), C !== -1 && (v("attribute value quote missmatch"), x = !0));
				else for (v("missing attribute value quotes"), x = !0, C += 1; C < c && (S = o.charCodeAt(C + 1), !(S === 32 || S < 14 && S > 8)); C++);
				for (C === -1 && (v("missing closing quotes"), C = c, x = !0), x || (d = o.substring(a, C)), a = C; C + 1 < c && (S = o.charCodeAt(C + 1), !(S === 32 || S < 14 && S > 8)); C++) a === C && (v("illegal character after attribute end"), x = !0);
				if (a = C + 1, x) continue parseAttr;
				if (h in y) {
					v("attribute <" + h + "> already defined");
					continue;
				}
				if (y[h] = !0, !p) {
					_[h] = d;
					continue;
				}
				if (f) {
					if (u = h === "xmlns" ? "xmlns" : h.charCodeAt(0) === 120 && h.substr(0, 6) === "xmlns:" ? h.substr(6) : null, u !== null) {
						if (e = nj(d), t = cj(u), m = g[e], !m) {
							if (u === "xmlns" || t in s && s[t] !== e) do
								m = "ns" + b++;
							while (s[m] !== void 0);
							else m = u;
							g[e] = m;
						}
						s[u] !== m && (l ||= (s = sj(s), !0), s[u] = m, u === "xmlns" && (s[cj(m)] = e, r = m), s[t] = e), _[h] = d;
						continue;
					}
					i.push(h, d);
					continue;
				}
				if (S = h.indexOf(":"), S === -1) {
					_[h] = d;
					continue;
				}
				if (!(n = s[h.substring(0, S)])) {
					v(aj(h.substring(0, S)));
					continue;
				}
				h = r === n ? h.substr(S + 1) : n + h.substr(S), _[h] = d;
			}
			if (f) for (a = 0, c = i.length; a < c; a++) {
				if (h = i[a++], d = i[a], S = h.indexOf(":"), S !== -1) {
					if (!(n = s[h.substring(0, S)])) {
						v(aj(h.substring(0, S)));
						continue;
					}
					h = r === n ? h.substr(S + 1) : n + h.substr(S);
				}
				_[h] = d;
			}
			return ne = _;
		}
		function re() {
			for (var t = /(\r\n|\r|\n)/g, n = 0, r = 0, i = 0, a = w, o, s; C >= i && (o = t.exec(e), !(!o || (a = o[0].length + o.index, a > C)));) n += 1, i = a;
			return C == -1 ? (r = a, s = e.substring(w)) : w === 0 ? s = e.substring(w, C) : (r = C - i, s = w == -1 ? e.substring(C) : e.substring(C, w + 1)), {
				data: s,
				line: n,
				column: r
			};
		}
		for (d = re, t && (M = Object.create({}, {
			name: oj(function() {
				return A;
			}),
			originalName: oj(function() {
				return j;
			}),
			attrs: oj(P),
			ns: oj(function() {
				return s;
			})
		})); w !== -1;) {
			if (C = e.charCodeAt(w) === 60 ? w : e.indexOf("<", w), C === -1) {
				if (y.length) return _("unexpected end of file");
				if (w === 0) return _("missing start tag");
				w < e.length && e.substring(w).trim() && v(rj);
				return;
			}
			if (w !== C) {
				if (y.length) {
					if (n && (n(e.substring(w, C), nj, d), h)) return;
				} else if (e.substring(w, C).trim() && (v(rj), h)) return;
			}
			if (O = e.charCodeAt(C + 1), O === 33) {
				if (D = e.charCodeAt(C + 2), D === 91 && e.substr(C + 3, 6) === "CDATA[") {
					if (w = e.indexOf("]]>", C), w === -1) return _("unclosed cdata");
					if (a && (a(e.substring(C + 9, w), d), h)) return;
					w += 3;
					continue;
				}
				if (D === 45 && e.charCodeAt(C + 3) === 45) {
					if (w = e.indexOf("-->", C), w === -1) return _("unclosed comment");
					if (c && (c(e.substring(C + 4, w), nj, d), h)) return;
					w += 3;
					continue;
				}
			}
			if (O === 63) {
				if (w = e.indexOf("?>", C), w === -1) return _("unclosed question");
				if (l && (l(e.substring(C, w + 2), d), h)) return;
				w += 2;
				continue;
			}
			for (T = C + 1;; T++) {
				if (k = e.charCodeAt(T), isNaN(k)) return w = -1, _("unclosed tag");
				if (k === 34) D = e.indexOf("\"", T + 1), T = D === -1 ? T : D;
				else if (k === 39) D = e.indexOf("'", T + 1), T = D === -1 ? T : D;
				else if (k === 62) {
					w = T;
					break;
				}
			}
			if (O === 33) {
				if (u && (u(e.substring(C, w + 1), nj, d), h)) return;
				w += 1;
				continue;
			}
			if (ne = {}, O === 47) {
				if (x = !1, S = !0, !y.length) return _("missing open tag");
				if (T = A = y.pop(), D = C + 2 + T.length, e.substring(C + 2, D) !== T) return _("closing tag mismatch");
				for (; D < w; D++) if (O = e.charCodeAt(D), !(O === 32 || O > 8 && O < 14)) return _("close tag");
			} else {
				if (e.charCodeAt(w - 1) === 47 ? (T = A = e.substring(C + 1, w - 1), x = !0, S = !0) : (T = A = e.substring(C + 1, w), x = !0, S = !1), !(O > 96 && O < 123 || O > 64 && O < 91 || O === 95 || O === 58)) return _("illegal first char nodeName");
				for (D = 1, E = T.length; D < E; D++) if (O = T.charCodeAt(D), !(O > 96 && O < 123 || O > 64 && O < 91 || O > 47 && O < 59 || O === 45 || O === 95 || O == 46)) {
					if (O === 32 || O < 14 && O > 8) {
						A = T.substring(0, D), ne = null;
						break;
					}
					return _("invalid nodeName");
				}
				S || y.push(A);
			}
			if (p) {
				if (m = s, x && (S || o.push(m), ne === null && (f = T.indexOf("xmlns", D) !== -1) && (te = D, N = T, P(), f = !1)), j = A, O = A.indexOf(":"), O !== -1) {
					if (ee = s[A.substring(0, O)], !ee) return _("missing namespace on <" + j + ">");
					A = A.substr(O + 1);
				} else ee = s.xmlns;
				ee && (A = ee + ":" + A);
			}
			if (x && (te = D, N = T, r && (t ? r(M, nj, S, d) : r(A, P, nj, S, d), h))) return;
			if (S) {
				if (i && (i(t ? M : A, nj, x, d), h)) return;
				p && (s = x ? m : o.pop());
			}
			w += 1;
		}
	}
}
//#endregion
//#region ../../../node_modules/moddle-xml/dist/index.js
function pj(e) {
	return e.xml && e.xml.tagAlias === "lowerCase";
}
var mj = {
	xsi: "http://www.w3.org/2001/XMLSchema-instance",
	xml: "http://www.w3.org/XML/1998/namespace"
}, hj = "property";
function gj(e) {
	return e.xml && e.xml.serialize;
}
function _j(e) {
	let t = gj(e);
	return t !== hj && (t || null);
}
function vj(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
function yj(e, t) {
	return pj(t) ? e.prefix + ":" + vj(e.localName) : e.name;
}
function bj(e, t) {
	var n = e.name, r = e.localName, i = t && t.xml && t.xml.typePrefix;
	return i && r.indexOf(i) === 0 ? e.prefix + ":" + r.slice(i.length) : n;
}
function xj(e, t, n) {
	let r = HA(e, t.xmlns), i = HA(`${t[r.prefix] || r.prefix}:${r.localName}`);
	return bj(i, n.getPackage(i.prefix));
}
function Sj(e) {
	return Error(e);
}
function Cj(e) {
	return e.$descriptor;
}
function wj(e) {
	Z(this, e), this.elementsById = {}, this.references = [], this.warnings = [], this.addReference = function(e) {
		this.references.push(e);
	}, this.addElement = function(e) {
		if (!e) throw Sj("expected element");
		var t = this.elementsById, n = Cj(e).idProperty, r;
		if (n && (r = e.get(n.name), r)) {
			if (!/^([a-z][\w-.]*:)?[a-z_][\w-.]*$/i.test(r)) throw Error("illegal ID <" + r + ">");
			if (t[r]) throw Sj("duplicate ID <" + r + ">");
			t[r] = e;
		}
	}, this.addWarning = function(e) {
		this.warnings.push(e);
	};
}
function Tj() {}
Tj.prototype.handleEnd = function() {}, Tj.prototype.handleText = function() {}, Tj.prototype.handleNode = function() {};
function Ej() {}
Ej.prototype = Object.create(Tj.prototype), Ej.prototype.handleNode = function() {
	return this;
};
function Dj() {}
Dj.prototype = Object.create(Tj.prototype), Dj.prototype.handleText = function(e) {
	this.body = (this.body || "") + e;
};
function Oj(e, t) {
	this.property = e, this.context = t;
}
Oj.prototype = Object.create(Dj.prototype), Oj.prototype.handleNode = function(e) {
	if (this.element) throw Sj("expected no sub nodes");
	return this.element = this.createReference(e), this;
}, Oj.prototype.handleEnd = function() {
	this.element.id = this.body;
}, Oj.prototype.createReference = function(e) {
	return {
		property: this.property.ns.name,
		id: ""
	};
};
function kj(e, t) {
	this.element = t, this.propertyDesc = e;
}
kj.prototype = Object.create(Dj.prototype), kj.prototype.handleEnd = function() {
	var e = this.body || "", t = this.element, n = this.propertyDesc;
	e = zA(n.type, e), n.isMany ? t.get(n.name).push(e) : t.set(n.name, e);
};
function Aj() {}
Aj.prototype = Object.create(Dj.prototype), Aj.prototype.handleNode = function(e) {
	var t = this, n = this.element;
	return n ? t = this.handleChild(e) : (n = this.element = this.createElement(e), this.context.addElement(n)), t;
};
function jj(e, t, n) {
	this.model = e, this.type = e.getType(t), this.context = n;
}
jj.prototype = Object.create(Aj.prototype), jj.prototype.addReference = function(e) {
	this.context.addReference(e);
}, jj.prototype.handleText = function(e) {
	var t = this.element;
	if (!Cj(t).bodyProperty) throw Sj("unexpected body text <" + e + ">");
	Dj.prototype.handleText.call(this, e);
}, jj.prototype.handleEnd = function() {
	var e = this.body, t = this.element, n = Cj(t).bodyProperty;
	n && e !== void 0 && (e = zA(n.type, e), t.set(n.name, e));
}, jj.prototype.createElement = function(e) {
	var t = e.attributes, n = this.type, r = Cj(n), i = this.context, a = new n({}), o = this.model, s;
	return X(t, function(e, t) {
		var n = r.propertiesByName[t], c;
		n && n.isReference ? n.isMany ? (c = e.split(" "), X(c, function(e) {
			i.addReference({
				element: a,
				property: n.ns.name,
				id: e
			});
		})) : i.addReference({
			element: a,
			property: n.ns.name,
			id: e
		}) : (n ? e = zA(n.type, e) : t === "xmlns" ? t = ":" + t : (s = HA(t, r.ns.prefix), o.getPackage(s.prefix) && i.addWarning({
			message: "unknown attribute <" + t + ">",
			element: a,
			property: t,
			value: e
		})), a.set(t, e));
	}), a;
}, jj.prototype.getPropertyForNode = function(e) {
	var t = e.name, n = HA(t), r = this.type, i = this.model, a = Cj(r), o = n.name, s = a.propertiesByName[o];
	if (s && !s.isAttr) {
		let t = _j(s);
		if (t) {
			let n = e.attributes[t];
			if (n) {
				let t = xj(n, e.ns, i), r = i.getType(t);
				return Z({}, s, { effectiveType: Cj(r).name });
			}
		}
		return s;
	}
	var c = i.getPackage(n.prefix);
	if (c) {
		let e = yj(n, c), t = i.getType(e);
		if (s = iT(a.properties, function(e) {
			return !e.isVirtual && !e.isReference && !e.isAttribute && t.hasType(e.type);
		}), s) return Z({}, s, { effectiveType: Cj(t).name });
	} else if (s = iT(a.properties, function(e) {
		return !e.isReference && !e.isAttribute && e.type === "Element";
	}), s) return s;
	throw Sj("unrecognized element <" + n.name + ">");
}, jj.prototype.toString = function() {
	return "ElementDescriptor[" + Cj(this.type).name + "]";
}, jj.prototype.valueHandler = function(e, t) {
	return new kj(e, t);
}, jj.prototype.referenceHandler = function(e) {
	return new Oj(e, this.context);
}, jj.prototype.handler = function(e) {
	return e === "Element" ? new Nj(this.model, e, this.context) : new jj(this.model, e, this.context);
}, jj.prototype.handleChild = function(e) {
	var t = this.getPropertyForNode(e), n, r = this.element, i;
	if (n = t.effectiveType || t.type, VA(n)) return this.valueHandler(t, r);
	i = t.isReference ? this.referenceHandler(t).handleNode(e) : this.handler(n).handleNode(e);
	var a = i.element;
	return a !== void 0 && (t.isMany ? r.get(t.name).push(a) : r.set(t.name, a), t.isReference ? (Z(a, { element: r }), this.context.addReference(a)) : a.$parent = r), i;
};
function Mj(e, t, n) {
	jj.call(this, e, t, n);
}
Mj.prototype = Object.create(jj.prototype), Mj.prototype.createElement = function(e) {
	var t = e.name, n = HA(t), r = this.model, i = this.type, a = r.getPackage(n.prefix), o = a && yj(n, a) || t;
	if (!i.hasType(o)) throw Sj("unexpected element <" + e.originalName + ">");
	return jj.prototype.createElement.call(this, e);
};
function Nj(e, t, n) {
	this.model = e, this.context = n;
}
Nj.prototype = Object.create(Aj.prototype), Nj.prototype.createElement = function(e) {
	var t = e.name, n = HA(t).prefix, r = e.ns[n + "$uri"], i = e.attributes;
	return this.model.createAny(t, r, i);
}, Nj.prototype.handleChild = function(e) {
	var t = new Nj(this.model, "Element", this.context).handleNode(e), n = this.element, r = t.element, i;
	return r !== void 0 && (i = n.$children = n.$children || [], i.push(r), r.$parent = n), t;
}, Nj.prototype.handleEnd = function() {
	this.body && (this.element.$body = this.body);
};
function Pj(e) {
	e instanceof XA && (e = { model: e }), Z(this, { lax: !1 }, e);
}
Pj.prototype.fromXML = function(e, t, n) {
	var r = t.rootHandler;
	t instanceof jj ? (r = t, t = {}) : typeof t == "string" ? (r = this.handler(t), t = {}) : typeof r == "string" && (r = this.handler(r));
	var i = this.model, a = this.lax, o = new wj(Z({}, t, { rootHandler: r })), s = new fj({ proxy: !0 }), c = Fj();
	r.context = o, c.push(r);
	function l(e, t, n) {
		var r = t(), i = r.line, a = r.column, s = r.data;
		s.charAt(0) === "<" && s.indexOf(" ") !== -1 && (s = s.slice(0, s.indexOf(" ")) + ">");
		var c = "unparsable content " + (s ? s + " " : "") + "detected\n	line: " + i + "\n	column: " + a + "\n	nested error: " + e.message;
		if (n) return o.addWarning({
			message: c,
			error: e
		}), !0;
		throw Sj(c);
	}
	function u(e, t) {
		return l(e, t, !0);
	}
	function d() {
		var e = o.elementsById, t = o.references, n, r;
		for (n = 0; r = t[n]; n++) {
			var i = r.element, a = e[r.id], s = Cj(i).propertiesByName[r.property];
			if (a || o.addWarning({
				message: "unresolved reference <" + r.id + ">",
				element: r.element,
				property: r.property,
				value: r.id
			}), s.isMany) {
				var c = i.get(s.name), l = c.indexOf(r);
				l === -1 && (l = c.length), a ? c[l] = a : c.splice(l, 1);
			} else i.set(s.name, a);
		}
	}
	function f() {
		c.pop().handleEnd();
	}
	var p = /^<\?xml /i, m = / encoding="([^"]+)"/i, h = /^utf-8$/i;
	function g(e) {
		if (p.test(e)) {
			var t = m.exec(e), n = t && t[1];
			!n || h.test(n) || o.addWarning({ message: "unsupported document encoding <" + n + ">, falling back to UTF-8" });
		}
	}
	function _(e, t) {
		var n = c.peek();
		try {
			c.push(n.handleNode(e));
		} catch (e) {
			l(e, t, a) && c.push(new Ej());
		}
	}
	function v(e, t) {
		try {
			c.peek().handleText(e);
		} catch (e) {
			u(e, t);
		}
	}
	function y(e, t) {
		e.trim() && v(e, t);
	}
	var b = i.getPackages().reduce(function(e, t) {
		return e[t.uri] = t.prefix, e;
	}, Object.entries(mj).reduce(function(e, [t, n]) {
		return e[n] = t, e;
	}, i.config && i.config.nsMap || {}));
	return s.ns(b).on("openTag", function(e, t, n, r) {
		var i = e.attrs || {}, a = Object.keys(i).reduce(function(e, n) {
			return e[n] = t(i[n]), e;
		}, {});
		_({
			name: e.name,
			originalName: e.originalName,
			attributes: a,
			ns: e.ns
		}, r);
	}).on("question", g).on("closeTag", f).on("cdata", v).on("text", function(e, t, n) {
		y(t(e), n);
	}).on("error", l).on("warn", u), new Promise(function(t, n) {
		var i;
		try {
			s.parse(e), d();
		} catch (e) {
			i = e;
		}
		var a = r.element;
		!i && !a && (i = Sj("failed to parse document as <" + r.type.$descriptor.name + ">"));
		var c = o.warnings, l = o.references, u = o.elementsById;
		return i ? (i.warnings = c, n(i)) : t({
			rootElement: a,
			elementsById: u,
			references: l,
			warnings: c
		});
	});
}, Pj.prototype.handler = function(e) {
	return new Mj(this.model, e);
};
function Fj() {
	var e = [];
	return Object.defineProperty(e, "peek", { value: function() {
		return this[this.length - 1];
	} }), e;
}
var Ij = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n", Lj = /<|>|'|"|&|\n\r|\n/g, Rj = /<|>|&/g;
function zj(e) {
	this.prefixMap = {}, this.uriMap = {}, this.used = {}, this.wellknown = [], this.custom = [], this.parent = e, this.defaultPrefixMap = e && e.defaultPrefixMap || {};
}
zj.prototype.mapDefaultPrefixes = function(e) {
	this.defaultPrefixMap = e;
}, zj.prototype.defaultUriByPrefix = function(e) {
	return this.defaultPrefixMap[e];
}, zj.prototype.byUri = function(e) {
	return this.uriMap[e] || this.parent && this.parent.byUri(e);
}, zj.prototype.add = function(e, t) {
	this.uriMap[e.uri] = e, t ? this.wellknown.push(e) : this.custom.push(e), this.mapPrefix(e.prefix, e.uri);
}, zj.prototype.uriByPrefix = function(e) {
	return this.prefixMap[e || "xmlns"] || this.parent && this.parent.uriByPrefix(e);
}, zj.prototype.mapPrefix = function(e, t) {
	this.prefixMap[e || "xmlns"] = t;
}, zj.prototype.getNSKey = function(e) {
	return e.prefix === void 0 ? e.uri : e.uri + "|" + e.prefix;
}, zj.prototype.logUsed = function(e) {
	var t = e.uri, n = this.getNSKey(e);
	this.used[n] = this.byUri(t), this.parent && this.parent.logUsed(e);
}, zj.prototype.getUsed = function(e) {
	return [].concat(this.wellknown, this.custom).filter((e) => {
		var t = this.getNSKey(e);
		return this.used[t];
	});
};
function Bj(e) {
	return e.charAt(0).toLowerCase() + e.slice(1);
}
function Vj(e, t) {
	return pj(t) ? Bj(e) : e;
}
function Hj(e, t) {
	e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} });
}
function Uj(e) {
	return nT(e) ? e : (e.prefix ? e.prefix + ":" : "") + e.localName;
}
function Wj(e) {
	return e.getUsed().filter(function(e) {
		return e.prefix !== "xml";
	}).map(function(e) {
		return {
			name: "xmlns" + (e.prefix ? ":" + e.prefix : ""),
			value: e.uri
		};
	});
}
function Gj(e, t) {
	return t.isGeneric ? Z({ localName: t.ns.localName }, e) : Z({ localName: Vj(t.ns.localName, t.$pkg) }, e);
}
function Kj(e, t) {
	return Z({ localName: t.ns.localName }, e);
}
function qj(e) {
	var t = e.$descriptor;
	return oT(t.properties, function(t) {
		var n = t.name;
		if (t.isVirtual || !rT(e, n)) return !1;
		var r = e[n];
		return r === t.default || r === null ? !1 : t.isMany ? r.length : !0;
	});
}
var Jj = {
	"\n": "#10",
	"\n\r": "#10",
	"\"": "#34",
	"'": "#39",
	"<": "#60",
	">": "#62",
	"&": "#38"
}, Yj = {
	"<": "lt",
	">": "gt",
	"&": "amp"
};
function Xj(e, t, n) {
	return e = nT(e) ? e : "" + e, e.replace(t, function(e) {
		return "&" + n[e] + ";";
	});
}
function Zj(e) {
	return Xj(e, Lj, Jj);
}
function Qj(e) {
	return Xj(e, Rj, Yj);
}
function $j(e) {
	return oT(e, function(e) {
		return e.isAttr;
	});
}
function eM(e) {
	return oT(e, function(e) {
		return !e.isAttr;
	});
}
function tM(e) {
	this.tagName = e;
}
tM.prototype.build = function(e) {
	return this.element = e, this;
}, tM.prototype.serializeTo = function(e) {
	e.appendIndent().append("<" + this.tagName + ">" + this.element.id + "</" + this.tagName + ">").appendNewLine();
};
function nM() {}
nM.prototype.serializeValue = nM.prototype.serializeTo = function(e) {
	e.append(this.escape ? Qj(this.value) : this.value);
}, nM.prototype.build = function(e, t) {
	return this.value = t, e.type === "String" && t.search(Rj) !== -1 && (this.escape = !0), this;
};
function rM(e) {
	this.tagName = e;
}
Hj(rM, nM), rM.prototype.serializeTo = function(e) {
	e.appendIndent().append("<" + this.tagName + ">"), this.serializeValue(e), e.append("</" + this.tagName + ">").appendNewLine();
};
function iM(e, t) {
	this.body = [], this.attrs = [], this.parent = e, this.propertyDescriptor = t;
}
iM.prototype.build = function(e) {
	this.element = e;
	var t = e.$descriptor, n = this.propertyDescriptor, r, i, a = t.isGeneric;
	return r = a ? this.parseGenericNsAttributes(e) : this.parseNsAttributes(e), n ? this.ns = this.nsPropertyTagName(n) : this.ns = this.nsTagName(t), this.tagName = this.addTagName(this.ns), a ? this.parseGenericContainments(e) : (i = qj(e), this.parseAttributes($j(i)), this.parseContainments(eM(i))), this.parseGenericAttributes(e, r), this;
}, iM.prototype.nsTagName = function(e) {
	return Gj(this.logNamespaceUsed(e.ns), e);
}, iM.prototype.nsPropertyTagName = function(e) {
	return Kj(this.logNamespaceUsed(e.ns), e);
}, iM.prototype.isLocalNs = function(e) {
	return e.uri === this.ns.uri;
}, iM.prototype.nsAttributeName = function(e) {
	var t = nT(e) ? HA(e) : e.ns;
	if (e.inherited) return { localName: t.localName };
	var n = this.logNamespaceUsed(t);
	return this.getNamespaces().logUsed(n), this.isLocalNs(n) ? { localName: t.localName } : Z({ localName: t.localName }, n);
}, iM.prototype.parseGenericNsAttributes = function(e) {
	return Object.entries(e).filter(([t, n]) => !t.startsWith("$") && this.parseNsAttribute(e, t, n)).map(([e, t]) => ({
		name: e,
		value: t
	}));
}, iM.prototype.parseGenericContainments = function(e) {
	var t = e.$body;
	t && this.body.push(new nM().build({ type: "String" }, t));
	var n = e.$children;
	n && X(n, (e) => {
		this.body.push(new iM(this).build(e));
	});
}, iM.prototype.parseNsAttribute = function(e, t, n) {
	var r = e.$model, i = HA(t), a;
	if (i.prefix === "xmlns" && (a = {
		prefix: i.localName,
		uri: n
	}), !i.prefix && i.localName === "xmlns" && (a = { uri: n }), !a) return {
		name: t,
		value: n
	};
	if (r && r.getPackage(n)) this.logNamespace(a, !0, !0);
	else {
		var o = this.logNamespaceUsed(a, !0);
		this.getNamespaces().logUsed(o);
	}
}, iM.prototype.parseNsAttributes = function(e) {
	var t = this, n = e.$attrs, r = [];
	return X(n, function(n, i) {
		var a = t.parseNsAttribute(e, i, n);
		a && r.push(a);
	}), r;
}, iM.prototype.parseGenericAttributes = function(e, t) {
	var n = this;
	X(t, function(t) {
		try {
			n.addAttribute(n.nsAttributeName(t.name), t.value);
		} catch (n) {
			typeof console < "u" && console.warn(`missing namespace information for <${t.name}=${t.value}> on`, e, n);
		}
	});
}, iM.prototype.parseContainments = function(e) {
	var t = this, n = this.body, r = this.element;
	X(e, function(e) {
		var i = r.get(e.name), a = e.isReference;
		if (e.isMany || (i = [i]), e.isBody) n.push(new nM().build(e, i[0]));
		else if (VA(e.type)) X(i, function(r) {
			n.push(new rM(t.addTagName(t.nsPropertyTagName(e))).build(e, r));
		});
		else if (a) X(i, function(r) {
			n.push(new tM(t.addTagName(t.nsPropertyTagName(e))).build(r));
		});
		else {
			var o = gj(e);
			X(i, function(r) {
				var i = o ? o === hj ? new iM(t, e) : new aM(t, e, o) : new iM(t);
				n.push(i.build(r));
			});
		}
	});
}, iM.prototype.getNamespaces = function(e) {
	var t = this.namespaces, n = this.parent, r;
	return t || (r = n && n.getNamespaces(), e || !r ? this.namespaces = t = new zj(r) : t = r), t;
}, iM.prototype.logNamespace = function(e, t, n) {
	var r = this.getNamespaces(n), i = e.uri, a = e.prefix;
	return (!r.byUri(i) || n) && r.add(e, t), r.mapPrefix(a, i), e;
}, iM.prototype.logNamespaceUsed = function(e, t) {
	var n = this.getNamespaces(t), r = e.prefix, i = e.uri, a, o, s;
	if (!r && !i) return { localName: e.localName };
	if (s = n.defaultUriByPrefix(r), i = i || s || n.uriByPrefix(r), !i) throw Error("no namespace uri given for prefix <" + r + ">");
	if (e = n.byUri(i), !e && !r && (e = this.logNamespace({ uri: i }, s === i, !0)), !e) {
		for (a = r, o = 1; n.uriByPrefix(a);) a = r + "_" + o++;
		e = this.logNamespace({
			prefix: a,
			uri: i
		}, s === i);
	}
	return r && n.mapPrefix(r, i), e;
}, iM.prototype.parseAttributes = function(e) {
	var t = this, n = this.element;
	X(e, function(e) {
		var r = n.get(e.name);
		if (e.isReference) if (!e.isMany) r = r.id;
		else {
			var i = [];
			X(r, function(e) {
				i.push(e.id);
			}), r = i.join(" ");
		}
		t.addAttribute(t.nsAttributeName(e), r);
	});
}, iM.prototype.addTagName = function(e) {
	var t = this.logNamespaceUsed(e);
	return this.getNamespaces().logUsed(t), Uj(e);
}, iM.prototype.addAttribute = function(e, t) {
	var n = this.attrs;
	nT(t) && (t = Zj(t));
	var r = aT(n, function(t) {
		return t.name.localName === e.localName && t.name.uri === e.uri && t.name.prefix === e.prefix;
	}), i = {
		name: e,
		value: t
	};
	r === -1 ? n.push(i) : n.splice(r, 1, i);
}, iM.prototype.serializeAttributes = function(e) {
	var t = this.attrs, n = this.namespaces;
	n && (t = Wj(n).concat(t)), X(t, function(t) {
		e.append(" ").append(Uj(t.name)).append("=\"").append(t.value).append("\"");
	});
}, iM.prototype.serializeTo = function(e) {
	var t = this.body[0], n = t && t.constructor !== nM;
	e.appendIndent().append("<" + this.tagName), this.serializeAttributes(e), e.append(t ? ">" : " />"), t && (n && e.appendNewLine().indent(), X(this.body, function(t) {
		t.serializeTo(e);
	}), n && e.unindent().appendIndent(), e.append("</" + this.tagName + ">")), e.appendNewLine();
};
function aM(e, t, n) {
	iM.call(this, e, t), this.serialization = n;
}
Hj(aM, iM), aM.prototype.parseNsAttributes = function(e) {
	var t = iM.prototype.parseNsAttributes.call(this, e).filter((e) => e.name !== this.serialization), n = e.$descriptor;
	if (n.name === this.propertyDescriptor.type) return t;
	var r = this.typeNs = this.nsTagName(n);
	this.getNamespaces().logUsed(this.typeNs);
	var i = e.$model.getPackage(r.uri), a = i.xml && i.xml.typePrefix || "";
	return this.addAttribute(this.nsAttributeName(this.serialization), (r.prefix ? r.prefix + ":" : "") + a + n.ns.localName), t;
}, aM.prototype.isLocalNs = function(e) {
	return e.uri === (this.typeNs || this.ns).uri;
};
function oM() {
	this.value = "", this.write = function(e) {
		this.value += e;
	};
}
function sM(e, t) {
	var n = [""];
	this.append = function(t) {
		return e.write(t), this;
	}, this.appendNewLine = function() {
		return t && e.write("\n"), this;
	}, this.appendIndent = function() {
		return t && e.write(n.join("  ")), this;
	}, this.indent = function() {
		return n.push(""), this;
	}, this.unindent = function() {
		return n.pop(), this;
	};
}
function cM(e) {
	e = Z({
		format: !1,
		preamble: !0
	}, e || {});
	function t(t, n) {
		var r = n || new oM(), i = new sM(r, e.format);
		e.preamble && i.append(Ij);
		var a = new iM(), o = t.$model;
		if (a.getNamespaces().mapDefaultPrefixes(lM(o)), a.build(t).serializeTo(i), !n) return r.value;
	}
	return { toXML: t };
}
function lM(e) {
	let t = e.config && e.config.nsMap || {}, n = {};
	for (let e in mj) n[e] = mj[e];
	for (let e in t) {
		let r = t[e];
		n[r] = e;
	}
	for (let t of e.getPackages()) n[t.prefix] = t.uri;
	return n;
}
//#endregion
//#region ../../../node_modules/bpmn-moddle/dist/index.js
function uM(e, t) {
	XA.call(this, e, t);
}
uM.prototype = Object.create(XA.prototype), uM.prototype.fromXML = function(e, t, n) {
	nT(t) || (n = t, t = "bpmn:Definitions");
	var r = new Pj(Z({
		model: this,
		lax: !0
	}, n)), i = r.handler(t);
	return r.fromXML(e, i);
}, uM.prototype.toXML = function(e, t) {
	var n = new cM(t);
	return new Promise(function(t, r) {
		try {
			return t({ xml: n.toXML(e) });
		} catch (e) {
			return r(e);
		}
	});
};
var dM = {
	bpmn: {
		name: "BPMN20",
		uri: "http://www.omg.org/spec/BPMN/20100524/MODEL",
		prefix: "bpmn",
		associations: [],
		types: [
			{
				name: "Interface",
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "operations",
						type: "Operation",
						isMany: !0
					},
					{
						name: "implementationRef",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "Operation",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "inMessageRef",
						type: "Message",
						isReference: !0
					},
					{
						name: "outMessageRef",
						type: "Message",
						isReference: !0
					},
					{
						name: "errorRef",
						type: "Error",
						isMany: !0,
						isReference: !0
					},
					{
						name: "implementationRef",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "EndPoint",
				superClass: ["RootElement"]
			},
			{
				name: "Auditing",
				superClass: ["BaseElement"]
			},
			{
				name: "GlobalTask",
				superClass: ["CallableElement"],
				properties: [{
					name: "resources",
					type: "ResourceRole",
					isMany: !0
				}]
			},
			{
				name: "Monitoring",
				superClass: ["BaseElement"]
			},
			{
				name: "Performer",
				superClass: ["ResourceRole"]
			},
			{
				name: "Process",
				superClass: ["FlowElementsContainer", "CallableElement"],
				properties: [
					{
						name: "processType",
						type: "ProcessType",
						isAttr: !0
					},
					{
						name: "isClosed",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "auditing",
						type: "Auditing"
					},
					{
						name: "monitoring",
						type: "Monitoring"
					},
					{
						name: "properties",
						type: "Property",
						isMany: !0
					},
					{
						name: "laneSets",
						isMany: !0,
						replaces: "FlowElementsContainer#laneSets",
						type: "LaneSet"
					},
					{
						name: "flowElements",
						isMany: !0,
						replaces: "FlowElementsContainer#flowElements",
						type: "FlowElement"
					},
					{
						name: "artifacts",
						type: "Artifact",
						isMany: !0
					},
					{
						name: "resources",
						type: "ResourceRole",
						isMany: !0
					},
					{
						name: "correlationSubscriptions",
						type: "CorrelationSubscription",
						isMany: !0
					},
					{
						name: "supports",
						type: "Process",
						isMany: !0,
						isReference: !0
					},
					{
						name: "definitionalCollaborationRef",
						type: "Collaboration",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "isExecutable",
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "LaneSet",
				superClass: ["BaseElement"],
				properties: [{
					name: "lanes",
					type: "Lane",
					isMany: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Lane",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "partitionElementRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "partitionElement",
						type: "BaseElement"
					},
					{
						name: "flowNodeRef",
						type: "FlowNode",
						isMany: !0,
						isReference: !0
					},
					{
						name: "childLaneSet",
						type: "LaneSet",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "GlobalManualTask",
				superClass: ["GlobalTask"]
			},
			{
				name: "ManualTask",
				superClass: ["Task"]
			},
			{
				name: "UserTask",
				superClass: ["Task"],
				properties: [{
					name: "renderings",
					type: "Rendering",
					isMany: !0
				}, {
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Rendering",
				superClass: ["BaseElement"]
			},
			{
				name: "HumanPerformer",
				superClass: ["Performer"]
			},
			{
				name: "PotentialOwner",
				superClass: ["HumanPerformer"]
			},
			{
				name: "GlobalUserTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}, {
					name: "renderings",
					type: "Rendering",
					isMany: !0
				}]
			},
			{
				name: "Gateway",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [{
					name: "gatewayDirection",
					type: "GatewayDirection",
					default: "Unspecified",
					isAttr: !0
				}]
			},
			{
				name: "EventBasedGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "instantiate",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "eventGatewayType",
					type: "EventBasedGatewayType",
					isAttr: !0,
					default: "Exclusive"
				}]
			},
			{
				name: "ComplexGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "activationCondition",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ExclusiveGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "InclusiveGateway",
				superClass: ["Gateway"],
				properties: [{
					name: "default",
					type: "SequenceFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ParallelGateway",
				superClass: ["Gateway"]
			},
			{
				name: "RootElement",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "Relationship",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "type",
						isAttr: !0,
						type: "String"
					},
					{
						name: "direction",
						type: "RelationshipDirection",
						isAttr: !0
					},
					{
						name: "source",
						isMany: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "target",
						isMany: !0,
						isReference: !0,
						type: "Element"
					}
				]
			},
			{
				name: "BaseElement",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						type: "String",
						isId: !0
					},
					{
						name: "documentation",
						type: "Documentation",
						isMany: !0
					},
					{
						name: "extensionDefinitions",
						type: "ExtensionDefinition",
						isMany: !0,
						isReference: !0
					},
					{
						name: "extensionElements",
						type: "ExtensionElements"
					}
				]
			},
			{
				name: "Extension",
				properties: [{
					name: "mustUnderstand",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "definition",
					type: "ExtensionDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ExtensionDefinition",
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "extensionAttributeDefinitions",
					type: "ExtensionAttributeDefinition",
					isMany: !0
				}]
			},
			{
				name: "ExtensionAttributeDefinition",
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "type",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isReference",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "extensionDefinition",
						type: "ExtensionDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ExtensionElements",
				properties: [
					{
						name: "valueRef",
						isAttr: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "values",
						type: "Element",
						isMany: !0
					},
					{
						name: "extensionAttributeDefinition",
						type: "ExtensionAttributeDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Documentation",
				superClass: ["BaseElement"],
				properties: [{
					name: "text",
					type: "String",
					isBody: !0
				}, {
					name: "textFormat",
					default: "text/plain",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Event",
				isAbstract: !0,
				superClass: ["FlowNode", "InteractionNode"],
				properties: [{
					name: "properties",
					type: "Property",
					isMany: !0
				}]
			},
			{
				name: "IntermediateCatchEvent",
				superClass: ["CatchEvent"]
			},
			{
				name: "IntermediateThrowEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "EndEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "StartEvent",
				superClass: ["CatchEvent"],
				properties: [{
					name: "isInterrupting",
					default: !0,
					isAttr: !0,
					type: "Boolean"
				}]
			},
			{
				name: "ThrowEvent",
				isAbstract: !0,
				superClass: ["Event"],
				properties: [
					{
						name: "dataInputs",
						type: "DataInput",
						isMany: !0
					},
					{
						name: "dataInputAssociations",
						type: "DataInputAssociation",
						isMany: !0
					},
					{
						name: "inputSet",
						type: "InputSet"
					},
					{
						name: "eventDefinitions",
						type: "EventDefinition",
						isMany: !0
					},
					{
						name: "eventDefinitionRef",
						type: "EventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CatchEvent",
				isAbstract: !0,
				superClass: ["Event"],
				properties: [
					{
						name: "parallelMultiple",
						isAttr: !0,
						type: "Boolean",
						default: !1
					},
					{
						name: "dataOutputs",
						type: "DataOutput",
						isMany: !0
					},
					{
						name: "dataOutputAssociations",
						type: "DataOutputAssociation",
						isMany: !0
					},
					{
						name: "outputSet",
						type: "OutputSet"
					},
					{
						name: "eventDefinitions",
						type: "EventDefinition",
						isMany: !0
					},
					{
						name: "eventDefinitionRef",
						type: "EventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "BoundaryEvent",
				superClass: ["CatchEvent"],
				properties: [{
					name: "cancelActivity",
					default: !0,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "attachedToRef",
					type: "Activity",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "EventDefinition",
				isAbstract: !0,
				superClass: ["RootElement"]
			},
			{
				name: "CancelEventDefinition",
				superClass: ["EventDefinition"]
			},
			{
				name: "ErrorEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "errorRef",
					type: "Error",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TerminateEventDefinition",
				superClass: ["EventDefinition"]
			},
			{
				name: "EscalationEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "escalationRef",
					type: "Escalation",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Escalation",
				properties: [
					{
						name: "structureRef",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "escalationCode",
						isAttr: !0,
						type: "String"
					}
				],
				superClass: ["RootElement"]
			},
			{
				name: "CompensateEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "waitForCompletion",
					isAttr: !0,
					type: "Boolean",
					default: !0
				}, {
					name: "activityRef",
					type: "Activity",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TimerEventDefinition",
				superClass: ["EventDefinition"],
				properties: [
					{
						name: "timeDate",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "timeCycle",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "timeDuration",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "LinkEventDefinition",
				superClass: ["EventDefinition"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "target",
						type: "LinkEventDefinition",
						isReference: !0
					},
					{
						name: "source",
						type: "LinkEventDefinition",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "MessageEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "messageRef",
					type: "Message",
					isAttr: !0,
					isReference: !0
				}, {
					name: "operationRef",
					type: "Operation",
					isReference: !0
				}]
			},
			{
				name: "ConditionalEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "condition",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}]
			},
			{
				name: "SignalEventDefinition",
				superClass: ["EventDefinition"],
				properties: [{
					name: "signalRef",
					type: "Signal",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Signal",
				superClass: ["RootElement"],
				properties: [{
					name: "structureRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ImplicitThrowEvent",
				superClass: ["ThrowEvent"]
			},
			{
				name: "DataState",
				superClass: ["BaseElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ItemAwareElement",
				superClass: ["BaseElement"],
				properties: [{
					name: "itemSubjectRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}, {
					name: "dataState",
					type: "DataState"
				}]
			},
			{
				name: "DataAssociation",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "sourceRef",
						type: "ItemAwareElement",
						isMany: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "transformation",
						type: "FormalExpression",
						xml: { serialize: "property" }
					},
					{
						name: "assignment",
						type: "Assignment",
						isMany: !0
					}
				]
			},
			{
				name: "DataInput",
				superClass: ["ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "inputSetRef",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "inputSetWithOptional",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "inputSetWithWhileExecuting",
						type: "InputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "DataOutput",
				superClass: ["ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "outputSetRef",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "outputSetWithOptional",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "outputSetWithWhileExecuting",
						type: "OutputSet",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "InputSet",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "dataInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "optionalInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "whileExecutingInputRefs",
						type: "DataInput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "outputSetRefs",
						type: "OutputSet",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "OutputSet",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "dataOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "inputSetRefs",
						type: "InputSet",
						isMany: !0,
						isReference: !0
					},
					{
						name: "optionalOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					},
					{
						name: "whileExecutingOutputRefs",
						type: "DataOutput",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Property",
				superClass: ["ItemAwareElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "DataInputAssociation",
				superClass: ["DataAssociation"]
			},
			{
				name: "DataOutputAssociation",
				superClass: ["DataAssociation"]
			},
			{
				name: "InputOutputSpecification",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "dataInputs",
						type: "DataInput",
						isMany: !0
					},
					{
						name: "dataOutputs",
						type: "DataOutput",
						isMany: !0
					},
					{
						name: "inputSets",
						type: "InputSet",
						isMany: !0
					},
					{
						name: "outputSets",
						type: "OutputSet",
						isMany: !0
					}
				]
			},
			{
				name: "DataObject",
				superClass: ["FlowElement", "ItemAwareElement"],
				properties: [{
					name: "isCollection",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}]
			},
			{
				name: "InputOutputBinding",
				properties: [
					{
						name: "inputDataRef",
						type: "InputSet",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "outputDataRef",
						type: "OutputSet",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Assignment",
				superClass: ["BaseElement"],
				properties: [{
					name: "from",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "to",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}]
			},
			{
				name: "DataStore",
				superClass: ["RootElement", "ItemAwareElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "capacity",
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "isUnlimited",
						default: !0,
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "DataStoreReference",
				superClass: ["ItemAwareElement", "FlowElement"],
				properties: [{
					name: "dataStoreRef",
					type: "DataStore",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "DataObjectReference",
				superClass: ["ItemAwareElement", "FlowElement"],
				properties: [{
					name: "dataObjectRef",
					type: "DataObject",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ConversationLink",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "sourceRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "ConversationAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerConversationNodeRef",
					type: "ConversationNode",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerConversationNodeRef",
					type: "ConversationNode",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "CallConversation",
				superClass: ["ConversationNode"],
				properties: [{
					name: "calledCollaborationRef",
					type: "Collaboration",
					isAttr: !0,
					isReference: !0
				}, {
					name: "participantAssociations",
					type: "ParticipantAssociation",
					isMany: !0
				}]
			},
			{
				name: "Conversation",
				superClass: ["ConversationNode"]
			},
			{
				name: "SubConversation",
				superClass: ["ConversationNode"],
				properties: [{
					name: "conversationNodes",
					type: "ConversationNode",
					isMany: !0
				}]
			},
			{
				name: "ConversationNode",
				isAbstract: !0,
				superClass: ["InteractionNode", "BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "participantRef",
						type: "Participant",
						isMany: !0,
						isReference: !0
					},
					{
						name: "messageFlowRefs",
						type: "MessageFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					}
				]
			},
			{
				name: "GlobalConversation",
				superClass: ["Collaboration"]
			},
			{
				name: "PartnerEntity",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "participantRef",
					type: "Participant",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "PartnerRole",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "participantRef",
					type: "Participant",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "CorrelationProperty",
				superClass: ["RootElement"],
				properties: [
					{
						name: "correlationPropertyRetrievalExpression",
						type: "CorrelationPropertyRetrievalExpression",
						isMany: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "type",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Error",
				superClass: ["RootElement"],
				properties: [
					{
						name: "structureRef",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "errorCode",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "CorrelationKey",
				superClass: ["BaseElement"],
				properties: [{
					name: "correlationPropertyRef",
					type: "CorrelationProperty",
					isMany: !0,
					isReference: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Expression",
				superClass: ["BaseElement"],
				isAbstract: !1,
				properties: [{
					name: "body",
					isBody: !0,
					type: "String"
				}]
			},
			{
				name: "FormalExpression",
				superClass: ["Expression"],
				properties: [{
					name: "language",
					isAttr: !0,
					type: "String"
				}, {
					name: "evaluatesToTypeRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Message",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "itemRef",
					type: "ItemDefinition",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ItemDefinition",
				superClass: ["RootElement"],
				properties: [
					{
						name: "itemKind",
						type: "ItemKind",
						isAttr: !0
					},
					{
						name: "structureRef",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isCollection",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "import",
						type: "Import",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "FlowElement",
				isAbstract: !0,
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "auditing",
						type: "Auditing"
					},
					{
						name: "monitoring",
						type: "Monitoring"
					},
					{
						name: "categoryValueRef",
						type: "CategoryValue",
						isMany: !0,
						isReference: !0
					}
				]
			},
			{
				name: "SequenceFlow",
				superClass: ["FlowElement"],
				properties: [
					{
						name: "isImmediate",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "conditionExpression",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "sourceRef",
						type: "FlowNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "FlowNode",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "FlowElementsContainer",
				isAbstract: !0,
				superClass: ["BaseElement"],
				properties: [{
					name: "laneSets",
					type: "LaneSet",
					isMany: !0
				}, {
					name: "flowElements",
					type: "FlowElement",
					isMany: !0
				}]
			},
			{
				name: "CallableElement",
				isAbstract: !0,
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "ioSpecification",
						type: "InputOutputSpecification",
						xml: { serialize: "property" }
					},
					{
						name: "supportedInterfaceRef",
						type: "Interface",
						isMany: !0,
						isReference: !0
					},
					{
						name: "ioBinding",
						type: "InputOutputBinding",
						isMany: !0,
						xml: { serialize: "property" }
					}
				]
			},
			{
				name: "FlowNode",
				isAbstract: !0,
				superClass: ["FlowElement"],
				properties: [
					{
						name: "incoming",
						type: "SequenceFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "outgoing",
						type: "SequenceFlow",
						isMany: !0,
						isReference: !0
					},
					{
						name: "lanes",
						type: "Lane",
						isMany: !0,
						isVirtual: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CorrelationPropertyRetrievalExpression",
				superClass: ["BaseElement"],
				properties: [{
					name: "messagePath",
					type: "FormalExpression"
				}, {
					name: "messageRef",
					type: "Message",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "CorrelationPropertyBinding",
				superClass: ["BaseElement"],
				properties: [{
					name: "dataPath",
					type: "FormalExpression"
				}, {
					name: "correlationPropertyRef",
					type: "CorrelationProperty",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Resource",
				superClass: ["RootElement"],
				properties: [{
					name: "name",
					isAttr: !0,
					type: "String"
				}, {
					name: "resourceParameters",
					type: "ResourceParameter",
					isMany: !0
				}]
			},
			{
				name: "ResourceParameter",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isRequired",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "type",
						type: "ItemDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "CorrelationSubscription",
				superClass: ["BaseElement"],
				properties: [{
					name: "correlationKeyRef",
					type: "CorrelationKey",
					isAttr: !0,
					isReference: !0
				}, {
					name: "correlationPropertyBinding",
					type: "CorrelationPropertyBinding",
					isMany: !0
				}]
			},
			{
				name: "MessageFlow",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "sourceRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "InteractionNode",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "MessageFlowAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerMessageFlowRef",
					type: "MessageFlow",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerMessageFlowRef",
					type: "MessageFlow",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "InteractionNode",
				isAbstract: !0,
				properties: [{
					name: "incomingConversationLinks",
					type: "ConversationLink",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}, {
					name: "outgoingConversationLinks",
					type: "ConversationLink",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}]
			},
			{
				name: "Participant",
				superClass: ["InteractionNode", "BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "interfaceRef",
						type: "Interface",
						isMany: !0,
						isReference: !0
					},
					{
						name: "participantMultiplicity",
						type: "ParticipantMultiplicity"
					},
					{
						name: "endPointRefs",
						type: "EndPoint",
						isMany: !0,
						isReference: !0
					},
					{
						name: "processRef",
						type: "Process",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ParticipantAssociation",
				superClass: ["BaseElement"],
				properties: [{
					name: "innerParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}, {
					name: "outerParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "ParticipantMultiplicity",
				properties: [{
					name: "minimum",
					default: 0,
					isAttr: !0,
					type: "Integer"
				}, {
					name: "maximum",
					default: 1,
					isAttr: !0,
					type: "Integer"
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "Collaboration",
				superClass: ["RootElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "isClosed",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "participants",
						type: "Participant",
						isMany: !0
					},
					{
						name: "messageFlows",
						type: "MessageFlow",
						isMany: !0
					},
					{
						name: "artifacts",
						type: "Artifact",
						isMany: !0
					},
					{
						name: "conversations",
						type: "ConversationNode",
						isMany: !0
					},
					{
						name: "conversationAssociations",
						type: "ConversationAssociation"
					},
					{
						name: "participantAssociations",
						type: "ParticipantAssociation",
						isMany: !0
					},
					{
						name: "messageFlowAssociations",
						type: "MessageFlowAssociation",
						isMany: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					},
					{
						name: "choreographyRef",
						type: "Choreography",
						isMany: !0,
						isReference: !0
					},
					{
						name: "conversationLinks",
						type: "ConversationLink",
						isMany: !0
					}
				]
			},
			{
				name: "ChoreographyActivity",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [
					{
						name: "participantRef",
						type: "Participant",
						isMany: !0,
						isReference: !0
					},
					{
						name: "initiatingParticipantRef",
						type: "Participant",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "correlationKeys",
						type: "CorrelationKey",
						isMany: !0
					},
					{
						name: "loopType",
						type: "ChoreographyLoopType",
						default: "None",
						isAttr: !0
					}
				]
			},
			{
				name: "CallChoreography",
				superClass: ["ChoreographyActivity"],
				properties: [{
					name: "calledChoreographyRef",
					type: "Choreography",
					isAttr: !0,
					isReference: !0
				}, {
					name: "participantAssociations",
					type: "ParticipantAssociation",
					isMany: !0
				}]
			},
			{
				name: "SubChoreography",
				superClass: ["ChoreographyActivity", "FlowElementsContainer"],
				properties: [{
					name: "artifacts",
					type: "Artifact",
					isMany: !0
				}]
			},
			{
				name: "ChoreographyTask",
				superClass: ["ChoreographyActivity"],
				properties: [{
					name: "messageFlowRef",
					type: "MessageFlow",
					isMany: !0,
					isReference: !0
				}]
			},
			{
				name: "Choreography",
				superClass: ["Collaboration", "FlowElementsContainer"]
			},
			{
				name: "GlobalChoreographyTask",
				superClass: ["Choreography"],
				properties: [{
					name: "initiatingParticipantRef",
					type: "Participant",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "TextAnnotation",
				superClass: ["Artifact"],
				properties: [{
					name: "text",
					type: "String"
				}, {
					name: "textFormat",
					default: "text/plain",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Group",
				superClass: ["Artifact"],
				properties: [{
					name: "categoryValueRef",
					type: "CategoryValue",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "Association",
				superClass: ["Artifact"],
				properties: [
					{
						name: "associationDirection",
						type: "AssociationDirection",
						isAttr: !0
					},
					{
						name: "sourceRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "targetRef",
						type: "BaseElement",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "Category",
				superClass: ["RootElement"],
				properties: [{
					name: "categoryValue",
					type: "CategoryValue",
					isMany: !0
				}, {
					name: "name",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Artifact",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "CategoryValue",
				superClass: ["BaseElement"],
				properties: [{
					name: "categorizedFlowElements",
					type: "FlowElement",
					isMany: !0,
					isVirtual: !0,
					isReference: !0
				}, {
					name: "value",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "Activity",
				isAbstract: !0,
				superClass: ["FlowNode"],
				properties: [
					{
						name: "isForCompensation",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "default",
						type: "SequenceFlow",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "ioSpecification",
						type: "InputOutputSpecification",
						xml: { serialize: "property" }
					},
					{
						name: "boundaryEventRefs",
						type: "BoundaryEvent",
						isMany: !0,
						isReference: !0
					},
					{
						name: "properties",
						type: "Property",
						isMany: !0
					},
					{
						name: "dataInputAssociations",
						type: "DataInputAssociation",
						isMany: !0
					},
					{
						name: "dataOutputAssociations",
						type: "DataOutputAssociation",
						isMany: !0
					},
					{
						name: "startQuantity",
						default: 1,
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "resources",
						type: "ResourceRole",
						isMany: !0
					},
					{
						name: "completionQuantity",
						default: 1,
						isAttr: !0,
						type: "Integer"
					},
					{
						name: "loopCharacteristics",
						type: "LoopCharacteristics"
					}
				]
			},
			{
				name: "ServiceTask",
				superClass: ["Task"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}, {
					name: "operationRef",
					type: "Operation",
					isAttr: !0,
					isReference: !0
				}]
			},
			{
				name: "SubProcess",
				superClass: [
					"Activity",
					"FlowElementsContainer",
					"InteractionNode"
				],
				properties: [{
					name: "triggeredByEvent",
					default: !1,
					isAttr: !0,
					type: "Boolean"
				}, {
					name: "artifacts",
					type: "Artifact",
					isMany: !0
				}]
			},
			{
				name: "LoopCharacteristics",
				isAbstract: !0,
				superClass: ["BaseElement"]
			},
			{
				name: "MultiInstanceLoopCharacteristics",
				superClass: ["LoopCharacteristics"],
				properties: [
					{
						name: "isSequential",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "behavior",
						type: "MultiInstanceBehavior",
						default: "All",
						isAttr: !0
					},
					{
						name: "loopCardinality",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "loopDataInputRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "loopDataOutputRef",
						type: "ItemAwareElement",
						isReference: !0
					},
					{
						name: "inputDataItem",
						type: "DataInput",
						xml: { serialize: "property" }
					},
					{
						name: "outputDataItem",
						type: "DataOutput",
						xml: { serialize: "property" }
					},
					{
						name: "complexBehaviorDefinition",
						type: "ComplexBehaviorDefinition",
						isMany: !0
					},
					{
						name: "completionCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "oneBehaviorEventRef",
						type: "EventDefinition",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "noneBehaviorEventRef",
						type: "EventDefinition",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "StandardLoopCharacteristics",
				superClass: ["LoopCharacteristics"],
				properties: [
					{
						name: "testBefore",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "loopCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "loopMaximum",
						type: "Integer",
						isAttr: !0
					}
				]
			},
			{
				name: "CallActivity",
				superClass: ["Activity", "InteractionNode"],
				properties: [{
					name: "calledElement",
					type: "String",
					isAttr: !0
				}]
			},
			{
				name: "Task",
				superClass: ["Activity", "InteractionNode"]
			},
			{
				name: "SendTask",
				superClass: ["Task"],
				properties: [
					{
						name: "implementation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ReceiveTask",
				superClass: ["Task"],
				properties: [
					{
						name: "implementation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "instantiate",
						default: !1,
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "operationRef",
						type: "Operation",
						isAttr: !0,
						isReference: !0
					},
					{
						name: "messageRef",
						type: "Message",
						isAttr: !0,
						isReference: !0
					}
				]
			},
			{
				name: "ScriptTask",
				superClass: ["Task"],
				properties: [{
					name: "scriptFormat",
					isAttr: !0,
					type: "String"
				}, {
					name: "script",
					type: "String"
				}]
			},
			{
				name: "BusinessRuleTask",
				superClass: ["Task"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "AdHocSubProcess",
				superClass: ["SubProcess"],
				properties: [
					{
						name: "completionCondition",
						type: "Expression",
						xml: { serialize: "xsi:type" }
					},
					{
						name: "ordering",
						type: "AdHocOrdering",
						isAttr: !0
					},
					{
						name: "cancelRemainingInstances",
						default: !0,
						isAttr: !0,
						type: "Boolean"
					}
				]
			},
			{
				name: "Transaction",
				superClass: ["SubProcess"],
				properties: [{
					name: "protocol",
					isAttr: !0,
					type: "String"
				}, {
					name: "method",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "GlobalScriptTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "scriptLanguage",
					isAttr: !0,
					type: "String"
				}, {
					name: "script",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "GlobalBusinessRuleTask",
				superClass: ["GlobalTask"],
				properties: [{
					name: "implementation",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ComplexBehaviorDefinition",
				superClass: ["BaseElement"],
				properties: [{
					name: "condition",
					type: "FormalExpression"
				}, {
					name: "event",
					type: "ImplicitThrowEvent"
				}]
			},
			{
				name: "ResourceRole",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "resourceRef",
						type: "Resource",
						isReference: !0
					},
					{
						name: "resourceParameterBindings",
						type: "ResourceParameterBinding",
						isMany: !0
					},
					{
						name: "resourceAssignmentExpression",
						type: "ResourceAssignmentExpression"
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "ResourceParameterBinding",
				properties: [{
					name: "expression",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}, {
					name: "parameterRef",
					type: "ResourceParameter",
					isAttr: !0,
					isReference: !0
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "ResourceAssignmentExpression",
				properties: [{
					name: "expression",
					type: "Expression",
					xml: { serialize: "xsi:type" }
				}],
				superClass: ["BaseElement"]
			},
			{
				name: "Import",
				properties: [
					{
						name: "importType",
						isAttr: !0,
						type: "String"
					},
					{
						name: "location",
						isAttr: !0,
						type: "String"
					},
					{
						name: "namespace",
						isAttr: !0,
						type: "String"
					}
				]
			},
			{
				name: "Definitions",
				superClass: ["BaseElement"],
				properties: [
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "targetNamespace",
						isAttr: !0,
						type: "String"
					},
					{
						name: "expressionLanguage",
						default: "http://www.w3.org/1999/XPath",
						isAttr: !0,
						type: "String"
					},
					{
						name: "typeLanguage",
						default: "http://www.w3.org/2001/XMLSchema",
						isAttr: !0,
						type: "String"
					},
					{
						name: "imports",
						type: "Import",
						isMany: !0
					},
					{
						name: "extensions",
						type: "Extension",
						isMany: !0
					},
					{
						name: "rootElements",
						type: "RootElement",
						isMany: !0
					},
					{
						name: "diagrams",
						isMany: !0,
						type: "bpmndi:BPMNDiagram"
					},
					{
						name: "exporter",
						isAttr: !0,
						type: "String"
					},
					{
						name: "relationships",
						type: "Relationship",
						isMany: !0
					},
					{
						name: "exporterVersion",
						isAttr: !0,
						type: "String"
					}
				]
			}
		],
		enumerations: [
			{
				name: "ProcessType",
				literalValues: [
					{ name: "None" },
					{ name: "Public" },
					{ name: "Private" }
				]
			},
			{
				name: "GatewayDirection",
				literalValues: [
					{ name: "Unspecified" },
					{ name: "Converging" },
					{ name: "Diverging" },
					{ name: "Mixed" }
				]
			},
			{
				name: "EventBasedGatewayType",
				literalValues: [{ name: "Parallel" }, { name: "Exclusive" }]
			},
			{
				name: "RelationshipDirection",
				literalValues: [
					{ name: "None" },
					{ name: "Forward" },
					{ name: "Backward" },
					{ name: "Both" }
				]
			},
			{
				name: "ItemKind",
				literalValues: [{ name: "Physical" }, { name: "Information" }]
			},
			{
				name: "ChoreographyLoopType",
				literalValues: [
					{ name: "None" },
					{ name: "Standard" },
					{ name: "MultiInstanceSequential" },
					{ name: "MultiInstanceParallel" }
				]
			},
			{
				name: "AssociationDirection",
				literalValues: [
					{ name: "None" },
					{ name: "One" },
					{ name: "Both" }
				]
			},
			{
				name: "MultiInstanceBehavior",
				literalValues: [
					{ name: "None" },
					{ name: "One" },
					{ name: "All" },
					{ name: "Complex" }
				]
			},
			{
				name: "AdHocOrdering",
				literalValues: [{ name: "Parallel" }, { name: "Sequential" }]
			}
		],
		xml: {
			tagAlias: "lowerCase",
			typePrefix: "t"
		}
	},
	bpmndi: {
		name: "BPMNDI",
		uri: "http://www.omg.org/spec/BPMN/20100524/DI",
		prefix: "bpmndi",
		types: [
			{
				name: "BPMNDiagram",
				properties: [{
					name: "plane",
					type: "BPMNPlane",
					redefines: "di:Diagram#rootElement"
				}, {
					name: "labelStyle",
					type: "BPMNLabelStyle",
					isMany: !0
				}],
				superClass: ["di:Diagram"]
			},
			{
				name: "BPMNPlane",
				properties: [{
					name: "bpmnElement",
					isAttr: !0,
					isReference: !0,
					type: "bpmn:BaseElement",
					redefines: "di:DiagramElement#modelElement"
				}],
				superClass: ["di:Plane"]
			},
			{
				name: "BPMNShape",
				properties: [
					{
						name: "bpmnElement",
						isAttr: !0,
						isReference: !0,
						type: "bpmn:BaseElement",
						redefines: "di:DiagramElement#modelElement"
					},
					{
						name: "isHorizontal",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "isExpanded",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "isMarkerVisible",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "label",
						type: "BPMNLabel"
					},
					{
						name: "isMessageVisible",
						isAttr: !0,
						type: "Boolean"
					},
					{
						name: "participantBandKind",
						type: "ParticipantBandKind",
						isAttr: !0
					},
					{
						name: "choreographyActivityShape",
						type: "BPMNShape",
						isAttr: !0,
						isReference: !0
					}
				],
				superClass: ["di:LabeledShape"]
			},
			{
				name: "BPMNEdge",
				properties: [
					{
						name: "label",
						type: "BPMNLabel"
					},
					{
						name: "bpmnElement",
						isAttr: !0,
						isReference: !0,
						type: "bpmn:BaseElement",
						redefines: "di:DiagramElement#modelElement"
					},
					{
						name: "sourceElement",
						isAttr: !0,
						isReference: !0,
						type: "di:DiagramElement",
						redefines: "di:Edge#source"
					},
					{
						name: "targetElement",
						isAttr: !0,
						isReference: !0,
						type: "di:DiagramElement",
						redefines: "di:Edge#target"
					},
					{
						name: "messageVisibleKind",
						type: "MessageVisibleKind",
						isAttr: !0,
						default: "initiating"
					}
				],
				superClass: ["di:LabeledEdge"]
			},
			{
				name: "BPMNLabel",
				properties: [{
					name: "labelStyle",
					type: "BPMNLabelStyle",
					isAttr: !0,
					isReference: !0,
					redefines: "di:DiagramElement#style"
				}],
				superClass: ["di:Label"]
			},
			{
				name: "BPMNLabelStyle",
				properties: [{
					name: "font",
					type: "dc:Font"
				}],
				superClass: ["di:Style"]
			}
		],
		enumerations: [{
			name: "ParticipantBandKind",
			literalValues: [
				{ name: "top_initiating" },
				{ name: "middle_initiating" },
				{ name: "bottom_initiating" },
				{ name: "top_non_initiating" },
				{ name: "middle_non_initiating" },
				{ name: "bottom_non_initiating" }
			]
		}, {
			name: "MessageVisibleKind",
			literalValues: [{ name: "initiating" }, { name: "non_initiating" }]
		}],
		associations: []
	},
	dc: {
		name: "DC",
		uri: "http://www.omg.org/spec/DD/20100524/DC",
		prefix: "dc",
		types: [
			{ name: "Boolean" },
			{ name: "Integer" },
			{ name: "Real" },
			{ name: "String" },
			{
				name: "Font",
				properties: [
					{
						name: "name",
						type: "String",
						isAttr: !0
					},
					{
						name: "size",
						type: "Real",
						isAttr: !0
					},
					{
						name: "isBold",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isItalic",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isUnderline",
						type: "Boolean",
						isAttr: !0
					},
					{
						name: "isStrikeThrough",
						type: "Boolean",
						isAttr: !0
					}
				]
			},
			{
				name: "Point",
				properties: [{
					name: "x",
					type: "Real",
					default: "0",
					isAttr: !0
				}, {
					name: "y",
					type: "Real",
					default: "0",
					isAttr: !0
				}]
			},
			{
				name: "Bounds",
				properties: [
					{
						name: "x",
						type: "Real",
						default: "0",
						isAttr: !0
					},
					{
						name: "y",
						type: "Real",
						default: "0",
						isAttr: !0
					},
					{
						name: "width",
						type: "Real",
						isAttr: !0
					},
					{
						name: "height",
						type: "Real",
						isAttr: !0
					}
				]
			}
		],
		associations: []
	},
	di: {
		name: "DI",
		uri: "http://www.omg.org/spec/DD/20100524/DI",
		prefix: "di",
		types: [
			{
				name: "DiagramElement",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						isId: !0,
						type: "String"
					},
					{
						name: "extension",
						type: "Extension"
					},
					{
						name: "owningDiagram",
						type: "Diagram",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "owningElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "modelElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0,
						type: "Element"
					},
					{
						name: "style",
						type: "Style",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "ownedElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isMany: !0,
						isVirtual: !0
					}
				]
			},
			{
				name: "Node",
				isAbstract: !0,
				superClass: ["DiagramElement"]
			},
			{
				name: "Edge",
				isAbstract: !0,
				superClass: ["DiagramElement"],
				properties: [
					{
						name: "source",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "target",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0,
						isReference: !0
					},
					{
						name: "waypoint",
						isUnique: !1,
						isMany: !0,
						type: "dc:Point",
						xml: { serialize: "xsi:type" }
					}
				]
			},
			{
				name: "Diagram",
				isAbstract: !0,
				properties: [
					{
						name: "id",
						isAttr: !0,
						isId: !0,
						type: "String"
					},
					{
						name: "rootElement",
						type: "DiagramElement",
						isReadOnly: !0,
						isVirtual: !0
					},
					{
						name: "name",
						isAttr: !0,
						type: "String"
					},
					{
						name: "documentation",
						isAttr: !0,
						type: "String"
					},
					{
						name: "resolution",
						isAttr: !0,
						type: "Real"
					},
					{
						name: "ownedStyle",
						type: "Style",
						isReadOnly: !0,
						isMany: !0,
						isVirtual: !0
					}
				]
			},
			{
				name: "Shape",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "bounds",
					type: "dc:Bounds"
				}]
			},
			{
				name: "Plane",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "planeElement",
					type: "DiagramElement",
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0
				}]
			},
			{
				name: "LabeledEdge",
				isAbstract: !0,
				superClass: ["Edge"],
				properties: [{
					name: "ownedLabel",
					type: "Label",
					isReadOnly: !0,
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0,
					isVirtual: !0
				}]
			},
			{
				name: "LabeledShape",
				isAbstract: !0,
				superClass: ["Shape"],
				properties: [{
					name: "ownedLabel",
					type: "Label",
					isReadOnly: !0,
					subsettedProperty: "DiagramElement-ownedElement",
					isMany: !0,
					isVirtual: !0
				}]
			},
			{
				name: "Label",
				isAbstract: !0,
				superClass: ["Node"],
				properties: [{
					name: "bounds",
					type: "dc:Bounds"
				}]
			},
			{
				name: "Style",
				isAbstract: !0,
				properties: [{
					name: "id",
					isAttr: !0,
					isId: !0,
					type: "String"
				}]
			},
			{
				name: "Extension",
				properties: [{
					name: "values",
					isMany: !0,
					type: "Element"
				}]
			}
		],
		associations: [],
		xml: { tagAlias: "lowerCase" }
	},
	bioc: {
		name: "bpmn.io colors for BPMN",
		uri: "http://bpmn.io/schema/bpmn/biocolor/1.0",
		prefix: "bioc",
		types: [{
			name: "ColoredShape",
			extends: ["bpmndi:BPMNShape"],
			properties: [{
				name: "stroke",
				isAttr: !0,
				type: "String"
			}, {
				name: "fill",
				isAttr: !0,
				type: "String"
			}]
		}, {
			name: "ColoredEdge",
			extends: ["bpmndi:BPMNEdge"],
			properties: [{
				name: "stroke",
				isAttr: !0,
				type: "String"
			}, {
				name: "fill",
				isAttr: !0,
				type: "String"
			}]
		}],
		enumerations: [],
		associations: []
	},
	color: {
		name: "BPMN in Color",
		uri: "http://www.omg.org/spec/BPMN/non-normative/color/1.0",
		prefix: "color",
		types: [
			{
				name: "ColoredLabel",
				extends: ["bpmndi:BPMNLabel"],
				properties: [{
					name: "color",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ColoredShape",
				extends: ["bpmndi:BPMNShape"],
				properties: [{
					name: "background-color",
					isAttr: !0,
					type: "String"
				}, {
					name: "border-color",
					isAttr: !0,
					type: "String"
				}]
			},
			{
				name: "ColoredEdge",
				extends: ["bpmndi:BPMNEdge"],
				properties: [{
					name: "border-color",
					isAttr: !0,
					type: "String"
				}]
			}
		],
		enumerations: [],
		associations: []
	}
};
function fM(e, t) {
	return new uM(Z({}, dM, e), t);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/BpmnTreeWalker.js
function pM(e, t) {
	return e.$instanceOf(t);
}
function mM(e) {
	return iT(e.rootElements, function(e) {
		return pM(e, "bpmn:Process") || pM(e, "bpmn:Collaboration");
	});
}
function hM(e) {
	var t = {}, n = [], r = {};
	function i(e, t) {
		return function(n) {
			e(n, t);
		};
	}
	function a(e) {
		t[e.id] = e;
	}
	function o(e) {
		return t[e.id];
	}
	function s(t, n) {
		if (t.gfx) throw Error(`already rendered ${vO(t)}`);
		return e.element(t, r[t.id], n);
	}
	function c(t, n) {
		return e.root(t, r[t.id], n);
	}
	function l(e, t) {
		try {
			var n = r[e.id] && s(e, t);
			return a(e), n;
		} catch (t) {
			u(t.message, {
				element: e,
				error: t
			}), console.error(`failed to import ${vO(e)}`, t);
		}
	}
	function u(t, n) {
		e.error(t, n);
	}
	var d = this.registerDi = function(e) {
		var t = e.bpmnElement;
		t ? r[t.id] ? u(`multiple DI elements defined for ${vO(t)}`, { element: t }) : r[t.id] = e : u(`no bpmnElement referenced in ${vO(e)}`, { element: e });
	};
	function f(e) {
		p(e.plane);
	}
	function p(e) {
		d(e), X(e.planeElement, m);
	}
	function m(e) {
		d(e);
	}
	this.handleDefinitions = function(e, t) {
		var i = e.diagrams;
		if (t && i.indexOf(t) === -1) throw Error("diagram not part of <bpmn:Definitions />");
		if (!t && i && i.length && (t = i[0]), !t) throw Error("no diagram to display");
		r = {}, f(t);
		var a = t.plane;
		if (!a) throw Error(`no plane for ${vO(t)}`);
		var o = a.bpmnElement;
		if (!o) if (o = mM(e), o) u(`correcting missing bpmnElement on ${vO(a)} to ${vO(o)}`), a.bpmnElement = o, d(a);
		else throw Error("no process or collaboration to display");
		var s = c(o, a);
		if (pM(o, "bpmn:Process") || pM(o, "bpmn:SubProcess")) g(o, s);
		else if (pM(o, "bpmn:Collaboration")) ne(o, s), _(e.rootElements, s);
		else throw Error(`unsupported bpmnElement for ${vO(a)}: ${vO(o)}`);
		h(n);
	};
	var h = this.handleDeferred = function() {
		for (var e; n.length;) e = n.shift(), e();
	};
	function g(e, t) {
		M(e, t), T(e.ioSpecification, t), w(e.artifacts, t), a(e);
	}
	function _(e, t) {
		oT(e, function(e) {
			return !o(e) && pM(e, "bpmn:Process") && e.laneSets;
		}).forEach(i(g, t));
	}
	function v(e, t) {
		l(e, t);
	}
	function y(e, t) {
		X(e, i(v, t));
	}
	function b(e, t) {
		l(e, t);
	}
	function x(e, t) {
		l(e, t);
	}
	function S(e, t) {
		l(e, t);
	}
	function C(e, t) {
		l(e, t);
	}
	function w(e, t) {
		X(e, function(e) {
			pM(e, "bpmn:Association") ? n.push(function() {
				C(e, t);
			}) : C(e, t);
		});
	}
	function T(e, t) {
		e && (X(e.dataInputs, i(x, t)), X(e.dataOutputs, i(S, t)));
	}
	var E = this.handleSubProcess = function(e, t) {
		M(e, t), w(e.artifacts, t);
	};
	function D(e, t) {
		var r = l(e, t);
		pM(e, "bpmn:SubProcess") && E(e, r || t), pM(e, "bpmn:Activity") && T(e.ioSpecification, t), n.push(function() {
			X(e.dataInputAssociations, i(b, t)), X(e.dataOutputAssociations, i(b, t));
		});
	}
	function O(e, t) {
		l(e, t);
	}
	function k(e, t) {
		l(e, t);
	}
	function ee(e, t) {
		n.push(function() {
			var n = l(e, t);
			e.childLaneSet && A(e.childLaneSet, n || t), P(e);
		});
	}
	function A(e, t) {
		X(e.lanes, i(ee, t));
	}
	function j(e, t) {
		X(e, i(A, t));
	}
	function M(e, t) {
		N(e.flowElements, t), e.laneSets && j(e.laneSets, t);
	}
	function N(e, t) {
		X(e, function(e) {
			pM(e, "bpmn:SequenceFlow") ? n.push(function() {
				O(e, t);
			}) : pM(e, "bpmn:BoundaryEvent") ? n.unshift(function() {
				D(e, t);
			}) : pM(e, "bpmn:FlowNode") ? D(e, t) : pM(e, "bpmn:DataObject") || (pM(e, "bpmn:DataStoreReference") || pM(e, "bpmn:DataObjectReference") ? k(e, t) : u(`unrecognized flowElement ${vO(e)} in context ${vO(t && t.businessObject)}`, {
				element: e,
				context: t
			}));
		});
	}
	function te(e, t) {
		var n = l(e, t), r = e.processRef;
		r && g(r, n || t);
	}
	function ne(e, t) {
		X(e.participants, i(te, t)), n.push(function() {
			y(e.messageFlows, t);
		}), w(e.artifacts, t);
	}
	function P(e) {
		X(e.flowNodeRef, function(t) {
			var n = t.get("lanes");
			n && n.push(e);
		});
	}
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/import/Importer.js
function gM(e, t, n) {
	var r, i, a, o, s = [];
	function c(e, t) {
		var n = new hM({
			root: function(e, t) {
				return r.add(e, t);
			},
			element: function(e, t, n) {
				return r.add(e, t, n);
			},
			error: function(e, t) {
				s.push({
					message: e,
					context: t
				});
			}
		});
		t ||= e.diagrams && e.diagrams[0];
		var i = _M(e, t);
		if (!i) throw Error("no diagram to display");
		X(i, function(t) {
			n.handleDefinitions(e, t);
		});
		var o = t.plane.bpmnElement.id;
		a.setRootElement(a.findRoot(o + "_plane") || a.findRoot(o));
	}
	return new Promise(function(l, u) {
		try {
			return r = e.get("bpmnImporter"), i = e.get("eventBus"), a = e.get("canvas"), i.fire("import.render.start", { definitions: t }), c(t, n), i.fire("import.render.complete", {
				error: o,
				warnings: s
			}), l({ warnings: s });
		} catch (e) {
			return e.warnings = s, u(e);
		}
	});
}
function _M(e, t) {
	if (!(!t || !t.plane)) {
		var n = t.plane.bpmnElement, r = n;
		!Q(n, "bpmn:Process") && !Q(n, "bpmn:Collaboration") && (r = yM(n));
		var i = Q(r, "bpmn:Collaboration") ? r : iT(e.rootElements, function(e) {
			if (Q(e, "bpmn:Collaboration")) return iT(e.participants, function(e) {
				return e.processRef === r;
			});
		}), a = [r];
		i && (a = uT(i.participants, function(e) {
			return e.processRef;
		}), a.push(i));
		var o = vM(a), s = [t], c = [n];
		return X(e.diagrams, function(e) {
			if (e.plane) {
				var t = e.plane.bpmnElement;
				o.indexOf(t) !== -1 && c.indexOf(t) === -1 && (s.push(e), c.push(t));
			}
		}), s;
	}
}
function vM(e) {
	var t = [];
	return X(e, function(e) {
		e && (t.push(e), t = t.concat(vM(e.flowElements)));
	}), t;
}
function yM(e) {
	for (var t = e; t;) {
		if (Q(t, "bpmn:Process")) return t;
		t = t.$parent;
	}
}
var bM = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.02 5.57\" width=\"53\" height=\"21\"><path fill=\"currentColor\" d=\"M1.88.92v.14c0 .41-.13.68-.4.8.33.14.46.44.46.86v.33c0 .61-.33.95-.95.95H0V0h.95c.65 0 .93.3.93.92zM.63.57v1.06h.24c.24 0 .38-.1.38-.43V.98c0-.28-.1-.4-.32-.4zm0 1.63v1.22h.36c.2 0 .32-.1.32-.39v-.35c0-.37-.12-.48-.4-.48H.63zM4.18.99v.52c0 .64-.31.98-.94.98h-.3V4h-.62V0h.92c.63 0 .94.35.94.99zM2.94.57v1.35h.3c.2 0 .3-.09.3-.37v-.6c0-.29-.1-.38-.3-.38h-.3zm2.89 2.27L6.25 0h.88v4h-.6V1.12L6.1 3.99h-.6l-.46-2.82v2.82h-.55V0h.87zM8.14 1.1V4h-.56V0h.79L9 2.4V0h.56v4h-.64zm2.49 2.29v.6h-.6v-.6zM12.12 1c0-.63.33-1 .95-1 .61 0 .95.37.95 1v2.04c0 .64-.34 1-.95 1-.62 0-.95-.37-.95-1zm.62 2.08c0 .28.13.39.33.39s.32-.1.32-.4V.98c0-.29-.12-.4-.32-.4s-.33.11-.33.4z\"/><path fill=\"currentColor\" d=\"M0 4.53h14.02v1.04H0zM11.08 0h.63v.62h-.63zm.63 4V1h-.63v2.98z\"/></svg>", xM = { verticalAlign: "middle" }, SM = { color: "#404040" }, CM = {
	zIndex: "1001",
	position: "fixed",
	top: "0",
	left: "0",
	right: "0",
	bottom: "0"
}, wM = {
	width: "100%",
	height: "100%",
	background: "rgba(40,40,40,0.2)"
}, TM = {
	position: "absolute",
	left: "50%",
	top: "40%",
	transform: "translate(-50%)",
	width: "260px",
	padding: "10px",
	background: "white",
	boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
	fontFamily: "Helvetica, Arial, sans-serif",
	fontSize: "14px",
	display: "flex",
	lineHeight: "1.3"
}, EM = "<div class=\"bjs-powered-by-lightbox\"><div class=\"backdrop\"></div><div class=\"notice\"><a href=\"https://bpmn.io\" target=\"_blank\" rel=\"noopener\" class=\"link\">" + bM + "</a><span>Web-based tooling for BPMN, DMN and forms powered by <a href=\"https://bpmn.io\" target=\"_blank\" rel=\"noopener\">bpmn.io</a>.</span></div></div>", DM;
function OM() {
	DM = JE(EM), XE(DM, CM), XE(pD("svg", DM), xM), XE(pD(".backdrop", DM), wM), XE(pD(".notice", DM), TM), XE(pD(".link", DM), SM, {
		margin: "15px 20px 15px 10px",
		alignSelf: "center"
	});
}
function kM() {
	DM || (OM(), fD.bind(DM, ".backdrop", "click", function(e) {
		document.body.removeChild(DM);
	})), document.body.appendChild(DM);
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/BaseViewer.js
function AM(e) {
	e = Z({}, NM, e), this._moddle = this._createModdle(e), this._container = this._createContainer(e), this._init(this._container, this._moddle, e), IM(this._container);
}
Kw(AM, PA), AM.prototype.importXML = async function(e, t) {
	let n = this;
	function r(e) {
		return n.get("eventBus").createEvent(e);
	}
	let i = [];
	try {
		e = this._emit("import.parse.start", { xml: e }) || e;
		let n;
		try {
			n = await this._moddle.fromXML(e, "bpmn:Definitions");
		} catch (e) {
			throw this._emit("import.parse.complete", { error: e }), e;
		}
		let a = n.rootElement, o = n.references, s = n.warnings, c = n.elementsById;
		i = i.concat(s), a = this._emit("import.parse.complete", r({
			error: null,
			definitions: a,
			elementsById: c,
			references: o,
			warnings: i
		})) || a;
		let l = await this.importDefinitions(a, t);
		return i = i.concat(l.warnings), this._emit("import.done", {
			error: null,
			warnings: i
		}), { warnings: i };
	} catch (e) {
		let t = e;
		throw i = i.concat(t.warnings || []), jM(t, i), t = MM(t), this._emit("import.done", {
			error: t,
			warnings: t.warnings
		}), t;
	}
}, AM.prototype.importDefinitions = async function(e, t) {
	return this._setDefinitions(e), { warnings: (await this.open(t)).warnings };
}, AM.prototype.open = async function(e) {
	let t = this._definitions, n = e;
	if (!t) {
		let e = /* @__PURE__ */ Error("no XML imported");
		throw jM(e, []), e;
	}
	if (typeof e == "string" && (n = FM(t, e), !n)) {
		let t = /* @__PURE__ */ Error("BPMNDiagram <" + e + "> not found");
		throw jM(t, []), t;
	}
	try {
		this.clear();
	} catch (e) {
		throw jM(e, []), e;
	}
	let { warnings: r } = await gM(this, t, n);
	return { warnings: r };
}, AM.prototype.saveXML = async function(e) {
	e ||= {};
	let t = this._definitions, n, r;
	try {
		if (!t) throw Error("no definitions loaded");
		t = this._emit("saveXML.start", { definitions: t }) || t, r = (await this._moddle.toXML(t, e)).xml, r = this._emit("saveXML.serialized", { xml: r }) || r;
	} catch (e) {
		n = e;
	}
	let i = n ? { error: n } : { xml: r };
	if (this._emit("saveXML.done", i), n) throw n;
	return i;
}, AM.prototype.saveSVG = async function() {
	this._emit("saveSVG.start");
	let e, t;
	try {
		let t = this.get("canvas"), n = t.getActiveLayer(), r = pD(":scope > defs", t._svg), i = yE(n), a = r ? "<defs>" + yE(r) + "</defs>" : "", o = n.getBBox();
		e = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- created with bpmn-js / http://bpmn.io -->\n<!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"" + o.width + "\" height=\"" + o.height + "\" viewBox=\"" + o.x + " " + o.y + " " + o.width + " " + o.height + "\" version=\"1.1\">" + a + i + "</svg>";
	} catch (e) {
		t = e;
	}
	if (this._emit("saveSVG.done", {
		error: t,
		svg: e
	}), t) throw t;
	return { svg: e };
}, AM.prototype._setDefinitions = function(e) {
	this._definitions = e;
}, AM.prototype.getModules = function() {
	return this._modules;
}, AM.prototype.clear = function() {
	this.getDefinitions() && PA.prototype.clear.call(this);
}, AM.prototype.destroy = function() {
	PA.prototype.destroy.call(this), hD(this._container);
}, AM.prototype.on = function(e, t, n, r) {
	return this.get("eventBus").on(e, t, n, r);
}, AM.prototype.off = function(e, t) {
	this.get("eventBus").off(e, t);
}, AM.prototype.attachTo = function(e) {
	if (!e) throw Error("parentNode required");
	this.detach(), e.get && e.constructor.prototype.jquery && (e = e.get(0)), typeof e == "string" && (e = pD(e)), e.appendChild(this._container), this._emit("attach", {}), this.get("canvas").resized();
}, AM.prototype.getDefinitions = function() {
	return this._definitions;
}, AM.prototype.detach = function() {
	let e = this._container, t = e.parentNode;
	t && (this._emit("detach", {}), t.removeChild(e));
}, AM.prototype._init = function(e, t, n) {
	let r = n.modules || this.getModules(n), i = n.additionalModules || [], a = [{
		bpmnjs: ["value", this],
		moddle: ["value", t]
	}], o = [].concat(a, r, i), s = Z(yT(n, ["additionalModules"]), {
		canvas: Z({}, n.canvas, { container: e }),
		modules: o
	});
	PA.call(this, s), n && n.container && this.attachTo(n.container);
}, AM.prototype._emit = function(e, t) {
	return this.get("eventBus").fire(e, t);
}, AM.prototype._createContainer = function(e) {
	let t = JE("<div class=\"bjs-container\"></div>");
	return XE(t, {
		width: PM(e.width),
		height: PM(e.height),
		position: e.position
	}), t;
}, AM.prototype._createModdle = function(e) {
	return new fM(Z({}, this._moddleExtensions, e.moddleExtensions));
}, AM.prototype._modules = [];
function jM(e, t) {
	return e.warnings = t, e;
}
function MM(e) {
	let t = /unparsable content <([^>]+)> detected([\s\S]*)$/.exec(e.message);
	return t && (e.message = "unparsable content <" + t[1] + "> detected; this may indicate an invalid BPMN 2.0 diagram file" + t[2]), e;
}
var NM = {
	width: "100%",
	height: "100%",
	position: "relative"
};
function PM(e) {
	return e + (eT(e) ? "px" : "");
}
function FM(e, t) {
	return t && iT(e.diagrams, function(e) {
		return e.id === t;
	}) || null;
}
function IM(e) {
	let t = JE("<a href=\"http://bpmn.io\" target=\"_blank\" class=\"bjs-powered-by\" title=\"Powered by bpmn.io\" >" + bM + "</a>");
	XE(pD("svg", t), xM), XE(t, SM, {
		position: "absolute",
		bottom: "15px",
		right: "15px",
		zIndex: "100"
	}), e.appendChild(t), cD.bind(t, "click", function(e) {
		kM(), e.preventDefault();
	});
}
//#endregion
//#region ../../../node_modules/bpmn-js/lib/Viewer.js
function LM(e) {
	AM.call(this, e);
}
Kw(LM, AM), LM.prototype._modules = [
	TO,
	ck,
	PO,
	Tk,
	lO
], LM.prototype._moddleExtensions = {};
//#endregion
//#region src/components/general/view-workflow-dialog.vue
var RM = {
	key: 0,
	class: "mb-4"
}, zM = {
	key: 0,
	class: "text-headline-small"
}, BM = {
	class: "d-flex flex-column",
	style: { height: "100%" }
}, VM = ["aria-label"], HM = { class: "center-controls" }, UM = { style: {
	width: "40px",
	display: "flex",
	"justify-content": "flex-end"
} }, WM = {
	__name: "view-workflow-dialog",
	props: /*@__PURE__*/ v({
		bpmnData: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		id: {
			type: String,
			default: ""
		}
	}, {
		dialogVisible: {},
		dialogVisibleModifiers: {}
	}),
	emits: ["update:dialogVisible"],
	setup(e) {
		let t = z(e, "HViewWorkflowDialog"), n = ce(e, "dialogVisible"), s = A(null), u = null, d = A(null), f = A(!1), p = A(1), m = A(!1), h = A({
			x: 0,
			y: 0
		});
		function g() {
			f.value = !f.value, setTimeout(() => {
				u && (u.get("canvas").resized(), u.get("canvas").zoom("fit-viewport", "auto"));
			}, 300);
		}
		function _() {
			if (!u) return;
			let e = u.get("canvas"), t = e.zoom(), n = Math.min(t * 1.2, 4);
			e.zoom(n), p.value = n;
		}
		function v() {
			if (!u) return;
			let e = u.get("canvas"), t = e.zoom(), n = Math.max(t * .8, .2);
			e.zoom(n), p.value = n;
		}
		function S(e) {
			u && (e.preventDefault(), e.deltaY < 0 ? _() : v());
		}
		function C(e) {
			!u || e.button !== 0 || (m.value = !0, h.value = {
				x: e.clientX,
				y: e.clientY
			}, e.target.style.cursor = "grabbing");
		}
		function w(e) {
			if (!m.value || !u) return;
			let t = e.clientX - h.value.x, n = e.clientY - h.value.y;
			u.get("canvas").scroll({
				dx: t,
				dy: n
			}), h.value = {
				x: e.clientX,
				y: e.clientY
			};
		}
		function T(e) {
			m.value && (m.value = !1, e.target && (e.target.style.cursor = "grab"));
		}
		async function E(e) {
			if (!e) {
				console.error("No BPMN-data provided");
				return;
			}
			u ||= new LM({ container: s.value });
			try {
				await b(), setTimeout(async () => {
					try {
						await u.importXML(e), u.get("canvas").zoom("fit-viewport", "auto");
					} catch (e) {
						console.error("Error importing XML", e);
					}
				}, 10);
			} catch (e) {
				console.error("Failed to render BPMN diagram: ", e);
			}
		}
		function D() {
			u && u.get("canvas").zoom("fit-viewport", "auto");
		}
		return I([() => n.value, () => t.bpmnData], async ([e, t]) => {
			e && t && (f.value = !1, await b(), s.value ? E(t) : console.error("Canvas reference not available"));
		}, { immediate: !0 }), I(() => n.value, (e) => {
			if (!e && u) try {
				u.destroy(), u = null;
			} catch (e) {
				console.error("Error destroying viewer:", e);
			}
		}), (e, u) => {
			let p = N("h-dialog");
			return O(), r(p, {
				modelValue: n.value,
				"onUpdate:modelValue": u[0] ||= (e) => n.value = e,
				"dialog-height": "80vh",
				"dialog-width": "80vw",
				class: x(["bpmn-dialog-content", { "fullscreen-dialog": f.value }]),
				persistent: !1,
				fullscreen: f.value
			}, {
				header: L(() => [F(t).title || F(t).id ? (O(), a("div", RM, [F(t).title ? (O(), a("p", zM, P(F(t).title), 1)) : i("", !0), F(t).id ? (O(), r(Ue, {
					key: 1,
					class: "ml-1 px-0"
				}, {
					default: L(() => [c("ID: " + P(F(t).id), 1)]),
					_: 1
				})) : i("", !0)])) : i("", !0)]),
				default: L(() => [o("div", BM, [o("div", {
					ref_key: "dialogRef",
					ref: d,
					class: x(["dialog", { fullscreen: f.value }])
				}, [o("div", {
					ref_key: "canvas",
					ref: s,
					class: x(["bpmn-canvas", { fullscreen: f.value }]),
					role: "application",
					tabindex: "0",
					"aria-label": F(B)("bpmn_diagram"),
					onWheel: S,
					onMousedown: C,
					onMousemove: w,
					onMouseup: T,
					onMouseleave: T,
					onBlur: T
				}, null, 42, VM), l(Ve, null, {
					default: L(() => [
						u[4] ||= o("div", { style: { width: "40px" } }, null, -1),
						l(Xe),
						o("div", HM, [
							l(qe, {
								location: "bottom",
								text: F(B)("reset_view"),
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(Ke, y({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": F(B)("reset_view"),
									onClick: D
								}), {
									default: L(() => [l(V, null, {
										default: L(() => [...u[1] ||= [c("mdi:mdi-refresh", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"]),
							l(qe, {
								location: "bottom",
								text: F(B)("zoom_out"),
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(Ke, y({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": F(B)("zoom_out"),
									onClick: v
								}), {
									default: L(() => [l(V, null, {
										default: L(() => [...u[2] ||= [c("mdi:mdi-minus", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"]),
							l(qe, {
								location: "bottom",
								text: F(B)("zoom_in"),
								"open-delay": 1e3
							}, {
								activator: L(({ props: e }) => [l(Ke, y({
									icon: "",
									small: "",
									class: "mr-2"
								}, e, {
									"aria-label": F(B)("zoom_in"),
									onClick: _
								}), {
									default: L(() => [l(V, null, {
										default: L(() => [...u[3] ||= [c("mdi:mdi-plus", -1)]]),
										_: 1
									})]),
									_: 1
								}, 16, ["aria-label"])]),
								_: 1
							}, 8, ["text"])
						]),
						l(Xe),
						o("div", UM, [l(qe, {
							location: "bottom",
							text: f.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen"),
							"open-delay": 1e3
						}, {
							activator: L(({ props: e }) => [l(Ke, y({ icon: "" }, e, {
								"aria-label": f.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen"),
								onClick: g
							}), {
								default: L(() => [l(V, null, {
									default: L(() => [c(P(f.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
									_: 1
								})]),
								_: 1
							}, 16, ["aria-label"])]),
							_: 1
						}, 8, ["text"])])
					]),
					_: 1
				})], 2)])]),
				_: 1
			}, 8, [
				"modelValue",
				"class",
				"fullscreen"
			]);
		};
	}
}, GM = {
	__name: "widgets-container",
	props: { widgets: {
		type: Array,
		required: !0,
		validator: (e) => e.every((e) => "title" in e && "count" in e)
	} },
	setup(t) {
		return z(t, "HWidgetsContainer"), (n, i) => {
			let o = N("h-widget");
			return O(), r(Ye, null, {
				default: L(() => [(O(!0), a(e, null, j(t.widgets, (e, n) => (O(), r(H, {
					key: n,
					cols: "12",
					sm: "6",
					md: t.widgets.length === 3 ? 4 : 3
				}, {
					default: L(() => [l(o, {
						title: e.title,
						count: e.count,
						description: e.description,
						icon: e.icon,
						color: e.color,
						"icon-color": e.iconColor
					}, null, 8, [
						"title",
						"count",
						"description",
						"icon",
						"color",
						"icon-color"
					])]),
					_: 2
				}, 1032, ["md"]))), 128))]),
				_: 1
			});
		};
	}
}, KM = { class: "d-flex flex-row align-center h-100" }, qM = { class: "d-flex ga-2" }, JM = { class: "d-flex flex-column h-admin-widget__content" }, YM = { class: "h-admin-widget__count" }, XM = { class: "h-admin-widget__title" }, ZM = /*#__PURE__*/ Vn({
	__name: "widget",
	props: {
		title: {
			type: String,
			required: !0
		},
		count: {
			type: [Number, String],
			required: !0
		},
		description: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: "mdi:mdi-information-outline"
		},
		color: {
			type: String,
			default: "grey-lighten-4"
		},
		iconColor: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		return z(e, "HWidgets"), (t, n) => (O(), r(Be, { class: "pa-2 h-admin-widget" }, {
			default: L(() => [o("div", KM, [o("div", qM, [l(Lt, {
				color: e.color,
				class: "mr-3",
				size: "56"
			}, {
				default: L(() => [l(V, {
					icon: e.icon,
					size: "x-large",
					color: e.iconColor,
					class: "h-admin-widget-icon"
				}, null, 8, ["icon", "color"])]),
				_: 1
			}, 8, ["color"])]), o("div", JM, [o("div", YM, P(e.count), 1), o("div", XM, P(e.title), 1)])])]),
			_: 1
		}));
	}
}, [["__scopeId", "data-v-404f1baa"]]), QM = /* @__PURE__ */ Nn((/* @__PURE__ */ An(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", S = function(e) {
			return e instanceof E || !(!e || !e[x]);
		}, C = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, w = function(e, t) {
			if (S(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new E(n);
		}, T = v;
		T.l = C, T.i = S, T.w = function(e, t) {
			return w(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var E = function() {
			function g(e) {
				this.$L = C(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (T.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return T;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = w(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return w(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < w(e);
			}, _.$g = function(e, t, n) {
				return T.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!T.u(t) || t, u = T.p(e), p = function(e, t) {
					var i = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return T.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = T.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[T.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = T.p(u), h = function(e) {
					var t = w(p);
					return T.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return T.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = T.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return T.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return T.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return T.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return T.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return T.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return T.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return T.s(t.$s, 2, "0");
							case "SSS": return T.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = T.p(f), _ = w(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return T.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : T.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = C(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return T.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), D = E.prototype;
		return w.prototype = D, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			D[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), w.extend = function(e, t) {
			return e.$i ||= (e(t, E, w), !0), w;
		}, w.locale = C, w.isDayjs = S, w.unix = function(e) {
			return w(1e3 * e);
		}, w.en = b[y], w.Ls = b, w.p = {}, w;
	}));
})))(), 1), $M = /* @__PURE__ */ d({
	__name: "filter-datetime",
	props: {
		modelValue: { default: null },
		label: { default: "Date Range" },
		minDateFilter: { default: null },
		minDatePresetFilter: { default: void 0 },
		dateRangeOptions: {},
		classPrefix: {},
		filterKey: {},
		manualSync: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let o = e, s = z(o, "HFilterDatetime"), c = h("adminFilterDesign", !1), u = t, d = h("filterGroupSyncSignal", A({
			action: null,
			timestamp: 0
		})), f = A(s.modelValue ?? null);
		I(() => s.modelValue, (e) => {
			s.manualSync && f.value !== e && (f.value = e ?? null);
		}), I(d, (e) => {
			s.manualSync && (e.action === "reset" ? f.value = s.modelValue ?? null : e.action === "apply" ? u("update:modelValue", f.value) : e.action === "clear" && (f.value = null, u("update:modelValue", null)));
		}, { deep: !0 });
		let p = n({
			get: () => s.manualSync ? f.value : s.modelValue,
			set: (e) => {
				let t = e;
				s.manualSync ? f.value = t : u("update:modelValue", t);
			}
		}), m = n(() => s.classPrefix && s.filterKey ? `h-${s.classPrefix}-filter-${s.filterKey}` : "");
		function g() {
			s.manualSync ? f.value = null : u("update:modelValue", null);
		}
		let { ranges: _, getPresetRange: v } = Ee(s.dateRangeOptions), b = [
			{
				value: "last15min",
				labelKey: "presets_last15min",
				subtitleKey: "sub_last15min"
			},
			{
				value: "last30min",
				labelKey: "presets_last30min",
				subtitleKey: "sub_last30min"
			},
			{
				value: "last1h",
				labelKey: "presets_last1h",
				subtitleKey: "sub_last1h"
			},
			{
				value: "last4h",
				labelKey: "presets_last4h",
				subtitleKey: "sub_last4h"
			},
			{
				value: "last6h",
				labelKey: "presets_last6h",
				subtitleKey: "sub_last6h"
			},
			{
				value: "last12h",
				labelKey: "presets_last12h",
				subtitleKey: "sub_last12h"
			},
			{
				value: "today",
				labelKey: "presets_today",
				subtitleKey: "sub_today"
			},
			{
				value: "yesterday",
				labelKey: "presets_yesterday",
				subtitleKey: "sub_yesterday"
			},
			{
				value: "last3d",
				labelKey: "presets_last3d",
				subtitleKey: "sub_last3d"
			},
			{
				value: "last7d",
				labelKey: "presets_last7d",
				subtitleKey: "sub_last7d"
			},
			{
				value: "last14d",
				labelKey: "presets_last14d",
				subtitleKey: "sub_last14d"
			},
			{
				value: "thisWeek",
				labelKey: "presets_this_week",
				subtitleKey: "sub_this_week"
			},
			{
				value: "lastWeek",
				labelKey: "presets_last_week",
				subtitleKey: "sub_last_week"
			},
			{
				value: "thisMonth",
				labelKey: "presets_this_month",
				subtitleKey: "sub_this_month"
			},
			{
				value: "lastMonth",
				labelKey: "presets_last_month",
				subtitleKey: "sub_last_month"
			},
			{
				value: "thisYear",
				labelKey: "presets_this_year",
				subtitleKey: "sub_presets_this_year"
			},
			{
				value: "lastYear",
				labelKey: "presets_last_year",
				subtitleKey: "sub_presets_last_year"
			}
		], S = (0, QM.default)(), w = n(() => o.minDateFilter ? o.minDateFilter : o.minDatePresetFilter ? v(o.minDatePresetFilter, S)?.start ?? null : null), T = n(() => {
			let e = (e) => w.value === null ? !1 : w.value.isValid() && e.isBefore(w.value);
			return b.map(({ value: t, labelKey: n, subtitleKey: r }) => {
				let i = v(t, S);
				return {
					value: t,
					label: B(n),
					subtitle: B(r),
					disabled: !i || e(i.start)
				};
			});
		});
		function E(e, t) {
			let n = (e) => e?.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") || "", r = n(e?.raw?.label), i = n(e?.raw?.subtitle), a = n(t), o = `${r} ${i}`;
			return o.includes(a) || a.split(" ").some((e) => o.includes(e));
		}
		return (t, n) => (O(), a("div", { class: x(["d-flex flex-column align-center justify-center my-0 h-filter h-filter-datetime", m.value]) }, [l(et, {
			modelValue: p.value,
			"onUpdate:modelValue": n[1] ||= (e) => p.value = e,
			label: e.label,
			items: T.value,
			placeholder: F(B)("placeholder_search"),
			"item-title": "label",
			"item-value": "value",
			class: "rounded-xl custom-select h-filter-datetime-main-combobox",
			style: C(F(c) ? void 0 : {
				maxWidth: "300px",
				minWidth: "300px"
			}),
			"hide-details": F(c),
			"menu-icon": F(c) ? "mdi:mdi-calendar-month" : void 0,
			"return-object": !1,
			filter: E,
			"allow-new": !1
		}, {
			"append-inner": L(() => [p.value ? (O(), r(V, {
				key: 0,
				class: "me-2 h-filter-datetime-clear-icon",
				style: { cursor: "pointer" },
				onClick: n[0] ||= R((e) => g(), ["stop"])
			})) : i("", !0)]),
			item: L(({ props: e, item: t }) => [l(wt, y(e, {
				style: t.disabled ? {
					opacity: "0.5",
					pointerEvents: "none"
				} : {},
				disabled: t.disabled,
				class: "h-filter-datetime-list-item"
			}), {
				default: L(() => [t.subtitle ? (O(), r(Tt, {
					key: 0,
					class: "h-filter-datetime-list-subtitle"
				})) : i("", !0)]),
				_: 2
			}, 1040, ["style", "disabled"])]),
			_: 1
		}, 8, [
			"modelValue",
			"label",
			"items",
			"placeholder",
			"style",
			"hide-details",
			"menu-icon"
		])], 2));
	}
}), eN = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, tN = {
	key: 0,
	class: "h-admin-filter-chip-options"
}, nN = /* @__PURE__ */ d({
	__name: "filter-multiselect",
	props: {
		title: {},
		options: {},
		modelValue: {},
		showAsChips: { type: Boolean },
		icon: {},
		classPrefix: {},
		filterKey: {},
		getColor: { type: Function },
		getIcon: { type: Function }
	},
	emits: ["update:modelValue"],
	setup(t, { emit: o }) {
		let u = z(t, "HFilterMultiselect"), d = h("adminFilterDesign", !1), { icon: f, showAsChips: p } = ae(u), m = n(() => d && u.showAsChips), g = n(() => {
			let e = F(u.options);
			return Array.isArray(e) ? e.filter((e) => e != null && e.value !== void 0) : [];
		}), _ = n(() => u.classPrefix && u.filterKey ? `h-${u.classPrefix}-filter-${u.filterKey}` : ""), v = A(!1), b = A(Array.isArray(u.modelValue) ? [...u.modelValue] : []), S = A([...b.value]);
		I(v, (e) => {
			e && (S.value = [...b.value]);
		});
		function C(e) {
			S.value = S.value.includes(e) ? S.value.filter((t) => t !== e) : [...S.value, e];
		}
		function w() {
			b.value = [...S.value], v.value = !1;
		}
		let T = o;
		I(b, (e) => {
			T("update:modelValue", e);
		}), I(() => u.modelValue, (e) => {
			JSON.stringify(e) !== JSON.stringify(b.value) && (b.value = Array.isArray(e) ? [...e] : []);
		}, { deep: !0 });
		function E(e) {
			if (u.getColor) return u.getColor(e);
			if (e && e.color) return e.color;
		}
		function D(e) {
			return u.getIcon ? u.getIcon(e) : e && e.icon ? e.icon : null;
		}
		function k(e) {
			e && e.stopPropagation(), S.value = [], b.value = [], v.value = !1;
		}
		return (n, o) => (O(), a("div", { class: x(["h-filter-multi-select h-filter mr-2", _.value]) }, [l(it, {
			modelValue: v.value,
			"onUpdate:modelValue": o[1] ||= (e) => v.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: F(d) ? 4 : 0,
			class: "h-filter-multiselect-main-menu"
		}, {
			activator: L(({ props: e }) => [l(Ke, y(e, {
				class: ["filter-button h-filter-multiselect-activator-btn", {
					"h-admin-filter-button": F(d),
					"h-admin-filter-button--open": F(d) && v.value,
					"h-admin-filter-button--active": F(d) && b.value.length > 0,
					"h-admin-filter-button--counted": F(d)
				}],
				"prepend-icon": F(f),
				"append-icon": F(d) ? v.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				size: "small",
				variant: "outlined",
				color: b.value.length > 0 ? "primary" : void 0
			}), s({
				default: L(() => [c(P(t.title) + " " + P(!F(d) && b.value.length > 0 ? `(${b.value.length})` : "") + " ", 1), !F(d) && b.value.length > 0 ? (O(), r(V, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-multiselect-clear-icon",
					onClick: k
				}, {
					default: L(() => [...o[2] ||= [c(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : i("", !0)]),
				_: 2
			}, [F(d) ? {
				name: "append",
				fn: L(() => [
					b.value.length > 0 ? (O(), a("span", eN, P(b.value.length), 1)) : i("", !0),
					b.value.length ? (O(), r(V, {
						key: 1,
						"aria-label": F(B)("clear"),
						role: "button",
						tabindex: "0",
						icon: "mdi:mdi-close",
						onClick: R(k, ["stop"]),
						onKeydown: [fe(R(k, ["stop", "prevent"]), ["enter"]), fe(R(k, ["stop", "prevent"]), ["space"])]
					}, null, 8, ["aria-label", "onKeydown"])) : i("", !0),
					l(V, { icon: v.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])
				]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: L(() => [l(Be, {
				class: x([{
					"h-admin-filter-menu": F(d),
					"h-admin-filter-chip-menu": m.value
				}, "filter-menu h-filter-multiselect-menu-card"]),
				elevation: "1",
				rounded: "lg"
			}, {
				default: L(() => [l(We, { class: "h-filter-multiselect-menu-text" }, {
					default: L(() => [m.value ? (O(), a("div", tN, [(O(!0), a(e, null, j(g.value, (e) => (O(), r(kt, {
						key: e.value,
						tag: "button",
						type: "button",
						variant: "outlined",
						color: E(e),
						class: x([{ "h-admin-filter-chip--selected": S.value.includes(e.value) }, "h-admin-filter-choice-chip"]),
						"aria-pressed": S.value.includes(e.value),
						onClick: (t) => C(e.value)
					}, {
						default: L(() => [
							D(e) ? (O(), r(V, {
								key: 0,
								icon: D(e) ?? void 0,
								size: "18",
								class: "mr-1"
							}, null, 8, ["icon"])) : i("", !0),
							c(" " + P(e.label) + " ", 1),
							S.value.includes(e.value) ? (O(), r(V, {
								key: 1,
								icon: "mdi:mdi-close-circle",
								size: "18",
								class: "ml-1"
							})) : i("", !0)
						]),
						_: 2
					}, 1032, [
						"color",
						"class",
						"aria-pressed",
						"onClick"
					]))), 128))])) : (O(), r(St, {
						key: 1,
						density: "compact",
						class: "h-filter-multiselect-list"
					}, {
						default: L(() => [(O(!0), a(e, null, j(g.value, (t) => (O(), r(wt, {
							key: t.value,
							class: "h-filter-multiselect-list-item"
						}, {
							prepend: L(() => [l(Mt, {
								modelValue: b.value,
								"onUpdate:modelValue": o[0] ||= (e) => b.value = e,
								value: t.value,
								density: "compact",
								color: "primary",
								"hide-details": "",
								size: "small",
								class: "h-filter-multiselect-checkbox"
							}, null, 8, ["modelValue", "value"])]),
							default: L(() => [l(Et, { class: "h-filter-multiselect-list-title" }, {
								default: L(() => [F(p) ? (O(), r(kt, {
									key: 0,
									size: "small",
									color: E(t),
									class: "ml-2 h-filter-multiselect-chip"
								}, {
									default: L(() => [D(t) ? (O(), r(V, {
										key: 0,
										size: "small",
										class: "mr-1 h-filter-multiselect-option-icon"
									}, {
										default: L(() => [c(P(D(t)), 1)]),
										_: 2
									}, 1024)) : i("", !0), c(" " + P(t.label), 1)]),
									_: 2
								}, 1032, ["color"])) : (O(), a(e, { key: 1 }, [D(t) ? (O(), r(V, {
									key: 0,
									size: "small",
									class: "mr-2 h-filter-multiselect-option-icon"
								}, {
									default: L(() => [c(P(D(t)), 1)]),
									_: 2
								}, 1024)) : i("", !0), c(" " + P(t.label), 1)], 64))]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024))), 128))]),
						_: 1
					}))]),
					_: 1
				}), m.value ? (O(), r(Ve, { key: 0 }, {
					default: L(() => [l(Ke, { onClick: w }, {
						default: L(() => [c(P(F(B)("apply")), 1)]),
						_: 1
					}), l(Ke, { onClick: k }, {
						default: L(() => [c(P(F(B)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})) : i("", !0)]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), rN = ["title"], iN = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, aN = { class: "text-body-medium mb-2 d-block" }, oN = { class: "d-flex flex-wrap mb-2" }, sN = /* @__PURE__ */ d({
	__name: "filter-multistring",
	props: {
		label: {},
		title: {},
		placeholder: { default: void 0 },
		modelValue: { default: () => [] },
		icon: {},
		classPrefix: {},
		filterKey: {}
	},
	emits: ["update:modelValue"],
	setup(t, { emit: u }) {
		let d = z(t, "HFilterMultistring"), f = h("adminFilterDesign", !1), { icon: p } = ae(d), m = u, g = n(() => d.placeholder ?? B("filter_enter_value_placeholder")), _ = n(() => d.classPrefix && d.filterKey ? `h-${d.classPrefix}-filter-${d.filterKey}` : ""), v = A(!1), b = A(""), S = A(Array.isArray(d.modelValue) ? [...d.modelValue] : []);
		I(() => d.modelValue, (e) => {
			S.value = Array.isArray(e) ? [...e] : [];
		}, {
			immediate: !0,
			deep: !0
		});
		function C() {
			m("update:modelValue", [...S.value]), b.value = "", v.value = !1;
		}
		function w() {
			S.value = [], m("update:modelValue", []);
		}
		function T() {
			b.value = "";
		}
		function E() {
			let e = b.value.trim();
			e && !S.value.includes(e) && (S.value.push(e), b.value = "");
		}
		function D(e) {
			let t = S.value.indexOf(e);
			t > -1 ? S.value.splice(t, 1) : S.value.push(e), m("update:modelValue", [...S.value]);
		}
		function k() {
			b.value.trim() ? E() : C();
		}
		function ee(e) {
			return S.value.includes(e);
		}
		function M(e) {
			S.value.splice(e, 1), m("update:modelValue", [...S.value]);
		}
		return (n, u) => (O(), a("div", { class: x(["h-filter-multistring h-filter mr-2", _.value]) }, [l(it, {
			modelValue: v.value,
			"onUpdate:modelValue": u[1] ||= (e) => v.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: F(f) ? 4 : 0,
			class: "h-filter-multistring-main-menu"
		}, {
			activator: L(({ props: e }) => [l(Ke, y(e, {
				class: ["filter-button h-filter-multistring-activator-btn", {
					"h-admin-filter-button": F(f),
					"h-admin-filter-button--open": F(f) && v.value,
					"h-admin-filter-button--active": F(f) && S.value.length > 0
				}],
				"prepend-icon": F(p),
				"append-icon": F(f) ? v.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				variant: "outlined",
				color: S.value.length ? "primary" : "",
				size: "small"
			}), s({
				default: L(() => [o("span", {
					class: "h-admin-filter-label",
					title: `${F(B)(t.label ?? "")}: ${S.value.join(", ")}`
				}, P(F(B)(t.label ?? "")) + " " + P(!F(f) && S.value.length ? `(${S.value.join(", ")})` : ""), 9, rN), S.value.length ? (O(), r(V, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-multistring-clear-icon",
					onClick: R(w, ["stop"])
				}, {
					default: L(() => [...u[2] ||= [c(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : i("", !0)]),
				_: 2
			}, [F(f) ? {
				name: "append",
				fn: L(() => [S.value.length > 0 ? (O(), a("span", iN, P(S.value.length), 1)) : i("", !0), l(V, { icon: v.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: L(() => [l(Be, {
				class: x([{ "h-admin-filter-menu": F(f) }, "filter-menu h-filter-multistring-menu-card"]),
				elevation: "1",
				rounded: "lg",
				width: "300"
			}, {
				default: L(() => [l(We, { class: "pa-2 h-filter-multistring-menu-text" }, {
					default: L(() => [
						o("span", aN, P(t.title), 1),
						l(Ze, {
							modelValue: b.value,
							"onUpdate:modelValue": u[0] ||= (e) => b.value = e,
							label: g.value,
							density: "compact",
							variant: "outlined",
							"hide-details": "",
							"single-line": "",
							class: "mb-2 h-filter-multistring-text-field",
							clearable: "",
							onKeyup: fe(k, ["enter"]),
							"onClick:clear": T
						}, null, 8, ["modelValue", "label"]),
						o("div", oN, [(O(!0), a(e, null, j(S.value, (e, t) => (O(), r(kt, {
							key: t,
							closable: "",
							size: "small",
							class: x(["ma-1 h-filter-multistring-chip", ee(e) ? "font-weight-bold" : ""]),
							onClick: (t) => D(e),
							"onClick:close": (e) => M(t)
						}, {
							default: L(() => [c(P(e), 1)]),
							_: 2
						}, 1032, [
							"class",
							"onClick",
							"onClick:close"
						]))), 128))]),
						l(Ve, null, {
							default: L(() => [l(Ke, {
								size: "small",
								color: "primary",
								class: "h-filter-multistring-apply-btn",
								onClick: C
							}, {
								default: L(() => [c(P(F(B)("apply")), 1)]),
								_: 1
							}), l(Ke, {
								size: "small",
								variant: "text",
								class: "mr-2 h-filter-multistring-clear-btn",
								onClick: w
							}, {
								default: L(() => [c(P(F(B)("clear")), 1)]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), cN = ["title"], lN = { key: 1 }, uN = { class: "h-filter-match-selector text-body-medium mr-1" }, dN = /* @__PURE__ */ d({
	__name: "filter-string",
	props: /*@__PURE__*/ v({
		title: { default: "Filter" },
		placeholder: { default: "Enter text..." },
		defaultMatchType: { default: "contains" },
		showMatchTypeSelector: {
			type: Boolean,
			default: !1
		},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: { default: void 0 },
		filterKey: { default: "" }
	}, {
		modelValue: {},
		modelModifiers: {},
		matchType: {},
		matchTypeModifiers: {}
	}),
	emits: /*@__PURE__*/ v(["update:modelValue", "update:matchType"], ["update:modelValue", "update:matchType"]),
	setup(t, { emit: u }) {
		let d = z(t, "HFilterString"), f = h("adminFilterDesign", !1), { icon: p } = ae(d), m = n(() => d.classPrefix && d.filterKey ? `h-${d.classPrefix}-filter-${d.filterKey}` : ""), g = u, _ = A(!1), v = A(!1), b = ce(t, "modelValue"), S = ce(t, "matchType"), C = A(b.value || ""), w = A(S.value || d.defaultMatchType), T = n({
			get: () => f ? C.value : b.value,
			set: (e) => {
				f ? C.value = e || "" : b.value = e;
			}
		});
		I(_, (e) => {
			e && (C.value = b.value || "", w.value = S.value || d.defaultMatchType);
		});
		let E = [{
			title: "Contains",
			value: "contains"
		}, {
			title: "Exact match",
			value: "exact"
		}];
		I(S, (e) => {
			g("update:matchType", e);
		});
		function D() {
			f && (b.value = C.value, S.value = w.value), _.value = !1;
		}
		function k(e) {
			e && e.stopPropagation(), b.value = "", g("update:modelValue", ""), g("update:matchType", "contains"), _.value = !1;
		}
		function ee(e, t) {
			return e ? e.length > t ? e.substring(0, t) + "..." : e : "";
		}
		function M(e) {
			let t = E.find((t) => t.value === e);
			return t ? t.title : "Match type";
		}
		function N(e) {
			S.value = e, v.value = !1, g("update:matchType", e);
		}
		return (n, u) => (O(), a("div", { class: x(["h-filter-string h-filter mr-2", m.value]) }, [l(it, {
			modelValue: _.value,
			"onUpdate:modelValue": u[3] ||= (e) => _.value = e,
			"close-on-content-click": !1,
			location: "bottom start",
			offset: F(f) ? 4 : 0,
			class: "h-filter-string-main-menu"
		}, {
			activator: L(({ props: e }) => [l(Ke, y(e, {
				class: ["filter-button h-filter-string-activator-btn", {
					"h-admin-filter-button": F(f),
					"h-admin-filter-button--open": F(f) && _.value,
					"h-admin-filter-button--active": F(f) && !!b.value
				}],
				variant: "outlined",
				"prepend-icon": F(p),
				"append-icon": F(f) ? _.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
				color: b.value ? "primary" : void 0,
				size: "small"
			}), s({
				default: L(() => [o("span", {
					class: "h-admin-filter-label",
					title: b.value ? `${t.title}: ${b.value}` : t.title
				}, P(t.title) + " " + P(!F(f) && b.value ? `(${ee(b.value, 12)})` : ""), 9, cN), b.value ? (O(), r(V, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-string-clear-icon",
					onClick: k
				}, {
					default: L(() => [...u[4] ||= [c(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : i("", !0)]),
				_: 2
			}, [F(f) ? {
				name: "append",
				fn: L(() => [b.value ? (O(), r(V, {
					key: 0,
					class: "h-admin-filter-selected-icon",
					icon: "mdi:mdi-check-circle"
				})) : i("", !0), l(V, { icon: _.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"append-icon",
				"class",
				"color"
			])]),
			default: L(() => [l(Be, {
				class: x([{ "h-admin-filter-menu": F(f) }, "filter-menu h-filter-string-menu-card"]),
				elevation: "1",
				rounded: "lg",
				width: F(f) ? 690 : 280,
				"max-width": "calc(100vw - 32px)"
			}, {
				default: L(() => [l(We, { class: "pa-2 h-filter-string-menu-text" }, {
					default: L(() => [F(f) && t.showMatchTypeSelector ? (O(), r(Qe, {
						key: 0,
						modelValue: w.value,
						"onUpdate:modelValue": u[0] ||= (e) => w.value = e,
						items: E,
						"aria-label": t.title,
						variant: "outlined",
						"hide-details": "",
						class: "h-admin-filter-match"
					}, null, 8, ["modelValue", "aria-label"])) : t.showMatchTypeSelector ? (O(), a("div", lN, [o("span", uN, P(t.title), 1), l(it, {
						modelValue: v.value,
						"onUpdate:modelValue": u[1] ||= (e) => v.value = e,
						class: "h-filter-string-match-menu"
					}, {
						activator: L(({ props: e }) => [o("strong", y(e, { class: "h-filter-match-selector strong-label" }), [c(P(M(S.value)) + " ", 1), l(V, { class: "h-filter-string-match-icon" }, {
							default: L(() => [...u[5] ||= [c("mdi:mdi-chevron-down", -1)]]),
							_: 1
						})], 16)]),
						default: L(() => [l(St, {
							density: "compact",
							class: "pa-0 h-filter-string-match-list"
						}, {
							default: L(() => [(O(), a(e, null, j(E, (e) => l(wt, {
								key: e.value,
								value: e.value,
								class: "h-filter-string-match-item",
								onClick: R((t) => N(e.value), ["stop"])
							}, {
								default: L(() => [l(Et, { class: "h-filter-string-match-title" }, {
									default: L(() => [c(P(e.title), 1)]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["value", "onClick"])), 64))]),
							_: 1
						})]),
						_: 1
					}, 8, ["modelValue"])])) : i("", !0), l(Ze, {
						modelValue: T.value,
						"onUpdate:modelValue": u[2] ||= (e) => T.value = e,
						label: t.placeholder,
						density: "compact",
						variant: "outlined",
						"hide-details": "",
						"single-line": "",
						class: "mb-2 h-filter-string-text-field",
						clearable: "",
						onKeyup: fe(D, ["enter"]),
						"onClick:clear": k
					}, null, 8, ["modelValue", "label"])]),
					_: 1
				}), l(Ve, null, {
					default: L(() => [l(Ke, {
						size: "small",
						color: "primary",
						class: "h-filter-string-apply-btn",
						onClick: D
					}, {
						default: L(() => [c(P(F(B)("apply")), 1)]),
						_: 1
					}), l(Ke, {
						size: "small",
						variant: "text",
						class: "mr-2 h-filter-string-clear-btn",
						onClick: k
					}, {
						default: L(() => [c(P(F(B)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			}, 8, ["class", "width"])]),
			_: 1
		}, 8, ["modelValue", "offset"])], 2));
	}
}), fN = {
	key: 0,
	class: "h-admin-filter-selection-count"
}, pN = /* @__PURE__ */ d({
	__name: "filter-group",
	props: /*@__PURE__*/ v({
		title: {},
		placeholder: { default: "Enter text..." },
		defaultMatchType: { default: "contains" },
		showMatchTypeSelector: {
			type: Boolean,
			default: !1
		},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: {},
		filterKey: { default: "" },
		controlsSync: {
			type: Boolean,
			default: !1
		},
		filterKeys: {}
	}, {
		filters: {},
		filtersModifiers: {},
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:filters", "update:modelValue"],
	setup(e) {
		let t = z(e, "HFilterGroup"), u = h("adminFilterDesign", !1), { icon: d } = ae(t), f = A({
			action: null,
			timestamp: 0
		});
		t.controlsSync && k("filterGroupSyncSignal", f);
		let p = n(() => t.classPrefix && t.filterKey ? `h-${t.classPrefix}-filter-${t.filterKey}` : ""), m = ce(e, "filters"), g = ee({}), _ = n(() => (t.filterKeys || Object.keys(g)).filter((e) => {
			let t = m.value?.[e];
			return t != null && t !== "" && (!Array.isArray(t) || t.length > 0);
		})), v = ce(e, "modelValue"), b = A(!1);
		function S() {
			m.value && Object.keys(g).forEach((e) => {
				g[e] = m.value?.[e];
			});
		}
		I(m, S, {
			immediate: !0,
			deep: !0
		}), I(b, (e) => {
			e && (S(), t.controlsSync && (f.value = {
				action: "reset",
				timestamp: Date.now()
			}));
		});
		function C() {
			m.value ||= {}, Object.keys(g).forEach((e) => {
				m.value[e] = g[e];
			});
		}
		function w() {
			t.controlsSync && (f.value = {
				action: "apply",
				timestamp: Date.now()
			}), C(), b.value = !1;
		}
		function T() {
			t.controlsSync && (f.value = {
				action: "clear",
				timestamp: Date.now()
			}), Object.keys(g).forEach((e) => {
				g[e] = null;
			}), m.value && t.filterKeys?.forEach((e) => {
				m.value[e] = null;
			}), C(), b.value = !1;
		}
		function E(e, t) {
			return e ? e.length > t ? e.substring(0, t) + "..." : e : "";
		}
		return (t, n) => {
			let f = N("h-theme-scope"), m = N("h-menu");
			return O(), a("div", { class: x(["h-filter-group h-filter", p.value]) }, [l(f, { name: "HScopedFilterGroupMenu" }, {
				default: L(() => [l(m, {
					modelValue: b.value,
					"onUpdate:modelValue": n[2] ||= (e) => b.value = e,
					"close-on-content-click": !1,
					offset: F(u) ? 4 : 0,
					location: "bottom end",
					class: "h-filter-group__menu"
				}, {
					activator: L(({ props: t }) => [l(f, { name: "HScopedFilterGroupMenuActivator" }, {
						default: L(() => [l(Ke, y(t, {
							variant: "outlined",
							size: "small",
							"prepend-icon": F(d),
							"append-icon": F(u) ? b.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" : void 0,
							class: {
								"h-admin-filter-button": F(u),
								"h-admin-filter-button--open": F(u) && b.value,
								"h-admin-filter-button--active": F(u) && _.value.length > 0,
								"h-admin-filter-button--counted": F(u)
							},
							color: _.value.length ? "filter-group-active" : "filter-group-inactive"
						}), s({
							default: L(() => [o("span", null, P(e.title) + " " + P(v.value ? `(${E(v.value, 12)})` : ""), 1), F(u) ? i("", !0) : (O(), r(f, {
								key: 0,
								name: "HScopedFilterGroupBadge"
							}, {
								default: L(() => [_.value.length ? (O(), r(At, {
									key: 0,
									class: "ml-auto",
									color: "filter-group-badge",
									content: _.value.length,
									inline: ""
								}, null, 8, ["content"])) : i("", !0)]),
								_: 1
							}))]),
							_: 2
						}, [F(u) ? {
							name: "append",
							fn: L(() => [
								_.value.length ? (O(), a("span", fN, P(_.value.length), 1)) : i("", !0),
								_.value.length ? (O(), r(V, {
									key: 1,
									"aria-label": F(B)("clear"),
									role: "button",
									tabindex: "0",
									icon: "mdi:mdi-close",
									onClick: R(T, ["stop"]),
									onKeydown: [fe(R(T, ["stop", "prevent"]), ["enter"]), fe(R(T, ["stop", "prevent"]), ["space"])]
								}, null, 8, ["aria-label", "onKeydown"])) : i("", !0),
								l(V, { icon: b.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])
							]),
							key: "0"
						} : void 0]), 1040, [
							"prepend-icon",
							"append-icon",
							"class",
							"color"
						])]),
						_: 2
					}, 1024)]),
					default: L(() => [l(f, { name: "HScopedFilterGroupMenuCard" }, {
						default: L(() => [l(Be, { class: x(["h-filter-group__content", { "h-admin-filter-menu": F(u) }]) }, {
							default: L(() => [M(t.$slots, "menu-content", { internalFilters: g }, () => [l(He, null, {
								default: L(() => [l(We, { class: "pt-2" }, {
									default: L(() => [M(t.$slots, "default", { internalFilters: g })]),
									_: 3
								}), l(Ve, null, {
									default: L(() => [l(f, { name: "HScopedFilterGroupApplyActionButton" }, {
										default: L(() => [l(Ke, { onClick: n[0] ||= (e) => w() }, {
											default: L(() => [c(P(F(B)("apply")), 1)]),
											_: 1
										})]),
										_: 1
									}), l(f, { name: "HScopedFilterGroupClearActionButton" }, {
										default: L(() => [l(Ke, { onClick: n[1] ||= (e) => T() }, {
											default: L(() => [c(P(F(B)("clear")), 1)]),
											_: 1
										})]),
										_: 1
									})]),
									_: 1
								})]),
								_: 3
							})])]),
							_: 3
						}, 8, ["class"])]),
						_: 3
					})]),
					_: 3
				}, 8, ["modelValue", "offset"])]),
				_: 3
			})], 2);
		};
	}
}), mN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "filter-text",
	props: {
		modelValue: {},
		placeholder: {},
		classPrefix: {},
		filterKey: {}
	},
	emits: ["update:modelValue", "search"],
	setup(e, { emit: t }) {
		let r = z(e, "HFilterText"), i = t, o = A(r.modelValue || ""), s = n(() => r.classPrefix && r.filterKey ? `h-${r.classPrefix}-filter-${r.filterKey}` : "");
		I(() => r.modelValue, (e) => {
			e !== o.value && (o.value = e || "");
		});
		function u(e) {
			i("update:modelValue", e);
		}
		function d() {
			i("search", o.value), i("update:modelValue", o.value);
		}
		return (t, n) => (O(), a("div", { class: x(["h-filter-text", s.value]) }, [l(Ze, {
			modelValue: o.value,
			"onUpdate:modelValue": [n[0] ||= (e) => o.value = e, u],
			placeholder: e.placeholder,
			density: "compact",
			variant: "outlined",
			"hide-details": "",
			"single-line": "",
			class: "h-filter-text-field",
			onKeyup: fe(d, ["enter"])
		}, {
			"prepend-inner": L(() => [l(V, { class: "h-filter-text-search-icon" }, {
				default: L(() => [...n[1] ||= [c("mdi:mdi-magnify", -1)]]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue", "placeholder"])], 2));
	}
}), [["__scopeId", "data-v-1ba261a2"]]), hN = { key: 1 }, gN = {
	key: 0,
	class: "h-filter-select-checkbox-scroll-container"
}, _N = {
	key: 1,
	class: "chip-list d-flex flex-wrap ga-1 py-1"
}, vN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "filter-select",
	props: {
		title: {},
		options: {},
		modelValue: {},
		type: {},
		icon: {},
		classPrefix: {},
		filterKey: {},
		selectLabel: {},
		multiple: { type: Boolean },
		clearable: { type: Boolean },
		buttonProps: {}
	},
	emits: ["update:modelValue"],
	setup(t, { emit: u }) {
		let d = z(t, "HFilterSelect"), f = h("adminFilterDesign", !1), { icon: p, type: m } = ae(d), g = n(() => d.classPrefix && d.filterKey ? `h-${d.classPrefix}-filter-${d.filterKey}` : ""), _ = A(!1), v = A(d.multiple ? Array.isArray(d.modelValue) ? [...d.modelValue] : [] : d.modelValue == null ? [] : [d.modelValue]), b = A(d.multiple && Array.isArray(d.modelValue) ? [...d.modelValue] : []), S = A((d.multiple, null)), C = u, w = n(() => d.options.map((e) => ({
			title: e.label,
			value: e.value,
			raw: e,
			icon: e.icon,
			color: e.color
		}))), T = n(() => {
			if (d.multiple) return null;
			let e = v.value.length > 0 ? v.value[0] : null;
			return d.options.find((t) => t.value === e);
		}), E = n(() => v.value.length > 0), D = n({
			get: () => d.multiple ? b.value : S.value,
			set: (e) => {
				d.multiple ? b.value = e : S.value = e;
			}
		});
		I(() => d.modelValue, (e) => {
			if (d.multiple) JSON.stringify(e) !== JSON.stringify(v.value) && (v.value = Array.isArray(e) ? [...e] : [], b.value = Array.isArray(e) ? [...e] : []);
			else {
				let t = Array.isArray(e) ? e[0] : e, n = t == null ? [] : [t];
				JSON.stringify(n) !== JSON.stringify(v.value) && (v.value = n);
			}
		}, { deep: !0 }), I(_, (e) => {
			e && (d.multiple ? b.value = [...v.value] : d.type === "chip" ? b.value = v.value.length > 0 ? [...v.value] : [] : S.value = v.value.length > 0 ? v.value[0] : null);
		});
		function k(e) {
			return d.multiple ? b.value.includes(e) : b.value.length === 1 && b.value[0] === e;
		}
		function ee(e) {
			let t = b.value.indexOf(e.value);
			t > -1 ? b.value.splice(t, 1) : b.value.push(e.value);
		}
		function M(e) {
			b.value[0] === e.value ? b.value = [] : b.value = [e.value];
		}
		function te(e) {
			let t = b.value.indexOf(e);
			t > -1 && b.value.splice(t, 1);
		}
		function ne(e) {
			return k(e.value) ? e.color || "primary" : "default";
		}
		function re(e) {
			return e ? "on-surface" : void 0;
		}
		function ie(e) {
			return e.color || "primary";
		}
		function oe() {
			if (d.multiple) v.value = [...b.value], C("update:modelValue", b.value);
			else if (d.type === "chip") {
				let e = b.value.length > 0 ? b.value[0] : null;
				v.value = e == null ? [] : [e], C("update:modelValue", e);
			} else C("update:modelValue", S.value);
			_.value = !1;
		}
		function se(e) {
			e && e.stopPropagation(), v.value = [], b.value = [], S.value = null, C("update:modelValue", d.multiple ? [] : null);
		}
		function ce() {
			se(), _.value = !1;
		}
		return (n, u) => {
			let d = N("HActionButton");
			return O(), a("div", { class: x(["h-filter-select h-filter mr-2", g.value]) }, [l(it, {
				modelValue: _.value,
				"onUpdate:modelValue": u[1] ||= (e) => _.value = e,
				"close-on-content-click": !1,
				class: "h-filter-select-main-menu"
			}, {
				activator: L(({ props: n }) => [l(Ke, y(n, {
					class: ["filter-button h-filter-select-activator-btn", {
						"h-admin-filter-button": F(f),
						"h-admin-filter-button--active": F(f) && E.value,
						"h-admin-filter-button--open": F(f) && _.value
					}],
					"prepend-icon": F(p),
					size: t.buttonProps?.size || "default",
					variant: t.buttonProps?.variant || "flat",
					color: t.buttonProps?.color || "neutral-100"
				}), {
					append: L(() => [
						F(f) && E.value ? (O(), r(V, {
							key: 0,
							class: "h-admin-filter-selected-icon",
							icon: "mdi:mdi-check-circle"
						})) : i("", !0),
						t.clearable && E.value ? (O(), r(V, {
							key: 1,
							size: "large",
							class: "h-filter-select-clear-icon",
							onClick: R(se, ["stop"])
						}, {
							default: L(() => [...u[2] ||= [c(" mdi:mdi-close ", -1)]]),
							_: 1
						})) : i("", !0),
						l(V, { size: "large" }, {
							default: L(() => [c(P(_.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down"), 1)]),
							_: 1
						})
					]),
					default: L(() => [c(P(t.title) + " ", 1), E.value ? (O(), a(e, { key: 0 }, [t.multiple && v.value.length > 0 ? (O(), r(At, {
						key: 0,
						content: v.value.length,
						color: "error",
						inline: "",
						class: "ml-2"
					}, null, 8, ["content"])) : !t.multiple && T.value ? (O(), a("span", hN, "(" + P(T.value.label) + ")", 1)) : i("", !0)], 64)) : i("", !0)]),
					_: 1
				}, 16, [
					"prepend-icon",
					"class",
					"size",
					"variant",
					"color"
				])]),
				default: L(() => [l(Be, {
					class: "filter-menu h-filter-select-menu-card",
					elevation: "1",
					rounded: "lg",
					"min-width": "300"
				}, {
					default: L(() => [
						l(We, { class: "h-filter-select-menu-text pa-4" }, {
							default: L(() => [F(m) === "checkbox" ? (O(), a("div", gN, [l(St, { class: "h-filter-select-checkbox-list pa-0" }, {
								default: L(() => [(O(!0), a(e, null, j(t.options, (e) => (O(), r(wt, {
									key: e.value,
									class: "px-1 rounded",
									ripple: !1,
									active: !1,
									onClick: (n) => t.multiple ? ee(e) : M(e)
								}, {
									prepend: L(() => [l(Nt, {
										"model-value": k(e.value),
										color: "primary",
										"hide-details": "",
										density: "compact",
										readonly: ""
									}, null, 8, ["model-value"])]),
									default: L(() => [l(Et, { class: x(["text-body-large", { "font-weight-medium": k(e.value) }]) }, {
										default: L(() => [c(P(e.label), 1)]),
										_: 2
									}, 1032, ["class"])]),
									_: 2
								}, 1032, ["onClick"]))), 128))]),
								_: 1
							})])) : F(m) === "chip" ? (O(), a("div", _N, [(O(!0), a(e, null, j(t.options, (e) => (O(), r(kt, {
								key: e.value,
								size: "small",
								color: ne(e),
								class: x(["h-filter-select-chip-item", { "chip-active": k(e.value) }]),
								onClick: (n) => t.multiple ? ee(e) : M(e)
							}, {
								default: L(() => [
									k(e.value) ? (O(), r(V, {
										key: 0,
										size: "x-small",
										class: "mr-1",
										color: re(!0)
									}, {
										default: L(() => [...u[3] ||= [c("mdi:mdi-check", -1)]]),
										_: 1
									}, 8, ["color"])) : i("", !0),
									o("span", { class: x({ "font-weight-medium": k(e.value) }) }, P(e.label), 3),
									t.multiple && k(e.value) ? (O(), r(V, {
										key: 1,
										size: "x-small",
										class: "ml-1",
										color: re(!0),
										onClick: R((t) => te(e.value), ["stop"])
									}, {
										default: L(() => [...u[4] ||= [c(" mdi:mdi-close ", -1)]]),
										_: 1
									}, 8, ["color", "onClick"])) : i("", !0)
								]),
								_: 2
							}, 1032, [
								"color",
								"class",
								"onClick"
							]))), 128))])) : F(m) === "autocomplete" ? (O(), r($e, {
								key: 2,
								modelValue: D.value,
								"onUpdate:modelValue": u[0] ||= (e) => D.value = e,
								items: w.value,
								label: t.selectLabel,
								density: "compact",
								variant: "outlined",
								"hide-details": "",
								multiple: t.multiple,
								chips: t.multiple,
								"closable-chips": t.multiple,
								class: "h-filter-select-autocomplete"
							}, s({ _: 2 }, [t.multiple ? {
								name: "chip",
								fn: L(({ props: e, internalItem: t }) => [l(kt, y(e, {
									color: ie(t.raw),
									size: "small"
								}), {
									default: L(() => [t.raw.icon ? (O(), r(V, {
										key: 0,
										size: "x-small",
										class: "mr-1"
									}, {
										default: L(() => [c(P(t.raw.icon), 1)]),
										_: 2
									}, 1024)) : i("", !0), c(" " + P(t.title), 1)]),
									_: 2
								}, 1040, ["color"])]),
								key: "0"
							} : void 0]), 1032, [
								"modelValue",
								"items",
								"label",
								"multiple",
								"chips",
								"closable-chips"
							])) : i("", !0)]),
							_: 1
						}),
						l(It),
						l(Ve, { class: "h-filter-select-actions pa-3" }, {
							default: L(() => [l(d, {
								type: "primary",
								size: "small",
								class: "h-filter-select-apply-btn text-uppercase",
								onClick: oe
							}, {
								default: L(() => [c(P(F(B)("apply")), 1)]),
								_: 1
							}), l(d, {
								type: "neutral",
								size: "small",
								class: "h-filter-select-clear-all-btn text-uppercase",
								onClick: ce
							}, {
								default: L(() => [c(P(F(B)("clear_all")), 1)]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				})]),
				_: 1
			}, 8, ["modelValue"])], 2);
		};
	}
}), [["__scopeId", "data-v-96485e31"]]), yN = { class: "d-flex align-center justify-space-between ga-4" }, bN = { class: "text-body-medium h-filter-switch-menu-label" }, xN = /* @__PURE__ */ d({
	__name: "filter-switch",
	props: /*@__PURE__*/ v({
		title: {},
		icon: { default: "mdi:mdi-filter-variant" },
		classPrefix: { default: void 0 },
		filterKey: { default: "" }
	}, {
		modelValue: {
			type: [Boolean, null],
			default: null
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = z(e, "HFilterSwitch"), u = h("adminFilterDesign", !1), { icon: d, title: f } = ae(t), p = ce(e, "modelValue"), m = A(!1), g = A(!1), _ = n(() => t.classPrefix && t.filterKey ? `h-${t.classPrefix}-filter-${t.filterKey}` : ""), v = n(() => p.value !== null && p.value !== void 0), b = n(() => p.value === !0 ? B("yes") : p.value === !1 ? B("no") : "");
		function S() {
			g.value = p.value === !0 || p.value === !1;
		}
		I(p, () => {
			m.value || S();
		}), I(m, (e) => {
			e && S();
		});
		function C(e) {
			return e ? p.value !== !1 : null;
		}
		function w(e) {
			g.value = !!e, p.value = C(!!e);
		}
		function T() {
			m.value = !1;
		}
		function E(e) {
			e && e.stopPropagation(), g.value = !1, p.value = null, m.value = !1;
		}
		return S(), (e, t) => (O(), a("div", { class: x(["h-filter-switch h-filter mr-2", _.value]) }, [l(it, {
			modelValue: m.value,
			"onUpdate:modelValue": t[0] ||= (e) => m.value = e,
			"close-on-content-click": !1,
			class: "h-filter-switch-main-menu"
		}, {
			activator: L(({ props: e }) => [l(Ke, y(e, {
				class: ["filter-button h-filter-switch-activator-btn", {
					"h-admin-filter-button": F(u),
					"h-admin-filter-button--active": F(u) && v.value,
					"h-admin-filter-button--open": F(u) && m.value
				}],
				variant: "outlined",
				"prepend-icon": F(d),
				color: v.value ? "primary" : void 0,
				size: "small"
			}), s({
				default: L(() => [c(P(F(f)) + " " + P(v.value ? `(${b.value})` : "") + " ", 1), v.value ? (O(), r(V, {
					key: 0,
					size: "large",
					class: "ml-1 clear-icon h-filter-switch-clear-icon",
					onClick: E
				}, {
					default: L(() => [...t[1] ||= [c(" mdi:mdi-close ", -1)]]),
					_: 1
				})) : i("", !0)]),
				_: 2
			}, [F(u) ? {
				name: "append",
				fn: L(() => [v.value ? (O(), r(V, {
					key: 0,
					class: "h-admin-filter-selected-icon",
					icon: "mdi:mdi-check-circle"
				})) : i("", !0), l(V, { icon: m.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down" }, null, 8, ["icon"])]),
				key: "0"
			} : void 0]), 1040, [
				"prepend-icon",
				"class",
				"color"
			])]),
			default: L(() => [l(Be, {
				class: "filter-menu h-filter-switch-menu-card",
				elevation: "1",
				rounded: "lg",
				"min-width": "240"
			}, {
				default: L(() => [l(We, { class: "pa-4 h-filter-switch-menu-text" }, {
					default: L(() => [o("div", yN, [o("span", bN, P(F(f)), 1), l(nt, {
						"model-value": g.value,
						class: "h-filter-switch-menu-switch",
						density: "compact",
						"hide-details": "",
						inset: "",
						color: "primary",
						"aria-label": F(f),
						"onUpdate:modelValue": w
					}, null, 8, ["model-value", "aria-label"])])]),
					_: 1
				}), l(Ve, null, {
					default: L(() => [l(Ke, {
						size: "small",
						color: "primary",
						class: "h-filter-switch-apply-btn",
						onClick: T
					}, {
						default: L(() => [c(P(F(B)("apply")), 1)]),
						_: 1
					}), l(Ke, {
						size: "small",
						variant: "text",
						class: "mr-2 h-filter-switch-clear-btn",
						onClick: E
					}, {
						default: L(() => [c(P(F(B)("clear")), 1)]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])], 2));
	}
}), SN = /*#__PURE__*/ Vn({
	__name: "description-table-cell",
	props: {
		value: {
			type: String,
			default: ""
		},
		classPrefix: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let t = z(e, "HDescriptionTableCell"), r = n(() => t.classPrefix ? `h-${t.classPrefix}-table-cell-description` : ""), s = A(!1);
		function u() {
			s.value = !0;
		}
		return (t, n) => e.value ? (O(), a("span", {
			key: 0,
			class: x(r.value)
		}, [l(qe, {
			location: "top",
			class: "h-description-cell-tooltip"
		}, {
			activator: L(({ props: e }) => [l(Ke, y(e, {
				icon: "mdi:mdi-message-text",
				variant: "text",
				size: "small",
				class: "h-description-cell-btn",
				"aria-label": F(B)("click_to_view_description"),
				onClick: u
			}), null, 16, ["aria-label"])]),
			default: L(() => [o("span", null, P(F(B)("click_to_view_description")), 1)]),
			_: 1
		}), l(Rt, {
			modelValue: s.value,
			"onUpdate:modelValue": n[1] ||= (e) => s.value = e,
			"max-width": "600"
		}, {
			default: L(() => [l(Be, null, {
				default: L(() => [l(Ge, { class: "text-headline-medium d-flex justify-space-between align-center" }, {
					default: L(() => [c(P(F(B)("description")) + " ", 1), l(Ke, {
						icon: "mdi:mdi-close",
						variant: "text",
						onClick: n[0] ||= (e) => s.value = !1
					})]),
					_: 1
				}), l(We, { class: "description-content" }, {
					default: L(() => [c(P(e.value), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["modelValue"])], 2)) : i("", !0);
	}
}, [["__scopeId", "data-v-dd0687e5"]]), CN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "chip-group-table-cell",
	props: {
		value: { default: () => [] },
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: () => !1
		},
		classPrefix: { default: "" },
		cellKey: { default: "" },
		column: {
			type: Boolean,
			default: !1
		},
		maxVisible: { default: 2 }
	},
	setup(t) {
		let o = z(t, "HChipGroupTableCell"), s = A(!1), l = h("adminResponsiveChips", !1), u = A(), { width: d } = mt(u), f = A([]), p = () => {
			let e = u.value?.querySelector(".v-chip");
			if (!l || !e) return;
			let t = getComputedStyle(e), n = document.createElement("canvas").getContext("2d");
			if (!n) return;
			n.font = `${t.fontWeight} ${t.fontSize} ${t.fontFamily}`;
			let r = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight) + 2;
			f.value = o.value.map((e) => n.measureText(String(e)).width + r);
		};
		E(async () => {
			p(), await document.fonts?.ready, p();
		}), I(() => o.value, p, {
			deep: !0,
			flush: "post"
		});
		let m = n(() => {
			if (!l || !d.value || f.value.length !== o.value.length) return o.maxVisible;
			if (f.value.reduce((e, t) => e + t, 0) + Math.max(0, o.value.length - 1) * 4 <= d.value) return o.value.length;
			let e = 0, t = 0;
			for (let n of f.value) {
				let r = e + (t ? 4 : 0) + n;
				if (r + (t < o.value.length - 1 ? 44 : 0) > d.value) break;
				e = r, t++;
			}
			return Math.max(1, t);
		}), g = n(() => s.value || o.value.length <= m.value ? o.value : o.value.slice(0, m.value)), _ = n(() => Math.max(0, o.value.length - m.value)), v = n(() => o.classPrefix && o.cellKey ? `h-${o.classPrefix}-table-cell-${o.cellKey}` : "");
		return (n, l) => {
			let d = N("h-chip-table-cell");
			return O(), a("div", {
				ref_key: "container",
				ref: u,
				class: x(["h-chip-group-cell", [v.value, { "h-chip-group-cell--expanded": s.value }]])
			}, [
				(O(!0), a(e, null, j(g.value, (e) => (O(), r(d, {
					key: e,
					value: e,
					color: t.isFilterActive(e) ? "purple-lighten-2" : "tag-default",
					"filter-on-click": t.filterOnClick,
					"is-filter-active": t.isFilterActive,
					"overflow-tooltip": ""
				}, null, 8, [
					"value",
					"color",
					"filter-on-click",
					"is-filter-active"
				]))), 128)),
				_.value > 0 && !s.value ? (O(), r(kt, {
					key: 0,
					size: "small",
					color: "grey-lighten-1",
					variant: "tonal",
					class: "h-chip-group-cell__overflow",
					onClick: l[0] ||= R((e) => s.value = !0, ["stop"])
				}, {
					default: L(() => [c(" +" + P(_.value) + " › ", 1)]),
					_: 1
				})) : i("", !0),
				s.value && F(o).value.length > m.value ? (O(), r(kt, {
					key: 1,
					size: "small",
					color: "grey-lighten-1",
					variant: "tonal",
					class: "h-chip-group-cell__overflow",
					onClick: l[1] ||= R((e) => s.value = !1, ["stop"])
				}, {
					default: L(() => [...l[2] ||= [c(" ‹ ", -1)]]),
					_: 1
				})) : i("", !0)
			], 2);
		};
	}
}), [["__scopeId", "data-v-57471b07"]]), wN = {
	key: 0,
	class: "h-chip-table-cell"
}, TN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "chip-table-cell",
	props: {
		value: { default: "" },
		item: { default: void 0 },
		color: { default: "default" },
		icon: { default: void 0 },
		getColor: {
			type: Function,
			default: void 0
		},
		getIcon: {
			type: Function,
			default: void 0
		},
		formatCell: {
			type: Function,
			default: void 0
		},
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" },
		overflowTooltip: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = z(e, "HChipTableCell"), o = A(null), s = A(!1), u = null, d = n(() => t.formatCell ? t.formatCell(t.value) : typeof t.value == "string" ? t.value : t.value?.name || ""), f = n(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : ""), p = n(() => t.getColor && t.value ? t.getColor(t.value) : t.color), m = n(() => t.getIcon && t.value ? t.getIcon(t.value) : t.icon), h = n(() => t.isFilterActive && t.value ? t.isFilterActive(t.value) : !1), g = n(() => typeof t.filterOnClick == "function"), _ = n(() => t.overflowTooltip || s.value);
		function v() {
			let e = o.value;
			return e ? e instanceof HTMLElement ? e : e.$el instanceof HTMLElement ? e.$el : null : null;
		}
		function y() {
			let e = v(), t = e?.querySelector(".v-chip__content") ?? e;
			if (!(t instanceof HTMLElement)) {
				s.value = !1;
				return;
			}
			s.value = t.scrollWidth > t.clientWidth + 1;
		}
		function S() {
			u?.disconnect();
			let e = v();
			!e || typeof ResizeObserver > "u" || (u = new ResizeObserver(() => y()), u.observe(e));
		}
		function C() {
			t.filterOnClick && t.value && t.filterOnClick(t.value);
		}
		return E(async () => {
			await b(), y(), S(), window.addEventListener("resize", y);
		}), I(d, async () => {
			await b(), y();
		}), w(() => {
			window.removeEventListener("resize", y), u?.disconnect(), u = null;
		}), (e, t) => d.value ? (O(), a("span", wN, [l(kt, {
			ref_key: "chipRef",
			ref: o,
			size: "small",
			color: p.value,
			"aria-label": d.value,
			role: g.value ? "button" : void 0,
			tabindex: g.value ? 0 : void 0,
			class: x([{
				"font-weight-bold": h.value,
				"h-datatable__field": g.value
			}, f.value]),
			onClick: C,
			onKeydown: [fe(C, ["enter"]), fe(R(C, ["prevent"]), ["space"])]
		}, {
			default: L(() => [m.value ? (O(), r(V, {
				key: 0,
				left: "",
				class: "mr-2"
			}, {
				default: L(() => [c(P(m.value), 1)]),
				_: 1
			})) : i("", !0), c(" " + P(d.value), 1)]),
			_: 1
		}, 8, [
			"color",
			"aria-label",
			"role",
			"tabindex",
			"class",
			"onKeydown"
		]), l(qe, {
			activator: "parent",
			location: "top",
			text: d.value,
			disabled: !_.value
		}, null, 8, ["text", "disabled"])])) : i("", !0);
	}
}), [["__scopeId", "data-v-fbcd6874"]]), EN = /* @__PURE__ */ d({
	__name: "btn-table-cell",
	props: {
		value: {
			type: [
				Boolean,
				String,
				Number
			],
			default: void 0
		},
		item: { default: void 0 },
		icon: { default: void 0 },
		color: { default: void 0 },
		getIcon: {
			type: Function,
			default: void 0
		},
		getColor: {
			type: Function,
			default: void 0
		},
		variant: { default: "text" },
		size: { default: "small" },
		filterOnClick: {
			type: Function,
			default: void 0
		},
		isFilterActive: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" }
	},
	setup(e) {
		let t = z(e, "HBtnTableCell"), a = n(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : ""), o = n(() => t.getIcon && t.item ? t.getIcon(t.item) : t.icon || "mdi:mdi-help-circle"), s = n(() => t.getColor && t.item ? t.getColor(t.item) : t.color || "grey"), u = n(() => t.isFilterActive && t.item ? t.isFilterActive(t.item) : !1), d = n(() => typeof t.filterOnClick == "function");
		function f() {
			t.filterOnClick && t.item && t.filterOnClick(t.item);
		}
		return (t, n) => e.value !== void 0 && e.value !== null ? (O(), r(Ke, {
			key: 0,
			icon: o.value,
			color: s.value,
			variant: e.variant,
			size: e.size,
			"aria-label": F(B)(e.cellKey),
			class: x([{
				"font-weight-bold": u.value,
				"h-datatable__field": d.value
			}, a.value]),
			onClick: R(f, ["stop"])
		}, {
			default: L(() => [l(V, { color: s.value }, {
				default: L(() => [c(P(o.value), 1)]),
				_: 1
			}, 8, ["color"])]),
			_: 1
		}, 8, [
			"icon",
			"color",
			"variant",
			"size",
			"aria-label",
			"class"
		])) : i("", !0);
	}
}), DN = ["title"], ON = { class: "h-pre-code-content" }, kN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "pre-code-table-cell",
	props: {
		value: { default: void 0 },
		formatCell: {
			type: Function,
			default: void 0
		},
		classPrefix: { default: "" },
		cellKey: { default: "" }
	},
	setup(e) {
		let t = z(e, "HPreCodeTableCell"), r = A(!1), s = n(() => t.value ? t.formatCell ? t.formatCell(t.value) : typeof t.value == "object" ? JSON.stringify(t.value, null, 2) : t.value : ""), c = n(() => t.classPrefix && t.cellKey ? `h-${t.classPrefix}-table-cell-${t.cellKey}` : "");
		return (e, t) => s.value ? (O(), a("div", {
			key: 0,
			class: x([
				"h-pre-code-table-cell",
				c.value,
				{ "h-pre-code-table-cell--expanded": r.value }
			]),
			style: { cursor: "pointer" },
			title: r.value ? "" : s.value,
			role: "button",
			tabindex: "0",
			onClick: t[0] ||= (e) => r.value = !r.value,
			onKeydown: t[1] ||= fe((e) => r.value = !r.value, ["enter"])
		}, [o("pre", ON, P(s.value), 1)], 42, DN)) : i("", !0);
	}
}), [["__scopeId", "data-v-e369f4cc"]]), AN = /* @__PURE__ */ d({
	__name: "level-options",
	props: {
		modelValue: { default: null },
		options: { default: () => [
			{
				title: "All",
				value: null
			},
			{
				title: "INFO",
				value: "INFO"
			},
			{
				title: "DEBUG",
				value: "DEBUG"
			},
			{
				title: "WARNING",
				value: "WARNING"
			},
			{
				title: "ERROR",
				value: "ERROR"
			}
		] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = bt(e, "modelValue", t);
		return (t, i) => (O(), r(Qe, {
			modelValue: F(n),
			"onUpdate:modelValue": i[0] ||= (e) => g(n) ? n.value = e : null,
			class: "c-system-logs-level-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": F(B)("level"),
			clearable: "",
			placeholder: F(B)("level")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), jN = /* @__PURE__ */ d({
	__name: "source-options",
	props: {
		modelValue: { default: () => [] },
		options: { default: () => [{
			title: "API",
			value: "api"
		}, {
			title: "Worker",
			value: "worker"
		}] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = bt(e, "modelValue", t);
		return (t, i) => (O(), r(Qe, {
			modelValue: F(n),
			"onUpdate:modelValue": i[0] ||= (e) => g(n) ? n.value = e : null,
			class: "c-admin-logs-source-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": F(B)("source"),
			multiple: "",
			placeholder: F(B)("source")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), MN = { class: "c-system-logs-table__header" }, NN = { class: "c-system-logs-table__row-header" }, PN = { class: "c-system-logs-table-header__message" }, FN = { class: "c-system-logs-table-header__timestamp" }, IN = { class: "c-system-logs-table-header__log-level" }, LN = { class: "c-system-logs-table-header__source" }, RN = { class: "c-system-logs-table__body" }, zN = { class: "c-system-logs-table-body__message" }, BN = { class: "c-system-logs-table-body__timestamp" }, VN = { class: "c-system-logs-table-body__log-level" }, HN = { class: "c-system-logs-table-body__source" }, UN = {
	key: 0,
	class: "c-system-logs-table__empty-body"
}, WN = {
	colspan: "4",
	class: "c-system-logs-table-body__empty"
}, GN = /* @__PURE__ */ d({
	__name: "logs-table",
	props: { logs: { default: () => [] } },
	setup(t) {
		let { formatDate: n } = Oe();
		function s(e) {
			switch (e?.toUpperCase()) {
				case "ERROR": return "bg-error";
				case "WARNING":
				case "WARN": return "bg-warning";
				case "DEBUG": return "bg-tertiary";
				default: return "bg-primary";
			}
		}
		return (u, d) => (O(), r(zt, { class: "c-system-logs-table" }, {
			default: L(() => [o("thead", MN, [o("tr", NN, [
				o("th", PN, P(F(B)("message")), 1),
				o("th", FN, P(F(B)("timestamp")), 1),
				o("th", IN, P(F(B)("level")), 1),
				o("th", LN, P(F(B)("source")), 1)
			])]), o("tbody", RN, [(O(!0), a(e, null, j(t.logs, (e) => (O(), a("tr", {
				key: `${e["@timestamp"]}-${e.message}`,
				class: "c-system-logs-table__row-body"
			}, [
				o("td", zN, P(e.message), 1),
				o("td", BN, P(F(n)(e["@timestamp"])), 1),
				o("td", VN, [l(kt, { class: x(["c-system-log-level", s(e["log.level"])]) }, {
					default: L(() => [c(P(e["log.level"]), 1)]),
					_: 2
				}, 1032, ["class"])]),
				o("td", HN, P(e.name), 1)
			]))), 128)), t.logs?.length ? i("", !0) : (O(), a("tr", UN, [o("td", WN, P(F(B)("no_data_available")), 1)]))])]),
			_: 1
		}));
	}
}), KN = /* @__PURE__ */ d({
	__name: "from-date-options",
	props: {
		modelValue: { default: 300 },
		options: { default: () => [
			{
				title: B("admin_logs_last_5_minutes"),
				value: 300
			},
			{
				title: B("admin_logs_last_30_minutes"),
				value: 1800
			},
			{
				title: B("admin_logs_last_1_hour"),
				value: 3600
			},
			{
				title: B("admin_logs_last_4_hours"),
				value: 14400
			},
			{
				title: B("admin_logs_last_8_hours"),
				value: 28800
			},
			{
				title: B("admin_logs_last_1_day"),
				value: 86400
			},
			{
				title: B("admin_logs_last_3_days"),
				value: 259200
			}
		] }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let n = bt(e, "modelValue", t);
		return (t, i) => (O(), r(Qe, {
			modelValue: F(n),
			"onUpdate:modelValue": i[0] ||= (e) => g(n) ? n.value = e : null,
			class: "c-admin-logs-from-date-options",
			items: e.options,
			"item-title": "title",
			"item-value": "value",
			"aria-label": F(B)("admin_logs_time_range"),
			placeholder: F(B)("admin_logs_time_range")
		}, null, 8, [
			"modelValue",
			"items",
			"aria-label",
			"placeholder"
		]));
	}
}), qN = { class: "h-themepack-provider" }, JN = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "themepack-provider",
	setup(e) {
		let t = Vt(), { hThemePack: n, hSetThemePack: r } = Ne(), i = ut(), { defaults: o } = Pe();
		return I([() => n?.value?.name, () => i?.meta?.theme], ([e, n]) => {
			let i = !!n, a = n || e;
			a && (t.change(a), i && r(a, { temporary: !0 }));
		}, { immediate: !0 }), (e, t) => (O(), a("div", qN, [l(Ht, { defaults: F(o) }, {
			default: L(() => [M(e.$slots, "default", {}, void 0, !0)]),
			_: 3
		}, 8, ["defaults"])]));
	}
}), [["__scopeId", "data-v-9d7cf0df"]]), YN = { class: "text-body-medium font-weight-medium text-medium-emphasis" }, XN = { class: "text-body-medium font-weight-semibold" }, ZN = /* @__PURE__ */ d({
	__name: "info-display",
	props: {
		variant: { default: "list" },
		title: {},
		description: {},
		avatar: {},
		avatarColor: { default: "#9dd5d6" },
		chipColor: { default: "#835400" },
		chipTextColor: { default: "white" },
		actionType: { default: "primary" },
		items: { default: () => [] }
	},
	setup(t) {
		return z(t, "HInfoDisplay"), (n, s) => (O(), r(Je, { class: x(["h-info-display pa-0", `h-info-display--${t.variant}`]) }, {
			default: L(() => [
				t.title || t.avatar ? (O(), r(Ye, {
					key: 0,
					class: "h-info-display__header mb-0"
				}, {
					default: L(() => [l(H, { cols: "12" }, {
						default: L(() => [M(n.$slots, "header", {
							title: t.title,
							description: t.description,
							avatar: t.avatar
						}, () => [l(Ye, { class: "align-center ga-4 ma-0 mb-0" }, {
							default: L(() => [t.avatar ? (O(), r(H, {
								key: 0,
								cols: "auto",
								class: "pa-0"
							}, {
								default: L(() => [M(n.$slots, "avatar", {
									avatar: t.avatar,
									avatarColor: t.avatarColor
								}, () => [l(Lt, {
									size: "48",
									color: t.avatarColor,
									class: "h-info-display__avatar text-headline-small font-weight-medium"
								}, {
									default: L(() => [c(P(t.avatar), 1)]),
									_: 1
								}, 8, ["color"])])]),
								_: 3
							})) : i("", !0), t.title ? (O(), r(H, {
								key: 1,
								cols: "auto",
								class: "text-headline-medium font-weight-semibold pa-0"
							}, {
								default: L(() => [M(n.$slots, "title", { title: t.title }, () => [c(P(t.title), 1)])]),
								_: 3
							})) : i("", !0)]),
							_: 3
						})])]),
						_: 3
					})]),
					_: 3
				})) : i("", !0),
				t.description ? (O(), r(Ye, {
					key: 1,
					class: "h-info-display__description mb-0"
				}, {
					default: L(() => [l(H, {
						cols: "12",
						class: "text-headline-small font-weight-regular"
					}, {
						default: L(() => [M(n.$slots, "description", { description: t.description }, () => [c(P(t.description), 1)])]),
						_: 3
					})]),
					_: 3
				})) : i("", !0),
				t.items && t.items.length > 0 ? (O(), r(Je, {
					key: 2,
					class: "h-info-display__items pa-0"
				}, {
					default: L(() => [(O(!0), a(e, null, j(t.items, (s, u) => (O(), a(e, { key: u }, [l(Ye, { class: "h-info-display__item align-center py-3 ma-0" }, {
						default: L(() => [M(n.$slots, "item", { item: s }, () => [l(Je, { class: "pa-0" }, {
							default: L(() => [l(Ye, {
								class: "align-center ma-0",
								style: { gap: "8px" }
							}, {
								default: L(() => [
									l(H, {
										cols: "auto",
										class: "d-flex align-center pa-0",
										style: {
											"min-width": "150px",
											gap: "8px"
										}
									}, {
										default: L(() => [M(n.$slots, "item-icon", { item: s }, () => [s.icon ? (O(), r(V, {
											key: 0,
											size: "20",
											color: "medium-emphasis",
											class: "h-info-display__icon"
										}, {
											default: L(() => [c(P(s.icon), 1)]),
											_: 2
										}, 1024)) : i("", !0)]), M(n.$slots, "item-label", { item: s }, () => [o("span", YN, P(s.label), 1)])]),
										_: 2
									}, 1024),
									l(H, {
										cols: "auto",
										class: "pa-0"
									}, {
										default: L(() => [M(n.$slots, "item-value", { item: s }, () => [o("span", XN, P(s.value), 1)])]),
										_: 2
									}, 1024),
									s.chip ? (O(), r(H, {
										key: 0,
										cols: "auto",
										class: "pa-0"
									}, {
										default: L(() => [M(n.$slots, "item-chip", { item: s }, () => [l(kt, {
											color: s.chip.color || t.chipColor,
											size: "small",
											class: "h-info-display__chip",
											style: C({ color: s.chip.textColor || t.chipTextColor })
										}, {
											default: L(() => [s.chip.icon ? (O(), r(V, {
												key: 0,
												start: "",
												size: "15"
											}, {
												default: L(() => [c(P(s.chip.icon), 1)]),
												_: 2
											}, 1024)) : i("", !0), c(" " + P(s.chip.text), 1)]),
											_: 2
										}, 1032, ["color", "style"])])]),
										_: 2
									}, 1024)) : i("", !0),
									s.actions ? (O(), r(H, {
										key: 1,
										cols: "auto",
										class: "ml-auto pa-0"
									}, {
										default: L(() => [M(n.$slots, "item-actions", { item: s }, () => [l(Je, { class: "pa-0" }, {
											default: L(() => [l(Ye, {
												class: "ma-0",
												style: { gap: "8px" }
											}, {
												default: L(() => [(O(!0), a(e, null, j(Array.isArray(s.actions) ? s.actions : [s.actions], (e, n) => (O(), r(H, {
													key: n,
													cols: "auto",
													class: "pa-0"
												}, {
													default: L(() => [l(ew, {
														type: e.type || t.actionType,
														color: e.color,
														size: "small",
														class: "h-info-display__action",
														onClick: e.onClick
													}, {
														default: L(() => [e.icon ? (O(), r(V, {
															key: 0,
															start: "",
															size: "16"
														}, {
															default: L(() => [c(P(e.icon), 1)]),
															_: 2
														}, 1024)) : i("", !0), c(" " + P(e.text), 1)]),
														_: 2
													}, 1032, [
														"type",
														"color",
														"onClick"
													])]),
													_: 2
												}, 1024))), 128))]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1024)])]),
										_: 2
									}, 1024)) : i("", !0)
								]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)])]),
						_: 2
					}, 1024), u < t.items.length - 1 ? (O(), r(Ye, {
						key: 0,
						class: "h-info-display__divider ma-0"
					}, {
						default: L(() => [l(H, {
							cols: "12",
							class: "pa-0"
						}, {
							default: L(() => [l(It, { opacity: .3 })]),
							_: 1
						})]),
						_: 1
					})) : i("", !0)], 64))), 128))]),
					_: 3
				})) : (O(), r(Ye, {
					key: 3,
					class: "h-info-display__empty"
				}, {
					default: L(() => [l(H, {
						cols: "12",
						class: "text-body-medium text-medium-emphasis text-center py-6"
					}, {
						default: L(() => [M(n.$slots, "empty", {}, () => [c(P(F(B)("info_display_empty_state")), 1)])]),
						_: 3
					})]),
					_: 3
				}))
			]),
			_: 3
		}, 8, ["class"]));
	}
}), QN = { class: "h-live-updates d-flex" }, $N = {
	key: 0,
	class: "h-live-updates-interval-option"
}, eP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "live-update-controls",
	props: {
		interval: {},
		isLiveUpdatesEnabled: {
			type: Boolean,
			default: () => !0
		},
		items: { default: () => [
			{
				title: B("n_seconds", { seconds: 1 }),
				value: 1e3
			},
			{
				title: B("n_seconds", { seconds: 2 }),
				value: 2e3
			},
			{
				title: B("n_seconds", { seconds: 5 }),
				value: 5e3
			},
			{
				title: B("n_seconds", { seconds: 30 }),
				value: 3e4
			},
			{
				title: B("n_minutes", { minutes: 1 }),
				value: 6e4
			},
			{
				title: B("n_minutes", { minutes: 5 }),
				value: 3e5
			}
		] }
	},
	emits: [
		"update:interval",
		"update:isLiveUpdatesEnabled",
		"interval-trigger"
	],
	setup(e, { emit: t }) {
		let r = z(e, "HLiveUpdateControls"), o = t, { interval: s, isLiveUpdatesEnabled: c } = xt(r, o), u = n(() => m.value ? "mdi:mdi-pause" : "mdi:mdi-play"), d = n(() => m.value ? B("pause_live_updates") : B("resume_live_updates")), { pause: f, resume: p, isActive: m } = gt(() => {
			o("interval-trigger");
		}, s, { immediate: c.value }), h = () => {
			m.value ? f() : p(), c.value = m.value;
		};
		return (t, n) => (O(), a("div", QN, [l(Ke, {
			class: "h-live-updates__btn",
			"aria-label": d.value,
			onClick: h
		}, {
			default: L(() => [l(V, {
				class: "h-live-updates__btn-icon",
				icon: u.value
			}, null, 8, ["icon"])]),
			_: 1
		}, 8, ["aria-label"]), l(Qe, {
			modelValue: F(s),
			"onUpdate:modelValue": n[0] ||= (e) => g(s) ? s.value = e : null,
			class: "h-live-updates__interval-options",
			items: e.items,
			"aria-label": F(B)("update_interval")
		}, {
			selection: L(({ item: e }) => [e ? (O(), a("span", $N, P(F(B)("update_every_n", { value: e.title })), 1)) : i("", !0)]),
			_: 1
		}, 8, [
			"modelValue",
			"items",
			"aria-label"
		])]));
	}
}), [["__scopeId", "data-v-37f206d9"]]), tP = {
	key: 0,
	class: "h-alert__actions d-flex flex-wrap"
}, nP = {
	key: 0,
	class: "d-flex flex-wrap mt-2"
}, rP = { class: "d-flex align-center" }, iP = { class: "d-flex ml-auto mr-0 justify-end" }, aP = /* @__PURE__ */ d({
	__name: "alert-bar",
	props: { alert: {} },
	setup(t) {
		let s = z(t, "HAlertBar"), { smAndUp: u } = Bt(), d = A(!!s.alert.hasTimedOut);
		vt(() => {
			d.value = !0, s.alert.hasTimedOut = !0;
		}, () => s.alert.timeout || 0, { immediate: !!s.alert.timeout && !s.alert.hasTimedOut });
		let f = n(() => s.alert.details?.isCode ? "h-pretty-code" : "div"), p = n(() => {
			let e = s.alert.details?.additionalInfo;
			if (e == null) return "";
			if (typeof e == "string") return e;
			try {
				return JSON.stringify(e, null, 2);
			} catch {
				return String(e);
			}
		}), m = A(s.alert.details?.description ? void 0 : 0), h = n({
			get: () => s.alert.isShowingDetails,
			set: (e) => {
				s.alert.isShowingDetails = e;
			}
		});
		function g() {
			h.value = !1;
		}
		function _(e) {
			e.willShowDetailsOnClick && (h.value = !0), e.onClick && e.onClick();
		}
		function v() {
			s.alert.isClosed = !0;
		}
		async function b() {
			p.value && await navigator.clipboard.writeText(p.value);
		}
		return (n, s) => {
			let x = N("h-theme-scope"), S = N("h-pretty-code");
			return O(), a(e, null, [(!t.alert.timeout || !d.value) && !t.alert.hasTimedOut && !t.alert.isClosed ? (O(), r(Jt, y({ key: 0 }, n.$attrs, {
				key: t.alert.id,
				class: "h-alert",
				type: t.alert.type,
				closable: t.alert.closable ?? !0,
				"onClick:close": s[0] ||= (e) => v()
			}), {
				title: L(() => [
					o("div", null, P(t.alert.title), 1),
					l(Xe, { class: "h-alert-bar-title-spacer" }),
					F(u) ? (O(), a("div", tP, [(O(!0), a(e, null, j(t.alert.actions, (e) => (O(), r(x, {
						key: e.text,
						name: "HScopedAlertBarDesktopActionBtn",
						component: F(Gt),
						class: "h-alert__action",
						href: e.href,
						target: e.target,
						color: e.buttonColor,
						variant: e.buttonVariant,
						density: "comfortable",
						onClick: (t) => _(e)
					}, {
						default: L(() => [c(P(e.text), 1)]),
						_: 2
					}, 1032, [
						"component",
						"href",
						"target",
						"color",
						"variant",
						"onClick"
					]))), 128))])) : i("", !0)
				]),
				text: L(() => [o("div", null, [o("div", null, P(t.alert.body), 1), F(u) ? i("", !0) : (O(), a("div", nP, [(O(!0), a(e, null, j(t.alert.actions, (e) => (O(), r(x, {
					key: e.text,
					name: "HScopedAlertBarMobileActionBtn",
					component: F(Gt),
					class: "h-alert__action",
					href: e.href,
					target: e.target,
					color: e.buttonColor,
					variant: e.buttonVariant,
					density: "comfortable",
					onClick: (t) => _(e)
				}, {
					default: L(() => [c(P(e.text), 1)]),
					_: 2
				}, 1032, [
					"component",
					"href",
					"target",
					"color",
					"variant",
					"onClick"
				]))), 128))]))])]),
				_: 1
			}, 16, ["type", "closable"])) : i("", !0), l(Rt, {
				modelValue: h.value,
				"onUpdate:modelValue": s[4] ||= (e) => h.value = e,
				class: "h-alert-details__dialog"
			}, {
				default: L(() => [l(Be, {
					class: "h-alert-details",
					color: t.alert.type
				}, {
					default: L(() => [l(Ge, { class: "h-alert-bar-details-title" }, {
						default: L(() => [o("div", rP, [o("div", null, P(t.alert.details?.title), 1), o("div", iP, [t.alert.canCopy ? (O(), r(F(Gt), {
							key: 0,
							icon: "fa fa-copy",
							variant: "text",
							class: "h-alert-bar-details-copy-btn d-block text-body-large",
							onClick: s[1] ||= (e) => b()
						})) : i("", !0), l(F(Gt), {
							icon: "fa fa-times",
							variant: "text",
							class: "h-alert-bar-details-close-btn d-block ml-2 text-body-large",
							onClick: s[2] ||= (e) => g()
						})])])]),
						_: 1
					}), l(We, { class: "h-alert-bar-details-text pa-3" }, {
						default: L(() => [t.alert.details?.description ? (O(), r(Ye, {
							key: 0,
							class: "h-alert-bar-details-row"
						}, {
							default: L(() => [l(H, { class: "h-alert-bar-details-col" }, {
								default: L(() => [(O(), r(te(f.value), {
									class: "h-alert-details__message",
									language: t.alert.details?.codeLanguage
								}, {
									default: L(() => [c(P(t.alert.details.description), 1)]),
									_: 1
								}, 8, ["language"]))]),
								_: 1
							})]),
							_: 1
						})) : i("", !0), l(Ye, { class: "h-alert-bar-details-row" }, {
							default: L(() => [t.alert.details?.additionalInfo ? (O(), r(H, {
								key: 0,
								class: "h-alert-bar-details-col"
							}, {
								default: L(() => [l(Zt, {
									modelValue: m.value,
									"onUpdate:modelValue": s[3] ||= (e) => m.value = e,
									class: "h-alert-bar-details-expansion-panels"
								}, {
									default: L(() => [l(Yt, {
										class: "h-alert-bar-details-expansion-panel",
										title: F(B)("alert_additional_info")
									}, {
										default: L(() => [l(Xt, { class: "h-alert-bar-details-expansion-panel-text" }, {
											default: L(() => [l(S, null, {
												default: L(() => [c(P(p.value), 1)]),
												_: 1
											})]),
											_: 1
										})]),
										_: 1
									}, 8, ["title"])]),
									_: 1
								}, 8, ["modelValue"])]),
								_: 1
							})) : i("", !0)]),
							_: 1
						})]),
						_: 1
					})]),
					_: 1
				}, 8, ["color"])]),
				_: 1
			}, 8, ["modelValue"])], 64);
		};
	}
}), oP = "h-alerts-provider", sP = /* @__PURE__ */ d({
	__name: "alerts-provider",
	props: {
		location: {},
		maxShownAlerts: {}
	},
	setup(t) {
		let i = Ie(), o = z(t, "HAlertsProvider"), { hAlerts: s } = xe(), c = A(o.location ?? i?.alerts_location ?? "bottom-center"), l = n(() => {
			switch (c.value) {
				case "top-right": return `${oP}--top ${oP}--right`;
				case "top-left": return `${oP}--top ${oP}--left`;
				case "bottom-right": return `${oP}--bottom ${oP}--right`;
				case "bottom-left": return `${oP}--bottom ${oP}--left`;
				case "bottom-center": return `${oP}--bottom ${oP}--center`;
				case "top-center": return `${oP}--top ${oP}--center`;
				default: return "";
			}
		});
		return (t, n) => (O(), a("div", { class: x({
			[oP]: !0,
			[l.value]: !0
		}) }, [(O(!0), a(e, null, j(F(s), (e) => (O(), r(aP, {
			key: e.id,
			class: "h-alerts-provider__alert",
			alert: e
		}, null, 8, ["alert"]))), 128))], 2));
	}
}), cP = /* @__PURE__ */ d({
	__name: "file-upload",
	props: {
		uploadUrl: {},
		selectedFiles: {}
	},
	emits: ["update:selectedFiles"],
	setup(e, { emit: t }) {
		let { selectedFiles: n } = xt(z(e, "HFileUpload"), t);
		return (e, t) => (O(), r(Qt, {
			modelValue: F(n),
			"onUpdate:modelValue": t[0] ||= (e) => g(n) ? n.value = e : null,
			multiple: "",
			class: "h-file-upload",
			accept: "image/png, image/jpeg, .png, .jpg, .jpeg .doc, .docx, .xml,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			"show-size": ""
		}, null, 8, ["modelValue"]));
	}
}), lP = /* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "page-head",
	props: {
		pageTitle: {},
		pagePrefix: {},
		pageMeta: {}
	},
	setup(e) {
		let t = Ie(), a = e, o = n(() => {
			let e = (a.pagePrefix ?? t?.custom_title?.value ?? "Onify - ").replace(/[\s-]+$/, "");
			return e ? `${e} - ` : "";
		}), { hSetTitle: s, hSetMeta: c, hDisposeHead: l, hUpdateHead: u } = Me(), d = le(), f = n(() => d?.default?.()?.[0]);
		function p() {
			s(a.pageTitle ?? null, (e) => `${o.value}${e ?? ""}`);
		}
		function m() {
			c(a.pageMeta ?? []);
		}
		function h() {
			p(), m(), u();
		}
		return E(h), D(() => {
			l();
		}), I([
			() => a.pageTitle,
			() => a.pagePrefix,
			() => a.pageMeta,
			o
		], h), (e, t) => f.value ? (O(), r(te(f.value), S(y({ key: 0 }, e.$attrs)), null, 16)) : i("", !0);
	}
}), uP = { class: "text-display-small" }, dP = { class: "text-headline-medium" }, fP = /* @__PURE__ */ d({
	__name: "legacy-form-container",
	props: {
		title: {},
		description: {},
		width: {},
		minWidth: {},
		maxWidth: {}
	},
	setup(e) {
		return z(e, "HLegacyFormContainer"), (t, n) => (O(), r(lP, null, {
			default: L(() => [l(Je, { class: "h-legacy-form-container" }, {
				default: L(() => [l(Ye, { class: "h-legacy-form-container-title-row" }, {
					default: L(() => [l(H, { class: "h-legacy-form-container-title-col py-4" }, {
						default: L(() => [o("div", uP, P(e.title), 1), o("div", dP, P(e.description), 1)]),
						_: 1
					})]),
					_: 1
				}), l(Ye, { class: "h-legacy-form-container-content-row" }, {
					default: L(() => [l(H, { class: "h-legacy-form-container-content-col" }, {
						default: L(() => [l($t, {
							class: "h-legacy-form-container__card rounded text-left bg-surface",
							width: e.width,
							"min-width": e.minWidth,
							"max-width": e.maxWidth
						}, {
							default: L(() => [M(t.$slots, "default")]),
							_: 3
						}, 8, [
							"width",
							"min-width",
							"max-width"
						])]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}));
	}
}), pP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "form-container",
	setup(e) {
		return (e, t) => (O(), r(lP, null, {
			default: L(() => [l(en, { class: "h-form-container h-100" }, {
				default: L(() => [e.$vuetify.display.mdAndUp ? (O(), r(nn, {
					key: 0,
					class: "h-form-container__drawer h-100",
					elevation: 0,
					permanent: "",
					floating: ""
				})) : i("", !0), l(tn, { class: "h-form-container-main-content" }, {
					default: L(() => [l(H, { class: "h-form-container__form text-left" }, {
						default: L(() => [M(e.$slots, "default", {}, void 0, !0)]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}));
	}
}), [["__scopeId", "data-v-c4de7168"]]), mP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "page-container",
	props: {
		pageTitle: {},
		pagePrefix: {}
	},
	setup(e) {
		return z(e, "HPageContainer"), (t, n) => (O(), r(lP, {
			"page-title": e.pageTitle,
			"page-prefix": e.pagePrefix
		}, {
			default: L(() => [l(Je, {
				class: "h-page-container text-left",
				fluid: ""
			}, {
				default: L(() => [l(Ye, null, {
					default: L(() => [l(H, null, {
						default: L(() => [M(t.$slots, "default", {}, void 0, !0)]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		}, 8, ["page-title", "page-prefix"]));
	}
}), [["__scopeId", "data-v-037b55fa"]]), hP = {}, gP = { class: "h-dialog-container" };
function _P(e, t) {
	return O(), a("div", gP, [M(e.$slots, "default")]);
}
var vP = /*#__PURE__*/ Vn(hP, [["render", _P]]), yP = {}, bP = { class: "h-page-title" };
function xP(e, t) {
	return O(), a("div", bP, [M(e.$slots, "default")]);
}
var SP = /*#__PURE__*/ Vn(yP, [["render", xP]]), CP = {}, wP = { class: "h-page-subtitle" };
function TP(e, t) {
	return O(), a("div", wP, [M(e.$slots, "default", {}, void 0, !0)]);
}
var EP = /*#__PURE__*/ Vn(CP, [["render", TP], ["__scopeId", "data-v-96a9c924"]]), DP = {}, OP = { class: "h-page-description mb-2" };
function kP(e, t) {
	return O(), a("div", OP, [M(e.$slots, "default", {}, void 0, !0)]);
}
var AP = /*#__PURE__*/ Vn(DP, [["render", kP], ["__scopeId", "data-v-5ccba0f4"]]), jP = /* @__PURE__ */ Nn((/* @__PURE__ */ An(((e, t) => {
	var n = function(e) {
		var t = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, n = 0, r = {}, i = {
			manual: e.Prism && e.Prism.manual,
			disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
			util: {
				encode: function e(t) {
					return t instanceof a ? new a(t.type, e(t.content), t.alias) : Array.isArray(t) ? t.map(e) : t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
				},
				type: function(e) {
					return Object.prototype.toString.call(e).slice(8, -1);
				},
				objId: function(e) {
					return e.__id || Object.defineProperty(e, "__id", { value: ++n }), e.__id;
				},
				clone: function e(t, n) {
					n ||= {};
					var r, a;
					switch (i.util.type(t)) {
						case "Object":
							if (a = i.util.objId(t), n[a]) return n[a];
							for (var o in r = {}, n[a] = r, t) t.hasOwnProperty(o) && (r[o] = e(t[o], n));
							return r;
						case "Array": return a = i.util.objId(t), n[a] ? n[a] : (r = [], n[a] = r, t.forEach(function(t, i) {
							r[i] = e(t, n);
						}), r);
						default: return t;
					}
				},
				getLanguage: function(e) {
					for (; e;) {
						var n = t.exec(e.className);
						if (n) return n[1].toLowerCase();
						e = e.parentElement;
					}
					return "none";
				},
				setLanguage: function(e, n) {
					e.className = e.className.replace(RegExp(t, "gi"), ""), e.classList.add("language-" + n);
				},
				currentScript: function() {
					if (typeof document > "u") return null;
					if (document.currentScript && document.currentScript.tagName === "SCRIPT") return document.currentScript;
					try {
						throw Error();
					} catch (r) {
						var e = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r.stack) || [])[1];
						if (e) {
							var t = document.getElementsByTagName("script");
							for (var n in t) if (t[n].src == e) return t[n];
						}
						return null;
					}
				},
				isActive: function(e, t, n) {
					for (var r = "no-" + t; e;) {
						var i = e.classList;
						if (i.contains(t)) return !0;
						if (i.contains(r)) return !1;
						e = e.parentElement;
					}
					return !!n;
				}
			},
			languages: {
				plain: r,
				plaintext: r,
				text: r,
				txt: r,
				extend: function(e, t) {
					var n = i.util.clone(i.languages[e]);
					for (var r in t) n[r] = t[r];
					return n;
				},
				insertBefore: function(e, t, n, r) {
					r ||= i.languages;
					var a = r[e], o = {};
					for (var s in a) if (a.hasOwnProperty(s)) {
						if (s == t) for (var c in n) n.hasOwnProperty(c) && (o[c] = n[c]);
						n.hasOwnProperty(s) || (o[s] = a[s]);
					}
					var l = r[e];
					return r[e] = o, i.languages.DFS(i.languages, function(t, n) {
						n === l && t != e && (this[t] = o);
					}), o;
				},
				DFS: function e(t, n, r, a) {
					a ||= {};
					var o = i.util.objId;
					for (var s in t) if (t.hasOwnProperty(s)) {
						n.call(t, s, t[s], r || s);
						var c = t[s], l = i.util.type(c);
						l === "Object" && !a[o(c)] ? (a[o(c)] = !0, e(c, n, null, a)) : l === "Array" && !a[o(c)] && (a[o(c)] = !0, e(c, n, s, a));
					}
				}
			},
			plugins: {},
			highlightAll: function(e, t) {
				i.highlightAllUnder(document, e, t);
			},
			highlightAllUnder: function(e, t, n) {
				var r = {
					callback: n,
					container: e,
					selector: "code[class*=\"language-\"], [class*=\"language-\"] code, code[class*=\"lang-\"], [class*=\"lang-\"] code"
				};
				i.hooks.run("before-highlightall", r), r.elements = Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)), i.hooks.run("before-all-elements-highlight", r);
				for (var a = 0, o; o = r.elements[a++];) i.highlightElement(o, t === !0, r.callback);
			},
			highlightElement: function(t, n, r) {
				var a = i.util.getLanguage(t), o = i.languages[a];
				i.util.setLanguage(t, a);
				var s = t.parentElement;
				s && s.nodeName.toLowerCase() === "pre" && i.util.setLanguage(s, a);
				var c = {
					element: t,
					language: a,
					grammar: o,
					code: t.textContent
				};
				function l(e) {
					c.highlightedCode = e, i.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, i.hooks.run("after-highlight", c), i.hooks.run("complete", c), r && r.call(c.element);
				}
				if (i.hooks.run("before-sanity-check", c), s = c.element.parentElement, s && s.nodeName.toLowerCase() === "pre" && !s.hasAttribute("tabindex") && s.setAttribute("tabindex", "0"), !c.code) {
					i.hooks.run("complete", c), r && r.call(c.element);
					return;
				}
				if (i.hooks.run("before-highlight", c), !c.grammar) {
					l(i.util.encode(c.code));
					return;
				}
				if (n && e.Worker) {
					var u = new Worker(i.filename);
					u.onmessage = function(e) {
						l(e.data);
					}, u.postMessage(JSON.stringify({
						language: c.language,
						code: c.code,
						immediateClose: !0
					}));
				} else l(i.highlight(c.code, c.grammar, c.language));
			},
			highlight: function(e, t, n) {
				var r = {
					code: e,
					grammar: t,
					language: n
				};
				if (i.hooks.run("before-tokenize", r), !r.grammar) throw Error("The language \"" + r.language + "\" has no grammar.");
				return r.tokens = i.tokenize(r.code, r.grammar), i.hooks.run("after-tokenize", r), a.stringify(i.util.encode(r.tokens), r.language);
			},
			tokenize: function(e, t) {
				var n = t.rest;
				if (n) {
					for (var r in n) t[r] = n[r];
					delete t.rest;
				}
				var i = new c();
				return l(i, i.head, e), s(e, i, t, i.head, 0), d(i);
			},
			hooks: {
				all: {},
				add: function(e, t) {
					var n = i.hooks.all;
					n[e] = n[e] || [], n[e].push(t);
				},
				run: function(e, t) {
					var n = i.hooks.all[e];
					if (!(!n || !n.length)) for (var r = 0, a; a = n[r++];) a(t);
				}
			},
			Token: a
		};
		e.Prism = i;
		function a(e, t, n, r) {
			this.type = e, this.content = t, this.alias = n, this.length = (r || "").length | 0;
		}
		a.stringify = function e(t, n) {
			if (typeof t == "string") return t;
			if (Array.isArray(t)) {
				var r = "";
				return t.forEach(function(t) {
					r += e(t, n);
				}), r;
			}
			var a = {
				type: t.type,
				content: e(t.content, n),
				tag: "span",
				classes: ["token", t.type],
				attributes: {},
				language: n
			}, o = t.alias;
			o && (Array.isArray(o) ? Array.prototype.push.apply(a.classes, o) : a.classes.push(o)), i.hooks.run("wrap", a);
			var s = "";
			for (var c in a.attributes) s += " " + c + "=\"" + (a.attributes[c] || "").replace(/"/g, "&quot;") + "\"";
			return "<" + a.tag + " class=\"" + a.classes.join(" ") + "\"" + s + ">" + a.content + "</" + a.tag + ">";
		};
		function o(e, t, n, r) {
			e.lastIndex = t;
			var i = e.exec(n);
			if (i && r && i[1]) {
				var a = i[1].length;
				i.index += a, i[0] = i[0].slice(a);
			}
			return i;
		}
		function s(e, t, n, r, c, d) {
			for (var f in n) if (!(!n.hasOwnProperty(f) || !n[f])) {
				var p = n[f];
				p = Array.isArray(p) ? p : [p];
				for (var m = 0; m < p.length; ++m) {
					if (d && d.cause == f + "," + m) return;
					var h = p[m], g = h.inside, _ = !!h.lookbehind, v = !!h.greedy, y = h.alias;
					if (v && !h.pattern.global) {
						var b = h.pattern.toString().match(/[imsuy]*$/)[0];
						h.pattern = RegExp(h.pattern.source, b + "g");
					}
					for (var x = h.pattern || h, S = r.next, C = c; S !== t.tail && !(d && C >= d.reach); C += S.value.length, S = S.next) {
						var w = S.value;
						if (t.length > e.length) return;
						if (!(w instanceof a)) {
							var T = 1, E;
							if (v) {
								if (E = o(x, C, e, _), !E || E.index >= e.length) break;
								var D = E.index, O = E.index + E[0].length, k = C;
								for (k += S.value.length; D >= k;) S = S.next, k += S.value.length;
								if (k -= S.value.length, C = k, S.value instanceof a) continue;
								for (var ee = S; ee !== t.tail && (k < O || typeof ee.value == "string"); ee = ee.next) T++, k += ee.value.length;
								T--, w = e.slice(C, k), E.index -= C;
							} else if (E = o(x, 0, w, _), !E) continue;
							var D = E.index, A = E[0], j = w.slice(0, D), M = w.slice(D + A.length), N = C + w.length;
							d && N > d.reach && (d.reach = N);
							var te = S.prev;
							j && (te = l(t, te, j), C += j.length), u(t, te, T);
							var ne = new a(f, g ? i.tokenize(A, g) : A, y, A);
							if (S = l(t, te, ne), M && l(t, S, M), T > 1) {
								var P = {
									cause: f + "," + m,
									reach: N
								};
								s(e, t, n, S.prev, C, P), d && P.reach > d.reach && (d.reach = P.reach);
							}
						}
					}
				}
			}
		}
		function c() {
			var e = {
				value: null,
				prev: null,
				next: null
			}, t = {
				value: null,
				prev: e,
				next: null
			};
			e.next = t, this.head = e, this.tail = t, this.length = 0;
		}
		function l(e, t, n) {
			var r = t.next, i = {
				value: n,
				prev: t,
				next: r
			};
			return t.next = i, r.prev = i, e.length++, i;
		}
		function u(e, t, n) {
			for (var r = t.next, i = 0; i < n && r !== e.tail; i++) r = r.next;
			t.next = r, r.prev = t, e.length -= i;
		}
		function d(e) {
			for (var t = [], n = e.head.next; n !== e.tail;) t.push(n.value), n = n.next;
			return t;
		}
		if (!e.document) return e.addEventListener && (i.disableWorkerMessageHandler || e.addEventListener("message", function(t) {
			var n = JSON.parse(t.data), r = n.language, a = n.code, o = n.immediateClose;
			e.postMessage(i.highlight(a, i.languages[r], r)), o && e.close();
		}, !1)), i;
		var f = i.util.currentScript();
		f && (i.filename = f.src, f.hasAttribute("data-manual") && (i.manual = !0));
		function p() {
			i.manual || i.highlightAll();
		}
		if (!i.manual) {
			var m = document.readyState;
			m === "loading" || m === "interactive" && f && f.defer ? document.addEventListener("DOMContentLoaded", p) : window.requestAnimationFrame ? window.requestAnimationFrame(p) : window.setTimeout(p, 16);
		}
		return i;
	}(typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {});
	t !== void 0 && t.exports && (t.exports = n), typeof global < "u" && (global.Prism = n), n.languages.markup = {
		comment: {
			pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
			greedy: !0
		},
		prolog: {
			pattern: /<\?[\s\S]+?\?>/,
			greedy: !0
		},
		doctype: {
			pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
			greedy: !0,
			inside: {
				"internal-subset": {
					pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
					lookbehind: !0,
					greedy: !0,
					inside: null
				},
				string: {
					pattern: /"[^"]*"|'[^']*'/,
					greedy: !0
				},
				punctuation: /^<!|>$|[[\]]/,
				"doctype-tag": /^DOCTYPE/i,
				name: /[^\s<>'"]+/
			}
		},
		cdata: {
			pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
			greedy: !0
		},
		tag: {
			pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
			greedy: !0,
			inside: {
				tag: {
					pattern: /^<\/?[^\s>\/]+/,
					inside: {
						punctuation: /^<\/?/,
						namespace: /^[^\s>\/:]+:/
					}
				},
				"special-attr": [],
				"attr-value": {
					pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
					inside: { punctuation: [{
						pattern: /^=/,
						alias: "attr-equals"
					}, {
						pattern: /^(\s*)["']|["']$/,
						lookbehind: !0
					}] }
				},
				punctuation: /\/?>/,
				"attr-name": {
					pattern: /[^\s>\/]+/,
					inside: { namespace: /^[^\s>\/:]+:/ }
				}
			}
		},
		entity: [{
			pattern: /&[\da-z]{1,8};/i,
			alias: "named-entity"
		}, /&#x?[\da-f]{1,8};/i]
	}, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(e) {
		e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
	}), Object.defineProperty(n.languages.markup.tag, "addInlined", { value: function(e, t) {
		var r = {};
		r["language-" + t] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: !0,
			inside: n.languages[t]
		}, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
		var i = { "included-cdata": {
			pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
			inside: r
		} };
		i["language-" + t] = {
			pattern: /[\s\S]+/,
			inside: n.languages[t]
		};
		var a = {};
		a[e] = {
			pattern: RegExp("(<__[^>]*>)(?:<!\\[CDATA\\[(?:[^\\]]|\\](?!\\]>))*\\]\\]>|(?!<!\\[CDATA\\[)[\\s\\S])*?(?=<\\/__>)".replace(/__/g, function() {
				return e;
			}), "i"),
			lookbehind: !0,
			greedy: !0,
			inside: i
		}, n.languages.insertBefore("markup", "cdata", a);
	} }), Object.defineProperty(n.languages.markup.tag, "addAttribute", { value: function(e, t) {
		n.languages.markup.tag.inside["special-attr"].push({
			pattern: RegExp("(^|[\"'\\s])(?:" + e + ")\\s*=\\s*(?:\"[^\"]*\"|'[^']*'|[^\\s'\">=]+(?=[\\s>]))", "i"),
			lookbehind: !0,
			inside: {
				"attr-name": /^[^\s=]+/,
				"attr-value": {
					pattern: /=[\s\S]+/,
					inside: {
						value: {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: !0,
							alias: [t, "language-" + t],
							inside: n.languages[t]
						},
						punctuation: [{
							pattern: /^=/,
							alias: "attr-equals"
						}, /"|'/]
					}
				}
			}
		});
	} }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml, (function(e) {
		var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
		e.languages.css = {
			comment: /\/\*[\s\S]*?\*\//,
			atrule: {
				pattern: RegExp("@[\\w-](?:[^;{\\s\"']|\\s+(?!\\s)|" + t.source + ")*?(?:;|(?=\\s*\\{))"),
				inside: {
					rule: /^@[\w-]+/,
					"selector-function-argument": {
						pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
						lookbehind: !0,
						alias: "selector"
					},
					keyword: {
						pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
						lookbehind: !0
					}
				}
			},
			url: {
				pattern: RegExp("\\burl\\((?:" + t.source + "|(?:[^\\\\\\r\\n()\"']|\\\\[\\s\\S])*)\\)", "i"),
				greedy: !0,
				inside: {
					function: /^url/i,
					punctuation: /^\(|\)$/,
					string: {
						pattern: RegExp("^" + t.source + "$"),
						alias: "url"
					}
				}
			},
			selector: {
				pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + t.source + ")*(?=\\s*\\{)"),
				lookbehind: !0
			},
			string: {
				pattern: t,
				greedy: !0
			},
			property: {
				pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
				lookbehind: !0
			},
			important: /!important\b/i,
			function: {
				pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
				lookbehind: !0
			},
			punctuation: /[(){};:,]/
		}, e.languages.css.atrule.inside.rest = e.languages.css;
		var n = e.languages.markup;
		n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
	})(n), n.languages.clike = {
		comment: [{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: !0,
			greedy: !0
		}, {
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: !0,
			greedy: !0
		}],
		string: {
			pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
			greedy: !0
		},
		"class-name": {
			pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
			lookbehind: !0,
			inside: { punctuation: /[.\\]/ }
		},
		keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
		boolean: /\b(?:false|true)\b/,
		function: /\b\w+(?=\()/,
		number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
		operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
		punctuation: /[{}[\];(),.:]/
	}, n.languages.javascript = n.languages.extend("clike", {
		"class-name": [n.languages.clike["class-name"], {
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: !0
		}],
		keyword: [{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: !0
		}, {
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: !0
		}],
		function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
		number: {
			pattern: RegExp("(^|[^\\w$])(?:NaN|Infinity|0[bB][01]+(?:_[01]+)*n?|0[oO][0-7]+(?:_[0-7]+)*n?|0[xX][\\dA-Fa-f]+(?:_[\\dA-Fa-f]+)*n?|\\d+(?:_\\d+)*n|(?:\\d+(?:_\\d+)*(?:\\.(?:\\d+(?:_\\d+)*)?)?|\\.\\d+(?:_\\d+)*)(?:[Ee][+-]?\\d+(?:_\\d+)*)?)(?![\\w$])"),
			lookbehind: !0
		},
		operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
	}), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", {
		regex: {
			pattern: RegExp("((?:^|[^$\\w\\xA0-\\uFFFF.\"'\\])\\s]|\\b(?:return|yield))\\s*)\\/(?:(?:\\[(?:[^\\]\\\\\\r\\n]|\\\\.)*\\]|\\\\.|[^/\\\\\\[\\r\\n])+\\/[dgimyus]{0,7}|(?:\\[(?:[^[\\]\\\\\\r\\n]|\\\\.|\\[(?:[^[\\]\\\\\\r\\n]|\\\\.|\\[(?:[^[\\]\\\\\\r\\n]|\\\\.)*\\])*\\])*\\]|\\\\.|[^/\\\\\\[\\r\\n])+\\/[dgimyus]{0,7}v[dgimyus]{0,7})(?=(?:\\s|\\/\\*(?:[^*]|\\*(?!\\/))*\\*\\/)*(?:$|[\\r\\n,.;:})\\]]|\\/\\/))"),
			lookbehind: !0,
			greedy: !0,
			inside: {
				"regex-source": {
					pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
					lookbehind: !0,
					alias: "language-regex",
					inside: n.languages.regex
				},
				"regex-delimiter": /^\/|\/$/,
				"regex-flags": /^[a-z]+$/
			}
		},
		"function-variable": {
			pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
			alias: "function"
		},
		parameter: [
			{
				pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
				lookbehind: !0,
				inside: n.languages.javascript
			},
			{
				pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
				lookbehind: !0,
				inside: n.languages.javascript
			}
		],
		constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
	}), n.languages.insertBefore("javascript", "string", {
		hashbang: {
			pattern: /^#!.*/,
			greedy: !0,
			alias: "comment"
		},
		"template-string": {
			pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
			greedy: !0,
			inside: {
				"template-punctuation": {
					pattern: /^`|`$/,
					alias: "string"
				},
				interpolation: {
					pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
					lookbehind: !0,
					inside: {
						"interpolation-punctuation": {
							pattern: /^\$\{|\}$/,
							alias: "punctuation"
						},
						rest: n.languages.javascript
					}
				},
				string: /[\s\S]+/
			}
		},
		"string-property": {
			pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
			lookbehind: !0,
			greedy: !0,
			alias: "property"
		}
	}), n.languages.insertBefore("javascript", "operator", { "literal-property": {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: !0,
		alias: "property"
	} }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute("on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)", "javascript")), n.languages.js = n.languages.javascript, (function() {
		if (n === void 0 || typeof document > "u") return;
		Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
		var e = "Loading…", t = function(e, t) {
			return "✖ Error " + e + " while fetching file: " + t;
		}, r = "✖ Error: File does not exist or is empty", i = {
			js: "javascript",
			py: "python",
			rb: "ruby",
			ps1: "powershell",
			psm1: "powershell",
			sh: "bash",
			bat: "batch",
			h: "c",
			tex: "latex"
		}, a = "data-src-status", o = "loading", s = "loaded", c = "failed", l = "pre[data-src]:not([" + a + "=\"" + s + "\"]):not([" + a + "=\"" + o + "\"])";
		function u(e, n, i) {
			var a = new XMLHttpRequest();
			a.open("GET", e, !0), a.onreadystatechange = function() {
				a.readyState == 4 && (a.status < 400 && a.responseText ? n(a.responseText) : a.status >= 400 ? i(t(a.status, a.statusText)) : i(r));
			}, a.send(null);
		}
		function d(e) {
			var t = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(e || "");
			if (t) {
				var n = Number(t[1]), r = t[2], i = t[3];
				return r ? i ? [n, Number(i)] : [n, void 0] : [n, n];
			}
		}
		n.hooks.add("before-highlightall", function(e) {
			e.selector += ", " + l;
		}), n.hooks.add("before-sanity-check", function(t) {
			var r = t.element;
			if (r.matches(l)) {
				t.code = "", r.setAttribute(a, o);
				var f = r.appendChild(document.createElement("CODE"));
				f.textContent = e;
				var p = r.getAttribute("data-src"), m = t.language;
				if (m === "none") {
					var h = (/\.(\w+)$/.exec(p) || [, "none"])[1];
					m = i[h] || h;
				}
				n.util.setLanguage(f, m), n.util.setLanguage(r, m);
				var g = n.plugins.autoloader;
				g && g.loadLanguages(m), u(p, function(e) {
					r.setAttribute(a, s);
					var t = d(r.getAttribute("data-range"));
					if (t) {
						var i = e.split(/\r\n?|\n/g), o = t[0], c = t[1] == null ? i.length : t[1];
						o < 0 && (o += i.length), o = Math.max(0, Math.min(o - 1, i.length)), c < 0 && (c += i.length), c = Math.max(0, Math.min(c, i.length)), e = i.slice(o, c).join("\n"), r.hasAttribute("data-start") || r.setAttribute("data-start", String(o + 1));
					}
					f.textContent = e, n.highlightElement(f);
				}, function(e) {
					r.setAttribute(a, c), f.textContent = e;
				});
			}
		}), n.plugins.fileHighlight = { highlight: function(e) {
			for (var t = (e || document).querySelectorAll(l), r = 0, i; i = t[r++];) n.highlightElement(i);
		} };
		var f = !1;
		n.fileHighlight = function() {
			f ||= (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), !0), n.plugins.fileHighlight.highlight.apply(this, arguments);
		};
	})();
})))(), 1), MP = /* @__PURE__ */ d({
	__name: "pretty-code",
	props: { language: { default: "javascript" } },
	setup(e) {
		z(e, "HPrettyCode");
		let t = A(crypto.randomUUID());
		function n() {
			window.Prism = window.Prism || {}, window.Prism.manual = !0, jP.default.highlightAll();
		}
		return E(n), T(() => {
			t.value = crypto.randomUUID(), b(n);
		}), (n, r) => (O(), a("pre", null, [(O(), a("code", {
			key: t.value,
			class: x(["h-pretty-code", `language-${e.language}`])
		}, [M(n.$slots, "default")], 2))]));
	}
});
//#endregion
//#region ../../../node_modules/lodash-es/isObject.js
function NP(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region src/components/general/autocomplete-input.vue.ts
var PP = d({
	inheritAttrs: !1,
	setup(e, t) {
		let r = t.attrs, i = t.emit, a = t.slots;
		function o(e) {
			return e && r.items?.length ? Array.isArray(e) ? r.items.filter((t) => e.includes(t[r["item-value"]])) : NP(e) ? e : r.items.find((t) => t[r["item-value"]] === e) : null;
		}
		let s = A(o(r.modelValue)), c = n(() => (r.items ?? []).concat(s.value)), l = r.limit;
		function u(e) {
			return Array.isArray(e) ? e.map((e) => e[r["item-value"]]) : e?.[r["item-value"]];
		}
		function d(e) {
			let t = e;
			Array.isArray(t) && l && t.length > l && (t = t.slice(t.length - l)), s.value = t, i("update:modelValue", r["item-value"] ? u(t) : t);
		}
		return () => m(Ut, {
			...r,
			modelValue: s.value,
			returnObject: !0,
			autocompleteItems: c.value,
			"onUpdate:modelValue": d
		}, { ...a });
	}
}), FP = { class: "h-bulletin__header d-flex justify-space-between mb-3" }, IP = { class: "font-weight-medium header__text" }, LP = { class: "h-bulletin__content" }, RP = { class: "h-bulletin__actions d-flex flex-wrap mt-3" }, zP = "action:", BP = /* @__PURE__ */ d({
	__name: "bulletin-item",
	props: {
		is: { default: "div" },
		bulletin: {},
		windowName: {}
	},
	emits: ["acknowledgeBulletin", "actionClicked"],
	setup(t, { emit: s }) {
		let u = z(t, "HBulletin"), d = s, f = oe(), p = n(() => Object.keys(f).filter((e) => e.startsWith(zP)).reduce((e, t) => (e[t.replace(zP, "")] = f[t], e), {}));
		function m() {
			d("acknowledgeBulletin", u.bulletin?.key);
		}
		function h(e, t, n) {
			d("actionClicked", e, t, n);
		}
		return (n, s) => {
			let d = N("h-theme-scope"), f = N("h-action-link");
			return O(), r(te(t.is), y({
				...n.$attrs,
				...F(u)
			}, { class: ["h-bulletin d-flex flex-column", {
				"h-bulletin--sticky": t.bulletin?.sticky,
				[`h-bulletin--${t.bulletin?.status}`]: !0
			}] }), {
				default: L(() => [
					o("div", FP, [M(n.$slots, "header", { bulletin: t.bulletin }, () => [o("h3", IP, P(t.bulletin?.title), 1), t.bulletin?.sticky ? i("", !0) : (O(), r(d, {
						key: 0,
						name: "HScopedBulletinAcknowledgeBtn",
						component: F(Gt),
						class: "h-bulletin-acknowledge-btn",
						"aria-label": "Acknowledge bulletin",
						onClick: s[0] ||= (e) => m()
					}, null, 8, ["component"]))])]),
					o("div", LP, [M(n.$slots, "default", { bulletin: t.bulletin }, () => [c(P(t.bulletin?.description), 1)])]),
					o("div", RP, [M(n.$slots, "actions", {
						bulletin: t.bulletin,
						actionProps: p.value
					}, () => [(O(!0), a(e, null, j(t.bulletin?.action, (e) => (O(), r(f, {
						key: e.url,
						class: "h-bulletin-action-link",
						to: e.url,
						target: e.target,
						"window-name": t.windowName ?? t.bulletin?.key,
						"no-route": "",
						onClick: (n) => h(e, t.bulletin, n)
					}, {
						default: L(() => [l(d, y({
							name: "HScopedBulletinActionBtn",
							component: F(Gt),
							class: ["h-bulletin-action-btn", { [`h-bulletin-action-btn--${t.bulletin?.status}`]: !0 }]
						}, { ref_for: !0 }, { ...p.value }), {
							default: L(() => [c(P(e.name), 1)]),
							_: 2
						}, 1040, ["component", "class"])]),
						_: 2
					}, 1032, [
						"to",
						"target",
						"window-name",
						"onClick"
					]))), 128))])])
				]),
				_: 3
			}, 16, ["class"]);
		};
	}
}), VP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "dialog-card",
	props: {
		modelValue: { type: Boolean },
		dialogWidth: { default: "850" },
		dialogHeight: { default: "auto" },
		hideClose: {
			type: Boolean,
			default: !1
		},
		background: {},
		customDefaults: {}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let a = z(e, "HDialog"), o = n(() => ({
			...rn().value,
			...a.customDefaults
		})), s = oe(), { smAndDown: c } = Bt(), u = n(() => d.value ? "100%" : a.dialogHeight), d = n(() => s.fullscreen === void 0 ? !s["max-width"] && !s.width && c.value : s.fullscreen), f = bt(a, "modelValue", t);
		return k(me, f), (t, n) => (O(), r(Rt, y({
			modelValue: F(f),
			"onUpdate:modelValue": n[0] ||= (e) => g(f) ? f.value = e : null,
			class: "h-dialog",
			persistent: "",
			fullscreen: d.value,
			width: e.dialogWidth,
			height: u.value
		}, t.$attrs, {
			"aria-label": F(B)("dialog"),
			"aria-labelledby": "hDialogHeader"
		}), {
			default: L(({ isActive: n }) => [l(Ht, { defaults: o.value }, {
				default: L(() => [l(Be, {
					class: "h-dialog-container",
					color: F(a).background
				}, {
					default: L(() => [l(Ge, { class: "h-dialog-container__header" }, {
						default: L(() => [M(t.$slots, "header", {}, void 0, !0), e.hideClose ? i("", !0) : (O(), r(Ke, {
							key: 0,
							class: "h-dialog-card-close-btn",
							variant: "text",
							icon: "mdi:mdi-close",
							"aria-label": F(B)("close-dialog"),
							onClick: (e) => n.value = !1
						}, null, 8, ["aria-label", "onClick"]))]),
						_: 2
					}, 1024), M(t.$slots, "default", { class: "h-dialog-container__content" }, void 0, !0)]),
					_: 2
				}, 1032, ["color"])]),
				_: 2
			}, 1032, ["defaults"])]),
			_: 3
		}, 16, [
			"modelValue",
			"fullscreen",
			"width",
			"height",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-03436bd3"]]), HP = { class: "text-headline-small font-weight-medium h-action-dialog__title" }, UP = {
	key: 0,
	class: "text-body-medium mt-1"
}, WP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "action-dialog",
	props: {
		modelValue: { type: Boolean },
		title: {},
		subtitle: {},
		dialogWidth: { default: "600" },
		dialogHeight: { default: "auto" },
		hideClose: {
			type: Boolean,
			default: !1
		},
		closeText: { default: "Avbryt" },
		closeIcon: {},
		saveText: { default: "Spara" },
		saveIcon: {},
		hideSave: {
			type: Boolean,
			default: !1
		},
		saveLoading: {
			type: Boolean,
			default: !1
		},
		saveDisabled: {
			type: Boolean,
			default: !1
		},
		background: {},
		customDefaults: {}
	},
	emits: [
		"update:modelValue",
		"close",
		"save"
	],
	setup(e, { emit: t }) {
		let s = A(), u = z(e, "HActionDialog"), d = oe(), { smAndDown: f } = Bt(), p = n(() => d.width === void 0 ? f.value ? "auto" : void 0 : d.width), m = n(() => d["max-width"] === void 0 ? f.value ? void 0 : "700" : d["max-width"]), h = n(() => _.value ? "100%" : u.dialogHeight), _ = n(() => d.fullscreen === void 0 ? !d["max-width"] && !d.width && f.value : d.fullscreen), v = t, b = bt(u, "modelValue", v);
		k(me, b);
		let x = (e) => {
			e.value = !1, v("close");
		}, S = async () => {
			if (s.value) {
				let { valid: e } = await s.value.validate();
				if (!e) return;
			}
			v("save");
		};
		return (t, n) => (O(), r(Rt, y({
			modelValue: F(b),
			"onUpdate:modelValue": n[0] ||= (e) => g(b) ? b.value = e : null,
			class: "h-action-dialog",
			persistent: "",
			fullscreen: _.value,
			width: p.value,
			"max-width": m.value,
			height: h.value
		}, t.$attrs, { "aria-label": F(B)("dialog") }), {
			default: L(({ isActive: n }) => [e.hideClose ? i("", !0) : (O(), r(ew, {
				key: 0,
				name: "HActionButtonClose",
				type: "custom",
				class: "h-action-dialog__close-btn",
				variant: "elevated",
				icon: "mdi:mdi-close",
				size: "36",
				color: "neutral-100",
				"aria-label": F(B)("close-dialog"),
				onClick: (e) => x(n)
			}, null, 8, ["aria-label", "onClick"])), l(Be, {
				class: "h-action-dialog__container position-relative",
				color: F(u).background
			}, {
				default: L(() => [
					l(Je, { class: "h-action-dialog__header pa-0" }, {
						default: L(() => [l(Ye, { class: "ma-0 align-center justify-space-between ga-5" }, {
							default: L(() => [l(H, { class: "pa-4 pb-0 h-action-dialog__header-left" }, {
								default: L(() => [M(t.$slots, "title", {}, () => [o("div", HP, P(e.title), 1), e.subtitle ? (O(), a("div", UP, P(e.subtitle), 1)) : i("", !0)], !0)]),
								_: 3
							}), t.$slots["header-right"] ? (O(), r(H, {
								key: 0,
								class: "pa-4 pb-0 h-action-dialog__header-right"
							}, {
								default: L(() => [M(t.$slots, "header-right", {}, void 0, !0)]),
								_: 3
							})) : i("", !0)]),
							_: 3
						})]),
						_: 3
					}),
					l(an, {
						ref_key: "formRef",
						ref: s,
						onSubmit: R(S, ["prevent"])
					}, {
						default: L(() => [l(Je, { class: "h-action-dialog__content pa-4" }, {
							default: L(() => [l(Ye, { class: "ma-0" }, {
								default: L(() => [l(H, {
									cols: "12",
									class: "pa-0"
								}, {
									default: L(() => [M(t.$slots, "default", {}, void 0, !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})]),
						_: 3
					}, 512),
					l(Je, { class: "h-action-dialog__footer pa-0" }, {
						default: L(() => [l(Ye, { class: "ma-0 justify-end align-center" }, {
							default: L(() => [l(H, {
								cols: "auto",
								class: "pa-4"
							}, {
								default: L(() => [M(t.$slots, "footer", {}, () => [l(Je, { class: "pa-0" }, {
									default: L(() => [l(Ye, {
										class: "ma-0",
										style: { gap: "8px" }
									}, {
										default: L(() => [
											l(H, {
												cols: "auto",
												class: "pa-0"
											}, {
												default: L(() => [M(t.$slots, "actions", {}, void 0, !0)]),
												_: 3
											}),
											l(H, {
												cols: "auto",
												class: "pa-0"
											}, {
												default: L(() => [l(ew, {
													type: "neutral",
													size: "default",
													"prepend-icon": e.closeIcon,
													onClick: (e) => x(n)
												}, {
													default: L(() => [c(P(e.closeText), 1)]),
													_: 1
												}, 8, ["prepend-icon", "onClick"])]),
												_: 2
											}, 1024),
											e.hideSave ? i("", !0) : (O(), r(H, {
												key: 0,
												cols: "auto",
												class: "pa-0"
											}, {
												default: L(() => [l(ew, {
													type: "primary",
													size: "default",
													"prepend-icon": e.saveIcon,
													loading: e.saveLoading,
													disabled: e.saveDisabled,
													onClick: S
												}, {
													default: L(() => [c(P(e.saveText), 1)]),
													_: 1
												}, 8, [
													"prepend-icon",
													"loading",
													"disabled"
												])]),
												_: 1
											}))
										]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1024)], !0)]),
								_: 2
							}, 1024)]),
							_: 2
						}, 1024)]),
						_: 2
					}, 1024)
				]),
				_: 2
			}, 1032, ["color"])]),
			_: 3
		}, 16, [
			"modelValue",
			"fullscreen",
			"width",
			"max-width",
			"height",
			"aria-label"
		]));
	}
}), [["__scopeId", "data-v-0ac64a01"]]), GP = {
	class: "h-confirmation-dialog__symbol",
	"aria-hidden": "true"
}, KP = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "confirmation-dialog",
	props: {
		modelValue: {
			type: Boolean,
			default: !1
		},
		title: { default: "" },
		message: { default: "" },
		confirmText: { default: "Confirm" },
		cancelText: { default: "Cancel" },
		maxWidth: { default: "400" }
	},
	emits: [
		"update:modelValue",
		"confirm",
		"cancel"
	],
	setup(e, { emit: t }) {
		let n = z(e, "HConfirmationDialog"), i = t, a = bt(n, "modelValue", i), s = () => {
			i("confirm"), a.value = !1;
		}, u = () => {
			i("cancel"), a.value = !1;
		};
		return ht(document, "keydown", (e) => {
			a.value && e.key === "Escape" && (e.preventDefault(), u());
		}), (t, n) => {
			let i = N("h-action-button");
			return O(), r(F(Kt), {
				modelValue: F(a),
				"onUpdate:modelValue": n[0] ||= (e) => g(a) ? a.value = e : null,
				"max-width": e.maxWidth,
				persistent: "",
				"aria-label": e.title
			}, {
				default: L(() => [l(Be, { class: "h-confirmation-dialog" }, {
					default: L(() => [
						o("div", GP, [l(V, { icon: "mdi:mdi-alert-circle" })]),
						l(Ge, { class: "h-confirmation-dialog__title" }, {
							default: L(() => [l(Ye, { "no-gutters": "" }, {
								default: L(() => [l(H, null, {
									default: L(() => [M(t.$slots, "title", {}, () => [o("h2", null, P(e.title), 1)], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						}),
						l(We, { class: "h-confirmation-dialog__message" }, {
							default: L(() => [l(Ye, { "no-gutters": "" }, {
								default: L(() => [l(H, null, {
									default: L(() => [M(t.$slots, "message", {}, () => [o("div", null, P(e.message), 1)], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						}),
						l(Ve, { class: "h-confirmation-dialog__actions" }, {
							default: L(() => [l(Ye, { "no-gutters": "" }, {
								default: L(() => [l(H, {
									cols: "6",
									class: "pr-1"
								}, {
									default: L(() => [M(t.$slots, "cancel-action", {}, () => [l(i, {
										type: "neutral",
										block: "",
										onClick: u
									}, {
										default: L(() => [c(P(e.cancelText), 1)]),
										_: 1
									})], !0)]),
									_: 3
								}), l(H, {
									cols: "6",
									class: "pl-1"
								}, {
									default: L(() => [M(t.$slots, "confirm-action", {}, () => [l(i, {
										type: "error",
										block: "",
										onClick: s
									}, {
										default: L(() => [c(P(e.confirmText), 1)]),
										_: 1
									})], !0)]),
									_: 3
								})]),
								_: 3
							})]),
							_: 3
						})
					]),
					_: 3
				})]),
				_: 3
			}, 8, [
				"modelValue",
				"max-width",
				"aria-label"
			]);
		};
	}
}), [["__scopeId", "data-v-c653d769"]]), qP = /* @__PURE__ */ An(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.defaultOptions = void 0, e.defaultOptions = {
		lowercase: !1,
		precision: 1,
		space: !1,
		units: [
			"",
			"K",
			"M",
			"B",
			"T",
			"P",
			"E"
		]
	};
})), JP = /* @__PURE__ */ An(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.getLocales = e.getFractionDigits = e.roundTo = e.parseValue = void 0;
	function t(e) {
		let t = parseFloat(e?.toString());
		if (isNaN(t)) throw Error("Input value is not a number");
		if (t > 2 ** 53 - 1 || t < -(2 ** 53 - 1)) throw RangeError("Input value is outside of safe integer range");
		return t;
	}
	e.parseValue = t;
	function n(e, t) {
		if (!Number.isFinite(e)) throw Error("Input value is not a finite number");
		if (!Number.isInteger(t) || t < 0) throw Error("Precision is not a positive integer");
		return Number.isInteger(e) ? e : parseFloat(e.toFixed(t));
	}
	e.roundTo = n;
	function r(e) {
		return Number.isInteger(e) ? 0 : e.toString().split(".")[1]?.length ?? 0;
	}
	e.getFractionDigits = r;
	function i() {
		return typeof navigator > "u" ? [] : Array.from(navigator.languages ?? []);
	}
	e.getLocales = i;
})), YP = (/* @__PURE__ */ An(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.millify = void 0;
	var t = qP(), n = JP(), r = 1e3;
	function* i(e) {
		let t = r;
		for (;;) {
			let n = e / t;
			if (n < 1) return;
			yield n, t *= r;
		}
	}
	function a(e, r) {
		let a = r ? {
			...t.defaultOptions,
			...r
		} : t.defaultOptions;
		if (!Array.isArray(a.units) || !a.units.length) throw Error("Option `units` must be a non-empty array");
		let o;
		try {
			o = n.parseValue(e);
		} catch (t) {
			return t instanceof Error && console.warn(`WARN: ${t.message} (millify)`), String(e);
		}
		let s = o < 0 ? "-" : "";
		o = Math.abs(o);
		let c = 0;
		for (let e of i(o)) o = e, c += 1;
		if (c >= a.units.length) return e.toString();
		let l = n.roundTo(o, a.precision);
		for (let e of i(l)) l = e, c += 1;
		let u = a.units[c] ?? "", d = a.lowercase ? u.toLowerCase() : u, f = a.space ? " " : "";
		return `${s}${l.toLocaleString(a.locales ?? n.getLocales(), { minimumFractionDigits: n.getFractionDigits(l) })}${f}${d}`;
	}
	e.millify = a;
})))(), XP = { key: 2 }, ZP = { key: 1 }, QP = { class: "h-shortcut__title pt-3" }, $P = "badge:", eF = "tooltip:", tF = /* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "shortcut-item",
	props: {
		is: { default: "div" },
		workspace: {},
		wrapperClass: {},
		avatarColor: { default: "primary" },
		windowName: {},
		iconMode: { default: "icon" },
		shortcut: {},
		badgeProps: { default: () => ({ iconMode: "icon" }) },
		tooltipProps: {}
	},
	setup(t) {
		let s = oe(), u = n(() => Object.keys(s).filter((e) => e.startsWith($P)).reduce((e, t) => (e[t.replace($P, "")] = s[t], e), {})), d = n(() => Object.keys(s).filter((e) => e.startsWith(eF)).reduce((e, t) => (e[t.replace(eF, "")] = s[t], e), {})), f = z(t, "HShortcut"), p = le(), { hubApiPath: m } = we(), { hHttpRequest: h } = Ce(), { oGetImage: g } = Fe(), _ = n(() => !!p["badge-content"]), v = n(() => {
			let e = f.shortcut?.badge?.url;
			return {
				...f.shortcut,
				badgeData: e ? h({ url: e.replace("{{workspace.slug}}", f.workspace).replace("{{config.api.url}}", m) }).data : null
			};
		});
		function b(e) {
			return e ? e.startsWith("http") || e.startsWith("https") || e.startsWith("/") : !1;
		}
		return (n, s) => {
			let f = N("h-action-link");
			return O(), r(qe, y({ ...d.value }, {
				disabled: !v.value?.description,
				text: v.value?.description,
				location: v.value?.tooltipLocation ?? "top",
				class: "h-shortcut-item"
			}), {
				activator: L(({ props: s }) => [l(At, y({
					...u.value,
					...s
				}, {
					"model-value": _.value || (v.value.badgeData?.value?.meta?.totalresults || 0) > 0,
					class: "h-shortcut__wrapper " + t.wrapperClass
				}), {
					badge: L(() => [M(n.$slots, "badge-content", {
						shortcut: v.value,
						isImage: b(v.value?.icon)
					}, () => [v.value.badge?.icon && (u.value.iconMode === "image" || b(t.shortcut?.badge?.icon)) ? (O(), r(jt, {
						key: 0,
						width: "15",
						class: "h-shortcut-item-badge-image",
						src: F(g)(t.shortcut?.badge?.icon ?? ""),
						alt: F(B)("image_alt_shortcut_badge")
					}, null, 8, ["src", "alt"])) : v.value.badge?.icon && u.value.iconMode === "icon" ? (O(), r(V, {
						key: 1,
						class: "h-shortcut-item-badge-icon",
						icon: t.shortcut?.badge?.icon
					}, null, 8, ["icon"])) : v.value.badgeData?.value?.meta?.totalresults ? (O(), a("div", XP, P(F(YP.millify)(v.value.badgeData?.value?.meta?.totalresults)), 1)) : i("", !0)])]),
					default: L(() => [l(f, {
						class: "h-shortcut-item-action-link w-100",
						to: v.value.link,
						target: v.value.target,
						"no-route": "",
						"window-name": t.windowName ?? t.shortcut?.key
					}, {
						default: L(() => [(O(), r(te(t.is), y(n.$attrs, {
							key: v.value.key,
							class: "h-shortcut__content",
							link: !0
						}), {
							default: L(() => [M(n.$slots, "avatar", {
								icon: v.value?.icon,
								shortcut: v.value,
								isImage: b(v.value?.icon)
							}, () => [l(Lt, {
								class: "h-shortcut__avatar",
								rounded: "0",
								variant: "text"
							}, {
								default: L(() => [t.iconMode === "image" || b(v.value?.icon) ? (O(), r(jt, {
									key: 0,
									class: "h-shortcut-item-avatar-image",
									cover: "",
									src: F(g)(v.value?.icon ?? ""),
									alt: F(B)("image_alt_shortcut_icon")
								}, {
									placeholder: L(() => [o("div", { class: x(["d-flex align-center justify-center fill-height text-headline-medium rounded-circle", { [`bg-${t.avatarColor}`]: !0 }]) }, [M(n.$slots, "avatar-content", {}, () => [c(P(v.value?.title?.[0]), 1)])], 2)]),
									_: 3
								}, 8, ["src", "alt"])) : t.iconMode === "icon" ? (O(), a(e, { key: 1 }, [v.value?.icon ? (O(), r(V, {
									key: 0,
									class: "h-shortcut__icon",
									icon: v.value?.icon
								}, null, 8, ["icon"])) : (O(), a("span", ZP, P(v.value?.title?.[0]), 1))], 64)) : i("", !0)]),
								_: 3
							})]), o("div", QP, [M(n.$slots, "title", {
								title: v.value?.title,
								shortcut: v.value
							}, () => [c(P(v.value?.title), 1)])])]),
							_: 3
						}, 16))]),
						_: 3
					}, 8, [
						"to",
						"target",
						"window-name"
					])]),
					_: 3
				}, 16, ["model-value", "class"])]),
				_: 3
			}, 16, [
				"disabled",
				"text",
				"location"
			]);
		};
	}
}), nF = { class: "d-flex align-center h-item-card__wrapper" }, rF = { class: "h-item-card__header" }, iF = { class: "h-item-card__title-action" }, aF = { key: 1 }, oF = { class: "h-item-card__body" }, sF = { class: "h-item-card__footer" }, cF = { class: "left-control" }, lF = { class: "h-item-card__right-control" }, uF = ["aria-expanded", "aria-label"], dF = 1, fF = "action:", pF = /* @__PURE__ */ d({
	__name: "item-card",
	props: {
		item: {},
		subtitle: { default: "" },
		tableData: {},
		showActionsOnCollapse: {
			type: Boolean,
			default: !0
		},
		hideBody: {
			type: Boolean,
			default: !1
		},
		alwaysExpand: {
			type: Boolean,
			default: !1
		},
		hideTooltip: {
			type: Boolean,
			default: !1
		},
		actionsMenu: { type: Boolean },
		windowName: {}
	},
	setup(t) {
		let s = z(t, "HItemCard"), u = oe(), d = le(), f = n(() => Object.keys(u).filter((e) => e.startsWith(fF)).reduce((e, t) => (e[t.replace(fF, "")] = u[t], e), {})), [p, m] = yt(), h = n(() => s.item.action?.find((e) => e.primary)), g = n(() => h.value?.url), _ = n(() => (d.body ? d.body() : []).length > 0 || !!s.tableData);
		return (n, s) => {
			let u = N("h-action-link"), d = N("h-theme-scope"), v = N("h-menu");
			return O(), a("div", nF, [l(Be, { class: "h-item-card" }, {
				default: L(() => [l(He, null, {
					default: L(() => [
						o("div", rF, [l(Ye, {
							class: "h-item-card__header-content",
							density: "compact"
						}, {
							default: L(() => [
								l(H, {
									class: "h-item-card__title",
									md: "7",
									cols: "12"
								}, {
									default: L(() => [M(n.$slots, "title", { item: t.item }, () => [g.value ? (O(), r(u, {
										key: 0,
										to: g.value,
										target: h.value?.target,
										class: "h-item-card__button d-inline-flex",
										"no-route": "",
										"window-name": t.windowName ?? t.item.key
									}, {
										default: L(() => [l(Ge, { class: "h-item-card-title" }, {
											default: L(() => [c(P(t.item.name), 1)]),
											_: 1
										}), o("div", iF, [l(V, { class: "h-item-card-title-action-icon" }, {
											default: L(() => [...s[1] ||= [c("mdi:mdi-chevron-right", -1)]]),
											_: 1
										})])]),
										_: 1
									}, 8, [
										"to",
										"target",
										"window-name"
									])) : (O(), a("div", aF, [l(Ge, { class: "h-item-card-title" }, {
										default: L(() => [c(P(t.item.name), 1)]),
										_: 1
									})]))]), l(Ue, {
										class: "h-item-card__subtitle",
										subtitle: t.subtitle,
										item: t.item
									}, {
										default: L(() => [M(n.$slots, "subtitle", {}, () => [c(P(t.subtitle), 1)])]),
										_: 3
									}, 8, ["subtitle", "item"])]),
									_: 3
								}),
								l(Xe, { class: "h-item-card-spacer" }),
								l(H, {
									class: "h-item-card-header-col",
									md: "5",
									cols: "12"
								}, {
									default: L(() => [M(n.$slots, "header", { open: F(p) })]),
									_: 3
								})
							]),
							_: 3
						})]),
						o("div", oF, [l(Ot, { class: "h-item-card-expand-transition" }, {
							default: L(() => [de(o("div", null, [o("div", null, [M(n.$slots, "body")])], 512), [[ue, F(p) || t.alwaysExpand]])]),
							_: 3
						})]),
						o("div", sF, [o("div", cF, [M(n.$slots, "actions", { item: t.item }, () => [F(p) || t.showActionsOnCollapse ? (O(), a(e, { key: 0 }, [t.actionsMenu && t.item.action?.length > dF ? (O(), r(v, {
							key: 0,
							class: "h-item-card-menu",
							"close-on-content-click": !1
						}, {
							activator: L(({ props: e }) => [l(d, y({
								name: "HScopedItemCardMenuBtn",
								component: F(Gt),
								class: "h-item-card-menu-btn mr-2 mt-4"
							}, {
								...f.value,
								...e
							}), {
								default: L(() => [c(P(F(B)("select_ction")), 1)]),
								_: 1
							}, 16, ["component"])]),
							default: L(() => [l(St, { class: "h-item-card-menu-item__list" }, {
								default: L(() => [(O(!0), a(e, null, j(t.item.action?.filter((e) => !e.primary), (e, n) => (O(), r(u, {
									key: n,
									class: "h-item-card-menu-item__link",
									to: e.url,
									target: e.target,
									"no-route": "",
									"window-name": t.windowName ?? t.item.key
								}, {
									default: L(() => [l(qe, {
										class: "h-item-card-tooltip",
										disabled: !e?.description || t.hideTooltip,
										text: e?.description,
										location: e?.tooltipLocation ?? "bottom",
										"max-width": "600"
									}, {
										activator: L(({ props: t }) => [(O(), r(wt, y({ ref_for: !0 }, { ...t }, {
											key: n,
											class: "h-item-card-menu-item",
											value: n,
											role: "option"
										}), {
											default: L(() => [l(Et, { class: "h-item-card-menu-item__title" }, {
												default: L(() => [c(P(e.name), 1)]),
												_: 2
											}, 1024)]),
											_: 2
										}, 1040, ["value"]))]),
										_: 2
									}, 1032, [
										"disabled",
										"text",
										"location"
									])]),
									_: 2
								}, 1032, [
									"to",
									"target",
									"window-name"
								]))), 128))]),
								_: 1
							})]),
							_: 1
						})) : (O(!0), a(e, { key: 1 }, j(t.item.action?.filter((e) => !e.primary), (e, n) => (O(), r(u, {
							key: n,
							to: e.url,
							target: e.target,
							"no-route": "",
							"window-name": t.windowName ?? t.item.key
						}, {
							default: L(() => [l(qe, {
								class: "h-item-card-action-tooltip",
								disabled: !e?.description || t.hideTooltip,
								text: e?.description,
								location: e?.tooltipLocation ?? "bottom",
								"max-width": "600"
							}, {
								activator: L(({ props: t }) => [(O(), r(d, y({ ref_for: !0 }, {
									...f.value,
									...t
								}, {
									key: e.id,
									name: "HScopedItemCardActionBtn",
									component: F(Gt),
									color: "primary",
									class: "h-item-card-action-btn mr-2 mt-4"
								}), {
									default: L(() => [c(P(e.name), 1)]),
									_: 2
								}, 1040, ["component"]))]),
								_: 2
							}, 1032, [
								"disabled",
								"text",
								"location"
							])]),
							_: 2
						}, 1032, [
							"to",
							"target",
							"window-name"
						]))), 128))], 64)) : i("", !0)]), M(n.$slots, "footer", { item: t.item })]), o("div", lF, [M(n.$slots, "rightControl", { item: t.item }, () => [_.value && !t.hideBody && !t.alwaysExpand ? (O(), a("button", {
							key: 0,
							class: "flex d-flex align-end space-x-3 h-item-card__toggle-button",
							"aria-expanded": F(p),
							"aria-label": t.item.name,
							onClick: s[0] ||= (e) => F(m)()
						}, [l(V, { class: x(["h-item-card__arrow", {
							"rotate-180": F(p),
							"rotate-0": !F(p)
						}]) }, {
							default: L(() => [...s[2] ||= [c(" mdi:mdi-chevron-down ", -1)]]),
							_: 1
						}, 8, ["class"])], 8, uF)) : i("", !0)])])])
					]),
					_: 3
				})]),
				_: 3
			})]);
		};
	}
}), mF = { class: "h-100 w-100 d-flex justify-center align-center flex-column ga-2 font-weight-medium text-center loader" }, hF = {
	key: 0,
	class: "d-flex w-100 h-100 justify-center align-center flex-column ga-2 font-weight-medium text-center h-component-loader__content loader"
}, gF = /* @__PURE__ */ d({
	__name: "loader",
	props: /*@__PURE__*/ v({
		fullScreen: {
			type: Boolean,
			default: !0
		},
		percentage: {},
		text: {},
		size: { default: 100 },
		width: { default: 15 },
		rotate: { default: 360 },
		color: {},
		textColor: { default: "primary" },
		bgColor: {}
	}, {
		isLoading: {
			type: Boolean,
			default: !1
		},
		isLoadingModifiers: {}
	}),
	emits: ["update:isLoading"],
	setup(t) {
		let s = z(t, "HLoader"), c = ce(t, "isLoading"), u = n(() => Vt().current.value.colors[s.textColor] ?? s.textColor), d = n(() => ({
			indeterminate: s.percentage === void 0,
			...s.percentage !== void 0 && { modelValue: s.percentage },
			...s
		}));
		return (n, s) => (O(), a(e, null, [t.fullScreen ? (O(), r(on, {
			key: 0,
			modelValue: c.value,
			"onUpdate:modelValue": s[0] ||= (e) => c.value = e,
			height: "100%",
			width: "100%",
			class: "h-page-loader"
		}, {
			default: L(() => [o("div", mF, [l(sn, y({ class: "h-loader-full-screen-progress" }, d.value), {
				default: L(() => [d.value.indeterminate ? i("", !0) : (O(), a("span", {
					key: 0,
					class: x(["h-page-loader__percentage", { "opacity-20": t.percentage < 5 }]),
					style: C({ color: u.value })
				}, P(t.percentage) + " % ", 7))]),
				_: 1
			}, 16), o("span", {
				class: "h-page-loader__text",
				style: C({ color: u.value })
			}, P(d.value.text), 5)])]),
			_: 1
		}, 8, ["modelValue"])) : i("", !0), l(on, {
			modelValue: c.value,
			"onUpdate:modelValue": s[1] ||= (e) => c.value = e,
			width: "100%",
			height: "100%",
			class: "h-loader-contained-overlay align-center justify-center",
			contained: ""
		}, {
			default: L(() => [t.fullScreen ? i("", !0) : (O(), a("div", hF, [l(sn, y({ class: "h-loader-contained-progress" }, d.value), {
				default: L(() => [d.value.indeterminate ? i("", !0) : (O(), a("span", {
					key: 0,
					class: "h-page-loader__percentage",
					style: C({ color: u.value })
				}, P(t.percentage) + " % ", 5))]),
				_: 1
			}, 16), o("div", {
				class: "h-page-loader__text",
				style: C({ color: u.value })
			}, P(d.value.text), 5)]))]),
			_: 1
		}, 8, ["modelValue"])], 64));
	}
}), _F = { class: "h-countdown-timer" }, vF = { class: "h-countdown-timer__hours" }, yF = {
	key: 0,
	class: "h-countdown-timer__label"
}, bF = {
	key: 1,
	class: "h-countdown-timer__separator"
}, xF = { class: "h-countdown-timer__minutes" }, SF = {
	key: 0,
	class: "h-countdown-timer__label"
}, CF = {
	key: 1,
	class: "h-countdown-timer__separator"
}, wF = { class: "h-countdown-timer__seconds" }, TF = {
	key: 0,
	class: "h-countdown-timer__label"
}, EF = /*#__PURE__*/ Vn(/* @__PURE__ */ Object.assign({ name: "HCountdownTimer" }, {
	__name: "countdown-timer",
	props: {
		seconds: {
			type: Number,
			required: !0,
			validator: (e) => e >= 0
		},
		autoStart: {
			type: Boolean,
			default: !0
		},
		showHours: {
			type: Boolean,
			default: !0
		},
		showMinutes: {
			type: Boolean,
			default: !0
		},
		showSeconds: {
			type: Boolean,
			default: !0
		},
		showLabels: {
			type: Boolean,
			default: !1
		},
		separator: {
			type: String,
			default: ":"
		},
		customDefaults: {
			type: Object,
			default: void 0
		}
	},
	emits: [
		"update:seconds",
		"complete",
		"tick"
	],
	setup(t, { expose: r, emit: s }) {
		let c = s, l = z(t, "HCountdownTimer"), u = A(l.seconds), d = A(!1), f = null;
		I(() => l.seconds, (e) => {
			d.value || (u.value = e);
		});
		let p = n(() => Math.floor(u.value / 3600)), m = n(() => Math.floor(u.value % 3600 / 60)), h = n(() => u.value % 60), g = n(() => String(p.value).padStart(2, "0")), _ = n(() => String(m.value).padStart(2, "0")), v = n(() => String(h.value).padStart(2, "0")), y = n(() => p.value === 1 ? B("time_hour") : B("time_hours")), b = n(() => m.value === 1 ? B("time_minute") : B("time_minutes")), x = n(() => h.value === 1 ? B("time_second") : B("time_seconds")), S = () => {
			d.value || u.value <= 0 || (d.value = !0, f = setInterval(() => {
				u.value > 0 && (u.value--, c("update:seconds", u.value), c("tick", {
					hours: p.value,
					minutes: m.value,
					seconds: h.value
				}), u.value === 0 && (C(), c("complete")));
			}, 1e3));
		}, C = () => {
			d.value = !1, f &&= (clearInterval(f), null);
		}, T = () => {
			C(), u.value = l.seconds, c("update:seconds", u.value);
		};
		return E(() => {
			l.autoStart && S();
		}), w(() => {
			C();
		}), r({
			start: S,
			pause: C,
			reset: T,
			restart: () => {
				T(), S();
			},
			isRunning: n(() => d.value),
			remainingSeconds: n(() => u.value)
		}), (n, r) => (O(), a("div", _F, [
			t.showHours ? (O(), a(e, { key: 0 }, [
				o("span", vF, P(g.value), 1),
				t.showLabels ? (O(), a("span", yF, P(y.value), 1)) : i("", !0),
				!t.showLabels && (t.showMinutes || t.showSeconds) ? (O(), a("span", bF, P(t.separator), 1)) : i("", !0)
			], 64)) : i("", !0),
			t.showMinutes ? (O(), a(e, { key: 1 }, [
				o("span", xF, P(_.value), 1),
				t.showLabels ? (O(), a("span", SF, P(b.value), 1)) : i("", !0),
				!t.showLabels && t.showSeconds ? (O(), a("span", CF, P(t.separator), 1)) : i("", !0)
			], 64)) : i("", !0),
			t.showSeconds ? (O(), a(e, { key: 2 }, [o("span", wF, P(v.value), 1), t.showLabels ? (O(), a("span", TF, P(x.value), 1)) : i("", !0)], 64)) : i("", !0)
		]));
	}
}), [["__scopeId", "data-v-0d79665f"]]), DF = { class: "h-process-item-tooltip__title" }, OF = /* @__PURE__ */ d({
	__name: "process-state",
	props: {
		process: {},
		tooltipClass: {},
		mobileBreakpoint: {}
	},
	setup(t) {
		let { thresholds: s } = Bt(), c = z(t, "HProcessState"), u = A(!1), d = Ie(), f = n(() => s.value[c.mobileBreakpoint ?? d?.default_mobile_breakpoint?.value ?? "md"]), p = A(null);
		function m(e) {
			return e.icon ? e.icon : e.result?.skipped ? "mdi:mdi-chevron-double-right" : "mdi-blank";
		}
		_t(p, (e) => {
			requestAnimationFrame(() => {
				u.value = (e[0].contentBoxSize?.[0]?.inlineSize ?? 0) < f.value;
			});
		});
		let h = n(() => c.process?.slice().sort((e, t) => e.order - t.order).filter((e) => !e.result?.done && !e.result?.skipped)[0]?.order);
		return (n, s) => (O(), r(cn, {
			ref_key: "processStateEl",
			ref: p,
			modelValue: h.value,
			"onUpdate:modelValue": s[0] ||= (e) => h.value = e,
			class: "h-process-stepper",
			"alt-labels": !u.value,
			mobile: u.value,
			flat: !0,
			style: C({ "--step-count": t.process.length })
		}, {
			default: L(() => [l(ln, { class: "h-process-state-header" }, {
				default: L(() => [(O(!0), a(e, null, j(t.process, (n, s) => (O(), a(e, { key: n.id || s }, [s ? (O(), r(It, {
					key: 0,
					class: "h-process-state-divider",
					thickness: ""
				})) : i("", !0), l(qe, {
					class: x(["h-process-item-tooltip", {
						[t.tooltipClass ?? ""]: !!t.tooltipClass,
						"h-process-item-tooltip--hide": n.hide,
						"h-process-item-tooltip--error": !!n.result?.error,
						"h-process-item-tooltip--skipped": !!n.result?.skipped,
						"h-process-item-tooltip--active": n.order === h.value,
						"h-process-item-tooltip--inactive": !n.result?.done && !n.result?.skipped && !n.result?.error && n.order !== h.value,
						"h-process-item-tooltip--done": !!n.result?.done
					}]),
					"open-on-hover": u.value,
					"open-on-click": u.value,
					location: "bottom"
				}, {
					default: L(() => [o("div", null, [o("div", DF, P(n.name), 1), o("div", null, P(n.result?.statusmessage), 1)])]),
					activator: L(({ props: e }) => [l(un, y({ ref_for: !0 }, e, {
						value: n.order,
						icon: m(n),
						complete: !!n.result?.done,
						"complete-icon": n.completeIcon,
						"edit-icon": n.editIcon ?? m(n),
						"error-icon": n.errorIcon ?? "mdi:mdi-exclamation",
						title: n.name,
						subtitle: n.result?.statusmessage,
						rules: n.result?.error ? [() => !1] : void 0,
						editable: u.value,
						class: ["h-process-item", {
							"h-process-item--hide": n.hide,
							"h-process-item--error": n.result?.error,
							"h-process-item--skipped": n.result?.skipped,
							"h-process-item--active": n.order === h.value,
							"h-process-item--inactive": !n.result?.done && !n.result?.skipped && !n.result?.error && n.order !== h.value,
							"h-process-item--done": n.result?.done
						}],
						"aria-label": n.name
					}), null, 16, [
						"value",
						"icon",
						"complete",
						"complete-icon",
						"edit-icon",
						"error-icon",
						"title",
						"subtitle",
						"rules",
						"editable",
						"aria-label",
						"class"
					])]),
					_: 2
				}, 1032, [
					"open-on-hover",
					"open-on-click",
					"class"
				])], 64))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, [
			"modelValue",
			"alt-labels",
			"mobile",
			"style"
		]));
	}
}), kF = { class: "tooltip-message" }, AF = /*#__PURE__*/ Vn({
	__name: "process-state-simple",
	props: {
		result: Object,
		item: Object,
		maxVisible: {
			type: Number,
			default: Infinity
		}
	},
	setup(t) {
		let s = z(t, "HProcessStateSimple"), u = A(!1), d = n(() => u.value ? p.value : p.value.slice(0, s.maxVisible)), f = n(() => s.item || s.result || {}), p = n(() => (f.value?.state || []).filter((e) => !e.hide).map((e, t) => ({
			id: e.id || `step-${t}`,
			order: e.order ?? t + 1,
			name: e.name || `Step ${t + 1}`,
			status: e.status?.name || "Running",
			result: e.result || {}
		})));
		function m(e) {
			return e.result?.done ? "mini-stepper__step--step-done" : e.result?.error ? "mini-stepper__step--step-error" : e.status === "Running" && !e.result?.done ? "mini-stepper__step--process-running" : f.value?.status?.name === "Completed" ? "mini-stepper__step--process-completed" : f.value?.status?.name === "Stopped" ? "mini-stepper__step--process-stopped" : "mini-stepper__step--default";
		}
		function h(e) {
			return e.status === "Running" && !e.result?.done;
		}
		return (n, s) => (O(), r(Je, { class: "mini-stepper-container h-process-state-simple-main-container" }, {
			default: L(() => [l(cn, { class: "mini-stepper h-process-state-simple-main-stepper" }, {
				default: L(() => [l(ln, { class: "mini-stepper-header h-process-state-simple-stepper-header" }, {
					default: L(() => [(O(!0), a(e, null, j(d.value, (e, t) => (O(), r(qe, {
						key: e.id || t,
						location: "top",
						class: "h-process-state-simple-step-tooltip"
					}, {
						activator: L(({ props: t }) => [o("div", y({ class: ["mini-stepper__step-wrapper", { "mini-stepper__step-wrapper--current": h(e) }] }, { ref_for: !0 }, t), [o("div", { class: x(["mini-stepper__step", { [m(e)]: !0 }]) }, null, 2)], 16)]),
						default: L(() => [o("span", kF, P(e.name || "No Name"), 1)]),
						_: 2
					}, 1024))), 128)), p.value.length > t.maxVisible ? (O(), r(kt, {
						key: 0,
						size: "small",
						variant: "outlined",
						onClick: s[0] ||= (e) => u.value = !u.value
					}, {
						default: L(() => [c(P(u.value ? "‹" : `+${p.value.length - t.maxVisible}`), 1)]),
						_: 1
					})) : i("", !0)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}));
	}
}, [["__scopeId", "data-v-18021271"]]);
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
var jF = (e, t) => (e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e), MF = {
	key: 0,
	class: "h-search-items-dialog"
}, NF = { class: "d-flex justify-space-between w-100 px-4 py-1" }, PF = { class: "h-search-items-dialog__results" }, FF = { class: "h-search-items-dialog__results-count" }, IF = /* @__PURE__ */ d({
	__name: "search-dialog",
	props: {
		searching: { type: Boolean },
		term: {},
		searchProps: {},
		workspace: {},
		filter: {},
		pagesize: {},
		sort: {}
	},
	emits: ["update:searching", "update:term"],
	setup(e, { emit: t }) {
		let s = z(e, "HSearchItemsDialog"), { searching: c, term: u } = xt(s, t), { hHttpRequest: d } = Ce(), { data: f } = d({
			url: `my/workspaces/${s.workspace}`,
			immediate: !!s.workspace
		}, { throwHttpErrors: !1 }), p = A(B("what_are_you_looking_for")), m = n(() => f?.value?.help?.searchtext ?? []), { pause: h } = gt(() => {
			if (!m.value.length) {
				h();
				return;
			}
			p.value = m.value[jF(0, m.value.length - 1)];
		}, 2e3), { params: _, data: v, loading: b } = d({
			url: `/my/items/${s.workspace}`,
			params: {
				term: (e) => e?.trim() || "*",
				filter: s.filter,
				pagesize: s.pagesize,
				sort: s.sort
			},
			isLive: !0,
			immediate: !1
		}, { throwHttpErrors: !1 });
		return I(() => _.term, () => {
			u.value = _.term;
		}), D(() => {
			u.value = null;
		}), (t, n) => {
			let u = N("h-search-items-results");
			return O(), r(Rt, {
				modelValue: F(c),
				"onUpdate:modelValue": n[1] ||= (e) => g(c) ? c.value = e : null,
				class: "h-search-dialog-main-dialog",
				"aria-label": F(B)("search_items")
			}, {
				default: L(() => [F(c) ? (O(), a("div", MF, [M(t.$slots, "inner-search", { searchData: e.searchProps }, () => [l(Ze, y({
					modelValue: F(_).term,
					"onUpdate:modelValue": n[0] ||= (e) => F(_).term = e
				}, { ...F(s).searchProps }, {
					variant: "solo",
					density: "compact",
					"single-line": !0,
					flat: !0,
					class: "h-search-items-dialog__field",
					placeholder: p.value,
					"hide-details": "",
					autofocus: "",
					loading: F(b)
				}), null, 16, [
					"modelValue",
					"placeholder",
					"loading"
				])]), F(v) === null || F(v) === void 0 ? i("", !0) : (O(), r(Be, {
					key: 0,
					class: "mt-2 h-search-items-dialog__items"
				}, {
					default: L(() => [l(He, { class: "h-search-dialog-results-card-item pa-0 flex-grow-1" }, {
						default: L(() => [l(Ge, { class: "h-search-items-dialog__title" }, {
							default: L(() => [o("div", NF, [o("div", PF, P(F(B)("search_results")), 1), o("div", FF, P(F(v)?.meta?.totalresults) + " " + P(F(B)("search_hits")), 1)]), l(It, {
								class: "h-search-dialog-results-divider",
								thickness: "1"
							})]),
							_: 1
						}), M(t.$slots, "items", {}, () => [l(u, {
							items: F(v)?.records,
							workspace: e.workspace
						}, null, 8, ["items", "workspace"])])]),
						_: 3
					})]),
					_: 3
				}))])) : i("", !0)]),
				_: 3
			}, 8, ["modelValue", "aria-label"]);
		};
	}
}), LF = { class: "h-search-items" }, RF = /* @__PURE__ */ d({
	__name: "search-activator",
	props: {
		workspace: {},
		persist: {
			type: Boolean,
			default: !1
		},
		showDialog: {
			type: Boolean,
			default: !0
		},
		filter: {},
		pagesize: {},
		sort: {}
	},
	emits: ["update:searching"],
	setup(e, { emit: t }) {
		z(e, "HSearchItems");
		let n = ut(), o = je("search"), s = A(""), [c, u] = yt();
		return I(n, () => {
			c.value = !1;
		}), (t, n) => (O(), a("div", LF, [M(t.$slots, "activator", {
			searchProps: F(o),
			toggleSearching: F(u)
		}, () => [l(Ze, y({ ...F(o) }, {
			id: "searchItemsActivator",
			modelValue: s.value,
			"onUpdate:modelValue": n[0] ||= (e) => s.value = e,
			"hide-details": "",
			"aria-label": F(B)("search"),
			class: "h-search-activator-text-field",
			onClick: n[1] ||= (e) => F(u)(!0)
		}), null, 16, ["modelValue", "aria-label"])]), e.showDialog ? M(t.$slots, "dialog", {
			key: 0,
			term: s.value,
			workspace: e.workspace,
			searching: F(c),
			searchProps: F(o),
			persist: e.persist,
			filter: e.filter,
			pagesize: e.pagesize,
			sort: e.sort
		}, () => [F(c) || e.persist ? (O(), r(IF, {
			key: 0,
			term: s.value,
			"onUpdate:term": n[2] ||= (e) => s.value = e,
			searching: F(c),
			"onUpdate:searching": n[3] ||= (e) => g(c) ? c.value = e : null,
			workspace: e.workspace ?? "",
			"search-props": F(o),
			persist: e.persist,
			filter: e.filter,
			pagesize: e.pagesize,
			sort: e.sort
		}, null, 8, [
			"term",
			"searching",
			"workspace",
			"search-props",
			"persist",
			"filter",
			"pagesize",
			"sort"
		])) : i("", !0)]) : i("", !0)]));
	}
}), zF = /* @__PURE__ */ new Map();
function BF(e) {
	let t = zF.get(e);
	if (t) return t;
	let n = _(u(e));
	return zF.set(e, n), n;
}
//#endregion
//#region src/components/general/item-card-template.vue
var VF = /* @__PURE__ */ d({
	__name: "item-card-template",
	props: {
		item: {},
		template: {}
	},
	setup(e) {
		let t = z(e, "HItemCardResolver"), i = n(() => o()), { resolveItemCard: a } = Se();
		function o() {
			let e = a(t.template ?? t.item.type ?? "");
			return e ? typeof e == "function" ? BF(e) : _(e.default ?? e) : pF;
		}
		return (e, n) => (O(), r(te(i.value), {
			key: F(t).item?.key,
			item: F(t).item
		}, s({ _: 2 }, [j(e.$slots, (t, n) => ({
			name: n,
			fn: L(() => [M(e.$slots, n)])
		}))]), 1032, ["item"]));
	}
}), HF = { class: "h-search-items-results__row" }, UF = {
	key: 0,
	class: "h-search-items__no-results text-center w-100 mt-4"
}, WF = { class: "h-search-items-results__list" }, GF = ["aria-expanded", "aria-selected"], KF = { class: "w-100 h-100 d-flex justify-center align-center" }, qF = { class: "search-items-item__preview pb-4" }, JF = {
	key: 1,
	class: "h-search-items-results__preview-wrapper"
}, YF = { class: "h-search-items-results__preview" }, XF = { class: "h-search-items-preview" }, ZF = /* @__PURE__ */ d({
	__name: "search-results",
	props: { items: {} },
	setup(u) {
		let d = u;
		z(d, "HSearchItemsResults");
		let { oGetImage: f } = Fe(), { xs: p } = Bt(), m = A({}), h = A(), g = n(() => p ? 40 : 60);
		I(n(() => d.items || []), () => {
			h.value = null;
		});
		function _(e) {
			return p.value && !!m.value[e.key];
		}
		function v(e) {
			return !p.value && h.value?.key === e.key;
		}
		function y(e) {
			m.value[e.key] = !m.value[e.key];
		}
		function b(e) {
			h.value = e;
		}
		return (n, d) => (O(), a("div", HF, [
			u.items?.length ? i("", !0) : (O(), a("div", UF, [l(V, {
				class: "h-search-items__no-results-icon",
				icon: "mdi:mdi-alert"
			}), o("h4", null, P(F(B)("no_results_found")), 1)])),
			o("div", WF, [u.items?.length ? (O(), r(St, {
				key: 0,
				class: "pt-0"
			}, {
				default: L(() => [(O(!0), a(e, null, j(u.items, (e) => (O(), a("div", {
					key: e.id || e.key,
					class: x(["h-search-items-item mb-sm-2", { "h-search-items-item--expanded": _(e) || v(e) }]),
					"aria-expanded": _(e),
					"aria-selected": v(e),
					role: "option"
				}, [o("div", null, [l(wt, {
					class: "h-search-items-item__list-item",
					title: e.name,
					subtitle: e.description,
					onMouseover: (t) => b(e),
					onFocus: (t) => b(e)
				}, s({
					prepend: L(() => [l(jt, {
						src: F(f)(e.icon ?? ""),
						width: g.value,
						height: g.value,
						class: "h-search-items-item__image rounded mr-4"
					}, {
						placeholder: L(() => [o("div", KF, [l(V, {
							class: "h-search-results-item-placeholder-icon",
							icon: "mdi:mdi-help-box",
							size: "large"
						}, {
							default: L(() => [c(P(e.icon), 1)]),
							_: 2
						}, 1024)])]),
						_: 2
					}, 1032, [
						"src",
						"width",
						"height"
					])]),
					_: 2
				}, [F(p) ? {
					name: "append",
					fn: L(() => [l(Ke, {
						icon: _(e) ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down",
						class: "h-search-items-item__show-more",
						variant: "text",
						rounded: !1,
						width: "30",
						onClick: (t) => y(e)
					}, null, 8, ["icon", "onClick"])]),
					key: "0"
				} : void 0]), 1032, [
					"title",
					"subtitle",
					"onMouseover",
					"onFocus"
				]), de(o("div", qF, [l(VF, {
					class: "search-items-item__preview-card",
					item: e,
					"action:density": "compact",
					"always-expand": !0
				}, null, 8, ["item"])], 512), [[ue, _(e)]])])], 10, GF))), 128))]),
				_: 1
			})) : i("", !0)]),
			!F(p) && h.value && u.items?.length > 0 ? (O(), a("div", JF, [o("div", YF, [o("div", XF, [(O(), r(t, null, [(O(), r(VF, {
				key: h.value.key,
				item: h.value,
				"always-expand": !0
			}, null, 8, ["item"]))], 1024))])])])) : i("", !0)
		]));
	}
}), QF = /* @__PURE__ */ function(e) {
	return e.New = "new", e.Read = "read", e;
}({}), $F = { class: "h-notification-item" }, eI = { class: "h-notification-item__type" }, tI = { class: "h-notification-item__time" }, nI = /* @__PURE__ */ d({
	__name: "notification-item",
	props: { notification: {} },
	emits: ["updateStatus"],
	setup(e, { emit: t }) {
		z(e, "HNotificationItem");
		let n = t;
		async function r(e, t) {
			n("updateStatus", e, t);
		}
		return (t, n) => (O(), a("div", $F, [
			l(Ke, {
				id: "btn-read",
				class: "h-notification-item-read-btn",
				"aria-label": "mark_as_read",
				onClick: n[0] ||= R((t) => r(e.notification.id, e.notification.status === F(QF).New ? F(QF).Read : F(QF).New), ["stop"])
			}, {
				default: L(() => [l(V, { class: "h-notification-item-read-icon" }), l(qe, {
					class: "h-notification-tooltip",
					activator: "parent"
				}, {
					default: L(() => [c(P(e.notification.status === "read" ? F(B)("mark_as_unread") : F(B)("mark_as_read")), 1)]),
					_: 1
				})]),
				_: 1
			}),
			o("span", eI, P(e.notification.title), 1),
			n[1] ||= c("  •  ", -1),
			o("span", tI, P(e.notification.timeAgo), 1),
			o("div", { class: x(["h-notification-item__title mt-1", { "read-all": e.notification.status === "read" }]) }, P(e.notification.message), 3)
		]));
	}
}), rI = { class: "h-notification-drawer" }, iI = { id: "btn-notif-actions" }, aI = /* @__PURE__ */ d({
	__name: "notification-drawer",
	props: /*@__PURE__*/ v({
		title: { default: "Notifications" },
		location: { default: "right" },
		width: { default: 400 },
		notificationData: { default: () => ({
			records: [],
			aggregations: { status_count: {
				doc_count_error_upper_bound: 0,
				sum_other_doc_count: 0,
				buckets: []
			} }
		}) }
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ v([
		"getUnreadCount",
		"markAllAsRead",
		"updateStatus"
	], ["update:modelValue"]),
	setup(t, { emit: n }) {
		let s = z(t, "HNotificationDrawer"), u = Ae(), { oUserSettings: d } = xn(Le()), f = n, p = ce(t, "modelValue"), m = A({}), h = ft(async () => {
			let e = [];
			for (let t of s.notificationData.records) {
				let n = new Date(t.timestamp || t.createdate), r = await y(d.value?.settings?.locale || F(u));
				e.push({
					...t,
					timeAgo: pn(n, /* @__PURE__ */ new Date(), {
						addSuffix: !0,
						locale: r
					})
				});
			}
			return e;
		});
		async function g() {
			f("markAllAsRead");
		}
		async function _(e, t) {
			f("updateStatus", e, t);
		}
		function v() {
			for (let e in m.value) m.value[e] = !1;
		}
		function y(e) {
			let t = {
				en: vn,
				enUS: vn,
				fi: yn,
				sv: bn
			};
			return t[e] ?? t[e?.split("-")[0]] ?? vn;
		}
		return (n, s) => {
			let u = N("h-theme-scope");
			return O(), a("div", rI, [l(nn, {
				modelValue: p.value,
				"onUpdate:modelValue": s[2] ||= (e) => p.value = e,
				location: "right",
				class: "h-notifications-panel bg-background",
				width: t.width,
				temporary: ""
			}, {
				default: L(() => [
					l(wt, {
						title: t.title,
						class: "h-notification-drawer-header-list-item header bg-surface"
					}, {
						default: L(() => [o("div", iI, [l(u, {
							name: "HScopedNotificationDrawerMarkAllBtn",
							component: F(Gt),
							class: "h-notification-drawer-mark-all-btn mr-2",
							onClick: s[0] ||= (e) => g()
						}, {
							default: L(() => [c(P(F(B)("mark_all_as_read")), 1)]),
							_: 1
						}, 8, ["component"]), l(u, {
							name: "HScopedNotificationDrawerCloseBtn",
							component: F(Gt),
							class: "h-notification-drawer-close-btn",
							"aria-label": "collapse_notifications",
							onClick: s[1] ||= (e) => {
								p.value = !1, v();
							}
						}, null, 8, ["component"])])]),
						_: 1
					}, 8, ["title"]),
					l(It, { class: "h-notification-drawer-divider" }),
					(O(!0), a(e, null, j(F(h), (e) => (O(), r(wt, {
						key: e.id,
						link: "",
						class: x(["h-notification-drawer-notification-list-item notification bg-surface mx-6 my-3", { unread: e.status === F(QF).New }]),
						elevation: 1,
						onClick: (t) => _(e.id, e.status === F(QF).New ? F(QF).Read : F(QF).New)
					}, {
						default: L(() => [M(n.$slots, "item", { notification: e }, () => [n.$slots.item ? i("", !0) : (O(), r(nI, {
							key: 0,
							class: "h-100",
							notification: e,
							onUpdateStatus: _
						}, null, 8, ["notification"]))])]),
						_: 2
					}, 1032, ["class", "onClick"]))), 128))
				]),
				_: 3
			}, 8, ["modelValue", "width"])]);
		};
	}
}), oI = /* @__PURE__ */ d({
	__name: "notification-badge",
	props: {
		aggregations: { default: () => ({ status_count: {
			doc_count_error_upper_bound: 0,
			sum_other_doc_count: 0,
			buckets: []
		} }) },
		color: {}
	},
	setup(e) {
		let t = z(e, "HNotificationBadge"), i = A(!1);
		function a() {
			i.value = !0;
		}
		let s = n(() => t.aggregations.status_count.buckets.find((e) => e.key === QF.New)?.doc_count || 0);
		return (t, n) => (O(), r(Ke, {
			id: "btn-notification",
			icon: "",
			class: "h-notification-badge",
			"aria-label": F(B)("notifications"),
			onClick: a
		}, {
			default: L(() => [s.value > 0 ? (O(), r(At, {
				key: 0,
				color: e.color,
				bordered: "",
				class: "h-notification-badge-count-badge"
			}, {
				badge: L(() => [o("span", null, P(s.value), 1)]),
				default: L(() => [l(V, { class: "h-notification-badge-icon" }, {
					default: L(() => [...n[0] ||= [c("mdi:mdi-bell-outline", -1)]]),
					_: 1
				})]),
				_: 1
			}, 8, ["color"])) : (O(), r(V, {
				key: 1,
				class: "h-notification-badge-unread-icon"
			}, {
				default: L(() => [...n[1] ||= [c("mdi:mdi-bell-outline", -1)]]),
				_: 1
			}))]),
			_: 1
		}, 8, ["aria-label"]));
	}
}), sI = ["src", "alt"], cI = { key: 1 }, lI = /*#__PURE__*/ Vn({
	__name: "onify-logo",
	props: {
		alt: String,
		fallbackSrc: String,
		src: {
			type: String,
			default: ""
		}
	},
	setup(e) {
		let t = e, r = Vt(), i = A([]), o = n(() => r?.global?.current?.value?.dark), s = n(() => {
			let e = he();
			return t.src || be(e, pe) || be(e, ye);
		}), c = n(() => [s.value, t.fallbackSrc || "data:image/png;base64,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"].find((e) => e && !i.value.includes(e)));
		return (t, n) => (O(), a("div", { class: x(["h-onify-logo", {
			"h-onify-logo--dark": o.value,
			"h-onify-logo--custom": c.value && c.value === s.value
		}]) }, [c.value ? (O(), a("img", {
			key: 0,
			class: "h-onify-logo__image",
			src: c.value,
			alt: e.alt ?? "Onify Logo",
			onError: n[0] ||= (e) => i.value.push(c.value)
		}, null, 40, sI)) : (O(), a("span", cI, P(e.alt), 1))], 2));
	}
}, [["__scopeId", "data-v-785017e3"]]), uI = { key: 1 }, dI = {
	key: 1,
	class: "h-layout__logo"
}, fI = { key: 2 }, pI = { class: "mr-2" }, mI = { key: 1 }, hI = { key: 2 }, gI = /* @__PURE__ */ d({
	__name: "navigation-menu",
	props: /*@__PURE__*/ v({
		workspaceSlug: {},
		loading: { type: Boolean },
		adminDesign: { type: Boolean },
		activePath: {}
	}, {
		modelValue: { type: Boolean },
		modelModifiers: {},
		loading: {},
		loadingModifiers: {}
	}),
	emits: ["update:modelValue", "update:loading"],
	setup(t) {
		let s = z(t, "HNavigationMenu"), c = ce(t, "modelValue"), u = A([]);
		function d(e) {
			try {
				return new URL(e, window.location.origin).pathname === s.activePath;
			} catch {
				return !1;
			}
		}
		I(c, (e) => {
			e && s.adminDesign && (u.value = s.activePath?.includes("/admin/connector/") ? ["administration", "connector"] : ["administration"]);
		});
		let f = ce(t, "loading");
		f.value = !0;
		let p = we().hubAppUrl.replace(/\/$/, ""), m = p, h = Ie(), { oUserSettings: g } = xn(Le()), { hHttpRequest: _ } = Ce(), { oGetImage: v } = Fe(), b = `${m}/admin/dashboard`, { data: S, loading: w } = _({ url: "/my/workspaces" }), { data: T, execute: E, loading: D } = _({
			url: () => `/my/shortcuts/workspace/${s.workspaceSlug}?pagesize=50`,
			precondition: () => !!s.workspaceSlug
		}), { data: k } = _({ url: "/my/shortcuts?placement=menu&term=*&pagesize=50" }), ee = n(() => S?.value?.map((e) => ({
			...e,
			link: e.startpage ? e.startpage : `${h?.workspaces_path?.value}/${e?.slug}`
		})) ?? []), te = n(() => s.workspaceSlug ? (T?.value ?? []).map((e) => ({
			...e,
			link: `${p}${e?.link}`
		})) ?? [] : []), ne = n(() => k?.value?.records?.map((e) => ({
			...e,
			link: `${p}${e?.link}`
		})) ?? []), re = n(() => ee.value?.find((e) => e.slug === s.workspaceSlug)), ie = n(() => (g.value?.role ?? []).includes("admin")), ae = n(() => [
			{
				link: `${m}/admin/agents`,
				name: B("agents_page_title"),
				icon: "mdi:mdi-robot-outline"
			},
			{
				link: `${m}/admin/audit`,
				name: B("activity_log"),
				icon: "mdi:mdi-format-list-bulleted-triangle"
			},
			{
				link: `${m}/admin/bulletins`,
				name: B("bulletins_page_title"),
				icon: "mdi:mdi-newspaper-variant-outline"
			},
			{
				link: `${m}/admin/dashboards`,
				name: B("admin_dashboards_title"),
				icon: "mdi:mdi-view-dashboard-variant-outline"
			},
			{
				link: `${m}/admin/domains`,
				name: B("admin_domains_title"),
				icon: "mdi:mdi-domain"
			},
			{
				link: `${m}/admin/forms`,
				name: B("admin_forms_title"),
				icon: "mdi:mdi-form-select"
			},
			{
				link: `${m}/admin/guides`,
				name: B("admin_guides_title"),
				icon: "mdi:mdi-book-open-outline"
			},
			{
				link: `${m}/admin/items`,
				name: B("admin_items_title"),
				icon: "mdi:mdi-format-list-bulleted"
			},
			{
				link: `${m}/admin/locales`,
				name: B("locales_page_title"),
				icon: "mdi:mdi-web"
			},
			{
				link: `${m}/admin/options`,
				name: B("admin_options_title"),
				icon: "mdi:mdi-tune-variant"
			},
			{
				link: `${m}/admin/processes`,
				name: B("admin_processes_title"),
				icon: "mdi:mdi-sitemap-outline"
			},
			{
				link: `${m}/admin/roles`,
				name: B("roles_page_title"),
				icon: "mdi:mdi-shield-account-outline"
			},
			{
				link: `${m}/admin/settings`,
				name: B("admin_settings_title"),
				icon: "mdi:mdi-file-cog-outline"
			},
			{
				link: `${m}/admin/shortcuts`,
				name: B("admin_shortcuts_title"),
				icon: "mdi:mdi-arrow-top-right-thick"
			},
			{
				link: `${m}/admin/strings`,
				name: B("admin_strings_title"),
				icon: "mdi:mdi-translate"
			},
			{
				link: `${m}/admin/users`,
				name: B("users_page_title"),
				icon: "mdi:mdi-account-group-outline"
			},
			{
				link: `${m}/admin/workflows`,
				name: B("admin_workflows_title"),
				icon: "mdi:mdi-sitemap"
			},
			{
				link: `${m}/admin/workspaces`,
				name: B("admin_workspaces_title"),
				icon: "mdi:mdi-view-grid-outline"
			},
			{
				link: `${m}/admin/resources`,
				name: B("admin_resources_title"),
				icon: "mdi:mdi-folder-outline"
			},
			{
				link: `${m}/admin/system-logs`,
				name: B("admin_system_logs_title"),
				icon: "mdi:mdi-view-list-outline"
			}
		].sort((e, t) => e.name.localeCompare(t.name, "sv"))), oe = n(() => [
			{
				link: `${m}/admin/connector/pipelines`,
				name: B("admin_connector_pipelines_title"),
				icon: "mdi:mdi-pipe"
			},
			{
				link: `${m}/admin/connector/datasource/file`,
				name: B("admin_connector_datasource_file_title"),
				icon: "mdi:mdi-file-outline"
			},
			{
				link: `${m}/admin/connector/datasource/ldap`,
				name: B("admin_connector_datasource_ldap_title"),
				icon: "mdi:mdi-folder-network-outline"
			},
			{
				link: `${m}/admin/connector/datasource/rest`,
				name: B("admin_connector_datasource_rest_title"),
				icon: "mdi:mdi-api"
			},
			{
				link: `${m}/admin/connector/datasource/sql`,
				name: B("admin_connector_datasource_sql_title"),
				icon: "mdi:mdi-database-outline"
			},
			{
				link: `${m}/admin/connector/tasks/index`,
				name: B("admin_connector_index_title"),
				icon: "mdi:mdi-database-search-outline"
			},
			{
				link: `${m}/admin/connector/tasks/purge`,
				name: B("admin_connector_purge_title"),
				icon: "mdi:mdi-delete-sweep-outline"
			},
			{
				link: `${m}/admin/connector/tasks/reader`,
				name: B("admin_connector_reader_title"),
				icon: "mdi:mdi-book-open-page-variant-outline"
			},
			{
				link: `${m}/admin/connector/tasks/script`,
				name: B("admin_connector_script_title"),
				icon: "mdi:mdi-script-text-outline"
			},
			{
				link: `${m}/admin/connector/tasks/transform`,
				name: B("admin_connector_transform_title"),
				icon: "mdi:mdi-swap-horizontal"
			}
		].sort((e, t) => e.name.localeCompare(t.name, "sv")));
		return I(() => s.workspaceSlug, () => {
			s.workspaceSlug && E();
		}), I([D, w], (e) => {
			f.value = !pt(e, (e) => !e).value;
		}), (n, s) => {
			let f = N("h-onify-logo"), p = N("h-theme-scope"), m = N("h-action-link"), g = N("h-shortcut");
			return O(), r(nn, {
				modelValue: c.value,
				"onUpdate:modelValue": s[1] ||= (e) => c.value = e,
				class: x(["h-navigation-menu h-layout__nav", {
					[`h-layout__nav--${t.workspaceSlug}`]: !!t.workspaceSlug,
					"h-navigation-menu--admin": t.adminDesign
				}]),
				style: C({
					"--workspace-item-bg-color": re.value?.color,
					"--workspace-item-text-color": "#ffffff"
				}),
				color: "navigation-menu",
				temporary: ""
			}, {
				prepend: L(() => [l($t, { class: "h-layout__nav-header d-flex justify-center align-center py-3" }, {
					default: L(() => [M(n.$slots, "logo", {}, () => [re.value ? (O(), a("div", uI, [l(p, {
						name: "HScopedNavigationMenuLogoAvatar",
						component: F(Wt),
						class: "h-layout__avatar"
					}, {
						default: L(() => [re.value.icon ? (O(), r(V, {
							key: 0,
							icon: re.value.icon,
							class: "h-layout__logo"
						}, null, 8, ["icon"])) : (O(), a("span", dI, P(re.value.name[0]), 1))]),
						_: 1
					}, 8, ["component"])])) : (O(), r(f, { key: 0 }))])]),
					_: 3
				})]),
				default: L(() => [l(St, {
					opened: u.value,
					"onUpdate:opened": s[0] ||= (e) => u.value = e,
					"expand-icon": t.adminDesign ? "mdi:mdi-chevron-right" : void 0,
					"collapse-icon": t.adminDesign ? "mdi:mdi-chevron-down" : void 0,
					class: "h-navigation-menu-main-list",
					density: "compact",
					nav: "",
					"aria-label": F(B)("main_navigation")
				}, {
					default: L(() => [
						l(m, {
							to: b,
							"no-route": ""
						}, {
							default: L(() => [l(wt, {
								class: "h-navigation-menu-home-list-item font-weight-medium",
								"prepend-icon": "mdi:mdi-home-outline",
								nav: "",
								link: "",
								title: F(B)("home"),
								role: "option"
							}, null, 8, ["title"])]),
							_: 1
						}),
						(O(!0), a(e, null, j(te.value, (e) => (O(), r(wt, {
							key: e.key,
							link: "",
							class: "h-layout__root-item",
							role: "option"
						}, {
							default: L(() => [l(g, {
								workspace: t.workspaceSlug,
								class: "h-layout__shortcut",
								shortcut: e,
								"badge:color": "secondary",
								"badge:inline": ""
							}, {
								avatar: L(({ icon: t, isImage: n }) => [l(F(Wt), { class: "h-navigation-menu-shortcut-avatar bg-gradient-shortcut-icon mr-4" }, {
									default: L(() => [t && !n ? (O(), r(V, {
										key: 0,
										class: "h-navigation-menu-shortcut-icon",
										icon: t
									}, null, 8, ["icon"])) : t && n ? (O(), r(jt, {
										key: 1,
										class: "h-navigation-menu-shortcut-icon",
										height: "32",
										src: F(v)(t),
										alt: F(B)("image_alt_shortcut_icon")
									}, null, 8, ["src", "alt"])) : (O(), a("span", fI, P(e.title[0]), 1))]),
									_: 2
								}, 1024)]),
								_: 2
							}, 1032, ["workspace", "shortcut"])]),
							_: 2
						}, 1024))), 128)),
						l(It, {
							class: "h-navigation-menu-main-divider my-5",
							role: "presentation"
						}),
						l(Ct, {
							value: "workspaces",
							class: "h-navigation-menu-workspaces-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: L(({ props: e }) => [l(wt, y(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-view-grid-outline",
								role: "option"
							}), {
								title: L(() => [o("span", pI, P(F(B)("workspaces")), 1), l(m, {
									to: F(h)?.workspaces_path?.value ?? void 0,
									"no-route": ""
								}, {
									default: L(() => [l(Ke, {
										class: "h-navigation-menu-workspaces-btn",
										"aria-label": F(B)("open_in_new")
									}, null, 8, ["aria-label"])]),
									_: 1
								}, 8, ["to"])]),
								_: 1
							}, 16)]),
							default: L(() => [(O(!0), a(e, null, j(ee.value, (e, n) => (O(), r(m, {
								key: e.link || n,
								class: "h-navigation-menu-workspaces-item-action-link",
								to: e.link ? e.link : void 0,
								"no-route": ""
							}, {
								default: L(() => [de((O(), r(wt, {
									id: `workspace-admin_${n}`,
									key: `workspace_${n}`,
									title: e.name,
									value: e,
									link: "",
									class: x(["h-layout__grouped-item h-layout__workspace-item", { [`h-layout__workspace-item--${e.slug}`]: !!e.slug }]),
									style: C({
										"--workspace-item-bg-color": e?.color,
										"--workspace-item-text-color": "#ffffff"
									}),
									active: e.slug === t.workspaceSlug,
									role: "option"
								}, {
									prepend: L(() => [l(F(Wt), { class: "h-layout__workspace-item-avatar" }, {
										default: L(() => [e.icon ? (O(), r(V, {
											key: 0,
											class: "h-navigation-menu-workspaces-item-icon",
											icon: e.icon
										}, null, 8, ["icon"])) : (O(), a("span", mI, P(e.name[0]), 1))]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1032, [
									"id",
									"title",
									"value",
									"class",
									"style",
									"active"
								])), [[Sn, { text: e.description }]])]),
								_: 2
							}, 1032, ["to"]))), 128))]),
							_: 1
						}),
						ie.value ? (O(), r(Ct, {
							key: 0,
							value: "administration",
							class: "h-navigation-menu-admin-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: L(({ props: e }) => [l(wt, y(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-cog-outline",
								title: F(B)("administration"),
								role: "option"
							}), null, 16, ["title"])]),
							default: L(() => [(O(!0), a(e, null, j(ae.value, (e, n) => (O(), r(m, {
								key: e.link || n,
								to: e.link ? e.link : void 0,
								"no-route": ""
							}, {
								default: L(() => [l(wt, {
									id: `item-admin_${n}`,
									class: "h-navigation-menu-admin-item-list-item h-layout__grouped-item",
									"prepend-icon": e.icon,
									nav: "",
									link: "",
									title: e.name,
									active: t.adminDesign && d(e.link),
									role: "option"
								}, null, 8, [
									"id",
									"prepend-icon",
									"title",
									"active"
								])]),
								_: 2
							}, 1032, ["to"]))), 128)), l(Ct, {
								value: "connector",
								fluid: "",
								role: "group"
							}, {
								activator: L(({ props: e }) => [l(wt, y(e, {
									class: "h-layout__grouped-item",
									"prepend-icon": "mdi:mdi-connection",
									nav: "",
									link: "",
									title: F(B)("connector"),
									role: "option"
								}), null, 16, ["title"])]),
								default: L(() => [(O(!0), a(e, null, j(oe.value, (e, n) => (O(), r(m, {
									key: e.link || n,
									to: e.link ? e.link : void 0,
									"no-route": ""
								}, {
									default: L(() => [l(wt, {
										id: `item-connector_${n}`,
										class: "h-navigation-menu-admin-item-list-item h-layout__grouped-item h-layout__connector-item",
										"prepend-icon": e.icon,
										nav: "",
										link: "",
										title: e.name,
										active: t.adminDesign && d(e.link),
										role: "option"
									}, null, 8, [
										"id",
										"prepend-icon",
										"title",
										"active"
									])]),
									_: 2
								}, 1032, ["to"]))), 128))]),
								_: 1
							})]),
							_: 1
						})) : i("", !0),
						ne.value.length && t.workspaceSlug ? (O(), r(Ct, {
							key: 1,
							class: "h-navigation-menu-shortcuts-list-group mt-2",
							fluid: "",
							role: "group"
						}, {
							activator: L(({ props: e }) => [l(wt, y(e, {
								class: "h-layout__group",
								"prepend-icon": "mdi:mdi-arrow-top-right-thick",
								title: F(B)("shortcuts"),
								role: "option"
							}), null, 16, ["title"])]),
							default: L(() => [(O(!0), a(e, null, j(ne.value, (e, n) => (O(), r(wt, {
								id: `item-admin_${n}`,
								key: `workspace_${n}`,
								class: "h-navigation-menu-shortcuts-item-list-item h-layout__grouped-item",
								nav: "",
								link: "",
								role: "option"
							}, {
								default: L(() => [l(g, {
									class: "h-layout__shortcut",
									workspace: t.workspaceSlug,
									shortcut: e,
									"badge:inline": "",
									"badge:color": "secondary"
								}, {
									avatar: L(({ icon: t, isImage: n }) => [l(F(Wt), { class: "h-navigation-menu-shortcuts-item-avatar bg-gradient-shortcut-icon mr-4" }, {
										default: L(() => [t && !n ? (O(), r(V, {
											key: 0,
											class: "h-navigation-menu-shortcuts-item-icon",
											icon: t
										}, null, 8, ["icon"])) : t && n ? (O(), r(jt, {
											key: 1,
											class: "h-navigation-menu-shortcut-icon",
											height: "32",
											src: F(v)(t),
											alt: F(B)("image_alt_shortcut_icon")
										}, null, 8, ["src", "alt"])) : (O(), a("span", hI, P(e.title[0]), 1))]),
										_: 2
									}, 1024)]),
									_: 2
								}, 1032, ["workspace", "shortcut"])]),
								_: 2
							}, 1032, ["id"]))), 128))]),
							_: 1
						})) : i("", !0)
					]),
					_: 1
				}, 8, [
					"opened",
					"expand-icon",
					"collapse-icon",
					"aria-label"
				])]),
				_: 3
			}, 8, [
				"modelValue",
				"class",
				"style"
			]);
		};
	}
}), _I = { class: "d-flex align-center h-breadcrumbs" }, vI = {
	key: 1,
	class: "h-breadcrumb__item-text"
}, yI = /* @__PURE__ */ d({
	__name: "breadcrumbs-nav",
	props: { items: {} },
	setup(e) {
		let { smAndDown: t } = Bt();
		z(e, "HBreadcrumbs");
		let n = dt();
		function o() {
			n.back();
		}
		return (n, s) => {
			let u = N("h-action-link");
			return O(), a("div", _I, [F(t) ? (O(), r(Ke, {
				key: 0,
				class: "h-breadcrumbs-back-btn mr-2",
				onClick: s[0] ||= (e) => o()
			})) : i("", !0), l(Ye, {
				"no-gutters": "",
				class: "h-breadcrumb__container"
			}, {
				default: L(() => [l(ze, {
					items: e.items,
					class: "h-breadcrumb pl-0 py-4"
				}, {
					divider: L(() => [l(V, { class: "h-breadcrumbs-divider-icon arrow" }, {
						default: L(() => [...s[1] ||= [c("mdi:mdi-chevron-right", -1)]]),
						_: 1
					})]),
					title: L(({ item: e }) => [l(u, {
						class: x(["h-breadcrumb__item", { "h-breadcrumb__item--with-icon": !!e.icon }]),
						to: e.href ?? "/",
						"aria-label": e.text
					}, {
						default: L(() => [e.icon ? (O(), r(V, {
							key: 0,
							class: "h-breadcrumb__item-icon"
						}, {
							default: L(() => [c(P(e.icon), 1)]),
							_: 2
						}, 1024)) : i("", !0), e.text ? (O(), a("span", vI, P(e.text), 1)) : i("", !0)]),
						_: 2
					}, 1032, [
						"class",
						"to",
						"aria-label"
					])]),
					_: 1
				}, 8, ["items"])]),
				_: 1
			})]);
		};
	}
}), bI = { class: "h-workspace-item__content ga-8" }, xI = { class: "h-workspace-item__icon" }, SI = {
	key: 1,
	class: "h-workspace-item__avatar-text"
}, CI = { class: "h-workspace-item__text" }, wI = { class: "h-workspace-item__title mr-1" }, TI = { class: "h-workspace-item__description text-medium-emphasis mb-2" }, EI = { class: "h-workspace-item__collapsed-tags" }, DI = /* @__PURE__ */ d({
	__name: "workspace-item",
	props: { workspace: {} },
	setup(t) {
		return z(t, "HWorkspaceItem"), (n, s) => {
			let u = N("h-theme-scope"), d = N("h-action-link");
			return O(), r(d, { class: "h-workspace-item-action-link h-workspace-item__link" }, {
				default: L(() => [l(Be, {
					link: !0,
					ripple: !0,
					class: x(["h-workspace-item pa-8", { [`h-workspace-item--${t.workspace.slug}`]: !0 }]),
					style: C({ "--workspace-item-bg-color": t.workspace.color })
				}, {
					default: L(() => [l(We, { class: "h-workspace-item-content-text h-100" }, {
						default: L(() => [o("div", bI, [o("div", xI, [l(Lt, { class: "h-workspace-item__avatar" }, {
							default: L(() => [t.workspace.icon ? (O(), r(F(qt), {
								key: 0,
								class: "h-workspace-item-icon",
								icon: t.workspace.icon
							}, null, 8, ["icon"])) : (O(), a("div", SI, P(t.workspace.title?.[0]), 1))]),
							_: 1
						})]), o("div", CI, [o("div", null, [
							o("span", wI, P(t.workspace.title), 1),
							o("div", TI, P(t.workspace.description), 1),
							o("div", null, [(O(!0), a(e, null, j(t.workspace?.tag?.slice(0, 2) ?? [], (e) => (O(), r(kt, {
								key: e,
								class: "h-workspace-item__tag mr-1",
								label: ""
							}, {
								default: L(() => [c(P(e), 1)]),
								_: 2
							}, 1024))), 128)), l(qe, {
								class: x(["h-workspace-item__tooltip", { [`h-workspace-item__tooltip--${t.workspace.slug}`]: !0 }]),
								location: "bottom",
								style: C({
									"--workspace-item-bg-color": t.workspace.color,
									"--workspace-item-text-color": "#ffffff"
								})
							}, {
								activator: L(({ props: e }) => [(t.workspace.tag?.length ?? 0) > 2 ? (O(), r(kt, y({ key: 0 }, e, {
									class: "h-workspace-item__tag mr-1",
									label: ""
								}), {
									default: L(() => [l(u, {
										name: "HScopedWorkspaceItemMoreTagsIcon",
										component: F(qt),
										class: "h-workspace-item-more-tags-icon"
									}, null, 8, ["component"])]),
									_: 1
								}, 16)) : i("", !0)]),
								default: L(() => [o("div", EI, P(t.workspace.tag?.slice(2).join(", ")), 1)]),
								_: 1
							}, 8, ["class", "style"])])
						])])])]),
						_: 1
					})]),
					_: 1
				}, 8, ["class", "style"])]),
				_: 1
			});
		};
	}
}), OI = /* @__PURE__ */ d({
	inheritAttrs: !1,
	__name: "dropdown-menu",
	props: { customDefaults: {} },
	setup(e) {
		let t = z(e, "HMenu"), i = n(() => ({
			...rn().value,
			...t.customDefaults
		}));
		return (e, t) => (O(), r(it, y({ class: "h-dropdown-menu" }, e.$attrs), {
			activator: L((t) => [M(e.$slots, "activator", S(p(t)))]),
			default: L(() => [l(Ht, { defaults: i.value }, {
				default: L(() => [M(e.$slots, "default")]),
				_: 3
			}, 8, ["defaults"])]),
			_: 3
		}, 16));
	}
}), kI = /*@__PURE__*/ Object.assign({
	name: "HThemeScope",
	inheritAttrs: !1
}, {
	__name: "theme-scope",
	props: {
		name: {
			type: String,
			required: !0,
			validator: (e) => e.startsWith("HScoped") ? !0 : (console.error(`[HThemeScope] Invalid name "${e}": Theme scope names must start with "HScoped" prefix. Example: "HScopedWorkspaceOpenBtn" instead of "${e}"`), !1)
		},
		component: {
			type: [String, Object],
			required: !1,
			default: null
		}
	},
	setup(e) {
		let t = e, n = f(), i = z({}, t.name);
		return n && (n.type && (n.type.name = t.name), n.proxy?.$options && (n.proxy.$options.name = t.name)), (t, n) => e.component ? (O(), r(te(e.component), S(y({ key: 0 }, {
			...t.$attrs,
			...F(i)
		})), {
			default: L(() => [M(t.$slots, "default")]),
			_: 3
		}, 16)) : M(t.$slots, "default", { key: 1 });
	}
}), AI = ["inert"], jI = { class: "bg-neutral-90 admin-form-header" }, MI = { class: "text-headline-small font-weight-medium" }, NI = /*#__PURE__*/ Vn({
	__name: "form-layout",
	props: {
		modelValue: {
			type: Boolean,
			default: !1
		},
		loading: {
			type: Boolean,
			default: !1
		},
		bgColor: {
			type: String,
			default: "neutral-99"
		},
		hasChanges: {
			type: Boolean,
			default: !1
		},
		submitDisabled: {
			type: Boolean,
			default: !1
		},
		headerText: {
			type: String,
			default: ""
		},
		drawerWidth: {
			type: Number,
			default: 600
		}
	},
	emits: [
		"submit",
		"cancel",
		"update:modelValue"
	],
	setup(e, { expose: t, emit: n }) {
		let { confirm: i } = Te(), a = e, s = n, u = A(null), d = A(!1), f = A(!1), p = A(0);
		I(() => a.modelValue, (e, t) => {
			t && !e && (d.value = !1, p.value += 1);
		});
		function m() {
			d.value = !d.value;
		}
		async function h() {
			a.loading || s("submit");
		}
		async function g(e) {
			e.target.tagName === "TEXTAREA" || e.target.closest(".v-combobox") || (e.preventDefault(), await h());
		}
		function _() {
			a.loading || (a.hasChanges ? b() : (d.value = !1, s("cancel")));
		}
		function v(e) {
			if (!a.loading) {
				if (e.preventDefault(), a.hasChanges) {
					b();
					return;
				}
				_();
			}
		}
		async function b() {
			(await i({
				title: B("discard_changes"),
				message: B("discard_changes_warning"),
				cancelText: B("keep_editing"),
				confirmText: B("discard")
			})).confirmed && (d.value = !1, s("update:modelValue", !1), s("cancel"));
		}
		async function S() {
			return await u.value?.validate();
		}
		function w() {
			return u.value?.reset();
		}
		function T() {
			return u.value?.resetValidation();
		}
		return t({
			validate: S,
			reset: w,
			resetValidation: T
		}), (t, n) => {
			let i = N("HActionButton");
			return O(), r(nn, {
				key: p.value,
				"model-value": e.modelValue,
				location: "right",
				width: d.value ? void 0 : e.drawerWidth,
				class: x({
					"fullscreen-drawer": d.value,
					"admin-form-drawer": !0
				}),
				temporary: "",
				touchless: "",
				"onUpdate:modelValue": n[4] ||= (e) => s("update:modelValue", e)
			}, {
				default: L(() => [o("div", {
					inert: e.modelValue ? void 0 : "",
					style: { display: "contents" }
				}, [l(Be, {
					flat: "",
					class: "h-100 d-flex flex-column"
				}, {
					default: L(() => [
						o("div", jI, [l(Ye, {
							"no-gutters": "",
							class: "flex-column"
						}, {
							default: L(() => [l(H, {
								class: "px-6",
								style: {
									"padding-top": "2px",
									"padding-bottom": "2px"
								}
							}, {
								default: L(() => [l(Ye, {
									"no-gutters": "",
									class: "align-center"
								}, {
									default: L(() => [l(H, null, {
										default: L(() => [o("h2", MI, P(e.headerText), 1)]),
										_: 1
									}), l(H, { cols: "auto" }, {
										default: L(() => [l(qe, {
											location: "bottom",
											"open-delay": 1e3
										}, {
											activator: L(({ props: e }) => [l(V, y(e, {
												size: "x-small",
												role: "button",
												tabindex: "0",
												"aria-label": d.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen"),
												class: ["cursor-pointer size-toggle-icon mr-4", { "text-primary": d.value || f.value }],
												onClick: m,
												onKeydown: [fe(m, ["enter"]), fe(R(m, ["prevent"]), ["space"])],
												onMouseover: n[0] ||= (e) => f.value = !0,
												onMouseleave: n[1] ||= (e) => f.value = !1,
												onFocus: n[2] ||= (e) => f.value = !0,
												onBlur: n[3] ||= (e) => f.value = !1
											}), {
												default: L(() => [c(P(d.value ? "mdi:mdi-arrow-collapse" : "mdi:mdi-arrow-expand"), 1)]),
												_: 1
											}, 16, [
												"aria-label",
												"class",
												"onKeydown"
											])]),
											default: L(() => [o("span", null, P(d.value ? F(B)("exit_fullscreen") : F(B)("enter_fullscreen")), 1)]),
											_: 1
										}), l(Ke, {
											icon: "mdi:mdi-close",
											variant: "text",
											"aria-label": F(B)("close"),
											onClick: _
										}, null, 8, ["aria-label"])]),
										_: 1
									})]),
									_: 1
								})]),
								_: 1
							}), l(H, { class: "pa-0" }, {
								default: L(() => [l(It, {
									thickness: 1,
									color: "neutral-80"
								})]),
								_: 1
							})]),
							_: 1
						})]),
						l(We, { class: x(["flex-1 overflow-y-auto scroll-contain admin-form-content", [{ "px-16 py-8": d.value }, `bg-${e.bgColor}`]]) }, {
							default: L(() => [o("div", {
								class: x({ "mx-auto": d.value }),
								style: C(d.value ? "width: 80%" : "")
							}, [l(an, {
								ref_key: "formRef",
								ref: u,
								onSubmit: R(h, ["prevent"]),
								onKeydown: [fe(R(g, ["prevent"]), ["enter"]), fe(R(v, ["prevent"]), ["esc"])]
							}, {
								default: L(() => [l(H, { class: x([
									"d-flex",
									"flex-column",
									"ga-4",
									"pa-6",
									`bg-${e.bgColor}`
								]) }, {
									default: L(() => [M(t.$slots, "default", {}, void 0, !0)]),
									_: 3
								}, 8, ["class"])]),
								_: 3
							}, 8, ["onKeydown"])], 6)]),
							_: 3
						}, 8, ["class"]),
						l(Ye, {
							class: x(["footer-actions ga-2 align-center admin-form-footer flex-shrink-0", [{ "footer-actions-bordered bg-white": !d.value }, { "justify-center": d.value }]]),
							"no-gutters": ""
						}, {
							default: L(() => [l(H, { cols: "auto" }, {
								default: L(() => [l(i, {
									type: "neutral",
									disabled: e.loading,
									"prepend-icon": "mdi:mdi-close",
									onClick: _
								}, {
									default: L(() => [c(P(F(B)("cancel")), 1)]),
									_: 1
								}, 8, ["disabled"])]),
								_: 1
							}), l(H, { cols: "auto" }, {
								default: L(() => [l(i, {
									type: "primary",
									loading: e.loading,
									disabled: e.loading || e.submitDisabled,
									"prepend-icon": "mdi:mdi-content-save",
									onClick: h
								}, {
									default: L(() => [c(P(F(B)("save")), 1)]),
									_: 1
								}, 8, ["loading", "disabled"])]),
								_: 1
							})]),
							_: 1
						}, 8, ["class"])
					]),
					_: 3
				})], 8, AI)]),
				_: 3
			}, 8, [
				"model-value",
				"width",
				"class"
			]);
		};
	}
}, [["__scopeId", "data-v-099c17ae"]]), PI = { class: "h-milestone-timeline" }, FI = {
	key: 0,
	class: "text-body-large mb-3"
}, II = { class: "font-weight-medium text-body-medium" }, LI = {
	key: 0,
	class: "text-body-small"
}, RI = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "milestone-timeline",
	props: {
		steps: {},
		currentStep: {},
		title: { default: "" }
	},
	setup(t) {
		let s = z(t, "HMilestoneTimeline"), u = n(() => s.steps.findIndex((e) => (typeof e == "string" ? e : e.title) === s.currentStep));
		function d(e) {
			return e < u.value ? "milestone-completed" : e === u.value ? "milestone-current" : "milestone-coming";
		}
		function f(e) {
			return e < u.value ? "line-completed" : e === u.value ? "line-current" : "line-coming";
		}
		function p(e) {
			return e < u.value ? "text-completed" : e === u.value ? "text-current" : "text-coming";
		}
		function m(e) {
			let t = s.steps[e];
			return typeof t == "object" && t.color ? { backgroundColor: t.color } : {};
		}
		function h(e) {
			let t = s.steps[e];
			return typeof t == "object" && t.color ? { backgroundColor: t.color } : {};
		}
		return (n, s) => (O(), a("div", PI, [t.title ? (O(), a("div", FI, P(t.title), 1)) : i("", !0), (O(!0), a(e, null, j(t.steps, (e, n) => (O(), r(Ye, {
			key: n,
			"no-gutters": "",
			class: "milestone-item"
		}, {
			default: L(() => [l(H, { cols: "auto" }, {
				default: L(() => [l(Ye, {
					"no-gutters": "",
					class: "flex-column align-center milestone-icon-wrapper"
				}, {
					default: L(() => [l(H, { cols: "auto" }, {
						default: L(() => [o("div", {
							class: x(["milestone-icon d-flex align-center justify-center", d(n)]),
							style: C(m(n))
						}, [l(V, {
							size: "x-small",
							color: "white"
						}, {
							default: L(() => [...s[0] ||= [c("mdi:mdi-check", -1)]]),
							_: 1
						})], 6)]),
						_: 2
					}, 1024), n < t.steps.length - 1 ? (O(), r(H, {
						key: 0,
						cols: "auto"
					}, {
						default: L(() => [o("div", {
							class: x(["milestone-line", f(n)]),
							style: C(h(n))
						}, null, 6)]),
						_: 2
					}, 1024)) : i("", !0)]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024), l(H, { class: "ml-3" }, {
				default: L(() => [o("div", { class: x(["milestone-text", p(n)]) }, [o("div", II, P(typeof e == "string" ? e : e.title), 1), typeof e == "object" && e.description ? (O(), a("div", LI, P(e.description), 1)) : i("", !0)], 2)]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024))), 128))]));
	}
}), [["__scopeId", "data-v-0080c133"]]), zI = ["multiple"], BI = { class: "font-weight-medium" }, VI = { class: "text-right attachment-actions" }, HI = { key: 0 }, UI = {
	colspan: "2",
	class: "text-center pa-4 text-body-medium",
	style: { color: "rgb(var(--v-theme-neutral-40))" }
}, WI = /*#__PURE__*/ Vn(/* @__PURE__ */ d({
	__name: "attachments",
	props: {
		attachments: {},
		title: { default: "" },
		elevation: { default: 2 },
		rounded: {
			type: [Boolean, String],
			default: "lg"
		},
		density: { default: "comfortable" },
		showViewButton: {
			type: Boolean,
			default: !1
		},
		showDownloadButton: {
			type: Boolean,
			default: !0
		},
		showDeleteButton: {
			type: Boolean,
			default: !1
		},
		showUploadButton: {
			type: Boolean,
			default: !1
		},
		uploadButtonProps: { default: () => ({ text: "browse_files" }) },
		uploadMultiple: {
			type: Boolean,
			default: !0
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		emptyMessage: { default: "no_attachments" },
		nameKey: { default: "name" }
	},
	emits: [
		"view",
		"download",
		"delete",
		"upload"
	],
	setup(t, { emit: n }) {
		let s = z(t, "HAttachments"), u = n, d = A(null);
		function f(e) {
			return e[s.nameKey] || e.name || e.filename || B("unnamed");
		}
		function p(e, t) {
			u("view", e, t);
		}
		function m(e, t) {
			u("download", e, t);
		}
		function h(e, t) {
			u("delete", t);
		}
		function g() {
			d.value?.click();
		}
		function _(e) {
			let t = e.target, n = Array.from(t.files || []);
			n.length > 0 && u("upload", n), t && (t.value = "");
		}
		return (n, s) => (O(), r(Be, {
			elevation: t.elevation,
			rounded: t.rounded
		}, {
			default: L(() => [t.title ? (O(), r(Ge, {
				key: 0,
				class: "text-body-large pa-4 pb-0"
			}, {
				default: L(() => [c(P(t.title), 1)]),
				_: 1
			})) : i("", !0), l(We, { class: x(t.showUploadButton ? "pa-2" : "pa-0") }, {
				default: L(() => [
					t.showUploadButton ? (O(), a("input", {
						key: 0,
						ref_key: "fileInput",
						ref: d,
						type: "file",
						multiple: t.uploadMultiple,
						style: { display: "none" },
						"aria-hidden": "true",
						onChange: _
					}, null, 40, zI)) : i("", !0),
					t.showUploadButton ? (O(), r(ew, {
						key: 1,
						type: t.uploadButtonProps?.type || "neutral",
						"prepend-icon": t.uploadButtonProps?.icon || "mdi:mdi-upload",
						size: t.uploadButtonProps?.size || "small",
						class: x(t.uploadButtonProps?.class || "text-uppercase"),
						disabled: t.disabled,
						onClick: g
					}, {
						default: L(() => [c(P(F(B)(t.uploadButtonProps?.text || "browse_files")), 1)]),
						_: 1
					}, 8, [
						"type",
						"prepend-icon",
						"size",
						"class",
						"disabled"
					])) : i("", !0),
					l(zt, {
						class: x(["h-attachments-table", { "mt-4": t.showUploadButton }]),
						density: t.density
					}, {
						default: L(() => [o("tbody", null, [(O(!0), a(e, null, j(t.attachments, (e, n) => (O(), a("tr", { key: n }, [o("td", BI, P(f(e)), 1), o("td", VI, [
							t.showViewButton ? (O(), r(Ke, {
								key: 0,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !e || t.disabled,
								onClick: (t) => p(e, n)
							}, {
								default: L(() => [l(V, { size: "small" }, {
									default: L(() => [...s[0] ||= [c("mdi:mdi-eye-outline", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : i("", !0),
							t.showDownloadButton ? (O(), r(Ke, {
								key: 1,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !e || t.disabled,
								onClick: (t) => m(e, n)
							}, {
								default: L(() => [l(V, { size: "small" }, {
									default: L(() => [...s[1] ||= [c("mdi:mdi-download", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : i("", !0),
							t.showDeleteButton ? (O(), r(Ke, {
								key: 2,
								icon: "",
								size: "x-small",
								variant: "text",
								disabled: !e || t.disabled,
								onClick: (t) => h(e, n)
							}, {
								default: L(() => [l(V, { size: "small" }, {
									default: L(() => [...s[2] ||= [c("mdi:mdi-delete", -1)]]),
									_: 1
								})]),
								_: 1
							}, 8, ["disabled", "onClick"])) : i("", !0)
						])]))), 128)), !t.attachments || t.attachments.length === 0 ? (O(), a("tr", HI, [o("td", UI, P(F(B)(t.emptyMessage)), 1)])) : i("", !0)])]),
						_: 1
					}, 8, ["class", "density"])
				]),
				_: 1
			}, 8, ["class"])]),
			_: 1
		}, 8, ["elevation", "rounded"]));
	}
}), [["__scopeId", "data-v-343624a6"]]), GI = { class: "resource-tree-node" }, KI = ["aria-selected", "onKeydown"], qI = {
	key: 1,
	class: "mr-1 flex-shrink-0",
	style: { width: "18px" }
}, JI = { class: "text-body-medium text-truncate" }, YI = /*#__PURE__*/ Vn({
	__name: "resource-tree-node",
	props: {
		node: {
			type: Object,
			required: !0
		},
		depth: {
			type: Number,
			default: 0
		},
		selectedPath: {
			type: String,
			default: ""
		},
		expandedPaths: {
			type: Array,
			default: () => []
		}
	},
	emits: ["select"],
	setup(t, { emit: s }) {
		let c = t, u = s, d = A(c.expandedPaths.includes(c.node.path) || !1);
		I(() => c.expandedPaths, (e) => {
			e.includes(c.node.path) && (d.value = !0);
		}, { immediate: !1 });
		let f = n(() => c.node.type === "directory" || Array.isArray(c.node.children)), p = n(() => c.selectedPath && c.selectedPath === c.node.path), m = n(() => c.node.children ? [...c.node.children].sort((e, t) => {
			let n = e.type === "directory" || Array.isArray(e.children), r = t.type === "directory" || Array.isArray(t.children);
			return n && !r ? -1 : !n && r ? 1 : (e.name || "").localeCompare(t.name || "");
		}) : []), h = n(() => f.value ? d.value ? "mdi:mdi-folder-open" : "mdi:mdi-folder" : {
			js: "mdi:mdi-language-javascript",
			mjs: "mdi:mdi-language-javascript",
			cjs: "mdi:mdi-language-javascript",
			ts: "mdi:mdi-language-typescript",
			json: "mdi:mdi-code-json",
			html: "mdi:mdi-language-html5",
			htm: "mdi:mdi-language-html5",
			css: "mdi:mdi-language-css3",
			scss: "mdi:mdi-language-css3",
			vue: "mdi:mdi-vuejs",
			md: "mdi:mdi-language-markdown",
			yml: "mdi:mdi-file-document-outline",
			yaml: "mdi:mdi-file-document-outline",
			xml: "mdi:mdi-xml",
			svg: "mdi:mdi-image-outline",
			png: "mdi:mdi-image-outline",
			jpg: "mdi:mdi-image-outline",
			jpeg: "mdi:mdi-image-outline",
			gif: "mdi:mdi-image-outline",
			webp: "mdi:mdi-image-outline",
			ico: "mdi:mdi-image-outline",
			bmp: "mdi:mdi-image-outline",
			avif: "mdi:mdi-image-outline",
			tif: "mdi:mdi-image-outline",
			tiff: "mdi:mdi-image-outline",
			apng: "mdi:mdi-image-outline",
			bpmn: "mdi:mdi-sitemap-outline"
		}[_(c.node.name)] || "mdi:mdi-file-outline"), g = n(() => f.value ? "amber-darken-2" : {
			js: "yellow-darken-3",
			mjs: "yellow-darken-3",
			cjs: "yellow-darken-3",
			ts: "blue",
			json: "green",
			html: "orange",
			css: "blue-darken-1",
			scss: "pink",
			vue: "green-darken-1",
			md: "grey",
			bpmn: "deep-purple"
		}[_(c.node.name)] || void 0);
		function _(e) {
			if (!e) return "";
			let t = e.split(".");
			return t.length > 1 ? t.pop().toLowerCase() : "";
		}
		function v() {
			f.value ? d.value = !d.value : u("select", c.node.path || c.node.name);
		}
		return (n, s) => {
			let c = N("resource-tree-node", !0);
			return O(), a("div", GI, [o("div", {
				class: x(["resource-tree-node__item d-flex align-center py-1 rounded-sm", {
					"resource-tree-node__item--selected bg-primary-lighten-4": p.value,
					"resource-tree-node__item--hover": !p.value
				}]),
				role: "treeitem",
				tabindex: "0",
				"aria-selected": p.value,
				style: C({
					paddingLeft: `${t.depth * 20 + 8}px`,
					paddingRight: "8px",
					cursor: "pointer"
				}),
				onClick: v,
				onKeydown: [fe(v, ["enter"]), fe(R(v, ["prevent"]), ["space"])]
			}, [
				f.value ? (O(), r(V, {
					key: 0,
					icon: d.value ? "mdi:mdi-chevron-down" : "mdi:mdi-chevron-right",
					size: "18",
					class: "mr-1 flex-shrink-0"
				}, null, 8, ["icon"])) : (O(), a("div", qI)),
				l(V, {
					icon: h.value,
					color: g.value,
					size: "18",
					class: "mr-2 flex-shrink-0"
				}, null, 8, ["icon", "color"]),
				o("span", JI, P(t.node.name), 1)
			], 46, KI), f.value && d.value ? (O(!0), a(e, { key: 0 }, j(m.value, (e) => (O(), r(c, {
				key: e.path || e.name,
				node: e,
				depth: t.depth + 1,
				"selected-path": t.selectedPath,
				"expanded-paths": t.expandedPaths,
				onSelect: s[0] ||= (e) => n.$emit("select", e)
			}, null, 8, [
				"node",
				"depth",
				"selected-path",
				"expanded-paths"
			]))), 128)) : i("", !0)]);
		};
	}
}, [["__scopeId", "data-v-0d3be0ac"]]), XI = { class: "resource-tree-view" }, ZI = {
	key: 0,
	class: "d-flex justify-center align-center pa-8"
}, QI = {
	key: 1,
	class: "pa-4 text-center text-medium-emphasis"
}, $I = { class: "text-body-medium" }, eL = {
	key: 2,
	class: "resource-tree-view__list pa-1"
}, tL = {
	__name: "resource-tree-view",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		selectedPath: {
			type: String,
			default: ""
		},
		expandedPaths: {
			type: Array,
			default: () => []
		},
		emptyText: {
			type: String,
			default: void 0
		}
	},
	emits: ["select"],
	setup(t) {
		let i = t, s = n(() => i.emptyText || B("admin_resources_no_resources_found")), c = n(() => i.items ? [...i.items].sort((e, t) => {
			let n = e.type === "directory" || Array.isArray(e.children), r = t.type === "directory" || Array.isArray(t.children);
			return n && !r ? -1 : !n && r ? 1 : (e.name || "").localeCompare(t.name || "");
		}) : []);
		return (n, i) => (O(), a("div", XI, [t.loading ? (O(), a("div", ZI, [l(sn, {
			indeterminate: "",
			size: "28",
			width: "2"
		})])) : !t.items || t.items.length === 0 ? (O(), a("div", QI, [l(V, {
			icon: "mdi:mdi-folder-open-outline",
			size: "32",
			class: "mb-2 d-block mx-auto"
		}), o("span", $I, P(s.value), 1)])) : (O(), a("div", eL, [(O(!0), a(e, null, j(c.value, (e) => (O(), r(YI, {
			key: e.path || e.name,
			node: e,
			depth: 0,
			"selected-path": t.selectedPath,
			"expanded-paths": t.expandedPaths,
			onSelect: i[0] ||= (e) => n.$emit("select", e)
		}, null, 8, [
			"node",
			"selected-path",
			"expanded-paths"
		]))), 128))]))]));
	}
};
//#endregion
//#region ../../../node_modules/marked/lib/marked.esm.js
function nL() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var rL = nL();
function iL(e) {
	rL = e;
}
var aL = { exec: () => null };
function oL(e) {
	let t = [];
	return (n) => {
		let r = Math.max(0, Math.min(3, n - 1)), i = t[r];
		return i || (i = e(r), t[r] = i), i;
	};
}
function sL(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(lL.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var cL = ((e = "") => {
	try {
		return !!RegExp("(?<=1)(?<!1)" + e);
	} catch {
		return !1;
	}
})(), lL = {
	codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] +\S/,
	listReplaceTask: /^\[[ xX]\] +/,
	listTaskCheckbox: /\[[ xX]\]/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: oL((e) => RegExp(`^ {0,${e}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
	hrRegex: oL((e) => RegExp(`^ {0,${e}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`)),
	fencesBeginRegex: oL((e) => RegExp(`^ {0,${e}}(?:\`\`\`|~~~)`)),
	headingBeginRegex: oL((e) => RegExp(`^ {0,${e}}#`)),
	htmlBeginRegex: oL((e) => RegExp(`^ {0,${e}}<(?:[a-z].*>|!--)`, "i")),
	blockquoteBeginRegex: oL((e) => RegExp(`^ {0,${e}}>`))
}, uL = /^(?:[ \t]*(?:\n|$))+/, dL = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, fL = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, pL = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, mL = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, hL = / {0,3}(?:[*+-]|\d{1,9}[.)])/, gL = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, _L = sL(gL).replace(/bull/g, hL).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), vL = sL(gL).replace(/bull/g, hL).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), yL = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, bL = /^[^\n]+/, xL = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, SL = sL(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", xL).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), CL = sL(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, hL).getRegex(), wL = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", TL = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, EL = sL("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", TL).replace("tag", wL).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), DL = sL(yL).replace("hr", pL).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", wL).getRegex(), OL = {
	blockquote: sL(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", DL).getRegex(),
	code: dL,
	def: SL,
	fences: fL,
	heading: mL,
	hr: pL,
	html: EL,
	lheading: _L,
	list: CL,
	newline: uL,
	paragraph: DL,
	table: aL,
	text: bL
}, kL = sL("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", pL).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", wL).getRegex(), AL = {
	...OL,
	lheading: vL,
	table: kL,
	paragraph: sL(yL).replace("hr", pL).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", kL).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", wL).getRegex()
}, jL = {
	...OL,
	html: sL("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", TL).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: aL,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: sL(yL).replace("hr", pL).replace("heading", " *#{1,6} *[^\n]").replace("lheading", _L).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, ML = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, NL = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, PL = /^( {2,}|\\)\n(?!\s*$)/, FL = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, IL = /[\p{P}\p{S}]/u, LL = /[\s\p{P}\p{S}]/u, RL = /[^\s\p{P}\p{S}]/u, zL = sL(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, LL).getRegex(), BL = /(?!~)[\p{P}\p{S}]/u, VL = /(?!~)[\s\p{P}\p{S}]/u, HL = /(?:[^\s\p{P}\p{S}]|~)/u, UL = sL(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", cL ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), WL = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, GL = sL(WL, "u").replace(/punct/g, IL).getRegex(), KL = sL(WL, "u").replace(/punct/g, BL).getRegex(), qL = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", JL = sL(qL, "gu").replace(/notPunctSpace/g, RL).replace(/punctSpace/g, LL).replace(/punct/g, IL).getRegex(), YL = sL(qL, "gu").replace(/notPunctSpace/g, HL).replace(/punctSpace/g, VL).replace(/punct/g, BL).getRegex(), XL = sL("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, RL).replace(/punctSpace/g, LL).replace(/punct/g, IL).getRegex(), ZL = sL(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, IL).getRegex(), QL = sL("^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, RL).replace(/punctSpace/g, LL).replace(/punct/g, IL).getRegex(), $L = sL(/\\(punct)/, "gu").replace(/punct/g, IL).getRegex(), eR = sL(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), tR = sL(TL).replace("(?:-->|$)", "-->").getRegex(), nR = sL("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", tR).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), rR = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, iR = sL(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", rR).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), aR = sL(/^!?\[(label)\]\[(ref)\]/).replace("label", rR).replace("ref", xL).getRegex(), oR = sL(/^!?\[(ref)\](?:\[\])?/).replace("ref", xL).getRegex(), sR = sL("reflink|nolink(?!\\()", "g").replace("reflink", aR).replace("nolink", oR).getRegex(), cR = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, lR = {
	_backpedal: aL,
	anyPunctuation: $L,
	autolink: eR,
	blockSkip: UL,
	br: PL,
	code: NL,
	del: aL,
	delLDelim: aL,
	delRDelim: aL,
	emStrongLDelim: GL,
	emStrongRDelimAst: JL,
	emStrongRDelimUnd: XL,
	escape: ML,
	link: iR,
	nolink: oR,
	punctuation: zL,
	reflink: aR,
	reflinkSearch: sR,
	tag: nR,
	text: FL,
	url: aL
}, uR = {
	...lR,
	link: sL(/^!?\[(label)\]\((.*?)\)/).replace("label", rR).getRegex(),
	reflink: sL(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", rR).getRegex()
}, dR = {
	...lR,
	emStrongRDelimAst: YL,
	emStrongLDelim: KL,
	delLDelim: ZL,
	delRDelim: QL,
	url: sL(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", cR).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
	text: sL(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", cR).getRegex()
}, fR = {
	...dR,
	br: sL(PL).replace("{2,}", "*").getRegex(),
	text: sL(dR.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, pR = {
	normal: OL,
	gfm: AL,
	pedantic: jL
}, mR = {
	normal: lR,
	gfm: dR,
	breaks: fR,
	pedantic: uR
}, hR = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, gR = (e) => hR[e];
function _R(e, t) {
	if (t) {
		if (lL.escapeTest.test(e)) return e.replace(lL.escapeReplace, gR);
	} else if (lL.escapeTestNoEncode.test(e)) return e.replace(lL.escapeReplaceNoEncode, gR);
	return e;
}
function vR(e) {
	try {
		e = encodeURI(e).replace(lL.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function yR(e, t) {
	let n = e.replace(lL.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(lL.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(lL.slashPipe, "|");
	return n;
}
function bR(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function xR(e) {
	let t = e.split("\n"), n = t.length - 1;
	for (; n >= 0 && lL.blankLine.test(t[n]);) n--;
	return t.length - n <= 2 ? e : t.slice(0, n + 1).join("\n");
}
function SR(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return n > 0 ? -2 : -1;
}
function CR(e, t = 0) {
	let n = t, r = "";
	for (let t of e) if (t === "	") {
		let e = 4 - n % 4;
		r += " ".repeat(e), n += e;
	} else r += t, n++;
	return r;
}
function wR(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1");
	r.state.inLink = !0;
	let c = {
		type: e[0].charAt(0) === "!" ? "image" : "link",
		raw: n,
		href: a,
		title: o,
		text: s,
		tokens: r.inlineTokens(s)
	};
	return r.state.inLink = !1, c;
}
function TR(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return r.length >= i.length ? e.slice(i.length) : e;
	}).join("\n");
}
var ER = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || rL;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = this.options.pedantic ? t[0] : xR(t[0]);
			return {
				type: "code",
				raw: e,
				codeBlockStyle: "indented",
				text: e.replace(this.rules.other.codeRemoveIndent, "")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = TR(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = bR(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: bR(t[0], "\n"),
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: bR(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = bR(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.blockquote(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - t.raw.length) + o.raw, r = r.substring(0, r.length - t.text.length) + o.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = CR(t[2].split("\n", 1)[0], t[1].length), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), f = this.rules.other.blockquoteBeginRegex(d);
					for (; e;) {
						let p = e.split("\n", 1)[0], m;
						if (l = p, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), m = l) : m = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || f.test(l) || t.test(l) || n.test(l)) break;
						if (m.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + m.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						u = !l.trim(), r += p + "\n", e = e.substring(p.length + 1), c = m.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
					type: "list_item",
					raw: r,
					task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e of i.items) {
				this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []);
				let t = e.tokens[0];
				if (e.task && (t?.type === "text" || t?.type === "paragraph")) {
					e.text = e.text.replace(this.rules.other.listReplaceTask, ""), t.raw = t.raw.replace(this.rules.other.listReplaceTask, ""), t.text = t.text.replace(this.rules.other.listReplaceTask, "");
					for (let e = this.lexer.inlineQueue.length - 1; e >= 0; e--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
						this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, "");
						break;
					}
					let n = this.rules.other.listTaskCheckbox.exec(e.raw);
					if (n) {
						let t = {
							type: "checkbox",
							raw: n[0] + " ",
							checked: n[0] !== "[ ]"
						};
						e.checked = t.checked, i.loose ? e.tokens[0] && ["paragraph", "text"].includes(e.tokens[0].type) && "tokens" in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = t.raw + e.tokens[0].raw, e.tokens[0].text = t.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(t)) : e.tokens.unshift({
							type: "paragraph",
							raw: t.raw,
							text: t.raw,
							tokens: [t]
						}) : e.tokens.unshift(t);
					}
				} else e.task &&= !1;
				if (!i.loose) {
					let t = e.tokens.filter((e) => e.type === "space");
					i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
				}
			}
			if (i.loose) for (let e of i.items) {
				e.loose = !0;
				for (let t of e.tokens) t.type === "text" && (t.type = "paragraph");
			}
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) {
			let e = xR(t[0]);
			return {
				type: "html",
				block: !0,
				raw: e,
				pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
				text: e
			};
		}
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: bR(t[0], "\n"),
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = yR(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: bR(t[0], "\n"),
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(yR(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) {
			let e = t[1].trim();
			return {
				type: "heading",
				raw: bR(t[0], "\n"),
				depth: t[2].charAt(0) === "=" ? 1 : 2,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let e = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(e)) {
				if (!this.rules.other.endAngleBracket.test(e)) return;
				let t = bR(e.slice(0, -1), "\\");
				if ((e.length - t.length) % 2 == 0) return;
			} else {
				let e = SR(t[2], "()");
				if (e === -2) return;
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let n = t[2], r = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(n);
				e && (n = e[1], r = e[3]);
			} else r = t[3] ? t[3].slice(1, -1) : "";
			return n = n.trim(), this.rules.other.startAngleBracket.test(n) && (n = this.options.pedantic && !this.rules.other.endAngleBracket.test(e) ? n.slice(1) : n.slice(1, -1)), wR(t, {
				href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
				title: r && r.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let e = t[(n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " ").toLowerCase()];
			if (!e) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return wR(n, e, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (c.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = c.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i) continue;
				if (a = [...i].length, r[3] || r[4]) {
					o += a;
					continue;
				} else if ((r[5] || r[6]) && n % 3 && !((n + a) % 3)) {
					s += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o + s);
				let t = [...r[0]][0].length, c = e.slice(0, n + r.index + t + a);
				if (Math.min(n, a) % 2) {
					let e = c.slice(1, -1);
					return {
						type: "em",
						raw: c,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = c.slice(2, -2);
				return {
					type: "strong",
					raw: c,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e, t, n = "") {
		let r = this.rules.inline.delLDelim.exec(e);
		if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
			for (s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [...i].length, a !== n)) continue;
				if (r[3] || r[4]) {
					o += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o);
				let t = [...r[0]][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
				return {
					type: "del",
					raw: s,
					text: c,
					tokens: this.lexer.inlineTokens(c)
				};
			}
		}
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, DR = class e {
	tokens;
	options;
	state;
	inlineQueue;
	tokenizer;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || rL, this.options.tokenizer = this.options.tokenizer || new ER(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			top: !0
		};
		let t = {
			other: lL,
			block: pR.normal,
			inline: mR.normal
		};
		this.options.pedantic ? (t.block = pR.pedantic, t.inline = mR.pedantic) : this.options.gfm && (t.block = pR.gfm, this.options.breaks ? t.inline = mR.breaks : t.inline = mR.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: pR,
			inline: mR
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(lL.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(lL.tabCharGlobal, "    ").replace(lL.spaceLine, ""));
		let r = Infinity;
		for (; e;) {
			if (e.length < r) r = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			let i;
			if (this.options.extensions?.block?.some((n) => (i = n.call({ lexer: this }, e, t)) ? (e = e.substring(i.raw.length), t.push(i), !0) : !1)) continue;
			if (i = this.tokenizer.space(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				i.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(i);
				continue;
			}
			if (i = this.tokenizer.code(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (i = this.tokenizer.fences(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.heading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.hr(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.blockquote(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.list(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.html(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.def(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[i.tag] || (this.tokens.links[i.tag] = {
					href: i.href,
					title: i.title
				}, t.push(i));
				continue;
			}
			if (i = this.tokenizer.table(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.lheading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			let a = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (a = e.substring(0, t + 1));
			}
			if (this.state.top && (i = this.tokenizer.paragraph(a))) {
				let r = t.at(-1);
				n && r?.type === "paragraph" ? (r.raw += (r.raw.endsWith("\n") ? "" : "\n") + i.raw, r.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = r.text) : t.push(i), n = a.length !== e.length, e = e.substring(i.raw.length);
				continue;
			}
			if (i = this.tokenizer.text(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	inlineTokens(e, t = []) {
		this.tokenizer.lexer = this;
		let n = e, r = null;
		if (this.tokens.links) {
			let e = Object.keys(this.tokens.links);
			if (e.length > 0) for (; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;) e.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
		}
		for (; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;) n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		let i;
		for (; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;) i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
		let a = !1, o = "", s = Infinity;
		for (; e;) {
			if (e.length < s) s = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			a || (o = ""), a = !1;
			let r;
			if (this.options.extensions?.inline?.some((n) => (r = n.call({ lexer: this }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
			if (r = this.tokenizer.escape(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.tag(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.link(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(r.raw.length);
				let n = t.at(-1);
				r.type === "text" && n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (r = this.tokenizer.emStrong(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.codespan(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.br(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.del(e, n, o)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (r = this.tokenizer.autolink(e)) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			if (!this.state.inLink && (r = this.tokenizer.url(e))) {
				e = e.substring(r.raw.length), t.push(r);
				continue;
			}
			let i = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (i = e.substring(0, t + 1));
			}
			if (r = this.tokenizer.inlineText(i)) {
				e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (o = r.raw.slice(-1)), a = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += r.raw, n.text += r.text) : t.push(r);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return t;
	}
	infiniteLoopError(e) {
		let t = "Infinite loop on byte: " + e;
		if (this.options.silent) console.error(t);
		else throw Error(t);
	}
}, OR = class {
	options;
	parser;
	constructor(e) {
		this.options = e || rL;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(lL.notSpaceStart)?.[0], i = e.replace(lL.endingNewline, "") + "\n";
		return r ? "<pre><code class=\"language-" + _R(r) + "\">" + (n ? i : _R(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : _R(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
	}
	html({ text: e }) {
		return e;
	}
	def(e) {
		return "";
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		return `<li>${this.parser.parse(e.tokens)}</li>
`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\"> ";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>
`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>
${e}</tr>
`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${_R(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, tokens: n }) {
		let r = this.parser.parseInline(n), i = vR(e);
		if (i === null) return r;
		e = i;
		let a = "<a href=\"" + e + "\"";
		return t && (a += " title=\"" + _R(t) + "\""), a += ">" + r + "</a>", a;
	}
	image({ href: e, title: t, text: n, tokens: r }) {
		r && (n = this.parser.parseInline(r, this.parser.textRenderer));
		let i = vR(e);
		if (i === null) return _R(n);
		e = i;
		let a = `<img src="${e}" alt="${_R(n)}"`;
		return t && (a += ` title="${_R(t)}"`), a += ">", a;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : _R(e.text);
	}
}, kR = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
	checkbox({ raw: e }) {
		return e;
	}
}, AR = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || rL, this.options.renderer = this.options.renderer || new OR(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new kR();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e) {
		this.renderer.parser = this;
		let t = "";
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (this.options.extensions?.renderers?.[r.type]) {
				let e = r, n = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (n !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"def",
					"paragraph",
					"text"
				].includes(e.type)) {
					t += n || "";
					continue;
				}
			}
			let i = r;
			switch (i.type) {
				case "space":
					t += this.renderer.space(i);
					break;
				case "hr":
					t += this.renderer.hr(i);
					break;
				case "heading":
					t += this.renderer.heading(i);
					break;
				case "code":
					t += this.renderer.code(i);
					break;
				case "table":
					t += this.renderer.table(i);
					break;
				case "blockquote":
					t += this.renderer.blockquote(i);
					break;
				case "list":
					t += this.renderer.list(i);
					break;
				case "checkbox":
					t += this.renderer.checkbox(i);
					break;
				case "html":
					t += this.renderer.html(i);
					break;
				case "def":
					t += this.renderer.def(i);
					break;
				case "paragraph":
					t += this.renderer.paragraph(i);
					break;
				case "text":
					t += this.renderer.text(i);
					break;
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return t;
	}
	parseInline(e, t = this.renderer) {
		this.renderer.parser = this;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "checkbox":
					n += t.checkbox(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, jR = class {
	options;
	block;
	constructor(e) {
		this.options = e || rL;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens",
		"emStrongMask"
	]);
	static passThroughHooksRespectAsync = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	emStrongMask(e) {
		return e;
	}
	provideLexer(e = this.block) {
		return e ? DR.lex : DR.lexInline;
	}
	provideParser(e = this.block) {
		return e ? AR.parse : AR.parseInline;
	}
}, MR = new class {
	defaults = nL();
	options = this.setOptions;
	parse = this.parseMarkdown(!0);
	parseInline = this.parseMarkdown(!1);
	Parser = AR;
	Renderer = OR;
	TextRenderer = kR;
	Lexer = DR;
	Tokenizer = ER;
	Hooks = jR;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new OR(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new ER(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new jR();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					jR.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async && jR.passThroughHooksRespectAsync.has(n)) return (async () => {
							let n = await i.call(t, e);
							return a.call(t, n);
						})();
						let r = i.call(t, e);
						return a.call(t, r);
					} : t[r] = (...e) => {
						if (this.defaults.async) return (async () => {
							let n = await i.apply(t, e);
							return n === !1 && (n = await a.apply(t, e)), n;
						})();
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return DR.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return AR.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		return (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof t > "u" || t === null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
				let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer(e) : e ? DR.lex : DR.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
				i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
				let o = await (i.hooks ? await i.hooks.provideParser(e) : e ? AR.parse : AR.parseInline)(a, i);
				return i.hooks ? await i.hooks.postprocess(o) : o;
			})().catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let n = (i.hooks ? i.hooks.provideLexer(e) : e ? DR.lex : DR.lexInline)(t, i);
				i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
				let r = (i.hooks ? i.hooks.provideParser(e) : e ? AR.parse : AR.parseInline)(n, i);
				return i.hooks && (r = i.hooks.postprocess(r)), r;
			} catch (e) {
				return a(e);
			}
		};
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + _R(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function NR(e, t) {
	return MR.parse(e, t);
}
NR.options = NR.setOptions = function(e) {
	return MR.setOptions(e), NR.defaults = MR.defaults, iL(NR.defaults), NR;
}, NR.getDefaults = nL, NR.defaults = rL, NR.use = function(...e) {
	return MR.use(...e), NR.defaults = MR.defaults, iL(NR.defaults), NR;
}, NR.walkTokens = function(e, t) {
	return MR.walkTokens(e, t);
}, NR.parseInline = MR.parseInline, NR.Parser = AR, NR.parser = AR.parse, NR.Renderer = OR, NR.TextRenderer = kR, NR.Lexer = DR, NR.lexer = DR.lex, NR.Tokenizer = ER, NR.Hooks = jR, NR.parse = NR, NR.options, NR.setOptions, NR.use, NR.walkTokens, NR.parseInline, AR.parse, DR.lex;
//#endregion
//#region ../../../node_modules/dompurify/dist/purify.es.mjs
function PR(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function FR(e) {
	if (Array.isArray(e)) return e;
}
function IR(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function LR() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function RR(e, t) {
	return FR(e) || IR(e, t) || zR(e, t) || LR();
}
function zR(e, t) {
	if (e) {
		if (typeof e == "string") return PR(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? PR(e, t) : void 0;
	}
}
var BR = Object.entries, VR = Object.setPrototypeOf, HR = Object.isFrozen, UR = Object.getPrototypeOf, WR = Object.getOwnPropertyDescriptor, GR = Object.freeze, KR = Object.seal, qR = Object.create, JR = typeof Reflect < "u" && Reflect, YR = JR.apply, XR = JR.construct;
GR ||= function(e) {
	return e;
}, KR ||= function(e) {
	return e;
}, YR ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, XR ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var ZR = _z(Array.prototype.forEach), QR = _z(Array.prototype.lastIndexOf), $R = _z(Array.prototype.pop), ez = _z(Array.prototype.push), tz = _z(Array.prototype.splice), nz = Array.isArray, rz = _z(String.prototype.toLowerCase), iz = _z(String.prototype.toString), az = _z(String.prototype.match), oz = _z(String.prototype.replace), sz = _z(String.prototype.indexOf), cz = _z(String.prototype.trim), lz = _z(Number.prototype.toString), uz = _z(Boolean.prototype.toString), dz = typeof BigInt > "u" ? null : _z(BigInt.prototype.toString), fz = typeof Symbol > "u" ? null : _z(Symbol.prototype.toString), pz = _z(Object.prototype.hasOwnProperty), mz = _z(Object.prototype.toString), hz = _z(RegExp.prototype.test), gz = vz(TypeError);
function _z(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return YR(e, t, n);
	};
}
function vz(e) {
	return function() {
		return XR(e, [...arguments]);
	};
}
function yz(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : rz;
	if (VR && VR(e, null), !nz(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (HR(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function bz(e) {
	for (let t = 0; t < e.length; t++) pz(e, t) || (e[t] = null);
	return e;
}
function xz(e) {
	let t = qR(null);
	for (let r of BR(e)) {
		var n = RR(r, 2);
		let i = n[0], a = n[1];
		pz(e, i) && (nz(a) ? t[i] = bz(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = xz(a) : t[i] = a);
	}
	return t;
}
function Sz(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return lz(e);
		case "boolean": return uz(e);
		case "bigint": return dz ? dz(e) : "0";
		case "symbol": return fz ? fz(e) : "Symbol()";
		case "undefined": return mz(e);
		case "function":
		case "object": {
			if (e === null) return mz(e);
			let t = e, n = Cz(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : mz(e);
			}
			return mz(e);
		}
		default: return mz(e);
	}
}
function Cz(e, t) {
	for (; e !== null;) {
		let n = WR(e, t);
		if (n) {
			if (n.get) return _z(n.get);
			if (typeof n.value == "function") return _z(n.value);
		}
		e = UR(e);
	}
	function n() {
		return null;
	}
	return n;
}
function wz(e) {
	try {
		return hz(e, ""), !0;
	} catch {
		return !1;
	}
}
var Tz = GR(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), Ez = GR(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), Dz = GR([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), Oz = GR([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), kz = GR(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), Az = GR([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), jz = GR(["#text"]), Mz = GR(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), Nz = GR(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dominant-baseline.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.pointer-events.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-orientation.text-rendering.textlength.type.u1.u2.unicode.values.vector-effect.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), Pz = GR(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), Fz = GR([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), Iz = KR(/{{[\w\W]*|^[\w\W]*}}/g), Lz = KR(/<%[\w\W]*|^[\w\W]*%>/g), Rz = KR(/\${[\w\W]*/g), zz = KR(/^data-[\-\w.\u00B7-\uFFFF]+$/), Bz = KR(/^aria-[\-\w]+$/), Vz = KR(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Hz = KR(/^(?:\w+script|data):/i), Uz = KR(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Wz = KR(/^html$/i), Gz = KR(/^[a-z][.\w]*(-[.\w]+)+$/i), Kz = KR(/<[/\w!]/g), qz = KR(/<[/\w]/g), Jz = KR(/<\/no(script|embed|frames)/i), Yz = KR(/\/>/i), Xz = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, Zz = [
	"style",
	"script",
	"xmp",
	"iframe",
	"noembed",
	"noframes",
	"plaintext",
	"noscript"
], Qz = GR(yz({}, Zz)), $z = function() {
	let e = {};
	return ZR(Zz, (t) => {
		e[t] = KR(RegExp("</" + t + "(?=[\\t\\n\\f\\r />])", "i"));
	}), GR(e);
}(), eB = function() {
	return typeof window > "u" ? null : window;
}, tB = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, nB = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
}, rB = function(e, t, n, r) {
	return pz(e, t) && nz(e[t]) ? yz(r.base ? xz(r.base) : {}, e[t], r.transform) : n;
}, iB = function(e, t, n) {
	let r = pz(e, t) ? e[t] : void 0;
	return r && typeof r == "object" ? xz(r) : n();
};
function aB() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : eB(), t = (e) => aB(e);
	if (t.version = "3.4.14", t.removed = [], !e || !e.document || e.document.nodeType !== Xz.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = Cz(d, "cloneNode"), p = Cz(d, "remove"), m = Cz(d, "nextSibling"), h = Cz(d, "childNodes"), g = Cz(d, "parentNode"), _ = Cz(d, "shadowRoot"), v = Cz(d, "attributes"), y = o && o.prototype ? Cz(o.prototype, "nodeType") : null, b = o && o.prototype ? Cz(o.prototype, "nodeName") : null, x = o && o.prototype ? Cz(o.prototype, "ownerDocument") : null, S = function(e) {
		return y ? y(e) : e.nodeType;
	}, C = function(e) {
		return b ? b(e) : e.nodeName;
	};
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let w, T = "", E, D = !1, O = 0, k = function() {
		if (O > 0) throw gz("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, ee = function(e) {
		k(), O++;
		try {
			return w.createHTML(e);
		} finally {
			O--;
		}
	}, A = function(e) {
		k(), O++;
		try {
			return w.createScriptURL(e);
		} finally {
			O--;
		}
	}, j = function() {
		return D ||= (E = tB(u, i), !0), E;
	}, M = n, N = M.implementation, te = M.createNodeIterator, ne = M.createDocumentFragment, P = M.getElementsByTagName, re = r.importNode, ie = nB();
	t.isSupported = typeof BR == "function" && typeof g == "function" && N && N.createHTMLDocument !== void 0;
	let ae = Iz, F = Lz, oe = Rz, se = zz, ce = Bz, le = Hz, ue = Uz, I = Gz, L = Vz, de = null, fe = yz({}, [
		...Tz,
		...Ez,
		...Dz,
		...kz,
		...jz
	]), R = null, pe = yz({}, [
		...Mz,
		...Nz,
		...Pz,
		...Fz
	]), me = Object.seal(qR(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), he = null, ge = null, _e = Object.seal(qR(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), ve = !0, ye = !0, be = !1, xe = !0, Se = !1, Ce = !0, we = !1, Te = !1, Ee = null, z = null, De = !1, Oe = !1, ke = !1, Ae = !1, je = !0, Me = !1, Ne = "user-content-", Pe = !0, B = !1, Fe = {}, Ie = null, Le = yz({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), Re = null, ze = yz({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Be = null, Ve = yz({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), He = "http://www.w3.org/1998/Math/MathML", Ue = "http://www.w3.org/2000/svg", We = "http://www.w3.org/1999/xhtml", Ge = We, Ke = !1, qe = null, V = yz({}, [
		He,
		Ue,
		We
	], iz), H = GR([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Je = yz({}, H), Ye = GR(["annotation-xml"]), Xe = yz({}, Ye), Ze = yz({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), Qe = null, $e = ["application/xhtml+xml", "text/html"], et = null, tt = null, nt = n.createElement("form"), rt = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, it = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (tt && tt === e) return;
		(!e || typeof e != "object") && (e = {}), e = xz(e), Qe = $e.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, et = Qe === "application/xhtml+xml" ? iz : rz, de = rB(e, "ALLOWED_TAGS", fe, { transform: et }), R = rB(e, "ALLOWED_ATTR", pe, { transform: et }), qe = rB(e, "ALLOWED_NAMESPACES", V, { transform: iz }), Be = rB(e, "ADD_URI_SAFE_ATTR", Ve, {
			transform: et,
			base: Ve
		}), Re = rB(e, "ADD_DATA_URI_TAGS", ze, {
			transform: et,
			base: ze
		}), Ie = rB(e, "FORBID_CONTENTS", Le, { transform: et }), he = rB(e, "FORBID_TAGS", xz({}), { transform: et }), ge = rB(e, "FORBID_ATTR", xz({}), { transform: et }), Fe = pz(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? xz(e.USE_PROFILES) : e.USE_PROFILES : !1, ve = e.ALLOW_ARIA_ATTR !== !1, ye = e.ALLOW_DATA_ATTR !== !1, be = e.ALLOW_UNKNOWN_PROTOCOLS || !1, xe = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Se = e.SAFE_FOR_TEMPLATES || !1, Ce = e.SAFE_FOR_XML !== !1, we = e.WHOLE_DOCUMENT || !1, Oe = e.RETURN_DOM || !1, ke = e.RETURN_DOM_FRAGMENT || !1, Ae = e.RETURN_TRUSTED_TYPE || !1, De = e.FORCE_BODY || !1, je = e.SANITIZE_DOM !== !1, Me = e.SANITIZE_NAMED_PROPS || !1, Pe = e.KEEP_CONTENT !== !1, B = e.IN_PLACE || !1, L = wz(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : Vz, Ge = typeof e.NAMESPACE == "string" ? e.NAMESPACE : We, Je = iB(e, "MATHML_TEXT_INTEGRATION_POINTS", () => yz({}, H)), Xe = iB(e, "HTML_INTEGRATION_POINTS", () => yz({}, Ye));
		let t = iB(e, "CUSTOM_ELEMENT_HANDLING", () => qR(null));
		if (me = qR(null), pz(t, "tagNameCheck") && rt(t.tagNameCheck) && (me.tagNameCheck = t.tagNameCheck), pz(t, "attributeNameCheck") && rt(t.attributeNameCheck) && (me.attributeNameCheck = t.attributeNameCheck), pz(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (me.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), KR(me), Se && (ye = !1), ke && (Oe = !0), Fe && (de = yz({}, jz), R = qR(null), Fe.html === !0 && (yz(de, Tz), yz(R, Mz)), Fe.svg === !0 && (yz(de, Ez), yz(R, Nz), yz(R, Fz)), Fe.svgFilters === !0 && (yz(de, Dz), yz(R, Nz), yz(R, Fz)), Fe.mathMl === !0 && (yz(de, kz), yz(R, Pz), yz(R, Fz))), _e.tagCheck = null, _e.attributeCheck = null, pz(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? _e.tagCheck = e.ADD_TAGS : nz(e.ADD_TAGS) && (de === fe && (de = xz(de)), yz(de, e.ADD_TAGS, et))), pz(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? _e.attributeCheck = e.ADD_ATTR : nz(e.ADD_ATTR) && (R === pe && (R = xz(R)), yz(R, e.ADD_ATTR, et))), pz(e, "ADD_FORBID_CONTENTS") && nz(e.ADD_FORBID_CONTENTS) && (Ie === Le && (Ie = xz(Ie)), yz(Ie, e.ADD_FORBID_CONTENTS, et)), Pe && (de["#text"] = !0), we && yz(de, [
			"html",
			"head",
			"body"
		]), de.table && (yz(de, ["tbody"]), delete he.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw gz("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw gz("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = w;
			w = e.TRUSTED_TYPES_POLICY;
			try {
				T = ee("");
			} catch (e) {
				throw w = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (w = void 0, T = "") : (w === void 0 && (w = j()), w && typeof T == "string" && (T = ee("")));
		GR && GR(e), tt = e;
	}, at = yz({}, [
		...Ez,
		...Dz,
		...Oz
	]), ot = yz({}, [...kz, ...Az]), st = function(e, t, n) {
		return t.namespaceURI === We ? e === "svg" : t.namespaceURI === He ? e === "svg" && (n === "annotation-xml" || Je[n]) : !!at[e];
	}, ct = function(e, t, n) {
		return t.namespaceURI === We ? e === "math" : t.namespaceURI === Ue ? e === "math" && Xe[n] : !!ot[e];
	}, lt = function(e, t, n) {
		return t.namespaceURI === Ue && !Xe[n] || t.namespaceURI === He && !Je[n] ? !1 : !ot[e] && (Ze[e] || !at[e]);
	}, ut = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ge,
			tagName: "template"
		});
		let n = rz(e.tagName), r = rz(t.tagName);
		return qe[e.namespaceURI] ? e.namespaceURI === Ue ? st(n, t, r) : e.namespaceURI === He ? ct(n, t, r) : e.namespaceURI === We ? lt(n, t, r) : !!(Qe === "application/xhtml+xml" && qe[e.namespaceURI]) : !1;
	}, dt = function(e) {
		ez(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			if (p(e), !g(e)) throw gz("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, ft = function(e, t, n) {
		try {
			e.removeAttributeNode(t);
		} catch {
			try {
				e.removeAttribute(n);
			} catch {}
		}
	}, pt = function(e) {
		gt(e);
		let t = h(e);
		if (t) {
			let e = [];
			ZR(t, (t) => {
				ez(e, t);
			}), ZR(e, (e) => {
				try {
					p(e);
				} catch {}
			});
		}
		let n = v(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			typeof i == "string" && ft(e, r, i);
		}
	}, mt = function(e, n, r) {
		if (!r) try {
			r = n.getAttributeNode(e);
		} catch {
			r = null;
		}
		ez(t.removed, {
			attribute: r || null,
			from: n
		});
		try {
			r ? n.removeAttributeNode(r) : n.removeAttribute(e);
		} catch {
			try {
				n.removeAttribute(e);
			} catch {}
		}
		if (e === "is") if (Oe || ke) try {
			dt(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, ht = function(e) {
		let t = v(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			typeof i != "string" || R[et(i)] || ft(e, r, i);
		}
	}, gt = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			S(e) === Xz.element && ht(e);
			let n = h(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, _t = function(e, t) {
		return Ce ? e === "patchsrc" ? !0 : e === "for" && t !== "label" && t !== "output" : !1;
	}, vt = function(e) {
		if (!Ce) return;
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop(), n = S(e);
			if (n === Xz.processingInstruction || n === Xz.comment && hz(qz, e.data)) {
				try {
					p(e);
				} catch {}
				continue;
			}
			if (n === Xz.element) {
				let t = e, n = et(C(e));
				try {
					t.hasAttribute && t.hasAttribute("patchsrc") && t.removeAttribute("patchsrc"), t.hasAttribute && t.hasAttribute("for") && _t("for", n) && t.removeAttribute("for");
				} catch {}
			}
			let r = h(e);
			if (r) for (let e = r.length - 1; e >= 0; --e) t.push(r[e]);
		}
	}, yt = function(e) {
		let t = null, r = null;
		if (De) e = "<remove></remove>" + e;
		else {
			let t = az(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		Qe === "application/xhtml+xml" && Ge === We && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = w ? ee(e) : e;
		if (Ge === We) try {
			t = new l().parseFromString(i, Qe);
		} catch {}
		if (!t || !t.documentElement) {
			t = N.createDocument(Ge, "template", null);
			try {
				t.documentElement.innerHTML = Ke ? T : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ge === We ? P.call(t, we ? "html" : "body")[0] : we ? t.documentElement : a;
	}, bt = function(e) {
		let t = x ? x(e) : e.ownerDocument;
		return te.call(t || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, xt = function(e) {
		return e = oz(e, ae, " "), e = oz(e, F, " "), e = oz(e, oe, " "), e;
	}, St = function(e) {
		e.normalize();
		let t = x ? x(e) : e.ownerDocument, n = te.call(t || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), r = n.nextNode();
		for (; r;) r.data = xt(r.data), r = n.nextNode();
		let i = e.querySelectorAll?.call(e, "template");
		i && ZR(i, (e) => {
			wt(e.content) && St(e.content);
		});
	}, Ct = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || et(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, wt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === Xz.documentFragment;
		} catch {
			return !1;
		}
	}, Tt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function Et(e, n, r) {
		e.length !== 0 && ZR(e, (e) => {
			e.call(t, n, r, tt);
		});
	}
	let Dt = function(e, t) {
		return !!(Ce && e.hasChildNodes() && !Tt(e.firstElementChild) && hz(Kz, e.textContent) && hz(Kz, e.innerHTML) || Ce && e.namespaceURI === We && Qz[t] && (Tt(e.firstElementChild) || typeof e.textContent == "string" && hz($z[t], e.textContent)) || e.nodeType === Xz.processingInstruction || Ce && e.nodeType === Xz.comment && hz(qz, e.data));
	}, Ot = function(e, t) {
		return e instanceof RegExp ? hz(e, t) : e instanceof Function ? !!e(t, ...[...arguments].slice(2)) : !1;
	}, kt = function(e, t, n) {
		if (!he[t] && Ft(t) && Ot(me.tagNameCheck, t)) return !1;
		if (Pe && !Ie[t]) {
			let t = g(e), r = h(e);
			if (r && t) {
				let i = r.length;
				for (let a = i - 1; a >= 0; --a) {
					let i = e === n ? f(r[a], !0) : r[a];
					t.insertBefore(i, m(e));
				}
			}
		}
		return dt(e), !0;
	}, At = function(e, t, n, r) {
		return e.length === 0 ? t : t === n || t === r ? xz(t) : t;
	}, jt = function(e, t) {
		return e === t || g(e) !== null ? !1 : (B && gt(e), !0);
	}, Mt = function(e, n) {
		if (Et(ie.beforeSanitizeElements, e, null), jt(e, n)) return !0;
		if (Ct(e)) return dt(e), !0;
		let r = et(C(e));
		if (de = At(ie.uponSanitizeElement, de, fe, Ee), Et(ie.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: de
		}), jt(e, n)) return !0;
		if (Dt(e, r)) return dt(e), !0;
		if (he[r] || !(_e.tagCheck instanceof Function && _e.tagCheck(r)) && !de[r]) {
			let t = kt(e, r, n);
			return t === !1 && Et(ie.afterSanitizeElements, e, null), t;
		}
		if (S(e) === Xz.element && !ut(e) || (r === "noscript" || r === "noembed" || r === "noframes") && hz(Jz, e.innerHTML)) return dt(e), !0;
		if (Se && e.nodeType === Xz.text) {
			let n = xt(e.textContent);
			e.textContent !== n && (ez(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return Et(ie.afterSanitizeElements, e, null), !1;
	}, Nt = function(e, t, r) {
		if (ge[t] || _t(t, e) || je && (t === "id" || t === "name") && (r in n || r in nt)) return !1;
		let i = R[t] || _e.attributeCheck instanceof Function && _e.attributeCheck(t, e);
		return ye && hz(se, t) || ve && hz(ce, t) ? !0 : i ? Be[t] || hz(L, oz(r, ue, "")) || (t === "src" || t === "xlink:href" || t === "href") && e !== "script" && sz(r, "data:") === 0 && Re[e] || be && !hz(le, oz(r, ue, "")) ? !0 : !r : Ft(e) && Ot(me.tagNameCheck, e) && Ot(me.attributeNameCheck, t, e) || t === "is" && me.allowCustomizedBuiltInElements && Ot(me.tagNameCheck, r);
	}, Pt = yz({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), Ft = function(e) {
		return !Pt[rz(e)] && hz(I, e);
	}, It = function(e, t, n, r) {
		if (w && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return ee(r);
			case "TrustedScriptURL": return A(r);
		}
		return r;
	}, Lt = function(e, n, r, i) {
		try {
			r ? e.setAttributeNS(r, n, i) : e.setAttribute(n, i), Ct(e) ? dt(e) : $R(t.removed);
		} catch {
			mt(n, e);
		}
	}, Rt = function(e) {
		Et(ie.beforeSanitizeAttributes, e, null);
		let t = e.attributes;
		if (!t || Ct(e)) return;
		R = At(ie.uponSanitizeAttribute, R, pe, z);
		let n = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: R,
			forceKeepAttr: void 0
		}, r = t.length, i = et(e.nodeName);
		for (; r--;) {
			let a = t[r], o = a.name, s = a.namespaceURI, c = a.value, l = et(o), u = c, d = o === "value" ? u : cz(u);
			if (n.attrName = l, n.attrValue = d, n.keepAttr = !0, n.forceKeepAttr = void 0, Et(ie.uponSanitizeAttribute, e, n), d = n.attrValue, Me && (l === "id" || l === "name") && sz(d, Ne) !== 0 && (mt(o, e, a), d = Ne + d), Ce && hz(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, d)) {
				mt(o, e, a);
				continue;
			}
			if (l === "attributename" && az(d, "href")) {
				mt(o, e, a);
				continue;
			}
			if (!n.forceKeepAttr) {
				if (!n.keepAttr) {
					mt(o, e, a);
					continue;
				}
				if (!xe && hz(Yz, d)) {
					mt(o, e, a);
					continue;
				}
				if (Se && (d = xt(d)), !Nt(i, l, d)) {
					mt(o, e, a);
					continue;
				}
				d = It(i, l, s, d), d !== u && Lt(e, o, s, d);
			}
		}
		Et(ie.afterSanitizeAttributes, e, null);
	}, zt = function(e) {
		let t = null, n = bt(e);
		for (Et(ie.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (Et(ie.uponSanitizeShadowNode, t, null), Mt(t, e), Rt(t), wt(t.content) && zt(t.content), S(t) === Xz.element) {
			let e = _(t);
			wt(e) && (Bt(e), zt(e));
		}
		Et(ie.afterSanitizeShadowDOM, e, null);
	}, Bt = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				zt(e.shadow);
				continue;
			}
			let n = e.node, r = S(n) === Xz.element, i = h(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = b ? b(n) : null;
				if (typeof e == "string" && et(e) === "template") {
					let e = n.content;
					wt(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = _(n);
				wt(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Ke = !e, Ke && (e = "<!-->"), typeof e != "string" && !Tt(e) && (e = Sz(e), typeof e != "string")) throw gz("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		Te ? (de = Ee, R = z) : it(n), (ie.uponSanitizeElement.length > 0 || ie.uponSanitizeAttribute.length > 0) && (de = xz(de)), ie.uponSanitizeAttribute.length > 0 && (R = xz(R)), t.removed = [];
		let c = B && typeof e != "string" && Tt(e);
		if (c) {
			vt(e);
			let t = C(e);
			if (typeof t == "string") {
				let n = et(t);
				if (!de[n] || he[n]) throw pt(e), gz("root node is forbidden and cannot be sanitized in-place");
			}
			if (Ct(e)) throw pt(e), gz("root node is clobbered and cannot be sanitized in-place");
			try {
				Bt(e);
			} catch (t) {
				throw pt(e), t;
			}
		} else if (Tt(e)) i = yt("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === Xz.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), Bt(a);
		else {
			if (!Oe && !Se && !we && e.indexOf("<") === -1) return w && Ae ? ee(e) : e;
			if (i = yt(e), !i) return Oe ? null : Ae ? T : "";
		}
		i && De && dt(i.firstChild);
		let l = c ? e : i;
		try {
			let e = bt(l);
			for (; o = e.nextNode();) Mt(o, l), Rt(o), wt(o.content) && zt(o.content);
		} catch (n) {
			throw c && (pt(e), ZR(t.removed, (e) => {
				e.element && gt(e.element);
			})), n;
		}
		if (c) return ZR(t.removed, (e) => {
			e.element && gt(e.element);
		}), Se && St(e), e;
		if (Oe) {
			if (Se && St(i), ke) for (s = ne.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (R.shadowroot || R.shadowrootmode) && (s = re.call(r, s, !0)), s;
		}
		let u = we ? i.outerHTML : i.innerHTML;
		return we && de["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && hz(Wz, i.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + u), Se && (u = xt(u)), w && Ae ? ee(u) : u;
	}, t.setConfig = function() {
		it(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}), Te = !0, Ee = de, z = R;
	}, t.clearConfig = function() {
		tt = null, Te = !1, Ee = null, z = null, w = E, T = "";
	}, t.isValidAttribute = function(e, t, n) {
		return tt || it({}), Nt(et(e), et(t), n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && pz(ie, e) && ez(ie[e], t);
	}, t.removeHook = function(e, t) {
		if (pz(ie, e)) {
			if (t !== void 0) {
				let n = QR(ie[e], t);
				return n === -1 ? void 0 : tz(ie[e], n, 1)[0];
			}
			return $R(ie[e]);
		}
	}, t.removeHooks = function(e) {
		pz(ie, e) && (ie[e] = []);
	}, t.removeAllHooks = function() {
		ie = nB();
	}, t;
}
var oB = aB(), sB = { class: "resource-content-viewer d-flex flex-column fill-height" }, cB = {
	key: 0,
	class: "resource-content-viewer__header d-flex align-center pa-3 border-b bg-surface"
}, lB = { class: "text-body-medium font-weight-medium text-truncate" }, uB = {
	key: 1,
	class: "d-flex justify-center align-center flex-grow-1"
}, dB = {
	key: 2,
	class: "d-flex justify-center align-center flex-grow-1"
}, fB = { class: "text-center text-medium-emphasis" }, pB = { class: "text-body-large" }, mB = {
	key: 3,
	class: "d-flex justify-center align-center flex-grow-1 pa-4 overflow-auto"
}, hB = ["src", "alt"], gB = {
	key: 4,
	class: "resource-content-viewer__pdf flex-grow-1 overflow-hidden"
}, _B = ["src"], vB = {
	key: 5,
	class: "resource-content-viewer__bpmn flex-grow-1 overflow-hidden position-relative"
}, yB = {
	key: 0,
	class: "d-flex justify-center align-center fill-height"
}, bB = { class: "text-center text-medium-emphasis" }, xB = { class: "text-body-large" }, SB = {
	key: 6,
	class: "resource-content-viewer__markdown flex-grow-1 overflow-y-auto pa-6"
}, CB = ["innerHTML"], wB = {
	key: 7,
	class: "d-flex justify-center align-center flex-grow-1"
}, TB = { class: "text-center text-medium-emphasis" }, EB = { class: "text-body-large" }, DB = {
	key: 8,
	class: "resource-content-viewer__editor flex-grow-1 overflow-hidden"
}, OB = /*#__PURE__*/ Vn({
	__name: "resource-content-viewer",
	props: {
		content: {
			type: String,
			default: ""
		},
		contentUrl: {
			type: String,
			default: ""
		},
		filePath: {
			type: String,
			default: ""
		},
		loading: {
			type: Boolean,
			default: !1
		},
		emptyText: {
			type: String,
			default: void 0
		}
	},
	setup(e) {
		let t = e, r = n(() => t.emptyText || B("admin_resources_select_file")), s = [
			"png",
			"jpg",
			"jpeg",
			"gif",
			"svg",
			"webp",
			"ico",
			"bmp",
			"avif",
			"tif",
			"tiff",
			"apng"
		], c = [
			"woff",
			"woff2",
			"ttf",
			"otf",
			"eot",
			"zip",
			"tar",
			"gz",
			"mp3",
			"mp4",
			"wav"
		], u = n(() => s.includes(E(t.filePath))), d = n(() => E(t.filePath) === "pdf"), f = n(() => E(t.filePath) === "bpmn"), p = n(() => ["md", "markdown"].includes(E(t.filePath))), m = n(() => c.includes(E(t.filePath))), h = n(() => {
			if (!p.value || !t.content) return "";
			let e = NR.parse(t.content, {
				breaks: !0,
				gfm: !0
			});
			return oB.sanitize(e);
		}), g = A(null), _ = A(!1), v = null;
		function y() {
			v &&= (v.destroy(), null);
		}
		async function x(e) {
			if (e && (await b(), g.value)) {
				_.value = !1, y(), v = new LM({ container: g.value });
				try {
					await v.importXML(e), v.get("canvas").zoom("fit-viewport", "auto");
				} catch (e) {
					console.error("Failed to render BPMN diagram:", e), _.value = !0;
				}
			}
		}
		I([() => t.content, () => f.value], ([e, t]) => {
			t && e ? x(e) : y();
		}), w(() => {
			y();
		});
		let S = {
			png: "image/png",
			jpg: "image/jpeg",
			jpeg: "image/jpeg",
			gif: "image/gif",
			svg: "image/svg+xml",
			webp: "image/webp",
			ico: "image/x-icon",
			bmp: "image/bmp",
			avif: "image/avif",
			tif: "image/tiff",
			tiff: "image/tiff",
			apng: "image/apng"
		}, C = n(() => {
			if (!u.value) return "";
			if (t.contentUrl) return t.contentUrl;
			if (!t.content) return "";
			let e = E(t.filePath);
			return `data:${S[e] || `image/${e}`};base64,${t.content}`;
		}), T = A("");
		I(() => t.content, (e) => {
			T.value = e || "";
		}, { immediate: !0 });
		function E(e) {
			if (!e) return "";
			let t = e.split(".");
			return t.length > 1 ? t.pop().toLowerCase() : "";
		}
		let D = n(() => {
			let e = [q.lineWrapping], n = E(t.filePath);
			return [
				"js",
				"mjs",
				"cjs"
			].includes(n) ? e.push(GC()) : n === "json" && e.push(US()), e;
		}), k = n(() => ({
			js: "mdi:mdi-language-javascript",
			mjs: "mdi:mdi-language-javascript",
			json: "mdi:mdi-code-json",
			html: "mdi:mdi-language-html5",
			css: "mdi:mdi-language-css3",
			vue: "mdi:mdi-vuejs",
			md: "mdi:mdi-language-markdown",
			yml: "mdi:mdi-file-document-outline",
			yaml: "mdi:mdi-file-document-outline",
			xml: "mdi:mdi-xml",
			bpmn: "mdi:mdi-sitemap-outline",
			pdf: "mdi:mdi-file-pdf-box",
			svg: "mdi:mdi-image-outline",
			png: "mdi:mdi-image-outline",
			jpg: "mdi:mdi-image-outline",
			jpeg: "mdi:mdi-image-outline",
			gif: "mdi:mdi-image-outline",
			webp: "mdi:mdi-image-outline",
			ico: "mdi:mdi-image-outline",
			bmp: "mdi:mdi-image-outline",
			avif: "mdi:mdi-image-outline",
			tif: "mdi:mdi-image-outline",
			tiff: "mdi:mdi-image-outline",
			apng: "mdi:mdi-image-outline"
		})[E(t.filePath)] || "mdi:mdi-file-outline");
		return (t, n) => (O(), a("div", sB, [e.filePath ? (O(), a("div", cB, [l(V, {
			icon: k.value,
			size: "18",
			class: "mr-2"
		}, null, 8, ["icon"]), o("span", lB, P(e.filePath), 1)])) : i("", !0), e.loading ? (O(), a("div", uB, [l(sn, { indeterminate: "" })])) : e.filePath ? u.value ? (O(), a("div", mB, [o("img", {
			src: C.value,
			alt: e.filePath,
			style: {
				"max-width": "100%",
				"max-height": "100%",
				"object-fit": "contain"
			}
		}, null, 8, hB)])) : d.value ? (O(), a("div", gB, [o("iframe", {
			src: e.contentUrl,
			class: "fill-height",
			style: {
				width: "100%",
				height: "100%",
				border: "none"
			},
			title: "PDF preview"
		}, null, 8, _B)])) : f.value ? (O(), a("div", vB, [_.value ? (O(), a("div", yB, [o("div", bB, [l(V, {
			icon: "mdi:mdi-alert-circle-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), o("div", xB, P(F(B)("admin_resources_bpmn_render_error")), 1)])])) : (O(), a("div", {
			key: 1,
			ref_key: "bpmnContainer",
			ref: g,
			class: "fill-height"
		}, null, 512))])) : p.value ? (O(), a("div", SB, [o("div", {
			class: "resource-content-viewer__markdown-body",
			innerHTML: h.value
		}, null, 8, CB)])) : m.value ? (O(), a("div", wB, [o("div", TB, [l(V, {
			icon: "mdi:mdi-file-alert-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), o("div", EB, P(F(B)("admin_resources_binary_preview")), 1)])])) : (O(), a("div", DB, [l(F(lS), {
			modelValue: T.value,
			"onUpdate:modelValue": n[0] ||= (e) => T.value = e,
			extensions: D.value,
			style: { height: "100%" },
			disabled: ""
		}, null, 8, ["modelValue", "extensions"])])) : (O(), a("div", dB, [o("div", fB, [l(V, {
			icon: "mdi:mdi-file-document-outline",
			size: "64",
			class: "mb-4 d-block mx-auto"
		}), o("div", pB, P(r.value), 1)])]))]));
	}
}, [["__scopeId", "data-v-ec45fd65"]]), kB = {
	class: "h-resource-view d-flex",
	style: { "min-height": "0" }
}, AB = { class: "flex-grow-1 overflow-y-auto" }, jB = {
	__name: "resource-view",
	props: {
		items: {
			type: Array,
			default: () => []
		},
		treeLoading: {
			type: Boolean,
			default: !1
		},
		selectedPath: {
			type: String,
			default: ""
		},
		expandedPaths: {
			type: Array,
			default: () => []
		},
		content: {
			type: String,
			default: ""
		},
		contentUrl: {
			type: String,
			default: ""
		},
		contentLoading: {
			type: Boolean,
			default: !1
		},
		sidebarWidth: {
			type: [Number, String],
			default: 320
		},
		sidebarBackground: {
			type: String,
			default: void 0
		},
		contentBackground: {
			type: String,
			default: void 0
		},
		emptyTreeText: {
			type: String,
			default: void 0
		},
		emptyContentText: {
			type: String,
			default: void 0
		}
	},
	emits: ["select"],
	setup(t) {
		let r = z(t, "HResourceView"), s = n(() => typeof r.sidebarWidth == "number" ? `${r.sidebarWidth}px` : r.sidebarWidth), c = n(() => r.sidebarBackground || "rgb(var(--v-theme-surface))"), u = n(() => r.contentBackground || void 0);
		return (n, r) => (O(), a("div", kB, [o("div", {
			class: "h-resource-view__sidebar d-flex flex-column flex-shrink-0 border-e",
			style: C({
				width: s.value,
				background: c.value
			})
		}, [
			M(n.$slots, "sidebar-top"),
			o("div", AB, [l(tL, {
				items: t.items,
				loading: t.treeLoading,
				"selected-path": t.selectedPath,
				"expanded-paths": t.expandedPaths,
				"empty-text": t.emptyTreeText,
				onSelect: r[0] ||= (e) => n.$emit("select", e)
			}, null, 8, [
				"items",
				"loading",
				"selected-path",
				"expanded-paths",
				"empty-text"
			])]),
			n.$slots["sidebar-info"] ? (O(), a(e, { key: 0 }, [l(It), M(n.$slots, "sidebar-info")], 64)) : i("", !0),
			n.$slots["sidebar-actions"] ? (O(), a(e, { key: 1 }, [l(It), M(n.$slots, "sidebar-actions")], 64)) : i("", !0)
		], 4), o("div", {
			class: "h-resource-view__content flex-grow-1 d-flex flex-column",
			style: C({
				minWidth: 0,
				background: u.value
			})
		}, [M(n.$slots, "content-header"), l(OB, {
			content: t.content,
			"content-url": t.contentUrl,
			"file-path": t.selectedPath,
			loading: t.contentLoading,
			"empty-text": t.emptyContentText
		}, null, 8, [
			"content",
			"content-url",
			"file-path",
			"loading",
			"empty-text"
		])], 4)]));
	}
}, MB = { class: "flex-1-1" }, NB = { class: "flex-1-1" }, PB = {
	key: 0,
	class: "text-body-2 text-error d-flex align-center ga-1"
}, FB = {
	key: 1,
	class: "text-headline-medium font-weight-bold"
}, IB = { class: "text-body-2 text-medium-emphasis" }, LB = { class: "mt-1 d-flex align-center flex-wrap ga-1" }, RB = {
	__name: "metric-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		},
		trend: {
			type: Object,
			default: null
		}
	},
	setup(e) {
		let t = z(e, "HMetricCard"), s = n(() => {
			if (t.trend) {
				if (t.trend.direction === "up") return "success";
				if (t.trend.direction === "down") return "error";
			}
		}), u = n(() => t.trend ? t.trend.percent === null || t.trend.percent === void 0 ? "—" : t.trend.percent < 0 ? "↓" : t.trend.percent > 0 ? "↑" : "—" : "");
		return (t, n) => (O(), r(Be, {
			class: x(["h-metric-card h-100", { "h-metric-card--clickable": !!e.widget.link }]),
			to: e.widget.link || void 0,
			ripple: !!e.widget.link,
			rounded: "lg",
			elevation: "1"
		}, {
			default: L(() => [e.loading && e.value === null ? (O(), r(We, {
				key: 0,
				class: "h-metric-card__body"
			}, {
				default: L(() => [l(Cn, {
					type: "avatar",
					class: "flex-0-0 mr-3",
					width: "56",
					height: "56"
				}), o("div", MB, [
					l(Cn, {
						type: "text",
						width: "80",
						height: "28",
						class: "mb-1"
					}),
					l(Cn, {
						type: "text",
						width: "120",
						height: "16"
					}),
					l(Cn, {
						type: "chip",
						width: "60",
						height: "22",
						class: "mt-1"
					})
				])]),
				_: 1
			})) : (O(), r(We, {
				key: 1,
				class: "h-metric-card__body"
			}, {
				default: L(() => [l(Lt, {
					color: e.widget.color || "grey-lighten-4",
					size: "56",
					class: "mr-3 flex-0-0"
				}, {
					default: L(() => [l(V, {
						icon: e.widget.icon || "mdi:mdi-chart-line",
						size: "x-large"
					}, null, 8, ["icon"])]),
					_: 1
				}, 8, ["color"]), o("div", NB, [
					e.error ? (O(), a("div", PB, [l(V, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), c(" " + P(F(B)("error")), 1)])) : (O(), a("div", FB, P(e.value ?? "—"), 1)),
					o("div", IB, P(e.widget.name), 1),
					o("div", LB, [e.loading && e.trend === null && e.widget.trend ? (O(), r(Cn, {
						key: 0,
						type: "chip",
						width: "60",
						height: "22"
					})) : e.trend ? (O(), r(kt, {
						key: 1,
						color: s.value,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: L(() => [c(P(u.value) + " " + P(e.trend.label), 1)]),
						_: 1
					}, 8, ["color"])) : i("", !0), e.widget.chip ? (O(), r(kt, {
						key: 2,
						color: e.widget.chip.color,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: L(() => [c(P(e.widget.chip.label), 1)]),
						_: 1
					}, 8, ["color"])) : i("", !0)])
				])]),
				_: 1
			}))]),
			_: 1
		}, 8, [
			"class",
			"to",
			"ripple"
		]));
	}
}, zB = ["href", "onClick"], BB = {
	key: 2,
	class: "h-metric-breakdown-card__label text-body-2 text-medium-emphasis"
}, VB = { class: "h-metric-breakdown-card__bar-bg mx-2 flex-1-1" }, HB = { class: "h-metric-breakdown-card__count text-body-2 font-weight-bold" }, UB = {
	key: 0,
	class: "h-metric-breakdown-card__toggle d-flex justify-center mt-1"
}, WB = {
	__name: "metric-breakdown-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		itemsData: {
			type: Object,
			default: () => ({})
		},
		loading: {
			type: Boolean,
			default: !1
		},
		maxVisibleRows: {
			type: Number,
			default: 10
		}
	},
	setup(t) {
		let s = z(t, "HMetricBreakdownCard"), u = dt(), d = A(!1), f = n(() => s.widget.items ?? []), p = n(() => f.value.length > s.maxVisibleRows), m = n(() => !p.value || d.value ? f.value : f.value.slice(0, s.maxVisibleRows)), h = n(() => `Visa ${f.value.length - s.maxVisibleRows} till`), g = n(() => "Visa färre"), _ = n(() => s.loading && f.value.every((e) => !s.itemsData[e._id]));
		function v(e) {
			return s.itemsData[e._id] ?? null;
		}
		function y(e) {
			if (!e.url) return null;
			let t = e.params?.query;
			return t ? `${e.url}?query=${encodeURIComponent(t)}` : e.url;
		}
		function b(e) {
			let t = y(e);
			t && u.push(t);
		}
		let x = n(() => {
			let e = 0;
			for (let t of f.value) {
				let n = v(t)?.rawValue;
				typeof n == "number" && n > e && (e = n);
			}
			return e;
		});
		function S(e) {
			if (x.value === 0) return 0;
			let t = v(e)?.rawValue;
			return typeof t == "number" ? Math.round(t / x.value * 100) : 0;
		}
		return (n, s) => (O(), r(Be, {
			class: "h-metric-breakdown-card h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: L(() => [l(Ge, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: L(() => [t.widget.icon ? (O(), r(V, {
					key: 0,
					icon: t.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : i("", !0), c(" " + P(t.widget.name), 1)]),
				_: 1
			}), l(We, { class: "pt-0 px-4 pb-4" }, {
				default: L(() => [_.value ? (O(), a(e, { key: 0 }, j(4, (e) => o("div", {
					key: e,
					class: "h-metric-breakdown-card__row mb-3"
				}, [
					l(Cn, {
						type: "text",
						width: "120",
						height: "14"
					}),
					l(Cn, {
						type: "text",
						class: "flex-1-1 mx-2",
						height: "8"
					}),
					l(Cn, {
						type: "text",
						width: "40",
						height: "14"
					})
				])), 64)) : (O(), a(e, { key: 1 }, [(O(!0), a(e, null, j(m.value, (t) => (O(), a("div", {
					key: t._id,
					class: "h-metric-breakdown-card__row mb-2"
				}, [
					t.icon ? (O(), r(V, {
						key: 0,
						icon: t.icon,
						size: "x-small",
						color: t.color || "primary",
						class: "flex-0-0 mr-1"
					}, null, 8, ["icon", "color"])) : i("", !0),
					y(t) ? (O(), a("a", {
						key: 1,
						href: y(t),
						class: "h-metric-breakdown-card__label h-metric-breakdown-card__label--link text-body-2",
						onClick: R((e) => b(t), ["prevent"])
					}, P(t.name), 9, zB)) : (O(), a("span", BB, P(t.name), 1)),
					o("div", VB, [o("div", {
						class: "h-metric-breakdown-card__bar-fill",
						style: C({
							width: S(t) + "%",
							backgroundColor: t.color || "var(--v-theme-primary)"
						})
					}, null, 4)]),
					o("span", HB, [v(t)?.loading ? (O(), r(sn, {
						key: 0,
						indeterminate: "",
						size: "12",
						width: "2"
					})) : v(t)?.error ? (O(), r(V, {
						key: 1,
						icon: "mdi:mdi-alert-circle-outline",
						size: "x-small",
						color: "error"
					})) : (O(), a(e, { key: 2 }, [c(P(v(t)?.value ?? "—"), 1)], 64))])
				]))), 128)), p.value ? (O(), a("div", UB, [l(Ke, {
					variant: "text",
					size: "small",
					density: "compact",
					"append-icon": d.value ? "mdi:mdi-chevron-up" : "mdi:mdi-chevron-down",
					onClick: s[0] ||= (e) => d.value = !d.value
				}, {
					default: L(() => [c(P(d.value ? g.value : h.value), 1)]),
					_: 1
				}, 8, ["append-icon"])])) : i("", !0)], 64))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, GB = {
	key: 0,
	class: "h-metric-histogram-card__chart"
}, KB = {
	key: 1,
	class: "text-body-2 text-medium-emphasis text-center py-4"
}, qB = ["aria-label"], JB = ["aria-label"], YB = { class: "h-metric-histogram-card__bar-label" }, XB = {
	key: 0,
	class: "h-metric-histogram-card__legend"
}, ZB = { class: "h-metric-histogram-card__legend-item" }, QB = { class: "h-metric-histogram-card__legend-item" }, $B = {
	__name: "metric-histogram-card",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		buckets: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(t) {
		let s = Array.from({ length: 12 }, () => 20 + Math.floor(Math.random() * 60)), u = z(t, "HMetricHistogramCard"), d = n(() => u.widget.interval === "week" ? "d MMM yyyy" : u.widget.interval === "month" ? "MMM yyyy" : "d MMM yyyy"), f = n(() => u.widget.dateFormat || d.value), p = n(() => u.widget.weekends === !0), m = n(() => u.widget.stretchBars === !0), h = n(() => u.widget.weekdayColor || u.widget.color || "var(--v-theme-primary)"), g = n(() => u.widget.weekendColor || h.value), _ = n(() => u.widget.weekendColor ? 1 : .35);
		function v(e) {
			if (e == null || e === "") return null;
			let t = String(e);
			if (/^\d{10,13}$/.test(t)) {
				let e = Number(t), n = t.length <= 10 ? e * 1e3 : e, r = new Date(n);
				return mn(r) ? r : null;
			}
			let n = gn(t);
			return mn(n) ? n : null;
		}
		let b = n(() => u.buckets.map((e) => {
			let t = v(e.key), n = p.value && t ? hn(t) : !1, r = t ? fn(t, f.value) : e.label;
			return {
				...e,
				date: t,
				isWeekend: n,
				formattedLabel: r
			};
		})), S = n(() => {
			let e = b.value;
			if (u.widget.interval !== "day" || !e.length) return e;
			let t = e.filter((e) => e.date);
			if (!t.length) return e;
			let n = new Map(t.map((e) => [_n(e.date).getTime(), e])), r = _n(/* @__PURE__ */ new Date()), i = (() => {
				if (u.widget._dateFrom) try {
					return _n(gn(u.widget._dateFrom));
				} catch {}
				return _n(t[0].date);
			})(), a = (() => {
				if (u.widget._dateTo) try {
					let e = _n(gn(u.widget._dateTo));
					return e <= r ? e : r;
				} catch {
					return r;
				}
				return r;
			})(), o = [];
			for (let e = new Date(i); e <= a; e = dn(e, 1)) {
				let t = e.getTime();
				if (n.has(t)) o.push(n.get(t));
				else {
					let n = fn(e, f.value);
					o.push({
						key: t,
						value: 0,
						label: n,
						date: new Date(e),
						isWeekend: p.value && hn(e),
						formattedLabel: n
					});
				}
			}
			return o;
		}), w = n(() => p.value && S.value.some((e) => e.isWeekend)), T = n(() => S.value.length ? Math.max(...S.value.map((e) => e.value)) : 1);
		function E(e) {
			return T.value === 0 ? 0 : Math.max(2, Math.round(e.value / T.value * 100));
		}
		function D(e) {
			return {
				height: E(e) + "%",
				backgroundColor: e.isWeekend ? g.value : h.value,
				opacity: e.isWeekend ? _.value : 1
			};
		}
		return (n, u) => (O(), r(Be, {
			class: "h-metric-histogram-card h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: L(() => [l(Ge, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: L(() => [t.widget.icon ? (O(), r(V, {
					key: 0,
					icon: t.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : i("", !0), c(" " + P(t.widget.name), 1)]),
				_: 1
			}), l(We, { class: "pt-0 pb-4" }, {
				default: L(() => [t.loading ? (O(), a("div", GB, [(O(!0), a(e, null, j(F(s), (e, t) => (O(), a("div", {
					key: t,
					class: "h-metric-histogram-card__bar-wrap"
				}, [l(Cn, {
					type: "image",
					height: e,
					class: "h-metric-histogram-card__bar-skeleton"
				}, null, 8, ["height"])]))), 128))])) : b.value.length ? (O(), a(e, { key: 2 }, [o("div", {
					class: x(["h-metric-histogram-card__chart", { "h-metric-histogram-card__chart--fit": m.value }]),
					role: "img",
					"aria-label": t.widget.name
				}, [(O(!0), a(e, null, j(S.value, (e) => (O(), a("div", {
					key: e.key,
					class: "h-metric-histogram-card__bar-wrap"
				}, [l(qe, {
					text: `${e.formattedLabel}: ${e.value}`,
					location: "top"
				}, {
					activator: L(({ props: t }) => [o("div", y({ ref_for: !0 }, t, {
						class: "h-metric-histogram-card__bar",
						style: D(e),
						"aria-label": `${e.formattedLabel}: ${e.value}`
					}), null, 16, JB)]),
					_: 2
				}, 1032, ["text"]), o("span", YB, P(e.formattedLabel), 1)]))), 128))], 10, qB), w.value ? (O(), a("div", XB, [o("span", ZB, [o("span", {
					class: "h-metric-histogram-card__legend-dot",
					style: C({ backgroundColor: h.value })
				}, null, 4), c(" " + P(F(B)("histogram_weekday")), 1)]), o("span", QB, [o("span", {
					class: "h-metric-histogram-card__legend-dot",
					style: C({
						backgroundColor: g.value,
						opacity: _.value
					})
				}, null, 4), c(" " + P(F(B)("histogram_weekend")), 1)])])) : i("", !0)], 64)) : (O(), a("div", KB, [l(V, {
					icon: "mdi:mdi-chart-bar-stacked",
					class: "mb-1"
				}), o("div", null, P(F(B)("no_data")), 1)]))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, eV = { class: "d-flex align-center justify-space-between flex-wrap ga-3 w-100" }, tV = { class: "h-metric-alert-banner__title font-weight-medium" }, nV = { class: "d-flex align-center ga-3 flex-shrink-0" }, rV = {
	key: 0,
	class: "d-flex align-center"
}, iV = {
	key: 1,
	class: "d-flex align-center ga-1 text-body-2"
}, aV = {
	key: 2,
	class: "text-h6 font-weight-bold"
}, oV = ["href"], sV = /*#__PURE__*/ Vn({
	__name: "metric-alert-banner",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(e) {
		let t = z(e, "HMetricAlertBanner"), s = n(() => t.widget.color || "error");
		function u(e) {
			if (e == null || e === "") return null;
			let t = typeof e == "string" ? parseFloat(String(e).replace(/[^0-9.]/g, "")) : Number(e);
			return Number.isFinite(t) ? t : null;
		}
		let d = n(() => {
			let e = u(t.value);
			return e === null ? !1 : e >= (t.widget.bannerThreshold ?? 1);
		});
		return (t, n) => d.value ? (O(), r(Jt, {
			key: 0,
			class: "h-metric-alert-banner",
			color: s.value,
			icon: e.widget.icon || "mdi:mdi-alert-circle",
			variant: "outlined",
			rounded: "lg",
			href: e.widget.link || void 0,
			clickable: !!e.widget.link,
			density: "compact"
		}, {
			text: L(() => [o("div", eV, [o("span", tV, P(e.widget.name), 1), o("div", nV, [e.loading ? (O(), a("span", rV, [l(sn, {
				indeterminate: "",
				size: "16",
				width: "2",
				class: "mr-1"
			})])) : e.error ? (O(), a("span", iV, [l(V, {
				icon: "mdi:mdi-alert",
				size: "small"
			}), c(" " + P(typeof e.error == "string" ? e.error : e.error.message), 1)])) : e.value === null ? i("", !0) : (O(), a("span", aV, P(e.value), 1)), e.widget.link ? (O(), a("a", {
				key: 3,
				href: e.widget.link,
				class: "d-flex align-center ga-1 text-decoration-none font-weight-medium text-body-2",
				style: C({ color: `rgb(var(--v-theme-${e.widget.linkColor || "primary"}))` })
			}, [c(P(e.widget.linkLabel || F(B)("view_all")) + " ", 1), l(V, {
				icon: "mdi:mdi-arrow-right",
				size: "small"
			})], 12, oV)) : i("", !0)])])]),
			_: 1
		}, 8, [
			"color",
			"icon",
			"href",
			"clickable"
		])) : i("", !0);
	}
}, [["__scopeId", "data-v-3cd646c9"]]), cV = { class: "text-body-1 font-weight-semibold" }, lV = {
	key: 0,
	class: "text-body-2 text-medium-emphasis mt-1"
}, uV = { class: "flex-1-1" }, dV = { class: "text-body-1 font-weight-semibold" }, fV = {
	key: 0,
	class: "text-body-2 text-medium-emphasis mt-1"
}, pV = {
	__name: "metric-info-card",
	props: { widget: {
		type: Object,
		required: !0
	} },
	setup(t) {
		let s = z(t, "HMetricInfoCard"), u = n(() => Array.isArray(s.widget.actions) && s.widget.actions.length > 0);
		return (n, s) => {
			let d = N("h-action-button"), f = N("h-action-link");
			return u.value ? (O(), r(Be, {
				key: 0,
				class: "h-metric-info-card h-metric-info-card--banner",
				rounded: "lg",
				elevation: "1"
			}, {
				default: L(() => [l(We, null, {
					default: L(() => [l(Ye, { class: "align-center" }, {
						default: L(() => [
							l(H, { cols: "auto" }, {
								default: L(() => [l(Lt, {
									color: "primary-lighten-4",
									size: "48"
								}, {
									default: L(() => [l(V, {
										icon: t.widget.icon || "mdi:mdi-information",
										color: "primary",
										size: "large"
									}, null, 8, ["icon"])]),
									_: 1
								})]),
								_: 1
							}),
							l(H, null, {
								default: L(() => [o("div", cV, P(t.widget.name), 1), t.widget.description ? (O(), a("div", lV, P(t.widget.description), 1)) : i("", !0)]),
								_: 1
							}),
							l(H, {
								cols: "12",
								sm: "auto",
								class: "d-flex flex-wrap ga-3 align-center"
							}, {
								default: L(() => [(O(!0), a(e, null, j(t.widget.actions, (e) => (O(), r(f, {
									key: e.name,
									to: e.link,
									target: "_blank"
								}, {
									default: L(() => [l(d, {
										type: e.type || "primary",
										"prepend-icon": e.icon,
										size: "small",
										tag: "span"
									}, {
										default: L(() => [c(P(e.name), 1)]),
										_: 2
									}, 1032, ["type", "prepend-icon"])]),
									_: 2
								}, 1032, ["to"]))), 128))]),
								_: 1
							})
						]),
						_: 1
					})]),
					_: 1
				})]),
				_: 1
			})) : (O(), r(Be, {
				key: 1,
				class: x(["h-metric-info-card h-metric-info-card--nav h-100", { "h-metric-info-card--clickable": !!t.widget.link }]),
				to: t.widget.link || void 0,
				ripple: !!t.widget.link,
				rounded: "lg",
				elevation: "1"
			}, {
				default: L(() => [l(We, { class: "h-metric-info-card__body" }, {
					default: L(() => [l(Lt, {
						color: "primary-lighten-4",
						size: "48",
						class: "mr-3 flex-0-0"
					}, {
						default: L(() => [l(V, {
							icon: t.widget.icon || "mdi:mdi-link",
							color: "primary"
						}, null, 8, ["icon"])]),
						_: 1
					}), o("div", uV, [o("div", dV, P(t.widget.name), 1), t.widget.description ? (O(), a("div", fV, P(t.widget.description), 1)) : i("", !0)])]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"class",
				"to",
				"ripple"
			]));
		};
	}
}, mV = {
	key: 0,
	class: "text-center py-4"
}, hV = { class: "h-metric-kpi-large__body text-center py-2" }, gV = {
	key: 0,
	class: "text-body-2 text-error d-flex align-center justify-center ga-1"
}, _V = {
	key: 1,
	class: "h-metric-kpi-large__value font-weight-bold"
}, vV = {
	key: 2,
	class: "text-body-2 text-medium-emphasis mt-1"
}, yV = { class: "mt-2" }, bV = { class: "h-metric-kpi-large__items" }, xV = { class: "text-caption text-medium-emphasis mt-1" }, SV = {
	__name: "metric-kpi-large",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		value: {
			type: [String, Number],
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		},
		trend: {
			type: Object,
			default: null
		},
		breakdownData: {
			type: Object,
			default: () => ({})
		}
	},
	setup(t) {
		let s = z(t, "HMetricKpiLarge"), u = n(() => Array.isArray(s.widget.items) && s.widget.items.length > 0), d = n(() => s.widget.trend?.label ?? null), f = n(() => s.trend ? s.trend.percent === null || s.trend.percent === void 0 ? "—" : s.trend.percent < 0 ? "↓" : s.trend.percent > 0 ? "↑" : "—" : ""), p = n(() => {
			if (s.trend) return s.trend.direction === "up" ? "success" : s.trend.direction === "down" ? "error" : "default";
		});
		return (n, s) => (O(), r(Be, {
			class: "h-metric-kpi-large h-100",
			rounded: "lg",
			elevation: "1"
		}, {
			default: L(() => [l(Ge, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: L(() => [t.widget.icon ? (O(), r(V, {
					key: 0,
					icon: t.widget.icon,
					size: "small",
					color: "primary"
				}, null, 8, ["icon"])) : i("", !0), c(" " + P(t.widget.name), 1)]),
				_: 1
			}), l(We, { class: "pt-0 pb-4" }, {
				default: L(() => [t.loading && t.value === null ? (O(), a("div", mV, [
					l(Cn, {
						type: "heading",
						width: "120",
						class: "mx-auto mb-2"
					}),
					l(Cn, {
						type: "text",
						width: "80",
						class: "mx-auto mb-2"
					}),
					l(Cn, {
						type: "chip",
						width: "80",
						height: "22",
						class: "mx-auto"
					})
				])) : (O(), a(e, { key: 1 }, [o("div", hV, [
					t.error ? (O(), a("div", gV, [l(V, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), c(" " + P(F(B)("error")), 1)])) : (O(), a("div", _V, P(t.value ?? "—"), 1)),
					t.widget.unit ? (O(), a("div", vV, P(t.widget.unit), 1)) : i("", !0),
					o("div", yV, [t.loading && t.trend === null && t.widget.trend ? (O(), r(Cn, {
						key: 0,
						type: "chip",
						width: "80",
						height: "22",
						class: "mx-auto"
					})) : t.trend ? (O(), r(kt, {
						key: 1,
						color: p.value,
						size: "x-small",
						variant: "tonal",
						class: "font-weight-semibold"
					}, {
						default: L(() => [c(P(f.value) + " " + P(t.trend.label) + " ", 1), d.value ? (O(), a(e, { key: 0 }, [c("· " + P(d.value), 1)], 64)) : i("", !0)]),
						_: 1
					}, 8, ["color"])) : i("", !0)])
				]), u.value ? (O(), a(e, { key: 0 }, [l(It, { class: "my-3" }), o("div", bV, [(O(!0), a(e, null, j(t.widget.items, (n) => (O(), a("div", {
					key: n._id ?? n.name,
					class: "h-metric-kpi-large__item text-center"
				}, [o("div", {
					class: "text-body-1 font-weight-bold",
					style: C(n.color ? { color: n.color } : {})
				}, [t.breakdownData[n._id]?.loading ? (O(), r(sn, {
					key: 0,
					indeterminate: "",
					size: "14",
					width: "2"
				})) : t.breakdownData[n._id]?.error ? (O(), r(V, {
					key: 1,
					icon: "mdi:mdi-alert-circle-outline",
					size: "small",
					color: "error"
				})) : (O(), a(e, { key: 2 }, [c(P(t.breakdownData[n._id]?.value ?? "—"), 1)], 64))], 4), o("div", xV, P(n.name), 1)]))), 128))])], 64)) : i("", !0)], 64))]),
				_: 1
			})]),
			_: 1
		}));
	}
}, CV = {
	key: 1,
	class: "d-flex align-center ga-2 text-body-2 text-error py-2"
}, wV = {
	key: 2,
	class: "text-body-2 text-medium-emphasis py-2"
}, TV = { class: "h-metric-filtered__row h-metric-filtered__row--header mb-1" }, EV = { class: "h-metric-filtered__key text-caption text-medium-emphasis font-weight-semibold" }, DV = {
	key: 1,
	class: "text-caption text-medium-emphasis font-weight-semibold mb-1"
}, OV = {
	key: 2,
	class: "d-flex align-center ga-2 text-body-2 text-error py-1 mb-1"
}, kV = ["title"], AV = {
	key: 1,
	class: "text-body-2 text-medium-emphasis"
}, jV = {
	__name: "metric-filtered",
	props: {
		widget: {
			type: Object,
			required: !0
		},
		groups: {
			type: Array,
			default: null
		},
		items: {
			type: Array,
			default: null
		},
		loading: {
			type: Boolean,
			default: !1
		},
		error: {
			type: [String, Error],
			default: null
		}
	},
	setup(t) {
		let s = z(t, "HMetricFiltered"), u = n(() => {
			let e = s.widget.link;
			return e ? typeof e == "string" ? e : e.to ?? e.href ?? e.url ?? null : null;
		}), d = n(() => {
			let e = s.widget.link;
			return e && typeof e == "object" && e.label ? e.label : s.widget.linkLabel ? s.widget.linkLabel : B("view_all");
		}), f = n(() => B("error")), p = n(() => s.error ? typeof s.error == "string" ? s.error : s.error.message || f.value : f.value), m = n(() => s.widget.emptyText || B("admin_dashboard_filtered_no_results")), h = n(() => s.widget.skeletonRows ?? 4), g = n(() => s.widget.maxItems ?? 10), _ = n(() => Array.isArray(s.groups) && s.groups.length > 0 ? s.groups.map((e) => ({
			...e,
			items: Array.isArray(e.items) ? e.items.slice(0, g.value) : []
		})) : Array.isArray(s.items) ? [{
			label: s.widget.label,
			items: s.items.slice(0, g.value),
			error: null
		}] : []), v = n(() => _.value.some((e) => e.items.length > 0));
		return (n, s) => (O(), r(Be, {
			class: x(["h-metric-filtered h-100", { "h-metric-filtered--clickable": !!u.value }]),
			rounded: "lg",
			elevation: "1"
		}, {
			default: L(() => [l(Ge, { class: "text-body-2 font-weight-semibold d-flex align-center ga-2 pb-2" }, {
				default: L(() => [
					t.widget.icon ? (O(), r(V, {
						key: 0,
						icon: t.widget.icon,
						size: "small",
						color: t.widget.color || "primary"
					}, null, 8, ["icon", "color"])) : i("", !0),
					c(" " + P(t.widget.name) + " ", 1),
					l(Xe),
					u.value ? (O(), r(Ke, {
						key: 1,
						to: u.value,
						size: "x-small",
						variant: "text",
						color: "primary",
						density: "compact",
						class: "text-caption"
					}, {
						default: L(() => [c(P(d.value), 1)]),
						_: 1
					}, 8, ["to"])) : i("", !0)
				]),
				_: 1
			}), l(We, { class: "pt-0 pb-4 px-4" }, {
				default: L(() => [t.loading && _.value.length === 0 ? (O(!0), a(e, { key: 0 }, j(h.value, (e) => (O(), a("div", {
					key: e,
					class: "h-metric-filtered__row h-metric-filtered__row--skeleton mb-2"
				}, [l(Cn, {
					type: "text",
					width: "120",
					height: "14"
				}), l(Cn, {
					type: "text",
					width: "80",
					height: "14"
				})]))), 128)) : t.error && !v.value ? (O(), a("div", CV, [l(V, {
					icon: "mdi:mdi-alert-circle-outline",
					size: "small"
				}), c(" " + P(p.value), 1)])) : !t.loading && !v.value ? (O(), a("div", wV, P(m.value), 1)) : (O(!0), a(e, { key: 3 }, j(_.value, (n, u) => (O(), a("section", {
					key: u,
					class: x({ "mt-3": u > 0 })
				}, [
					_.value.length === 1 && n.label ? (O(), a(e, { key: 0 }, [o("div", TV, [o("span", EV, P(n.label), 1), s[0] ||= o("span", { class: "h-metric-filtered__value" }, null, -1)]), l(It, { class: "mb-2" })], 64)) : _.value.length > 1 && n.label ? (O(), a("div", DV, P(n.label), 1)) : i("", !0),
					n.error ? (O(), a("div", OV, [l(V, {
						icon: "mdi:mdi-alert-circle-outline",
						size: "small"
					}), c(" " + P(n.error), 1)])) : i("", !0),
					(O(!0), a(e, null, j(n.items, (e, n) => (O(), a("div", {
						key: `${u}_${e.key}_${n}`,
						class: "h-metric-filtered__row mb-1"
					}, [o("span", {
						class: "h-metric-filtered__key text-body-2 font-weight-medium",
						title: e.key
					}, P(e.key), 9, kV), e.value ? (O(), r(kt, {
						key: 0,
						size: "x-small",
						variant: "tonal",
						color: t.widget.color || "default",
						class: "h-metric-filtered__value font-weight-medium"
					}, {
						default: L(() => [c(P(e.value), 1)]),
						_: 2
					}, 1032, ["color"])) : (O(), a("span", AV, "—"))]))), 128))
				], 2))), 128))]),
				_: 1
			})]),
			_: 1
		}, 8, ["class"]));
	}
}, MV = /* @__PURE__ */ jn({
	HActionButton: () => ew,
	HActionButtons: () => dw,
	HActionCard: () => Nw,
	HActionDialog: () => WP,
	HActionLink: () => lw,
	HActionMenu: () => Pw,
	HAdminDataView: () => Zn,
	HAdminLayout: () => Hn,
	HAdminLogsFromDateOptions: () => KN,
	HAdminLogsLevelOptions: () => AN,
	HAdminLogsSourceOptions: () => jN,
	HAdminLogsTable: () => GN,
	HAdminTemplate: () => $n,
	HAlertBar: () => aP,
	HAlertsProvider: () => sP,
	HAttachments: () => WI,
	HAutocomplete: () => PP,
	HBreadcrumbs: () => yI,
	HBtnTableCell: () => EN,
	HBulletin: () => BP,
	HChipGroupTableCell: () => CN,
	HChipTableCell: () => TN,
	HConfirmationDialog: () => KP,
	HCountdownTimer: () => EF,
	HDataTable: () => Uw,
	HDescriptionTableCell: () => SN,
	HDialog: () => VP,
	HDialogContainer: () => vP,
	HFileUpload: () => cP,
	HFilterDatetime: () => $M,
	HFilterGroup: () => pN,
	HFilterMultiselect: () => nN,
	HFilterMultistring: () => sN,
	HFilterSelect: () => vN,
	HFilterString: () => dN,
	HFilterSwitch: () => xN,
	HFilterText: () => mN,
	HFiltersContainer: () => yw,
	HFormAutocomplete: () => sr,
	HFormCodeEditor: () => $C,
	HFormCombobox: () => cr,
	HFormContainer: () => pP,
	HFormDatePicker: () => dr,
	HFormDateTimePicker: () => yr,
	HFormField: () => ir,
	HFormLabel: () => tr,
	HFormLayout: () => NI,
	HFormOtpInput: () => br,
	HFormPassword: () => xr,
	HFormSelect: () => or,
	HFormSwitch: () => ur,
	HFormText: () => ar,
	HFormTextarea: () => lr,
	HInfoDisplay: () => ZN,
	HItemCard: () => pF,
	HItemCardTemplate: () => VF,
	HLegacyFormContainer: () => fP,
	HLiveUpdateControls: () => eP,
	HLoader: () => gF,
	HMenu: () => OI,
	HMetricAlertBanner: () => sV,
	HMetricBreakdownCard: () => WB,
	HMetricCard: () => RB,
	HMetricFiltered: () => jV,
	HMetricHistogramCard: () => $B,
	HMetricInfoCard: () => pV,
	HMetricKpiLarge: () => SV,
	HMilestoneTimeline: () => RI,
	HNavigationMenu: () => gI,
	HNotificationBadge: () => oI,
	HNotificationDrawer: () => aI,
	HNotificationItem: () => nI,
	HOnifyLogo: () => lI,
	HPageContainer: () => mP,
	HPageDescription: () => AP,
	HPageHead: () => lP,
	HPageSubtitle: () => EP,
	HPageTitle: () => SP,
	HPreCodeTableCell: () => kN,
	HPrettyCode: () => MP,
	HProcessState: () => OF,
	HProcessStateSimple: () => AF,
	HResourceContentViewer: () => OB,
	HResourceTreeNode: () => YI,
	HResourceTreeView: () => tL,
	HResourceView: () => jB,
	HSearch: () => pw,
	HSearchItems: () => RF,
	HSearchItemsDialog: () => IF,
	HSearchItemsResults: () => ZF,
	HShortcut: () => tF,
	HThemePackProvider: () => JN,
	HThemeScope: () => kI,
	HTooltip: () => bw,
	HViewCodeDialog: () => Gw,
	HViewWorkflowDialog: () => WM,
	HWidget: () => ZM,
	HWidgetsContainer: () => GM,
	HWorkspaceItem: () => DI
});
//#endregion
//#region src/index.ts
function NV() {
	return { install(e) {
		for (let t in MV) e.component(t, MV[t]);
	} };
}
//#endregion
export { ew as HActionButton, dw as HActionButtons, Nw as HActionCard, WP as HActionDialog, lw as HActionLink, Pw as HActionMenu, Zn as HAdminDataView, Hn as HAdminLayout, KN as HAdminLogsFromDateOptions, AN as HAdminLogsLevelOptions, jN as HAdminLogsSourceOptions, GN as HAdminLogsTable, $n as HAdminTemplate, aP as HAlertBar, sP as HAlertsProvider, WI as HAttachments, PP as HAutocomplete, yI as HBreadcrumbs, EN as HBtnTableCell, BP as HBulletin, CN as HChipGroupTableCell, TN as HChipTableCell, KP as HConfirmationDialog, EF as HCountdownTimer, Uw as HDataTable, SN as HDescriptionTableCell, VP as HDialog, vP as HDialogContainer, cP as HFileUpload, $M as HFilterDatetime, pN as HFilterGroup, nN as HFilterMultiselect, sN as HFilterMultistring, vN as HFilterSelect, dN as HFilterString, xN as HFilterSwitch, mN as HFilterText, yw as HFiltersContainer, sr as HFormAutocomplete, $C as HFormCodeEditor, cr as HFormCombobox, pP as HFormContainer, dr as HFormDatePicker, yr as HFormDateTimePicker, ir as HFormField, tr as HFormLabel, NI as HFormLayout, br as HFormOtpInput, xr as HFormPassword, or as HFormSelect, ur as HFormSwitch, ar as HFormText, lr as HFormTextarea, ZN as HInfoDisplay, pF as HItemCard, VF as HItemCardTemplate, fP as HLegacyFormContainer, eP as HLiveUpdateControls, gF as HLoader, OI as HMenu, sV as HMetricAlertBanner, WB as HMetricBreakdownCard, RB as HMetricCard, jV as HMetricFiltered, $B as HMetricHistogramCard, pV as HMetricInfoCard, SV as HMetricKpiLarge, RI as HMilestoneTimeline, gI as HNavigationMenu, oI as HNotificationBadge, aI as HNotificationDrawer, nI as HNotificationItem, lI as HOnifyLogo, mP as HPageContainer, AP as HPageDescription, lP as HPageHead, EP as HPageSubtitle, SP as HPageTitle, kN as HPreCodeTableCell, MP as HPrettyCode, OF as HProcessState, AF as HProcessStateSimple, OB as HResourceContentViewer, YI as HResourceTreeNode, tL as HResourceTreeView, jB as HResourceView, pw as HSearch, RF as HSearchItems, IF as HSearchItemsDialog, ZF as HSearchItemsResults, tF as HShortcut, JN as HThemePackProvider, kI as HThemeScope, bw as HTooltip, Gw as HViewCodeDialog, WM as HViewWorkflowDialog, ZM as HWidget, GM as HWidgetsContainer, DI as HWorkspaceItem, NV as hCreateComponents };

//# sourceMappingURL=helix-components.es.js.map